(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.y.m$ === region.t.m$)
	{
		return 'on line ' + region.y.m$;
	}
	return 'on lines ' + region.y.m$ + ' through ' + region.t.m$;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.my,
		impl.pM,
		impl.o7,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		ct: func(record.ct),
		o2: record.o2,
		n4: record.n4
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.ct;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.o2;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.n4) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.my,
		impl.pM,
		impl.o7,
		function(sendToApp, initialModel) {
			var view = impl.pY;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.my,
		impl.pM,
		impl.o7,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.gz && impl.gz(sendToApp)
			var view = impl.pY;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.hn);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.bs) && (_VirtualDom_doc.title = title = doc.bs);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.nG;
	var onUrlRequest = impl.nH;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		gz: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.n7 === next.n7
							&& curr.mp === next.mp
							&& curr.nY.a === next.nY.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		my: function(flags)
		{
			return A3(impl.my, flags, _Browser_getUrl(), key);
		},
		pY: impl.pY,
		pM: impl.pM,
		o7: impl.o7
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { ml: 'hidden', k5: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { ml: 'mozHidden', k5: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { ml: 'msHidden', k5: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { ml: 'webkitHidden', k5: 'webkitvisibilitychange' }
		: { ml: 'hidden', k5: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		jG: _Browser_getScene(),
		kq: {
			kw: _Browser_window.pageXOffset,
			kx: _Browser_window.pageYOffset,
			g6: _Browser_doc.documentElement.clientWidth,
			fx: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		g6: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		fx: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			jG: {
				g6: node.scrollWidth,
				fx: node.scrollHeight
			},
			kq: {
				kw: node.scrollLeft,
				kx: node.scrollTop,
				g6: node.clientWidth,
				fx: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			jG: _Browser_getScene(),
			kq: {
				kw: x,
				kx: y,
				g6: _Browser_doc.documentElement.clientWidth,
				fx: _Browser_doc.documentElement.clientHeight
			},
			lT: {
				kw: x + rect.left,
				kx: y + rect.top,
				g6: rect.width,
				fx: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}




function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.cn.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.cn.b, xhr)); });
		$elm$core$Maybe$isJust(request.kf) && _Http_track(router, xhr, request.kf.a);

		try {
			xhr.open(request.f, request.ba, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.ba));
		}

		_Http_configureRequest(xhr, request);

		request.hn.a && xhr.setRequestHeader('Content-Type', request.hn.a);
		xhr.send(request.hn.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.it; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.j8.a || 0;
	xhr.responseType = request.cn.d;
	xhr.withCredentials = request.kG;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		ba: xhr.responseURL,
		j0: xhr.status,
		o0: xhr.statusText,
		it: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			oT: event.loaded,
			jV: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			oa: event.loaded,
			jV: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.nm) { flags += 'm'; }
	if (options.k3) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.P) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.X),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.X);
		} else {
			var treeLen = builder.P * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder._) : builder._;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.P);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.X) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.X);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{_: nodeList, P: (len / $elm$core$Array$branchFactor) | 0, X: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {il: fragment, mp: host, b_: path, nY: port_, n7: protocol, jj: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $author$project$Kernel$Msg$AppMsg = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Kernel$MsgAnything$dispatchMessages = F2(
	function (mainUpdate, _v0) {
		var state = _v0.aX;
		var commands = _v0.le;
		var messages = _v0.Z;
		var runMessages = F2(
			function (currMsg, _v2) {
				var newState = _v2.a;
				var newCmd = _v2.b;
				return function (_v1) {
					var newestState = _v1.a;
					var newestCmd = _v1.b;
					return _Utils_Tuple2(
						newestState,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[newCmd, newestCmd])));
				}(
					A2(mainUpdate, currMsg, newState));
			});
		return A3(
			$elm$core$List$foldl,
			runMessages,
			_Utils_Tuple2(state, commands),
			messages);
	});
var $author$project$Kernel$Aspect$Toaster$Toaster$init = {bU: 0, bG: $elm$core$Array$empty, ak: 0};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $author$project$Kernel$Aspect$Navigation$Routing$addCmd = F2(
	function (newCmd, _v0) {
		var state = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			state,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, newCmd])));
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$Kernel$Aspect$Utility$ifElse = F3(
	function (_true, _false, bool) {
		return bool ? _true : _false;
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $elm$core$Basics$not = _Basics_not;
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Kernel$Aspect$Url$Url$fromNavigationLocation = function (location) {
	var splitAndFilterEmpty = F2(
		function (delimiter, string) {
			return A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				A2($elm$core$String$split, delimiter, string));
		});
	var removeQuestionMarkPrefix = function (string) {
		return A3(
			$author$project$Kernel$Aspect$Utility$ifElse,
			A2($elm$core$String$dropLeft, 1, string),
			string,
			A2($elm$core$String$startsWith, '?', string));
	};
	var pathList = A2(splitAndFilterEmpty, '/', location.gj);
	var listToTuple = function (list) {
		var maybeList = A3(
			$author$project$Kernel$Aspect$Utility$ifElse,
			$elm$core$Maybe$Just(list),
			$elm$core$Maybe$Nothing,
			$elm$core$List$length(list) === 2);
		if ((((!maybeList.$) && maybeList.a.b) && maybeList.a.b.b) && (!maybeList.a.b.b.b)) {
			var _v1 = maybeList.a;
			var key = _v1.a;
			var _v2 = _v1.b;
			var value = _v2.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(key, value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var decodeQueryParams = function (list) {
		var uncurry2 = F2(
			function (fun, tup) {
				return A2(fun, tup.a, tup.b);
			});
		return A2(
			$elm$core$List$filterMap,
			uncurry2(
				$elm$core$Maybe$map2($elm$core$Tuple$pair)),
			A2(
				$elm$core$List$map,
				A2($elm$core$Tuple$mapBoth, $elm$url$Url$percentDecode, $elm$url$Url$percentDecode),
				list));
	};
	var addDefaultValueIfEmpty = F2(
		function (_default, string) {
			return A3(
				$author$project$Kernel$Aspect$Utility$ifElse,
				string,
				$elm$core$String$concat(
					_List_fromArray(
						[string, '=', _default])),
				A2($elm$core$String$contains, '=', string));
		});
	var queryDict = $elm$core$Dict$fromList(
		decodeQueryParams(
			A2(
				$elm$core$List$filterMap,
				listToTuple,
				A2(
					$elm$core$List$map,
					splitAndFilterEmpty('='),
					A2(
						$elm$core$List$map,
						addDefaultValueIfEmpty('true'),
						A2(
							splitAndFilterEmpty,
							'&',
							removeQuestionMarkPrefix(location.gw)))))));
	return {b_: pathList, cA: queryDict};
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Kernel$Aspect$Navigation$RouteHistory$PushState = function (a) {
	return {$: 0, a: a};
};
var $author$project$Kernel$Aspect$Navigation$RouteHistory$ReplaceState = function (a) {
	return {$: 1, a: a};
};
var $author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $wernerdegroot$listzipper$List$Zipper$before = function (_v0) {
	var ls = _v0.a;
	return $elm$core$List$reverse(ls);
};
var $wernerdegroot$listzipper$List$Zipper$current = function (_v0) {
	var x = _v0.b;
	return x;
};
var $wernerdegroot$listzipper$List$Zipper$Zipper = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $wernerdegroot$listzipper$List$Zipper$from = F3(
	function (bef, curr, aft) {
		return A3(
			$wernerdegroot$listzipper$List$Zipper$Zipper,
			$elm$core$List$reverse(bef),
			curr,
			aft);
	});
var $author$project$Kernel$Aspect$Navigation$RouteHistory$newRoute = F2(
	function (route, _v0) {
		var routeHistory = _v0.a;
		return A3(
			$author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory,
			A3(
				$wernerdegroot$listzipper$List$Zipper$from,
				_Utils_ap(
					$wernerdegroot$listzipper$List$Zipper$before(routeHistory),
					_List_fromArray(
						[
							$wernerdegroot$listzipper$List$Zipper$current(routeHistory)
						])),
				route,
				_List_Nil),
			$elm$core$Maybe$Nothing,
			false);
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $wernerdegroot$listzipper$List$Zipper$mapCurrent = F2(
	function (f, _v0) {
		var ls = _v0.a;
		var x = _v0.b;
		var rs = _v0.c;
		return A3(
			$wernerdegroot$listzipper$List$Zipper$Zipper,
			ls,
			f(x),
			rs);
	});
var $author$project$Kernel$Aspect$Navigation$RouteHistory$replaceRoute = F2(
	function (route, _v0) {
		var routeHistory = _v0.a;
		var isBack = _v0.c;
		return A3(
			$author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory,
			A2(
				$wernerdegroot$listzipper$List$Zipper$mapCurrent,
				$elm$core$Basics$always(route),
				routeHistory),
			$elm$core$Maybe$Nothing,
			isBack);
	});
var $author$project$Kernel$Aspect$Navigation$RouteHistory$toZipperHistoryIndex = function (zipperHistory) {
	return $elm$core$List$length(
		$wernerdegroot$listzipper$List$Zipper$before(zipperHistory));
};
var $author$project$Kernel$Aspect$Navigation$RouteHistory$toCurrIndex = function (_v0) {
	var routeHistory = _v0.a;
	return $author$project$Kernel$Aspect$Navigation$RouteHistory$toZipperHistoryIndex(routeHistory);
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Kernel$Aspect$Navigation$RouteHistory$routingCommands = _Platform_outgoingPort(
	'routingCommands',
	$elm$json$Json$Encode$list($elm$core$Basics$identity));
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Kernel$Aspect$Navigation$RouteHistory$toRoutingCommands = function (commands) {
	var toCommand = function (cmd) {
		switch (cmd.$) {
			case 0:
				var routeState = cmd.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('pushState')),
							_Utils_Tuple2(
							'stateIndex',
							$elm$json$Json$Encode$int(routeState.br)),
							_Utils_Tuple2(
							'title',
							$elm$json$Json$Encode$string(routeState.bs)),
							_Utils_Tuple2(
							'url',
							$elm$json$Json$Encode$string(routeState.ba))
						]));
			case 1:
				var routeState = cmd.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('replaceState')),
							_Utils_Tuple2(
							'stateIndex',
							$elm$json$Json$Encode$int(routeState.br)),
							_Utils_Tuple2(
							'title',
							$elm$json$Json$Encode$string(routeState.bs)),
							_Utils_Tuple2(
							'url',
							$elm$json$Json$Encode$string(routeState.ba))
						]));
			default:
				var _int = cmd.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('go')),
							_Utils_Tuple2(
							'steps',
							$elm$json$Json$Encode$int(_int))
						]));
		}
	};
	return $author$project$Kernel$Aspect$Navigation$RouteHistory$routingCommands(
		A2($elm$core$List$map, toCommand, commands));
};
var $author$project$Kernel$Aspect$Navigation$RouteHistory$replaceCurrentAndRouteTo = function (config) {
	var theRoutingCommands = _List_fromArray(
		[
			$author$project$Kernel$Aspect$Navigation$RouteHistory$ReplaceState(
			{
				br: $author$project$Kernel$Aspect$Navigation$RouteHistory$toCurrIndex(config.b1),
				bs: config.of,
				ba: config.og
			}),
			$author$project$Kernel$Aspect$Navigation$RouteHistory$PushState(
			{
				br: $author$project$Kernel$Aspect$Navigation$RouteHistory$toCurrIndex(config.b1) + 1,
				bs: config.oD,
				ba: config.oF
			})
		]);
	var routeHistory = A2(
		$author$project$Kernel$Aspect$Navigation$RouteHistory$newRoute,
		config.gu,
		A2($author$project$Kernel$Aspect$Navigation$RouteHistory$replaceRoute, config.oe, config.b1));
	return _Utils_Tuple2(
		routeHistory,
		$author$project$Kernel$Aspect$Navigation$RouteHistory$toRoutingCommands(theRoutingCommands));
};
var $author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$generalError = _Platform_outgoingPort('generalError', $elm$json$Json$Encode$string);
var $author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$toGeneralErrorString = function (description) {
	return '' + description;
};
var $author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$reportErr = F2(
	function (description, err) {
		return $author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$generalError(
			$author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$toGeneralErrorString(description) + (': ' + err));
	});
var $author$project$Kernel$Aspect$Navigation$RouteHistory$setRoute = function (config) {
	return config.gA ? _Utils_Tuple2(
		A2($author$project$Kernel$Aspect$Navigation$RouteHistory$replaceRoute, config.jE, config.b1),
		$author$project$Kernel$Aspect$Navigation$RouteHistory$toRoutingCommands(
			_List_fromArray(
				[
					$author$project$Kernel$Aspect$Navigation$RouteHistory$ReplaceState(
					{
						br: $author$project$Kernel$Aspect$Navigation$RouteHistory$toCurrIndex(config.b1),
						bs: config.bs,
						ba: config.ba
					})
				]))) : _Utils_Tuple2(
		A2($author$project$Kernel$Aspect$Navigation$RouteHistory$newRoute, config.jE, config.b1),
		$author$project$Kernel$Aspect$Navigation$RouteHistory$toRoutingCommands(
			_List_fromArray(
				[
					$author$project$Kernel$Aspect$Navigation$RouteHistory$PushState(
					{
						br: $author$project$Kernel$Aspect$Navigation$RouteHistory$toCurrIndex(config.b1) + 1,
						bs: config.bs,
						ba: config.ba
					})
				])));
};
var $author$project$Kernel$Aspect$Platform$Platform$setTitleAndDescription = _Platform_outgoingPort(
	'setTitleAndDescription',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'description',
					$elm$json$Json$Encode$string($.lH)),
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string($.bs))
				]));
	});
var $wernerdegroot$listzipper$List$Zipper$singleton = function (x) {
	return A3($wernerdegroot$listzipper$List$Zipper$Zipper, _List_Nil, x, _List_Nil);
};
var $author$project$Kernel$Aspect$Navigation$RouteHistory$singleton = function (route) {
	return A3(
		$author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory,
		$wernerdegroot$listzipper$List$Zipper$singleton(route),
		$elm$core$Maybe$Nothing,
		false);
};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $author$project$Kernel$Aspect$Url$Url$toUrlString = function (url) {
	var foldToQueryString = F3(
		function (key, value, result) {
			var prepend = A3($author$project$Kernel$Aspect$Utility$ifElse, '', '&', result === '?');
			var encodedValue = $elm$url$Url$percentEncode(value);
			var encodedKey = $elm$url$Url$percentEncode(key);
			return $elm$core$String$concat(
				_List_fromArray(
					[result, prepend, encodedKey, '=', encodedValue]));
		});
	var toQueryString = function (queryParams) {
		return A3(
			$author$project$Kernel$Aspect$Utility$ifElse,
			'',
			A3($elm$core$Dict$foldr, foldToQueryString, '?', queryParams),
			$elm$core$Dict$isEmpty(queryParams));
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				A2($elm$core$String$join, '/', url.b_),
				toQueryString(url.cA)
			]));
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Kernel$Aspect$Navigation$Routing$toInitialRoute = F4(
	function (config, programArgs, appState, homeRoute) {
		var setTitleAndDesc = function (route) {
			return $author$project$Kernel$Aspect$Platform$Platform$setTitleAndDescription(
				A2(config.oE, appState, route));
		};
		var reportUnsupportedFirstRoute = function (_v0) {
			var history = _v0.a;
			var cmd = _v0.b;
			return _Utils_Tuple2(
				history,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							cmd,
							programArgs.mO.h1.mG ? $elm$core$Platform$Cmd$none : A2($author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$reportErr, 'replaceWithHomeRouteAndReportErr', programArgs.mO.np.gj)
						])));
		};
		var replaceWithHomeRoute = A2(
			$author$project$Kernel$Aspect$Navigation$Routing$addCmd,
			setTitleAndDesc(homeRoute),
			$author$project$Kernel$Aspect$Navigation$RouteHistory$setRoute(
				{
					jE: homeRoute,
					b1: $author$project$Kernel$Aspect$Navigation$RouteHistory$singleton(homeRoute),
					gA: true,
					bs: A2(config.oE, appState, homeRoute).bs,
					ba: $author$project$Kernel$Aspect$Url$Url$toUrlString(
						config.oF(homeRoute))
				}));
		var replaceWithHomeAndRouteToAuthRoute = A2(
			$author$project$Kernel$Aspect$Navigation$Routing$addCmd,
			setTitleAndDesc(config.kQ),
			$author$project$Kernel$Aspect$Navigation$RouteHistory$replaceCurrentAndRouteTo(
				{
					oe: homeRoute,
					of: A2(config.oE, appState, homeRoute).bs,
					og: $author$project$Kernel$Aspect$Url$Url$toUrlString(
						config.oF(homeRoute)),
					b1: $author$project$Kernel$Aspect$Navigation$RouteHistory$singleton(homeRoute),
					gu: config.kQ,
					oD: A2(config.oE, appState, config.kQ).bs,
					oF: $author$project$Kernel$Aspect$Url$Url$toUrlString(
						config.oF(config.kQ))
				}));
		var replaceWithDefaultRouteAndReportErr = config.oA(homeRoute) ? reportUnsupportedFirstRoute(replaceWithHomeAndRouteToAuthRoute) : reportUnsupportedFirstRoute(replaceWithHomeRoute);
		var decideFirstAndSecondRoute = function (route) {
			return (config.oA(route) && _Utils_eq(
				config.mE(appState),
				$elm$core$Maybe$Just(false))) ? A2(
				$author$project$Kernel$Aspect$Navigation$Routing$addCmd,
				setTitleAndDesc(config.kQ),
				$author$project$Kernel$Aspect$Navigation$RouteHistory$replaceCurrentAndRouteTo(
					{
						oe: route,
						of: A2(config.oE, appState, route).bs,
						og: $author$project$Kernel$Aspect$Url$Url$toUrlString(
							config.oF(route)),
						b1: $author$project$Kernel$Aspect$Navigation$RouteHistory$singleton(route),
						gu: config.kQ,
						oD: A2(config.oE, appState, config.kQ).bs,
						oF: $author$project$Kernel$Aspect$Url$Url$toUrlString(
							config.oF(config.kQ))
					})) : (_Utils_eq(route, homeRoute) ? replaceWithHomeRoute : A2(
				$author$project$Kernel$Aspect$Navigation$Routing$addCmd,
				setTitleAndDesc(route),
				$author$project$Kernel$Aspect$Navigation$RouteHistory$replaceCurrentAndRouteTo(
					{
						oe: homeRoute,
						of: A2(config.oE, appState, homeRoute).bs,
						og: $author$project$Kernel$Aspect$Url$Url$toUrlString(
							config.oF(homeRoute)),
						b1: $author$project$Kernel$Aspect$Navigation$RouteHistory$singleton(homeRoute),
						gu: route,
						oD: A2(config.oE, appState, route).bs,
						oF: $author$project$Kernel$Aspect$Url$Url$toUrlString(
							config.oF(route))
					})));
		};
		return A2(
			$elm$core$Maybe$withDefault,
			replaceWithDefaultRouteAndReportErr,
			A2(
				$elm$core$Maybe$map,
				decideFirstAndSecondRoute,
				config.pO(
					$author$project$Kernel$Aspect$Url$Url$fromNavigationLocation(programArgs.mO.np))));
	});
var $author$project$Kernel$Aspect$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Kernel$Aspect$Navigation$Msg$RouteTo = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Kernel$Msg$RoutingMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Kernel$Aspect$Navigation$RouteHistory$current = function (_v0) {
	var routeHistory = _v0.a;
	return $wernerdegroot$listzipper$List$Zipper$current(routeHistory);
};
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Kernel$Aspect$Navigation$RouteHistory$isPendingRoutingAction = function (_v0) {
	var maybePending = _v0.b;
	return $elm_community$maybe_extra$Maybe$Extra$isJust(maybePending);
};
var $author$project$Kernel$Msg$ToasterMsg = function (a) {
	return {$: 4, a: a};
};
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Kernel$MsgAnything$topmostHandler = F2(
	function (mainUpdate, _v0) {
		var updated = _v0.pN;
		var stateSetter = _v0.o$;
		var msgTag = _v0.nl;
		var runOutMsg = F2(
			function (outMsg, _v4) {
				var latestParentState = _v4.a;
				var parentCmd = _v4.b;
				return function (_v3) {
					var latestestParentState = _v3.a;
					var latestParentCmd = _v3.b;
					return _Utils_Tuple2(
						latestestParentState,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[latestParentCmd, parentCmd])));
				}(
					A2(mainUpdate, outMsg, latestParentState));
			});
		var _v1 = function (_v2) {
			var newChildState = _v2.a;
			var cmd = _v2.b;
			var theOutMsgs = _v2.c;
			return _Utils_Tuple3(
				stateSetter(newChildState),
				A2($elm$core$Platform$Cmd$map, msgTag, cmd),
				theOutMsgs);
		}(updated);
		var newParentState = _v1.a;
		var taggedChildCmd = _v1.b;
		var outMsgs = _v1.c;
		return A3(
			$elm$core$List$foldl,
			runOutMsg,
			_Utils_Tuple2(newParentState, taggedChildCmd),
			outMsgs);
	});
var $author$project$Kernel$Aspect$Navigation$Routing$NewRoute = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Kernel$Aspect$Navigation$Routing$UserWantsBack = {$: 0};
var $author$project$Kernel$Aspect$Navigation$Routing$UserWantsForward = {$: 1};
var $author$project$Kernel$Aspect$Navigation$RouteHistory$Go = function (a) {
	return {$: 2, a: a};
};
var $author$project$Kernel$Aspect$Navigation$RouteHistory$NavigatingBackward = 1;
var $author$project$Kernel$Aspect$Navigation$RouteHistory$PendingPopStateResponse = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $wernerdegroot$listzipper$List$Zipper$next = function (_v0) {
	var ls = _v0.a;
	var x = _v0.b;
	var rs = _v0.c;
	if (!rs.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var y = rs.a;
		var ys = rs.b;
		return $elm$core$Maybe$Just(
			A3(
				$wernerdegroot$listzipper$List$Zipper$Zipper,
				A2($elm$core$List$cons, x, ls),
				y,
				ys));
	}
};
var $wernerdegroot$listzipper$List$Zipper$previous = function (_v0) {
	var ls = _v0.a;
	var x = _v0.b;
	var rs = _v0.c;
	if (!ls.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var y = ls.a;
		var ys = ls.b;
		return $elm$core$Maybe$Just(
			A3(
				$wernerdegroot$listzipper$List$Zipper$Zipper,
				ys,
				y,
				A2($elm$core$List$cons, x, rs)));
	}
};
var $author$project$Kernel$Aspect$Navigation$RouteHistory$dropWhile = F3(
	function (direction, theDropper, theRouteHistory) {
		var moveAStep = function () {
			if (!direction) {
				return $wernerdegroot$listzipper$List$Zipper$next;
			} else {
				return $wernerdegroot$listzipper$List$Zipper$previous;
			}
		}();
		var drop = F2(
			function (currStep, currHistory) {
				drop:
				while (true) {
					var _v0 = moveAStep(currHistory);
					if (!_v0.$) {
						var movedHistory = _v0.a;
						if (theDropper(
							$wernerdegroot$listzipper$List$Zipper$current(movedHistory))) {
							var $temp$currStep = currStep + 1,
								$temp$currHistory = movedHistory;
							currStep = $temp$currStep;
							currHistory = $temp$currHistory;
							continue drop;
						} else {
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(movedHistory, currStep + 1));
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			});
		return A2(drop, 0, theRouteHistory);
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$Kernel$Aspect$Navigation$RouteHistory$dropWhileAndRouteTo = F3(
	function (dropper, route, _v0) {
		var routeHistory = _v0.a;
		var isBack = _v0.c;
		var _v1 = A3($author$project$Kernel$Aspect$Navigation$RouteHistory$dropWhile, 1, dropper, routeHistory);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var pendingRouteHistory = _v2.a;
			var steps = _v2.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A3(
						$author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory,
						routeHistory,
						$elm$core$Maybe$Just(
							A4(
								$author$project$Kernel$Aspect$Navigation$RouteHistory$PendingPopStateResponse,
								false,
								pendingRouteHistory,
								$elm$core$Maybe$Just(route),
								false)),
						isBack),
					$author$project$Kernel$Aspect$Navigation$RouteHistory$toRoutingCommands(
						_List_fromArray(
							[
								$author$project$Kernel$Aspect$Navigation$RouteHistory$Go(-steps)
							]))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Kernel$Aspect$Navigation$RouteHistory$NothingSpecial = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Kernel$Aspect$Navigation$RouteHistory$PendingRouteCorrectionPopStateResponse = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Kernel$Aspect$Navigation$RouteHistory$PopStateError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Kernel$Aspect$Navigation$RouteHistory$PopStateSuccess = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Kernel$Aspect$Navigation$RouteHistory$PopStateSuccessAndRouteTo = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Kernel$Aspect$Navigation$RouteHistory$UserWantsBack = function (a) {
	return {$: 3, a: a};
};
var $author$project$Kernel$Aspect$Navigation$RouteHistory$UserWantsForward = function (a) {
	return {$: 4, a: a};
};
var $author$project$Kernel$Aspect$Navigation$RouteHistory$handlePopState = F2(
	function (popStateIndex, _v0) {
		var routeHistory = _v0.a;
		var maybePendingPopState = _v0.b;
		var isBack_curr = _v0.c;
		if (!maybePendingPopState.$) {
			if (!maybePendingPopState.a.$) {
				var _v2 = maybePendingPopState.a;
				var shouldSilent = _v2.a;
				var pendingHistory = _v2.b;
				var maybeRouteToAfterSuccessfulPopState = _v2.c;
				var isBack_new = _v2.d;
				if (_Utils_eq(
					popStateIndex,
					$author$project$Kernel$Aspect$Navigation$RouteHistory$toZipperHistoryIndex(pendingHistory))) {
					if (maybeRouteToAfterSuccessfulPopState.$ === 1) {
						return A2(
							$author$project$Kernel$Aspect$Navigation$RouteHistory$PopStateSuccess,
							shouldSilent,
							A3($author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory, pendingHistory, $elm$core$Maybe$Nothing, isBack_new));
					} else {
						var route = maybeRouteToAfterSuccessfulPopState.a;
						return A3(
							$author$project$Kernel$Aspect$Navigation$RouteHistory$PopStateSuccessAndRouteTo,
							shouldSilent,
							A3($author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory, pendingHistory, $elm$core$Maybe$Nothing, false),
							route);
					}
				} else {
					return $author$project$Kernel$Aspect$Navigation$RouteHistory$PopStateError(
						'Unexpected pendingIndex:' + $elm$core$String$fromInt(
							$author$project$Kernel$Aspect$Navigation$RouteHistory$toZipperHistoryIndex(pendingHistory)));
				}
			} else {
				var _v4 = maybePendingPopState.a;
				var pendingTargetStateIndex = _v4.a;
				var isBack_new = _v4.b;
				return _Utils_eq(
					popStateIndex,
					$author$project$Kernel$Aspect$Navigation$RouteHistory$toZipperHistoryIndex(routeHistory)) ? ((_Utils_cmp(pendingTargetStateIndex, popStateIndex) > 0) ? $author$project$Kernel$Aspect$Navigation$RouteHistory$UserWantsForward(
					A3($author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Nothing, isBack_new)) : ((_Utils_cmp(pendingTargetStateIndex, popStateIndex) < 0) ? $author$project$Kernel$Aspect$Navigation$RouteHistory$UserWantsBack(
					A3($author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Nothing, isBack_new)) : $author$project$Kernel$Aspect$Navigation$RouteHistory$PopStateError(
					'PendingRouteCorrectionPopStateResponse: index same as current: ' + $elm$core$String$fromInt(popStateIndex)))) : $author$project$Kernel$Aspect$Navigation$RouteHistory$PopStateError(
					'PendingRouteCorrectionPopStateResponse: Unexpected popStateIndex:' + $elm$core$String$fromInt(popStateIndex));
			}
		} else {
			var currIndex = $author$project$Kernel$Aspect$Navigation$RouteHistory$toCurrIndex(
				A3($author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory, routeHistory, maybePendingPopState, isBack_curr));
			return (_Utils_cmp(popStateIndex, currIndex) < 0) ? A2(
				$author$project$Kernel$Aspect$Navigation$RouteHistory$NothingSpecial,
				A3(
					$author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory,
					routeHistory,
					$elm$core$Maybe$Just(
						A2($author$project$Kernel$Aspect$Navigation$RouteHistory$PendingRouteCorrectionPopStateResponse, popStateIndex, true)),
					isBack_curr),
				$author$project$Kernel$Aspect$Navigation$RouteHistory$toRoutingCommands(
					_List_fromArray(
						[
							$author$project$Kernel$Aspect$Navigation$RouteHistory$Go(currIndex - popStateIndex)
						]))) : ((_Utils_cmp(popStateIndex, currIndex) > 0) ? A2(
				$author$project$Kernel$Aspect$Navigation$RouteHistory$NothingSpecial,
				A3(
					$author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory,
					routeHistory,
					$elm$core$Maybe$Just(
						A2($author$project$Kernel$Aspect$Navigation$RouteHistory$PendingRouteCorrectionPopStateResponse, popStateIndex, false)),
					isBack_curr),
				$author$project$Kernel$Aspect$Navigation$RouteHistory$toRoutingCommands(
					_List_fromArray(
						[
							$author$project$Kernel$Aspect$Navigation$RouteHistory$Go(-(popStateIndex - currIndex))
						]))) : $author$project$Kernel$Aspect$Navigation$RouteHistory$PopStateError(
				'index same as current: ' + $elm$core$String$fromInt(popStateIndex)));
		}
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$Kernel$Aspect$Navigation$RouteHistory$routeBackTo = F2(
	function (targetRoute, _v0) {
		var routeHistory = _v0.a;
		var isBack = _v0.c;
		var _v1 = A3(
			$author$project$Kernel$Aspect$Navigation$RouteHistory$dropWhile,
			1,
			$elm$core$Basics$neq(targetRoute),
			routeHistory);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var pendingRouteHistory = _v2.a;
			var steps = _v2.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A3(
						$author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory,
						routeHistory,
						$elm$core$Maybe$Just(
							A4($author$project$Kernel$Aspect$Navigation$RouteHistory$PendingPopStateResponse, false, pendingRouteHistory, $elm$core$Maybe$Nothing, true)),
						isBack),
					$author$project$Kernel$Aspect$Navigation$RouteHistory$toRoutingCommands(
						_List_fromArray(
							[
								$author$project$Kernel$Aspect$Navigation$RouteHistory$Go(-steps)
							]))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Kernel$Aspect$Navigation$RouteHistory$routeBackWhileDropping = F2(
	function (dropper, _v0) {
		var routeHistory = _v0.a;
		var isBack = _v0.c;
		var _v1 = A3($author$project$Kernel$Aspect$Navigation$RouteHistory$dropWhile, 1, dropper, routeHistory);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var pendingRouteHistory = _v2.a;
			var steps = _v2.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A3(
						$author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory,
						routeHistory,
						$elm$core$Maybe$Just(
							A4($author$project$Kernel$Aspect$Navigation$RouteHistory$PendingPopStateResponse, false, pendingRouteHistory, $elm$core$Maybe$Nothing, true)),
						isBack),
					$author$project$Kernel$Aspect$Navigation$RouteHistory$toRoutingCommands(
						_List_fromArray(
							[
								$author$project$Kernel$Aspect$Navigation$RouteHistory$Go(-steps)
							]))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Kernel$Aspect$Navigation$RouteHistory$NavigatingForward = 0;
var $author$project$Kernel$Aspect$Navigation$RouteHistory$routeForwardTo = F2(
	function (targetRoute, _v0) {
		var routeHistory = _v0.a;
		var isBack = _v0.c;
		var _v1 = A3(
			$author$project$Kernel$Aspect$Navigation$RouteHistory$dropWhile,
			0,
			$elm$core$Basics$neq(targetRoute),
			routeHistory);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var pendingRouteHistory = _v2.a;
			var steps = _v2.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A3(
						$author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory,
						routeHistory,
						$elm$core$Maybe$Just(
							A4($author$project$Kernel$Aspect$Navigation$RouteHistory$PendingPopStateResponse, false, pendingRouteHistory, $elm$core$Maybe$Nothing, false)),
						isBack),
					$author$project$Kernel$Aspect$Navigation$RouteHistory$toRoutingCommands(
						_List_fromArray(
							[
								$author$project$Kernel$Aspect$Navigation$RouteHistory$Go(steps)
							]))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Kernel$Aspect$Navigation$RouteHistory$routeForwardWhileDropping = F2(
	function (dropper, _v0) {
		var routeHistory = _v0.a;
		var isBack = _v0.c;
		var _v1 = A3($author$project$Kernel$Aspect$Navigation$RouteHistory$dropWhile, 0, dropper, routeHistory);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var pendingRouteHistory = _v2.a;
			var steps = _v2.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A3(
						$author$project$Kernel$Aspect$Navigation$RouteHistory$RouteHistory,
						routeHistory,
						$elm$core$Maybe$Just(
							A4($author$project$Kernel$Aspect$Navigation$RouteHistory$PendingPopStateResponse, false, pendingRouteHistory, $elm$core$Maybe$Nothing, false)),
						isBack),
					$author$project$Kernel$Aspect$Navigation$RouteHistory$toRoutingCommands(
						_List_fromArray(
							[
								$author$project$Kernel$Aspect$Navigation$RouteHistory$Go(steps)
							]))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Kernel$Aspect$Navigation$Routing$routeTo = function (_v0) {
	var config = _v0.hG;
	var newRoute = _v0.aU;
	var shouldReplace = _v0.gA;
	var state = _v0.aX;
	var isUnauthenticated_and_routeNeedsAuth = _Utils_eq(
		config.ac.mE(state.eV),
		$elm$core$Maybe$Just(false)) && config.ac.oA(newRoute);
	if (isUnauthenticated_and_routeNeedsAuth) {
		return $author$project$Kernel$Aspect$Navigation$RouteHistory$setRoute(
			{
				jE: config.ac.kQ,
				b1: state.jE,
				gA: false,
				bs: A2(config.ac.oE, state.eV, config.ac.kQ).bs,
				ba: $author$project$Kernel$Aspect$Url$Url$toUrlString(
					config.ac.oF(config.ac.kQ))
			});
	} else {
		return $author$project$Kernel$Aspect$Navigation$RouteHistory$setRoute(
			{
				jE: newRoute,
				b1: state.jE,
				gA: shouldReplace,
				bs: A2(config.ac.oE, state.eV, newRoute).bs,
				ba: $author$project$Kernel$Aspect$Url$Url$toUrlString(
					config.ac.oF(newRoute))
			});
	}
};
var $author$project$Kernel$Aspect$Navigation$Routing$routeToOutMsg = function (_v0) {
	var config = _v0.hG;
	var newRoute = _v0.aU;
	var shouldReplace = _v0.gA;
	var shouldSilent = _v0.jP;
	var state = _v0.aX;
	var _v1 = $author$project$Kernel$Aspect$Navigation$Routing$routeTo(
		{hG: config, aU: newRoute, gA: shouldReplace, jP: shouldSilent, aX: state});
	var routeHistory = _v1.a;
	var cmd = _v1.b;
	return _Utils_Tuple3(
		routeHistory,
		cmd,
		$elm$core$Maybe$Just(
			A3(
				$author$project$Kernel$Aspect$Navigation$Routing$NewRoute,
				shouldSilent,
				state.jE,
				$author$project$Kernel$Aspect$Navigation$RouteHistory$current(routeHistory))));
};
var $author$project$Kernel$Aspect$Navigation$Routing$update = F3(
	function (config, msg, state) {
		switch (msg.$) {
			case 0:
				var shouldReplace = msg.a;
				var shouldSilent = msg.b;
				var route = msg.c;
				return $author$project$Kernel$Aspect$Navigation$RouteHistory$isPendingRoutingAction(state.jE) ? _Utils_Tuple3(state.jE, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : $author$project$Kernel$Aspect$Navigation$Routing$routeToOutMsg(
					{hG: config, aU: route, gA: shouldReplace, jP: shouldSilent, aX: state});
			case 1:
				var dropper = msg.a;
				var route = msg.b;
				if ($author$project$Kernel$Aspect$Navigation$RouteHistory$isPendingRoutingAction(state.jE)) {
					return _Utils_Tuple3(state.jE, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				} else {
					var _v1 = A3($author$project$Kernel$Aspect$Navigation$RouteHistory$dropWhileAndRouteTo, dropper, route, state.jE);
					if (!_v1.$) {
						var _v2 = _v1.a;
						var newRouteHistory = _v2.a;
						var cmd = _v2.b;
						return _Utils_Tuple3(newRouteHistory, cmd, $elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(
							state.jE,
							A2($author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$reportErr, 'DropWhileAndRouteTo', 'not enough lee-way'),
							$elm$core$Maybe$Nothing);
					}
				}
			case 2:
				var maybeDefault = msg.a;
				var dropper = msg.b;
				if ($author$project$Kernel$Aspect$Navigation$RouteHistory$isPendingRoutingAction(state.jE)) {
					return _Utils_Tuple3(state.jE, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				} else {
					var _v3 = _Utils_Tuple2(
						A2($author$project$Kernel$Aspect$Navigation$RouteHistory$routeBackWhileDropping, dropper, state.jE),
						maybeDefault);
					if (!_v3.a.$) {
						var _v4 = _v3.a.a;
						var newRouteHistory = _v4.a;
						var cmd = _v4.b;
						return _Utils_Tuple3(newRouteHistory, cmd, $elm$core$Maybe$Nothing);
					} else {
						if (!_v3.b.$) {
							var _v5 = _v3.a;
							var defaultRoute = _v3.b.a;
							return $author$project$Kernel$Aspect$Navigation$Routing$routeToOutMsg(
								{hG: config, aU: defaultRoute, gA: false, jP: false, aX: state});
						} else {
							var _v6 = _v3.a;
							var _v7 = _v3.b;
							return _Utils_Tuple3(
								state.jE,
								A2($author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$reportErr, 'RouteBackWhileDropping', 'not enough lee-way'),
								$elm$core$Maybe$Nothing);
						}
					}
				}
			case 3:
				var maybeDefault = msg.a;
				var targetRoute = msg.b;
				var _v8 = _Utils_Tuple2(
					A2($author$project$Kernel$Aspect$Navigation$RouteHistory$routeBackTo, targetRoute, state.jE),
					maybeDefault);
				if (!_v8.a.$) {
					var _v9 = _v8.a.a;
					var newRouteHistory = _v9.a;
					var cmd = _v9.b;
					return _Utils_Tuple3(newRouteHistory, cmd, $elm$core$Maybe$Nothing);
				} else {
					if (!_v8.b.$) {
						var _v10 = _v8.a;
						var defaultRoute = _v8.b.a;
						return $author$project$Kernel$Aspect$Navigation$Routing$routeToOutMsg(
							{hG: config, aU: defaultRoute, gA: true, jP: false, aX: state});
					} else {
						var _v11 = _v8.a;
						var _v12 = _v8.b;
						return _Utils_Tuple3(
							state.jE,
							A2($author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$reportErr, 'RouteBackTo', 'not enough lee-way'),
							$elm$core$Maybe$Nothing);
					}
				}
			case 4:
				var maybeDefault = msg.a;
				var targetRoute = msg.b;
				var _v13 = _Utils_Tuple2(
					A2($author$project$Kernel$Aspect$Navigation$RouteHistory$routeForwardTo, targetRoute, state.jE),
					maybeDefault);
				if (!_v13.a.$) {
					var _v14 = _v13.a.a;
					var newRouteHistory = _v14.a;
					var cmd = _v14.b;
					return _Utils_Tuple3(newRouteHistory, cmd, $elm$core$Maybe$Nothing);
				} else {
					if (!_v13.b.$) {
						var _v15 = _v13.a;
						var defaultRoute = _v13.b.a;
						return $author$project$Kernel$Aspect$Navigation$Routing$routeToOutMsg(
							{hG: config, aU: defaultRoute, gA: true, jP: false, aX: state});
					} else {
						var _v16 = _v13.a;
						var _v17 = _v13.b;
						return _Utils_Tuple3(
							state.jE,
							A2($author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$reportErr, 'RouteBackTo', 'not enough lee-way'),
							$elm$core$Maybe$Nothing);
					}
				}
			case 5:
				var isAuthenticated = _Utils_eq(
					config.ac.mE(state.eV),
					$elm$core$Maybe$Just(true));
				var goingBack = isAuthenticated ? A2($author$project$Kernel$Aspect$Navigation$RouteHistory$routeBackWhileDropping, config.ac.mD, state.jE) : A2($author$project$Kernel$Aspect$Navigation$RouteHistory$routeBackWhileDropping, config.ac.oA, state.jE);
				if ($author$project$Kernel$Aspect$Navigation$RouteHistory$isPendingRoutingAction(state.jE)) {
					return _Utils_Tuple3(state.jE, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				} else {
					if (!goingBack.$) {
						var _v19 = goingBack.a;
						var newHistory = _v19.a;
						var cmd = _v19.b;
						return _Utils_Tuple3(newHistory, cmd, $elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(state.jE, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
					}
				}
			case 6:
				var isAuthenticated = _Utils_eq(
					config.ac.mE(state.eV),
					$elm$core$Maybe$Just(true));
				var goingForward = isAuthenticated ? A2($author$project$Kernel$Aspect$Navigation$RouteHistory$routeForwardWhileDropping, config.ac.mD, state.jE) : A2($author$project$Kernel$Aspect$Navigation$RouteHistory$routeForwardWhileDropping, config.ac.oA, state.jE);
				if ($author$project$Kernel$Aspect$Navigation$RouteHistory$isPendingRoutingAction(state.jE)) {
					return _Utils_Tuple3(state.jE, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				} else {
					if (!goingForward.$) {
						var _v21 = goingForward.a;
						var newHistory = _v21.a;
						var cmd = _v21.b;
						return _Utils_Tuple3(newHistory, cmd, $elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(
							state.jE,
							A2($author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$reportErr, 'RouteForward', 'not enough lee-way'),
							$elm$core$Maybe$Nothing);
					}
				}
			case 7:
				var payload = msg.a;
				var _v22 = A2($author$project$Kernel$Aspect$Navigation$RouteHistory$handlePopState, payload.br, state.jE);
				switch (_v22.$) {
					case 0:
						var shouldSilent = _v22.a;
						var newRouteHistory = _v22.b;
						return _Utils_Tuple3(
							newRouteHistory,
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Just(
								A3(
									$author$project$Kernel$Aspect$Navigation$Routing$NewRoute,
									shouldSilent,
									state.jE,
									$author$project$Kernel$Aspect$Navigation$RouteHistory$current(newRouteHistory))));
					case 1:
						var shouldSilent = _v22.a;
						var newRouteHistory = _v22.b;
						var newRoute = _v22.c;
						return $author$project$Kernel$Aspect$Navigation$Routing$routeToOutMsg(
							{
								hG: config,
								aU: newRoute,
								gA: false,
								jP: shouldSilent,
								aX: _Utils_update(
									state,
									{jE: newRouteHistory})
							});
					case 2:
						var err = _v22.a;
						return _Utils_Tuple3(
							state.jE,
							A2($author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$reportErr, 'PopStateError for pathname:' + payload.iQ.gj, err),
							$elm$core$Maybe$Nothing);
					case 3:
						var routeHistory = _v22.a;
						return _Utils_Tuple3(
							routeHistory,
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Just($author$project$Kernel$Aspect$Navigation$Routing$UserWantsBack));
					case 4:
						var routeHistory = _v22.a;
						return _Utils_Tuple3(
							routeHistory,
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Just($author$project$Kernel$Aspect$Navigation$Routing$UserWantsForward));
					default:
						var routeHistory = _v22.a;
						var cmd = _v22.b;
						return _Utils_Tuple3(routeHistory, cmd, $elm$core$Maybe$Nothing);
				}
			case 8:
				var navigationLocation = msg.a.np;
				var shouldReplace = msg.a.gA;
				var shouldSilent = msg.a.jP;
				if ($author$project$Kernel$Aspect$Navigation$RouteHistory$isPendingRoutingAction(state.jE)) {
					return _Utils_Tuple3(state.jE, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				} else {
					var _v23 = config.ac.pO(
						$author$project$Kernel$Aspect$Url$Url$fromNavigationLocation(navigationLocation));
					if (!_v23.$) {
						var route = _v23.a;
						return $author$project$Kernel$Aspect$Navigation$Routing$routeToOutMsg(
							{hG: config, aU: route, gA: shouldReplace, jP: shouldSilent, aX: state});
					} else {
						return _Utils_Tuple3(
							state.jE,
							A2($author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$reportErr, 'NavToFromLoopback: unexpected pathname:', navigationLocation.gj),
							$elm$core$Maybe$Nothing);
					}
				}
			default:
				return $author$project$Kernel$Aspect$Navigation$Routing$routeToOutMsg(
					{hG: config, aU: config.ac.kQ, gA: false, jP: false, aX: state});
		}
	});
var $author$project$Kernel$Aspect$Toaster$Toaster$ToastTimerDone = function (a) {
	return {$: 0, a: a};
};
var $author$project$Kernel$Aspect$Toaster$Toaster$areTooManyToasts = F2(
	function (theToastsHeight, windowHeight) {
		return _Utils_cmp(theToastsHeight, (windowHeight / 3) | 0) > 0;
	});
var $author$project$Kernel$Aspect$Toaster$Toaster$ToastHidingDone = {$: 1};
var $author$project$Kernel$Aspect$Utility$timeInterval = {lA: ((1000 * 60) * 60) * 24, mr: (1000 * 60) * 60, nh: 1000 * 60, jI: 1000};
var $author$project$Kernel$Aspect$Toaster$Toaster$hideOldestVisibleToast = function (model) {
	var sleeper = A2(
		$elm$core$Task$perform,
		$elm$core$Basics$always($author$project$Kernel$Aspect$Toaster$Toaster$ToastHidingDone),
		$elm$core$Process$sleep(2 * $author$project$Kernel$Aspect$Utility$timeInterval.jI));
	return (model.ak > 0) ? _Utils_Tuple3(
		_Utils_update(
			model,
			{bU: model.bU + 1, ak: model.ak - 1}),
		sleeper,
		_List_Nil) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $author$project$Kernel$Aspect$Toaster$Toaster$isToastIdxVisible = F2(
	function (_v0, toastIdx) {
		var toasts = _v0.bG;
		var visibleToasts = _v0.ak;
		return _Utils_cmp(
			($elm$core$Array$length(toasts) - visibleToasts) - 1,
			toastIdx) < 0;
	});
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!value.$) {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$push = F2(
	function (a, array) {
		var tail = array.d;
		return A2(
			$elm$core$Array$unsafeReplaceTail,
			A2($elm$core$Elm$JsArray$push, a, tail),
			array);
	});
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $author$project$Kernel$Aspect$Utility$updateArray = F3(
	function (n, f, a) {
		var element = A2($elm$core$Array$get, n, a);
		if (element.$ === 1) {
			return a;
		} else {
			var element_ = element.a;
			return A3(
				$elm$core$Array$set,
				n,
				f(element_),
				a);
		}
	});
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var $elm$core$Elm$JsArray$slice = _JsArray_slice;
var $elm$core$Array$appendHelpBuilder = F2(
	function (tail, builder) {
		var tailLen = $elm$core$Elm$JsArray$length(tail);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.X)) - tailLen;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.X, tail);
		return (notAppended < 0) ? {
			_: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder._),
			P: builder.P + 1,
			X: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
		} : ((!notAppended) ? {
			_: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder._),
			P: builder.P + 1,
			X: $elm$core$Elm$JsArray$empty
		} : {_: builder._, P: builder.P, X: appended});
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$Array$sliceLeft = F2(
	function (from, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		if (!from) {
			return array;
		} else {
			if (_Utils_cmp(
				from,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					len - from,
					$elm$core$Array$shiftStep,
					$elm$core$Elm$JsArray$empty,
					A3(
						$elm$core$Elm$JsArray$slice,
						from - $elm$core$Array$tailIndex(len),
						$elm$core$Elm$JsArray$length(tail),
						tail));
			} else {
				var skipNodes = (from / $elm$core$Array$branchFactor) | 0;
				var helper = F2(
					function (node, acc) {
						if (!node.$) {
							var subTree = node.a;
							return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
						} else {
							var leaf = node.a;
							return A2($elm$core$List$cons, leaf, acc);
						}
					});
				var leafNodes = A3(
					$elm$core$Elm$JsArray$foldr,
					helper,
					_List_fromArray(
						[tail]),
					tree);
				var nodesToInsert = A2($elm$core$List$drop, skipNodes, leafNodes);
				if (!nodesToInsert.b) {
					return $elm$core$Array$empty;
				} else {
					var head = nodesToInsert.a;
					var rest = nodesToInsert.b;
					var firstSlice = from - (skipNodes * $elm$core$Array$branchFactor);
					var initialBuilder = {
						_: _List_Nil,
						P: 0,
						X: A3(
							$elm$core$Elm$JsArray$slice,
							firstSlice,
							$elm$core$Elm$JsArray$length(head),
							head)
					};
					return A2(
						$elm$core$Array$builderToArray,
						true,
						A3($elm$core$List$foldl, $elm$core$Array$appendHelpBuilder, initialBuilder, rest));
				}
			}
		}
	});
var $elm$core$Array$fetchNewTail = F4(
	function (shift, end, treeEnd, tree) {
		fetchNewTail:
		while (true) {
			var pos = $elm$core$Array$bitMask & (treeEnd >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var sub = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$end = end,
					$temp$treeEnd = treeEnd,
					$temp$tree = sub;
				shift = $temp$shift;
				end = $temp$end;
				treeEnd = $temp$treeEnd;
				tree = $temp$tree;
				continue fetchNewTail;
			} else {
				var values = _v0.a;
				return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
			}
		}
	});
var $elm$core$Array$hoistTree = F3(
	function (oldShift, newShift, tree) {
		hoistTree:
		while (true) {
			if ((_Utils_cmp(oldShift, newShift) < 1) || (!$elm$core$Elm$JsArray$length(tree))) {
				return tree;
			} else {
				var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);
				if (!_v0.$) {
					var sub = _v0.a;
					var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
						$temp$newShift = newShift,
						$temp$tree = sub;
					oldShift = $temp$oldShift;
					newShift = $temp$newShift;
					tree = $temp$tree;
					continue hoistTree;
				} else {
					return tree;
				}
			}
		}
	});
var $elm$core$Array$sliceTree = F3(
	function (shift, endIdx, tree) {
		var lastPos = $elm$core$Array$bitMask & (endIdx >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
		if (!_v0.$) {
			var sub = _v0.a;
			var newSub = A3($elm$core$Array$sliceTree, shift - $elm$core$Array$shiftStep, endIdx, sub);
			return (!$elm$core$Elm$JsArray$length(newSub)) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3(
				$elm$core$Elm$JsArray$unsafeSet,
				lastPos,
				$elm$core$Array$SubTree(newSub),
				A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
		} else {
			return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
		}
	});
var $elm$core$Array$sliceRight = F2(
	function (end, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		if (_Utils_eq(end, len)) {
			return array;
		} else {
			if (_Utils_cmp(
				end,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					startShift,
					tree,
					A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
			} else {
				var endIdx = $elm$core$Array$tailIndex(end);
				var depth = $elm$core$Basics$floor(
					A2(
						$elm$core$Basics$logBase,
						$elm$core$Array$branchFactor,
						A2($elm$core$Basics$max, 1, endIdx - 1)));
				var newShift = A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep);
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					newShift,
					A3(
						$elm$core$Array$hoistTree,
						startShift,
						newShift,
						A3($elm$core$Array$sliceTree, startShift, endIdx, tree)),
					A4($elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
			}
		}
	});
var $elm$core$Array$translateIndex = F2(
	function (index, _v0) {
		var len = _v0.a;
		var posIndex = (index < 0) ? (len + index) : index;
		return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
	});
var $elm$core$Array$slice = F3(
	function (from, to, array) {
		var correctTo = A2($elm$core$Array$translateIndex, to, array);
		var correctFrom = A2($elm$core$Array$translateIndex, from, array);
		return (_Utils_cmp(correctFrom, correctTo) > 0) ? $elm$core$Array$empty : A2(
			$elm$core$Array$sliceLeft,
			correctFrom,
			A2($elm$core$Array$sliceRight, correctTo, array));
	});
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Kernel$Aspect$Toaster$Toaster$toastsHeight = F3(
	function (toasts, fromIndex, toIndex) {
		var heightSumCalculator = F2(
			function (_v0, sum) {
				var maybeHeight = _v0.b;
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					sum,
					$elm$core$Basics$add(sum),
					maybeHeight);
			});
		return A3(
			$elm$core$Array$foldl,
			heightSumCalculator,
			0,
			A3($elm$core$Array$slice, fromIndex, toIndex, toasts));
	});
var $author$project$Kernel$Aspect$Toaster$Toaster$visibleToastsHeight = F2(
	function (toasts, visibleToasts) {
		return A3(
			$author$project$Kernel$Aspect$Toaster$Toaster$toastsHeight,
			toasts,
			-visibleToasts,
			$elm$core$Array$length(toasts));
	});
var $author$project$Kernel$Aspect$Toaster$Toaster$update = F3(
	function (_v0, msg, model) {
		var windowHeight = _v0.ku;
		switch (msg.$) {
			case 0:
				var toastIdx = msg.a;
				return A2($author$project$Kernel$Aspect$Toaster$Toaster$isToastIdxVisible, model, toastIdx) ? $author$project$Kernel$Aspect$Toaster$Toaster$hideOldestVisibleToast(model) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			case 1:
				var _v2 = _Utils_Tuple2(model.ak, model.bU - 1);
				if ((!_v2.a) && (!_v2.b)) {
					return _Utils_Tuple3($author$project$Kernel$Aspect$Toaster$Toaster$init, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bU: model.bU - 1}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var toastIdx = msg.a;
				var height = msg.b.fx;
				var toasts = A3(
					$author$project$Kernel$Aspect$Utility$updateArray,
					toastIdx,
					function (_v3) {
						var t = _v3.a;
						return _Utils_Tuple2(
							t,
							$elm$core$Maybe$Just(height));
					},
					model.bG);
				var visibleHeight = A2($author$project$Kernel$Aspect$Toaster$Toaster$visibleToastsHeight, toasts, model.ak);
				var visibleToasts = ((model.ak > 1) && A2($author$project$Kernel$Aspect$Toaster$Toaster$areTooManyToasts, visibleHeight, windowHeight)) ? (model.ak - 1) : model.ak;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bG: toasts, ak: visibleToasts}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				return $author$project$Kernel$Aspect$Toaster$Toaster$hideOldestVisibleToast(model);
			case 4:
				var actionMsg = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[actionMsg]));
			default:
				var toastItem = msg.a;
				var toasts = A2(
					$elm$core$Array$push,
					_Utils_Tuple2(toastItem, $elm$core$Maybe$Nothing),
					model.bG);
				var cbMsg = $author$project$Kernel$Aspect$Toaster$Toaster$ToastTimerDone(
					$elm$core$Array$length(toasts) - 1);
				var cmd = A2(
					$elm$core$Task$perform,
					$elm$core$Basics$always(cbMsg),
					$elm$core$Process$sleep(5 * $author$project$Kernel$Aspect$Utility$timeInterval.jI));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bG: toasts, ak: model.ak + 1}),
					cmd,
					_List_Nil);
		}
	});
var $elm$file$File$Download$url = function (href) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$never,
		_File_downloadUrl(href));
};
var $author$project$Kernel$Update$updaterRecursive = F3(
	function (config, msg, state) {
		switch (msg.$) {
			case 0:
				var appMsg = msg.a;
				return A2(
					$author$project$Kernel$MsgAnything$topmostHandler,
					$author$project$Kernel$Update$updaterRecursive(config),
					{
						nl: $author$project$Kernel$Msg$AppMsg,
						o$: function (childState) {
							return _Utils_update(
								state,
								{eV: childState});
						},
						pN: A2(config.pM, appMsg, state)
					});
			case 2:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{ph: posix}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var msgs = msg.a;
				return A2(
					$author$project$Kernel$MsgAnything$dispatchMessages,
					$author$project$Kernel$Update$updaterRecursive(config),
					{le: $elm$core$Platform$Cmd$none, Z: msgs, aX: state});
			case 3:
				var time = msg.a;
				var theMsg = msg.b;
				return _Utils_Tuple2(
					state,
					A2(
						$elm$core$Task$perform,
						function (_v1) {
							return theMsg;
						},
						$elm$core$Process$sleep(time)));
			case 4:
				var toasterMsg = msg.a;
				return A2(
					$author$project$Kernel$MsgAnything$topmostHandler,
					$author$project$Kernel$Update$updaterRecursive(config),
					{
						nl: $author$project$Kernel$Msg$ToasterMsg,
						o$: function (childState) {
							return _Utils_update(
								state,
								{pv: childState});
						},
						pN: A3(
							$author$project$Kernel$Aspect$Toaster$Toaster$update,
							{ku: state.k0.fx},
							toasterMsg,
							state.pv)
					});
			case 5:
				var routingMsg = msg.a;
				var _v2 = A3($author$project$Kernel$Aspect$Navigation$Routing$update, config, routingMsg, state);
				var newRouteHistory = _v2.a;
				var cmd = _v2.b;
				var outMsg = _v2.c;
				if (!outMsg.$) {
					switch (outMsg.a.$) {
						case 0:
							var _v4 = outMsg.a;
							return A2(
								$author$project$Kernel$MsgAnything$dispatchMessages,
								$author$project$Kernel$Update$updaterRecursive(config),
								{
									le: cmd,
									Z: A2(
										config.ac.pR,
										state.eV,
										$author$project$Kernel$Aspect$Navigation$RouteHistory$current(newRouteHistory)),
									aX: _Utils_update(
										state,
										{jE: newRouteHistory})
								});
						case 1:
							var _v5 = outMsg.a;
							return A2(
								$author$project$Kernel$MsgAnything$dispatchMessages,
								$author$project$Kernel$Update$updaterRecursive(config),
								{
									le: cmd,
									Z: A2(
										config.ac.pS,
										state.eV,
										$author$project$Kernel$Aspect$Navigation$RouteHistory$current(newRouteHistory)),
									aX: _Utils_update(
										state,
										{jE: newRouteHistory})
								});
						default:
							var _v6 = outMsg.a;
							var shouldSilent = _v6.a;
							var oldHistory = _v6.b;
							var newRoute = _v6.c;
							return shouldSilent ? _Utils_Tuple2(
								_Utils_update(
									state,
									{jE: newRouteHistory}),
								cmd) : A2(
								$author$project$Kernel$MsgAnything$dispatchMessages,
								$author$project$Kernel$Update$updaterRecursive(config),
								{
									le: cmd,
									Z: A3(config.ac.nC, state, oldHistory, newRoute),
									aX: _Utils_update(
										state,
										{jE: newRouteHistory})
								});
					}
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							state,
							{jE: newRouteHistory}),
						cmd);
				}
			case 6:
				var browser = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{k0: browser}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var event = msg.a;
				switch (event.$) {
					case 0:
						return A2(
							$author$project$Kernel$MsgAnything$dispatchMessages,
							$author$project$Kernel$Update$updaterRecursive(config),
							{
								le: $elm$core$Platform$Cmd$none,
								Z: A2(
									config.nE,
									state,
									$author$project$Kernel$Aspect$Navigation$RouteHistory$current(state.jE)),
								aX: state
							});
					case 1:
						return A2(
							$author$project$Kernel$MsgAnything$dispatchMessages,
							$author$project$Kernel$Update$updaterRecursive(config),
							{
								le: $elm$core$Platform$Cmd$none,
								Z: A2(
									config.nD,
									state,
									$author$project$Kernel$Aspect$Navigation$RouteHistory$current(state.jE)),
								aX: state
							});
					default:
						var theEvent = event.a;
						return _Utils_Tuple2(
							state,
							$author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$generalError('handleLifecycleEvent: unexpected event: ' + theEvent));
				}
			case 8:
				var visibility = msg.a;
				if (visibility === 1) {
					return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
				} else {
					return A2(
						$author$project$Kernel$MsgAnything$dispatchMessages,
						$author$project$Kernel$Update$updaterRecursive(config),
						{
							le: $elm$core$Platform$Cmd$none,
							Z: A2(
								config.nB,
								state,
								$author$project$Kernel$Aspect$Navigation$RouteHistory$current(state.jE)),
							aX: state
						});
				}
			case 9:
				var url = msg.a;
				return _Utils_Tuple2(
					state,
					$elm$file$File$Download$url(url));
			default:
				return A2(
					$author$project$Kernel$MsgAnything$dispatchMessages,
					$author$project$Kernel$Update$updaterRecursive(config),
					{
						le: $elm$core$Platform$Cmd$none,
						Z: A2(
							config.nB,
							state,
							$author$project$Kernel$Aspect$Navigation$RouteHistory$current(state.jE)),
						aX: state
					});
		}
	});
var $author$project$Kernel$Update$maybeRedirect = F2(
	function (config, state) {
		var _v0 = A2(
			config.ac.ob,
			state.eV,
			$author$project$Kernel$Aspect$Navigation$RouteHistory$current(state.jE));
		if (!_v0.$) {
			var redirectTo = _v0.a;
			var _v1 = $author$project$Kernel$Aspect$Navigation$RouteHistory$setRoute(
				{
					jE: redirectTo.jE,
					b1: state.jE,
					gA: redirectTo.gA,
					bs: A2(config.ac.oE, state.eV, redirectTo.jE).bs,
					ba: $author$project$Kernel$Aspect$Url$Url$toUrlString(
						config.ac.oF(redirectTo.jE))
				});
			var routeHistory = _v1.a;
			var routeCmds = _v1.b;
			return A2(
				$author$project$Kernel$MsgAnything$dispatchMessages,
				$author$project$Kernel$Update$updaterRecursive(config),
				{
					le: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[routeCmds])),
					Z: A3(config.ac.nC, state, state.jE, redirectTo.jE),
					aX: _Utils_update(
						state,
						{jE: routeHistory})
				});
		} else {
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Kernel$Update$update = F3(
	function (config, msg, state) {
		var _v0 = A3($author$project$Kernel$Update$updaterRecursive, config, msg, state);
		var newState = _v0.a;
		var cmd = _v0.b;
		var _v1 = function () {
			var isAuthenticatedInNewState = config.ac.mE(newState.eV);
			var authStateChanged = !_Utils_eq(
				config.ac.mE(state.eV),
				isAuthenticatedInNewState);
			if ($author$project$Kernel$Aspect$Navigation$RouteHistory$isPendingRoutingAction(state.jE)) {
				return _Utils_Tuple2(newState, $elm$core$Platform$Cmd$none);
			} else {
				if (authStateChanged) {
					if (!isAuthenticatedInNewState.$) {
						if (isAuthenticatedInNewState.a) {
							return config.ac.mD(
								$author$project$Kernel$Aspect$Navigation$RouteHistory$current(newState.jE)) ? A3(
								$author$project$Kernel$Update$updaterRecursive,
								config,
								$author$project$Kernel$Msg$RoutingMsg(
									A2($author$project$Kernel$Aspect$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault, $elm$core$Maybe$Nothing, config.ac.mD)),
								newState) : A2($author$project$Kernel$Update$maybeRedirect, config, newState);
						} else {
							return config.ac.oA(
								$author$project$Kernel$Aspect$Navigation$RouteHistory$current(newState.jE)) ? A3(
								$author$project$Kernel$Update$updaterRecursive,
								config,
								$author$project$Kernel$Msg$RoutingMsg(
									A3($author$project$Kernel$Aspect$Navigation$Msg$RouteTo, false, false, config.ac.kQ)),
								newState) : A2($author$project$Kernel$Update$maybeRedirect, config, newState);
						}
					} else {
						return A2($author$project$Kernel$Update$maybeRedirect, config, newState);
					}
				} else {
					return A2($author$project$Kernel$Update$maybeRedirect, config, newState);
				}
			}
		}();
		var newStateWithUpdatedRouting = _v1.a;
		var updatedRoutingCmd = _v1.b;
		var setTitleAndDescriptionCmd = function () {
			var oldMeta = A2(
				config.ac.oE,
				state.eV,
				$author$project$Kernel$Aspect$Navigation$RouteHistory$current(state.jE));
			var newMeta = A2(
				config.ac.oE,
				newState.eV,
				$author$project$Kernel$Aspect$Navigation$RouteHistory$current(newState.jE));
			return (!_Utils_eq(oldMeta, newMeta)) ? $author$project$Kernel$Aspect$Platform$Platform$setTitleAndDescription(newMeta) : $elm$core$Platform$Cmd$none;
		}();
		return _Utils_Tuple2(
			newStateWithUpdatedRouting,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, setTitleAndDescriptionCmd, updatedRoutingCmd])));
	});
var $author$project$Kernel$Main$init = F2(
	function (config, programArgs) {
		var homeRouteDecidingParams = {
			k0: programArgs.mO.k0,
			h1: programArgs.mO.h1,
			mp: programArgs.mO.np.mp,
			mq: programArgs.mO.np.mq,
			nK: programArgs.mO.np.nK,
			nY: $elm$core$String$toInt(programArgs.mO.np.nY),
			n7: programArgs.mO.np.n7,
			ph: $elm$time$Time$millisToPosix(programArgs.mO.ls),
			qm: A2($elm$time$Time$customZone, programArgs.mO.pj, _List_Nil)
		};
		var _v0 = config.my(programArgs);
		var appState = _v0.a;
		var appCmd = _v0.b;
		var initComands = A2($elm$core$Platform$Cmd$map, $author$project$Kernel$Msg$AppMsg, appCmd);
		var homeRoute = A2(config.ac.pm, homeRouteDecidingParams, appState);
		var _v1 = A4($author$project$Kernel$Aspect$Navigation$Routing$toInitialRoute, config.ac, programArgs, appState, homeRoute);
		var initialRouteHistory = _v1.a;
		var initialRouteCmd = _v1.b;
		var initState = {
			eV: appState,
			k0: programArgs.mO.k0,
			h1: programArgs.mO.h1,
			jE: initialRouteHistory,
			ph: $elm$time$Time$millisToPosix(programArgs.mO.ls),
			pv: $author$project$Kernel$Aspect$Toaster$Toaster$init,
			qm: A2($elm$time$Time$customZone, programArgs.mO.pj, _List_Nil)
		};
		return A2(
			$author$project$Kernel$MsgAnything$dispatchMessages,
			$author$project$Kernel$Update$update(config),
			{le: initComands, Z: _List_Nil, aX: initState});
	});
var $author$project$Kernel$Msg$LifeCycleEvent = function (a) {
	return {$: 7, a: a};
};
var $author$project$Kernel$Msg$UpdateCurrentTime = function (a) {
	return {$: 2, a: a};
};
var $author$project$Kernel$Msg$VisibilityChange = function (a) {
	return {$: 8, a: a};
};
var $author$project$Kernel$Msg$WeAreOnline = {$: 10};
var $author$project$Kernel$Msg$WindowResize = function (a) {
	return {$: 6, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {ji: processes, j6: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.ji;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.j6);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Kernel$Aspect$Platform$Platform$lifeCycleEvent = _Platform_incomingPort('lifeCycleEvent', $elm$json$Json$Decode$string);
var $author$project$Kernel$Aspect$Platform$Platform$Pause = {$: 1};
var $author$project$Kernel$Aspect$Platform$Platform$Resume = {$: 0};
var $author$project$Kernel$Aspect$Platform$Platform$Unexpected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Kernel$Aspect$Platform$Platform$toLifeCycleEvent = function (eventString) {
	switch (eventString) {
		case 'Resume':
			return $author$project$Kernel$Aspect$Platform$Platform$Resume;
		case 'Pause':
			return $author$project$Kernel$Aspect$Platform$Platform$Pause;
		default:
			var unexpected = eventString;
			return $author$project$Kernel$Aspect$Platform$Platform$Unexpected(unexpected);
	}
};
var $author$project$Kernel$Aspect$Platform$Platform$listenLifeCycleEvents = function (tag) {
	return $author$project$Kernel$Aspect$Platform$Platform$lifeCycleEvent(
		A2($elm$core$Basics$composeL, tag, $author$project$Kernel$Aspect$Platform$Platform$toLifeCycleEvent));
};
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$browser$Browser$Events$Document = 0;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {je: pids, j4: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {h3: event, iI: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.je,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.iI;
		var event = _v0.h3;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.j4);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$Hidden = 1;
var $elm$browser$Browser$Events$Visible = 0;
var $elm$browser$Browser$Events$withHidden = F2(
	function (func, isHidden) {
		return func(
			isHidden ? 1 : 0);
	});
var $elm$browser$Browser$Events$onVisibilityChange = function (func) {
	var info = _Browser_visibilityInfo(0);
	return A3(
		$elm$browser$Browser$Events$on,
		0,
		info.k5,
		A2(
			$elm$json$Json$Decode$map,
			$elm$browser$Browser$Events$withHidden(func),
			A2(
				$elm$json$Json$Decode$field,
				'target',
				A2($elm$json$Json$Decode$field, info.ml, $elm$json$Json$Decode$bool))));
};
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $author$project$Kernel$Aspect$Platform$Platform$weAreOnline = _Platform_incomingPort(
	'weAreOnline',
	$elm$json$Json$Decode$null(0));
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Kernel$Aspect$Browser$Browser$windowResize = _Platform_incomingPort(
	'windowResize',
	A2(
		$elm$json$Json$Decode$andThen,
		function (width) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (unitSize) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (pixelRatio) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (height) {
									return $elm$json$Json$Decode$succeed(
										{fx: height, jf: pixelRatio, eE: unitSize, g6: width});
								},
								A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
						},
						A2($elm$json$Json$Decode$field, 'pixelRatio', $elm$json$Json$Decode$float));
				},
				A2($elm$json$Json$Decode$field, 'unitSize', $elm$json$Json$Decode$int));
		},
		A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int)));
var $author$project$Kernel$Main$subscriptions = F2(
	function (config, state) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Kernel$Msg$AppMsg,
					config.o7(state)),
					A2($elm$time$Time$every, 6000, $author$project$Kernel$Msg$UpdateCurrentTime),
					$author$project$Kernel$Aspect$Browser$Browser$windowResize($author$project$Kernel$Msg$WindowResize),
					$author$project$Kernel$Aspect$Platform$Platform$listenLifeCycleEvents($author$project$Kernel$Msg$LifeCycleEvent),
					$elm$browser$Browser$Events$onVisibilityChange($author$project$Kernel$Msg$VisibilityChange),
					$author$project$Kernel$Aspect$Platform$Platform$weAreOnline(
					$elm$core$Basics$always($author$project$Kernel$Msg$WeAreOnline))
				]));
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Kernel$Aspect$Toaster$Toaster$Tap = {$: 3};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$Kernel$Aspect$Toaster$Toaster$hiddenToastsHeight = F2(
	function (toasts, visibleToasts) {
		return A3(
			$author$project$Kernel$Aspect$Toaster$Toaster$toastsHeight,
			toasts,
			0,
			$elm$core$Array$length(toasts) - visibleToasts);
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			_: _List_Nil,
			P: 0,
			X: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail)
		};
		var helper = F2(
			function (node, builder) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.P * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						_: A2($elm$core$List$cons, mappedLeaf, builder._),
						P: builder.P + 1,
						X: builder.X
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $author$project$Kernel$Aspect$Toaster$Toaster$ReceiveToastHeight = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $author$project$Kernel$UI$Eventfull$Eventfull$eventFull = F2(
	function (eventHandlers, attrs) {
		var toAttrs = function (_v0) {
			var eventEmitterAttributes = _v0;
			return eventEmitterAttributes;
		};
		var normalizedHandlers = $elm$core$List$concat(
			A2($elm$core$List$map, toAttrs, eventHandlers));
		var defaultAttrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('block')
			]);
		return A2(
			$elm$html$Html$node,
			'event-full',
			_Utils_ap(
				defaultAttrs,
				_Utils_ap(normalizedHandlers, attrs)));
	});
var $author$project$Kernel$UI$Eventfull$Eventfull$EventEmitter = $elm$core$Basics$identity;
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Kernel$UI$Eventfull$Eventfull$Size = F4(
	function (width, height, contentWidth, contentHeight) {
		return {li: contentHeight, lj: contentWidth, fx: height, g6: width};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$Kernel$Aspect$Utility$preventer = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		function (msg) {
			return {ct: msg, n4: true, o2: true};
		},
		decoder);
};
var $author$project$Kernel$Aspect$Utility$onLocal = F2(
	function (eventName, decoder) {
		return A2(
			$elm$html$Html$Events$custom,
			eventName,
			$author$project$Kernel$Aspect$Utility$preventer(decoder));
	});
var $author$project$Kernel$UI$Eventfull$Eventfull$onSizeEmitter = function (tag) {
	return A2(
		$author$project$Kernel$Aspect$Utility$onLocal,
		'onSize',
		A2(
			$elm$json$Json$Decode$map,
			tag,
			A2(
				$elm$json$Json$Decode$field,
				'detail',
				A5(
					$elm$json$Json$Decode$map4,
					$author$project$Kernel$UI$Eventfull$Eventfull$Size,
					A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'contentWidth', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'contentHeight', $elm$json$Json$Decode$int)))));
};
var $author$project$Kernel$UI$Eventfull$Eventfull$onFirstChildSize = function (tag) {
	return _List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'emit-first-child-size', 'true'),
			$author$project$Kernel$UI$Eventfull$Eventfull$onSizeEmitter(tag)
		]);
};
var $author$project$Kernel$Aspect$Toaster$Toaster$toastView = F4(
	function (idx, _v0, isHidden, topBarOffset) {
		var shade = _v0.jN;
		var content = _v0.A;
		var background = _v0.hi;
		var moveOver = isHidden ? topBarOffset : 0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('aToast'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('outOfSight', isHidden)
						])),
					A2(
					$elm$html$Html$Attributes$style,
					'transform',
					'translateY(-' + ($elm$core$String$fromInt(moveOver) + 'px)'))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative'),
							A2(
							$elm$html$Html$Attributes$style,
							'margin-top',
							'-' + ($elm$core$String$fromInt(topBarOffset) + 'px'))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$style,
									'height',
									$elm$core$String$fromInt(topBarOffset) + 'px')
								]),
							_List_Nil),
							background,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('shade absolute inset-0')
								]),
							_List_fromArray(
								[shade])),
							A3(
							$author$project$Kernel$UI$Eventfull$Eventfull$eventFull,
							_List_fromArray(
								[
									$author$project$Kernel$UI$Eventfull$Eventfull$onFirstChildSize(
									$author$project$Kernel$Aspect$Toaster$Toaster$ReceiveToastHeight(idx))
								]),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative')
								]),
							_List_fromArray(
								[content]))
						]))
				]));
	});
var $author$project$Kernel$Aspect$Toaster$Toaster$toKeyedToasts = F3(
	function (toasts, visibleToasts, topBarOffset) {
		var oldestVisibleToastIndex = $elm$core$Array$length(toasts) - visibleToasts;
		var foldToKeyed = F2(
			function (_v1, keyedList) {
				var toastIndex = _v1.a;
				var toast = _v1.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						$elm$core$String$fromInt(toastIndex),
						A4(
							$author$project$Kernel$Aspect$Toaster$Toaster$toastView,
							toastIndex,
							toast,
							_Utils_cmp(toastIndex, oldestVisibleToastIndex) < 0,
							topBarOffset)),
					keyedList);
			});
		return $elm$core$List$reverse(
			A3(
				$elm$core$Array$foldl,
				foldToKeyed,
				_List_Nil,
				A2(
					$elm$core$Array$indexedMap,
					F2(
						function (idx, _v0) {
							var toast = _v0.a;
							return _Utils_Tuple2(idx, toast);
						}),
					toasts)));
	});
var $author$project$Kernel$Aspect$Toaster$Toaster$view = F2(
	function (_v0, topBarOffset) {
		var toasts = _v0.bG;
		var visibleToasts = _v0.ak;
		var offset = A2($author$project$Kernel$Aspect$Toaster$Toaster$hiddenToastsHeight, toasts, visibleToasts);
		return A3(
			$elm$html$Html$node,
			'toaster',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute right0 left0'),
					A2($elm$html$Html$Attributes$style, 'z-index', '1500'),
					A2(
					$elm$html$Html$Attributes$style,
					'top',
					$elm$core$String$fromInt(topBarOffset) + 'px'),
					A2(
					$elm$html$Html$Events$on,
					'mousedown',
					$elm$json$Json$Decode$succeed($author$project$Kernel$Aspect$Toaster$Toaster$Tap))
				]),
			_List_fromArray(
				[
					A3(
					$elm$html$Html$Keyed$node,
					'div',
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toastsSlidingWrap relative'),
							A2(
							$elm$html$Html$Attributes$style,
							'transform',
							'translateY(-' + ($elm$core$String$fromInt(offset) + 'px)'))
						]),
					A3($author$project$Kernel$Aspect$Toaster$Toaster$toKeyedToasts, toasts, visibleToasts, topBarOffset))
				]));
	});
var $author$project$Kernel$View$view = F2(
	function (config, state) {
		return A3(
			$elm$html$Html$node,
			'elm-framework',
			_List_Nil,
			_List_fromArray(
				[
					config.pY(state),
					A2(
					$elm$html$Html$map,
					$author$project$Kernel$Msg$ToasterMsg,
					A2($author$project$Kernel$Aspect$Toaster$Toaster$view, state.pv, 0))
				]));
	});
var $author$project$Kernel$Main$app = function (config) {
	return $elm$browser$Browser$element(
		{
			my: $author$project$Kernel$Main$init(config),
			o7: $author$project$Kernel$Main$subscriptions(config),
			pM: $author$project$Kernel$Update$update(config),
			pY: $author$project$Kernel$View$view(config)
		});
};
var $author$project$Remote$RequestMsg$CheckAuth = function (a) {
	return {$: 3, a: a};
};
var $author$project$Remote$RequestMsg$CheckAuthContextOther = 1;
var $author$project$Msg$PollHashrateAndWorkers = {$: 5};
var $author$project$Msg$AccountMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Msg$GlobalMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Global$Msg$OnAuthSuccess = {$: 0};
var $author$project$Remote$Msg$OnAuthSuccess = {$: 1};
var $author$project$UI$Account$Msg$OnAuthSuccess = {$: 2};
var $author$project$Remote$Msg$OnBrokerAuthSuccess = {$: 4};
var $author$project$Remote$Msg$OnWatcherAuthSuccess = {$: 2};
var $author$project$Msg$RemoteMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$RemoteRequestMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Remote$RequestMsg$UserHashrateHistorical = function (a) {
	return {$: 11, a: a};
};
var $author$project$Remote$HashrateHistory$dayInMillis = ((24 * 60) * 60) * 1000;
var $author$project$Remote$HashrateHistory$bootstrapWindowMillis = 30 * $author$project$Remote$HashrateHistory$dayInMillis;
var $author$project$Remote$HashrateHistory$historyChunkMillis = 7 * $author$project$Remote$HashrateHistory$dayInMillis;
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $author$project$Remote$HashrateHistory$historicalRangesBetween = F2(
	function (from, to) {
		var toMillis = $elm$time$Time$posixToMillis(to);
		var fromMillis = $elm$time$Time$posixToMillis(from);
		var buildRanges = F2(
			function (rangeStart, accumulatedRanges) {
				buildRanges:
				while (true) {
					var rangeEnd = A2($elm$core$Basics$min, toMillis, rangeStart + $author$project$Remote$HashrateHistory$historyChunkMillis);
					var nextRanges = A2(
						$elm$core$List$cons,
						{
							c6: $elm$time$Time$millisToPosix(rangeStart),
							dr: $elm$time$Time$millisToPosix(rangeEnd)
						},
						accumulatedRanges);
					if (_Utils_cmp(rangeEnd, toMillis) > -1) {
						return $elm$core$List$reverse(nextRanges);
					} else {
						var $temp$rangeStart = rangeEnd,
							$temp$accumulatedRanges = nextRanges;
						rangeStart = $temp$rangeStart;
						accumulatedRanges = $temp$accumulatedRanges;
						continue buildRanges;
					}
				}
			});
		return (_Utils_cmp(fromMillis, toMillis) > 0) ? _List_Nil : A2(buildRanges, fromMillis, _List_Nil);
	});
var $author$project$Remote$HashrateHistory$bootstrapRequests = function (now) {
	var nowMillis = $elm$time$Time$posixToMillis(now);
	return A2(
		$elm$core$List$map,
		$author$project$Remote$RequestMsg$UserHashrateHistorical,
		A2(
			$author$project$Remote$HashrateHistory$historicalRangesBetween,
			$elm$time$Time$millisToPosix(nowMillis - $author$project$Remote$HashrateHistory$bootstrapWindowMillis),
			now));
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$Global$Model$MainAccountData = 0;
var $author$project$Types$ProgramArgs$ApiEndpoint = $elm$core$Basics$identity;
var $author$project$Types$ProgramArgs$toConfig = function (configArgs) {
	return {kI: configArgs.kI};
};
var $author$project$Global$Global$init = function (_v0) {
	var appArgs = _v0.kJ;
	var kernelArgs = _v0.mO;
	var theConfig = $author$project$Types$ProgramArgs$toConfig(appArgs.lg);
	return _Utils_Tuple2(
		{dD: 0, cP: $elm$core$Maybe$Nothing, hl: '', hG: theConfig, h1: kernelArgs.h1, ma: kernelArgs.np.nK, fM: false, dn: 0, kp: '', pW: '0.0.2'},
		$elm$core$Platform$Cmd$none);
};
var $author$project$UI$Account$Model$init = {hl: '', kj: ''};
var $author$project$UI$Auth$Model$ResetPasswordStepOne = 0;
var $author$project$UI$Auth$Model$UserLogin = 0;
var $author$project$UI$Auth$Model$init = {hq: '', hr: '', lb: '', ff: '', iR: 0, cy: '', oh: 0, jC: false, pK: '', p2: '', p3: ''};
var $author$project$UI$ComponentsPreview$Model$init = {};
var $author$project$UI$Connect$Model$init = {};
var $author$project$UI$Home$Model$init = {iw: $elm$core$Maybe$Nothing, jW: 120};
var $author$project$UI$Library$Chart$Model$ThirtyDays = 3;
var $author$project$UI$Library$Chart$Model$rangeScaleMax = 10000;
var $author$project$UI$Library$Chart$Model$fullRangeSelection = {h_: $author$project$UI$Library$Chart$Model$rangeScaleMax, j$: 0};
var $author$project$UI$Library$Chart$Model$init = {hv: _List_Nil, hP: '', hQ: '', ix: _List_Nil, jK: $author$project$UI$Library$Chart$Model$fullRangeSelection, kr: 3};
var $author$project$UI$Library$DateRangePicker$All = 0;
var $author$project$UI$Library$DateRangePicker$init = {fo: '', aS: false, au: 0, gY: ''};
var $author$project$UI$Library$TablePagination$init = {nN: 1, i9: 15};
var $author$project$UI$Workers$Model$AllWorkers = 0;
var $author$project$UI$Workers$Model$Ascending = 0;
var $author$project$UI$Workers$Model$SortName = 0;
var $author$project$UI$Workers$Model$init = {$8: 0, nN: 0, i9: 20, gx: '', jX: 0, jY: 0};
var $author$project$Model$init = F3(
	function (global, remote, appArgs) {
		return {ha: $author$project$UI$Account$Model$init, hh: $author$project$UI$Auth$Model$init, hw: $author$project$UI$Library$Chart$Model$init, hF: $author$project$UI$ComponentsPreview$Model$init, hI: $author$project$UI$Connect$Model$init, im: $author$project$UI$Library$DateRangePicker$init, $9: $author$project$UI$Library$TablePagination$init, me: global, iu: $author$project$UI$Home$Model$init, jb: $author$project$UI$Library$DateRangePicker$init, jc: $author$project$UI$Library$TablePagination$init, jr: remote, kv: $author$project$UI$Workers$Model$init};
	});
var $author$project$Types$BrokerSessionStatus$BrokerSessionFetched = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$BrokerSessionStatus$BrokerUnauthenticated = {$: 0};
var $author$project$Kernel$Types$CorrelationId$CorrelationId = $elm$core$Basics$identity;
var $author$project$Types$UserSessionStatus$SessionFetched = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$UUID$UUID = $elm$core$Basics$identity;
var $author$project$Types$UserSessionStatus$Unauthenticated = {$: 0};
var $author$project$Types$ApiToken$AggregateGeneratedBTCAndHashrate = 2;
var $author$project$Types$ApiToken$AggregateGeneratedBTCOnly = 1;
var $author$project$Types$ApiToken$AggregateHashrateOnly = 0;
var $author$project$Types$ApiToken$aggregateApiKeyRequirementFromWire = function (raw) {
	switch (raw) {
		case 'hashrate':
			return $elm$core$Maybe$Just(0);
		case 'generated_btc':
			return $elm$core$Maybe$Just(1);
		case 'generated_btc_hashrate':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$ApiToken$defaultAggregateApiKeyRequirement = 2;
var $author$project$Types$Broker$fromBrokerSessionJS = function (_v0) {
	var id = _v0.mu;
	var email = _v0.ff;
	var referenceCode = _v0.oc;
	return {ff: email, mu: id, oc: referenceCode};
};
var $wernerdegroot$listzipper$List$Zipper$fromList = function (xs) {
	if (!xs.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var y = xs.a;
		var ys = xs.b;
		return $elm$core$Maybe$Just(
			A3($wernerdegroot$listzipper$List$Zipper$Zipper, _List_Nil, y, ys));
	}
};
var $author$project$Types$User$UserId = $elm$core$Basics$identity;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Types$KycStatus$Submitted = 1;
var $author$project$Types$KycStatus$Unverified = 0;
var $author$project$Types$KycStatus$Verified = 2;
var $author$project$Types$KycStatus$fromString = function (kycStatus) {
	switch (kycStatus) {
		case 'unverified':
			return 0;
		case 'submitted':
			return 1;
		case 'verified':
			return 2;
		default:
			return 0;
	}
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Types$UserSession$fromUserSessionJS = function (_v0) {
	var id = _v0.mu;
	var email = _v0.ff;
	var language = _v0.mS;
	var active = _v0.kD;
	var twoFactorSecret = _v0.g0;
	var kycStatus = _v0.mQ;
	var sellingHashRate = _v0.oN;
	var token = _v0.g_;
	var fpps_token = _v0.l8;
	var bitcoinAddresses = _v0.kT;
	var activeBitcoinAddress = A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$first,
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var isActive = _v1.b;
					return isActive;
				},
				$elm$core$Dict$toList(
					A2(
						$elm$core$Result$withDefault,
						$elm$core$Dict$empty,
						A2(
							$elm$json$Json$Decode$decodeValue,
							$elm$json$Json$Decode$dict($elm$json$Json$Decode$bool),
							bitcoinAddresses))))));
	return {
		kD: active,
		hl: activeBitcoinAddress,
		ff: email,
		l8: fpps_token,
		mu: id,
		mQ: $author$project$Types$KycStatus$fromString(kycStatus),
		mS: language,
		oN: sellingHashRate,
		g_: token,
		g0: twoFactorSecret
	};
};
var $author$project$Types$PplnsProjection$PplnsNotRequested = {$: 0};
var $author$project$Remote$Model$WorkersPaginationIdle = 0;
var $author$project$Remote$Model$WatcherAccessUnknown = 0;
var $author$project$Remote$Model$initialWatcherAccess = {d_: 0, mb: 0, d1: 0, em: 0, eu: 0, bJ: 0};
var $author$project$Remote$Model$initialRemote = F6(
	function (multiWatcherRequirement, correlationIds, uuids, userSessionStatus, brokerSessionStatus, userId) {
		return {
			hd: $author$project$Types$ApiToken$defaultAggregateApiKeyRequirement,
			eO: _List_Nil,
			eP: $elm$core$Maybe$Nothing,
			eQ: $elm$core$Dict$empty,
			eR: $elm$core$Dict$empty,
			eT: '',
			eU: $elm$core$Maybe$Nothing,
			e$: $elm$core$Maybe$Nothing,
			dI: brokerSessionStatus,
			ln: correlationIds,
			hM: _List_Nil,
			hN: $elm$core$Maybe$Nothing,
			h5: false,
			h6: '',
			h7: true,
			h8: '',
			h9: false,
			ia: '',
			ib: true,
			ic: '',
			mb: $elm$core$Maybe$Nothing,
			ft: 0.0,
			fu: 0.0,
			c9: $elm$core$Maybe$Nothing,
			da: $elm$core$Maybe$Nothing,
			mU: $elm$core$Maybe$Nothing,
			mV: $elm$core$Maybe$Nothing,
			d5: $elm$core$Maybe$Nothing,
			iK: $elm$core$Maybe$Nothing,
			mY: $elm$core$Maybe$Nothing,
			bz: $elm$core$Dict$empty,
			bm: $elm$core$Dict$empty,
			a3: $elm$core$Dict$empty,
			bn: $elm$core$Dict$empty,
			bA: $elm$core$Dict$empty,
			a4: $elm$core$Dict$empty,
			eb: multiWatcherRequirement,
			bX: _List_Nil,
			C: _List_Nil,
			ej: $elm$core$Maybe$Nothing,
			nQ: $elm$core$Maybe$Nothing,
			bD: 0,
			ek: _List_Nil,
			di: false,
			jd: $elm$core$Maybe$Nothing,
			nR: $elm$core$Maybe$Nothing,
			dk: $author$project$Types$PplnsProjection$PplnsNotRequested,
			jv: 7,
			gq: $elm$core$Maybe$Nothing,
			gr: $elm$core$Maybe$Nothing,
			jQ: false,
			gB: false,
			gC: false,
			jR: false,
			jS: false,
			j1: '',
			j2: '',
			gM: $elm$core$Dict$empty,
			ex: $elm$core$Maybe$Just(_List_Nil),
			gO: false,
			dA: $elm$core$Maybe$Nothing,
			g4: userId,
			pQ: userSessionStatus,
			pU: uuids,
			az: $author$project$Remote$Model$initialWatcherAccess,
			eH: $elm$core$Maybe$Nothing,
			p1: $elm$core$Maybe$Nothing,
			cc: $elm$core$Maybe$Nothing,
			eI: $elm$core$Maybe$Nothing,
			bJ: $elm$core$Maybe$Nothing,
			eL: $elm$core$Maybe$Nothing,
			eM: 0
		};
	});
var $author$project$Remote$Model$startWatcherSession = F2(
	function (watcherSession, remote) {
		var watcherPayoutInfo = (_Utils_eq(
			remote.cc,
			$elm$core$Maybe$Just(watcherSession)) && ($elm$core$List$length(remote.bX) <= 1)) ? remote.p1 : $elm$core$Maybe$Nothing;
		return _Utils_update(
			remote,
			{
				eO: _List_Nil,
				eP: $elm$core$Maybe$Nothing,
				eQ: $elm$core$Dict$empty,
				eR: $elm$core$Dict$empty,
				eT: '',
				eU: $elm$core$Maybe$Nothing,
				e$: $elm$core$Maybe$Nothing,
				dI: $author$project$Types$BrokerSessionStatus$BrokerUnauthenticated,
				mb: $elm$core$Maybe$Nothing,
				ft: 0.0,
				fu: 0.0,
				c9: $elm$core$Maybe$Nothing,
				da: $elm$core$Maybe$Nothing,
				mU: $elm$core$Maybe$Nothing,
				mV: $elm$core$Maybe$Nothing,
				d5: $elm$core$Maybe$Nothing,
				mY: $elm$core$Maybe$Nothing,
				bz: $elm$core$Dict$empty,
				bm: $elm$core$Dict$empty,
				a3: $elm$core$Dict$empty,
				bn: $elm$core$Dict$empty,
				bA: $elm$core$Dict$empty,
				a4: $elm$core$Dict$empty,
				bX: _List_fromArray(
					[watcherSession]),
				ej: $elm$core$Maybe$Nothing,
				nQ: $elm$core$Maybe$Nothing,
				bD: remote.bD + 1,
				ek: _List_Nil,
				di: false,
				nR: $elm$core$Maybe$Nothing,
				dk: $author$project$Types$PplnsProjection$PplnsNotRequested,
				gq: $elm$core$Maybe$Nothing,
				gr: $elm$core$Maybe$Nothing,
				gB: false,
				gC: false,
				gM: $elm$core$Dict$empty,
				ex: $elm$core$Maybe$Just(_List_Nil),
				gO: false,
				dA: $elm$core$Maybe$Nothing,
				g4: watcherSession.g4,
				pQ: $author$project$Types$UserSessionStatus$Unauthenticated,
				az: $author$project$Remote$Model$initialWatcherAccess,
				eH: $elm$core$Maybe$Nothing,
				p1: watcherPayoutInfo,
				cc: $elm$core$Maybe$Just(watcherSession),
				eI: $elm$core$Maybe$Nothing,
				bJ: $elm$core$Maybe$Nothing,
				eL: $elm$core$Maybe$Nothing,
				eM: 0
			});
	});
var $author$project$Remote$Model$startMultiWatcherSessions = F3(
	function (requirement, sessions, remote) {
		var remoteWithSingleSession = function () {
			var _v0 = $elm$core$List$head(sessions);
			if (!_v0.$) {
				var watcherSession = _v0.a;
				return A2($author$project$Remote$Model$startWatcherSession, watcherSession, remote);
			} else {
				return remote;
			}
		}();
		return _Utils_update(
			remoteWithSingleSession,
			{
				bz: $elm$core$Dict$empty,
				bm: $elm$core$Dict$empty,
				a3: $elm$core$Dict$empty,
				bn: $elm$core$Dict$empty,
				bA: $elm$core$Dict$empty,
				a4: $elm$core$Dict$empty,
				eb: requirement,
				bX: sessions,
				p1: ($elm$core$List$length(sessions) === 1) ? remoteWithSingleSession.p1 : $elm$core$Maybe$Nothing
			});
	});
var $author$project$Remote$Model$init = function (appArgs) {
	var uuids = A2(
		$elm$core$Maybe$withDefault,
		$wernerdegroot$listzipper$List$Zipper$singleton(appArgs.pT),
		$wernerdegroot$listzipper$List$Zipper$fromList(
			A2($elm$core$List$map, $elm$core$Basics$identity, appArgs.pU)));
	var userSessionStatus = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Types$UserSessionStatus$Unauthenticated,
		A2(
			$elm$core$Maybe$map,
			$author$project$Types$UserSessionStatus$SessionFetched,
			A2($elm$core$Maybe$map, $author$project$Types$UserSession$fromUserSessionJS, appArgs.hf)));
	var userId = $elm$core$String$isEmpty(appArgs.g4) ? A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.mu;
			},
			appArgs.hf)) : appArgs.g4;
	var multiWatcherRequirement = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Types$ApiToken$defaultAggregateApiKeyRequirement,
		$author$project$Types$ApiToken$aggregateApiKeyRequirementFromWire(appArgs.eb));
	var correlationIds = A2(
		$elm$core$Maybe$withDefault,
		$wernerdegroot$listzipper$List$Zipper$singleton(appArgs.cW),
		$wernerdegroot$listzipper$List$Zipper$fromList(
			A2($elm$core$List$map, $elm$core$Basics$identity, appArgs.ln)));
	var brokerSessionStatus = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Types$BrokerSessionStatus$BrokerUnauthenticated,
		A2(
			$elm$core$Maybe$map,
			$author$project$Types$BrokerSessionStatus$BrokerSessionFetched,
			A2($elm$core$Maybe$map, $author$project$Types$Broker$fromBrokerSessionJS, appArgs.hp)));
	var initialState = A6($author$project$Remote$Model$initialRemote, multiWatcherRequirement, correlationIds, uuids, userSessionStatus, brokerSessionStatus, userId);
	var initialStateWithWatcherSession = function () {
		var _v0 = _Utils_Tuple2(appArgs.p0, appArgs.eG);
		if (!_v0.a.b) {
			if (!_v0.b.$) {
				var watcherSession = _v0.b.a;
				return A2($author$project$Remote$Model$startWatcherSession, watcherSession, initialState);
			} else {
				var _v1 = _v0.b;
				return initialState;
			}
		} else {
			var watcherSessions = _v0.a;
			return A3($author$project$Remote$Model$startMultiWatcherSessions, multiWatcherRequirement, watcherSessions, initialState);
		}
	}();
	var initialStateWithWatcherPayoutInfo = ($elm$core$List$length(initialStateWithWatcherSession.bX) === 1) ? _Utils_update(
		initialStateWithWatcherSession,
		{p1: appArgs.p1}) : initialStateWithWatcherSession;
	return _Utils_Tuple2(initialStateWithWatcherPayoutInfo, $elm$core$Platform$Cmd$none);
};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$MainModule$init = function (programArgs) {
	var appArgs = programArgs.kJ;
	var kernelArgs = programArgs.mO;
	var msgToCmd = function (msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$identity,
			$elm$core$Task$succeed(msg));
	};
	var onAuthSuccessAndInitialCmds = function () {
		if ($elm_community$maybe_extra$Maybe$Extra$isNothing(appArgs.eG) && $elm_community$maybe_extra$Maybe$Extra$isJust(appArgs.hf)) {
			var initialHistoryRequests = A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $author$project$Msg$RemoteRequestMsg, msgToCmd),
				$author$project$Remote$HashrateHistory$bootstrapRequests(
					$elm$time$Time$millisToPosix(programArgs.mO.ls)));
			return _Utils_ap(
				_List_fromArray(
					[
						msgToCmd(
						$author$project$Msg$RemoteMsg($author$project$Remote$Msg$OnAuthSuccess)),
						msgToCmd(
						$author$project$Msg$GlobalMsg($author$project$Global$Msg$OnAuthSuccess)),
						msgToCmd(
						$author$project$Msg$AccountMsg($author$project$UI$Account$Msg$OnAuthSuccess))
					]),
				initialHistoryRequests);
		} else {
			return _List_Nil;
		}
	}();
	var onBrokerAuthSuccessAndInitialCmds = ($elm_community$maybe_extra$Maybe$Extra$isNothing(appArgs.eG) && $elm_community$maybe_extra$Maybe$Extra$isJust(appArgs.hp)) ? _List_fromArray(
		[
			msgToCmd(
			$author$project$Msg$RemoteMsg($author$project$Remote$Msg$OnBrokerAuthSuccess))
		]) : _List_Nil;
	var onWatcherAuthSuccessAndInitialCmds = $elm_community$maybe_extra$Maybe$Extra$isJust(appArgs.eG) ? _List_fromArray(
		[
			msgToCmd(
			$author$project$Msg$RemoteMsg($author$project$Remote$Msg$OnWatcherAuthSuccess)),
			msgToCmd(
			$author$project$Msg$GlobalMsg($author$project$Global$Msg$OnAuthSuccess))
		]) : _List_Nil;
	var _v0 = $author$project$Remote$Model$init(appArgs);
	var remote = _v0.a;
	var remoteCmd = _v0.b;
	var _v1 = $author$project$Global$Global$init(programArgs);
	var global = _v1.a;
	var globalCmd = _v1.b;
	return _Utils_Tuple2(
		A3($author$project$Model$init, global, remote, appArgs),
		$elm$core$Platform$Cmd$batch(
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Msg$GlobalMsg, globalCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Msg$RemoteRequestMsg, remoteCmd)
					]),
				_Utils_ap(
					onAuthSuccessAndInitialCmds,
					_Utils_ap(onWatcherAuthSuccessAndInitialCmds, onBrokerAuthSuccessAndInitialCmds)))));
};
var $author$project$Remote$Model$isUserAuthenticated = function (remote) {
	var _v0 = remote.pQ;
	if (_v0.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Remote$Model$isWatcherAuthenticated = function (remote) {
	return !_Utils_eq(remote.cc, $elm$core$Maybe$Nothing);
};
var $author$project$Remote$Model$isAuthenticated = function (remote) {
	return $author$project$Remote$Model$isUserAuthenticated(remote) || $author$project$Remote$Model$isWatcherAuthenticated(remote);
};
var $author$project$Msg$ConnectMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Global$Msg$OnRoute = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Remote$Msg$OnRoute = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$UI$Account$Msg$OnRoute = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$UI$Connect$Msg$OnRoute = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$MainModule$onNewRouteMsgs = F3(
	function (_v0, oldHistory, route) {
		return _List_fromArray(
			[
				$author$project$Kernel$Msg$AppMsg(
				$author$project$Msg$GlobalMsg(
					A2($author$project$Global$Msg$OnRoute, oldHistory, route))),
				$author$project$Kernel$Msg$AppMsg(
				$author$project$Msg$RemoteMsg(
					A2($author$project$Remote$Msg$OnRoute, oldHistory, route))),
				$author$project$Kernel$Msg$AppMsg(
				$author$project$Msg$AccountMsg(
					A2($author$project$UI$Account$Msg$OnRoute, oldHistory, route))),
				$author$project$Kernel$Msg$AppMsg(
				$author$project$Msg$ConnectMsg(
					A2($author$project$UI$Connect$Msg$OnRoute, oldHistory, route)))
			]);
	});
var $author$project$TopMsg$requestMsg = A2($elm$core$Basics$composeL, $author$project$Kernel$Msg$AppMsg, $author$project$Msg$RemoteRequestMsg);
var $author$project$Route$Route$Authentication = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Auth$Route$Login = {$: 0};
var $author$project$Route$Route$authEntryRoute = $author$project$Route$Route$Authentication($author$project$UI$Auth$Route$Login);
var $author$project$Route$RouteUtil$isAuthRoute = function (route) {
	if (route.$ === 1) {
		var authRoute = route.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Types$UserSessionStatus$isAuthenticated = function (userSessionStatus) {
	switch (userSessionStatus.$) {
		case 0:
			return $elm$core$Maybe$Just(false);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Just(true);
	}
};
var $author$project$Global$Msg$OnUserWantsBack = {$: 3};
var $author$project$Kernel$Aspect$Navigation$Msg$DropWhileAndRouteTo = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Kernel$Aspect$Navigation$Msg$RouteBack = {$: 5};
var $author$project$Kernel$Aspect$Navigation$Msg$RouteBackTo = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Kernel$Aspect$Navigation$Msg$RouteForward = {$: 6};
var $author$project$Kernel$Aspect$Navigation$Msg$RouteForwardTo = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Kernel$Aspect$Toaster$Toaster$NewToast = function (a) {
	return {$: 5, a: a};
};
var $author$project$UI$Library$Icon$Report = 5;
var $author$project$Kernel$Aspect$Toaster$Toaster$ActionClick = function (a) {
	return {$: 4, a: a};
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Kernel$Aspect$Toaster$Toasts$listMessageView = function (msg) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('marTop0h text-14 breakWord')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(msg)
			]));
};
var $author$project$Kernel$Aspect$Utility$noOpAttr = A2($elm$html$Html$Attributes$attribute, 'no-op-attr', 'no-op-attr');
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Kernel$Aspect$Toaster$Toasts$toast = F5(
	function (maybeActionMsg, icon, colors, msg, messages) {
		var tapHandler = function () {
			if (!maybeActionMsg.$) {
				var actionMsg = maybeActionMsg.a;
				return $elm$html$Html$Events$onClick(
					$author$project$Kernel$Aspect$Toaster$Toaster$ActionClick(actionMsg));
			} else {
				return $author$project$Kernel$Aspect$Utility$noOpAttr;
			}
		}();
		return {
			hi: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute top1 right0 bottom0 left0 toastBackground')
					]),
				_List_Nil),
			A: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center font-sans w-screen ' + colors),
						tapHandler
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-2 ')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('left')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-20 font-sans text-center w-full')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(msg)
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pad0 mar0 noListStyle font-sans'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'hidden',
														$elm$core$List$isEmpty(messages))
													]))
											]),
										A2($elm$core$List$map, $author$project$Kernel$Aspect$Toaster$Toasts$listMessageView, messages))
									]))
							]))
					])),
			jN: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shadeBlur absolute inset-0 toastBackgroundShade o2')
					]),
				_List_Nil)
		};
	});
var $author$project$Kernel$Aspect$Toaster$Toasts$error = function (maybeActionMsg) {
	return A3($author$project$Kernel$Aspect$Toaster$Toasts$toast, maybeActionMsg, 5, 'text-dmnd-black bg-dmnd-red-1');
};
var $author$project$Kernel$Aspect$Toaster$MsgToasts$toastErr = F3(
	function (maybeActionMsg, notifMsg, messages) {
		return $author$project$Kernel$Msg$ToasterMsg(
			$author$project$Kernel$Aspect$Toaster$Toaster$NewToast(
				A3($author$project$Kernel$Aspect$Toaster$Toasts$error, maybeActionMsg, notifMsg, messages)));
	});
var $author$project$UI$Library$Icon$Info = 0;
var $author$project$Kernel$Aspect$Toaster$Toasts$info = function (maybeActionMsg) {
	return A3($author$project$Kernel$Aspect$Toaster$Toasts$toast, maybeActionMsg, 0, 'text-dmnd-black bg-white');
};
var $author$project$Kernel$Aspect$Toaster$MsgToasts$toastInfo = F3(
	function (maybeActionMsg, notifMsg, messages) {
		return $author$project$Kernel$Msg$ToasterMsg(
			$author$project$Kernel$Aspect$Toaster$Toaster$NewToast(
				A3($author$project$Kernel$Aspect$Toaster$Toasts$info, maybeActionMsg, notifMsg, messages)));
	});
var $author$project$UI$Library$Icon$Check = 2;
var $author$project$Kernel$Aspect$Toaster$Toasts$success = function (maybeActionMsg) {
	return A3($author$project$Kernel$Aspect$Toaster$Toasts$toast, maybeActionMsg, 2, 'text-dmnd-black bg-dmnd-green');
};
var $author$project$Kernel$Aspect$Toaster$MsgToasts$toastSuccess = F3(
	function (maybeActionMsg, notifMsg, messages) {
		return $author$project$Kernel$Msg$ToasterMsg(
			$author$project$Kernel$Aspect$Toaster$Toaster$NewToast(
				A3($author$project$Kernel$Aspect$Toaster$Toasts$success, maybeActionMsg, notifMsg, messages)));
	});
var $author$project$Kernel$RouteMsgs$routeMsg = {
	lO: F2(
		function (dropper, route) {
			return $author$project$Kernel$Msg$RoutingMsg(
				A2($author$project$Kernel$Aspect$Navigation$Msg$DropWhileAndRouteTo, dropper, route));
		}),
	ot: $author$project$Kernel$Msg$RoutingMsg($author$project$Kernel$Aspect$Navigation$Msg$RouteBack),
	ou: A2(
		$elm$core$Basics$composeL,
		$author$project$Kernel$Msg$RoutingMsg,
		$author$project$Kernel$Aspect$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault($elm$core$Maybe$Nothing)),
	ov: F2(
		function (_default, dropper) {
			return $author$project$Kernel$Msg$RoutingMsg(
				A2(
					$author$project$Kernel$Aspect$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault,
					$elm$core$Maybe$Just(_default),
					dropper));
		}),
	ow: function (_v0) {
		var _default = _v0.a;
		var dropper = _v0.b;
		return $author$project$Kernel$Msg$RoutingMsg(
			A2($author$project$Kernel$Aspect$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault, _default, dropper));
	},
	ox: function (route) {
		return $author$project$Kernel$Msg$RoutingMsg(
			A2(
				$author$project$Kernel$Aspect$Navigation$Msg$RouteBackTo,
				$elm$core$Maybe$Just(route),
				route));
	},
	oy: $author$project$Kernel$Msg$RoutingMsg($author$project$Kernel$Aspect$Navigation$Msg$RouteForward),
	oz: function (route) {
		return $author$project$Kernel$Msg$RoutingMsg(
			A2(
				$author$project$Kernel$Aspect$Navigation$Msg$RouteForwardTo,
				$elm$core$Maybe$Just(route),
				route));
	},
	gu: A2(
		$elm$core$Basics$composeL,
		$author$project$Kernel$Msg$RoutingMsg,
		A2($author$project$Kernel$Aspect$Navigation$Msg$RouteTo, false, false)),
	oB: A2(
		$elm$core$Basics$composeL,
		$author$project$Kernel$Msg$RoutingMsg,
		A2($author$project$Kernel$Aspect$Navigation$Msg$RouteTo, true, false)),
	oC: A2(
		$elm$core$Basics$composeL,
		$author$project$Kernel$Msg$RoutingMsg,
		A2($author$project$Kernel$Aspect$Navigation$Msg$RouteTo, true, true)),
	aQ: $author$project$Kernel$Aspect$Toaster$MsgToasts$toastErr,
	pu: $author$project$Kernel$Aspect$Toaster$MsgToasts$toastInfo,
	ka: $author$project$Kernel$Aspect$Toaster$MsgToasts$toastSuccess
};
var $author$project$MainModule$onUserWantsBack = F2(
	function (state, route) {
		if ($elm_community$maybe_extra$Maybe$Extra$isJust(state.me.cP)) {
			return _List_fromArray(
				[
					$author$project$Kernel$Msg$AppMsg(
					$author$project$Msg$GlobalMsg($author$project$Global$Msg$OnUserWantsBack))
				]);
		} else {
			switch (route.$) {
				case 0:
					return _List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]);
				case 1:
					var authRoute = route.a;
					return _List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]);
				case 2:
					return _List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]);
				case 4:
					return _List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]);
				case 3:
					return _List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]);
				case 5:
					return _List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]);
				case 6:
					return _List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]);
				case 7:
					return _List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]);
				case 8:
					return _List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]);
				case 9:
					return _List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]);
				case 10:
					return _List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]);
				case 11:
					return _List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]);
				case 12:
					return _List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]);
				default:
					return _List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]);
			}
		}
	});
var $author$project$MainModule$onUserWantsForward = F2(
	function (state, route) {
		switch (route.$) {
			case 0:
				return _List_fromArray(
					[$author$project$Kernel$RouteMsgs$routeMsg.oy]);
			case 1:
				var authRoute = route.a;
				return _List_fromArray(
					[$author$project$Kernel$RouteMsgs$routeMsg.oy]);
			case 2:
				return _List_fromArray(
					[$author$project$Kernel$RouteMsgs$routeMsg.oy]);
			case 4:
				return _List_fromArray(
					[$author$project$Kernel$RouteMsgs$routeMsg.oy]);
			case 3:
				return _List_fromArray(
					[$author$project$Kernel$RouteMsgs$routeMsg.oy]);
			case 5:
				return _List_fromArray(
					[$author$project$Kernel$RouteMsgs$routeMsg.oy]);
			case 6:
				return _List_fromArray(
					[$author$project$Kernel$RouteMsgs$routeMsg.oy]);
			case 7:
				return _List_fromArray(
					[$author$project$Kernel$RouteMsgs$routeMsg.oy]);
			case 8:
				return _List_fromArray(
					[$author$project$Kernel$RouteMsgs$routeMsg.oy]);
			case 9:
				return _List_fromArray(
					[$author$project$Kernel$RouteMsgs$routeMsg.oy]);
			case 10:
				return _List_fromArray(
					[$author$project$Kernel$RouteMsgs$routeMsg.oy]);
			case 11:
				return _List_fromArray(
					[$author$project$Kernel$RouteMsgs$routeMsg.oy]);
			case 12:
				return _List_fromArray(
					[$author$project$Kernel$RouteMsgs$routeMsg.oy]);
			default:
				return _List_fromArray(
					[$author$project$Kernel$RouteMsgs$routeMsg.oy]);
		}
	});
var $author$project$Global$Model$AggregateAccountData = 1;
var $author$project$UI$Auth$Route$BrokerLogin = {$: 4};
var $author$project$Route$Route$Home = {$: 2};
var $author$project$Route$Route$MultiWatcher = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Remote$Model$WatcherGeneratedBTCResource = 2;
var $author$project$Remote$Model$WatcherPplnsProjectionResource = 3;
var $author$project$Remote$Model$WatcherWorkersResource = 1;
var $author$project$Route$Route$Workers = {$: 7};
var $author$project$Remote$Model$canViewSubAccounts = function (remote) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.p_;
			},
			remote.nR));
};
var $author$project$Remote$Model$hasSubAccounts = function (remote) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
			remote.ex));
};
var $author$project$Remote$Model$isBrokerAuthenticated = function (_v0) {
	var brokerSessionStatus = _v0.dI;
	switch (brokerSessionStatus.$) {
		case 0:
			return false;
		case 1:
			return false;
		default:
			return true;
	}
};
var $author$project$Remote$Model$isFppsUser = function (remote) {
	var hasGeneratedBtc = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
			remote.mb));
	var hasFppsHashrate = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (hashrate) {
				return hashrate.ii > 0;
			},
			remote.dA));
	return hasFppsHashrate || hasGeneratedBtc;
};
var $author$project$Types$ApiToken$aggregateRequirementIncludesGeneratedBTC = function (requirement) {
	switch (requirement) {
		case 0:
			return false;
		case 1:
			return true;
		default:
			return true;
	}
};
var $author$project$Remote$Model$multiWatcherAllowsGeneratedBTC = function (remote) {
	return $author$project$Types$ApiToken$aggregateRequirementIncludesGeneratedBTC(remote.eb);
};
var $author$project$Types$ApiToken$aggregateRequirementIncludesHashrate = function (requirement) {
	switch (requirement) {
		case 0:
			return true;
		case 1:
			return false;
		default:
			return true;
	}
};
var $author$project$Remote$Model$multiWatcherAllowsHashrate = function (remote) {
	return $author$project$Types$ApiToken$aggregateRequirementIncludesHashrate(remote.eb);
};
var $author$project$Remote$Model$WatcherAccessDenied = 2;
var $author$project$Remote$Model$watcherAccessIsDenied = F2(
	function (resource, remote) {
		var access = function () {
			switch (resource) {
				case 0:
					return remote.az.d1;
				case 1:
					return remote.az.bJ;
				case 2:
					return remote.az.mb;
				case 3:
					return remote.az.em;
				case 4:
					return remote.az.eu;
				default:
					return remote.az.d_;
			}
		}();
		return access === 2;
	});
var $author$project$Remote$Model$watcherHasPayoutInfo = function (remote) {
	return $author$project$Remote$Model$isWatcherAuthenticated(remote) && (($elm$core$List$length(remote.bX) === 1) && (!_Utils_eq(remote.p1, $elm$core$Maybe$Nothing)));
};
var $author$project$Remote$Model$watcherMayViewPayouts = function (remote) {
	return $author$project$Remote$Model$watcherHasPayoutInfo(remote) && (!A2($author$project$Remote$Model$watcherAccessIsDenied, 2, remote));
};
var $author$project$MainModule$redirect = F2(
	function (appState, route) {
		var isEffectiveAggregateData = (appState.me.dD === 1) && ($author$project$Remote$Model$canViewSubAccounts(appState.jr) && $author$project$Remote$Model$hasSubAccounts(appState.jr));
		if ($author$project$Remote$Model$isWatcherAuthenticated(appState.jr)) {
			switch (route.$) {
				case 2:
					return $elm$core$Maybe$Nothing;
				case 7:
					return ($elm$core$List$length(appState.jr.bX) > 1) ? ($author$project$Remote$Model$multiWatcherAllowsHashrate(appState.jr) ? $elm$core$Maybe$Nothing : ($author$project$Remote$Model$multiWatcherAllowsGeneratedBTC(appState.jr) ? $elm$core$Maybe$Just(
						{
							jE: A2($author$project$Route$Route$MultiWatcher, appState.jr.eb, appState.jr.bX),
							gA: true
						}) : $elm$core$Maybe$Just(
						{jE: $author$project$Route$Route$Home, gA: true}))) : (A2($author$project$Remote$Model$watcherAccessIsDenied, 1, appState.jr) ? $elm$core$Maybe$Just(
						{jE: $author$project$Route$Route$Home, gA: true}) : $elm$core$Maybe$Nothing);
				case 11:
					return ($elm$core$List$length(appState.jr.bX) > 1) ? ($author$project$Remote$Model$multiWatcherAllowsGeneratedBTC(appState.jr) ? $elm$core$Maybe$Just(
						{
							jE: A2($author$project$Route$Route$MultiWatcher, appState.jr.eb, appState.jr.bX),
							gA: true
						}) : ($author$project$Remote$Model$multiWatcherAllowsHashrate(appState.jr) ? $elm$core$Maybe$Just(
						{jE: $author$project$Route$Route$Workers, gA: true}) : $elm$core$Maybe$Just(
						{jE: $author$project$Route$Route$Home, gA: true}))) : (A2($author$project$Remote$Model$watcherAccessIsDenied, 2, appState.jr) ? $elm$core$Maybe$Just(
						{jE: $author$project$Route$Route$Home, gA: true}) : $elm$core$Maybe$Nothing);
				case 13:
					return $author$project$Remote$Model$multiWatcherAllowsGeneratedBTC(appState.jr) ? $elm$core$Maybe$Nothing : ($author$project$Remote$Model$multiWatcherAllowsHashrate(appState.jr) ? $elm$core$Maybe$Just(
						{jE: $author$project$Route$Route$Workers, gA: true}) : $elm$core$Maybe$Just(
						{jE: $author$project$Route$Route$Home, gA: true}));
				case 5:
					return $author$project$Remote$Model$watcherMayViewPayouts(appState.jr) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						{jE: $author$project$Route$Route$Home, gA: true});
				case 12:
					return (($elm$core$List$length(appState.jr.bX) > 1) || A2($author$project$Remote$Model$watcherAccessIsDenied, 3, appState.jr)) ? $elm$core$Maybe$Just(
						{jE: $author$project$Route$Route$Home, gA: true}) : $elm$core$Maybe$Nothing;
				case 6:
					return $elm$core$Maybe$Nothing;
				case 1:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Just(
						{jE: $author$project$Route$Route$Home, gA: true});
			}
		} else {
			switch (route.$) {
				case 10:
					return (!$author$project$Remote$Model$isBrokerAuthenticated(appState.jr)) ? $elm$core$Maybe$Just(
						{
							jE: $author$project$Route$Route$Authentication($author$project$UI$Auth$Route$BrokerLogin),
							gA: true
						}) : $elm$core$Maybe$Nothing;
				case 8:
					if (isEffectiveAggregateData) {
						return $elm$core$Maybe$Just(
							{jE: $author$project$Route$Route$Home, gA: true});
					} else {
						var _v2 = appState.jr.nR;
						if (_v2.$ === 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							return (!$author$project$Remote$Model$canViewSubAccounts(appState.jr)) ? $elm$core$Maybe$Just(
								{jE: $author$project$Route$Route$Home, gA: true}) : $elm$core$Maybe$Nothing;
						}
					}
				case 9:
					return isEffectiveAggregateData ? $elm$core$Maybe$Just(
						{jE: $author$project$Route$Route$Home, gA: true}) : $elm$core$Maybe$Nothing;
				case 11:
					if ($elm$core$List$length(appState.jr.bX) > 1) {
						return $author$project$Remote$Model$multiWatcherAllowsGeneratedBTC(appState.jr) ? $elm$core$Maybe$Just(
							{
								jE: A2($author$project$Route$Route$MultiWatcher, appState.jr.eb, appState.jr.bX),
								gA: true
							}) : ($author$project$Remote$Model$multiWatcherAllowsHashrate(appState.jr) ? $elm$core$Maybe$Just(
							{jE: $author$project$Route$Route$Workers, gA: true}) : $elm$core$Maybe$Just(
							{jE: $author$project$Route$Route$Home, gA: true}));
					} else {
						if (isEffectiveAggregateData) {
							return $elm$core$Maybe$Nothing;
						} else {
							var _v3 = appState.jr.mb;
							if (_v3.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								return (!$author$project$Remote$Model$isFppsUser(appState.jr)) ? $elm$core$Maybe$Just(
									{jE: $author$project$Route$Route$Home, gA: true}) : $elm$core$Maybe$Nothing;
							}
						}
					}
				case 12:
					return isEffectiveAggregateData ? $elm$core$Maybe$Just(
						{jE: $author$project$Route$Route$Home, gA: true}) : $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Route$RouteUtil$requiresAuthentication = function (route) {
	switch (route.$) {
		case 0:
			return false;
		case 1:
			var authRoute = route.a;
			return false;
		case 2:
			return true;
		case 4:
			return true;
		case 3:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return true;
		case 10:
			return false;
		case 11:
			return true;
		case 12:
			return true;
		default:
			return true;
	}
};
var $author$project$Route$Route$Account = {$: 6};
var $author$project$Route$Route$ApiKeys = {$: 9};
var $author$project$Route$Route$Broker = {$: 10};
var $author$project$Route$Route$ComponentsPreview = {$: 0};
var $author$project$Route$Route$Connect = {$: 3};
var $author$project$Route$Route$Connections = {$: 4};
var $author$project$UI$Auth$Route$ForgotPassword = {$: 2};
var $author$project$Route$Route$GeneratedBitcoin = {$: 11};
var $author$project$Route$Route$Payouts = {$: 5};
var $author$project$Route$Route$PplnsProjection = {$: 12};
var $author$project$UI$Auth$Route$ResetPassword = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$Route$Subaccounts = {$: 8};
var $author$project$Route$RouteMappers$decodePathSegment = function (segment) {
	return A2(
		$elm$core$Maybe$withDefault,
		segment,
		$elm$url$Url$percentDecode(segment));
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $author$project$Route$RouteMappers$pairSegmentsToWatcherSessions = function (pairSegments) {
	var parsePairs = function (segments) {
		if (!segments.b) {
			return $elm$core$Maybe$Just(_List_Nil);
		} else {
			if (segments.b.b) {
				var userIdSegment = segments.a;
				var _v1 = segments.b;
				var tokenSegment = _v1.a;
				var rest = _v1.b;
				var userId = $author$project$Route$RouteMappers$decodePathSegment(userIdSegment);
				var token = $author$project$Route$RouteMappers$decodePathSegment(tokenSegment);
				var session = {g_: token, g4: userId};
				return ($elm$core$String$isEmpty(userId) || $elm$core$String$isEmpty(token)) ? $elm$core$Maybe$Nothing : A2(
					$elm$core$Maybe$map,
					function (parsedPairs) {
						return A2($elm$core$List$cons, session, parsedPairs);
					},
					parsePairs(rest));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	};
	var pairCount = $elm$core$List$length(pairSegments);
	return ((pairCount < 2) || (!(!A2($elm$core$Basics$modBy, 2, pairCount)))) ? $elm$core$Maybe$Nothing : parsePairs(pairSegments);
};
var $author$project$Route$RouteMappers$multiWatcherRequirementAndSessions = function (segments) {
	if (segments.b) {
		var requirementSegment = segments.a;
		var rest = segments.b;
		var _v1 = $author$project$Types$ApiToken$aggregateApiKeyRequirementFromWire(
			$author$project$Route$RouteMappers$decodePathSegment(requirementSegment));
		if (!_v1.$) {
			var requirement = _v1.a;
			return A2(
				$elm$core$Maybe$map,
				function (sessions) {
					return _Utils_Tuple2(requirement, sessions);
				},
				$author$project$Route$RouteMappers$pairSegmentsToWatcherSessions(rest));
		} else {
			return A2(
				$elm$core$Maybe$map,
				function (sessions) {
					return _Utils_Tuple2($author$project$Types$ApiToken$defaultAggregateApiKeyRequirement, sessions);
				},
				$author$project$Route$RouteMappers$pairSegmentsToWatcherSessions(segments));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Route$RouteMappers$multiWatcherRouteFromRequirement = F2(
	function (requirement, sessions) {
		if (!requirement) {
			return $author$project$Route$Route$Workers;
		} else {
			return A2($author$project$Route$Route$MultiWatcher, requirement, sessions);
		}
	});
var $author$project$Route$RouteMappers$routeForMultiWatcher = function (pathSegments) {
	_v0$5:
	while (true) {
		if (pathSegments.b) {
			switch (pathSegments.a) {
				case 'multiwatcher':
					if (!pathSegments.b.b) {
						return $elm$core$Maybe$Just(
							A2($author$project$Route$Route$MultiWatcher, $author$project$Types$ApiToken$defaultAggregateApiKeyRequirement, _List_Nil));
					} else {
						var rest = pathSegments.b;
						return A2(
							$elm$core$Maybe$map,
							function (_v1) {
								var requirement = _v1.a;
								var sessions = _v1.b;
								return A2($author$project$Route$RouteMappers$multiWatcherRouteFromRequirement, requirement, sessions);
							},
							$author$project$Route$RouteMappers$multiWatcherRequirementAndSessions(rest));
					}
				case 'login':
					if (pathSegments.b.b && (pathSegments.b.a === 'multiwatcher')) {
						var _v2 = pathSegments.b;
						var rest = _v2.b;
						return A2(
							$elm$core$Maybe$map,
							function (_v3) {
								var requirement = _v3.a;
								var sessions = _v3.b;
								return A2($author$project$Route$RouteMappers$multiWatcherRouteFromRequirement, requirement, sessions);
							},
							$author$project$Route$RouteMappers$multiWatcherRequirementAndSessions(rest));
					} else {
						break _v0$5;
					}
				case 'static':
					if (pathSegments.b.b) {
						switch (pathSegments.b.a) {
							case 'multiwatcher':
								var _v4 = pathSegments.b;
								var rest = _v4.b;
								return A2(
									$elm$core$Maybe$map,
									function (_v5) {
										var requirement = _v5.a;
										var sessions = _v5.b;
										return A2($author$project$Route$RouteMappers$multiWatcherRouteFromRequirement, requirement, sessions);
									},
									$author$project$Route$RouteMappers$multiWatcherRequirementAndSessions(rest));
							case 'login':
								if (pathSegments.b.b.b && (pathSegments.b.b.a === 'multiwatcher')) {
									var _v6 = pathSegments.b;
									var _v7 = _v6.b;
									var rest = _v7.b;
									return A2(
										$elm$core$Maybe$map,
										function (_v8) {
											var requirement = _v8.a;
											var sessions = _v8.b;
											return A2($author$project$Route$RouteMappers$multiWatcherRouteFromRequirement, requirement, sessions);
										},
										$author$project$Route$RouteMappers$multiWatcherRequirementAndSessions(rest));
								} else {
									break _v0$5;
								}
							default:
								break _v0$5;
						}
					} else {
						break _v0$5;
					}
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$UI$Auth$Route$WatcherLoginLink = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$RouteMappers$watcherLoginRoute = F2(
	function (userId, token) {
		return $author$project$Route$Route$Authentication(
			$author$project$UI$Auth$Route$WatcherLoginLink(
				{
					g_: $author$project$Route$RouteMappers$decodePathSegment(token),
					g4: $author$project$Route$RouteMappers$decodePathSegment(userId)
				}));
	});
var $author$project$Route$RouteMappers$routeFor = function (url) {
	var _v0 = url.b_;
	_v0$30:
	while (true) {
		if (_v0.b) {
			if (_v0.b.b) {
				if (_v0.b.b.b) {
					if (_v0.b.b.b.b) {
						if (_v0.b.b.b.b.b) {
							if ((((_v0.a === 'static') && (_v0.b.a === 'login')) && (_v0.b.b.a === 'watcher')) && (!_v0.b.b.b.b.b.b)) {
								var _v3 = _v0.b;
								var _v4 = _v3.b;
								var _v5 = _v4.b;
								var userId = _v5.a;
								var _v6 = _v5.b;
								var token = _v6.a;
								return $elm$core$Maybe$Just(
									A2($author$project$Route$RouteMappers$watcherLoginRoute, userId, token));
							} else {
								break _v0$30;
							}
						} else {
							if ((_v0.a === 'login') && (_v0.b.a === 'watcher')) {
								var _v16 = _v0.b;
								var _v17 = _v16.b;
								var userId = _v17.a;
								var _v18 = _v17.b;
								var token = _v18.a;
								return $elm$core$Maybe$Just(
									A2($author$project$Route$RouteMappers$watcherLoginRoute, userId, token));
							} else {
								break _v0$30;
							}
						}
					} else {
						if (_v0.a === 'workers') {
							var _v19 = _v0.b;
							var _v20 = _v19.b;
							return $elm$core$Maybe$Just($author$project$Route$Route$Workers);
						} else {
							break _v0$30;
						}
					}
				} else {
					switch (_v0.a) {
						case 'static':
							switch (_v0.b.a) {
								case 'components-preview':
									var _v1 = _v0.b;
									return $elm$core$Maybe$Just($author$project$Route$Route$ComponentsPreview);
								case 'login':
									var _v2 = _v0.b;
									return $elm$core$Maybe$Just(
										$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$Login));
								case 'home':
									var _v7 = _v0.b;
									return $elm$core$Maybe$Just($author$project$Route$Route$Home);
								case 'payouts':
									var _v8 = _v0.b;
									return $elm$core$Maybe$Just($author$project$Route$Route$Payouts);
								case 'account':
									var _v9 = _v0.b;
									return $elm$core$Maybe$Just($author$project$Route$Route$Account);
								case 'connect':
									var _v10 = _v0.b;
									return $elm$core$Maybe$Just($author$project$Route$Route$Connect);
								case 'connections':
									var _v11 = _v0.b;
									return $elm$core$Maybe$Just($author$project$Route$Route$Connections);
								case 'forgot-password':
									var _v12 = _v0.b;
									return $elm$core$Maybe$Just(
										$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$ForgotPassword));
								case 'reset-password':
									var _v13 = _v0.b;
									return $elm$core$Maybe$Just(
										$author$project$Route$Route$Authentication(
											$author$project$UI$Auth$Route$ResetPassword(
												{ff: $elm$core$Maybe$Nothing})));
								case 'generated-bitcoin':
									var _v14 = _v0.b;
									return $elm$core$Maybe$Just($author$project$Route$Route$GeneratedBitcoin);
								case 'pplns-projection':
									var _v15 = _v0.b;
									return $elm$core$Maybe$Just($author$project$Route$Route$PplnsProjection);
								default:
									break _v0$30;
							}
						case 'broker':
							if (_v0.b.a === 'login') {
								var _v21 = _v0.b;
								return $elm$core$Maybe$Just(
									$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$BrokerLogin));
							} else {
								break _v0$30;
							}
						default:
							break _v0$30;
					}
				}
			} else {
				switch (_v0.a) {
					case 'components-preview':
						return $elm$core$Maybe$Just($author$project$Route$Route$ComponentsPreview);
					case 'login':
						return $elm$core$Maybe$Just(
							$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$Login));
					case 'home':
						return $elm$core$Maybe$Just($author$project$Route$Route$Home);
					case 'payouts':
						return $elm$core$Maybe$Just($author$project$Route$Route$Payouts);
					case 'account':
						return $elm$core$Maybe$Just($author$project$Route$Route$Account);
					case 'connect':
						return $elm$core$Maybe$Just($author$project$Route$Route$Connect);
					case 'connections':
						return $elm$core$Maybe$Just($author$project$Route$Route$Connections);
					case 'forgot-password':
						return $elm$core$Maybe$Just(
							$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$ForgotPassword));
					case 'reset-password':
						var maybeEmail = A2($elm$core$Dict$get, 'email', url.cA);
						return $elm$core$Maybe$Just(
							$author$project$Route$Route$Authentication(
								$author$project$UI$Auth$Route$ResetPassword(
									{ff: maybeEmail})));
					case 'generated-bitcoin':
						return $elm$core$Maybe$Just($author$project$Route$Route$GeneratedBitcoin);
					case 'pplns-projection':
						return $elm$core$Maybe$Just($author$project$Route$Route$PplnsProjection);
					case 'workers':
						return $elm$core$Maybe$Just($author$project$Route$Route$Workers);
					case 'subaccounts':
						return $elm$core$Maybe$Just($author$project$Route$Route$Subaccounts);
					case 'api-keys':
						return $elm$core$Maybe$Just($author$project$Route$Route$ApiKeys);
					case 'broker-dashboard':
						return $elm$core$Maybe$Just($author$project$Route$Route$Broker);
					default:
						break _v0$30;
				}
			}
		} else {
			break _v0$30;
		}
	}
	return $elm$core$Maybe$Just(
		A2(
			$elm$core$Maybe$withDefault,
			$author$project$Route$Route$Home,
			$author$project$Route$RouteMappers$routeForMultiWatcher(url.b_)));
};
var $author$project$MainModule$toHomeRoute = F2(
	function (params, appState) {
		var _v0 = params.mq;
		switch (_v0) {
			case '127.0.0.1':
				return $author$project$Route$Route$Home;
			case '0.0.0.0':
				return $author$project$Route$Route$Home;
			case 'dev-app.dmnd.work':
				return $author$project$Route$Route$Home;
			case 'app.dmnd.work':
				return $author$project$Route$Route$Home;
			default:
				return $author$project$Route$Route$Home;
		}
	});
var $author$project$Types$WebPageMetadata$title = function (theTitle) {
	return {lH: '', bs: theTitle};
};
var $author$project$Route$RouteUtil$toMetadata = F2(
	function (state, route) {
		switch (route.$) {
			case 0:
				return $author$project$Types$WebPageMetadata$title('Components');
			case 1:
				var authRoute = route.a;
				switch (authRoute.$) {
					case 0:
						return $author$project$Types$WebPageMetadata$title('Login');
					case 1:
						return $author$project$Types$WebPageMetadata$title('Watcher Login');
					case 4:
						return $author$project$Types$WebPageMetadata$title('Broker Login');
					case 2:
						return $author$project$Types$WebPageMetadata$title('Forgot Password');
					default:
						return $author$project$Types$WebPageMetadata$title('Reset Password');
				}
			case 2:
				return $author$project$Types$WebPageMetadata$title('Home');
			case 4:
				return $author$project$Types$WebPageMetadata$title('Connections');
			case 3:
				return $author$project$Types$WebPageMetadata$title('Connect');
			case 5:
				return $author$project$Types$WebPageMetadata$title('Payouts');
			case 6:
				return $author$project$Types$WebPageMetadata$title('Account');
			case 7:
				return $author$project$Types$WebPageMetadata$title('Workers hashrate');
			case 8:
				return $author$project$Types$WebPageMetadata$title('Subaccounts');
			case 9:
				return $author$project$Types$WebPageMetadata$title('API Keys');
			case 10:
				return $author$project$Types$WebPageMetadata$title('Broker Dashboard');
			case 11:
				return $author$project$Types$WebPageMetadata$title('Generated Bitcoin');
			case 12:
				return $author$project$Types$WebPageMetadata$title('PPLNS Projection');
			default:
				return $author$project$Types$WebPageMetadata$title('MultiWatcher');
		}
	});
var $author$project$Kernel$Aspect$Url$Url$path = function (thePath) {
	return {b_: thePath, cA: $elm$core$Dict$empty};
};
var $author$project$Route$RouteMappers$urlFor = function (route) {
	switch (route.$) {
		case 0:
			return $author$project$Kernel$Aspect$Url$Url$path(
				_List_fromArray(
					['components-preview']));
		case 1:
			var authRoute = route.a;
			switch (authRoute.$) {
				case 0:
					return $author$project$Kernel$Aspect$Url$Url$path(
						_List_fromArray(
							['login']));
				case 1:
					return $author$project$Kernel$Aspect$Url$Url$path(
						_List_fromArray(
							['login']));
				case 4:
					return $author$project$Kernel$Aspect$Url$Url$path(
						_List_fromArray(
							['broker', 'login']));
				case 2:
					return $author$project$Kernel$Aspect$Url$Url$path(
						_List_fromArray(
							['forgot-password']));
				default:
					return $author$project$Kernel$Aspect$Url$Url$path(
						_List_fromArray(
							['reset-password']));
			}
		case 2:
			return $author$project$Kernel$Aspect$Url$Url$path(
				_List_fromArray(
					['home']));
		case 4:
			return $author$project$Kernel$Aspect$Url$Url$path(
				_List_fromArray(
					['connections']));
		case 3:
			return $author$project$Kernel$Aspect$Url$Url$path(
				_List_fromArray(
					['connect']));
		case 5:
			return $author$project$Kernel$Aspect$Url$Url$path(
				_List_fromArray(
					['payouts']));
		case 6:
			return $author$project$Kernel$Aspect$Url$Url$path(
				_List_fromArray(
					['account']));
		case 7:
			return $author$project$Kernel$Aspect$Url$Url$path(
				_List_fromArray(
					['workers']));
		case 8:
			return $author$project$Kernel$Aspect$Url$Url$path(
				_List_fromArray(
					['subaccounts']));
		case 9:
			return $author$project$Kernel$Aspect$Url$Url$path(
				_List_fromArray(
					['api-keys']));
		case 10:
			return $author$project$Kernel$Aspect$Url$Url$path(
				_List_fromArray(
					['broker-dashboard']));
		case 11:
			return $author$project$Kernel$Aspect$Url$Url$path(
				_List_fromArray(
					['generated-bitcoin']));
		case 12:
			return $author$project$Kernel$Aspect$Url$Url$path(
				_List_fromArray(
					['pplns-projection']));
		default:
			return $author$project$Kernel$Aspect$Url$Url$path(
				_List_fromArray(
					['multiwatcher']));
	}
};
var $author$project$MainModule$routingConfig = function () {
	var toTitleDescription = function (_v0) {
		var title = _v0.bs;
		var description = _v0.lH;
		return {lH: description, bs: title};
	};
	return {
		kQ: $author$project$Route$Route$authEntryRoute,
		mD: $author$project$Route$RouteUtil$isAuthRoute,
		mE: function (appState) {
			return $author$project$Remote$Model$isWatcherAuthenticated(appState.jr) ? $elm$core$Maybe$Just(true) : $author$project$Types$UserSessionStatus$isAuthenticated(appState.jr.pQ);
		},
		nC: $author$project$MainModule$onNewRouteMsgs,
		ob: $author$project$MainModule$redirect,
		oA: $author$project$Route$RouteUtil$requiresAuthentication,
		oE: F2(
			function (state, route) {
				return toTitleDescription(
					A2($author$project$Route$RouteUtil$toMetadata, state, route));
			}),
		oF: $author$project$Route$RouteMappers$urlFor,
		pm: $author$project$MainModule$toHomeRoute,
		pO: $author$project$Route$RouteMappers$routeFor,
		pR: $author$project$MainModule$onUserWantsBack,
		pS: $author$project$MainModule$onUserWantsForward
	};
}();
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$UI$Util$oneMinute = 60000;
var $author$project$Global$Msg$EmailVerificationResentSecondPass = {$: 8};
var $author$project$Global$Global$subscriptions = function (_v0) {
	var secsToEnableResendEmailVerification = _v0.dn;
	var second = 1000;
	var tickResetEmailVerification = (secsToEnableResendEmailVerification > 0) ? _List_fromArray(
		[
			A2(
			$elm$time$Time$every,
			second,
			function (_v1) {
				return $author$project$Global$Msg$EmailVerificationResentSecondPass;
			})
		]) : _List_Nil;
	return $elm$core$Platform$Sub$batch(tickResetEmailVerification);
};
var $author$project$MainModule$subscriptions = function (_v0) {
	var appState = _v0.eV;
	var subscribeToHashrateAndWorkers = $author$project$Remote$Model$isAuthenticated(appState.jr) ? A2(
		$elm$time$Time$every,
		$author$project$UI$Util$oneMinute,
		$elm$core$Basics$always($author$project$Msg$PollHashrateAndWorkers)) : $elm$core$Platform$Sub$none;
	return $author$project$Remote$Model$isAuthenticated(appState.jr) ? $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				subscribeToHashrateAndWorkers,
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$GlobalMsg,
				$author$project$Global$Global$subscriptions(appState.me))
			])) : $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Remote$Model$toUserSession = function (_v0) {
	var userSessionStatus = _v0.pQ;
	switch (userSessionStatus.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			var userSession = userSessionStatus.a;
			return $elm$core$Maybe$Just(userSession);
	}
};
var $author$project$Msg$AuthMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Msg$ChartMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Msg$ComponentsPreviewMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Remote$RequestMsg$FetchPayoutProgress = {$: 22};
var $author$project$Remote$RequestMsg$FetchPayouts = {$: 21};
var $author$project$Remote$RequestMsg$GeneratedBTC = {$: 15};
var $author$project$Msg$HomeMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Remote$RequestMsg$LoadWatcherPayouts = {$: 24};
var $author$project$Msg$RemoteResponseMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Remote$RequestMsg$ReplaceWorkers = 0;
var $author$project$Remote$RequestMsg$RetrieveSubAccount = {$: 56};
var $author$project$Remote$RequestMsg$UserHashrate = {$: 10};
var $author$project$Types$Payout$UserPayoutContext = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Remote$RequestMsg$UserPplnsProjection = function (a) {
	return {$: 17, a: a};
};
var $author$project$Remote$RequestMsg$WatcherGeneratedBTC = function (a) {
	return {$: 16, a: a};
};
var $author$project$Remote$RequestMsg$WatcherHashrate = function (a) {
	return {$: 12, a: a};
};
var $author$project$Remote$Model$WatcherHashrateResource = 0;
var $author$project$Types$Payout$WatcherPayoutContext = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Remote$RequestMsg$WatcherPayouts = {$: 23};
var $author$project$Remote$RequestMsg$WatcherPplnsProjection = function (a) {
	return {$: 18, a: a};
};
var $author$project$Remote$RequestMsg$WatcherWorkersInfo = function (a) {
	return {$: 31, a: a};
};
var $author$project$Remote$RequestMsg$WorkersInfo = function (a) {
	return {$: 30, a: a};
};
var $author$project$Msg$WorkersMsg = function (a) {
	return {$: 11, a: a};
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $author$project$UI$Util$monthToInt = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.y, posixMinutes) < 0) {
					return posixMinutes + era.j;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		lA: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		i_: month,
		ky: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).lA;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).i_;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).ky;
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$UI$Util$currentDateString = function (time) {
	var zone = $elm$time$Time$utc;
	var year = $elm$core$String$fromInt(
		A2($elm$time$Time$toYear, zone, time));
	var month = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			$author$project$UI$Util$monthToInt(
				A2($elm$time$Time$toMonth, zone, time))));
	var day = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$time$Time$toDay, zone, time)));
	return year + ('-' + (month + ('-' + day)));
};
var $author$project$Remote$RequestMsg$defaultWorkersPageLimit = 500;
var $author$project$Types$BTC$BTC = $elm$core$Basics$identity;
var $elm$core$List$sortBy = _List_sortBy;
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$UI$Library$AccountData$combineGeneratedBTCByDay = function (entries) {
	var btcValue = function (_v1) {
		var value = _v1;
		return value;
	};
	var addEntry = F2(
		function (entry, maybeExisting) {
			if (!maybeExisting.$) {
				var existing = maybeExisting.a;
				return $elm$core$Maybe$Just(
					_Utils_update(
						existing,
						{
							hs: btcValue(existing.hs) + btcValue(entry.hs),
							d1: existing.d1 + entry.d1
						}));
			} else {
				return $elm$core$Maybe$Just(entry);
			}
		});
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.h0;
			},
			$elm$core$Dict$values(
				A3(
					$elm$core$List$foldl,
					function (entry) {
						return A2(
							$elm$core$Dict$update,
							entry.h0,
							addEntry(entry));
					},
					$elm$core$Dict$empty,
					entries))));
};
var $author$project$UI$Library$AccountData$currentSubAccountGeneratedBTC = function (remote) {
	return A2(
		$elm$core$List$concatMap,
		function (subAccount) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, subAccount.mu, remote.eQ));
		},
		A2($elm$core$Maybe$withDefault, _List_Nil, remote.ex));
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$UI$Library$AccountData$currentSubAccountsHaveEntries = F2(
	function (subAccounts, entriesBySubAccount) {
		return A2(
			$elm$core$List$all,
			function (subAccount) {
				return A2($elm$core$Dict$member, subAccount.mu, entriesBySubAccount);
			},
			subAccounts);
	});
var $author$project$UI$Library$AccountData$scopeIsAggregate = F2(
	function (scope, remote) {
		return (scope === 1) && ($author$project$Remote$Model$isUserAuthenticated(remote) && ($author$project$Remote$Model$canViewSubAccounts(remote) && ((!remote.gO) || $author$project$Remote$Model$hasSubAccounts(remote))));
	});
var $elm$core$Basics$pow = _Basics_pow;
var $author$project$Types$PplnsProjection$averageDailyHashrate = function (retainedDifficulty) {
	return (retainedDifficulty * A2($elm$core$Basics$pow, 2, 32)) / 86400;
};
var $author$project$Types$GeneratedBTC$withPplnsHashrate = F2(
	function (dailyWork, entries) {
		var hashrateByDay = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (work) {
					return _Utils_Tuple2(
						work.p8,
						$author$project$Types$PplnsProjection$averageDailyHashrate(work.jB));
				},
				A2(
					$elm$core$List$filter,
					function (work) {
						return work.jB > 0;
					},
					dailyWork)));
		var fillMissingHashrate = function (entry) {
			if (entry.d1 > 0) {
				return entry;
			} else {
				var _v0 = A2($elm$core$Dict$get, entry.h0, hashrateByDay);
				if (!_v0.$) {
					var hashrate = _v0.a;
					return _Utils_update(
						entry,
						{d1: hashrate});
				} else {
					return entry;
				}
			}
		};
		return A2($elm$core$List$map, fillMissingHashrate, entries);
	});
var $author$project$UI$Library$AccountData$generatedBTCForScope = F2(
	function (scope, remote) {
		if (A2($author$project$UI$Library$AccountData$scopeIsAggregate, scope, remote)) {
			var _v0 = _Utils_Tuple3(remote.gO, remote.mb, remote.ex);
			if (!_v0.a) {
				return $elm$core$Maybe$Nothing;
			} else {
				if ((!_v0.b.$) && (!_v0.c.$)) {
					var mainEntries = _v0.b.a;
					var subAccounts = _v0.c.a;
					return A2($author$project$UI$Library$AccountData$currentSubAccountsHaveEntries, subAccounts, remote.eQ) ? $elm$core$Maybe$Just(
						$author$project$UI$Library$AccountData$combineGeneratedBTCByDay(
							_Utils_ap(
								mainEntries,
								$author$project$UI$Library$AccountData$currentSubAccountGeneratedBTC(remote)))) : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		} else {
			var _v1 = _Utils_Tuple2(remote.dk, remote.mb);
			if ((_v1.a.$ === 4) && (!_v1.b.$)) {
				var projection = _v1.a.a;
				var entries = _v1.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Types$GeneratedBTC$withPplnsHashrate, projection.lt, entries));
			} else {
				return remote.mb;
			}
		}
	});
var $author$project$Remote$Model$generatedBTCNeedsRefresh = F2(
	function (now, remote) {
		var expired = function (timestamp) {
			return A2(
				$elm$core$Maybe$withDefault,
				true,
				A2(
					$elm$core$Maybe$map,
					function (lastTime) {
						return _Utils_cmp(
							$elm$time$Time$posixToMillis(now) - $elm$time$Time$posixToMillis(lastTime),
							(5 * 60) * 1000) > -1;
					},
					timestamp));
		};
		return expired(remote.da) && (_Utils_eq(remote.mb, $elm$core$Maybe$Nothing) || expired(remote.c9));
	});
var $author$project$Remote$Model$isRequestAlreadyOngoing = F2(
	function (remote, requestMsg) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.aM;
				},
				$elm$core$Basics$eq(requestMsg)),
			remote.C);
	});
var $author$project$UI$Library$Chart$Model$latestChartPoint = function (chartData) {
	if (!chartData.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var firstPoint = chartData.a;
		var remainingPoints = chartData.b;
		return $elm$core$Maybe$Just(
			A3(
				$elm$core$List$foldl,
				F2(
					function (point, _v1) {
						return point;
					}),
				firstPoint,
				remainingPoints));
	}
};
var $author$project$Remote$Model$watcherSessionKey = function (session) {
	return _Utils_Tuple2(session.g4, session.g_);
};
var $author$project$Remote$Model$multiWatcherHashrateAccessForSession = F2(
	function (session, remote) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Dict$get,
				$author$project$Remote$Model$watcherSessionKey(session),
				remote.bn));
	});
var $author$project$Update$outMsgHandlerTopmost = function (_v0) {
	var updated = _v0.pN;
	var msgTag = _v0.nl;
	var stateSetter = _v0.o$;
	return function (_v1) {
		var childState = _v1.a;
		var childCmd = _v1.b;
		var msgs = _v1.c;
		return _Utils_Tuple3(
			stateSetter(childState),
			A2($elm$core$Platform$Cmd$map, msgTag, childCmd),
			msgs);
	}(updated);
};
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $author$project$UI$Util$formatPosix = function (time) {
	var zone = $elm$time$Time$utc;
	var year = $elm$core$String$fromInt(
		A2($elm$time$Time$toYear, zone, time));
	var second = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$time$Time$toSecond, zone, time)));
	var month = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			$author$project$UI$Util$monthToInt(
				A2($elm$time$Time$toMonth, zone, time))));
	var minute = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$time$Time$toMinute, zone, time)));
	var hour = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$time$Time$toHour, zone, time)));
	var day = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$time$Time$toDay, zone, time)));
	return year + ('-' + (month + ('-' + (day + (' ' + (hour + (':' + (minute + (':' + second)))))))));
};
var $author$project$Types$Payout$payoutDate = function (payout) {
	return A2(
		$elm$core$String$left,
		10,
		$author$project$UI$Util$formatPosix(payout.b5));
};
var $author$project$Remote$Model$toWatcherSession = function (remote) {
	return remote.cc;
};
var $author$project$Remote$Model$payoutsAreLoading = function (remote) {
	return remote.di || function () {
		var _v0 = $author$project$Remote$Model$toWatcherSession(remote);
		if (!_v0.$) {
			var watcherSession = _v0.a;
			return $author$project$Remote$Model$watcherMayViewPayouts(remote) && A2(
				$author$project$Remote$Model$isRequestAlreadyOngoing,
				remote,
				$author$project$Remote$RequestMsg$WatcherGeneratedBTC(watcherSession));
		} else {
			return false;
		}
	}();
};
var $author$project$Remote$Model$payoutsAreStaleForContext = F3(
	function (now, context, remote) {
		return (!_Utils_eq(
			remote.nQ,
			$elm$core$Maybe$Just(context))) || function () {
			var _v0 = remote.mV;
			if (_v0.$ === 1) {
				return true;
			} else {
				var lastFetchTime = _v0.a;
				return _Utils_cmp(
					$elm$time$Time$posixToMillis(now) - $elm$time$Time$posixToMillis(lastFetchTime),
					(5 * 60) * 1000) > -1;
			}
		}();
	});
var $author$project$Remote$HashrateHistory$recoveryRequests = F2(
	function (now, lastKnownPoint) {
		var nowMillis = $elm$time$Time$posixToMillis(now);
		var startMillis = A2(
			$elm$core$Basics$max,
			$elm$time$Time$posixToMillis(lastKnownPoint),
			nowMillis - $author$project$Remote$HashrateHistory$bootstrapWindowMillis);
		return A2(
			$elm$core$List$map,
			$author$project$Remote$RequestMsg$UserHashrateHistorical,
			A2(
				$author$project$Remote$HashrateHistory$historicalRangesBetween,
				$elm$time$Time$millisToPosix(startMillis),
				now));
	});
var $author$project$Remote$HashrateHistory$recoveryThresholdMillis = (3 * 60) * 1000;
var $author$project$Remote$HashrateHistory$snapshotCadenceMillis = (2 * 60) * 1000;
var $author$project$Remote$HashrateHistory$shouldRecoverHistory = F3(
	function (now, lastFetchTime, lastKnownPoint) {
		var _v0 = _Utils_Tuple2(lastFetchTime, lastKnownPoint);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fetchTime = _v0.a.a;
			var knownPoint = _v0.b.a;
			var nowMillis = $elm$time$Time$posixToMillis(now);
			return (_Utils_cmp(
				nowMillis - $elm$time$Time$posixToMillis(fetchTime),
				$author$project$Remote$HashrateHistory$recoveryThresholdMillis) > -1) && (_Utils_cmp(
				nowMillis - $elm$time$Time$posixToMillis(knownPoint),
				$author$project$Remote$HashrateHistory$snapshotCadenceMillis) > -1);
		} else {
			return false;
		}
	});
var $author$project$Update$shouldResetDateRangePagination = function (msg) {
	switch (msg.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return true;
		case 3:
			return true;
		default:
			return true;
	}
};
var $author$project$Types$User$unwrapUserId = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Kernel$Aspect$Clipboard$Clipboard$copyToClipboard = _Platform_outgoingPort('copyToClipboard', $elm$json$Json$Encode$string);
var $author$project$Kernel$Aspect$Browser$OpenNewTab$openNewTab = _Platform_outgoingPort('openNewTab', $elm$json$Json$Encode$string);
var $author$project$Kernel$ToastMsgs$toastMsg = {aQ: $author$project$Kernel$Aspect$Toaster$MsgToasts$toastErr, pu: $author$project$Kernel$Aspect$Toaster$MsgToasts$toastInfo, ka: $author$project$Kernel$Aspect$Toaster$MsgToasts$toastSuccess};
var $author$project$Global$Global$update = F5(
	function (currTime, currRoute, maybeSession, msg, global) {
		var config = global.hG;
		switch (msg.$) {
			case 2:
				var theNewRoute = msg.b;
				return _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_Nil);
			case 0:
				var maybeRouteMsg = function () {
					if (currRoute.$ === 1) {
						var authRoute = currRoute.a;
						if (authRoute.$ === 1) {
							return _List_fromArray(
								[
									$author$project$Kernel$RouteMsgs$routeMsg.oB($author$project$Route$Route$Home)
								]);
						} else {
							return _List_fromArray(
								[
									$author$project$Kernel$RouteMsgs$routeMsg.gu($author$project$Route$Route$Home)
								]);
						}
					} else {
						return _List_Nil;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						global,
						{dD: 0}),
					$elm$core$Platform$Cmd$none,
					maybeRouteMsg);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						global,
						{dD: 0}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$Kernel$RouteMsgs$routeMsg.gu($author$project$Route$Route$Broker)
						]));
			case 4:
				var label = msg.a;
				var err = msg.b;
				return _Utils_Tuple3(
					global,
					$author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$generalError(label + (': ' + err)),
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						global,
						{fM: !global.fM}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var scope = msg.a;
				var routeRequests = ((scope === 1) && (_Utils_eq(currRoute, $author$project$Route$Route$Subaccounts) || _Utils_eq(currRoute, $author$project$Route$Route$ApiKeys))) ? _List_fromArray(
					[
						$author$project$Kernel$RouteMsgs$routeMsg.gu($author$project$Route$Route$Home)
					]) : _List_Nil;
				var fetchScopedPayouts = (_Utils_eq(currRoute, $author$project$Route$Route$GeneratedBitcoin) && (!scope)) ? _List_fromArray(
					[
						$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$FetchPayoutProgress)
					]) : (_Utils_eq(currRoute, $author$project$Route$Route$Payouts) ? _List_fromArray(
					[
						$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$FetchPayouts)
					]) : _List_Nil);
				var fetchScopedGeneratedBTC = _Utils_eq(currRoute, $author$project$Route$Route$GeneratedBitcoin) ? _List_fromArray(
					[
						$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GeneratedBTC)
					]) : _List_Nil;
				var aggregateRequests = (scope === 1) ? _List_fromArray(
					[
						$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RetrieveSubAccount)
					]) : _List_Nil;
				return _Utils_Tuple3(
					_Utils_update(
						global,
						{dD: scope}),
					$elm$core$Platform$Cmd$none,
					_Utils_ap(
						aggregateRequests,
						_Utils_ap(
							fetchScopedPayouts,
							_Utils_ap(fetchScopedGeneratedBTC, routeRequests))));
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						global,
						{dn: 60}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				return _Utils_Tuple3(
					_Utils_update(
						global,
						{dn: global.dn - 1}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var input = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						global,
						{kp: input}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var input = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						global,
						{hl: input}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var dialogWindow = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						global,
						{
							cP: $elm$core$Maybe$Just(dialogWindow)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				return $elm_community$maybe_extra$Maybe$Extra$isJust(global.cP) ? _Utils_Tuple3(
					_Utils_update(
						global,
						{cP: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil) : _Utils_Tuple3(
					global,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[$author$project$Kernel$RouteMsgs$routeMsg.ot]));
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						global,
						{cP: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var string = msg.a;
				return _Utils_Tuple3(
					global,
					$author$project$Kernel$Aspect$Clipboard$Clipboard$copyToClipboard(string),
					_List_fromArray(
						[
							A3($author$project$Kernel$ToastMsgs$toastMsg.ka, $elm$core$Maybe$Nothing, 'Copied to clipboard', _List_Nil)
						]));
			case 14:
				var string = msg.a;
				return _Utils_Tuple3(
					global,
					$author$project$Kernel$Aspect$Clipboard$Clipboard$copyToClipboard(string),
					_List_fromArray(
						[
							A3(
							$author$project$Kernel$ToastMsgs$toastMsg.ka,
							$elm$core$Maybe$Nothing,
							'Copied to clipboard',
							_List_fromArray(
								['Use the FPPS password ONLY if you are an FPPS authorized miner.']))
						]));
			case 15:
				var url = msg.a;
				return _Utils_Tuple3(
					global,
					$author$project$Kernel$Aspect$Browser$OpenNewTab$openNewTab(url),
					_List_Nil);
			default:
				return _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Remote$RequestMsg$BrokerMiners = {$: 62};
var $author$project$Remote$RequestMsg$FetchApiTokens = {$: 63};
var $author$project$Remote$RequestMsg$FetchPayoutLinkAddresses = {$: 65};
var $author$project$Remote$RequestMsg$FetchPermissions = {$: 58};
var $author$project$Types$AuthSession$IdToken = $elm$core$Basics$identity;
var $author$project$Remote$RequestMsg$WatcherFees = function (a) {
	return {$: 20, a: a};
};
var $author$project$Remote$RequestMsg$WatcherShareStats = function (a) {
	return {$: 19, a: a};
};
var $author$project$Remote$Model$clearMultiWatcherModeState = function (remote) {
	return _Utils_update(
		remote,
		{mb: $elm$core$Maybe$Nothing, c9: $elm$core$Maybe$Nothing, da: $elm$core$Maybe$Nothing, mV: $elm$core$Maybe$Nothing, d5: $elm$core$Maybe$Nothing, bz: $elm$core$Dict$empty, bm: $elm$core$Dict$empty, a3: $elm$core$Dict$empty, bn: $elm$core$Dict$empty, bA: $elm$core$Dict$empty, a4: $elm$core$Dict$empty, eb: $author$project$Types$ApiToken$defaultAggregateApiKeyRequirement, bX: _List_Nil, ej: $elm$core$Maybe$Nothing, nQ: $elm$core$Maybe$Nothing, bD: remote.bD + 1, ek: _List_Nil, di: false, dk: $author$project$Types$PplnsProjection$PplnsNotRequested, g4: '', az: $author$project$Remote$Model$initialWatcherAccess, eH: $elm$core$Maybe$Nothing, p1: $elm$core$Maybe$Nothing, cc: $elm$core$Maybe$Nothing, eI: $elm$core$Maybe$Nothing});
};
var $author$project$Remote$RequestMsg$WatcherLogin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Remote$Model$multiWatcherGeneratedBTCAccessForSession = F2(
	function (session, remote) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Dict$get,
				$author$project$Remote$Model$watcherSessionKey(session),
				remote.bm));
	});
var $author$project$Remote$Model$isMultiWatcherGeneratedBTCAccessDenied = F2(
	function (session, remote) {
		return A2($author$project$Remote$Model$multiWatcherGeneratedBTCAccessForSession, session, remote) === 2;
	});
var $author$project$Remote$FetchResourceBasedOnRoute$fiveMinutesInMillis = (5 * 60) * 1000;
var $author$project$Remote$FetchResourceBasedOnRoute$isStale = F2(
	function (now, lastFetchTime) {
		if (lastFetchTime.$ === 1) {
			return true;
		} else {
			var lastTime = lastFetchTime.a;
			return _Utils_cmp(
				$elm$time$Time$posixToMillis(now) - $elm$time$Time$posixToMillis(lastTime),
				$author$project$Remote$FetchResourceBasedOnRoute$fiveMinutesInMillis) > -1;
		}
	});
var $author$project$Remote$RequestMsg$WatcherHashrateHistorical = function (a) {
	return {$: 13, a: a};
};
var $author$project$Remote$HashrateHistory$watcherBootstrapRequests = F2(
	function (watcher, now) {
		var nowMillis = $elm$time$Time$posixToMillis(now);
		return A2(
			$elm$core$List$map,
			function (range) {
				return $author$project$Remote$RequestMsg$WatcherHashrateHistorical(
					{c6: range.c6, dr: range.dr, g_: watcher.g_, g4: watcher.g4});
			},
			A2(
				$author$project$Remote$HashrateHistory$historicalRangesBetween,
				$elm$time$Time$millisToPosix(nowMillis - $author$project$Remote$HashrateHistory$bootstrapWindowMillis),
				now));
	});
var $author$project$Remote$FetchResourceBasedOnRoute$fetchResourceBasedOnRoute = F5(
	function (oldRouteHistory, route, global, remote, time) {
		var workersAreStale = A2($author$project$Remote$FetchResourceBasedOnRoute$isStale, time, remote.mY);
		var payoutsAreStale = A2($author$project$Remote$FetchResourceBasedOnRoute$isStale, time, remote.mV) || function () {
			var _v8 = $author$project$Remote$Model$toUserSession(remote);
			if (!_v8.$) {
				var session = _v8.a;
				return !_Utils_eq(
					remote.nQ,
					$elm$core$Maybe$Just(
						A2(
							$author$project$Types$Payout$UserPayoutContext,
							$author$project$Types$User$unwrapUserId(session.mu),
							global.dD === 1)));
			} else {
				return false;
			}
		}();
		var isAggregateData = (global.dD === 1) && $author$project$Remote$Model$canViewSubAccounts(remote);
		var hashrateIsStale = A2($author$project$Remote$FetchResourceBasedOnRoute$isStale, time, remote.mU);
		switch (route.$) {
			case 0:
				return _Utils_Tuple3(remote, $elm$core$Platform$Cmd$none, _List_Nil);
			case 1:
				var authRoute = route.a;
				if (authRoute.$ === 1) {
					var watcherSession = authRoute.a;
					return _Utils_Tuple3(
						remote,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								$author$project$TopMsg$requestMsg(
								$author$project$Remote$RequestMsg$WatcherLogin(watcherSession))
							]));
				} else {
					return _Utils_Tuple3(remote, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var _v2 = $author$project$Remote$Model$toWatcherSession(remote);
				if (!_v2.$) {
					var watcherSession = _v2.a;
					var hashrateRequests = (hashrateIsStale && (!A2($author$project$Remote$Model$watcherAccessIsDenied, 0, remote))) ? _List_fromArray(
						[
							$author$project$TopMsg$requestMsg(
							$author$project$Remote$RequestMsg$WatcherHashrate(watcherSession))
						]) : _List_Nil;
					return _Utils_Tuple3(remote, $elm$core$Platform$Cmd$none, hashrateRequests);
				} else {
					var hashrateRequests = hashrateIsStale ? _List_fromArray(
						[
							$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$UserHashrate)
						]) : _List_Nil;
					return _Utils_Tuple3(
						remote,
						$elm$core$Platform$Cmd$none,
						_Utils_ap(
							hashrateRequests,
							_List_fromArray(
								[
									$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RetrieveSubAccount)
								])));
				}
			case 3:
				return _Utils_Tuple3(remote, $elm$core$Platform$Cmd$none, _List_Nil);
			case 4:
				return _Utils_Tuple3(remote, $elm$core$Platform$Cmd$none, _List_Nil);
			case 5:
				var payoutRequests = $author$project$Remote$Model$isWatcherAuthenticated(remote) ? ((payoutsAreStale && $author$project$Remote$Model$watcherMayViewPayouts(remote)) ? _List_fromArray(
					[
						$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$WatcherPayouts)
					]) : _List_Nil) : (isAggregateData ? A2(
					$elm$core$List$cons,
					$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RetrieveSubAccount),
					payoutsAreStale ? _List_fromArray(
						[
							$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$FetchPayouts)
						]) : _List_Nil) : (payoutsAreStale ? _List_fromArray(
					[
						$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$FetchPayouts)
					]) : _List_Nil));
				return _Utils_Tuple3(remote, $elm$core$Platform$Cmd$none, payoutRequests);
			case 6:
				return _Utils_Tuple3(remote, $elm$core$Platform$Cmd$none, _List_Nil);
			case 7:
				var _v3 = $author$project$Remote$Model$toWatcherSession(remote);
				if (!_v3.$) {
					var watcherSession = _v3.a;
					var sessions = remote.bX;
					var isMultiwatcher = $elm$core$List$length(sessions) > 1;
					var multiwatcherHashrateRequests = (isMultiwatcher && $author$project$Remote$Model$multiWatcherAllowsHashrate(remote)) ? A2(
						$elm$core$List$concatMap,
						function (session) {
							return A2(
								$elm$core$List$map,
								$author$project$TopMsg$requestMsg,
								A2($author$project$Remote$HashrateHistory$watcherBootstrapRequests, session, time));
						},
						sessions) : _List_Nil;
					var multiwatcherLiveHashrateRequests = (isMultiwatcher && $author$project$Remote$Model$multiWatcherAllowsHashrate(remote)) ? A2(
						$elm$core$List$map,
						function (session) {
							return $author$project$TopMsg$requestMsg(
								$author$project$Remote$RequestMsg$WatcherHashrate(session));
						},
						sessions) : _List_Nil;
					var workerRequests = ((!isMultiwatcher) && (workersAreStale && (!A2($author$project$Remote$Model$watcherAccessIsDenied, 1, remote)))) ? _List_fromArray(
						[
							$author$project$TopMsg$requestMsg(
							$author$project$Remote$RequestMsg$WatcherWorkersInfo(
								{hO: $elm$core$Maybe$Nothing, v: $author$project$Remote$RequestMsg$defaultWorkersPageLimit, iX: 0, g_: watcherSession.g_, g4: watcherSession.g4}))
						]) : _List_Nil;
					var hashrateRequests = isMultiwatcher ? _Utils_ap(multiwatcherHashrateRequests, multiwatcherLiveHashrateRequests) : ((hashrateIsStale && (!A2($author$project$Remote$Model$watcherAccessIsDenied, 0, remote))) ? _List_fromArray(
						[
							$author$project$TopMsg$requestMsg(
							$author$project$Remote$RequestMsg$WatcherHashrate(watcherSession))
						]) : _List_Nil);
					return _Utils_Tuple3(
						remote,
						$elm$core$Platform$Cmd$none,
						_Utils_ap(workerRequests, hashrateRequests));
				} else {
					var sessionToken = function () {
						var _v4 = $author$project$Remote$Model$toUserSession(remote);
						if (!_v4.$) {
							var userSession = _v4.a;
							return userSession.g_;
						} else {
							return '';
						}
					}();
					var workerRequests = (workersAreStale && (!$elm$core$String$isEmpty(sessionToken))) ? _List_fromArray(
						[
							$author$project$TopMsg$requestMsg(
							$author$project$Remote$RequestMsg$WorkersInfo(
								{hO: $elm$core$Maybe$Nothing, v: $author$project$Remote$RequestMsg$defaultWorkersPageLimit, iX: 0, g_: sessionToken}))
						]) : _List_Nil;
					var hashrateRequests = hashrateIsStale ? _List_fromArray(
						[
							$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$UserHashrate)
						]) : _List_Nil;
					var aggregateRequests = isAggregateData ? _List_fromArray(
						[
							$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RetrieveSubAccount)
						]) : _List_Nil;
					return _Utils_Tuple3(
						remote,
						$elm$core$Platform$Cmd$none,
						_Utils_ap(
							workerRequests,
							_Utils_ap(hashrateRequests, aggregateRequests)));
				}
			case 8:
				return _Utils_Tuple3(
					remote,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RetrieveSubAccount)
						]));
			case 9:
				return _Utils_Tuple3(
					remote,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$FetchApiTokens),
							$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RetrieveSubAccount),
							$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$FetchPayoutLinkAddresses)
						]));
			case 10:
				return _Utils_Tuple3(
					remote,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$BrokerMiners)
						]));
			case 11:
				var _v5 = $author$project$Remote$Model$toWatcherSession(remote);
				if (!_v5.$) {
					var watcherSession = _v5.a;
					var hashrateRequests = (hashrateIsStale && (!A2($author$project$Remote$Model$watcherAccessIsDenied, 0, remote))) ? _List_fromArray(
						[
							$author$project$TopMsg$requestMsg(
							$author$project$Remote$RequestMsg$WatcherHashrate(watcherSession))
						]) : _List_Nil;
					var generatedRequests = A2($author$project$Remote$Model$watcherAccessIsDenied, 2, remote) ? _List_Nil : _List_fromArray(
						[
							$author$project$TopMsg$requestMsg(
							$author$project$Remote$RequestMsg$WatcherGeneratedBTC(watcherSession))
						]);
					return _Utils_Tuple3(
						remote,
						$elm$core$Platform$Cmd$none,
						_Utils_ap(generatedRequests, hashrateRequests));
				} else {
					var payoutRequests = ((!global.dD) && payoutsAreStale) ? _List_fromArray(
						[
							$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$FetchPayoutProgress)
						]) : _List_Nil;
					var hashrateRequests = hashrateIsStale ? _List_fromArray(
						[
							$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$UserHashrate)
						]) : _List_Nil;
					var aggregateRequests = isAggregateData ? _List_fromArray(
						[
							$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RetrieveSubAccount)
						]) : _List_Nil;
					return _Utils_Tuple3(
						remote,
						$elm$core$Platform$Cmd$none,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GeneratedBTC)
								]),
							_Utils_ap(
								hashrateRequests,
								_Utils_ap(aggregateRequests, payoutRequests))));
				}
			case 12:
				var _v6 = $author$project$Remote$Model$toWatcherSession(remote);
				if (!_v6.$) {
					var watcherSession = _v6.a;
					return (_Utils_eq(
						remote.bX,
						_List_fromArray(
							[watcherSession])) && (!A2($author$project$Remote$Model$watcherAccessIsDenied, 3, remote))) ? _Utils_Tuple3(
						remote,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								$author$project$TopMsg$requestMsg(
								$author$project$Remote$RequestMsg$WatcherPplnsProjection(watcherSession))
							])) : _Utils_Tuple3(remote, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var _v7 = $author$project$Remote$Model$toUserSession(remote);
					if (!_v7.$) {
						var userSession = _v7.a;
						return _Utils_Tuple3(
							remote,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$TopMsg$requestMsg(
									$author$project$Remote$RequestMsg$UserPplnsProjection(
										$author$project$Types$User$unwrapUserId(userSession.mu)))
								]));
					} else {
						return _Utils_Tuple3(remote, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				}
			default:
				var routeRequirement = route.a;
				var routeSessions = route.b;
				var sessions = $elm$core$List$isEmpty(routeSessions) ? remote.bX : routeSessions;
				var requirement = $elm$core$List$isEmpty(routeSessions) ? remote.eb : routeRequirement;
				var multiwatcherLiveHashrateRequests = $author$project$Types$ApiToken$aggregateRequirementIncludesHashrate(requirement) ? A2(
					$elm$core$List$map,
					function (session) {
						return $author$project$TopMsg$requestMsg(
							$author$project$Remote$RequestMsg$WatcherHashrate(session));
					},
					sessions) : _List_Nil;
				var multiwatcherHashrateRequests = $author$project$Types$ApiToken$aggregateRequirementIncludesHashrate(requirement) ? A2(
					$elm$core$List$concatMap,
					function (session) {
						return A2(
							$elm$core$List$map,
							$author$project$TopMsg$requestMsg,
							A2($author$project$Remote$HashrateHistory$watcherBootstrapRequests, session, time));
					},
					sessions) : _List_Nil;
				var hashrateRequests = _Utils_ap(multiwatcherHashrateRequests, multiwatcherLiveHashrateRequests);
				var generatedRequests = $author$project$Types$ApiToken$aggregateRequirementIncludesGeneratedBTC(requirement) ? $elm$core$List$concat(
					A2(
						$elm$core$List$map,
						function (session) {
							return A2($author$project$Remote$Model$isMultiWatcherGeneratedBTCAccessDenied, session, remote) ? _List_Nil : _List_fromArray(
								[
									$author$project$TopMsg$requestMsg(
									$author$project$Remote$RequestMsg$WatcherGeneratedBTC(session))
								]);
						},
						sessions)) : _List_Nil;
				return _Utils_Tuple3(
					remote,
					$elm$core$Platform$Cmd$none,
					_Utils_ap(generatedRequests, hashrateRequests));
		}
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$PendingResponseAuthenticated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Kernel$Aspect$Remote$RemoteModel$sendRequestsThatArePendingAuthentication = F3(
	function (remote, msgMapper, token) {
		var sendRequestIfPendingAuth = function (savedRequest) {
			var _v3 = savedRequest.D;
			switch (_v3.$) {
				case 0:
					return _Utils_Tuple2(savedRequest, $elm$core$Platform$Cmd$none);
				case 1:
					return _Utils_Tuple2(savedRequest, $elm$core$Platform$Cmd$none);
				default:
					var toCmd = _v3.a;
					var cmd = toCmd(token);
					return _Utils_Tuple2(
						_Utils_update(
							savedRequest,
							{
								D: $author$project$Kernel$Aspect$Remote$RemoteModel$PendingResponseAuthenticated(toCmd)
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							msgMapper(savedRequest.aM),
							cmd));
			}
		};
		var folder = F2(
			function (_v1, _v2) {
				var request = _v1.a;
				var cmd = _v1.b;
				var requests = _v2.a;
				var commands = _v2.b;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, request, requests),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmd, commands])));
			});
		var _v0 = A3(
			$elm$core$List$foldl,
			folder,
			_Utils_Tuple2(_List_Nil, $elm$core$Platform$Cmd$none),
			A2($elm$core$List$map, sendRequestIfPendingAuth, remote.C));
		var updatedOngoingRequests = _v0.a;
		var cmds = _v0.b;
		return _Utils_Tuple3(
			_Utils_update(
				remote,
				{C: updatedOngoingRequests}),
			cmds,
			_List_Nil);
	});
var $author$project$Remote$Update$update = F5(
	function (msg, remote, route, global, time) {
		switch (msg.$) {
			case 0:
				var oldHistory = msg.a;
				var newRoute = msg.b;
				var remoteState = function () {
					if (newRoute.$ === 1) {
						var authRoute = newRoute.a;
						if (authRoute.$ === 1) {
							return remote;
						} else {
							return $author$project$Remote$Model$clearMultiWatcherModeState(remote);
						}
					} else {
						return remote;
					}
				}();
				return A5($author$project$Remote$FetchResourceBasedOnRoute$fetchResourceBasedOnRoute, oldHistory, newRoute, global, remoteState, time);
			case 1:
				return function (_v3) {
					var state = _v3.a;
					var cmd = _v3.b;
					var ms = _v3.c;
					var workersRequests = function () {
						var _v6 = $author$project$Remote$Model$toUserSession(state);
						if (!_v6.$) {
							var userSession = _v6.a;
							return $elm$core$String$isEmpty(userSession.g_) ? _List_Nil : _List_fromArray(
								[
									$author$project$TopMsg$requestMsg(
									$author$project$Remote$RequestMsg$WorkersInfo(
										{hO: $elm$core$Maybe$Nothing, v: $author$project$Remote$RequestMsg$defaultWorkersPageLimit, iX: 0, g_: userSession.g_}))
								]);
						} else {
							return _List_Nil;
						}
					}();
					var routeRequests = function () {
						switch (route.$) {
							case 9:
								return _List_fromArray(
									[
										$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$FetchApiTokens),
										$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$FetchPayoutLinkAddresses)
									]);
							case 11:
								return A2(
									$elm$core$List$cons,
									$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$UserHashrate),
									(!global.dD) ? _List_fromArray(
										[
											$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$FetchPayoutProgress)
										]) : _List_Nil);
							case 5:
								return _List_fromArray(
									[
										$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$FetchPayouts)
									]);
							default:
								return _List_Nil;
						}
					}();
					var initialRequests = _Utils_ap(
						_List_fromArray(
							[
								$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$UserHashrate),
								$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GeneratedBTC),
								$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$FetchPermissions),
								$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RetrieveSubAccount)
							]),
						function () {
							var _v4 = $author$project$Remote$Model$toUserSession(state);
							if (!_v4.$) {
								var userSession = _v4.a;
								return _List_fromArray(
									[
										$author$project$TopMsg$requestMsg(
										$author$project$Remote$RequestMsg$UserPplnsProjection(
											$author$project$Types$User$unwrapUserId(userSession.mu)))
									]);
							} else {
								return _List_Nil;
							}
						}());
					return _Utils_Tuple3(
						state,
						cmd,
						_Utils_ap(
							ms,
							_Utils_ap(
								initialRequests,
								_Utils_ap(workersRequests, routeRequests))));
				}(
					A3($author$project$Kernel$Aspect$Remote$RemoteModel$sendRequestsThatArePendingAuthentication, remote, $author$project$Msg$RemoteResponseMsg, ''));
			case 2:
				var sessions = function () {
					if ($elm$core$List$isEmpty(remote.bX)) {
						var _v8 = $author$project$Remote$Model$toWatcherSession(remote);
						if (!_v8.$) {
							var watcherSession = _v8.a;
							return _List_fromArray(
								[watcherSession]);
						} else {
							return _List_Nil;
						}
					} else {
						return remote.bX;
					}
				}();
				var watcherRequests = function () {
					if ($elm$core$List$length(sessions) > 1) {
						return A2(
							$elm$core$List$concatMap,
							function (session) {
								return $elm$core$List$concat(
									_List_fromArray(
										[
											$author$project$Remote$Model$multiWatcherAllowsGeneratedBTC(remote) ? _List_fromArray(
											[
												$author$project$TopMsg$requestMsg(
												$author$project$Remote$RequestMsg$WatcherGeneratedBTC(session))
											]) : _List_Nil,
											$author$project$Remote$Model$multiWatcherAllowsHashrate(remote) ? _List_fromArray(
											[
												$author$project$TopMsg$requestMsg(
												$author$project$Remote$RequestMsg$WatcherHashrate(session))
											]) : _List_Nil
										]));
							},
							sessions);
					} else {
						if (sessions.b && (!sessions.b.b)) {
							var watcherSession = sessions.a;
							return _List_fromArray(
								[
									$author$project$TopMsg$requestMsg(
									$author$project$Remote$RequestMsg$WatcherHashrate(watcherSession)),
									$author$project$TopMsg$requestMsg(
									$author$project$Remote$RequestMsg$WatcherGeneratedBTC(watcherSession)),
									$author$project$TopMsg$requestMsg(
									$author$project$Remote$RequestMsg$WatcherPplnsProjection(watcherSession)),
									$author$project$TopMsg$requestMsg(
									$author$project$Remote$RequestMsg$WatcherShareStats(watcherSession)),
									$author$project$TopMsg$requestMsg(
									$author$project$Remote$RequestMsg$WatcherFees(watcherSession)),
									$author$project$TopMsg$requestMsg(
									$author$project$Remote$RequestMsg$WatcherWorkersInfo(
										{hO: $elm$core$Maybe$Nothing, v: $author$project$Remote$RequestMsg$defaultWorkersPageLimit, iX: 0, g_: watcherSession.g_, g4: watcherSession.g4}))
								]);
						} else {
							return _List_Nil;
						}
					}
				}();
				var historyRequests = $author$project$Remote$Model$multiWatcherAllowsHashrate(remote) ? A2(
					$elm$core$List$concatMap,
					function (session) {
						return A2(
							$elm$core$List$map,
							$author$project$TopMsg$requestMsg,
							A2($author$project$Remote$HashrateHistory$watcherBootstrapRequests, session, time));
					},
					sessions) : _List_Nil;
				return _Utils_Tuple3(
					remote,
					$elm$core$Platform$Cmd$none,
					_Utils_ap(watcherRequests, historyRequests));
			case 4:
				return _Utils_Tuple3(
					remote,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$BrokerMiners)
						]));
			default:
				return _Utils_Tuple3(remote, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Remote$RequestMsg$SelectReportDays = function (a) {
	return {$: 28, a: a};
};
var $author$project$TopMsg$remoteRequestMsg = A2($elm$core$Basics$composeL, $author$project$Kernel$Msg$AppMsg, $author$project$Msg$RemoteRequestMsg);
var $author$project$UI$Account$Update$update = F4(
	function (maybeSession, _v0, msg, state) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
			case 1:
				var routeHistory = msg.a;
				var route = msg.b;
				if (route.$ === 6) {
					return _Utils_Tuple3(
						_Utils_update(
							state,
							{
								hl: function () {
									if (state.hl === '') {
										if (!maybeSession.$) {
											var session = maybeSession.a;
											return A2($elm$core$Maybe$withDefault, '', session.hl);
										} else {
											return '';
										}
									} else {
										return state.hl;
									}
								}()
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{
							hl: function () {
								if (state.hl === '') {
									if (!maybeSession.$) {
										var session = maybeSession.a;
										return A2($elm$core$Maybe$withDefault, '', session.hl);
									} else {
										return '';
									}
								} else {
									return state.hl;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var input = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{hl: input}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var days = msg.a;
				return _Utils_Tuple3(
					state,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$TopMsg$remoteRequestMsg(
							$author$project$Remote$RequestMsg$SelectReportDays(days))
						]));
		}
	});
var $author$project$UI$Auth$Model$ResetPasswordStepTwo = 1;
var $author$project$UI$Auth$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 13:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			case 0:
				var string = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ff: string}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var string = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cy: string}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var string = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{p3: string}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var string = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{p2: string}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var loginMode = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iR: loginMode}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var string = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hq: string}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var string = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hr: string}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var string = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lb: string}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var string = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pK: string}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oh: 1, pK: ''}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jC: !model.jC}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				return _Utils_Tuple3($author$project$UI$Auth$Model$init, $elm$core$Platform$Cmd$none, _List_Nil);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$UI$ComponentsPreview$View$update = F4(
	function (_v0, maybeSession, msg, state) {
		return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$UI$Connect$Update$update = F3(
	function (_v0, msg, state) {
		if (!msg.$) {
			return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
		} else {
			var routeHistory = msg.a;
			var route = msg.b;
			if (route.$ === 3) {
				return _Utils_Tuple3(
					state,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$TopMsg$requestMsg(
							$author$project$Remote$RequestMsg$CheckAuth(1))
						]));
			} else {
				return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$UI$Home$Update$update = F3(
	function (maybeSession, msg, state) {
		if (!msg.$) {
			var newValue = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					state,
					{
						jW: A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(newValue))
					}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			var label = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					state,
					{iw: label}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		}
	});
var $author$project$UI$Library$Chart$Model$CustomRange = 4;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {lA: d, i_: m, ky: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		f8: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		ky: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.ky, 0, date.f8);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.lA;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.i_;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.f8;
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		ks: 1 + (((rd - week1Day1) / 7) | 0),
		kt: wy,
		p4: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.ks;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.kt;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.ea(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.f0(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.ea(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.e6(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.cd(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.cd(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.cd(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.g5(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.cd(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.cd(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {hB: col, lk: contextStack, n5: problem, oG: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.oG, s.hB, x, s.hK));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.j, s.oG, s.hB, s.gJ);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{hB: newCol, hK: s.hK, x: s.x, j: newOffset, oG: newRow, gJ: s.gJ});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.j, s.gJ);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{hB: 1, hK: s.hK, x: s.x, j: s.j + 1, oG: s.oG + 1, gJ: s.gJ}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{hB: s.hB + 1, hK: s.hK, x: s.x, j: newOffset, oG: s.oG, gJ: s.gJ}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.gJ);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.j, offset) < 0,
					0,
					{hB: col, hK: s0.hK, x: s0.x, j: offset, oG: row, gJ: s0.gJ});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.j, s.oG, s.hB, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.j, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.j, s1.j, s0.gJ),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.gJ),
			s.j) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {hB: col, n5: problem, oG: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.oG, p.hB, p.n5);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{hB: 1, hK: _List_Nil, x: 1, j: 0, oG: 1, gJ: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	e6: $justinmimbs$date$Date$withOrdinalSuffix,
	f0: $justinmimbs$date$Date$monthToName,
	ea: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	g5: $justinmimbs$date$Date$weekdayToName,
	cd: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$UI$Library$Chart$Model$chartPointDate = F2(
	function (zone, point) {
		return $justinmimbs$date$Date$toIsoString(
			A2($justinmimbs$date$Date$fromPosix, zone, point.ph));
	});
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$UI$Library$Chart$Model$chartDateBounds = F2(
	function (zone, chartData) {
		var sortedDates = $elm$core$List$sort(
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				A2(
					$elm$core$List$map,
					$author$project$UI$Library$Chart$Model$chartPointDate(zone),
					chartData)));
		return _Utils_Tuple2(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(sortedDates)),
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(
					$elm$core$List$reverse(sortedDates))));
	});
var $author$project$UI$Library$Chart$Update$ensureCustomDateRange = F2(
	function (zone, state) {
		var _v0 = A2($author$project$UI$Library$Chart$Model$chartDateBounds, zone, state.hv);
		var minDate = _v0.a;
		var maxDate = _v0.b;
		var toDate = $elm$core$String$isEmpty(state.hQ) ? maxDate : state.hQ;
		var fromDate = $elm$core$String$isEmpty(state.hP) ? minDate : state.hP;
		return _Utils_update(
			state,
			{hP: fromDate, hQ: toDate});
	});
var $author$project$UI$Library$Chart$Update$toChartPoint = F4(
	function (observedAt, pplnsHashrate, fppsHashrate, totalHashrate) {
		return {l6: fppsHashrate, n$: pplnsHashrate, ph: observedAt, pG: totalHashrate};
	});
var $author$project$UI$Library$Chart$Update$hashrateToChartPoint = function (currentHashrate) {
	return A2(
		$elm$core$Maybe$map,
		function (observedAt) {
			return A4($author$project$UI$Library$Chart$Update$toChartPoint, observedAt, currentHashrate.n1, currentHashrate.ii, currentHashrate.ay);
		},
		currentHashrate.ny);
};
var $author$project$UI$Library$Chart$Update$historyPointToChartPoint = function (historyPoint) {
	return A4($author$project$UI$Library$Chart$Update$toChartPoint, historyPoint.ny, historyPoint.n1, historyPoint.ii, historyPoint.ay);
};
var $author$project$UI$Library$Chart$Update$historyRetentionMillis = (((30 * 24) * 60) * 60) * 1000;
var $author$project$UI$Library$Chart$Update$mergeChartData = F2(
	function (newPoints, existingPoints) {
		var sortedPoints = A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ph;
				},
				$elm$time$Time$posixToMillis),
			_Utils_ap(existingPoints, newPoints));
		var dedupedPoints = $elm$core$List$reverse(
			A3(
				$elm$core$List$foldl,
				F2(
					function (point, accumulatedPoints) {
						if (accumulatedPoints.b) {
							var latestPoint = accumulatedPoints.a;
							var rest = accumulatedPoints.b;
							return _Utils_eq(
								$elm$time$Time$posixToMillis(latestPoint.ph),
								$elm$time$Time$posixToMillis(point.ph)) ? A2($elm$core$List$cons, point, rest) : A2($elm$core$List$cons, point, accumulatedPoints);
						} else {
							return _List_fromArray(
								[point]);
						}
					}),
				_List_Nil,
				sortedPoints));
		var _v0 = $author$project$UI$Library$Chart$Model$latestChartPoint(dedupedPoints);
		if (!_v0.$) {
			var latestPoint = _v0.a;
			var cutoffMillis = $elm$time$Time$posixToMillis(latestPoint.ph) - $author$project$UI$Library$Chart$Update$historyRetentionMillis;
			return A2(
				$elm$core$List$filter,
				function (point) {
					return _Utils_cmp(
						$elm$time$Time$posixToMillis(point.ph),
						cutoffMillis) > -1;
				},
				dedupedPoints);
		} else {
			return _List_Nil;
		}
	});
var $author$project$UI$Library$Chart$Update$parseRangeInput = F2(
	function (fallback, rawValue) {
		return A3(
			$elm$core$Basics$clamp,
			0,
			$author$project$UI$Library$Chart$Model$rangeScaleMax,
			A2(
				$elm$core$Maybe$withDefault,
				fallback,
				$elm$core$String$toInt(rawValue)));
	});
var $author$project$UI$Library$Chart$Update$update = F4(
	function (zone, _v0, msg, state) {
		switch (msg.$) {
			case 0:
				var hovering = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{ix: hovering}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var currentHashrate = msg.a;
				var updatedChartData = A2(
					$elm$core$Maybe$withDefault,
					state.hv,
					A2(
						$elm$core$Maybe$map,
						function (chartPoint) {
							return A2(
								$author$project$UI$Library$Chart$Update$mergeChartData,
								_List_fromArray(
									[chartPoint]),
								state.hv);
						},
						$author$project$UI$Library$Chart$Update$hashrateToChartPoint(currentHashrate)));
				var nextState = _Utils_update(
					state,
					{hv: updatedChartData, ix: _List_Nil});
				return _Utils_Tuple3(
					(nextState.kr === 4) ? A2($author$project$UI$Library$Chart$Update$ensureCustomDateRange, zone, nextState) : nextState,
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var historyPoints = msg.a;
				var nextState = _Utils_update(
					state,
					{
						hv: A2(
							$author$project$UI$Library$Chart$Update$mergeChartData,
							A2($elm$core$List$map, $author$project$UI$Library$Chart$Update$historyPointToChartPoint, historyPoints),
							state.hv),
						ix: _List_Nil
					});
				return _Utils_Tuple3(
					(nextState.kr === 4) ? A2($author$project$UI$Library$Chart$Update$ensureCustomDateRange, zone, nextState) : nextState,
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var visiblePeriod = msg.a;
				var nextState = _Utils_update(
					state,
					{ix: _List_Nil, jK: $author$project$UI$Library$Chart$Model$fullRangeSelection, kr: visiblePeriod});
				return _Utils_Tuple3(
					(visiblePeriod === 4) ? A2($author$project$UI$Library$Chart$Update$ensureCustomDateRange, zone, nextState) : nextState,
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var date = msg.a;
				var _v2 = A2($author$project$UI$Library$Chart$Model$chartDateBounds, zone, state.hv);
				var maxDate = _v2.b;
				var currentToDate = $elm$core$String$isEmpty(state.hQ) ? maxDate : state.hQ;
				var toDate = ((!$elm$core$String$isEmpty(currentToDate)) && (_Utils_cmp(date, currentToDate) > 0)) ? date : currentToDate;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{hP: date, hQ: toDate, ix: _List_Nil, jK: $author$project$UI$Library$Chart$Model$fullRangeSelection, kr: 4}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var date = msg.a;
				var _v3 = A2($author$project$UI$Library$Chart$Model$chartDateBounds, zone, state.hv);
				var minDate = _v3.a;
				var currentFromDate = $elm$core$String$isEmpty(state.hP) ? minDate : state.hP;
				var fromDate = ((!$elm$core$String$isEmpty(currentFromDate)) && (_Utils_cmp(date, currentFromDate) < 0)) ? date : currentFromDate;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{hP: fromDate, hQ: date, ix: _List_Nil, jK: $author$project$UI$Library$Chart$Model$fullRangeSelection, kr: 4}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var rawValue = msg.a;
				var nextStart = A2(
					$elm$core$Basics$min,
					state.jK.h_,
					A2($author$project$UI$Library$Chart$Update$parseRangeInput, state.jK.j$, rawValue));
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{
							ix: _List_Nil,
							jK: {h_: state.jK.h_, j$: nextStart}
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var rawValue = msg.a;
				var nextEnd = A2(
					$elm$core$Basics$max,
					state.jK.j$,
					A2($author$project$UI$Library$Chart$Update$parseRangeInput, state.jK.h_, rawValue));
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{
							ix: _List_Nil,
							jK: {h_: nextEnd, j$: state.jK.j$}
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3($author$project$UI$Library$Chart$Model$init, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$UI$Library$DateRangePicker$Custom = 3;
var $author$project$UI$Library$DateRangePicker$dateBounds = function (dates) {
	var sortedDates = $elm$core$List$sort(
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			dates));
	return _Utils_Tuple2(
		A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(sortedDates)),
		A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				$elm$core$List$reverse(sortedDates))));
};
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.ky - 1)) + ($justinmimbs$date$Date$monthToNumber(date.i_) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.lA,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.n5;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('month ' + ($elm$core$String$fromInt(mn) + ' is out of range')) + (' (1 to 12)' + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))) : ((!A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('day ' + ($elm$core$String$fromInt(d) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(
				A2(
					$justinmimbs$date$Date$daysInMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + ')')) + ((' for ' + $justinmimbs$date$Date$monthToName(
				$justinmimbs$date$Date$numberToMonth(mn))) + ((((mn === 2) && (d === 29)) ? (' (' + ($elm$core$String$fromInt(y) + ' is not a leap year)')) : '') + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		var daysInYear = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, daysInYear, od)) ? $elm$core$Result$Err(
			'Invalid ordinal date: ' + (('ordinal-day ' + ($elm$core$String$fromInt(od) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(daysInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(y)) + ('; received (year ' + ($elm$core$String$fromInt(y) + (', ordinal-day ' + ($elm$core$String$fromInt(od) + ')')))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od);
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		var weeksInYear = $justinmimbs$date$Date$is53WeekYear(wy) ? 53 : 52;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, weeksInYear, wn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('week ' + ($elm$core$String$fromInt(wn) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(weeksInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(wy)) + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')')))))))))) : ((!A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('weekday ' + ($elm$core$String$fromInt(wdn) + ' is out of range')) + (' (1 to 7)' + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')'))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $author$project$UI$Library$DateRangePicker$startDateForLastDays = F2(
	function (days, endDate) {
		return $elm$core$String$isEmpty(endDate) ? '' : A2(
			$elm$core$Result$withDefault,
			endDate,
			A2(
				$elm$core$Result$map,
				A2(
					$elm$core$Basics$composeR,
					A2($justinmimbs$date$Date$add, 3, 1 - days),
					$justinmimbs$date$Date$toIsoString),
				$justinmimbs$date$Date$fromIsoString(endDate)));
	});
var $author$project$UI$Library$DateRangePicker$selectedRangeFor = F3(
	function (today, dates, model) {
		var _v0 = $author$project$UI$Library$DateRangePicker$dateBounds(dates);
		var minDate_ = _v0.a;
		var maxDate_ = _v0.b;
		var fallbackTo = $elm$core$String$isEmpty(model.gY) ? ($elm$core$String$isEmpty(maxDate_) ? today : maxDate_) : model.gY;
		var fallbackFrom = $elm$core$String$isEmpty(model.fo) ? ($elm$core$String$isEmpty(minDate_) ? today : minDate_) : model.fo;
		var _v1 = model.au;
		switch (_v1) {
			case 0:
				return _Utils_Tuple2(minDate_, maxDate_);
			case 1:
				return _Utils_Tuple2(
					A2($author$project$UI$Library$DateRangePicker$startDateForLastDays, 7, today),
					today);
			case 2:
				return _Utils_Tuple2(
					A2($author$project$UI$Library$DateRangePicker$startDateForLastDays, 30, today),
					today);
			default:
				return _Utils_Tuple2(fallbackFrom, fallbackTo);
		}
	});
var $author$project$UI$Library$DateRangePicker$update = F4(
	function (today, dates, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_update(
					model,
					{aS: !model.aS});
			case 1:
				return _Utils_update(
					model,
					{aS: false});
			case 2:
				var preset = msg.a;
				var _v1 = A3(
					$author$project$UI$Library$DateRangePicker$selectedRangeFor,
					today,
					dates,
					_Utils_update(
						model,
						{au: preset}));
				var fromDate = _v1.a;
				var toDate = _v1.b;
				return _Utils_update(
					model,
					{fo: fromDate, aS: preset === 3, au: preset, gY: toDate});
			case 3:
				var date = msg.a;
				var _v2 = A3(
					$author$project$UI$Library$DateRangePicker$selectedRangeFor,
					today,
					dates,
					_Utils_update(
						model,
						{au: 3}));
				var currentToDate = _v2.b;
				var toDate = ((!$elm$core$String$isEmpty(currentToDate)) && (_Utils_cmp(date, currentToDate) > 0)) ? date : currentToDate;
				return _Utils_update(
					model,
					{fo: date, aS: true, au: 3, gY: toDate});
			default:
				var date = msg.a;
				var _v3 = A3(
					$author$project$UI$Library$DateRangePicker$selectedRangeFor,
					today,
					dates,
					_Utils_update(
						model,
						{au: 3}));
				var currentFromDate = _v3.a;
				var fromDate = ((!$elm$core$String$isEmpty(currentFromDate)) && (_Utils_cmp(date, currentFromDate) < 0)) ? date : currentFromDate;
				return _Utils_update(
					model,
					{fo: fromDate, aS: false, au: 3, gY: date});
		}
	});
var $author$project$UI$Library$TablePagination$normalizePage = function (page) {
	return A2($elm$core$Basics$max, 1, page);
};
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$UI$Library$TablePagination$normalizePageSize = function (pageSize) {
	return A2(
		$elm$core$List$member,
		pageSize,
		_List_fromArray(
			[10, 15, 20])) ? pageSize : 15;
};
var $author$project$UI$Library$TablePagination$update = F2(
	function (msg, state) {
		if (!msg.$) {
			var page = msg.a;
			return _Utils_update(
				state,
				{
					nN: $author$project$UI$Library$TablePagination$normalizePage(page)
				});
		} else {
			var pageSize = msg.a;
			return _Utils_update(
				state,
				{
					nN: 1,
					i9: $author$project$UI$Library$TablePagination$normalizePageSize(pageSize)
				});
		}
	});
var $author$project$UI$Workers$Model$Descending = 1;
var $author$project$UI$Workers$Update$update = F4(
	function (_v0, _v1, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			case 1:
				var column = msg.a;
				var direction = function () {
					if (_Utils_eq(model.jX, column)) {
						var _v3 = model.jY;
						if (!_v3) {
							return 1;
						} else {
							return 0;
						}
					} else {
						return 0;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nN: 0, jX: column, jY: direction}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var filter = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{$8: filter, nN: 0}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var newPage = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nN: newPage}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var size = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nN: 0, i9: size}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var query = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nN: 0, gx: query}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Remote$ResponseMsg$Activate2FA = function (a) {
	return {$: 6, a: a};
};
var $author$project$Remote$ResponseMsg$AggregateSubAccountGeneratedBTC = F2(
	function (a, b) {
		return {$: 34, a: a, b: b};
	});
var $author$project$Remote$ResponseMsg$AggregateSubAccountWorkersInfo = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Types$BrokerSessionStatus$BrokerAuthenticating = {$: 1};
var $author$project$Remote$ResponseMsg$BrokerLogin = function (a) {
	return {$: 27, a: a};
};
var $author$project$Remote$ResponseMsg$BrokerLogout = function (a) {
	return {$: 28, a: a};
};
var $author$project$Remote$ResponseMsg$BrokerMiners = function (a) {
	return {$: 29, a: a};
};
var $author$project$Remote$ResponseMsg$CheckAuth = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Remote$ResponseMsg$CreateApiToken = function (a) {
	return {$: 40, a: a};
};
var $author$project$Remote$ResponseMsg$CreateSubAccount = function (a) {
	return {$: 22, a: a};
};
var $author$project$Remote$UpdateRequest$DELETE = 3;
var $author$project$Remote$ResponseMsg$FetchApiTokens = function (a) {
	return {$: 39, a: a};
};
var $author$project$Remote$ResponseMsg$FetchPermissions = function (a) {
	return {$: 26, a: a};
};
var $author$project$Remote$ResponseMsg$FetchSubAccountSummary = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Remote$ResponseMsg$ForgotPassword = function (a) {
	return {$: 7, a: a};
};
var $author$project$Remote$UpdateRequest$GET = 0;
var $author$project$Remote$ResponseMsg$GeneratedBTC = function (a) {
	return {$: 30, a: a};
};
var $author$project$Remote$ResponseMsg$Logout = function (a) {
	return {$: 1, a: a};
};
var $author$project$Remote$UpdateRequest$POST = 1;
var $author$project$Remote$UpdateRequest$PUT = 2;
var $author$project$Remote$ResponseMsg$PayoutLinkAddresses = function (a) {
	return {$: 37, a: a};
};
var $author$project$Remote$RequestMsg$PayoutTransactions = function (a) {
	return {$: 25, a: a};
};
var $author$project$Remote$ResponseMsg$PayoutTransactions = F2(
	function (a, b) {
		return {$: 38, a: a, b: b};
	});
var $author$project$Types$PplnsProjection$PplnsLoading = {$: 1};
var $author$project$Kernel$Aspect$Remote$RemoteModel$PreventExact = {$: 0};
var $author$project$Kernel$Aspect$Remote$RemoteModel$PreventIfMatches = function (a) {
	return {$: 1, a: a};
};
var $author$project$Remote$ResponseMsg$Report = function (a) {
	return {$: 18, a: a};
};
var $author$project$Remote$ResponseMsg$ResendEmailVerification = function (a) {
	return {$: 5, a: a};
};
var $author$project$UI$Library$Chart$Msg$Reset = {$: 8};
var $author$project$Remote$ResponseMsg$ResetPassword = function (a) {
	return {$: 8, a: a};
};
var $author$project$Remote$ResponseMsg$RetrieveSubAccount = function (a) {
	return {$: 24, a: a};
};
var $author$project$Remote$ResponseMsg$RevokeApiToken = F2(
	function (a, b) {
		return {$: 41, a: a, b: b};
	});
var $author$project$Remote$ResponseMsg$SignIn = function (a) {
	return {$: 0, a: a};
};
var $author$project$Remote$ResponseMsg$SubAccountLogin = function (a) {
	return {$: 9, a: a};
};
var $author$project$Remote$ResponseMsg$UpdateBitcoinAddress = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Remote$ResponseMsg$UpdateSubAccount = function (a) {
	return {$: 23, a: a};
};
var $author$project$Types$UserSessionStatus$UserAuthenticating = {$: 1};
var $author$project$Remote$ResponseMsg$UserHashrate = function (a) {
	return {$: 10, a: a};
};
var $author$project$Remote$ResponseMsg$UserHashrateHistorical = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Remote$ResponseMsg$UserPplnsProjection = function (a) {
	return {$: 32, a: a};
};
var $author$project$Remote$ResponseMsg$VerifyEmail = function (a) {
	return {$: 4, a: a};
};
var $author$project$Remote$ResponseMsg$WatcherFees = function (a) {
	return {$: 36, a: a};
};
var $author$project$Remote$ResponseMsg$WatcherGeneratedBTC = function (a) {
	return {$: 31, a: a};
};
var $author$project$Remote$ResponseMsg$WatcherHashrate = function (a) {
	return {$: 13, a: a};
};
var $author$project$Remote$ResponseMsg$WatcherHashrateHistorical = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Remote$ResponseMsg$WatcherPplnsProjection = function (a) {
	return {$: 33, a: a};
};
var $author$project$Remote$ResponseMsg$WatcherShareStats = function (a) {
	return {$: 35, a: a};
};
var $author$project$Remote$ResponseMsg$WatcherWorkersInfo = function (a) {
	return {$: 20, a: a};
};
var $author$project$Remote$ResponseMsg$WorkersInfo = function (a) {
	return {$: 19, a: a};
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$String$trim = _String_trim;
var $author$project$Types$ApiToken$recoverableToken = function (key) {
	return A2(
		$elm$core$Maybe$andThen,
		function (secret) {
			return ($elm$core$String$isEmpty(
				$elm$core$String$trim(secret)) || A2($elm$core$String$startsWith, 'sha256:', secret)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				{c1: key.c1, mu: key.mu, oK: key.oK, g_: secret, g4: key.g4});
		},
		key.g_);
};
var $author$project$Types$ApiToken$EarningsRead = 2;
var $author$project$Types$ApiToken$HashrateRead = 0;
var $author$project$Types$ApiToken$tokenHasScope = F2(
	function (scope, token) {
		return A2($elm$core$List$member, scope, token.oK);
	});
var $author$project$Types$ApiToken$tokenHasExactlyScopes = F2(
	function (requiredScopes, token) {
		return _Utils_eq(
			$elm$core$List$length(token.oK),
			$elm$core$List$length(requiredScopes)) && A2(
			$elm$core$List$all,
			function (scope) {
				return A2($author$project$Types$ApiToken$tokenHasScope, scope, token);
			},
			requiredScopes);
	});
var $author$project$Types$ApiToken$tokenMatchesAggregateRequirement = F2(
	function (requirement, token) {
		switch (requirement) {
			case 0:
				return A2(
					$author$project$Types$ApiToken$tokenHasExactlyScopes,
					_List_fromArray(
						[0]),
					token);
			case 1:
				return A2(
					$author$project$Types$ApiToken$tokenHasExactlyScopes,
					_List_fromArray(
						[2]),
					token);
			default:
				return A2(
					$author$project$Types$ApiToken$tokenHasExactlyScopes,
					_List_fromArray(
						[0, 2]),
					token);
		}
	});
var $author$project$Types$ApiToken$aggregateEligibleTokens = F2(
	function (time, requirement) {
		return $elm$core$List$filter(
			function (key) {
				return (!_Utils_eq(
					$author$project$Types$ApiToken$recoverableToken(key),
					$elm$core$Maybe$Nothing)) && (A2($author$project$Types$ApiToken$tokenMatchesAggregateRequirement, requirement, key) && A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						function (expiry) {
							return _Utils_cmp(
								$elm$time$Time$posixToMillis(expiry),
								$elm$time$Time$posixToMillis(time)) > 0;
						},
						key.c1)));
			});
	});
var $author$project$Types$ApiToken$ApiToken = function (id) {
	return function (userId) {
		return function (tokenPrefix) {
			return function (ownerEmail) {
				return function (ownerFirstName) {
					return function (scopes) {
						return function (createdAt) {
							return function (expiresAt) {
								return function (lastUsedAt) {
									return function (token) {
										return {lq: createdAt, c1: expiresAt, mu: id, mX: lastUsedAt, nL: ownerEmail, nM: ownerFirstName, oK: scopes, g_: token, pz: tokenPrefix, g4: userId};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString = function (p) {
	switch (p.$) {
		case 0:
			var s = p.a;
			return 'expecting \'' + (s + '\'');
		case 1:
			return 'expecting int';
		case 2:
			return 'expecting hex';
		case 3:
			return 'expecting octal';
		case 4:
			return 'expecting binary';
		case 5:
			return 'expecting float';
		case 6:
			return 'expecting number';
		case 7:
			return 'expecting variable';
		case 8:
			var s = p.a;
			return 'expecting symbol \'' + (s + '\'');
		case 9:
			var s = p.a;
			return 'expecting keyword \'' + (s + '\'');
		case 10:
			return 'expecting end';
		case 11:
			return 'unexpected char';
		case 12:
			var s = p.a;
			return 'problem ' + s;
		default:
			return 'bad repeat';
	}
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString = function (deadend) {
	return $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString(deadend.n5) + (' at row ' + ($elm$core$String$fromInt(deadend.oG) + (', col ' + $elm$core$String$fromInt(deadend.hB))));
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString = function (deadEnds) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$intersperse,
			'; ',
			A2($elm$core$List$map, $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString, deadEnds)));
};
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$core$Basics$round = _Basics_round;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 1) {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$map8 = _Json_map8;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Types$ApiToken$FeesRead = 4;
var $author$project$Types$ApiToken$RejectsRead = 3;
var $author$project$Types$ApiToken$WorkersRead = 1;
var $author$project$Types$ApiToken$scopeFromWire = function (raw) {
	switch (raw) {
		case 'hashrate_read':
			return $elm$core$Maybe$Just(0);
		case 'workers_read':
			return $elm$core$Maybe$Just(1);
		case 'earnings_read':
			return $elm$core$Maybe$Just(2);
		case 'rejects_read':
			return $elm$core$Maybe$Just(3);
		case 'fees_read':
			return $elm$core$Maybe$Just(4);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$ApiToken$scopeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (raw) {
		var _v0 = $author$project$Types$ApiToken$scopeFromWire(raw);
		if (!_v0.$) {
			var s = _v0.a;
			return $elm$json$Json$Decode$succeed(s);
		} else {
			return $elm$json$Json$Decode$fail('unknown api_token_scope: ' + raw);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$ApiToken$apiTokenDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (build) {
		return A3(
			$elm$json$Json$Decode$map2,
			build,
			A2(
				$elm$json$Json$Decode$field,
				'last_used_at',
				$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$field,
						'token',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
						$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
					])));
	},
	A9(
		$elm$json$Json$Decode$map8,
		F8(
			function (id, userId, tokenPrefix, ownerEmail, ownerFirstName, scopes, createdAt, expiresAt) {
				return A8($author$project$Types$ApiToken$ApiToken, id, userId, tokenPrefix, ownerEmail, ownerFirstName, scopes, createdAt, expiresAt);
			}),
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'user_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'token_prefix', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'owner_email', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$field,
			'owner_first_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
		A2(
			$elm$json$Json$Decode$field,
			'scopes',
			$elm$json$Json$Decode$list($author$project$Types$ApiToken$scopeDecoder)),
		A2($elm$json$Json$Decode$field, 'created_at', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
		A2(
			$elm$json$Json$Decode$field,
			'expires_at',
			$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder))));
var $author$project$Types$ApiToken$apiTokenListDecoder = $elm$json$Json$Decode$list($author$project$Types$ApiToken$apiTokenDecoder);
var $author$project$Remote$Model$areAllWorkersLoaded = function (remote) {
	return (!_Utils_eq(remote.bJ, $elm$core$Maybe$Nothing)) && ((!remote.eM) && _Utils_eq(remote.eL, $elm$core$Maybe$Nothing));
};
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$Types$ApiToken$permissionCount = function (token) {
	return $elm$core$List$length(token.oK);
};
var $author$project$Types$ApiToken$bestPerUser = function (tokens) {
	return $elm$core$Dict$values(
		A3(
			$elm$core$List$foldl,
			function (token) {
				return A2(
					$elm$core$Dict$update,
					token.g4,
					function (current) {
						return $elm$core$Maybe$Just(
							function () {
								if (!current.$) {
									var existing = current.a;
									return (_Utils_cmp(
										$author$project$Types$ApiToken$permissionCount(token),
										$author$project$Types$ApiToken$permissionCount(existing)) > 0) ? token : existing;
								} else {
									return token;
								}
							}());
					});
			},
			$elm$core$Dict$empty,
			tokens));
};
var $author$project$Remote$UpdateRequest$brokerLoginEncoder = function (_v0) {
	var email = _v0.ff;
	var password = _v0.cy;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(email)),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(password))
			]));
};
var $author$project$Types$Broker$BrokerMiner = F5(
	function (id, name, hashrate, total_work, broker_fee) {
		return {k$: broker_fee, d1: hashrate, mu: id, aJ: name, pI: total_work};
	});
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Types$Broker$brokerMinerDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Types$Broker$BrokerMiner,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'hashrate', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'total_work', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'broker_fee', $elm$json$Json$Decode$float));
var $author$project$Types$Broker$BrokerSession = F3(
	function (id, email, referenceCode) {
		return {ff: email, mu: id, oc: referenceCode};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Types$Broker$brokerSessionDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Types$Broker$BrokerSession,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'referenceCode', $elm$json$Json$Decode$string));
var $author$project$TopMsg$chartMsg = A2($elm$core$Basics$composeL, $author$project$Kernel$Msg$AppMsg, $author$project$Msg$ChartMsg);
var $author$project$Remote$Model$cleanUpRemote = function (remote) {
	var initRemote = A6($author$project$Remote$Model$initialRemote, remote.eb, remote.ln, remote.pU, $author$project$Types$UserSessionStatus$Unauthenticated, $author$project$Types$BrokerSessionStatus$BrokerUnauthenticated, remote.g4);
	return _Utils_update(
		initRemote,
		{C: remote.C, bD: remote.bD + 1});
};
var $author$project$Types$ApiToken$scopeToWire = function (scope) {
	switch (scope) {
		case 0:
			return 'hashrate_read';
		case 1:
			return 'workers_read';
		case 2:
			return 'earnings_read';
		case 3:
			return 'rejects_read';
		default:
			return 'fees_read';
	}
};
var $author$project$Types$ApiToken$scopeEncoder = A2($elm$core$Basics$composeR, $author$project$Types$ApiToken$scopeToWire, $elm$json$Json$Encode$string);
var $author$project$Types$ApiToken$createApiTokenRequestEncoder = function (req) {
	var base = _List_fromArray(
		[
			_Utils_Tuple2(
			'target_user_id',
			$elm$json$Json$Encode$string(req.j7)),
			_Utils_Tuple2(
			'scopes',
			A2($elm$json$Json$Encode$list, $author$project$Types$ApiToken$scopeEncoder, req.oK))
		]);
	var withExpiry = function () {
		var _v0 = req.lY;
		if (!_v0.$) {
			var secs = _v0.a;
			return _Utils_ap(
				base,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'expires_at',
						$elm$json$Json$Encode$int(secs))
					]));
		} else {
			return base;
		}
	}();
	return $elm$json$Json$Encode$object(withExpiry);
};
var $author$project$Types$ApiToken$CreateApiTokenResponse = F5(
	function (id, userId, scopes, expiresAt, token) {
		return {c1: expiresAt, mu: id, oK: scopes, g_: token, g4: userId};
	});
var $author$project$Types$ApiToken$createApiTokenResponseDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Types$ApiToken$CreateApiTokenResponse,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'user_id', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'scopes',
		$elm$json$Json$Decode$list($author$project$Types$ApiToken$scopeDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'expires_at',
		$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)),
	A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string));
var $author$project$Types$Permissions$Permissions = F3(
	function (editBtcAddress, createSubAccount, viewSubAccounts) {
		return {lp: createSubAccount, lS: editBtcAddress, p_: viewSubAccounts};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Types$Permissions$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'view_sub_accounts',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'create_sub_account',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'edit_btc_address',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Types$Permissions$Permissions))));
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Types$UserSession$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bitcoin_addresses',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$bool),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fpps_token',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(''),
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'token',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'selling_hash_rate',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'two_factor_secret',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'active',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'language',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'email',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed(
										F9(
											function (id, email, language, active, twoFactorSecret, sellingHashRate, token, fpps_token, bitcoinAddresses) {
												var activeBitcoinAddress = A2(
													$elm$core$Maybe$map,
													$elm$core$Tuple$first,
													$elm$core$List$head(
														A2(
															$elm$core$List$filter,
															function (_v0) {
																var isActive = _v0.b;
																return isActive;
															},
															$elm$core$Dict$toList(bitcoinAddresses))));
												return {kD: active, hl: activeBitcoinAddress, ff: email, l8: fpps_token, mu: id, mQ: 0, mS: language, oN: sellingHashRate, g_: token, g0: twoFactorSecret};
											})))))))))));
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $author$project$Types$GeneratedBTC$GeneratedBTC = F6(
	function (entry_day, btc_generated, fpps_btc_generated, hashrate, sub_account, sub_account_id) {
		return {hs: btc_generated, h0: entry_day, fn: fpps_btc_generated, d1: hashrate, o4: sub_account, o5: sub_account_id};
	});
var $author$project$Types$GeneratedBTC$decodeSubAccountName = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'sub_account',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$field,
			'sub_account_name',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$field,
			'subaccount',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$field,
			'name',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)),
			$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
		]));
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Types$GeneratedBTC$decoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Types$GeneratedBTC$GeneratedBTC,
	A2($elm$json$Json$Decode$field, 'entry_day', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'btc_generated',
		A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$float)),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$field,
			'fpps_btc_generated',
			A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$float))),
	A2($elm$json$Json$Decode$field, 'hashrate', $elm$json$Json$Decode$float),
	$author$project$Types$GeneratedBTC$decodeSubAccountName,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'sub_account_id',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)),
				A2(
				$elm$json$Json$Decode$field,
				'sub_account_id',
				A2(
					$elm$json$Json$Decode$map,
					A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$core$Maybe$Just),
					$elm$json$Json$Decode$int)),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			])));
var $author$project$Types$PplnsProjection$PplnsProjection = function (subaccountId) {
	return function (calculatedAt) {
		return function (sourceSnapshotAt) {
			return function (sourceBlockHeight) {
				return function (lastPoolBlockHeight) {
					return function (poolWorkSinceLastBlock) {
						return function (syntheticFillDifficulty) {
							return function (networkDifficulty) {
								return function (blockSubsidySats) {
									return function (modelVersion) {
										return function (earnedHistoryCompleteFromDay) {
											return function (dailyWork) {
												return function (horizons) {
													return {kV: blockSubsidySats, k2: calculatedAt, lt: dailyWork, lQ: earnedHistoryCompleteFromDay, fz: horizons, mW: lastPoolBlockHeight, iY: modelVersion, nr: networkDifficulty, nW: poolWorkSinceLastBlock, oX: sourceBlockHeight, oY: sourceSnapshotAt, j3: subaccountId, pa: syntheticFillDifficulty};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$PplnsProjection$PplnsProjectionDailyWork = F6(
	function (workDay, retainedDifficulty, projectedNetSats, alreadyEarnedNetSats, totalNetSats, earnedHistoryComplete) {
		return {kH: alreadyEarnedNetSats, lP: earnedHistoryComplete, n6: projectedNetSats, jB: retainedDifficulty, kd: totalNetSats, p8: workDay};
	});
var $author$project$Types$PplnsProjection$dailyWorkDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Types$PplnsProjection$PplnsProjectionDailyWork,
	A2($elm$json$Json$Decode$field, 'work_day', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'retained_difficulty', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'projected_net_sats', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'already_earned_net_sats', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'total_net_sats', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'earned_history_complete', $elm$json$Json$Decode$bool));
var $author$project$Types$PplnsProjection$PplnsProjectionHorizon = F8(
	function (horizon, retainedDifficulty, totalModeledWindowDifficulty, difficultyScore, grossSubsidySats, poolFee, brokerFee, netSats) {
		return {k_: brokerFee, lL: difficultyScore, mf: grossSubsidySats, fy: horizon, nq: netSats, nV: poolFee, jB: retainedDifficulty, pH: totalModeledWindowDifficulty};
	});
var $author$project$Types$PplnsProjection$horizonDecoder = A9(
	$elm$json$Json$Decode$map8,
	$author$project$Types$PplnsProjection$PplnsProjectionHorizon,
	A2($elm$json$Json$Decode$field, 'horizon', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'retained_difficulty', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'total_modeled_window_difficulty', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'difficulty_score', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'gross_subsidy_sats', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'pool_fee', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'broker_fee', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'net_sats', $elm$json$Json$Decode$int));
var $author$project$Types$PplnsProjection$rawDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'horizons',
	$elm$json$Json$Decode$list($author$project$Types$PplnsProjection$horizonDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'daily_work',
		$elm$json$Json$Decode$list($author$project$Types$PplnsProjection$dailyWorkDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'earned_history_complete_from_day',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'model_version',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'block_subsidy_sats',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'network_difficulty',
						$elm$json$Json$Decode$float,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'synthetic_fill_difficulty',
							$elm$json$Json$Decode$float,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'pool_work_since_last_block',
								$elm$json$Json$Decode$float,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'last_pool_block_height',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'source_block_height',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'source_snapshot_at',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'calculated_at',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'subaccount_id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Types$PplnsProjection$PplnsProjection))))))))))))));
var $author$project$Types$PplnsProjection$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (projection) {
		return (!A2(
			$elm$core$List$member,
			projection.iY,
			_List_fromArray(
				[3, 4]))) ? $elm$json$Json$Decode$fail('Unsupported PPLNS projection model') : ((!_Utils_eq(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.fy;
				},
				projection.fz),
			A2($elm$core$List$range, 0, 8))) ? $elm$json$Json$Decode$fail('Invalid PPLNS projection horizons') : $elm$json$Json$Decode$succeed(projection));
	},
	$author$project$Types$PplnsProjection$rawDecoder);
var $author$project$Types$Hashrate$EH = 6;
var $author$project$Types$Hashrate$GH = 3;
var $author$project$Types$Hashrate$H = 0;
var $author$project$Types$Hashrate$KH = 1;
var $author$project$Types$Hashrate$MH = 2;
var $author$project$Types$Hashrate$PH = 5;
var $author$project$Types$Hashrate$TH = 4;
var $author$project$Types$Hashrate$rawHashrateToHashrate = function (hashrate) {
	var teraHash = 1.0e12;
	var petaHash = 1.0e15;
	var megaHash = 1.0e6;
	var kiloHash = 1.0e3;
	var gigaHash = 1.0e9;
	var exaHash = 1.0e18;
	var _v0 = (_Utils_cmp(hashrate, exaHash) > -1) ? _Utils_Tuple2(hashrate / exaHash, 6) : ((_Utils_cmp(hashrate, petaHash) > -1) ? _Utils_Tuple2(hashrate / petaHash, 5) : ((_Utils_cmp(hashrate, teraHash) > -1) ? _Utils_Tuple2(hashrate / teraHash, 4) : ((_Utils_cmp(hashrate, gigaHash) > -1) ? _Utils_Tuple2(hashrate / gigaHash, 3) : ((_Utils_cmp(hashrate, megaHash) > -1) ? _Utils_Tuple2(hashrate / megaHash, 2) : ((_Utils_cmp(hashrate, kiloHash) > -1) ? _Utils_Tuple2(hashrate / kiloHash, 1) : _Utils_Tuple2(hashrate, 0))))));
	var adjusted = _v0.a;
	var unit = _v0.b;
	return {cz: adjusted, cL: unit};
};
var $author$project$Types$BTC$toSatoshis = function (_v0) {
	var value = _v0;
	return $elm$core$Basics$round(value * 100000000);
};
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$Types$BTC$trimTrailingZeros = function (value) {
	trimTrailingZeros:
	while (true) {
		if (A2($elm$core$String$endsWith, '0', value)) {
			var $temp$value = A2($elm$core$String$dropRight, 1, value);
			value = $temp$value;
			continue trimTrailingZeros;
		} else {
			return value;
		}
	}
};
var $author$project$Types$BTC$toString = function (_v0) {
	var value = _v0;
	var sign = (value < 0) ? '-' : '';
	if ((!(!value)) && ($elm$core$Basics$abs(value) < 0.00000001)) {
		var fractional = $author$project$Types$BTC$trimTrailingZeros(
			A3(
				$elm$core$String$padLeft,
				17,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$round(
						$elm$core$Basics$abs(value) * 1.0e17))));
		return $elm$core$String$isEmpty(fractional) ? '0' : (sign + ('0.' + fractional));
	} else {
		var satoshis = $elm$core$Basics$abs(
			$author$project$Types$BTC$toSatoshis(value));
		var whole = (satoshis / 100000000) | 0;
		var fractional = $author$project$Types$BTC$trimTrailingZeros(
			A3(
				$elm$core$String$padLeft,
				8,
				'0',
				$elm$core$String$fromInt(
					A2($elm$core$Basics$modBy, 100000000, satoshis))));
		return $elm$core$String$isEmpty(fractional) ? _Utils_ap(
			sign,
			$elm$core$String$fromInt(whole)) : (sign + ($elm$core$String$fromInt(whole) + ('.' + fractional)));
	}
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $author$project$Types$Hashrate$toTwoDigitString = function (number) {
	var rounded = $elm$core$String$fromFloat(
		$elm$core$Basics$round(number * 100) / 100);
	if (A2($elm$core$String$contains, '.', rounded)) {
		var _v0 = A2($elm$core$String$split, '.', rounded);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var intPart = _v0.a;
			var _v1 = _v0.b;
			var fracPart = _v1.a;
			return intPart + ('.' + A3($elm$core$String$padRight, 2, '0', fracPart));
		} else {
			return rounded;
		}
	} else {
		return rounded;
	}
};
var $author$project$Types$Hashrate$unitToString = function (unit) {
	switch (unit) {
		case 0:
			return 'H/s';
		case 1:
			return 'KH/s';
		case 2:
			return 'MH/s';
		case 3:
			return 'GH/s';
		case 4:
			return 'TH/s';
		case 5:
			return 'PH/s';
		default:
			return 'EH/s';
	}
};
var $author$project$Types$Hashrate$toString = function (_v0) {
	var quantity = _v0.cz;
	var unit = _v0.cL;
	return $author$project$Types$Hashrate$toTwoDigitString(quantity) + (' ' + $author$project$Types$Hashrate$unitToString(unit));
};
var $author$project$Types$GeneratedBTC$generatedBTCToCsvRow = function (_v0) {
	var entry_day = _v0.h0;
	var btc_generated = _v0.hs;
	var hashrate = _v0.d1;
	return A2(
		$elm$core$String$join,
		',',
		_List_fromArray(
			[
				entry_day,
				$author$project$Types$Hashrate$toString(
				$author$project$Types$Hashrate$rawHashrateToHashrate(hashrate)),
				$author$project$Types$BTC$toString(btc_generated)
			]));
};
var $author$project$Types$GeneratedBTC$generatedBTCsToCsv = function (entries) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$cons,
			'entry_day,hashrate,btc_generated',
			A2($elm$core$List$map, $author$project$Types$GeneratedBTC$generatedBTCToCsvRow, entries)));
};
var $elm$file$File$Download$string = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(_File_download, name, mime, content));
	});
var $author$project$Types$GeneratedBTC$downloadGeneratedBTCCsv = F2(
	function (filename, entries) {
		return A3(
			$elm$file$File$Download$string,
			filename,
			'text/csv',
			$author$project$Types$GeneratedBTC$generatedBTCsToCsv(entries));
	});
var $author$project$Types$Payout$kindToString = function (kind) {
	if (!kind) {
		return 'pplns';
	} else {
		return 'fpps';
	}
};
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Types$Payout$payoutToCsvRow = function (payout) {
	return A2(
		$elm$core$String$join,
		',',
		_List_fromArray(
			[
				$author$project$UI$Util$formatPosix(payout.b5),
				$elm$core$String$toUpper(
				$author$project$Types$Payout$kindToString(payout.iJ)),
				$author$project$Types$BTC$toString(payout.dG),
				payout.kk,
				payout.dr
			]));
};
var $author$project$Types$Payout$payoutsToCsv = function (payouts) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$cons,
			'timestamp,kind,amount_btc,txid,to',
			A2($elm$core$List$map, $author$project$Types$Payout$payoutToCsvRow, payouts)));
};
var $author$project$Types$Payout$downloadPayoutsCsv = F2(
	function (filename, payouts) {
		return A3(
			$elm$file$File$Download$string,
			filename,
			'text/csv',
			$author$project$Types$Payout$payoutsToCsv(payouts));
	});
var $author$project$Types$Worker$displayHashrate = function (worker) {
	var _v0 = worker.fN;
	if (!_v0.$) {
		if (_v0.a) {
			var _v1 = worker.ii;
			if (!_v1.$) {
				var hashrate = _v1.a;
				return $elm$core$Maybe$Just(hashrate);
			} else {
				return worker.d1;
			}
		} else {
			var _v2 = worker.d1;
			if (!_v2.$) {
				var hashrate = _v2.a;
				return $elm$core$Maybe$Just(hashrate);
			} else {
				return worker.ii;
			}
		}
	} else {
		var _v3 = worker.d1;
		if (!_v3.$) {
			var hashrate = _v3.a;
			return $elm$core$Maybe$Just(hashrate);
		} else {
			return worker.ii;
		}
	}
};
var $author$project$Types$Worker$displayHashrateOrZero = function (worker) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$author$project$Types$Worker$displayHashrate(worker));
};
var $author$project$Types$Worker$formatHashrate = function (hashrate) {
	return $author$project$Types$Hashrate$toString(
		$author$project$Types$Hashrate$rawHashrateToHashrate(hashrate));
};
var $author$project$Types$Worker$rejectedShares = function (worker) {
	var _v0 = worker.jp;
	if (!_v0.$) {
		var shares = _v0.a;
		return $elm$core$Maybe$Just(shares);
	} else {
		return worker.ij;
	}
};
var $author$project$Types$Worker$totalShares = function (worker) {
	var _v0 = worker.ke;
	if (!_v0.$) {
		var shares = _v0.a;
		return $elm$core$Maybe$Just(shares);
	} else {
		return worker.ik;
	}
};
var $author$project$Types$Worker$workerKind = function (worker) {
	var _v0 = worker.fN;
	if (!_v0.$) {
		if (_v0.a) {
			return 'fpps';
		} else {
			return 'pplns';
		}
	} else {
		var _v1 = _Utils_Tuple2(worker.d1, worker.ii);
		if ((_v1.a.$ === 1) && (!_v1.b.$)) {
			var _v2 = _v1.a;
			return 'fpps';
		} else {
			return 'pplns';
		}
	}
};
var $author$project$Types$Worker$workerInfoToCsvRow = function (worker) {
	return A2(
		$elm$core$String$join,
		',',
		_List_fromArray(
			[
				worker.aJ,
				$author$project$Types$Worker$workerKind(worker),
				$author$project$Types$Worker$formatHashrate(
				$author$project$Types$Worker$displayHashrateOrZero(worker)),
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					$author$project$Types$Worker$totalShares(worker))),
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					$author$project$Types$Worker$rejectedShares(worker))),
				worker.iG ? 'true' : 'false',
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$UI$Util$formatPosix, worker.hJ))
			]));
};
var $author$project$Types$Worker$workerInfosToCsv = function (workers) {
	var header = 'name,kind,hashrate,total_shares,rejected_shares,is_connected,connected_at';
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$cons,
			header,
			A2($elm$core$List$map, $author$project$Types$Worker$workerInfoToCsvRow, workers)));
};
var $author$project$Types$Worker$downloadWorkersCsv = function (workers) {
	return A3(
		$elm$file$File$Download$string,
		'workers_report.csv',
		'text/csv',
		$author$project$Types$Worker$workerInfosToCsv(workers));
};
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $author$project$Types$SubAccountSummary$SubAccountFees = F2(
	function (poolFee, brokerFee) {
		return {k_: brokerFee, nV: poolFee};
	});
var $author$project$Types$SubAccountSummary$feesDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$SubAccountSummary$SubAccountFees,
	A2($elm$json$Json$Decode$field, 'pool_fee', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'broker_fee', $elm$json$Json$Decode$float));
var $author$project$Types$GeneratedBTC$filterByDateRange = F3(
	function (from, to, entries) {
		return A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.h0;
			},
			A2(
				$elm$core$List$filter,
				function (e) {
					return (_Utils_cmp(e.h0, from) > -1) && (_Utils_cmp(e.h0, to) < 1);
				},
				entries));
	});
var $author$project$Types$Payout$filterByDateRange = F3(
	function (from, to, payouts) {
		return A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.b5;
				},
				$elm$time$Time$posixToMillis),
			A2(
				$elm$core$List$filter,
				function (payout) {
					var date = $author$project$Types$Payout$payoutDate(payout);
					return (_Utils_cmp(date, from) > -1) && (_Utils_cmp(date, to) < 1);
				},
				payouts));
	});
var $author$project$Types$Payout$filterLastDays = F3(
	function (days, now, payouts) {
		var fromDate = $author$project$UI$Util$currentDateString(
			$elm$time$Time$millisToPosix(
				function (millis) {
					return millis - ((((A2($elm$core$Basics$max, 0, days - 1) * 24) * 60) * 60) * 1000);
				}(
					$elm$time$Time$posixToMillis(now))));
		return A3(
			$author$project$Types$Payout$filterByDateRange,
			fromDate,
			$author$project$UI$Util$currentDateString(now),
			payouts);
	});
var $author$project$Remote$UpdateRequest$monthToInt = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $author$project$Remote$UpdateRequest$formatWorkersTimestamp = function (timestamp) {
	var zone = $elm$time$Time$utc;
	var year = $elm$core$String$fromInt(
		A2($elm$time$Time$toYear, zone, timestamp));
	var second = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$time$Time$toSecond, zone, timestamp)));
	var month = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			$author$project$Remote$UpdateRequest$monthToInt(
				A2($elm$time$Time$toMonth, zone, timestamp))));
	var minute = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$time$Time$toMinute, zone, timestamp)));
	var hour = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$time$Time$toHour, zone, timestamp)));
	var day = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$time$Time$toDay, zone, timestamp)));
	return year + ('-' + (month + ('-' + (day + ('T' + (hour + (':' + (minute + (':' + (second + 'Z'))))))))));
};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Types$Payout$initialQuery = F2(
	function (generation, context) {
		return {kC: _List_Nil, hK: context, hO: $elm$core$Maybe$Nothing, mc: generation, eJ: $elm$core$Maybe$Nothing};
	});
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Remote$UpdateRequest$loginEncoder = function (_v0) {
	var email = _v0.ff;
	var password = _v0.cy;
	var totpToken = _v0.g$;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(email)),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(password)),
				_Utils_Tuple2(
				'totp_token',
				$elm$core$String$isEmpty(totpToken) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(totpToken)),
				_Utils_Tuple2(
				'language',
				$elm$json$Json$Encode$string('En'))
			]));
};
var $author$project$Remote$Model$markWatcherAccess = F3(
	function (resource, access, remote) {
		var watcherAccess = remote.az;
		var updatedAccess = function () {
			switch (resource) {
				case 0:
					return _Utils_update(
						watcherAccess,
						{d1: access});
				case 1:
					return _Utils_update(
						watcherAccess,
						{bJ: access});
				case 2:
					return _Utils_update(
						watcherAccess,
						{mb: access});
				case 3:
					return _Utils_update(
						watcherAccess,
						{em: access});
				case 4:
					return _Utils_update(
						watcherAccess,
						{eu: access});
				default:
					return _Utils_update(
						watcherAccess,
						{d_: access});
			}
		}();
		return _Utils_update(
			remote,
			{az: updatedAccess});
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Remote$UpdateRequest$methodToString = function (method) {
	switch (method) {
		case 0:
			return 'GET';
		case 1:
			return 'POST';
		case 2:
			return 'PUT';
		default:
			return 'DELETE';
	}
};
var $author$project$Types$ApiToken$aggregateApiKeyRequirementToWire = function (requirement) {
	switch (requirement) {
		case 0:
			return 'hashrate';
		case 1:
			return 'generated_btc';
		default:
			return 'generated_btc_hashrate';
	}
};
var $author$project$Remote$UpdateRequest$multiWatcherLinkForTokens = F3(
	function (frontendOrigin, requirement, tokens) {
		var pairSegments = A2(
			$elm$core$String$join,
			'/',
			A2(
				$elm$core$List$concatMap,
				function (token) {
					return _List_fromArray(
						[
							$elm$url$Url$percentEncode(token.g4),
							$elm$url$Url$percentEncode(token.g_)
						]);
				},
				tokens));
		return frontendOrigin + ('/login/multiwatcher#requirement=' + ($author$project$Types$ApiToken$aggregateApiKeyRequirementToWire(requirement) + ('&sessions=' + $elm$url$Url$percentEncode(pairSegments))));
	});
var $author$project$Types$Payout$PayoutAddressResponse = F2(
	function (fppsAddress, pplnsAddress) {
		return {l5: fppsAddress, n_: pplnsAddress};
	});
var $author$project$Types$Payout$payoutAddressResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$Payout$PayoutAddressResponse,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'fpps_payout_address', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'fpps_address', $elm$json$Json$Decode$string)
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'pplns_payout_address', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'pplns_address', $elm$json$Json$Decode$string)
			])));
var $author$project$Types$Payout$payoutEndpoint = function (query) {
	var window = function () {
		var _v1 = query.eJ;
		if (!_v1.$) {
			var _v2 = _v1.a;
			var from = _v2.a;
			var to = _v2.b;
			return '&from=' + ($elm$url$Url$percentEncode(from) + ('&to=' + $elm$url$Url$percentEncode(to)));
		} else {
			return '';
		}
	}();
	var path = function () {
		var _v0 = query.hK;
		if (!_v0.$) {
			var userId = _v0.a;
			var includeSubAccounts = _v0.b;
			return includeSubAccounts ? 'v1/user/payouts' : ('v1/user/sub_account/' + ($elm$url$Url$percentEncode(userId) + '/payouts'));
		} else {
			var userId = _v0.a;
			return 'v1/user/sub_account/' + ($elm$url$Url$percentEncode(userId) + '/payouts');
		}
	}();
	var cursor = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (value) {
				return '&cursor=' + $elm$url$Url$percentEncode(value);
			},
			query.hO));
	return path + ('?limit=100' + (window + cursor));
};
var $author$project$Types$Payout$PayoutPage = F4(
	function (payouts, nextCursor, from, to) {
		return {c6: from, bB: nextCursor, ek: payouts, dr: to};
	});
var $author$project$Types$Payout$PayoutRecord = F5(
	function (txid, to, amount, kind, timestamp) {
		return {dG: amount, iJ: kind, b5: timestamp, dr: to, kk: txid};
	});
var $author$project$Types$BTC$fromSatoshis = function (satoshis) {
	return satoshis / 100000000;
};
var $author$project$Types$Payout$FPPS = 1;
var $author$project$Types$Payout$PPLNS = 0;
var $author$project$Types$Payout$payoutKindDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (kind) {
		switch (kind) {
			case 'fpps':
				return $elm$json$Json$Decode$succeed(1);
			case 'pplns':
				return $elm$json$Json$Decode$succeed(0);
			default:
				return $elm$json$Json$Decode$fail('Unknown payout kind: ' + kind);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$DecodeUtil$unixTimestamp = A2(
	$elm$json$Json$Decode$map,
	$elm$time$Time$millisToPosix,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$mul(1000),
		$elm$json$Json$Decode$int));
var $author$project$Types$Payout$payoutRecordDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Types$Payout$PayoutRecord,
	A2($elm$json$Json$Decode$field, 'txid', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Types$BTC$fromSatoshis,
		A2($elm$json$Json$Decode$field, 'amount_sats', $elm$json$Json$Decode$int)),
	A2($elm$json$Json$Decode$field, 'kind', $author$project$Types$Payout$payoutKindDecoder),
	A2($elm$json$Json$Decode$field, 'confirmed_at', $author$project$Types$DecodeUtil$unixTimestamp));
var $author$project$Types$Payout$payoutPageDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Types$Payout$PayoutPage,
	A2(
		$elm$json$Json$Decode$field,
		'payouts',
		$elm$json$Json$Decode$list($author$project$Types$Payout$payoutRecordDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'next_cursor',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'from', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'to', $elm$json$Json$Decode$string));
var $author$project$TopMsg$remoteMsg = A2($elm$core$Basics$composeL, $author$project$Kernel$Msg$AppMsg, $author$project$Msg$RemoteMsg);
var $author$project$Types$Report$ReportRecord = F2(
	function (activity, shares) {
		return {dE: activity, jO: shares};
	});
var $author$project$Types$Report$Activity = F3(
	function (worker_name, timestamp, activity) {
		return {dE: activity, b5: timestamp, eK: worker_name};
	});
var $author$project$Types$Report$activityDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Types$Report$Activity,
	A2($elm$json$Json$Decode$field, 'worker_name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'timestamp', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'activity', $elm$json$Json$Decode$string));
var $author$project$Types$Report$Share = F3(
	function (difficulty, rejection_reason, worker_name) {
		return {e9: difficulty, jq: rejection_reason, eK: worker_name};
	});
var $author$project$Types$Report$sharesDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Types$Report$Share,
	A2(
		$elm$json$Json$Decode$field,
		'difficulty',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float)),
	A2(
		$elm$json$Json$Decode$field,
		'rejection_reason',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'worker_name', $elm$json$Json$Decode$string));
var $author$project$Types$Report$reportDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$Report$ReportRecord,
	A2(
		$elm$json$Json$Decode$field,
		'activity',
		$elm$json$Json$Decode$list($author$project$Types$Report$activityDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'shares',
		$elm$json$Json$Decode$list($author$project$Types$Report$sharesDecoder)));
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$riskyTask = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{kG: true, hn: r.hn, cn: r.jz, it: r.it, f: r.f, j8: r.j8, kf: $elm$core$Maybe$Nothing, ba: r.ba});
};
var $author$project$Remote$UpdateRequest$sessionResponseResult = F4(
	function (endpoint, decoder, errorDecoder, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err('Bad url: ' + url);
			case 1:
				return $elm$core$Result$Err('Timeout');
			case 2:
				return $elm$core$Result$Err('Network error');
			case 3:
				var statusCode = response.a.j0;
				var body = response.b;
				if ((endpoint === 'logout') && (statusCode === 401)) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, '{}'));
				} else {
					var _v1 = A2($elm$json$Json$Decode$decodeString, errorDecoder.e, body);
					if (!_v1.$) {
						var decodedError = _v1.a;
						return $elm$core$Result$Err(
							errorDecoder.b7(decodedError));
					} else {
						var error = _v1.a;
						var _v2 = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$string, body);
						if (!_v2.$) {
							var errorString = _v2.a;
							return $elm$core$Result$Err(errorString);
						} else {
							return $elm$core$Result$Err(
								'Bad Status: ' + ($elm$core$String$fromInt(statusCode) + (' ' + $elm$json$Json$Decode$errorToString(error))));
						}
					}
				}
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$json$Json$Decode$errorToString,
					A2(
						$elm$json$Json$Decode$decodeString,
						decoder,
						$elm$core$String$isEmpty(body) ? '{}' : body));
		}
	});
var $author$project$Types$SubAccountSummary$ShareStats = F7(
	function (windowHours, pplnsAccepted, pplnsRejected, fppsAccepted, fppsRejected, accepted, rejected) {
		return {kB: accepted, l4: fppsAccepted, l7: fppsRejected, nZ: pplnsAccepted, n0: pplnsRejected, od: rejected, p5: windowHours};
	});
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$Types$SubAccountSummary$shareStatsDecoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Types$SubAccountSummary$ShareStats,
	A2($elm$json$Json$Decode$field, 'window_hours', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'pplns_accepted', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'pplns_rejected', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'fpps_accepted', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'fpps_rejected', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'accepted', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'rejected', $elm$json$Json$Decode$int));
var $author$project$Kernel$Aspect$Browser$OpenNewTab$storeWatcherSession = _Platform_outgoingPort('storeWatcherSession', $elm$json$Json$Encode$string);
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $author$project$Types$SubAccount$SubAccount = F6(
	function (sub_account, bitcoin_address, id, token, fpps_token, hashrate) {
		return {kU: bitcoin_address, l8: fpps_token, d1: hashrate, mu: id, o4: sub_account, g_: token};
	});
var $author$project$Types$SubAccount$subAccountDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Types$SubAccount$SubAccount,
	A2($elm$json$Json$Decode$field, 'sub_account', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$map,
		function (addresses) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$first,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (_v0) {
								var isActive = _v0.b;
								return isActive;
							},
							$elm$core$Dict$toList(addresses)))));
		},
		A2(
			$elm$json$Json$Decode$field,
			'bitcoin_addresses',
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$bool))),
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'fpps_token',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(''),
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))),
	A2($elm$json$Json$Decode$field, 'hashrate', $elm$json$Json$Decode$string));
var $author$project$Remote$UpdateRequest$subAccountLoginEncoder = function (_v0) {
	var currentUserToken = _v0.e4;
	var subAccountToken = _v0.gN;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'owner_token',
				$elm$json$Json$Encode$string(currentUserToken)),
				_Utils_Tuple2(
				'subaccount_token',
				$elm$json$Json$Encode$string(subAccountToken))
			]));
};
var $author$project$Types$SubAccountSummary$SubAccountSummary = F5(
	function (subAccountId, hashrate, shareStats, fees, todayGeneratedBtc) {
		return {d_: fees, d1: hashrate, eu: shareStats, o3: subAccountId, px: todayGeneratedBtc};
	});
var $author$project$Types$User$UserHashrate = F4(
	function (observed_at, pplns_hashrate, fpps_hashrate, total_hashrate) {
		return {ii: fpps_hashrate, ny: observed_at, n1: pplns_hashrate, ay: total_hashrate};
	});
var $author$project$Types$User$scaledHashrateToRaw = F2(
	function (value, unit) {
		switch (unit) {
			case 'H/s':
				return value;
			case 'KH/s':
				return value * 1.0e3;
			case 'MH/s':
				return value * 1.0e6;
			case 'GH/s':
				return value * 1.0e9;
			case 'TH/s':
				return value * 1.0e12;
			case 'PH/s':
				return value * 1.0e15;
			case 'EH/s':
				return value * 1.0e18;
			default:
				return value;
		}
	});
var $author$project$Types$User$scaledHashrateDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$User$scaledHashrateToRaw,
	A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'unit', $elm$json$Json$Decode$string));
var $author$project$Types$User$hashrateFieldDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$elm$json$Json$Decode$float, $author$project$Types$User$scaledHashrateDecoder]));
var $author$project$Types$User$daysFromCivil = F3(
	function (year, month, day) {
		var monthPrime = (month > 2) ? (month - 3) : (month + 9);
		var dayOfYear = (((((153 * monthPrime) + 2) / 5) | 0) + day) - 1;
		var adjustedYear = (month <= 2) ? (year - 1) : year;
		var era = (adjustedYear / 400) | 0;
		var yearOfEra = adjustedYear - (era * 400);
		var dayOfEra = (((yearOfEra * 365) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0)) + dayOfYear;
		return ((era * 146097) + dayOfEra) - 719468;
	});
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $author$project$Types$User$parseDatePart = function (datePart) {
	var _v0 = A2($elm$core$String$split, '-', datePart);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var yearPart = _v0.a;
		var _v1 = _v0.b;
		var monthPart = _v1.a;
		var _v2 = _v1.b;
		var dayPart = _v2.a;
		return A4(
			$elm$core$Maybe$map3,
			F3(
				function (year, month, day) {
					return _Utils_Tuple3(year, month, day);
				}),
			$elm$core$String$toInt(yearPart),
			$elm$core$String$toInt(monthPart),
			$elm$core$String$toInt(dayPart));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$User$parseOffsetPart = function (offsetPart) {
	var _v0 = A2($elm$core$String$split, ':', offsetPart);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var hourPart = _v0.a;
		var _v1 = _v0.b;
		var minutePart = _v1.a;
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (hour, minute) {
					return (((hour * 60) + minute) * 60) * 1000;
				}),
			$elm$core$String$toInt(hourPart),
			$elm$core$String$toInt(minutePart));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$User$parseSecondPart = function (secondPart) {
	var _v0 = A2($elm$core$String$split, '.', secondPart);
	if (_v0.b) {
		if (!_v0.b.b) {
			var wholeSeconds = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				function (seconds) {
					return _Utils_Tuple2(seconds, 0);
				},
				$elm$core$String$toInt(wholeSeconds));
		} else {
			var wholeSeconds = _v0.a;
			var _v1 = _v0.b;
			var fractionalPart = _v1.a;
			var _v2 = $elm$core$String$toInt(wholeSeconds);
			if (!_v2.$) {
				var seconds = _v2.a;
				var paddedFraction = A3(
					$elm$core$String$padRight,
					3,
					'0',
					A2($elm$core$String$left, 3, fractionalPart));
				return A2(
					$elm$core$Maybe$map,
					function (millis) {
						return _Utils_Tuple2(seconds, millis);
					},
					$elm$core$String$toInt(paddedFraction));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$User$parseTimePart = function (timePart) {
	var _v0 = A2($elm$core$String$split, ':', timePart);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var hourPart = _v0.a;
		var _v1 = _v0.b;
		var minutePart = _v1.a;
		var _v2 = _v1.b;
		var secondPart = _v2.a;
		var _v3 = $author$project$Types$User$parseSecondPart(secondPart);
		if (!_v3.$) {
			var _v4 = _v3.a;
			var second = _v4.a;
			var millis = _v4.b;
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (hour, minute) {
						return {mr: hour, bl: millis, nh: minute, jI: second};
					}),
				$elm$core$String$toInt(hourPart),
				$elm$core$String$toInt(minutePart));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$User$parseTimeAndOffset = function (timeAndOffsetPart) {
	var withOffset = F3(
		function (sign, timePart, offsetPart) {
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (_v4, offsetMillis) {
						var hour = _v4.mr;
						var minute = _v4.nh;
						var second = _v4.jI;
						var millis = _v4.bl;
						return {mr: hour, bl: millis, nh: minute, df: sign * offsetMillis, jI: second};
					}),
				$author$project$Types$User$parseTimePart(timePart),
				$author$project$Types$User$parseOffsetPart(offsetPart));
		});
	if (A2($elm$core$String$endsWith, 'Z', timeAndOffsetPart)) {
		return A2(
			$elm$core$Maybe$map,
			function (parsedTime) {
				return {mr: parsedTime.mr, bl: parsedTime.bl, nh: parsedTime.nh, df: 0, jI: parsedTime.jI};
			},
			$author$project$Types$User$parseTimePart(
				A2($elm$core$String$dropRight, 1, timeAndOffsetPart)));
	} else {
		if (A2($elm$core$String$contains, '+', timeAndOffsetPart)) {
			var _v0 = A2($elm$core$String$split, '+', timeAndOffsetPart);
			if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
				var timePart = _v0.a;
				var _v1 = _v0.b;
				var offsetPart = _v1.a;
				return A3(withOffset, 1, timePart, offsetPart);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			var _v2 = A2($elm$core$String$split, '-', timeAndOffsetPart);
			if ((_v2.b && _v2.b.b) && (!_v2.b.b.b)) {
				var timePart = _v2.a;
				var _v3 = _v2.b;
				var offsetPart = _v3.a;
				return A3(withOffset, -1, timePart, offsetPart);
			} else {
				return A2(
					$elm$core$Maybe$map,
					function (parsedTime) {
						return {mr: parsedTime.mr, bl: parsedTime.bl, nh: parsedTime.nh, df: 0, jI: parsedTime.jI};
					},
					$author$project$Types$User$parseTimePart(timeAndOffsetPart));
			}
		}
	}
};
var $author$project$Types$User$rfc3339ToPosix = function (timestamp) {
	var _v0 = A2($elm$core$String$split, 'T', timestamp);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var datePart = _v0.a;
		var _v1 = _v0.b;
		var timeAndOffsetPart = _v1.a;
		var _v2 = _Utils_Tuple2(
			$author$project$Types$User$parseDatePart(datePart),
			$author$project$Types$User$parseTimeAndOffset(timeAndOffsetPart));
		if ((!_v2.a.$) && (!_v2.b.$)) {
			var _v3 = _v2.a.a;
			var year = _v3.a;
			var month = _v3.b;
			var day = _v3.c;
			var hour = _v2.b.a.mr;
			var minute = _v2.b.a.nh;
			var second = _v2.b.a.jI;
			var millis = _v2.b.a.bl;
			var offsetMillis = _v2.b.a.df;
			var epochDays = A3($author$project$Types$User$daysFromCivil, year, month, day);
			var epochMillis = ((((((((epochDays * 24) + hour) * 60) + minute) * 60) + second) * 1000) + millis) - offsetMillis;
			return $elm$core$Maybe$Just(
				$elm$time$Time$millisToPosix(epochMillis));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$User$posixDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		var _v0 = $author$project$Types$User$rfc3339ToPosix(value);
		if (!_v0.$) {
			var observedAt = _v0.a;
			return $elm$json$Json$Decode$succeed(observedAt);
		} else {
			return $elm$json$Json$Decode$fail('Invalid RFC3339 timestamp: ' + value);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$User$optionalObservedAtDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'observed_at',
			$elm$json$Json$Decode$nullable($author$project$Types$User$posixDecoder)),
			$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$Types$User$userHashrateDecode = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Types$User$UserHashrate,
	$author$project$Types$User$optionalObservedAtDecoder,
	A2($elm$json$Json$Decode$field, 'pplns_hashrate', $author$project$Types$User$hashrateFieldDecoder),
	A2($elm$json$Json$Decode$field, 'fpps_hashrate', $author$project$Types$User$hashrateFieldDecoder),
	A2($elm$json$Json$Decode$field, 'total_hashrate', $author$project$Types$User$hashrateFieldDecoder));
var $author$project$Types$SubAccountSummary$subAccountSummaryDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Types$SubAccountSummary$SubAccountSummary,
	A2($elm$json$Json$Decode$field, 'sub_account_id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'hashrate', $author$project$Types$User$userHashrateDecode),
	A2($elm$json$Json$Decode$field, 'share_stats', $author$project$Types$SubAccountSummary$shareStatsDecoder),
	A2($elm$json$Json$Decode$field, 'fees', $author$project$Types$SubAccountSummary$feesDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'today_generated_btc',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float)));
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{kG: false, hn: r.hn, cn: r.jz, it: r.it, f: r.f, j8: r.j8, kf: $elm$core$Maybe$Nothing, ba: r.ba});
};
var $author$project$Kernel$Aspect$Remote$RemoteModel$PendingAuthentication = function (a) {
	return {$: 2, a: a};
};
var $author$project$Kernel$Aspect$Remote$RemoteModel$addAndSendRequest = function (cfg) {
	var status = cfg.D;
	var cmd = cfg.a0;
	var requestConfig = cfg.bo;
	var requestParams = cfg.bp;
	var state = requestConfig.aX;
	var newPendingRequest = {a$: requestParams.a$, as: requestParams.as, aM: requestConfig.R, aW: requestParams.aW, D: cfg.D};
	var updatedStateWithOngoingRequests = _Utils_update(
		state,
		{
			C: _Utils_ap(
				state.C,
				_List_fromArray(
					[newPendingRequest]))
		});
	var updatedState = function () {
		var _v0 = requestParams.al;
		if (_v0.$ === 1) {
			return updatedStateWithOngoingRequests;
		} else {
			var mapState = _v0.a;
			return mapState(updatedStateWithOngoingRequests);
		}
	}();
	return _Utils_Tuple3(updatedState, cmd, _List_Nil);
};
var $author$project$Kernel$Aspect$Remote$RemoteModel$anyRequestPendingAuthentication = function (ongoingRequests) {
	return A2(
		$elm$core$List$any,
		function (savedReq) {
			var _v0 = savedReq.D;
			if (_v0.$ === 2) {
				return true;
			} else {
				return false;
			}
		},
		ongoingRequests);
};
var $author$project$Kernel$Aspect$Remote$RemoteModel$isRequestOngoing = function (cfg) {
	var state = cfg.aX;
	return A2(
		$elm$core$List$member,
		cfg.R,
		A2(
			$elm$core$List$map,
			function ($) {
				return $.aM;
			},
			state.C));
};
var $elm_community$maybe_extra$Maybe$Extra$withDefaultLazy = F2(
	function (_default, m) {
		if (m.$ === 1) {
			return _default(0);
		} else {
			var a = m.a;
			return a;
		}
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$create_sendAuthenticatedEndlessListRequest = F2(
	function (cfg, params) {
		var state = cfg.aX;
		var toAccessToken = cfg.gX;
		var fetcher = function (maybeNextPagePointer) {
			return params.d$(maybeNextPagePointer);
		};
		var maybeToCmd = function () {
			var _v3 = params.dW;
			if (!_v3.$) {
				var el = _v3.a;
				var _v4 = el.D;
				switch (_v4.$) {
					case 0:
						return $elm$core$Maybe$Just(
							fetcher($elm$core$Maybe$Nothing));
					case 1:
						var nextPagePointer = _v4.a;
						return $elm$core$Maybe$Just(
							fetcher(
								$elm$core$Maybe$Just(nextPagePointer)));
					default:
						return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Just(
					fetcher($elm$core$Maybe$Nothing));
			}
		}();
		var handleMakeRequest = function (token) {
			if (!maybeToCmd.$) {
				var toCmd = maybeToCmd.a;
				return $author$project$Kernel$Aspect$Remote$RemoteModel$addAndSendRequest(
					{
						a0: toCmd(token),
						bo: cfg,
						bp: {a$: false, al: params.al, as: $elm$core$Maybe$Nothing, aW: $elm$core$Maybe$Nothing},
						D: $author$project$Kernel$Aspect$Remote$RemoteModel$PendingResponseAuthenticated(toCmd)
					});
			} else {
				return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		};
		var handleStoreRequest = function (_v1) {
			if (!maybeToCmd.$) {
				var toCmd = maybeToCmd.a;
				return $author$project$Kernel$Aspect$Remote$RemoteModel$addAndSendRequest(
					{
						a0: $elm$core$Platform$Cmd$none,
						bo: cfg,
						bp: {a$: false, al: params.al, as: $elm$core$Maybe$Nothing, aW: $elm$core$Maybe$Nothing},
						D: $author$project$Kernel$Aspect$Remote$RemoteModel$PendingAuthentication(toCmd)
					});
			} else {
				return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		};
		return $author$project$Kernel$Aspect$Remote$RemoteModel$isRequestOngoing(cfg) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : ($author$project$Kernel$Aspect$Remote$RemoteModel$anyRequestPendingAuthentication(state.C) ? handleStoreRequest(0) : A2(
			$elm_community$maybe_extra$Maybe$Extra$withDefaultLazy,
			handleStoreRequest,
			A2(
				$elm$core$Maybe$map,
				handleMakeRequest,
				toAccessToken(state))));
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$requestExists = F3(
	function (requestMsg, remote, comparator) {
		return $elm_community$maybe_extra$Maybe$Extra$isJust(
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.aM;
					},
					comparator(requestMsg)),
				remote.C));
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$exactRequestExists = F2(
	function (requestMsg, remote) {
		return A3($author$project$Kernel$Aspect$Remote$RemoteModel$requestExists, requestMsg, remote, $elm$core$Basics$eq);
	});
var $elm_community$list_extra$List$Extra$updateIf = F3(
	function (predicate, update, list) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return predicate(item) ? update(item) : item;
			},
			list);
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$replacePendingAuthRequest = function (_v0) {
	var requestMatcher = _v0.jx;
	var status = _v0.D;
	var requestConfig = _v0.bo;
	var requestParams = _v0.bp;
	var state = requestConfig.aX;
	var newPendingRequest = {a$: requestParams.a$, as: requestParams.as, aM: requestConfig.R, aW: requestParams.aW, D: status};
	var updatedOngoingRequests = A3(
		$elm_community$list_extra$List$Extra$updateIf,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.aM;
			},
			requestMatcher(requestConfig.R)),
		$elm$core$Basics$always(newPendingRequest),
		state.C);
	var updatedStateWithOngoingRequests = _Utils_update(
		state,
		{C: updatedOngoingRequests});
	var updatedState = function () {
		var _v1 = requestParams.al;
		if (_v1.$ === 1) {
			return updatedStateWithOngoingRequests;
		} else {
			var mapState = _v1.a;
			return mapState(updatedStateWithOngoingRequests);
		}
	}();
	return _Utils_Tuple3(updatedState, $elm$core$Platform$Cmd$none, _List_Nil);
};
var $author$project$Kernel$Aspect$Remote$RemoteModel$create_sendAuthenticatedRequest = F2(
	function (cfg, params) {
		var state = cfg.aX;
		var toAccessToken = cfg.gX;
		var handleStoreRequest = function (_v2) {
			var storeTheRequest = $author$project$Kernel$Aspect$Remote$RemoteModel$addAndSendRequest(
				{
					a0: $elm$core$Platform$Cmd$none,
					bo: cfg,
					bp: params,
					D: $author$project$Kernel$Aspect$Remote$RemoteModel$PendingAuthentication(params.ds)
				});
			var _v1 = params.cV;
			switch (_v1.$) {
				case 0:
					return A2($author$project$Kernel$Aspect$Remote$RemoteModel$exactRequestExists, cfg.R, state) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : storeTheRequest;
				case 1:
					var comparator = _v1.a;
					return A3($author$project$Kernel$Aspect$Remote$RemoteModel$requestExists, cfg.R, state, comparator) ? $author$project$Kernel$Aspect$Remote$RemoteModel$replacePendingAuthRequest(
						{
							bo: cfg,
							jx: comparator,
							bp: params,
							D: $author$project$Kernel$Aspect$Remote$RemoteModel$PendingAuthentication(params.ds)
						}) : storeTheRequest;
				default:
					return A2($author$project$Kernel$Aspect$Remote$RemoteModel$exactRequestExists, cfg.R, state) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : storeTheRequest;
			}
		};
		var handleMakeRequest = function (token) {
			var makeTheRequest = $author$project$Kernel$Aspect$Remote$RemoteModel$addAndSendRequest(
				{
					a0: params.ds(token),
					bo: cfg,
					bp: params,
					D: $author$project$Kernel$Aspect$Remote$RemoteModel$PendingResponseAuthenticated(params.ds)
				});
			var _v0 = params.cV;
			switch (_v0.$) {
				case 0:
					return A2($author$project$Kernel$Aspect$Remote$RemoteModel$exactRequestExists, cfg.R, state) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : makeTheRequest;
				case 1:
					var comparator = _v0.a;
					return A3($author$project$Kernel$Aspect$Remote$RemoteModel$requestExists, cfg.R, state, comparator) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : makeTheRequest;
				default:
					return makeTheRequest;
			}
		};
		return $author$project$Kernel$Aspect$Remote$RemoteModel$anyRequestPendingAuthentication(state.C) ? handleStoreRequest(0) : A2(
			$elm_community$maybe_extra$Maybe$Extra$withDefaultLazy,
			handleStoreRequest,
			A2(
				$elm$core$Maybe$map,
				handleMakeRequest,
				toAccessToken(state)));
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$PendingResponseUnauthenticated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Kernel$Aspect$Remote$RemoteModel$create_sendEndlessListRequest = F2(
	function (cfg, params) {
		var state = cfg.aX;
		var fetcher = function (maybeNextPagePointer) {
			return params.d$(maybeNextPagePointer);
		};
		var cmd = function () {
			var _v0 = params.dW.D;
			switch (_v0.$) {
				case 0:
					return fetcher($elm$core$Maybe$Nothing);
				case 1:
					var nextPagePointer = _v0.a;
					return fetcher(
						$elm$core$Maybe$Just(nextPagePointer));
				default:
					return $elm$core$Platform$Cmd$none;
			}
		}();
		return $author$project$Kernel$Aspect$Remote$RemoteModel$isRequestOngoing(cfg) ? _Utils_Tuple3(state, cmd, _List_Nil) : $author$project$Kernel$Aspect$Remote$RemoteModel$addAndSendRequest(
			{
				a0: cmd,
				bo: cfg,
				bp: {a$: false, al: params.al, as: $elm$core$Maybe$Nothing, aW: $elm$core$Maybe$Nothing},
				D: $author$project$Kernel$Aspect$Remote$RemoteModel$PendingResponseUnauthenticated(cmd)
			});
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$create_sendRequest = F2(
	function (cfg, params) {
		var state = cfg.aX;
		var makeTheRequest = $author$project$Kernel$Aspect$Remote$RemoteModel$addAndSendRequest(
			{
				a0: params.a0,
				bo: cfg,
				bp: params,
				D: $author$project$Kernel$Aspect$Remote$RemoteModel$PendingResponseUnauthenticated(params.a0)
			});
		var _v0 = params.cV;
		switch (_v0.$) {
			case 0:
				return A2($author$project$Kernel$Aspect$Remote$RemoteModel$exactRequestExists, cfg.R, state) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : makeTheRequest;
			case 1:
				var comparator = _v0.a;
				return A3($author$project$Kernel$Aspect$Remote$RemoteModel$requestExists, cfg.R, state, comparator) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : makeTheRequest;
			default:
				return makeTheRequest;
		}
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$toRequestHelpers = function (cfg) {
	return {
		oP: $author$project$Kernel$Aspect$Remote$RemoteModel$create_sendAuthenticatedEndlessListRequest(cfg),
		oQ: $author$project$Kernel$Aspect$Remote$RemoteModel$create_sendAuthenticatedRequest(cfg),
		oR: $author$project$Kernel$Aspect$Remote$RemoteModel$create_sendEndlessListRequest(cfg),
		oS: $author$project$Kernel$Aspect$Remote$RemoteModel$create_sendRequest(cfg)
	};
};
var $author$project$Remote$Model$WrappedRemote = $elm$core$Basics$identity;
var $author$project$Remote$Model$transformRevertStateToWrapped = F3(
	function (transform, correlationId, wrappedRemote) {
		var remote = wrappedRemote;
		return A2(transform, correlationId, remote);
	});
var $author$project$Types$User$UserHashrateHistoryPoint = F4(
	function (observed_at, pplns_hashrate, fpps_hashrate, total_hashrate) {
		return {ii: fpps_hashrate, ny: observed_at, n1: pplns_hashrate, ay: total_hashrate};
	});
var $author$project$Types$User$userHashrateHistoryPointDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Types$User$UserHashrateHistoryPoint,
	A2($elm$json$Json$Decode$field, 'observed_at', $author$project$Types$User$posixDecoder),
	A2($elm$json$Json$Decode$field, 'pplns_hashrate', $author$project$Types$User$hashrateFieldDecoder),
	A2($elm$json$Json$Decode$field, 'fpps_hashrate', $author$project$Types$User$hashrateFieldDecoder),
	A2($elm$json$Json$Decode$field, 'total_hashrate', $author$project$Types$User$hashrateFieldDecoder));
var $author$project$Remote$Model$WatcherAccessAllowed = 1;
var $author$project$Remote$Model$watcherCanViewPayouts = function (remote) {
	return $author$project$Remote$Model$watcherHasPayoutInfo(remote) && (remote.az.mb === 1);
};
var $author$project$UI$Library$AccountData$aggregateSubAccountWorkers = function (remote) {
	return A2(
		$elm$core$List$concatMap,
		function (subAccount) {
			return A2(
				$elm$core$List$map,
				function (worker) {
					return _Utils_update(
						worker,
						{aJ: subAccount.o4 + ('/' + worker.aJ)});
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, subAccount.mu, remote.eR)));
		},
		A2($elm$core$Maybe$withDefault, _List_Nil, remote.ex));
};
var $author$project$UI$Library$AccountData$mainWorkersForAggregate = function (remote) {
	var _v0 = remote.bJ;
	if (!_v0.$) {
		var workers = _v0.a;
		return $elm$core$Maybe$Just(workers);
	} else {
		var _v1 = $author$project$Remote$Model$toUserSession(remote);
		if (!_v1.$) {
			var userSession = _v1.a;
			return $elm$core$String$isEmpty(userSession.g_) ? $elm$core$Maybe$Just(_List_Nil) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$UI$Library$AccountData$workersForScope = F2(
	function (scope, remote) {
		if (A2($author$project$UI$Library$AccountData$scopeIsAggregate, scope, remote)) {
			var _v0 = _Utils_Tuple3(
				remote.gO,
				$author$project$UI$Library$AccountData$mainWorkersForAggregate(remote),
				remote.ex);
			if (!_v0.a) {
				return $elm$core$Maybe$Nothing;
			} else {
				if ((!_v0.b.$) && (!_v0.c.$)) {
					var mainWorkers = _v0.b.a;
					var subAccounts = _v0.c.a;
					return A2($author$project$UI$Library$AccountData$currentSubAccountsHaveEntries, subAccounts, remote.eR) ? $elm$core$Maybe$Just(
						_Utils_ap(
							mainWorkers,
							$author$project$UI$Library$AccountData$aggregateSubAccountWorkers(remote))) : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		} else {
			return remote.bJ;
		}
	});
var $author$project$Types$Worker$WorkersPage = F2(
	function (workers, nextCursor) {
		return {bB: nextCursor, bJ: workers};
	});
var $author$project$Types$Worker$WorkerInfo = function (name) {
	return function (hashrate) {
		return function (total_shares) {
			return function (rejected_shares) {
				return function (is_connected) {
					return function (connected_at) {
						return function (fpps_hashrate) {
							return function (fpps_total_shares) {
								return function (fpps_rejected_shares) {
									return function (is_fpps) {
										return {hJ: connected_at, ii: fpps_hashrate, ij: fpps_rejected_shares, ik: fpps_total_shares, d1: hashrate, iG: is_connected, fN: is_fpps, aJ: name, jp: rejected_shares, ke: total_shares};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Types$Worker$workerInfoDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'is_fpps',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'fpps_rejected_shares',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'fpps_total_shares',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'fpps_hashrate',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'connected_at',
					$elm$json$Json$Decode$nullable(
						A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_connected',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'rejected_shares',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'total_shares',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'hashrate',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Types$Worker$WorkerInfo)))))))))));
var $author$project$Types$Worker$workersPageDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$Worker$WorkersPage,
	A2(
		$elm$json$Json$Decode$field,
		'workers',
		$elm$json$Json$Decode$list($author$project$Types$Worker$workerInfoDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'next_cursor',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$Remote$Model$WorkersPaginationLoadingInitial = 1;
var $author$project$Remote$Model$WorkersPaginationLoadingMore = 2;
var $author$project$Remote$UpdateRequest$workersPaginationStatusFor = function (mode) {
	if (!mode) {
		return 1;
	} else {
		return 2;
	}
};
var $author$project$Remote$UpdateRequest$workersRequestConflict = F2(
	function (left, right) {
		var _v0 = _Utils_Tuple2(left, right);
		_v0$3:
		while (true) {
			switch (_v0.a.$) {
				case 30:
					if (_v0.b.$ === 30) {
						return true;
					} else {
						break _v0$3;
					}
				case 31:
					if (_v0.b.$ === 31) {
						return true;
					} else {
						break _v0$3;
					}
				case 32:
					if (_v0.b.$ === 32) {
						var leftRequest = _v0.a.a;
						var rightRequest = _v0.b.a;
						return _Utils_eq(leftRequest.o3, rightRequest.o3);
					} else {
						break _v0$3;
					}
				default:
					break _v0$3;
			}
		}
		return false;
	});
var $author$project$Remote$UpdateRequest$updateReadyRequest = F4(
	function (requestMsg, global, time, state) {
		var config = global.hG;
		var env = global.h1;
		var helpers = $author$project$Kernel$Aspect$Remote$RemoteModel$toRequestHelpers(
			{
				hg: $author$project$Route$Route$authEntryRoute,
				R: requestMsg,
				aX: state,
				gX: $elm$core$Basics$always($elm$core$Maybe$Nothing)
			});
		var _v1 = config.kI;
		var apiEndpoint = _v1;
		var cmd = function (_v26) {
			var method = _v26.f;
			var endpoint = _v26.g;
			var maybeEncoder = _v26.h;
			var responseMsg = _v26.i;
			var decoder = _v26.e;
			var errorDecoder = _v26.bS;
			var url = apiEndpoint + ('/api/' + endpoint);
			var resolver = $elm$http$Http$stringResolver(
				A3($author$project$Remote$UpdateRequest$sessionResponseResult, endpoint, decoder, errorDecoder));
			var body = function () {
				if (!maybeEncoder.$) {
					var body_ = maybeEncoder.a;
					return $elm$http$Http$jsonBody(body_);
				} else {
					return $elm$http$Http$emptyBody;
				}
			}();
			return A2(
				$elm$core$Task$attempt,
				responseMsg,
				$elm$http$Http$riskyTask(
					{
						hn: body,
						it: _Utils_ap(
							$elm$core$String$isEmpty(state.g4) ? _List_Nil : _List_fromArray(
								[
									A2($elm$http$Http$header, 'X-Account-ID', state.g4)
								]),
							(A2($elm$core$String$startsWith, 'api-tokens', endpoint) && (!$elm$core$String$isEmpty(state.eT))) ? _List_fromArray(
								[
									A2($elm$http$Http$header, 'X-TOTP-Token', state.eT)
								]) : _List_Nil),
						f: $author$project$Remote$UpdateRequest$methodToString(method),
						jz: resolver,
						j8: $elm$core$Maybe$Nothing,
						ba: url
					}));
		};
		var sendRequest = function (_v24) {
			var method = _v24.f;
			var endpoint = _v24.g;
			var maybeEncoder = _v24.h;
			var responseMsg = _v24.i;
			var decoder = _v24.e;
			var mapState = _v24.al;
			var blocksInput = _v24.a$;
			var revertState = _v24.aW;
			return helpers.oS(
				{
					a$: blocksInput,
					a0: cmd(
						{
							e: decoder,
							g: endpoint,
							bS: {
								e: A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
								b7: $elm$core$Basics$identity
							},
							h: maybeEncoder,
							f: method,
							i: responseMsg
						}),
					cV: $author$project$Kernel$Aspect$Remote$RemoteModel$PreventExact,
					al: mapState,
					as: $elm$core$Maybe$Nothing,
					aW: A2($elm$core$Maybe$map, $author$project$Remote$Model$transformRevertStateToWrapped, revertState)
				});
		};
		var publicCmd = F2(
			function (token, _v23) {
				var method = _v23.f;
				var endpoint = _v23.g;
				var maybeEncoder = _v23.h;
				var responseMsg = _v23.i;
				var decoder = _v23.e;
				var errorDecoder = _v23.bS;
				var url = apiEndpoint + ('/api/' + endpoint);
				var resolver = $elm$http$Http$stringResolver(
					function (response) {
						switch (response.$) {
							case 0:
								var url_ = response.a;
								return $elm$core$Result$Err('Bad url: ' + url_);
							case 1:
								return $elm$core$Result$Err('Timeout');
							case 2:
								return $elm$core$Result$Err('Network error');
							case 3:
								var statusCode = response.a.j0;
								var body_ = response.b;
								var _v21 = A2($elm$json$Json$Decode$decodeString, errorDecoder.e, body_);
								if (!_v21.$) {
									var decodedError = _v21.a;
									return $elm$core$Result$Err(
										errorDecoder.b7(decodedError));
								} else {
									var err = _v21.a;
									var _v22 = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$string, body_);
									if (!_v22.$) {
										var errorString = _v22.a;
										return $elm$core$Result$Err(errorString);
									} else {
										return $elm$core$Result$Err(
											'Bad Status: ' + ($elm$core$String$fromInt(statusCode) + (' ' + $elm$json$Json$Decode$errorToString(err))));
									}
								}
							default:
								var body_ = response.b;
								var theBody = $elm$core$String$isEmpty(body_) ? '{}' : body_;
								return A2(
									$elm$core$Result$mapError,
									$elm$json$Json$Decode$errorToString,
									A2($elm$json$Json$Decode$decodeString, decoder, theBody));
						}
					});
				var body = function () {
					if (!maybeEncoder.$) {
						var body_ = maybeEncoder.a;
						return $elm$http$Http$jsonBody(body_);
					} else {
						return $elm$http$Http$emptyBody;
					}
				}();
				return A2(
					$elm$core$Task$attempt,
					responseMsg,
					$elm$http$Http$task(
						{
							hn: body,
							it: _List_fromArray(
								[
									A2($elm$http$Http$header, 'Authorization', 'Bearer ' + token)
								]),
							f: $author$project$Remote$UpdateRequest$methodToString(method),
							jz: resolver,
							j8: $elm$core$Maybe$Nothing,
							ba: url
						}));
			});
		var sendPublicRequest = F2(
			function (token, _v18) {
				var method = _v18.f;
				var endpoint = _v18.g;
				var maybeEncoder = _v18.h;
				var responseMsg = _v18.i;
				var decoder = _v18.e;
				var mapState = _v18.al;
				var blocksInput = _v18.a$;
				var revertState = _v18.aW;
				return helpers.oS(
					{
						a$: blocksInput,
						a0: A2(
							publicCmd,
							token,
							{
								e: decoder,
								g: endpoint,
								bS: {
									e: A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
									b7: $elm$core$Basics$identity
								},
								h: maybeEncoder,
								f: method,
								i: responseMsg
							}),
						cV: $author$project$Kernel$Aspect$Remote$RemoteModel$PreventExact,
						al: mapState,
						as: $elm$core$Maybe$Nothing,
						aW: A2($elm$core$Maybe$map, $author$project$Remote$Model$transformRevertStateToWrapped, revertState)
					});
			});
		switch (requestMsg.$) {
			case 0:
				var email = requestMsg.a.ff;
				var password = requestMsg.a.cy;
				var totpToken = requestMsg.a.g$;
				return sendRequest(
					{
						a$: true,
						e: $author$project$Types$UserSession$decode,
						g: 'log_user',
						al: $elm$core$Maybe$Just(
							function (state_) {
								return _Utils_update(
									state_,
									{pQ: $author$project$Types$UserSessionStatus$UserAuthenticating});
							}),
						h: $elm$core$Maybe$Just(
							$author$project$Remote$UpdateRequest$loginEncoder(
								{ff: email, cy: password, g$: totpToken})),
						f: 1,
						i: $author$project$Remote$ResponseMsg$SignIn,
						aW: $elm$core$Maybe$Just(
							$elm$core$Basics$always(
								function (state_) {
									return _Utils_update(
										state_,
										{pQ: $author$project$Types$UserSessionStatus$Unauthenticated});
								}))
					});
			case 1:
				var userId = requestMsg.a.g4;
				var token = requestMsg.a.g_;
				var watcherSession = {
					g_: $elm$core$String$trim(token),
					g4: $elm$core$String$trim(userId)
				};
				var watcherSessionJson = A2(
					$elm$json$Json$Encode$encode,
					0,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'userId',
								$elm$json$Json$Encode$string(watcherSession.g4)),
								_Utils_Tuple2(
								'token',
								$elm$json$Json$Encode$string(watcherSession.g_))
							])));
				var persistWatcherSession = _Utils_eq(
					state.cc,
					$elm$core$Maybe$Just(watcherSession)) ? $elm$core$Platform$Cmd$none : $author$project$Kernel$Aspect$Browser$OpenNewTab$storeWatcherSession(watcherSessionJson);
				return ($elm$core$String$isEmpty(watcherSession.g4) || $elm$core$String$isEmpty(watcherSession.g_)) ? _Utils_Tuple3(
					state,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A3($author$project$Kernel$RouteMsgs$routeMsg.aQ, $elm$core$Maybe$Nothing, 'Enter an account ID and watcher token', _List_Nil)
						])) : _Utils_Tuple3(
					A2($author$project$Remote$Model$startWatcherSession, watcherSession, state),
					persistWatcherSession,
					_List_fromArray(
						[
							$author$project$TopMsg$chartMsg($author$project$UI$Library$Chart$Msg$Reset),
							$author$project$TopMsg$remoteMsg($author$project$Remote$Msg$OnWatcherAuthSuccess),
							$author$project$Kernel$RouteMsgs$routeMsg.oB($author$project$Route$Route$Home)
						]));
			case 2:
				return $author$project$Remote$Model$isWatcherAuthenticated(state) ? _Utils_Tuple3(
					$author$project$Remote$Model$cleanUpRemote(
						_Utils_update(
							state,
							{g4: ''})),
					A2(
						$elm$core$Task$perform,
						$author$project$Remote$ResponseMsg$Logout,
						$elm$core$Task$succeed(
							$elm$core$Result$Ok(0))),
					_List_Nil) : sendRequest(
					{
						a$: true,
						e: $elm$json$Json$Decode$succeed(0),
						g: 'logout',
						al: $elm$core$Maybe$Nothing,
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 1,
						i: $author$project$Remote$ResponseMsg$Logout,
						aW: $elm$core$Maybe$Nothing
					});
			case 9:
				var currentUserToken = requestMsg.a.e4;
				var subAccountToken = requestMsg.a.gN;
				return sendRequest(
					{
						a$: true,
						e: $author$project$Types$UserSession$decode,
						g: 'log_subaccount',
						al: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Just(
							$author$project$Remote$UpdateRequest$subAccountLoginEncoder(
								{e4: currentUserToken, gN: subAccountToken})),
						f: 1,
						i: $author$project$Remote$ResponseMsg$SubAccountLogin,
						aW: $elm$core$Maybe$Nothing
					});
			case 4:
				var code = requestMsg.a;
				return sendRequest(
					{
						a$: false,
						e: $author$project$Types$UserSession$decode,
						g: 'activate',
						al: $elm$core$Maybe$Nothing,
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Just(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'code',
										$elm$json$Json$Encode$string(code))
									]))),
						f: 2,
						i: $author$project$Remote$ResponseMsg$VerifyEmail,
						aW: $elm$core$Maybe$Nothing
					});
			case 5:
				return sendRequest(
					{
						a$: false,
						e: $elm$json$Json$Decode$succeed(0),
						g: 'resend_code',
						al: $elm$core$Maybe$Nothing,
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$ResendEmailVerification,
						aW: $elm$core$Maybe$Nothing
					});
			case 6:
				var activationCode = requestMsg.a;
				return sendRequest(
					{
						a$: false,
						e: $author$project$Types$UserSession$decode,
						g: 'activate_2fa',
						al: $elm$core$Maybe$Nothing,
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Just(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'token',
										$elm$json$Json$Encode$string(activationCode))
									]))),
						f: 2,
						i: $author$project$Remote$ResponseMsg$Activate2FA,
						aW: $elm$core$Maybe$Nothing
					});
			case 3:
				var checkAuthContext = requestMsg.a;
				return $author$project$Remote$Model$isBrokerAuthenticated(state) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : ((!$author$project$Remote$Model$isUserAuthenticated(state)) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : sendRequest(
					{
						a$: false,
						e: $author$project$Types$UserSession$decode,
						g: 'check_auth',
						al: $elm$core$Maybe$Nothing,
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$CheckAuth(checkAuthContext),
						aW: $elm$core$Maybe$Nothing
					}));
			case 7:
				var email = requestMsg.a.ff;
				var encoder = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'email',
							$elm$json$Json$Encode$string(email))
						]));
				return sendRequest(
					{
						a$: true,
						e: $elm$json$Json$Decode$succeed(0),
						g: 'forgot_password',
						al: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Just(encoder),
						f: 1,
						i: $author$project$Remote$ResponseMsg$ForgotPassword,
						aW: $elm$core$Maybe$Nothing
					});
			case 8:
				var email = requestMsg.a.ff;
				var code = requestMsg.a.lb;
				var two_fa_token = requestMsg.a.pK;
				var newPassword = requestMsg.a.ns;
				var encoder = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'email',
							$elm$json$Json$Encode$string(email)),
							_Utils_Tuple2(
							'code',
							$elm$json$Json$Encode$string(code)),
							_Utils_Tuple2(
							'two_fa_token',
							$elm$json$Json$Encode$string(two_fa_token)),
							_Utils_Tuple2(
							'new_password',
							$elm$json$Json$Encode$string(newPassword))
						]));
				return sendRequest(
					{
						a$: true,
						e: $elm$json$Json$Decode$succeed(0),
						g: 'reset_password',
						al: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Just(encoder),
						f: 1,
						i: $author$project$Remote$ResponseMsg$ResetPassword,
						aW: $elm$core$Maybe$Nothing
					});
			case 10:
				return sendRequest(
					{a$: false, e: $author$project$Types$User$userHashrateDecode, g: 'user/hashrate', al: $elm$core$Maybe$Nothing, as: $elm$core$Maybe$Nothing, h: $elm$core$Maybe$Nothing, f: 0, i: $author$project$Remote$ResponseMsg$UserHashrate, aW: $elm$core$Maybe$Nothing});
			case 12:
				var userId = requestMsg.a.g4;
				var token = requestMsg.a.g_;
				return ($elm$core$String$isEmpty(userId) || $elm$core$String$isEmpty(token)) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : A2(
					sendPublicRequest,
					token,
					{
						a$: false,
						e: $author$project$Types$User$userHashrateDecode,
						g: 'user/sub_account/' + ($elm$url$Url$percentEncode(userId) + '/hashrate'),
						al: $elm$core$Maybe$Nothing,
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$WatcherHashrate,
						aW: $elm$core$Maybe$Nothing
					});
			case 11:
				var range = requestMsg.a;
				return sendRequest(
					{
						a$: false,
						e: $elm$json$Json$Decode$list($author$project$Types$User$userHashrateHistoryPointDecoder),
						g: 'user/hashrate/historical?from=' + ($elm$url$Url$percentEncode(
							$author$project$Remote$UpdateRequest$formatWorkersTimestamp(range.c6)) + ('&to=' + $elm$url$Url$percentEncode(
							$author$project$Remote$UpdateRequest$formatWorkersTimestamp(range.dr)))),
						al: $elm$core$Maybe$Nothing,
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$UserHashrateHistorical(range),
						aW: $elm$core$Maybe$Nothing
					});
			case 13:
				var range = requestMsg.a;
				return ($elm$core$String$isEmpty(range.g4) || $elm$core$String$isEmpty(range.g_)) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : A2(
					sendPublicRequest,
					range.g_,
					{
						a$: false,
						e: $elm$json$Json$Decode$list($author$project$Types$User$userHashrateHistoryPointDecoder),
						g: 'user/sub_account/' + ($elm$url$Url$percentEncode(range.g4) + ('/hashrate/historical?from=' + ($elm$url$Url$percentEncode(
							$author$project$Remote$UpdateRequest$formatWorkersTimestamp(range.c6)) + ('&to=' + $elm$url$Url$percentEncode(
							$author$project$Remote$UpdateRequest$formatWorkersTimestamp(range.dr)))))),
						al: $elm$core$Maybe$Nothing,
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$WatcherHashrateHistorical(
							{c6: range.c6, dr: range.dr}),
						aW: $elm$core$Maybe$Nothing
					});
			case 15:
				return sendRequest(
					{
						a$: false,
						e: $elm$json$Json$Decode$list($author$project$Types$GeneratedBTC$decoder),
						g: 'generated_btc',
						al: $elm$core$Maybe$Just(
							function (current) {
								return _Utils_update(
									current,
									{
										da: $elm$core$Maybe$Just(time)
									});
							}),
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$GeneratedBTC,
						aW: $elm$core$Maybe$Nothing
					});
			case 16:
				var userId = requestMsg.a.g4;
				var token = requestMsg.a.g_;
				return ($elm$core$String$isEmpty(userId) || $elm$core$String$isEmpty(token)) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : A2(
					sendPublicRequest,
					token,
					{
						a$: false,
						e: $elm$json$Json$Decode$list($author$project$Types$GeneratedBTC$decoder),
						g: 'user/sub_account/' + ($elm$url$Url$percentEncode(userId) + '/generated_btc'),
						al: $elm$core$Maybe$Just(
							function (current) {
								return _Utils_update(
									current,
									{
										da: $elm$core$Maybe$Just(time)
									});
							}),
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$WatcherGeneratedBTC,
						aW: $elm$core$Maybe$Nothing
					});
			case 17:
				var userId = requestMsg.a;
				var activeUserId = A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.mu;
						},
						$author$project$Types$User$unwrapUserId),
					$author$project$Remote$Model$toUserSession(state));
				return ($elm$core$String$isEmpty(userId) || (!_Utils_eq(
					activeUserId,
					$elm$core$Maybe$Just(userId)))) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : sendRequest(
					{
						a$: false,
						e: $author$project$Types$PplnsProjection$decoder,
						g: 'user/sub_account/' + ($elm$url$Url$percentEncode(userId) + '/pplns_projection'),
						al: $elm$core$Maybe$Just(
							function (state_) {
								var _v3 = state_.dk;
								if (_v3.$ === 4) {
									return state_;
								} else {
									return _Utils_update(
										state_,
										{dk: $author$project$Types$PplnsProjection$PplnsLoading});
								}
							}),
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$UserPplnsProjection,
						aW: $elm$core$Maybe$Nothing
					});
			case 18:
				var watcherSession = requestMsg.a;
				var userId = watcherSession.g4;
				var token = watcherSession.g_;
				return ($elm$core$String$isEmpty(userId) || ($elm$core$String$isEmpty(token) || ((!_Utils_eq(
					$author$project$Remote$Model$toWatcherSession(state),
					$elm$core$Maybe$Just(watcherSession))) || (!_Utils_eq(
					state.bX,
					_List_fromArray(
						[watcherSession])))))) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : A2(
					sendPublicRequest,
					token,
					{
						a$: false,
						e: $author$project$Types$PplnsProjection$decoder,
						g: 'user/sub_account/' + ($elm$url$Url$percentEncode(userId) + '/pplns_projection'),
						al: $elm$core$Maybe$Just(
							function (state_) {
								var _v4 = state_.dk;
								if (_v4.$ === 4) {
									return state_;
								} else {
									return A3(
										$author$project$Remote$Model$markWatcherAccess,
										3,
										0,
										_Utils_update(
											state_,
											{dk: $author$project$Types$PplnsProjection$PplnsLoading}));
								}
							}),
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$WatcherPplnsProjection,
						aW: $elm$core$Maybe$Nothing
					});
			case 19:
				var userId = requestMsg.a.g4;
				var token = requestMsg.a.g_;
				return ($elm$core$String$isEmpty(userId) || $elm$core$String$isEmpty(token)) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : A2(
					sendPublicRequest,
					token,
					{
						a$: false,
						e: $author$project$Types$SubAccountSummary$shareStatsDecoder,
						g: 'user/sub_account/' + ($elm$url$Url$percentEncode(userId) + '/share_stats?hours=24'),
						al: $elm$core$Maybe$Nothing,
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$WatcherShareStats,
						aW: $elm$core$Maybe$Nothing
					});
			case 20:
				var userId = requestMsg.a.g4;
				var token = requestMsg.a.g_;
				return ($elm$core$String$isEmpty(userId) || $elm$core$String$isEmpty(token)) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : A2(
					sendPublicRequest,
					token,
					{
						a$: false,
						e: $author$project$Types$SubAccountSummary$feesDecoder,
						g: 'user/sub_account/' + ($elm$url$Url$percentEncode(userId) + '/fees'),
						al: $elm$core$Maybe$Nothing,
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$WatcherFees,
						aW: $elm$core$Maybe$Nothing
					});
			case 22:
				return (!global.dD) ? A4($author$project$Remote$UpdateRequest$updateRequest, $author$project$Remote$RequestMsg$FetchPayouts, global, time, state) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
			case 21:
				var _v5 = $author$project$Remote$Model$toUserSession(state);
				if (!_v5.$) {
					var userSession = _v5.a;
					var context = A2(
						$author$project$Types$Payout$UserPayoutContext,
						$author$project$Types$User$unwrapUserId(userSession.mu),
						global.dD === 1);
					var sameContext = _Utils_eq(
						state.nQ,
						$elm$core$Maybe$Just(context));
					if (state.di && _Utils_eq(
						state.nQ,
						$elm$core$Maybe$Just(context))) {
						return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
					} else {
						var generation = state.bD + 1;
						return _Utils_Tuple3(
							_Utils_update(
								state,
								{
									mV: sameContext ? state.mV : $elm$core$Maybe$Nothing,
									nQ: $elm$core$Maybe$Just(context),
									bD: generation,
									ek: sameContext ? state.ek : _List_Nil,
									di: true
								}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$TopMsg$requestMsg(
									$author$project$Remote$RequestMsg$PayoutTransactions(
										A2($author$project$Types$Payout$initialQuery, generation, context)))
								]));
					}
				} else {
					return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 65:
				return sendRequest(
					{a$: false, e: $author$project$Types$Payout$payoutAddressResponseDecoder, g: 'payouts/addresses', al: $elm$core$Maybe$Nothing, as: $elm$core$Maybe$Nothing, h: $elm$core$Maybe$Nothing, f: 0, i: $author$project$Remote$ResponseMsg$PayoutLinkAddresses, aW: $elm$core$Maybe$Nothing});
			case 23:
				var _v6 = $author$project$Remote$Model$toWatcherSession(state);
				if (!_v6.$) {
					var watcherSession = _v6.a;
					return ($author$project$Remote$Model$watcherMayViewPayouts(state) && (!state.di)) ? ((!A2($author$project$Remote$Model$generatedBTCNeedsRefresh, time, state)) ? ($author$project$Remote$Model$watcherCanViewPayouts(state) ? A4($author$project$Remote$UpdateRequest$updateRequest, $author$project$Remote$RequestMsg$LoadWatcherPayouts, global, time, state) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil)) : (A2(
						$author$project$Remote$Model$isRequestAlreadyOngoing,
						state,
						$author$project$Remote$RequestMsg$WatcherGeneratedBTC(watcherSession)) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(
						state,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								$author$project$TopMsg$requestMsg(
								$author$project$Remote$RequestMsg$WatcherGeneratedBTC(watcherSession))
							])))) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 24:
				var _v7 = $author$project$Remote$Model$toWatcherSession(state);
				if (!_v7.$) {
					var watcherSession = _v7.a;
					if ($author$project$Remote$Model$watcherCanViewPayouts(state)) {
						var context = A2($author$project$Types$Payout$WatcherPayoutContext, watcherSession.g4, watcherSession.g_);
						var sameContext = _Utils_eq(
							state.nQ,
							$elm$core$Maybe$Just(context));
						if (state.di && _Utils_eq(
							state.nQ,
							$elm$core$Maybe$Just(context))) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						} else {
							var generation = state.bD + 1;
							var query = A2($author$project$Types$Payout$initialQuery, generation, context);
							return _Utils_Tuple3(
								_Utils_update(
									state,
									{
										mV: sameContext ? state.mV : $elm$core$Maybe$Nothing,
										nQ: $elm$core$Maybe$Just(context),
										bD: generation,
										ek: sameContext ? state.ek : _List_Nil,
										di: true
									}),
								$elm$core$Platform$Cmd$none,
								_List_fromArray(
									[
										$author$project$TopMsg$requestMsg(
										$author$project$Remote$RequestMsg$PayoutTransactions(query))
									]));
						}
					} else {
						return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 25:
				var query = requestMsg.a;
				var send = function () {
					var _v8 = query.hK;
					if (!_v8.$) {
						return sendRequest;
					} else {
						var token = _v8.b;
						return sendPublicRequest(token);
					}
				}();
				return ((!_Utils_eq(query.mc, state.bD)) || (!_Utils_eq(
					state.nQ,
					$elm$core$Maybe$Just(query.hK)))) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : send(
					{
						a$: false,
						e: $author$project$Types$Payout$payoutPageDecoder,
						g: $author$project$Types$Payout$payoutEndpoint(query),
						al: $elm$core$Maybe$Nothing,
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$PayoutTransactions(query),
						aW: $elm$core$Maybe$Nothing
					});
			case 14:
				var secondsHistory = requestMsg.a;
				return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
			case 27:
				var days = requestMsg.a.lB;
				var newState = function () {
					if (!days.$) {
						var d = days.a;
						return _Utils_update(
							state,
							{
								jv: A2(
									$elm$core$Maybe$withDefault,
									state.jv,
									$elm$core$String$toInt(d))
							});
					} else {
						return state;
					}
				}();
				var endpoint = function () {
					if (!days.$) {
						var d = days.a;
						return 'report?days=' + d;
					} else {
						return 'report';
					}
				}();
				return sendRequest(
					{
						a$: false,
						e: $author$project$Types$Report$reportDecoder,
						g: endpoint,
						al: $elm$core$Maybe$Just(
							function (state_) {
								return _Utils_update(
									newState,
									{jv: state_.jv});
							}),
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$Report,
						aW: $elm$core$Maybe$Nothing
					});
			case 28:
				var days = requestMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{jv: days}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 29:
				var posixTime = requestMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{
							iK: $elm$core$Maybe$Just(posixTime)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 26:
				var bitcoinAddress = requestMsg.a.hl;
				var twoFaToken = requestMsg.a.kj;
				var subAccountId = requestMsg.a.o3;
				var encoder = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'bitcoin_address',
							$elm$json$Json$Encode$string(bitcoinAddress)),
							_Utils_Tuple2(
							'two_fa_token',
							$elm$json$Json$Encode$string(twoFaToken)),
							_Utils_Tuple2(
							'sub_account_id',
							function () {
								if (!subAccountId.$) {
									var id = subAccountId.a;
									return $elm$json$Json$Encode$string(id);
								} else {
									return $elm$json$Json$Encode$null;
								}
							}())
						]));
				return sendRequest(
					{
						a$: true,
						e: $elm$json$Json$Decode$succeed(0),
						g: 'bitcoin_address',
						al: $elm$core$Maybe$Nothing,
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Just(encoder),
						f: 1,
						i: $author$project$Remote$ResponseMsg$UpdateBitcoinAddress(bitcoinAddress),
						aW: $elm$core$Maybe$Nothing
					});
			case 30:
				var token = requestMsg.a.g_;
				var limit = requestMsg.a.v;
				var cursor = requestMsg.a.hO;
				var mode = requestMsg.a.iX;
				if (_Utils_eq(
					$author$project$Remote$Model$toUserSession(state),
					$elm$core$Maybe$Nothing)) {
					return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var queryParams = A2(
						$elm$core$String$join,
						'&',
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$core$Maybe$Just(
									'limit=' + $elm$core$String$fromInt(limit)),
									A2(
									$elm$core$Maybe$map,
									function (cursor_) {
										return 'cursor=' + $elm$url$Url$percentEncode(cursor_);
									},
									cursor)
								])));
					var endpoint = 'workers/all?' + queryParams;
					return helpers.oS(
						{
							a$: false,
							a0: cmd(
								{
									e: $author$project$Types$Worker$workersPageDecoder,
									g: endpoint,
									bS: {
										e: A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
										b7: $elm$core$Basics$identity
									},
									h: $elm$core$Maybe$Nothing,
									f: 0,
									i: $author$project$Remote$ResponseMsg$WorkersInfo
								}),
							cV: $author$project$Kernel$Aspect$Remote$RemoteModel$PreventIfMatches($author$project$Remote$UpdateRequest$workersRequestConflict),
							al: $elm$core$Maybe$Just(
								function (state_) {
									return _Utils_update(
										state_,
										{
											eM: $author$project$Remote$UpdateRequest$workersPaginationStatusFor(mode)
										});
								}),
							as: $elm$core$Maybe$Nothing,
							aW: $elm$core$Maybe$Nothing
						});
				}
			case 31:
				var userId = requestMsg.a.g4;
				var token = requestMsg.a.g_;
				var limit = requestMsg.a.v;
				var cursor = requestMsg.a.hO;
				var mode = requestMsg.a.iX;
				if ($elm$core$String$isEmpty(userId) || $elm$core$String$isEmpty(token)) {
					return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var queryParams = A2(
						$elm$core$String$join,
						'&',
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$core$Maybe$Just(
									'limit=' + $elm$core$String$fromInt(limit)),
									A2(
									$elm$core$Maybe$map,
									function (cursor_) {
										return 'cursor=' + $elm$url$Url$percentEncode(cursor_);
									},
									cursor)
								])));
					var endpoint = 'workers/all?' + queryParams;
					return helpers.oS(
						{
							a$: false,
							a0: A2(
								publicCmd,
								token,
								{
									e: $author$project$Types$Worker$workersPageDecoder,
									g: endpoint,
									bS: {
										e: A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
										b7: $elm$core$Basics$identity
									},
									h: $elm$core$Maybe$Nothing,
									f: 0,
									i: $author$project$Remote$ResponseMsg$WatcherWorkersInfo
								}),
							cV: $author$project$Kernel$Aspect$Remote$RemoteModel$PreventIfMatches($author$project$Remote$UpdateRequest$workersRequestConflict),
							al: $elm$core$Maybe$Just(
								function (state_) {
									return _Utils_update(
										state_,
										{
											eM: $author$project$Remote$UpdateRequest$workersPaginationStatusFor(mode)
										});
								}),
							as: $elm$core$Maybe$Nothing,
							aW: $elm$core$Maybe$Nothing
						});
				}
			case 32:
				var subAccountId = requestMsg.a.o3;
				var token = requestMsg.a.g_;
				var limit = requestMsg.a.v;
				var cursor = requestMsg.a.hO;
				var mode = requestMsg.a.iX;
				var accumulated = requestMsg.a.kC;
				if ($elm$core$String$isEmpty(subAccountId) || _Utils_eq(
					$author$project$Remote$Model$toUserSession(state),
					$elm$core$Maybe$Nothing)) {
					return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var queryParams = A2(
						$elm$core$String$join,
						'&',
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$core$Maybe$Just(
									'limit=' + $elm$core$String$fromInt(limit)),
									A2(
									$elm$core$Maybe$map,
									function (cursor_) {
										return 'cursor=' + $elm$url$Url$percentEncode(cursor_);
									},
									cursor)
								])));
					var endpoint = 'user/sub_account/' + ($elm$url$Url$percentEncode(subAccountId) + ('/workers?' + queryParams));
					return helpers.oS(
						{
							a$: false,
							a0: cmd(
								{
									e: $author$project$Types$Worker$workersPageDecoder,
									g: endpoint,
									bS: {
										e: A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
										b7: $elm$core$Basics$identity
									},
									h: $elm$core$Maybe$Nothing,
									f: 0,
									i: $author$project$Remote$ResponseMsg$AggregateSubAccountWorkersInfo(subAccountId)
								}),
							cV: $author$project$Kernel$Aspect$Remote$RemoteModel$PreventIfMatches($author$project$Remote$UpdateRequest$workersRequestConflict),
							al: $elm$core$Maybe$Nothing,
							as: $elm$core$Maybe$Nothing,
							aW: $elm$core$Maybe$Nothing
						});
				}
			case 33:
				var subAccountId = requestMsg.a.o3;
				var token = requestMsg.a.g_;
				var fallbackToken = requestMsg.a.l$;
				return ($elm$core$String$isEmpty(subAccountId) || _Utils_eq(
					$author$project$Remote$Model$toUserSession(state),
					$elm$core$Maybe$Nothing)) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : sendRequest(
					{
						a$: false,
						e: $elm$json$Json$Decode$list($author$project$Types$GeneratedBTC$decoder),
						g: 'user/sub_account/' + ($elm$url$Url$percentEncode(subAccountId) + '/generated_btc'),
						al: $elm$core$Maybe$Nothing,
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$AggregateSubAccountGeneratedBTC(subAccountId),
						aW: $elm$core$Maybe$Nothing
					});
			case 34:
				if (global.dD === 1) {
					var _v12 = A2($author$project$UI$Library$AccountData$workersForScope, global.dD, state);
					if (!_v12.$) {
						var workers = _v12.a;
						return _Utils_Tuple3(
							state,
							$author$project$Types$Worker$downloadWorkersCsv(workers),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							state,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A3(
									$author$project$Kernel$RouteMsgs$routeMsg.pu,
									$elm$core$Maybe$Nothing,
									'Aggregate workers are still loading',
									_List_fromArray(
										['Wait for every subaccount worker roster to finish loading, then try the CSV export again.']))
								]));
					}
				} else {
					if ($author$project$Remote$Model$areAllWorkersLoaded(state)) {
						return _Utils_Tuple3(
							state,
							$author$project$Types$Worker$downloadWorkersCsv(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($author$project$UI$Library$AccountData$workersForScope, global.dD, state))),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							state,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A3(
									$author$project$Kernel$RouteMsgs$routeMsg.pu,
									$elm$core$Maybe$Nothing,
									'Workers are still loading',
									_List_fromArray(
										['Wait a second for the full roster to finish fetching, then try the CSV export again.']))
								]));
					}
				}
			case 35:
				if (state.jR) {
					return _Utils_Tuple3(
						_Utils_update(
							state,
							{jR: false}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					var _v13 = A2($author$project$UI$Library$AccountData$generatedBTCForScope, global.dD, state);
					if (!_v13.$) {
						var entries = _v13.a;
						var dates = $elm$core$List$sort(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.h0;
								},
								entries));
						var fromDate = A2(
							$elm$core$Maybe$withDefault,
							'',
							$elm$core$List$head(dates));
						var toDate = A2(
							$elm$core$Maybe$withDefault,
							'',
							$elm$core$List$head(
								$elm$core$List$reverse(dates)));
						return _Utils_Tuple3(
							_Utils_update(
								state,
								{h5: false, h6: fromDate, h7: true, h8: toDate, jR: true}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							state,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A3(
									$author$project$Kernel$RouteMsgs$routeMsg.pu,
									$elm$core$Maybe$Nothing,
									'Generated BTC is still loading',
									_List_fromArray(
										['Wait for every subaccount generated BTC response to finish loading, then try again.']))
								]));
					}
				}
			case 36:
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{h7: !state.h7}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 37:
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{h5: !state.h5}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 38:
				var date = requestMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{h6: date}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 39:
				var date = requestMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{h8: date}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 40:
				var _v14 = A2($author$project$UI$Library$AccountData$generatedBTCForScope, global.dD, state);
				if (!_v14.$) {
					var entries = _v14.a;
					return _Utils_Tuple3(
						_Utils_update(
							state,
							{jR: false}),
						A2(
							$author$project$Types$GeneratedBTC$downloadGeneratedBTCCsv,
							'generated_btc.csv',
							A3($author$project$Types$GeneratedBTC$filterByDateRange, state.h6, state.h8, entries)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						state,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A3(
								$author$project$Kernel$RouteMsgs$routeMsg.pu,
								$elm$core$Maybe$Nothing,
								'Generated BTC is still loading',
								_List_fromArray(
									['Wait for every subaccount generated BTC response to finish loading, then try again.']))
							]));
				}
			case 41:
				var days = requestMsg.a;
				var _v15 = A2($author$project$UI$Library$AccountData$generatedBTCForScope, global.dD, state);
				if (!_v15.$) {
					var entries = _v15.a;
					var filtered = A2(
						$elm$core$List$take,
						days,
						$elm$core$List$reverse(
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.h0;
								},
								entries)));
					return _Utils_Tuple3(
						_Utils_update(
							state,
							{jR: false}),
						A2($author$project$Types$GeneratedBTC$downloadGeneratedBTCCsv, 'generated_btc.csv', filtered),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						state,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A3(
								$author$project$Kernel$RouteMsgs$routeMsg.pu,
								$elm$core$Maybe$Nothing,
								'Generated BTC is still loading',
								_List_fromArray(
									['Wait for every subaccount generated BTC response to finish loading, then try again.']))
							]));
				}
			case 42:
				var _v16 = A2($author$project$UI$Library$AccountData$generatedBTCForScope, global.dD, state);
				if (!_v16.$) {
					var entries = _v16.a;
					return _Utils_Tuple3(
						_Utils_update(
							state,
							{jR: false}),
						A2($author$project$Types$GeneratedBTC$downloadGeneratedBTCCsv, 'generated_btc_all.csv', entries),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						state,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A3(
								$author$project$Kernel$RouteMsgs$routeMsg.pu,
								$elm$core$Maybe$Nothing,
								'Generated BTC is still loading',
								_List_fromArray(
									['Wait for every subaccount generated BTC response to finish loading, then try again.']))
							]));
				}
			case 43:
				if (state.jS) {
					return _Utils_Tuple3(
						_Utils_update(
							state,
							{jS: false}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					var dates = $elm$core$List$sort(
						A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
							A2($elm$core$List$map, $author$project$Types$Payout$payoutDate, state.ek)));
					var fromDate = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(dates));
					var toDate = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							$elm$core$List$reverse(dates)));
					return _Utils_Tuple3(
						_Utils_update(
							state,
							{h9: false, ia: fromDate, ib: true, ic: toDate, jS: true}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 44:
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{ib: !state.ib}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 45:
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{h9: !state.h9}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 46:
				var date = requestMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{ia: date}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 47:
				var date = requestMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{ic: date}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 48:
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{jS: false}),
					A2(
						$author$project$Types$Payout$downloadPayoutsCsv,
						'payouts.csv',
						A3($author$project$Types$Payout$filterByDateRange, state.ia, state.ic, state.ek)),
					_List_Nil);
			case 49:
				var days = requestMsg.a;
				var filtered = A3($author$project$Types$Payout$filterLastDays, days, time, state.ek);
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{jS: false}),
					A2($author$project$Types$Payout$downloadPayoutsCsv, 'payouts.csv', filtered),
					_List_Nil);
			case 50:
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{jS: false}),
					A2($author$project$Types$Payout$downloadPayoutsCsv, 'payouts_all.csv', state.ek),
					_List_Nil);
			case 51:
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{jQ: !state.jQ, j1: '', j2: ''}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 52:
				var name = requestMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{j2: name}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 53:
				var address = requestMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{j1: address}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 54:
				var sub_account = requestMsg.a.o4;
				var bitcoin_address = requestMsg.a.kU;
				return sendRequest(
					{
						a$: true,
						e: $elm$json$Json$Decode$succeed(0),
						g: 'user/sub_account',
						al: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Just(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'sub_account',
										$elm$json$Json$Encode$string(sub_account)),
										_Utils_Tuple2(
										'bitcoin_address',
										$elm$json$Json$Encode$string(bitcoin_address))
									]))),
						f: 1,
						i: $author$project$Remote$ResponseMsg$CreateSubAccount,
						aW: $elm$core$Maybe$Nothing
					});
			case 55:
				var id = requestMsg.a.mu;
				var name = requestMsg.a.aJ;
				var twoFaToken = requestMsg.a.kj;
				return sendRequest(
					{
						a$: true,
						e: $elm$json$Json$Decode$succeed(0),
						g: 'user/sub_account',
						al: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Just(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'id',
										$elm$json$Json$Encode$string(id)),
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string(name)),
										_Utils_Tuple2(
										'two_fa_token',
										$elm$json$Json$Encode$string(twoFaToken))
									]))),
						f: 2,
						i: $author$project$Remote$ResponseMsg$UpdateSubAccount,
						aW: $elm$core$Maybe$Nothing
					});
			case 56:
				return sendRequest(
					{
						a$: false,
						e: $elm$json$Json$Decode$list($author$project$Types$SubAccount$subAccountDecoder),
						g: 'user/sub_account',
						al: (global.dD === 1) ? $elm$core$Maybe$Just(
							function (state_) {
								return _Utils_update(
									state_,
									{eQ: $elm$core$Dict$empty, eR: $elm$core$Dict$empty, gO: false});
							}) : $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$RetrieveSubAccount,
						aW: $elm$core$Maybe$Nothing
					});
			case 57:
				var subId = requestMsg.a;
				return sendRequest(
					{
						a$: false,
						e: $author$project$Types$SubAccountSummary$subAccountSummaryDecoder,
						g: 'user/sub_account/' + (subId + '/summary'),
						al: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$FetchSubAccountSummary(subId),
						aW: $elm$core$Maybe$Nothing
					});
			case 58:
				return sendRequest(
					{a$: false, e: $author$project$Types$Permissions$decode, g: 'user/permissions', al: $elm$core$Maybe$Nothing, h: $elm$core$Maybe$Nothing, f: 0, i: $author$project$Remote$ResponseMsg$FetchPermissions, aW: $elm$core$Maybe$Nothing});
			case 60:
				var email = requestMsg.a.ff;
				var password = requestMsg.a.cy;
				return sendRequest(
					{
						a$: true,
						e: $author$project$Types$Broker$brokerSessionDecoder,
						g: 'broker/log',
						al: $elm$core$Maybe$Just(
							function (state_) {
								return _Utils_update(
									state_,
									{dI: $author$project$Types$BrokerSessionStatus$BrokerAuthenticating});
							}),
						h: $elm$core$Maybe$Just(
							$author$project$Remote$UpdateRequest$brokerLoginEncoder(
								{ff: email, cy: password})),
						f: 1,
						i: $author$project$Remote$ResponseMsg$BrokerLogin,
						aW: $elm$core$Maybe$Just(
							$elm$core$Basics$always(
								function (state_) {
									return _Utils_update(
										state_,
										{dI: $author$project$Types$BrokerSessionStatus$BrokerUnauthenticated});
								}))
					});
			case 61:
				return _Utils_Tuple3(
					state,
					A2(
						$elm$core$Task$perform,
						$author$project$Remote$ResponseMsg$BrokerLogout,
						$elm$core$Task$succeed(
							$elm$core$Result$Ok(0))),
					_List_Nil);
			case 62:
				return sendRequest(
					{
						a$: false,
						e: $elm$json$Json$Decode$list($author$project$Types$Broker$brokerMinerDecoder),
						g: 'broker/miners?from_block_height=937924',
						al: $elm$core$Maybe$Nothing,
						as: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 0,
						i: $author$project$Remote$ResponseMsg$BrokerMiners,
						aW: $elm$core$Maybe$Nothing
					});
			case 63:
				return sendRequest(
					{a$: false, e: $author$project$Types$ApiToken$apiTokenListDecoder, g: 'api-tokens', al: $elm$core$Maybe$Nothing, h: $elm$core$Maybe$Nothing, f: 0, i: $author$project$Remote$ResponseMsg$FetchApiTokens, aW: $elm$core$Maybe$Nothing});
			case 64:
				var value = requestMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{eT: value}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 66:
				var targetUserId = requestMsg.a.j7;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{eO: _List_Nil, eP: $elm$core$Maybe$Nothing, eT: '', hM: _List_Nil, hN: targetUserId, gq: $elm$core$Maybe$Nothing, gB: false, gC: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 67:
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{eT: '', hM: _List_Nil, hN: $elm$core$Maybe$Nothing, gC: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 68:
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{hd: $author$project$Types$ApiToken$defaultAggregateApiKeyRequirement, eO: _List_Nil, eP: $elm$core$Maybe$Nothing, eT: '', gB: true, gC: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 69:
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{eO: _List_Nil, eP: $elm$core$Maybe$Nothing, eT: '', gB: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 70:
				var requirement = requestMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{hd: requirement, eP: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 71:
				var tokenId = requestMsg.a;
				var nextSelectedIds = A2($elm$core$List$member, tokenId, state.eO) ? A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(tokenId),
					state.eO) : A2($elm$core$List$cons, tokenId, state.eO);
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{eO: nextSelectedIds, eP: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 72:
				var selectedIds = $elm$core$Set$fromList(state.eO);
				var selectedTokens = A2(
					$elm$core$List$filterMap,
					$author$project$Types$ApiToken$recoverableToken,
					$author$project$Types$ApiToken$bestPerUser(
						A2(
							$elm$core$List$filter,
							function (key) {
								return A2($elm$core$Set$member, key.mu, selectedIds);
							},
							A3(
								$author$project$Types$ApiToken$aggregateEligibleTokens,
								time,
								state.hd,
								A2($elm$core$Maybe$withDefault, _List_Nil, state.eU)))));
				return $elm$core$List$isEmpty(selectedTokens) ? _Utils_Tuple3(
					state,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A3($author$project$Kernel$RouteMsgs$routeMsg.aQ, $elm$core$Maybe$Nothing, 'Select an active API key with the selected permissions and an available secret', _List_Nil)
						])) : _Utils_Tuple3(
					_Utils_update(
						state,
						{
							eP: $elm$core$Maybe$Just(
								A3($author$project$Remote$UpdateRequest$multiWatcherLinkForTokens, global.ma, state.hd, selectedTokens))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 73:
				var targetUserId = requestMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{
							hN: $elm$core$Maybe$Just(targetUserId)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 74:
				var scope = requestMsg.a;
				var next = A2($elm$core$List$member, scope, state.hM) ? A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(scope),
					state.hM) : A2($elm$core$List$cons, scope, state.hM);
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{hM: next}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 75:
				var scopes = requestMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{hM: scopes}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 76:
				var _v17 = state.hN;
				if (_v17.$ === 1) {
					return _Utils_Tuple3(
						state,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A3($author$project$Kernel$RouteMsgs$routeMsg.aQ, $elm$core$Maybe$Nothing, 'Pick a target account before creating an API key', _List_Nil)
							]));
				} else {
					var targetUserId = _v17.a;
					return $elm$core$List$isEmpty(state.hM) ? _Utils_Tuple3(
						state,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A3($author$project$Kernel$RouteMsgs$routeMsg.aQ, $elm$core$Maybe$Nothing, 'Select at least one scope', _List_Nil)
							])) : sendRequest(
						{
							a$: true,
							e: $author$project$Types$ApiToken$createApiTokenResponseDecoder,
							g: 'api-tokens',
							al: $elm$core$Maybe$Nothing,
							h: $elm$core$Maybe$Just(
								$author$project$Types$ApiToken$createApiTokenRequestEncoder(
									{lY: $elm$core$Maybe$Nothing, oK: state.hM, j7: targetUserId})),
							f: 1,
							i: $author$project$Remote$ResponseMsg$CreateApiToken,
							aW: $elm$core$Maybe$Nothing
						});
				}
			case 77:
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{gq: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 78:
				var tokenId = requestMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{
							eT: '',
							jd: $elm$core$Maybe$Just(tokenId)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 79:
				return _Utils_Tuple3(
					_Utils_update(
						state,
						{eT: '', jd: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 80:
				var tokenId = requestMsg.a;
				return sendRequest(
					{
						a$: true,
						e: $elm$json$Json$Decode$succeed(0),
						g: 'api-tokens/' + tokenId,
						al: $elm$core$Maybe$Nothing,
						h: $elm$core$Maybe$Nothing,
						f: 3,
						i: $author$project$Remote$ResponseMsg$RevokeApiToken(tokenId),
						aW: $elm$core$Maybe$Nothing
					});
			default:
				return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Remote$UpdateRequest$updateRequest = F4(
	function (requestMsg, global, time, state) {
		var exportsPayouts = function () {
			switch (requestMsg.$) {
				case 43:
					return !state.jS;
				case 48:
					return true;
				case 49:
					return true;
				case 50:
					return true;
				default:
					return false;
			}
		}();
		return (exportsPayouts && $author$project$Remote$Model$payoutsAreLoading(state)) ? _Utils_Tuple3(
			state,
			$elm$core$Platform$Cmd$none,
			_List_fromArray(
				[
					A3(
					$author$project$Kernel$RouteMsgs$routeMsg.pu,
					$elm$core$Maybe$Nothing,
					'Payouts are still loading',
					_List_fromArray(
						['Wait for all payout pages to finish loading, then export.']))
				])) : A4($author$project$Remote$UpdateRequest$updateReadyRequest, requestMsg, global, time, state);
	});
var $author$project$Remote$RequestMsg$AggregateSubAccountGeneratedBTC = function (a) {
	return {$: 33, a: a};
};
var $author$project$Remote$RequestMsg$AggregateSubAccountWorkersInfo = function (a) {
	return {$: 32, a: a};
};
var $author$project$Remote$RequestMsg$AppendWorkers = 1;
var $author$project$Remote$RequestMsg$CheckAuthContextAfterSignIn = 0;
var $author$project$Global$Msg$EmailVerificationResent = {$: 7};
var $author$project$Remote$RequestMsg$FetchSubAccountSummary = function (a) {
	return {$: 57, a: a};
};
var $author$project$Kernel$Aspect$Remote$RemoteModel$GeneralErrHandler_DefaultToast = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Global$Msg$HideModal = {$: 12};
var $author$project$UI$Auth$Msg$InitModel = {$: 10};
var $author$project$UI$Auth$Msg$InputCode = function (a) {
	return {$: 7, a: a};
};
var $author$project$UI$Auth$Msg$InputPassword = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Auth$Msg$InputTwoFaToken = function (a) {
	return {$: 8, a: a};
};
var $author$project$UI$Library$Chart$Msg$MergeHistoricalData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Global$Msg$OnBrokerAuthSuccess = {$: 1};
var $author$project$Global$Msg$OpenNewTab = function (a) {
	return {$: 15, a: a};
};
var $author$project$Types$PplnsProjection$PplnsLoaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$PplnsProjection$PplnsUnavailable = {$: 2};
var $author$project$UI$Auth$Msg$ProceedToResetPasswordStepTwo = {$: 12};
var $author$project$Global$Msg$SelectAccountDataScope = function (a) {
	return {$: 6, a: a};
};
var $author$project$UI$Library$Chart$Msg$UpdateChartData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Remote$ResponseMsg$UserHashrateTime = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Remote$Model$WatcherFeesResource = 5;
var $author$project$Remote$Model$WatcherShareStatsResource = 4;
var $author$project$TopMsg$authMsg = A2($elm$core$Basics$composeL, $author$project$Kernel$Msg$AppMsg, $author$project$Msg$AuthMsg);
var $author$project$Kernel$Aspect$Browser$OpenNewTab$clearBrokerSession = _Platform_outgoingPort(
	'clearBrokerSession',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Kernel$Aspect$Browser$OpenNewTab$clearSessionStorage = _Platform_outgoingPort(
	'clearSessionStorage',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Remote$UpdateResponse$currentSubAccountExists = F2(
	function (subAccountId, state) {
		return A2(
			$elm$core$List$any,
			function (subAccount) {
				return _Utils_eq(subAccount.mu, subAccountId);
			},
			A2($elm$core$Maybe$withDefault, _List_Nil, state.ex));
	});
var $author$project$Remote$UpdateResponse$canonicalDecimalString = function (value) {
	var trimmed = $elm$core$String$trim(value);
	var dropLeadingZeroes = function (digits) {
		dropLeadingZeroes:
		while (true) {
			var _v0 = $elm$core$String$uncons(digits);
			if ((!_v0.$) && ('0' === _v0.a.a)) {
				var _v1 = _v0.a;
				var rest = _v1.b;
				var $temp$digits = rest;
				digits = $temp$digits;
				continue dropLeadingZeroes;
			} else {
				return digits;
			}
		}
	};
	var canonicalize = F2(
		function (sign, digits) {
			if ($elm$core$String$isEmpty(digits) || (!A2(
				$elm$core$String$all,
				function (_char) {
					return (_char >= '0') && (_char <= '9');
				},
				digits))) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v5 = dropLeadingZeroes(digits);
				if (_v5 === '') {
					return $elm$core$Maybe$Just('0');
				} else {
					var canonicalDigits = _v5;
					return $elm$core$Maybe$Just(
						_Utils_ap(sign, canonicalDigits));
				}
			}
		});
	var _v2 = $elm$core$String$uncons(trimmed);
	_v2$2:
	while (true) {
		if (!_v2.$) {
			switch (_v2.a.a) {
				case '-':
					var _v3 = _v2.a;
					var digits = _v3.b;
					return A2(canonicalize, '-', digits);
				case '+':
					var _v4 = _v2.a;
					var digits = _v4.b;
					return A2(canonicalize, '', digits);
				default:
					break _v2$2;
			}
		} else {
			break _v2$2;
		}
	}
	return A2(canonicalize, '', trimmed);
};
var $author$project$Remote$UpdateResponse$decimalStringsMatch = F2(
	function (left, right) {
		var _v0 = _Utils_Tuple2(
			$author$project$Remote$UpdateResponse$canonicalDecimalString(left),
			$author$project$Remote$UpdateResponse$canonicalDecimalString(right));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var canonicalLeft = _v0.a.a;
			var canonicalRight = _v0.b.a;
			return _Utils_eq(canonicalLeft, canonicalRight);
		} else {
			return false;
		}
	});
var $author$project$UI$Library$Chart$View$ewmaEquivalentSampleCount = 50.0;
var $author$project$UI$Library$Chart$View$ewmaAlpha = 2 / ($author$project$UI$Library$Chart$View$ewmaEquivalentSampleCount + 1);
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$TopMsg$globalMsg = A2($elm$core$Basics$composeL, $author$project$Kernel$Msg$AppMsg, $author$project$Msg$GlobalMsg);
var $elm$core$String$toLower = _String_toLower;
var $author$project$Remote$UpdateResponse$isPplnsProjectionMissingError = function (error) {
	var lower = $elm$core$String$toLower(error);
	return A2($elm$core$String$contains, 'pplns projection is not available', lower) || A2($elm$core$String$contains, 'projection-not-found', lower);
};
var $author$project$Remote$UpdateResponse$isTwoFactorResetError = function (error) {
	return A2(
		$elm$core$String$contains,
		'2fa',
		$elm$core$String$toLower(error));
};
var $author$project$Remote$UpdateResponse$isWatcherAccessError = function (error) {
	var lower = $elm$core$String$toLower(error);
	return A2($elm$core$String$contains, 'unauthorized', lower) || (A2($elm$core$String$contains, 'forbidden', lower) || (A2($elm$core$String$contains, 'invalid token', lower) || (A2($elm$core$String$contains, 'authentication required', lower) || (A2($elm$core$String$contains, 'does not grant', lower) || A2($elm$core$String$contains, 'not authorized', lower)))));
};
var $author$project$Types$PplnsProjection$PplnsFailed = {$: 3};
var $author$project$Remote$UpdateResponse$markPplnsProjectionFailedUnlessLoaded = function (state) {
	var _v0 = state.dk;
	if (_v0.$ === 4) {
		return state;
	} else {
		return _Utils_update(
			state,
			{dk: $author$project$Types$PplnsProjection$PplnsFailed});
	}
};
var $author$project$Remote$UpdateResponse$markPplnsProjectionFetched = F2(
	function (time, state) {
		return _Utils_update(
			state,
			{
				d5: $elm$core$Maybe$Just(time)
			});
	});
var $author$project$Remote$UpdateResponse$markWatcherDeniedOnAccessError = F3(
	function (resource, error, state) {
		return $author$project$Remote$UpdateResponse$isWatcherAccessError(error) ? A3($author$project$Remote$Model$markWatcherAccess, resource, 2, state) : state;
	});
var $author$project$Types$Payout$nextQuery = F2(
	function (query, page) {
		return A2(
			$elm$core$Maybe$map,
			function (cursor) {
				return _Utils_update(
					query,
					{
						kC: _Utils_ap(query.kC, page.ek),
						hO: $elm$core$Maybe$Just(cursor),
						eJ: $elm$core$Maybe$Just(
							_Utils_Tuple2(page.c6, page.dr))
					});
			},
			page.bB);
	});
var $author$project$Remote$UpdateResponse$payoutQueryMatchesCurrentSession = F2(
	function (query, state) {
		if ((!_Utils_eq(query.mc, state.bD)) || (!_Utils_eq(
			state.nQ,
			$elm$core$Maybe$Just(query.hK)))) {
			return false;
		} else {
			var _v0 = query.hK;
			if (!_v0.$) {
				var userId = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.mu;
							},
							A2(
								$elm$core$Basics$composeR,
								$author$project$Types$User$unwrapUserId,
								$elm$core$Basics$eq(userId))),
						$author$project$Remote$Model$toUserSession(state)));
			} else {
				var userId = _v0.a;
				var token = _v0.b;
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (watcherSession) {
							return _Utils_eq(watcherSession.g4, userId) && (_Utils_eq(watcherSession.g_, token) && $author$project$Remote$Model$watcherCanViewPayouts(state));
						},
						$author$project$Remote$Model$toWatcherSession(state)));
			}
		}
	});
var $author$project$Types$Report$encodeActivity = function (activity) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'worker_name',
				$elm$json$Json$Encode$string(activity.eK)),
				_Utils_Tuple2(
				'timestamp',
				$elm$json$Json$Encode$string(activity.b5)),
				_Utils_Tuple2(
				'activity',
				$elm$json$Json$Encode$string(activity.dE))
			]));
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Types$Report$encodeShare = function (share) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'difficulty',
				function () {
					var _v0 = share.e9;
					if (!_v0.$) {
						var diff = _v0.a;
						return $elm$json$Json$Encode$float(diff);
					} else {
						return $elm$json$Json$Encode$null;
					}
				}()),
				_Utils_Tuple2(
				'rejection_reason',
				function () {
					var _v1 = share.jq;
					if (!_v1.$) {
						var reason = _v1.a;
						return $elm$json$Json$Encode$string(reason);
					} else {
						return $elm$json$Json$Encode$null;
					}
				}()),
				_Utils_Tuple2(
				'worker_name',
				$elm$json$Json$Encode$string(share.eK))
			]));
};
var $author$project$Types$Report$encodeReport = function (report) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'activity',
				A2($elm$json$Json$Encode$list, $author$project$Types$Report$encodeActivity, report.dE)),
				_Utils_Tuple2(
				'shares',
				A2($elm$json$Json$Encode$list, $author$project$Types$Report$encodeShare, report.jO))
			]));
};
var $author$project$Types$Report$saveReportAsJsonFile = F3(
	function (report, reportDays, timestamp) {
		var jsonValue = $author$project$Types$Report$encodeReport(report);
		var jsonString = A2($elm$json$Json$Encode$encode, 4, jsonValue);
		var fileName = $elm$core$String$fromInt(reportDays) + (' days_' + ('workers_report_' + (timestamp + '.json')));
		return A3($elm$file$File$Download$string, fileName, 'application/json', jsonString);
	});
var $author$project$Remote$Model$setMultiWatcherGeneratedBTCAccessForSession = F3(
	function (session, access, remote) {
		return _Utils_update(
			remote,
			{
				bm: A3(
					$elm$core$Dict$insert,
					$author$project$Remote$Model$watcherSessionKey(session),
					access,
					remote.bm)
			});
	});
var $author$project$Remote$Model$setMultiWatcherGeneratedBTCForSession = F3(
	function (session, generatedEntries, remote) {
		return _Utils_update(
			remote,
			{
				bz: A3(
					$elm$core$Dict$insert,
					$author$project$Remote$Model$watcherSessionKey(session),
					generatedEntries,
					remote.bz)
			});
	});
var $author$project$Remote$Model$setMultiWatcherGeneratedBTCLoadErrorForSession = F3(
	function (session, hasError, remote) {
		var sessionKey = $author$project$Remote$Model$watcherSessionKey(session);
		return hasError ? _Utils_update(
			remote,
			{
				a3: A3($elm$core$Dict$insert, sessionKey, true, remote.a3)
			}) : _Utils_update(
			remote,
			{
				a3: A2($elm$core$Dict$remove, sessionKey, remote.a3)
			});
	});
var $author$project$Remote$Model$setMultiWatcherHashrateAccessForSession = F3(
	function (session, access, remote) {
		return _Utils_update(
			remote,
			{
				bn: A3(
					$elm$core$Dict$insert,
					$author$project$Remote$Model$watcherSessionKey(session),
					access,
					remote.bn)
			});
	});
var $author$project$Remote$Model$mergeHistoryPoints = function (points) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$second,
		A2(
			$elm$core$List$sortBy,
			$elm$core$Tuple$first,
			$elm$core$Dict$toList(
				A3(
					$elm$core$List$foldl,
					F2(
						function (point, acc) {
							return A3(
								$elm$core$Dict$insert,
								$elm$time$Time$posixToMillis(point.ny),
								point,
								acc);
						}),
					$elm$core$Dict$empty,
					points))));
};
var $author$project$Remote$Model$multiWatcherHashrateHistoryForSession = F2(
	function (session, remote) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Dict$get,
				$author$project$Remote$Model$watcherSessionKey(session),
				remote.bA));
	});
var $author$project$Remote$Model$setMultiWatcherHashrateForSession = F3(
	function (session, history, remote) {
		var key = $author$project$Remote$Model$watcherSessionKey(session);
		var existingHistory = A2($author$project$Remote$Model$multiWatcherHashrateHistoryForSession, session, remote);
		var mergedHistory = $author$project$Remote$Model$mergeHistoryPoints(
			$elm$core$List$concat(
				_List_fromArray(
					[existingHistory, history])));
		return _Utils_update(
			remote,
			{
				bA: A3($elm$core$Dict$insert, key, mergedHistory, remote.bA)
			});
	});
var $author$project$Remote$Model$setMultiWatcherHashrateLoadErrorForSession = F3(
	function (session, hasError, remote) {
		var sessionKey = $author$project$Remote$Model$watcherSessionKey(session);
		return hasError ? _Utils_update(
			remote,
			{
				a4: A3($elm$core$Dict$insert, sessionKey, true, remote.a4)
			}) : _Utils_update(
			remote,
			{
				a4: A2($elm$core$Dict$remove, sessionKey, remote.a4)
			});
	});
var $author$project$Kernel$Aspect$Browser$OpenNewTab$storeBrokerSession = _Platform_outgoingPort('storeBrokerSession', $elm$json$Json$Encode$string);
var $author$project$Kernel$Aspect$Browser$OpenNewTab$storeUserId = _Platform_outgoingPort('storeUserId', $elm$json$Json$Encode$string);
var $author$project$Kernel$UI$EndlessList$EndlessList$NextPageFetchable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Kernel$UI$EndlessList$EndlessList$ReceivedAllItems = {$: 2};
var $author$project$Kernel$Types$OrderedCollection$OrderedCollection = $elm$core$Basics$identity;
var $turboMaCk$any_dict$Dict$Any$AnyDict = $elm$core$Basics$identity;
var $turboMaCk$any_dict$Dict$Any$fromList = F2(
	function (f, xs) {
		return {
			V: $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (_v0) {
						var k = _v0.a;
						var v = _v0.b;
						return _Utils_Tuple2(
							f(k),
							_Utils_Tuple2(k, v));
					},
					xs)),
			aP: f
		};
	});
var $author$project$Kernel$Aspect$Utility$uniqueBy = F2(
	function (toId, list) {
		var consIfNotMember = F2(
			function (el, subList) {
				return $elm_community$maybe_extra$Maybe$Extra$isJust(
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (tady) {
							return _Utils_eq(
								toId(el),
								toId(tady));
						},
						subList)) ? subList : A2($elm$core$List$cons, el, subList);
			});
		return A3($elm$core$List$foldr, consIfNotMember, _List_Nil, list);
	});
var $author$project$Kernel$Types$OrderedCollection$fromList = F3(
	function (toId, serializeId, list) {
		var uniqList = A2($author$project$Kernel$Aspect$Utility$uniqueBy, toId, list);
		var dict = A2(
			$turboMaCk$any_dict$Dict$Any$fromList,
			serializeId,
			A2(
				$elm$core$List$map,
				function (i) {
					return _Utils_Tuple2(
						toId(i),
						i);
				},
				uniqList));
		return {V: dict, m: uniqList, gy: serializeId, gZ: toId};
	});
var $author$project$Kernel$Types$OrderedCollection$append = F2(
	function (newList, _v0) {
		var toId = _v0.gZ;
		var serializeId = _v0.gy;
		var list = _v0.m;
		return A3(
			$author$project$Kernel$Types$OrderedCollection$fromList,
			toId,
			serializeId,
			_Utils_ap(list, newList));
	});
var $author$project$Kernel$Aspect$Utility$dropFirstThatSatisfies = F2(
	function (predicate, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			var a = list.a;
			var rest = list.b;
			return predicate(a) ? rest : A2(
				$elm$core$List$cons,
				a,
				A2($author$project$Kernel$Aspect$Utility$dropFirstThatSatisfies, predicate, rest));
		}
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$dropOngoingRequest = function (cfg) {
	var state = cfg.aX;
	return _Utils_update(
		state,
		{
			C: A2(
				$author$project$Kernel$Aspect$Utility$dropFirstThatSatisfies,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.aM;
					},
					$elm$core$Basics$eq(cfg.R)),
				state.C)
		});
};
var $author$project$Kernel$Aspect$Remote$RemoteModel$revertState = F3(
	function (state, savedRequest, transformRevertState) {
		if (savedRequest.$ === 1) {
			return state;
		} else {
			var savedReq = savedRequest.a;
			var _v1 = savedReq.aW;
			if (_v1.$ === 1) {
				return state;
			} else {
				var revertStateFunction = _v1.a;
				var _v2 = savedReq.as;
				if (!_v2.$) {
					var correlationId = _v2.a;
					return A3(transformRevertState, revertStateFunction, correlationId, state);
				} else {
					return state;
				}
			}
		}
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$dropOngoingRequestAndRevertState = function (cfg) {
	var state = cfg.aX;
	var savedRequest = A2(
		$elm_community$list_extra$List$Extra$find,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.aM;
			},
			$elm$core$Basics$eq(cfg.R)),
		state.C);
	return A3(
		$author$project$Kernel$Aspect$Remote$RemoteModel$revertState,
		$author$project$Kernel$Aspect$Remote$RemoteModel$dropOngoingRequest(cfg),
		savedRequest,
		cfg.cK);
};
var $author$project$Kernel$Aspect$Utility$decodeString = F2(
	function (decoder, string) {
		return A2(
			$elm$core$Result$mapError,
			$elm$json$Json$Decode$errorToString,
			A2($elm$json$Json$Decode$decodeString, decoder, string));
	});
var $author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$detailedError = _Platform_outgoingPort(
	'detailedError',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'extra',
					$elm$core$Basics$identity($.id)),
					_Utils_Tuple2(
					'msg',
					$elm$json$Json$Encode$string($.f1))
				]));
	});
var $author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$reportDetailsAsString = function (record) {
	return $author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$detailedError(
		{
			id: $elm$json$Json$Encode$string(record.lJ),
			f1: record.f1
		});
};
var $author$project$Kernel$Aspect$Remote$RemoteModel$genericHttpBadStatusHandler = F2(
	function (_v0, remoteState) {
		var msg = _v0.f1;
		var details = _v0.lJ;
		var error = _v0.bj;
		var messages = _v0.Z;
		return _Utils_Tuple3(
			remoteState,
			$author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$reportDetailsAsString(
				{lJ: details, f1: msg}),
			_List_fromArray(
				[
					A3($author$project$Kernel$ToastMsgs$toastMsg.aQ, $elm$core$Maybe$Nothing, error, messages)
				]));
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$defaultHttpBadStatusHandler = F2(
	function (_v0, remoteState) {
		var responseBody = _v0.jA;
		var error = _v0.bj;
		var messages = _v0.Z;
		return A2(
			$author$project$Kernel$Aspect$Remote$RemoteModel$genericHttpBadStatusHandler,
			{lJ: responseBody, bj: error, Z: messages, f1: 'Response error'},
			remoteState);
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$updateRequestStatusAndRefreshToken = F3(
	function (state, requestMsg, refreshTokenMsg) {
		var updateCurrentRequestStatusToPendingAuthentication = function (savedReq) {
			if (_Utils_eq(savedReq.aM, requestMsg)) {
				var _v0 = savedReq.D;
				switch (_v0.$) {
					case 1:
						var toCmd = _v0.a;
						return _Utils_update(
							savedReq,
							{
								D: $author$project$Kernel$Aspect$Remote$RemoteModel$PendingAuthentication(toCmd)
							});
					case 2:
						return savedReq;
					default:
						return savedReq;
				}
			} else {
				return savedReq;
			}
		};
		var newOngoingRequests = A2($elm$core$List$map, updateCurrentRequestStatusToPendingAuthentication, state.C);
		var newState = _Utils_update(
			state,
			{C: newOngoingRequests});
		return _Utils_Tuple3(
			newState,
			$elm$core$Platform$Cmd$none,
			_List_fromArray(
				[refreshTokenMsg]));
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$handleHttpBadStatus = F3(
	function (cfg, meta, responseBody) {
		var notAuthenticatedResponseOrLazy = function (toOther) {
			return (meta.j0 === 401) ? A2(
				$author$project$Kernel$Aspect$Remote$RemoteModel$genericHttpBadStatusHandler,
				{
					lJ: responseBody,
					bj: 'Error: Not authenticated',
					Z: _List_fromArray(
						['Please log in first']),
					f1: 'Graphql.Http.BadStatus: Not Authenticated: 401'
				},
				$author$project$Kernel$Aspect$Remote$RemoteModel$dropOngoingRequestAndRevertState(cfg)) : toOther(0);
		};
		var _v0 = cfg.fp;
		switch (_v0.$) {
			case 0:
				var string = _v0.a;
				var strings = _v0.b;
				return notAuthenticatedResponseOrLazy(
					function (_v1) {
						return A2(
							$author$project$Kernel$Aspect$Remote$RemoteModel$defaultHttpBadStatusHandler,
							{bj: string, Z: strings, jA: responseBody},
							$author$project$Kernel$Aspect$Remote$RemoteModel$dropOngoingRequestAndRevertState(cfg));
					});
			case 1:
				var decoder = _v0.a;
				var defaultErrMsg = _v0.b;
				return notAuthenticatedResponseOrLazy(
					function (_v2) {
						return A2(
							$author$project$Kernel$Aspect$Remote$RemoteModel$genericHttpBadStatusHandler,
							function () {
								var _v3 = A2($author$project$Kernel$Aspect$Utility$decodeString, decoder, responseBody);
								if (!_v3.$) {
									var value = _v3.a;
									return {
										lJ: A2($elm$core$String$join, ', ', value.Z),
										bj: value.bi,
										Z: value.Z,
										f1: 'Response error: ' + value.bi
									};
								} else {
									return {lJ: responseBody, bj: defaultErrMsg.bi, Z: defaultErrMsg.Z, f1: 'Undecodable error'};
								}
							}(),
							$author$project$Kernel$Aspect$Remote$RemoteModel$dropOngoingRequestAndRevertState(cfg));
					});
			case 2:
				var handleResponseBody = _v0.a;
				return A2(
					handleResponseBody,
					_List_fromArray(
						[responseBody]),
					cfg.aX);
			default:
				var authError = _v0.a.he;
				var httpErrDecoder = _v0.a.iz;
				var defaultHttpErrorMessages = _v0.a.hU;
				var refreshTokenMsg = _v0.a.jo;
				var isHttpAuthErr = function () {
					if (!authError.$) {
						var decoder = authError.a;
						return _Utils_eq(
							A2($elm$json$Json$Decode$decodeString, decoder, responseBody),
							$elm$core$Result$Ok(0));
					} else {
						return false;
					}
				}();
				return ((meta.j0 === 401) || isHttpAuthErr) ? A3($author$project$Kernel$Aspect$Remote$RemoteModel$updateRequestStatusAndRefreshToken, cfg.aX, cfg.R, refreshTokenMsg) : A2(
					$author$project$Kernel$Aspect$Remote$RemoteModel$genericHttpBadStatusHandler,
					function () {
						var _v4 = A2($elm$json$Json$Decode$decodeString, httpErrDecoder, responseBody);
						if (!_v4.$) {
							var value = _v4.a;
							return {
								lJ: A2($elm$core$String$join, ', ', value.Z),
								bj: value.bi,
								Z: value.Z,
								f1: 'Response error: ' + value.bi
							};
						} else {
							return {lJ: responseBody, bj: defaultHttpErrorMessages.bi, Z: defaultHttpErrorMessages.Z, f1: defaultHttpErrorMessages.bi};
						}
					}(),
					$author$project$Kernel$Aspect$Remote$RemoteModel$dropOngoingRequestAndRevertState(cfg));
		}
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$handleGqlHttpError = F2(
	function (cfg, httpError) {
		switch (httpError.$) {
			case 0:
				var string = httpError.a;
				return _Utils_Tuple3(
					$author$project$Kernel$Aspect$Remote$RemoteModel$dropOngoingRequestAndRevertState(cfg),
					$author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$generalError('Graphql.Http.BadUrl: ' + string),
					_List_fromArray(
						[
							A3(
							$author$project$Kernel$ToastMsgs$toastMsg.aQ,
							$elm$core$Maybe$Nothing,
							'Bad URL',
							_List_fromArray(
								[string]))
						]));
			case 1:
				return _Utils_Tuple3(
					$author$project$Kernel$Aspect$Remote$RemoteModel$dropOngoingRequestAndRevertState(cfg),
					$author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$generalError('Graphql.Http.Timeout'),
					_List_fromArray(
						[
							A3(
							$author$project$Kernel$ToastMsgs$toastMsg.aQ,
							$elm$core$Maybe$Nothing,
							'Request timed out',
							_List_fromArray(
								['Try again maybe?']))
						]));
			case 2:
				return _Utils_Tuple3(
					$author$project$Kernel$Aspect$Remote$RemoteModel$dropOngoingRequestAndRevertState(cfg),
					$author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$generalError('Graphql.Http.NetworkError'),
					_List_fromArray(
						[
							A3(
							$author$project$Kernel$ToastMsgs$toastMsg.aQ,
							$elm$core$Maybe$Nothing,
							'Network error',
							_List_fromArray(
								['Please check whether your network is on and functional']))
						]));
			case 3:
				var meta = httpError.a;
				var responseBody = httpError.b;
				return A3($author$project$Kernel$Aspect$Remote$RemoteModel$handleHttpBadStatus, cfg, meta, responseBody);
			default:
				var jdErr = httpError.a;
				return _Utils_Tuple3(
					$author$project$Kernel$Aspect$Remote$RemoteModel$dropOngoingRequestAndRevertState(cfg),
					$author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$generalError(
						'Graphql.Http.BadPayload:\n' + $elm$json$Json$Decode$errorToString(jdErr)),
					_List_fromArray(
						[
							A3(
							$author$project$Kernel$ToastMsgs$toastMsg.aQ,
							$elm$core$Maybe$Nothing,
							'Bad payload / Unexpected response',
							_List_fromArray(
								[
									A2(
									$elm$core$String$left,
									2000,
									$elm$json$Json$Decode$errorToString(jdErr))
								]))
						]));
		}
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$handleGraphqlError = F2(
	function (cfg, error) {
		var toastAndReportGraphqlError = function (gqlErr) {
			return A2($elm$core$String$startsWith, 'Validation error', gqlErr.ct) ? _Utils_Tuple2(
				$author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$generalError(gqlErr.ct),
				A3(
					$author$project$Kernel$ToastMsgs$toastMsg.aQ,
					$elm$core$Maybe$Nothing,
					'There was a problem talking to the backend',
					_List_fromArray(
						['Please try updating the app']))) : _Utils_Tuple2(
				$author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$generalError(gqlErr.ct),
				A3($author$project$Kernel$ToastMsgs$toastMsg.aQ, $elm$core$Maybe$Nothing, gqlErr.ct, _List_Nil));
		};
		var batchErrs = F2(
			function (_v3, acc) {
				var reportCmd = _v3.a;
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[reportCmd, acc]));
			});
		var dropRequestToastAndReport = function (gqlErrors) {
			return function (errs) {
				return _Utils_Tuple3(
					$author$project$Kernel$Aspect$Remote$RemoteModel$dropOngoingRequestAndRevertState(cfg),
					A3($elm$core$List$foldl, batchErrs, $elm$core$Platform$Cmd$none, errs),
					A2($elm$core$List$map, $elm$core$Tuple$second, errs));
			}(
				A2($elm$core$List$map, toastAndReportGraphqlError, gqlErrors));
		};
		if (!error.$) {
			var graphqlErrors = error.b;
			var _v1 = cfg.fp;
			switch (_v1.$) {
				case 2:
					var handleErrors = _v1.a;
					return A2(
						handleErrors,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.ct;
							},
							graphqlErrors),
						cfg.aX);
				case 3:
					var authError = _v1.a.he;
					var httpErrDecoder = _v1.a.iz;
					var defaultHttpErrorMessages = _v1.a.hU;
					var refreshTokenMsg = _v1.a.jo;
					var isGqlAuthErr = function () {
						if (!authError.$) {
							var decoder = authError.a;
							return false;
						} else {
							var isAuthError = authError.a;
							return A2(
								$elm$core$List$any,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ct;
									},
									isAuthError),
								graphqlErrors);
						}
					}();
					return isGqlAuthErr ? A3($author$project$Kernel$Aspect$Remote$RemoteModel$updateRequestStatusAndRefreshToken, cfg.aX, cfg.R, refreshTokenMsg) : dropRequestToastAndReport(graphqlErrors);
				default:
					return dropRequestToastAndReport(graphqlErrors);
			}
		} else {
			var httpError = error.a;
			return A2($author$project$Kernel$Aspect$Remote$RemoteModel$handleGqlHttpError, cfg, httpError);
		}
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$create_handleEndlessListResponse = F2(
	function (cfg, params) {
		var _v0 = params.am;
		if (!_v0.$) {
			var pagedResponse = _v0.a;
			var updatedEndlessList = {
				hC: A2($author$project$Kernel$Types$OrderedCollection$append, pagedResponse.mN, params.jg.hC),
				D: function () {
					var _v1 = pagedResponse.nu;
					if (!_v1.$) {
						var nextPagePointer = _v1.a;
						return $author$project$Kernel$UI$EndlessList$EndlessList$NextPageFetchable(nextPagePointer);
					} else {
						return $author$project$Kernel$UI$EndlessList$EndlessList$ReceivedAllItems;
					}
				}()
			};
			var newState = $author$project$Kernel$Aspect$Remote$RemoteModel$dropOngoingRequest(cfg);
			return _Utils_Tuple3(
				A2(params.al, updatedEndlessList, newState),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			var error = _v0.a;
			return A2($author$project$Kernel$Aspect$Remote$RemoteModel$handleGraphqlError, cfg, error);
		}
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$handleOngoingRequest = F2(
	function (keepOngoingRequest, cfg) {
		return keepOngoingRequest ? cfg.aX : $author$project$Kernel$Aspect$Remote$RemoteModel$dropOngoingRequest(cfg);
	});
var $author$project$Kernel$Aspect$Utility$mergeTupleFromState = F2(
	function (fromState, _v0) {
		var state = _v0.a;
		var cmd = _v0.b;
		var list = _v0.c;
		var _v1 = fromState(state);
		var newState = _v1.a;
		var newCmd = _v1.b;
		var newList = _v1.c;
		return _Utils_Tuple3(
			newState,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[newCmd, cmd])),
			_Utils_ap(list, newList));
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$create_handleResponse = F2(
	function (cfg, params) {
		var newState = A2($author$project$Kernel$Aspect$Remote$RemoteModel$handleOngoingRequest, params.aI, cfg);
		var handledTuple = function () {
			var _v0 = params.am;
			if (!_v0.$) {
				var value = _v0.a;
				return A2(params.aK, value, newState);
			} else {
				var error = _v0.a;
				var _v1 = A2($author$project$Kernel$Aspect$Remote$RemoteModel$handleGraphqlError, cfg, error);
				var state_ = _v1.a;
				var cmds = _v1.b;
				var msgs = _v1.c;
				var _v2 = A2(params.cw, error, state_);
				var finalState = _v2.a;
				var newCmds = _v2.b;
				var newMsgs = _v2.c;
				return _Utils_Tuple3(
					finalState,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmds, newCmds])),
					_Utils_ap(msgs, newMsgs));
			}
		}();
		return A2($author$project$Kernel$Aspect$Utility$mergeTupleFromState, params.cv, handledTuple);
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$create_handleResponseSuccess = F2(
	function (cfg, params) {
		var _v0 = params.am;
		if (!_v0.$) {
			var value = _v0.a;
			return A2(
				params.aK,
				value,
				A2($author$project$Kernel$Aspect$Remote$RemoteModel$handleOngoingRequest, params.aI, cfg));
		} else {
			var error = _v0.a;
			return A2($author$project$Kernel$Aspect$Remote$RemoteModel$handleGraphqlError, cfg, error);
		}
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$create_handleResponseWithExpectedErr = F2(
	function (cfg, params) {
		var newState = A2($author$project$Kernel$Aspect$Remote$RemoteModel$handleOngoingRequest, params.aI, cfg);
		var handledTuple = function () {
			var _v0 = params.am;
			if (!_v0.$) {
				if (!_v0.a.$) {
					var value = _v0.a.a;
					return A2(params.aK, value, newState);
				} else {
					var err = _v0.a.a;
					return _Utils_Tuple3(
						newState,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A3($author$project$Kernel$ToastMsgs$toastMsg.aQ, $elm$core$Maybe$Nothing, err, _List_Nil)
							]));
				}
			} else {
				var error = _v0.a;
				return A2(
					$author$project$Kernel$Aspect$Utility$mergeTupleFromState,
					function (state) {
						return A2(
							$author$project$Kernel$Aspect$Remote$RemoteModel$handleGraphqlError,
							_Utils_update(
								cfg,
								{aX: state}),
							error);
					},
					A2(params.cw, error, cfg.aX));
			}
		}();
		return A2($author$project$Kernel$Aspect$Utility$mergeTupleFromState, params.cv, handledTuple);
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$create_handleResponseWithExpectedErr_success = F2(
	function (cfg, params) {
		var newState = A2($author$project$Kernel$Aspect$Remote$RemoteModel$handleOngoingRequest, params.aI, cfg);
		var _v0 = params.am;
		if (!_v0.$) {
			if (!_v0.a.$) {
				var value = _v0.a.a;
				return A2(params.aK, value, newState);
			} else {
				var err = _v0.a.a;
				return _Utils_Tuple3(
					newState,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A3($author$project$Kernel$ToastMsgs$toastMsg.aQ, $elm$core$Maybe$Nothing, err, _List_Nil)
						]));
			}
		} else {
			var error = _v0.a;
			return A2($author$project$Kernel$Aspect$Remote$RemoteModel$handleGraphqlError, cfg, error);
		}
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$findSavedRequest = F2(
	function (requestMsg, ongoingRequests) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.aM;
				},
				$elm$core$Basics$eq(requestMsg)),
			ongoingRequests);
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$create_handleResultResponse = F2(
	function (cfg, params) {
		var stateWithDroppedRequest = A2($author$project$Kernel$Aspect$Remote$RemoteModel$handleOngoingRequest, params.aI, cfg);
		var savedReq = A2($author$project$Kernel$Aspect$Remote$RemoteModel$findSavedRequest, cfg.R, cfg.aX.C);
		var handledTuple = function () {
			var _v0 = params.am;
			if (!_v0.$) {
				var value = _v0.a;
				return A2(params.aK, value, stateWithDroppedRequest);
			} else {
				var error = _v0.a;
				return A2(
					params.cw,
					error,
					A3($author$project$Kernel$Aspect$Remote$RemoteModel$revertState, stateWithDroppedRequest, savedReq, cfg.cK));
			}
		}();
		return A2($author$project$Kernel$Aspect$Utility$mergeTupleFromState, params.cv, handledTuple);
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$create_handleResultResponseSuccess = F2(
	function (cfg, params) {
		var state = cfg.aX;
		var stateWithDroppedRequest = A2($author$project$Kernel$Aspect$Remote$RemoteModel$handleOngoingRequest, params.aI, cfg);
		var savedRequest = A2($author$project$Kernel$Aspect$Remote$RemoteModel$findSavedRequest, cfg.R, cfg.aX.C);
		var _v0 = params.am;
		if (!_v0.$) {
			var value = _v0.a;
			return A2(params.aK, value, stateWithDroppedRequest);
		} else {
			var error = _v0.a;
			return _Utils_Tuple3(
				A3($author$project$Kernel$Aspect$Remote$RemoteModel$revertState, stateWithDroppedRequest, savedRequest, cfg.cK),
				$author$project$Kernel$Aspect$ErrorReporter$ErrorReporter$generalError(
					params.fi(error)),
				_List_fromArray(
					[
						A3(
						$author$project$Kernel$ToastMsgs$toastMsg.aQ,
						$elm$core$Maybe$Nothing,
						params.fi(error),
						_List_Nil)
					]));
		}
	});
var $author$project$Kernel$Aspect$Remote$RemoteModel$toResponseHandlers = function (cfg) {
	return {
		oi: $author$project$Kernel$Aspect$Remote$RemoteModel$create_handleResponse(cfg),
		oj: $author$project$Kernel$Aspect$Remote$RemoteModel$create_handleEndlessListResponse(cfg),
		ok: $author$project$Kernel$Aspect$Remote$RemoteModel$create_handleResultResponse(cfg),
		ol: $author$project$Kernel$Aspect$Remote$RemoteModel$create_handleResultResponseSuccess(cfg),
		om: $author$project$Kernel$Aspect$Remote$RemoteModel$create_handleResponseSuccess(cfg),
		on: $author$project$Kernel$Aspect$Remote$RemoteModel$create_handleResponseWithExpectedErr(cfg),
		oo: $author$project$Kernel$Aspect$Remote$RemoteModel$create_handleResponseWithExpectedErr_success(cfg)
	};
};
var $author$project$Remote$UpdateResponse$isTransientError = function (error) {
	return A2($elm$core$String$contains, 'Too many requests', error);
};
var $author$project$Remote$UpdateResponse$toastUnlessTransient = function (error) {
	return $author$project$Remote$UpdateResponse$isTransientError(error) ? _List_Nil : _List_fromArray(
		[
			A3($author$project$Kernel$RouteMsgs$routeMsg.aQ, $elm$core$Maybe$Nothing, error, _List_Nil)
		]);
};
var $author$project$Remote$Model$transformRevertState = F3(
	function (transform, correlationId, remote) {
		var wrappedRemote = remote;
		var unwrappedRemote = function () {
			var _v0 = A2(transform, correlationId, wrappedRemote);
			var transformedRemote = _v0;
			return transformedRemote;
		}();
		return unwrappedRemote;
	});
var $author$project$Remote$UpdateResponse$updateResponse = F4(
	function (topState, requestMsg, responseMsg, route) {
		var currentState = topState.eV.jr;
		var handle = $author$project$Kernel$Aspect$Remote$RemoteModel$toResponseHandlers(
			{
				hg: $author$project$Route$Route$authEntryRoute,
				fp: A2($author$project$Kernel$Aspect$Remote$RemoteModel$GeneralErrHandler_DefaultToast, 'Request failed', _List_Nil),
				R: requestMsg,
				aX: currentState,
				cK: $author$project$Remote$Model$transformRevertState
			});
		var clearMultiWatcherModeState = function (state) {
			return _Utils_update(
				state,
				{mb: $elm$core$Maybe$Nothing, c9: $elm$core$Maybe$Nothing, da: $elm$core$Maybe$Nothing, mV: $elm$core$Maybe$Nothing, d5: $elm$core$Maybe$Nothing, bz: $elm$core$Dict$empty, bm: $elm$core$Dict$empty, a3: $elm$core$Dict$empty, bn: $elm$core$Dict$empty, bA: $elm$core$Dict$empty, a4: $elm$core$Dict$empty, bX: _List_Nil, ej: $elm$core$Maybe$Nothing, nQ: $elm$core$Maybe$Nothing, bD: state.bD + 1, ek: _List_Nil, di: false, dk: $author$project$Types$PplnsProjection$PplnsNotRequested, az: $author$project$Remote$Model$initialWatcherAccess, eH: $elm$core$Maybe$Nothing, p1: $elm$core$Maybe$Nothing, cc: $elm$core$Maybe$Nothing, eI: $elm$core$Maybe$Nothing});
		};
		switch (responseMsg.$) {
			case 0:
				var result = responseMsg.a;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{pQ: $author$project$Types$UserSessionStatus$Unauthenticated}),
									$elm$core$Platform$Cmd$none,
									A2(
										$elm$core$List$cons,
										$author$project$Kernel$RouteMsgs$routeMsg.gu(
											$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$Login)),
										$author$project$Remote$UpdateResponse$toastUnlessTransient(error)));
							}),
						aK: F2(
							function (userSession, state) {
								var newUserId = $author$project$Types$User$unwrapUserId(userSession.mu);
								var bootstrapHistoryRequests = A2(
									$elm$core$List$map,
									$author$project$TopMsg$requestMsg,
									$author$project$Remote$HashrateHistory$bootstrapRequests(topState.ph));
								return _Utils_Tuple3(
									clearMultiWatcherModeState(
										_Utils_update(
											state,
											{
												g4: newUserId,
												pQ: $author$project$Types$UserSessionStatus$SessionFetched(userSession)
											})),
									$author$project$Kernel$Aspect$Browser$OpenNewTab$storeUserId(newUserId),
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$TopMsg$chartMsg($author$project$UI$Library$Chart$Msg$Reset),
												$author$project$TopMsg$remoteMsg($author$project$Remote$Msg$OnAuthSuccess),
												$author$project$TopMsg$globalMsg($author$project$Global$Msg$OnAuthSuccess),
												$author$project$TopMsg$requestMsg(
												$author$project$Remote$RequestMsg$CheckAuth(0))
											]),
										bootstrapHistoryRequests));
							}),
						am: result
					});
			case 9:
				var result = responseMsg.a;
				return handle.ol(
					{
						fi: $elm$core$Basics$identity,
						aI: false,
						aK: F2(
							function (userSession, state) {
								var subuserId = $author$project$Types$User$unwrapUserId(userSession.mu);
								var newUrl = '/?subaccount=' + subuserId;
								return _Utils_Tuple3(
									state,
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											$author$project$TopMsg$globalMsg(
											$author$project$Global$Msg$OpenNewTab(newUrl))
										]));
							}),
						am: result
					});
			case 1:
				var result = responseMsg.a;
				return handle.ol(
					{
						fi: $elm$core$Basics$identity,
						aI: false,
						aK: F2(
							function (_v1, state) {
								return _Utils_Tuple3(
									$author$project$Remote$Model$cleanUpRemote(
										_Utils_update(
											state,
											{g4: ''})),
									$author$project$Kernel$Aspect$Browser$OpenNewTab$clearSessionStorage(0),
									_List_fromArray(
										[
											$author$project$TopMsg$chartMsg($author$project$UI$Library$Chart$Msg$Reset),
											$author$project$TopMsg$authMsg($author$project$UI$Auth$Msg$InitModel),
											$author$project$Kernel$RouteMsgs$routeMsg.gu(
											$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$Login))
										]));
							}),
						am: result
					});
			case 2:
				return handle.om(
					{
						aI: false,
						aK: F2(
							function (self, state) {
								return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						am: $elm$core$Result$Ok(0)
					});
			case 3:
				var checkAuthContext = responseMsg.a;
				var result = responseMsg.b;
				var routeToMsgs = function () {
					if (route.$ === 1) {
						return _List_fromArray(
							[
								$author$project$Kernel$RouteMsgs$routeMsg.gu($author$project$Route$Route$Home)
							]);
					} else {
						return _List_Nil;
					}
				}();
				var authenticationErrorToast = (!checkAuthContext) ? _List_fromArray(
					[
						A3($author$project$Kernel$RouteMsgs$routeMsg.aQ, $elm$core$Maybe$Nothing, 'Authentication error, please sign in again', _List_Nil)
					]) : _List_Nil;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (_v2, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{pQ: $author$project$Types$UserSessionStatus$Unauthenticated}),
									$elm$core$Platform$Cmd$none,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$TopMsg$chartMsg($author$project$UI$Library$Chart$Msg$Reset)
											]),
										authenticationErrorToast));
							}),
						aK: F2(
							function (userSession, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{
											pQ: $author$project$Types$UserSessionStatus$SessionFetched(userSession)
										}),
									$elm$core$Platform$Cmd$none,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$TopMsg$remoteMsg($author$project$Remote$Msg$OnAuthSuccess),
												$author$project$TopMsg$globalMsg($author$project$Global$Msg$OnAuthSuccess)
											]),
										routeToMsgs));
							}),
						am: result
					});
			case 4:
				var result = responseMsg.a;
				return handle.ol(
					{
						fi: $elm$core$Basics$identity,
						aI: false,
						aK: F2(
							function (_v4, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{
											pQ: function () {
												var _v5 = state.pQ;
												if (_v5.$ === 2) {
													var userSession = _v5.a;
													return $author$project$Types$UserSessionStatus$SessionFetched(
														_Utils_update(
															userSession,
															{kD: true}));
												} else {
													return state.pQ;
												}
											}()
										}),
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A3($author$project$Kernel$RouteMsgs$routeMsg.ka, $elm$core$Maybe$Nothing, 'Email activated successfully', _List_Nil)
										]));
							}),
						am: result
					});
			case 5:
				var result = responseMsg.a;
				return handle.ol(
					{
						fi: $elm$core$Basics$identity,
						aI: false,
						aK: F2(
							function (_v6, state) {
								return _Utils_Tuple3(
									state,
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											$author$project$TopMsg$globalMsg($author$project$Global$Msg$EmailVerificationResent),
											A3($author$project$Kernel$RouteMsgs$routeMsg.ka, $elm$core$Maybe$Nothing, 'Verification email sent successfully', _List_Nil)
										]));
							}),
						am: result
					});
			case 6:
				var result = responseMsg.a;
				return handle.ol(
					{
						fi: $elm$core$Basics$identity,
						aI: false,
						aK: F2(
							function (userSession, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{
											pQ: $author$project$Types$UserSessionStatus$SessionFetched(userSession)
										}),
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											$author$project$TopMsg$globalMsg($author$project$Global$Msg$HideModal),
											A3($author$project$Kernel$RouteMsgs$routeMsg.ka, $elm$core$Maybe$Nothing, 'Two Factor Authentication activated successfully', _List_Nil)
										]));
							}),
						am: result
					});
			case 7:
				var result = responseMsg.a;
				return handle.ol(
					{
						fi: $elm$core$Basics$identity,
						aI: false,
						aK: F2(
							function (_v7, state) {
								return _Utils_Tuple3(
									state,
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A3($author$project$Kernel$RouteMsgs$routeMsg.ka, $elm$core$Maybe$Nothing, 'We have sent an email with a code to reset your password', _List_Nil),
											$author$project$TopMsg$authMsg(
											$author$project$UI$Auth$Msg$InputPassword('')),
											$author$project$TopMsg$authMsg(
											$author$project$UI$Auth$Msg$InputCode('')),
											$author$project$TopMsg$authMsg(
											$author$project$UI$Auth$Msg$InputTwoFaToken('')),
											$author$project$Kernel$RouteMsgs$routeMsg.gu(
											$author$project$Route$Route$Authentication(
												$author$project$UI$Auth$Route$ResetPassword(
													{ff: $elm$core$Maybe$Nothing})))
										]));
							}),
						am: result
					});
			case 8:
				var result = responseMsg.a;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								return ($author$project$Remote$UpdateResponse$isTwoFactorResetError(error) && (!topState.eV.hh.oh)) ? _Utils_Tuple3(
									state,
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											$author$project$TopMsg$authMsg($author$project$UI$Auth$Msg$ProceedToResetPasswordStepTwo)
										])) : _Utils_Tuple3(
									state,
									$elm$core$Platform$Cmd$none,
									$author$project$Remote$UpdateResponse$toastUnlessTransient(error));
							}),
						aK: F2(
							function (_v8, state) {
								return _Utils_Tuple3(
									state,
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A3($author$project$Kernel$RouteMsgs$routeMsg.ka, $elm$core$Maybe$Nothing, 'Password changed successfully', _List_Nil),
											$author$project$Kernel$RouteMsgs$routeMsg.gu(
											$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$Login)),
											$author$project$TopMsg$authMsg($author$project$UI$Auth$Msg$InitModel)
										]));
							}),
						am: result
					});
			case 10:
				var result = responseMsg.a;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								return $author$project$Remote$Model$isUserAuthenticated(state) ? _Utils_Tuple3(
									_Utils_update(
										state,
										{dA: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									$author$project$Remote$UpdateResponse$toastUnlessTransient(error)) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						aK: F2(
							function (hashrate, state) {
								return _Utils_Tuple3(
									state,
									$author$project$Remote$Model$isUserAuthenticated(state) ? A2(
										$elm$core$Task$perform,
										function (time) {
											return A2($author$project$Remote$ResponseMsg$UserHashrateTime, time, hashrate);
										},
										$elm$time$Time$now) : $elm$core$Platform$Cmd$none,
									_List_Nil);
							}),
						am: result
					});
			case 11:
				var time = responseMsg.a;
				var hashrate = responseMsg.b;
				return $author$project$Remote$Model$isUserAuthenticated(currentState) ? _Utils_Tuple3(
					_Utils_update(
						currentState,
						{
							mU: $elm$core$Maybe$Just(time),
							dA: $elm$core$Maybe$Just(hashrate)
						}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$TopMsg$chartMsg(
							$author$project$UI$Library$Chart$Msg$UpdateChartData(hashrate))
						])) : _Utils_Tuple3(currentState, $elm$core$Platform$Cmd$none, _List_Nil);
			case 13:
				var result = responseMsg.a;
				var requestSession = function () {
					if (requestMsg.$ === 12) {
						var watcherSession = requestMsg.a;
						return $elm$core$Maybe$Just(watcherSession);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var isMultiWatcherRequest = function (state) {
					if (!requestSession.$) {
						var session = requestSession.a;
						return ($elm$core$List$length(state.bX) > 1) && A2($elm$core$List$member, session, state.bX);
					} else {
						return false;
					}
				};
				var aggregateHashratePoints = function (points) {
					return A2(
						$elm$core$List$map,
						$elm$core$Tuple$second,
						A2(
							$elm$core$List$sortBy,
							$elm$core$Tuple$first,
							$elm$core$Dict$toList(
								A3(
									$elm$core$List$foldl,
									F2(
										function (point, acc) {
											var timestamp = $elm$time$Time$posixToMillis(point.ny);
											var existing = A2($elm$core$Dict$get, timestamp, acc);
											var merged = function () {
												if (!existing.$) {
													var accumulated = existing.a;
													return {ii: accumulated.ii + point.ii, ny: point.ny, n1: accumulated.n1 + point.n1, ay: accumulated.ay + point.ay};
												} else {
													return point;
												}
											}();
											return A3($elm$core$Dict$insert, timestamp, merged, acc);
										}),
									$elm$core$Dict$empty,
									points))));
				};
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								var stateWithAccess = function () {
									if (!requestSession.$) {
										var session = requestSession.a;
										return isMultiWatcherRequest(state) ? ($author$project$Remote$UpdateResponse$isWatcherAccessError(error) ? A3(
											$author$project$Remote$Model$setMultiWatcherHashrateLoadErrorForSession,
											session,
											false,
											A3($author$project$Remote$Model$setMultiWatcherHashrateAccessForSession, session, 2, state)) : A3(
											$author$project$Remote$Model$setMultiWatcherHashrateLoadErrorForSession,
											session,
											true,
											A3($author$project$Remote$Model$setMultiWatcherHashrateAccessForSession, session, 1, state))) : A3($author$project$Remote$UpdateResponse$markWatcherDeniedOnAccessError, 0, error, state);
									} else {
										return A3($author$project$Remote$UpdateResponse$markWatcherDeniedOnAccessError, 0, error, state);
									}
								}();
								return _Utils_Tuple3(
									_Utils_update(
										stateWithAccess,
										{dA: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							}),
						aK: F2(
							function (hashrate, state) {
								var maybeLivePoint = {
									ii: hashrate.ii,
									ny: A2($elm$core$Maybe$withDefault, topState.ph, hashrate.ny),
									n1: hashrate.n1,
									ay: hashrate.ay
								};
								var stateWithAccess = function () {
									if (isMultiWatcherRequest(state)) {
										if (!requestSession.$) {
											var session = requestSession.a;
											return A3(
												$author$project$Remote$Model$setMultiWatcherHashrateLoadErrorForSession,
												session,
												false,
												A3(
													$author$project$Remote$Model$setMultiWatcherHashrateAccessForSession,
													session,
													1,
													A3(
														$author$project$Remote$Model$setMultiWatcherHashrateForSession,
														session,
														_List_fromArray(
															[maybeLivePoint]),
														state)));
										} else {
											return state;
										}
									} else {
										return A3($author$project$Remote$Model$markWatcherAccess, 0, 1, state);
									}
								}();
								var stateWithAggregatedHashrate = _Utils_update(
									stateWithAccess,
									{
										mU: $elm$core$Maybe$Just(topState.ph),
										dA: $elm$core$Maybe$Just(hashrate)
									});
								var chartMsg = function () {
									if (isMultiWatcherRequest(state)) {
										var aggregatedHistory = aggregateHashratePoints(
											$elm$core$List$concat(
												$elm$core$Dict$values(stateWithAggregatedHashrate.bA)));
										return $author$project$TopMsg$chartMsg(
											$author$project$UI$Library$Chart$Msg$MergeHistoricalData(aggregatedHistory));
									} else {
										return $author$project$TopMsg$chartMsg(
											$author$project$UI$Library$Chart$Msg$UpdateChartData(hashrate));
									}
								}();
								return _Utils_Tuple3(
									stateWithAggregatedHashrate,
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[chartMsg]));
							}),
						am: result
					});
			case 14:
				var time = responseMsg.a;
				var hashrate = responseMsg.b;
				var requestSession = function () {
					if (requestMsg.$ === 12) {
						var session = requestMsg.a;
						return $elm$core$Maybe$Just(session);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var isMultiWatcherRequest = function (state) {
					if (!requestSession.$) {
						var session = requestSession.a;
						return ($elm$core$List$length(state.bX) > 1) && A2($elm$core$List$member, session, state.bX);
					} else {
						return false;
					}
				};
				var aggregateHashratePoints = function (points) {
					return A2(
						$elm$core$List$map,
						$elm$core$Tuple$second,
						A2(
							$elm$core$List$sortBy,
							$elm$core$Tuple$first,
							$elm$core$Dict$toList(
								A3(
									$elm$core$List$foldl,
									F2(
										function (point, acc) {
											var timestamp = $elm$time$Time$posixToMillis(point.ny);
											var existing = A2($elm$core$Dict$get, timestamp, acc);
											var merged = function () {
												if (!existing.$) {
													var accumulated = existing.a;
													return {ii: accumulated.ii + point.ii, ny: point.ny, n1: accumulated.n1 + point.n1, ay: accumulated.ay + point.ay};
												} else {
													return point;
												}
											}();
											return A3($elm$core$Dict$insert, timestamp, merged, acc);
										}),
									$elm$core$Dict$empty,
									points))));
				};
				if ($author$project$Remote$Model$isWatcherAuthenticated(currentState)) {
					var maybeLivePoint = {
						ii: hashrate.ii,
						ny: A2($elm$core$Maybe$withDefault, time, hashrate.ny),
						n1: hashrate.n1,
						ay: hashrate.ay
					};
					var stateWithAccess = function () {
						if (isMultiWatcherRequest(currentState)) {
							if (!requestSession.$) {
								var session = requestSession.a;
								return A3(
									$author$project$Remote$Model$setMultiWatcherHashrateLoadErrorForSession,
									session,
									false,
									A3(
										$author$project$Remote$Model$setMultiWatcherHashrateAccessForSession,
										session,
										1,
										A3(
											$author$project$Remote$Model$setMultiWatcherHashrateForSession,
											session,
											_List_fromArray(
												[maybeLivePoint]),
											currentState)));
							} else {
								return currentState;
							}
						} else {
							return A3($author$project$Remote$Model$markWatcherAccess, 0, 1, currentState);
						}
					}();
					var stateWithAggregatedHashrate = _Utils_update(
						stateWithAccess,
						{
							mU: $elm$core$Maybe$Just(time),
							dA: $elm$core$Maybe$Just(hashrate)
						});
					var chartMsg = function () {
						if (isMultiWatcherRequest(currentState)) {
							var aggregatedHistory = aggregateHashratePoints(
								$elm$core$List$concat(
									$elm$core$Dict$values(stateWithAggregatedHashrate.bA)));
							return $author$project$TopMsg$chartMsg(
								$author$project$UI$Library$Chart$Msg$MergeHistoricalData(aggregatedHistory));
						} else {
							return $author$project$TopMsg$chartMsg(
								$author$project$UI$Library$Chart$Msg$UpdateChartData(hashrate));
						}
					}();
					return _Utils_Tuple3(
						stateWithAggregatedHashrate,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[chartMsg]));
				} else {
					return _Utils_Tuple3(currentState, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var result = responseMsg.b;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (_v18, state) {
								return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						aK: F2(
							function (historyPoints, state) {
								return $author$project$Remote$Model$isUserAuthenticated(state) ? _Utils_Tuple3(
									state,
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											$author$project$TopMsg$chartMsg(
											$author$project$UI$Library$Chart$Msg$MergeHistoricalData(historyPoints))
										])) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						am: result
					});
			case 15:
				var result = responseMsg.b;
				var requestSession = function () {
					if (requestMsg.$ === 13) {
						var range = requestMsg.a;
						return $elm$core$Maybe$Just(
							{g_: range.g_, g4: range.g4});
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var isMultiWatcherRequest = function (state) {
					if (!requestSession.$) {
						var session = requestSession.a;
						return ($elm$core$List$length(state.bX) > 1) && A2($elm$core$List$member, session, state.bX);
					} else {
						return false;
					}
				};
				var aggregateHistoryPoints = function (points) {
					return A2(
						$elm$core$List$map,
						$elm$core$Tuple$second,
						A2(
							$elm$core$List$sortBy,
							$elm$core$Tuple$first,
							$elm$core$Dict$toList(
								A3(
									$elm$core$List$foldl,
									F2(
										function (point, acc) {
											var timestamp = $elm$time$Time$posixToMillis(point.ny);
											var existing = A2($elm$core$Dict$get, timestamp, acc);
											var merged = function () {
												if (!existing.$) {
													var accumulated = existing.a;
													return {ii: accumulated.ii + point.ii, ny: point.ny, n1: accumulated.n1 + point.n1, ay: accumulated.ay + point.ay};
												} else {
													return point;
												}
											}();
											return A3($elm$core$Dict$insert, timestamp, merged, acc);
										}),
									$elm$core$Dict$empty,
									points))));
				};
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								var stateWithSessionError = function () {
									if (!requestSession.$) {
										var session = requestSession.a;
										return isMultiWatcherRequest(state) ? ($author$project$Remote$UpdateResponse$isWatcherAccessError(error) ? A3(
											$author$project$Remote$Model$setMultiWatcherHashrateLoadErrorForSession,
											session,
											false,
											A3($author$project$Remote$Model$setMultiWatcherHashrateAccessForSession, session, 2, state)) : A3(
											$author$project$Remote$Model$setMultiWatcherHashrateLoadErrorForSession,
											session,
											true,
											A3($author$project$Remote$Model$setMultiWatcherHashrateAccessForSession, session, 1, state))) : A3($author$project$Remote$UpdateResponse$markWatcherDeniedOnAccessError, 0, error, state);
									} else {
										return A3($author$project$Remote$UpdateResponse$markWatcherDeniedOnAccessError, 0, error, state);
									}
								}();
								return _Utils_Tuple3(stateWithSessionError, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						aK: F2(
							function (historyPoints, state) {
								if ($author$project$Remote$Model$isWatcherAuthenticated(state)) {
									if (!requestSession.$) {
										var session = requestSession.a;
										var stateWithSessionHistory = isMultiWatcherRequest(state) ? function (s) {
											return _Utils_update(
												s,
												{
													mU: $elm$core$Maybe$Just(topState.ph)
												});
										}(
											A3(
												$author$project$Remote$Model$setMultiWatcherHashrateLoadErrorForSession,
												session,
												false,
												A3(
													$author$project$Remote$Model$setMultiWatcherHashrateAccessForSession,
													session,
													1,
													A3($author$project$Remote$Model$setMultiWatcherHashrateForSession, session, historyPoints, state)))) : A3(
											$author$project$Remote$Model$markWatcherAccess,
											0,
											1,
											_Utils_update(
												state,
												{
													mU: $elm$core$Maybe$Just(topState.ph)
												}));
										var aggregatedHistory = isMultiWatcherRequest(state) ? aggregateHistoryPoints(
											$elm$core$List$concat(
												$elm$core$Dict$values(stateWithSessionHistory.bA))) : historyPoints;
										return _Utils_Tuple3(
											stateWithSessionHistory,
											$elm$core$Platform$Cmd$none,
											_List_fromArray(
												[
													$author$project$TopMsg$chartMsg(
													$author$project$UI$Library$Chart$Msg$MergeHistoricalData(aggregatedHistory))
												]));
									} else {
										return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
									}
								} else {
									return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
								}
							}),
						am: result
					});
			case 16:
				var durationSeconds = responseMsg.a;
				var result = responseMsg.b;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						aK: F2(
							function (averageHashrate, state) {
								var updatedState = function () {
									switch (durationSeconds) {
										case 3600:
											return _Utils_update(
												state,
												{ft: averageHashrate});
										case 21600:
											return _Utils_update(
												state,
												{fu: averageHashrate});
										default:
											return state;
									}
								}();
								return _Utils_Tuple3(updatedState, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						am: result
					});
			case 17:
				var address = responseMsg.a;
				var result = responseMsg.b;
				return handle.ol(
					{
						fi: $elm$core$Basics$identity,
						aI: false,
						aK: F2(
							function (_v25, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{
											pQ: function () {
												var _v26 = state.pQ;
												if (_v26.$ === 2) {
													var userSession = _v26.a;
													return $author$project$Types$UserSessionStatus$SessionFetched(
														_Utils_update(
															userSession,
															{
																hl: $elm$core$Maybe$Just(address)
															}));
												} else {
													return state.pQ;
												}
											}()
										}),
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A3($author$project$Kernel$RouteMsgs$routeMsg.ka, $elm$core$Maybe$Nothing, 'Bitcoin address updated successfully', _List_Nil),
											$author$project$TopMsg$requestMsg(
											$author$project$Remote$RequestMsg$CheckAuth(1)),
											$author$project$TopMsg$globalMsg($author$project$Global$Msg$HideModal)
										]));
							}),
						am: result
					});
			case 19:
				var result = responseMsg.a;
				var workersRequest = function () {
					if (requestMsg.$ === 30) {
						var request = requestMsg.a;
						return request;
					} else {
						return {hO: $elm$core$Maybe$Nothing, v: $author$project$Remote$RequestMsg$defaultWorkersPageLimit, iX: 0, g_: ''};
					}
				}();
				var smoothWorkerHashrate = F2(
					function (prevWorkers, newWorkers) {
						var smoothMaybe = F2(
							function (newValue, prevValue) {
								var _v30 = _Utils_Tuple2(newValue, prevValue);
								if ((!_v30.a.$) && (!_v30.b.$)) {
									var newHr = _v30.a.a;
									var prevHr = _v30.b.a;
									return $elm$core$Maybe$Just(($author$project$UI$Library$Chart$View$ewmaAlpha * newHr) + ((1 - $author$project$UI$Library$Chart$View$ewmaAlpha) * prevHr));
								} else {
									return newValue;
								}
							});
						var prevByName = $elm$core$Dict$fromList(
							A2(
								$elm$core$List$map,
								function (worker) {
									return _Utils_Tuple2(worker.aJ, worker);
								},
								prevWorkers));
						return A2(
							$elm$core$List$map,
							function (worker) {
								var prevWorker = A2($elm$core$Dict$get, worker.aJ, prevByName);
								return _Utils_update(
									worker,
									{
										ii: A2(
											smoothMaybe,
											worker.ii,
											A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.ii;
												},
												prevWorker)),
										d1: A2(
											smoothMaybe,
											worker.d1,
											A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.d1;
												},
												prevWorker))
									});
							},
							newWorkers);
					});
				var appendAndDedupeByName = F2(
					function (existingWorkers, incomingWorkers) {
						var incomingByName = $elm$core$Dict$fromList(
							A2(
								$elm$core$List$map,
								function (worker) {
									return _Utils_Tuple2(worker.aJ, worker);
								},
								incomingWorkers));
						var updatedExistingWorkers = A2(
							$elm$core$List$map,
							function (worker) {
								return A2(
									$elm$core$Maybe$withDefault,
									worker,
									A2($elm$core$Dict$get, worker.aJ, incomingByName));
							},
							existingWorkers);
						var existingNames = $elm$core$Set$fromList(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.aJ;
								},
								existingWorkers));
						var appendedWorkers = A2(
							$elm$core$List$filter,
							function (worker) {
								return !A2($elm$core$Set$member, worker.aJ, existingNames);
							},
							incomingWorkers);
						return _Utils_ap(updatedExistingWorkers, appendedWorkers);
					});
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								return $author$project$Remote$Model$isUserAuthenticated(state) ? _Utils_Tuple3(
									_Utils_update(
										state,
										{eM: 0}),
									$elm$core$Platform$Cmd$none,
									$author$project$Remote$UpdateResponse$toastUnlessTransient(error)) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						aK: F2(
							function (page, state) {
								if ($author$project$Remote$Model$isUserAuthenticated(state)) {
									var previousWorkers = A2($elm$core$Maybe$withDefault, _List_Nil, state.bJ);
									var smoothedWorkers = A2(smoothWorkerHashrate, previousWorkers, page.bJ);
									var nextWorkersRequest = function () {
										var _v29 = page.bB;
										if (!_v29.$) {
											var nextCursor = _v29.a;
											return _List_fromArray(
												[
													$author$project$TopMsg$requestMsg(
													$author$project$Remote$RequestMsg$WorkersInfo(
														{
															hO: $elm$core$Maybe$Just(nextCursor),
															v: workersRequest.v,
															iX: 1,
															g_: workersRequest.g_
														}))
												]);
										} else {
											return _List_Nil;
										}
									}();
									var nextPaginationStatus = function () {
										var _v28 = page.bB;
										if (!_v28.$) {
											return 2;
										} else {
											return 0;
										}
									}();
									var mergedWorkers = function () {
										var _v27 = workersRequest.iX;
										if (!_v27) {
											return smoothedWorkers;
										} else {
											return A2(appendAndDedupeByName, previousWorkers, smoothedWorkers);
										}
									}();
									return _Utils_Tuple3(
										_Utils_update(
											state,
											{
												mY: $elm$core$Maybe$Just(topState.ph),
												bJ: $elm$core$Maybe$Just(mergedWorkers),
												eL: page.bB,
												eM: nextPaginationStatus
											}),
										$elm$core$Platform$Cmd$none,
										nextWorkersRequest);
								} else {
									return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
								}
							}),
						am: result
					});
			case 20:
				var result = responseMsg.a;
				var workersRequest = function () {
					if (requestMsg.$ === 31) {
						var request = requestMsg.a;
						return request;
					} else {
						return {hO: $elm$core$Maybe$Nothing, v: $author$project$Remote$RequestMsg$defaultWorkersPageLimit, iX: 0, g_: '', g4: ''};
					}
				}();
				var smoothWorkerHashrate = F2(
					function (prevWorkers, newWorkers) {
						var smoothMaybe = F2(
							function (newValue, prevValue) {
								var _v35 = _Utils_Tuple2(newValue, prevValue);
								if ((!_v35.a.$) && (!_v35.b.$)) {
									var newHr = _v35.a.a;
									var prevHr = _v35.b.a;
									return $elm$core$Maybe$Just(($author$project$UI$Library$Chart$View$ewmaAlpha * newHr) + ((1 - $author$project$UI$Library$Chart$View$ewmaAlpha) * prevHr));
								} else {
									return newValue;
								}
							});
						var prevByName = $elm$core$Dict$fromList(
							A2(
								$elm$core$List$map,
								function (worker) {
									return _Utils_Tuple2(worker.aJ, worker);
								},
								prevWorkers));
						return A2(
							$elm$core$List$map,
							function (worker) {
								var prevWorker = A2($elm$core$Dict$get, worker.aJ, prevByName);
								return _Utils_update(
									worker,
									{
										ii: A2(
											smoothMaybe,
											worker.ii,
											A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.ii;
												},
												prevWorker)),
										d1: A2(
											smoothMaybe,
											worker.d1,
											A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.d1;
												},
												prevWorker))
									});
							},
							newWorkers);
					});
				var appendAndDedupeByName = F2(
					function (existingWorkers, incomingWorkers) {
						var incomingByName = $elm$core$Dict$fromList(
							A2(
								$elm$core$List$map,
								function (worker) {
									return _Utils_Tuple2(worker.aJ, worker);
								},
								incomingWorkers));
						var updatedExistingWorkers = A2(
							$elm$core$List$map,
							function (worker) {
								return A2(
									$elm$core$Maybe$withDefault,
									worker,
									A2($elm$core$Dict$get, worker.aJ, incomingByName));
							},
							existingWorkers);
						var existingNames = $elm$core$Set$fromList(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.aJ;
								},
								existingWorkers));
						var appendedWorkers = A2(
							$elm$core$List$filter,
							function (worker) {
								return !A2($elm$core$Set$member, worker.aJ, existingNames);
							},
							incomingWorkers);
						return _Utils_ap(updatedExistingWorkers, appendedWorkers);
					});
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								var stateWithAccess = A3($author$project$Remote$UpdateResponse$markWatcherDeniedOnAccessError, 1, error, state);
								return _Utils_Tuple3(
									_Utils_update(
										stateWithAccess,
										{eM: 0}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							}),
						aK: F2(
							function (page, state) {
								var stateWithAccess = A3($author$project$Remote$Model$markWatcherAccess, 1, 1, state);
								var previousWorkers = A2($elm$core$Maybe$withDefault, _List_Nil, state.bJ);
								var smoothedWorkers = A2(smoothWorkerHashrate, previousWorkers, page.bJ);
								var nextWorkersRequest = function () {
									var _v34 = page.bB;
									if (!_v34.$) {
										var nextCursor = _v34.a;
										return _List_fromArray(
											[
												$author$project$TopMsg$requestMsg(
												$author$project$Remote$RequestMsg$WatcherWorkersInfo(
													{
														hO: $elm$core$Maybe$Just(nextCursor),
														v: workersRequest.v,
														iX: 1,
														g_: workersRequest.g_,
														g4: workersRequest.g4
													}))
											]);
									} else {
										return _List_Nil;
									}
								}();
								var nextPaginationStatus = function () {
									var _v33 = page.bB;
									if (!_v33.$) {
										return 2;
									} else {
										return 0;
									}
								}();
								var mergedWorkers = function () {
									var _v32 = workersRequest.iX;
									if (!_v32) {
										return smoothedWorkers;
									} else {
										return A2(appendAndDedupeByName, previousWorkers, smoothedWorkers);
									}
								}();
								return _Utils_Tuple3(
									_Utils_update(
										stateWithAccess,
										{
											mY: $elm$core$Maybe$Just(topState.ph),
											bJ: $elm$core$Maybe$Just(mergedWorkers),
											eL: page.bB,
											eM: nextPaginationStatus
										}),
									$elm$core$Platform$Cmd$none,
									nextWorkersRequest);
							}),
						am: result
					});
			case 21:
				var subAccountId = responseMsg.a;
				var result = responseMsg.b;
				var workersRequest = function () {
					if (requestMsg.$ === 32) {
						var request = requestMsg.a;
						return request;
					} else {
						return {kC: _List_Nil, hO: $elm$core$Maybe$Nothing, v: $author$project$Remote$RequestMsg$defaultWorkersPageLimit, iX: 0, o3: subAccountId, g_: ''};
					}
				}();
				var appendAndDedupeByName = F2(
					function (existingWorkers, incomingWorkers) {
						var incomingByName = $elm$core$Dict$fromList(
							A2(
								$elm$core$List$map,
								function (worker) {
									return _Utils_Tuple2(worker.aJ, worker);
								},
								incomingWorkers));
						var updatedExistingWorkers = A2(
							$elm$core$List$map,
							function (worker) {
								return A2(
									$elm$core$Maybe$withDefault,
									worker,
									A2($elm$core$Dict$get, worker.aJ, incomingByName));
							},
							existingWorkers);
						var existingNames = $elm$core$Set$fromList(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.aJ;
								},
								existingWorkers));
						var appendedWorkers = A2(
							$elm$core$List$filter,
							function (worker) {
								return !A2($elm$core$Set$member, worker.aJ, existingNames);
							},
							incomingWorkers);
						return _Utils_ap(updatedExistingWorkers, appendedWorkers);
					});
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (_v37, state) {
								return A2($author$project$Remote$UpdateResponse$currentSubAccountExists, subAccountId, state) ? _Utils_Tuple3(
									_Utils_update(
										state,
										{
											eR: A3($elm$core$Dict$insert, subAccountId, _List_Nil, state.eR)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						aK: F2(
							function (page, state) {
								var previousWorkers = workersRequest.kC;
								var mergedWorkers = A2(appendAndDedupeByName, previousWorkers, page.bJ);
								var nextWorkersRequest = function () {
									var _v39 = page.bB;
									if (!_v39.$) {
										var nextCursor = _v39.a;
										return _List_fromArray(
											[
												$author$project$TopMsg$requestMsg(
												$author$project$Remote$RequestMsg$AggregateSubAccountWorkersInfo(
													{
														kC: mergedWorkers,
														hO: $elm$core$Maybe$Just(nextCursor),
														v: workersRequest.v,
														iX: 1,
														o3: workersRequest.o3,
														g_: workersRequest.g_
													}))
											]);
									} else {
										return _List_Nil;
									}
								}();
								var _v38 = page.bB;
								if (!_v38.$) {
									return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, nextWorkersRequest);
								} else {
									return A2($author$project$Remote$UpdateResponse$currentSubAccountExists, subAccountId, state) ? _Utils_Tuple3(
										_Utils_update(
											state,
											{
												eR: A3($elm$core$Dict$insert, subAccountId, mergedWorkers, state.eR)
											}),
										$elm$core$Platform$Cmd$none,
										_List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
								}
							}),
						am: result
					});
			case 18:
				var result = responseMsg.a;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								return _Utils_Tuple3(
									state,
									$elm$core$Platform$Cmd$none,
									$author$project$Remote$UpdateResponse$toastUnlessTransient(error));
							}),
						aK: F2(
							function (report, _v41) {
								return _Utils_Tuple3(
									_Utils_update(
										currentState,
										{
											iK: $elm$core$Maybe$Just(topState.ph)
										}),
									A3(
										$author$project$Types$Report$saveReportAsJsonFile,
										report,
										currentState.jv,
										$author$project$UI$Util$currentDateString(topState.ph)),
									_List_fromArray(
										[
											A3($author$project$Kernel$RouteMsgs$routeMsg.ka, $elm$core$Maybe$Nothing, 'Workers report downloaded successfully', _List_Nil)
										]));
							}),
						am: result
					});
			case 22:
				var result = responseMsg.a;
				return handle.ol(
					{
						fi: $elm$core$Basics$identity,
						aI: false,
						aK: F2(
							function (_v42, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{jQ: false, j1: '', j2: ''}),
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A3($author$project$Kernel$RouteMsgs$routeMsg.ka, $elm$core$Maybe$Nothing, 'SubAccount created successfully', _List_Nil),
											$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RetrieveSubAccount)
										]));
							}),
						am: result
					});
			case 23:
				var result = responseMsg.a;
				return handle.ol(
					{
						fi: $elm$core$Basics$identity,
						aI: false,
						aK: F2(
							function (_v43, state) {
								return _Utils_Tuple3(
									state,
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A3($author$project$Kernel$RouteMsgs$routeMsg.ka, $elm$core$Maybe$Nothing, 'Subaccount name updated successfully', _List_Nil),
											$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RetrieveSubAccount),
											$author$project$TopMsg$globalMsg($author$project$Global$Msg$HideModal)
										]));
							}),
						am: result
					});
			case 24:
				var result = responseMsg.a;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								if ($author$project$Remote$Model$isUserAuthenticated(state)) {
									var resetAggregateScopeRequests = (topState.eV.me.dD === 1) ? _List_fromArray(
										[
											$author$project$TopMsg$globalMsg(
											$author$project$Global$Msg$SelectAccountDataScope(0))
										]) : _List_Nil;
									return _Utils_Tuple3(
										_Utils_update(
											state,
											{ex: $elm$core$Maybe$Nothing, gO: false}),
										$elm$core$Platform$Cmd$none,
										_Utils_ap(
											resetAggregateScopeRequests,
											$author$project$Remote$UpdateResponse$toastUnlessTransient(error)));
								} else {
									return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
								}
							}),
						aK: F2(
							function (subAccounts, state) {
								if ($author$project$Remote$Model$isUserAuthenticated(state)) {
									var summaryRequests = A2(
										$elm$core$List$map,
										function (sub) {
											return $author$project$TopMsg$requestMsg(
												$author$project$Remote$RequestMsg$FetchSubAccountSummary(sub.mu));
										},
										subAccounts);
									var isAggregateData = topState.eV.me.dD === 1;
									var resetAggregateScopeRequests = (isAggregateData && $elm$core$List$isEmpty(subAccounts)) ? _List_fromArray(
										[
											$author$project$TopMsg$globalMsg(
											$author$project$Global$Msg$SelectAccountDataScope(0))
										]) : _List_Nil;
									var currentSubAccountIds = $elm$core$Set$fromList(
										A2(
											$elm$core$List$map,
											function ($) {
												return $.mu;
											},
											subAccounts));
									var keepCurrentSubAccount = F2(
										function (subAccountId, _v44) {
											return A2($elm$core$Set$member, subAccountId, currentSubAccountIds);
										});
									var aggregateWorkerRequests = (isAggregateData && (_Utils_eq(route, $author$project$Route$Route$Workers) || _Utils_eq(route, $author$project$Route$Route$Connections))) ? A2(
										$elm$core$List$map,
										function (sub) {
											return $author$project$TopMsg$requestMsg(
												$author$project$Remote$RequestMsg$AggregateSubAccountWorkersInfo(
													{kC: _List_Nil, hO: $elm$core$Maybe$Nothing, v: $author$project$Remote$RequestMsg$defaultWorkersPageLimit, iX: 0, o3: sub.mu, g_: sub.g_}));
										},
										subAccounts) : _List_Nil;
									var aggregateGeneratedBTCRequests = (isAggregateData && _Utils_eq(route, $author$project$Route$Route$GeneratedBitcoin)) ? A2(
										$elm$core$List$map,
										function (sub) {
											return $author$project$TopMsg$requestMsg(
												$author$project$Remote$RequestMsg$AggregateSubAccountGeneratedBTC(
													{
														l$: $elm$core$Maybe$Just(sub.g_),
														o3: sub.mu,
														g_: sub.l8
													}));
										},
										subAccounts) : _List_Nil;
									return _Utils_Tuple3(
										_Utils_update(
											state,
											{
												eQ: A2($elm$core$Dict$filter, keepCurrentSubAccount, state.eQ),
												eR: A2($elm$core$Dict$filter, keepCurrentSubAccount, state.eR),
												gM: A2($elm$core$Dict$filter, keepCurrentSubAccount, state.gM),
												ex: $elm$core$Maybe$Just(subAccounts),
												gO: true
											}),
										$elm$core$Platform$Cmd$none,
										_Utils_ap(
											summaryRequests,
											_Utils_ap(
												aggregateWorkerRequests,
												_Utils_ap(aggregateGeneratedBTCRequests, resetAggregateScopeRequests))));
								} else {
									return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
								}
							}),
						am: result
					});
			case 25:
				var subId = responseMsg.a;
				var result = responseMsg.b;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (_v45, state) {
								return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						aK: F2(
							function (summary, state) {
								return $author$project$Remote$Model$isUserAuthenticated(state) ? _Utils_Tuple3(
									_Utils_update(
										state,
										{
											gM: A3($elm$core$Dict$insert, subId, summary, state.gM)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						am: result
					});
			case 26:
				var result = responseMsg.a;
				return handle.ol(
					{
						fi: $elm$core$Basics$identity,
						aI: false,
						aK: F2(
							function (permissions, state) {
								return $author$project$Remote$Model$isUserAuthenticated(state) ? _Utils_Tuple3(
									_Utils_update(
										state,
										{
											nR: $elm$core$Maybe$Just(permissions)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						am: result
					});
			case 27:
				var result = responseMsg.a;
				return handle.ol(
					{
						fi: $elm$core$Basics$identity,
						aI: false,
						aK: F2(
							function (brokerSession, state) {
								var brokerSessionJson = A2(
									$elm$json$Json$Encode$encode,
									0,
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'id',
												$elm$json$Json$Encode$string(brokerSession.mu)),
												_Utils_Tuple2(
												'email',
												$elm$json$Json$Encode$string(brokerSession.ff)),
												_Utils_Tuple2(
												'referenceCode',
												$elm$json$Json$Encode$string(brokerSession.oc))
											])));
								return _Utils_Tuple3(
									clearMultiWatcherModeState(
										_Utils_update(
											state,
											{
												dI: $author$project$Types$BrokerSessionStatus$BrokerSessionFetched(brokerSession),
												pQ: $author$project$Types$UserSessionStatus$Unauthenticated
											})),
									$author$project$Kernel$Aspect$Browser$OpenNewTab$storeBrokerSession(brokerSessionJson),
									_List_fromArray(
										[
											$author$project$TopMsg$remoteMsg($author$project$Remote$Msg$OnBrokerAuthSuccess),
											$author$project$TopMsg$globalMsg($author$project$Global$Msg$OnBrokerAuthSuccess)
										]));
							}),
						am: result
					});
			case 28:
				var result = responseMsg.a;
				return handle.ol(
					{
						fi: $elm$core$Basics$identity,
						aI: false,
						aK: F2(
							function (_v46, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{e$: $elm$core$Maybe$Nothing, dI: $author$project$Types$BrokerSessionStatus$BrokerUnauthenticated}),
									$author$project$Kernel$Aspect$Browser$OpenNewTab$clearBrokerSession(0),
									_List_fromArray(
										[
											$author$project$TopMsg$authMsg($author$project$UI$Auth$Msg$InitModel),
											$author$project$Kernel$RouteMsgs$routeMsg.gu(
											$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$BrokerLogin))
										]));
							}),
						am: result
					});
			case 29:
				var result = responseMsg.a;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (_v47, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{e$: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							}),
						aK: F2(
							function (clients, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{
											e$: $elm$core$Maybe$Just(clients)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							}),
						am: result
					});
			case 30:
				var result = responseMsg.a;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (_v48, state) {
								return (_Utils_eq(route, $author$project$Route$Route$GeneratedBitcoin) && ($author$project$Remote$Model$isUserAuthenticated(state) && (!topState.eV.me.dD))) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : ($author$project$Remote$Model$isUserAuthenticated(state) ? _Utils_Tuple3(
									_Utils_update(
										state,
										{
											mb: (topState.eV.me.dD === 1) ? $elm$core$Maybe$Just(_List_Nil) : $elm$core$Maybe$Nothing
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil));
							}),
						aK: F2(
							function (generatedEntries, state) {
								return $author$project$Remote$Model$isUserAuthenticated(state) ? _Utils_Tuple3(
									_Utils_update(
										state,
										{
											mb: $elm$core$Maybe$Just(generatedEntries),
											c9: $elm$core$Maybe$Just(topState.ph)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						am: result
					});
			case 31:
				var result = responseMsg.a;
				var requestSession = function () {
					if (requestMsg.$ === 16) {
						var session = requestMsg.a;
						return $elm$core$Maybe$Just(session);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var requestIsForActiveWatcher = function (state) {
					if (!requestSession.$) {
						var session = requestSession.a;
						return $elm$core$List$isEmpty(state.bX) ? _Utils_eq(
							$author$project$Remote$Model$toWatcherSession(state),
							$elm$core$Maybe$Just(session)) : A2($elm$core$List$member, session, state.bX);
					} else {
						return false;
					}
				};
				var isMultiWatcherRequest = function (state) {
					return requestIsForActiveWatcher(state) && ($elm$core$List$length(state.bX) > 1);
				};
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								var stateWithSessionAccess = function () {
									if (requestIsForActiveWatcher(state)) {
										if (!requestSession.$) {
											var session = requestSession.a;
											return $author$project$Remote$UpdateResponse$isWatcherAccessError(error) ? A3(
												$author$project$Remote$Model$setMultiWatcherGeneratedBTCLoadErrorForSession,
												session,
												false,
												A3($author$project$Remote$Model$setMultiWatcherGeneratedBTCAccessForSession, session, 2, state)) : A3(
												$author$project$Remote$Model$setMultiWatcherGeneratedBTCLoadErrorForSession,
												session,
												true,
												A3($author$project$Remote$Model$setMultiWatcherGeneratedBTCAccessForSession, session, 1, state));
										} else {
											return state;
										}
									} else {
										return state;
									}
								}();
								var stateToReturn = (!requestIsForActiveWatcher(state)) ? state : (isMultiWatcherRequest(state) ? stateWithSessionAccess : (($author$project$Remote$UpdateResponse$isWatcherAccessError(error) || (!_Utils_eq(route, $author$project$Route$Route$GeneratedBitcoin))) ? A3(
									$author$project$Remote$UpdateResponse$markWatcherDeniedOnAccessError,
									2,
									error,
									_Utils_update(
										stateWithSessionAccess,
										{mb: $elm$core$Maybe$Nothing})) : stateWithSessionAccess));
								return _Utils_Tuple3(stateToReturn, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						aK: F2(
							function (generatedEntries, state) {
								var stateWithSessionEntries = function () {
									if (requestIsForActiveWatcher(state)) {
										if (!requestSession.$) {
											var session = requestSession.a;
											return A3(
												$author$project$Remote$Model$setMultiWatcherGeneratedBTCLoadErrorForSession,
												session,
												false,
												A3(
													$author$project$Remote$Model$setMultiWatcherGeneratedBTCAccessForSession,
													session,
													1,
													A3($author$project$Remote$Model$setMultiWatcherGeneratedBTCForSession, session, generatedEntries, state)));
										} else {
											return state;
										}
									} else {
										return state;
									}
								}();
								var stateToReturn = (!requestIsForActiveWatcher(state)) ? state : (isMultiWatcherRequest(state) ? stateWithSessionEntries : A3(
									$author$project$Remote$Model$markWatcherAccess,
									2,
									1,
									_Utils_update(
										stateWithSessionEntries,
										{
											mb: $elm$core$Maybe$Just(generatedEntries),
											c9: $elm$core$Maybe$Just(topState.ph)
										})));
								var payoutRequests = function () {
									if (!requestSession.$) {
										var session = requestSession.a;
										return (requestIsForActiveWatcher(state) && ((_Utils_eq(route, $author$project$Route$Route$Payouts) || (_Utils_eq(route, $author$project$Route$Route$GeneratedBitcoin) && (!topState.eV.me.dD))) && ($author$project$Remote$Model$watcherCanViewPayouts(stateToReturn) && A3(
											$author$project$Remote$Model$payoutsAreStaleForContext,
											topState.ph,
											A2($author$project$Types$Payout$WatcherPayoutContext, session.g4, session.g_),
											stateToReturn)))) ? _List_fromArray(
											[
												$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$LoadWatcherPayouts)
											]) : _List_Nil;
									} else {
										return _List_Nil;
									}
								}();
								return _Utils_Tuple3(stateToReturn, $elm$core$Platform$Cmd$none, payoutRequests);
							}),
						am: result
					});
			case 32:
				var result = responseMsg.a;
				var requestUserId = function () {
					if (requestMsg.$ === 17) {
						var userId = requestMsg.a;
						return $elm$core$Maybe$Just(userId);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var requestIsForActiveUser = function (state) {
					var _v54 = _Utils_Tuple2(
						requestUserId,
						$author$project$Remote$Model$toUserSession(state));
					if ((!_v54.a.$) && (!_v54.b.$)) {
						var userId = _v54.a.a;
						var userSession = _v54.b.a;
						return _Utils_eq(
							$author$project$Types$User$unwrapUserId(userSession.mu),
							userId);
					} else {
						return false;
					}
				};
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								return (!requestIsForActiveUser(state)) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : ($author$project$Remote$UpdateResponse$isPplnsProjectionMissingError(error) ? _Utils_Tuple3(
									A2(
										$author$project$Remote$UpdateResponse$markPplnsProjectionFetched,
										topState.ph,
										_Utils_update(
											state,
											{dk: $author$project$Types$PplnsProjection$PplnsUnavailable})),
									$elm$core$Platform$Cmd$none,
									_List_Nil) : ($author$project$Remote$UpdateResponse$isWatcherAccessError(error) ? _Utils_Tuple3(
									A2(
										$author$project$Remote$UpdateResponse$markPplnsProjectionFetched,
										topState.ph,
										$author$project$Remote$UpdateResponse$markPplnsProjectionFailedUnlessLoaded(state)),
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											$author$project$TopMsg$requestMsg(
											$author$project$Remote$RequestMsg$CheckAuth(1))
										])) : _Utils_Tuple3(
									A2(
										$author$project$Remote$UpdateResponse$markPplnsProjectionFetched,
										topState.ph,
										$author$project$Remote$UpdateResponse$markPplnsProjectionFailedUnlessLoaded(state)),
									$elm$core$Platform$Cmd$none,
									_List_Nil)));
							}),
						aK: F2(
							function (projection, state) {
								return (!requestIsForActiveUser(state)) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : (_Utils_eq(
									requestUserId,
									$elm$core$Maybe$Just(projection.j3)) ? _Utils_Tuple3(
									A2(
										$author$project$Remote$UpdateResponse$markPplnsProjectionFetched,
										topState.ph,
										_Utils_update(
											state,
											{
												dk: $author$project$Types$PplnsProjection$PplnsLoaded(projection)
											})),
									$elm$core$Platform$Cmd$none,
									_List_Nil) : _Utils_Tuple3(
									$author$project$Remote$UpdateResponse$markPplnsProjectionFailedUnlessLoaded(state),
									$elm$core$Platform$Cmd$none,
									_List_Nil));
							}),
						am: result
					});
			case 33:
				var result = responseMsg.a;
				var requestSession = function () {
					if (requestMsg.$ === 18) {
						var watcherSession = requestMsg.a;
						return $elm$core$Maybe$Just(watcherSession);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var requestIsForActiveSingleWatcher = function (state) {
					if (!requestSession.$) {
						var watcherSession = requestSession.a;
						return _Utils_eq(
							$author$project$Remote$Model$toWatcherSession(state),
							$elm$core$Maybe$Just(watcherSession)) && _Utils_eq(
							state.bX,
							_List_fromArray(
								[watcherSession]));
					} else {
						return false;
					}
				};
				var projectionMatchesRequest = function (projection) {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (session) {
								return A2($author$project$Remote$UpdateResponse$decimalStringsMatch, session.g4, projection.j3);
							},
							requestSession));
				};
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								return (!requestIsForActiveSingleWatcher(state)) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : ($author$project$Remote$UpdateResponse$isWatcherAccessError(error) ? _Utils_Tuple3(
									A2(
										$author$project$Remote$UpdateResponse$markPplnsProjectionFetched,
										topState.ph,
										A3(
											$author$project$Remote$Model$markWatcherAccess,
											3,
											2,
											_Utils_update(
												state,
												{dk: $author$project$Types$PplnsProjection$PplnsUnavailable}))),
									$elm$core$Platform$Cmd$none,
									_List_Nil) : ($author$project$Remote$UpdateResponse$isPplnsProjectionMissingError(error) ? _Utils_Tuple3(
									A2(
										$author$project$Remote$UpdateResponse$markPplnsProjectionFetched,
										topState.ph,
										A3(
											$author$project$Remote$Model$markWatcherAccess,
											3,
											1,
											_Utils_update(
												state,
												{dk: $author$project$Types$PplnsProjection$PplnsUnavailable}))),
									$elm$core$Platform$Cmd$none,
									_List_Nil) : _Utils_Tuple3(
									A2(
										$author$project$Remote$UpdateResponse$markPplnsProjectionFetched,
										topState.ph,
										$author$project$Remote$UpdateResponse$markPplnsProjectionFailedUnlessLoaded(state)),
									$elm$core$Platform$Cmd$none,
									_List_Nil)));
							}),
						aK: F2(
							function (projection, state) {
								return (!requestIsForActiveSingleWatcher(state)) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : (projectionMatchesRequest(projection) ? _Utils_Tuple3(
									A2(
										$author$project$Remote$UpdateResponse$markPplnsProjectionFetched,
										topState.ph,
										A3(
											$author$project$Remote$Model$markWatcherAccess,
											3,
											1,
											_Utils_update(
												state,
												{
													dk: $author$project$Types$PplnsProjection$PplnsLoaded(projection)
												}))),
									$elm$core$Platform$Cmd$none,
									_List_Nil) : _Utils_Tuple3(
									$author$project$Remote$UpdateResponse$markPplnsProjectionFailedUnlessLoaded(state),
									$elm$core$Platform$Cmd$none,
									_List_Nil));
							}),
						am: result
					});
			case 34:
				var subAccountId = responseMsg.a;
				var result = responseMsg.b;
				var fallbackToken = function () {
					if (requestMsg.$ === 33) {
						var request = requestMsg.a;
						return request.l$;
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (_v58, state) {
								if (A2($author$project$Remote$UpdateResponse$currentSubAccountExists, subAccountId, state)) {
									if (!fallbackToken.$) {
										var fallback = fallbackToken.a;
										return $elm$core$String$isEmpty(fallback) ? _Utils_Tuple3(
											_Utils_update(
												state,
												{
													eQ: A3($elm$core$Dict$insert, subAccountId, _List_Nil, state.eQ)
												}),
											$elm$core$Platform$Cmd$none,
											_List_Nil) : _Utils_Tuple3(
											state,
											$elm$core$Platform$Cmd$none,
											_List_fromArray(
												[
													$author$project$TopMsg$requestMsg(
													$author$project$Remote$RequestMsg$AggregateSubAccountGeneratedBTC(
														{l$: $elm$core$Maybe$Nothing, o3: subAccountId, g_: fallback}))
												]));
									} else {
										return _Utils_Tuple3(
											_Utils_update(
												state,
												{
													eQ: A3($elm$core$Dict$insert, subAccountId, _List_Nil, state.eQ)
												}),
											$elm$core$Platform$Cmd$none,
											_List_Nil);
									}
								} else {
									return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
								}
							}),
						aK: F2(
							function (generatedEntries, state) {
								return A2($author$project$Remote$UpdateResponse$currentSubAccountExists, subAccountId, state) ? _Utils_Tuple3(
									_Utils_update(
										state,
										{
											eQ: A3($elm$core$Dict$insert, subAccountId, generatedEntries, state.eQ)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						am: result
					});
			case 35:
				var result = responseMsg.a;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								var stateWithAccess = A3($author$project$Remote$UpdateResponse$markWatcherDeniedOnAccessError, 4, error, state);
								return _Utils_Tuple3(
									_Utils_update(
										stateWithAccess,
										{eI: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							}),
						aK: F2(
							function (shareStats, state) {
								return _Utils_Tuple3(
									A3(
										$author$project$Remote$Model$markWatcherAccess,
										4,
										1,
										_Utils_update(
											state,
											{
												eI: $elm$core$Maybe$Just(shareStats)
											})),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							}),
						am: result
					});
			case 36:
				var result = responseMsg.a;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								var stateWithAccess = A3($author$project$Remote$UpdateResponse$markWatcherDeniedOnAccessError, 5, error, state);
								return _Utils_Tuple3(
									_Utils_update(
										stateWithAccess,
										{eH: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							}),
						aK: F2(
							function (fees, state) {
								return _Utils_Tuple3(
									A3(
										$author$project$Remote$Model$markWatcherAccess,
										5,
										1,
										_Utils_update(
											state,
											{
												eH: $elm$core$Maybe$Just(fees)
											})),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							}),
						am: result
					});
			case 37:
				var result = responseMsg.a;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{ej: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									$author$project$Remote$UpdateResponse$toastUnlessTransient(error));
							}),
						aK: F2(
							function (payoutAddresses, state) {
								return ($elm$core$String$isEmpty(payoutAddresses.l5) && $elm$core$String$isEmpty(payoutAddresses.n_)) ? _Utils_Tuple3(
									_Utils_update(
										state,
										{ej: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A3($author$project$Kernel$RouteMsgs$routeMsg.aQ, $elm$core$Maybe$Nothing, 'Pool payout addresses are not configured', _List_Nil)
										])) : _Utils_Tuple3(
									_Utils_update(
										state,
										{
											ej: $elm$core$Maybe$Just(payoutAddresses)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							}),
						am: result
					});
			case 38:
				var query = responseMsg.a;
				var result = responseMsg.b;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								return A2($author$project$Remote$UpdateResponse$payoutQueryMatchesCurrentSession, query, state) ? _Utils_Tuple3(
									_Utils_update(
										state,
										{di: false}),
									$elm$core$Platform$Cmd$none,
									$author$project$Remote$UpdateResponse$toastUnlessTransient(error)) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
							}),
						aK: F2(
							function (page, state) {
								if (A2($author$project$Remote$UpdateResponse$payoutQueryMatchesCurrentSession, query, state)) {
									var nextAccumulated = _Utils_ap(query.kC, page.ek);
									var _v61 = A2($author$project$Types$Payout$nextQuery, query, page);
									if (!_v61.$) {
										var next = _v61.a;
										return _Utils_Tuple3(
											state,
											$elm$core$Platform$Cmd$none,
											_List_fromArray(
												[
													$author$project$TopMsg$requestMsg(
													$author$project$Remote$RequestMsg$PayoutTransactions(next))
												]));
									} else {
										return _Utils_Tuple3(
											_Utils_update(
												state,
												{
													mV: $elm$core$Maybe$Just(topState.ph),
													ek: nextAccumulated,
													di: false
												}),
											$elm$core$Platform$Cmd$none,
											_List_Nil);
									}
								} else {
									return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
								}
							}),
						am: result
					});
			case 39:
				var result = responseMsg.a;
				return handle.ok(
					{
						aI: false,
						cv: function (state) {
							return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
						},
						cw: F2(
							function (error, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{eU: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									$author$project$Remote$UpdateResponse$toastUnlessTransient(error));
							}),
						aK: F2(
							function (tokens, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{
											eU: $elm$core$Maybe$Just(tokens)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							}),
						am: result
					});
			case 40:
				var result = responseMsg.a;
				return handle.ol(
					{
						fi: $elm$core$Basics$identity,
						aI: false,
						aK: F2(
							function (resp, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{
											eT: '',
											hM: _List_Nil,
											hN: $elm$core$Maybe$Nothing,
											gq: $elm$core$Maybe$Just(resp),
											gC: false
										}),
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A3($author$project$Kernel$RouteMsgs$routeMsg.ka, $elm$core$Maybe$Nothing, 'API key created', _List_Nil),
											$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$FetchApiTokens)
										]));
							}),
						am: result
					});
			default:
				var result = responseMsg.b;
				return handle.ol(
					{
						fi: $elm$core$Basics$identity,
						aI: false,
						aK: F2(
							function (_v62, state) {
								return _Utils_Tuple3(
									_Utils_update(
										state,
										{eT: '', jd: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A3($author$project$Kernel$RouteMsgs$routeMsg.ka, $elm$core$Maybe$Nothing, 'API key revoked', _List_Nil),
											$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$FetchApiTokens)
										]));
							}),
						am: result
					});
		}
	});
var $author$project$Remote$HashrateHistory$watcherRecoveryRequests = F3(
	function (watcher, now, lastKnownPoint) {
		var nowMillis = $elm$time$Time$posixToMillis(now);
		var startMillis = A2(
			$elm$core$Basics$max,
			$elm$time$Time$posixToMillis(lastKnownPoint),
			nowMillis - $author$project$Remote$HashrateHistory$bootstrapWindowMillis);
		return A2(
			$elm$core$List$map,
			function (range) {
				return $author$project$Remote$RequestMsg$WatcherHashrateHistorical(
					{c6: range.c6, dr: range.dr, g_: watcher.g_, g4: watcher.g4});
			},
			A2(
				$author$project$Remote$HashrateHistory$historicalRangesBetween,
				$elm$time$Time$millisToPosix(startMillis),
				now));
	});
var $author$project$Update$update = F2(
	function (msg, topState) {
		var currRoute = $author$project$Kernel$Aspect$Navigation$RouteHistory$current(topState.jE);
		var appState = topState.eV;
		switch (msg.$) {
			case 0:
				var theMsg = msg.a;
				return $author$project$Update$outMsgHandlerTopmost(
					{
						nl: $author$project$Msg$GlobalMsg,
						o$: function (childState) {
							return _Utils_update(
								appState,
								{me: childState});
						},
						pN: A5($author$project$Global$Global$update, topState.ph, currRoute, $elm$core$Maybe$Nothing, theMsg, appState.me)
					});
			case 1:
				var theMsg = msg.a;
				return $author$project$Update$outMsgHandlerTopmost(
					{
						nl: $author$project$Msg$ComponentsPreviewMsg,
						o$: function (childState) {
							return _Utils_update(
								appState,
								{hF: childState});
						},
						pN: A4($author$project$UI$ComponentsPreview$View$update, appState.me, $elm$core$Maybe$Nothing, theMsg, appState.hF)
					});
			case 2:
				var theMsg = msg.a;
				return $author$project$Update$outMsgHandlerTopmost(
					{
						nl: $elm$core$Basics$identity,
						o$: function (childState) {
							return _Utils_update(
								appState,
								{jr: childState});
						},
						pN: A5($author$project$Remote$Update$update, theMsg, appState.jr, currRoute, appState.me, topState.ph)
					});
			case 3:
				var requestMsg = msg.a;
				var _v1 = A4($author$project$Remote$UpdateRequest$updateRequest, requestMsg, appState.me, topState.ph, appState.jr);
				var remote = _v1.a;
				var cmd = _v1.b;
				var outMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						appState,
						{jr: remote}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Msg$RemoteResponseMsg(requestMsg),
						cmd),
					outMsgs);
			case 4:
				var requestMsg = msg.a;
				var responseMsg = msg.b;
				return $author$project$Update$outMsgHandlerTopmost(
					{
						nl: $author$project$Msg$RemoteResponseMsg(requestMsg),
						o$: function (childState) {
							return _Utils_update(
								appState,
								{jr: childState});
						},
						pN: A4($author$project$Remote$UpdateResponse$updateResponse, topState, requestMsg, responseMsg, currRoute)
					});
			case 5:
				var pplnsProjectionIsStale = function () {
					var _v11 = appState.jr.d5;
					if (_v11.$ === 1) {
						return true;
					} else {
						var lastFetchTime = _v11.a;
						return _Utils_cmp(
							$elm$time$Time$posixToMillis(topState.ph) - $elm$time$Time$posixToMillis(lastFetchTime),
							(5 * 60) * 1000) > -1;
					}
				}();
				var pplnsProjectionRequests = function () {
					if (!pplnsProjectionIsStale) {
						return _List_Nil;
					} else {
						var _v9 = $author$project$Remote$Model$toUserSession(appState.jr);
						if (!_v9.$) {
							var userSession = _v9.a;
							return _List_fromArray(
								[
									$author$project$TopMsg$requestMsg(
									$author$project$Remote$RequestMsg$UserPplnsProjection(
										$author$project$Types$User$unwrapUserId(userSession.mu)))
								]);
						} else {
							var _v10 = $author$project$Remote$Model$toWatcherSession(appState.jr);
							if (!_v10.$) {
								var watcherSession = _v10.a;
								return (_Utils_eq(
									appState.jr.bX,
									_List_fromArray(
										[watcherSession])) && (!A2($author$project$Remote$Model$watcherAccessIsDenied, 3, appState.jr))) ? _List_fromArray(
									[
										$author$project$TopMsg$requestMsg(
										$author$project$Remote$RequestMsg$WatcherPplnsProjection(watcherSession))
									]) : _List_Nil;
							} else {
								return _List_Nil;
							}
						}
					}
				}();
				var payoutRequests = function () {
					if (_Utils_eq(currRoute, $author$project$Route$Route$Payouts)) {
						var payoutRequest = $author$project$Remote$Model$isWatcherAuthenticated(appState.jr) ? $author$project$Remote$RequestMsg$WatcherPayouts : $author$project$Remote$RequestMsg$FetchPayouts;
						var _v6 = appState.jr.mV;
						if (_v6.$ === 1) {
							return _List_fromArray(
								[
									$author$project$TopMsg$requestMsg(payoutRequest)
								]);
						} else {
							var lastFetchTime = _v6.a;
							return (_Utils_cmp(
								$elm$time$Time$posixToMillis(topState.ph) - $elm$time$Time$posixToMillis(lastFetchTime),
								(5 * 60) * 1000) > -1) ? _List_fromArray(
								[
									$author$project$TopMsg$requestMsg(payoutRequest)
								]) : _List_Nil;
						}
					} else {
						if (_Utils_eq(currRoute, $author$project$Route$Route$GeneratedBitcoin) && (!appState.me.dD)) {
							var refreshForContext = F3(
								function (context, payoutRequest, generatedRequests) {
									var earningsRequests = A2($author$project$Remote$Model$generatedBTCNeedsRefresh, topState.ph, appState.jr) ? generatedRequests : _List_Nil;
									return (A3($author$project$Remote$Model$payoutsAreStaleForContext, topState.ph, context, appState.jr) && (($author$project$Remote$Model$isUserAuthenticated(appState.jr) || $author$project$Remote$Model$watcherCanViewPayouts(appState.jr)) && (!$author$project$Remote$Model$payoutsAreLoading(appState.jr)))) ? A2(
										$elm$core$List$cons,
										$author$project$TopMsg$requestMsg(payoutRequest),
										earningsRequests) : earningsRequests;
								});
							var _v7 = $author$project$Remote$Model$toUserSession(appState.jr);
							if (!_v7.$) {
								var session = _v7.a;
								return A3(
									refreshForContext,
									A2(
										$author$project$Types$Payout$UserPayoutContext,
										$author$project$Types$User$unwrapUserId(session.mu),
										false),
									$author$project$Remote$RequestMsg$FetchPayoutProgress,
									A2($author$project$Remote$Model$isRequestAlreadyOngoing, appState.jr, $author$project$Remote$RequestMsg$GeneratedBTC) ? _List_Nil : _List_fromArray(
										[
											$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GeneratedBTC)
										]));
							} else {
								var _v8 = $author$project$Remote$Model$toWatcherSession(appState.jr);
								if (!_v8.$) {
									var session = _v8.a;
									return $author$project$Remote$Model$watcherMayViewPayouts(appState.jr) ? A3(
										refreshForContext,
										A2($author$project$Types$Payout$WatcherPayoutContext, session.g4, session.g_),
										$author$project$Remote$RequestMsg$LoadWatcherPayouts,
										A2(
											$author$project$Remote$Model$isRequestAlreadyOngoing,
											appState.jr,
											$author$project$Remote$RequestMsg$WatcherGeneratedBTC(session)) ? _List_Nil : _List_fromArray(
											[
												$author$project$TopMsg$requestMsg(
												$author$project$Remote$RequestMsg$WatcherGeneratedBTC(session))
											])) : _List_Nil;
								} else {
									return _List_Nil;
								}
							}
						} else {
							return _List_Nil;
						}
					}
				}();
				var batchedRequests = function () {
					var _v2 = $author$project$Remote$Model$toUserSession(appState.jr);
					if (!_v2.$) {
						var userSession = _v2.a;
						var lastKnownHashratePoint = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ph;
							},
							$author$project$UI$Library$Chart$Model$latestChartPoint(appState.hw.hv));
						var historyRecoveryRequests = function () {
							if (A3($author$project$Remote$HashrateHistory$shouldRecoverHistory, topState.ph, appState.jr.mU, lastKnownHashratePoint)) {
								if (!lastKnownHashratePoint.$) {
									var lastKnownPoint = lastKnownHashratePoint.a;
									return A2(
										$elm$core$List$map,
										$author$project$TopMsg$requestMsg,
										A2($author$project$Remote$HashrateHistory$recoveryRequests, topState.ph, lastKnownPoint));
								} else {
									return _List_Nil;
								}
							} else {
								return _List_Nil;
							}
						}();
						var aggregateSubAccountRequests = ((appState.me.dD === 1) && $author$project$Remote$Model$canViewSubAccounts(appState.jr)) ? _List_fromArray(
							[
								$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RetrieveSubAccount)
							]) : _List_Nil;
						return _Utils_ap(
							historyRecoveryRequests,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$UserHashrate)
									]),
								_Utils_ap(
									aggregateSubAccountRequests,
									$elm$core$String$isEmpty(userSession.g_) ? _List_Nil : ((_Utils_eq(currRoute, $author$project$Route$Route$Workers) || _Utils_eq(currRoute, $author$project$Route$Route$Connections)) ? _List_fromArray(
										[
											$author$project$TopMsg$requestMsg(
											$author$project$Remote$RequestMsg$WorkersInfo(
												{hO: $elm$core$Maybe$Nothing, v: $author$project$Remote$RequestMsg$defaultWorkersPageLimit, iX: 0, g_: userSession.g_}))
										]) : _List_Nil))));
					} else {
						var _v4 = $author$project$Remote$Model$toWatcherSession(appState.jr);
						if (!_v4.$) {
							var watcherSession = _v4.a;
							var sessions = appState.jr.bX;
							var lastKnownHashratePoint = A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.ph;
								},
								$author$project$UI$Library$Chart$Model$latestChartPoint(appState.hw.hv));
							var hasWorkersAccess = !A2($author$project$Remote$Model$watcherAccessIsDenied, 1, appState.jr);
							var hasHashrateAccess = !A2($author$project$Remote$Model$watcherAccessIsDenied, 0, appState.jr);
							var hasMultiSessionHashrateAccess = ($elm$core$List$length(appState.jr.bX) > 1) ? function (session) {
								return !(A2($author$project$Remote$Model$multiWatcherHashrateAccessForSession, session, appState.jr) === 2);
							} : function (session) {
								return hasHashrateAccess;
							};
							var historyRecoveryRequests = function () {
								if (A3($author$project$Remote$HashrateHistory$shouldRecoverHistory, topState.ph, appState.jr.mU, lastKnownHashratePoint)) {
									if (!lastKnownHashratePoint.$) {
										var lastKnownPoint = lastKnownHashratePoint.a;
										return A2(
											$elm$core$List$concatMap,
											function (session) {
												return A2(
													$elm$core$List$map,
													$author$project$TopMsg$requestMsg,
													A3($author$project$Remote$HashrateHistory$watcherRecoveryRequests, session, topState.ph, lastKnownPoint));
											},
											A2($elm$core$List$filter, hasMultiSessionHashrateAccess, sessions));
									} else {
										return _List_Nil;
									}
								} else {
									return _List_Nil;
								}
							}();
							return _Utils_ap(
								historyRecoveryRequests,
								_Utils_ap(
									((!$elm$core$List$isEmpty(sessions)) && (hasHashrateAccess && ($elm$core$List$length(sessions) === 1))) ? _List_fromArray(
										[
											$author$project$TopMsg$requestMsg(
											$author$project$Remote$RequestMsg$WatcherHashrate(watcherSession))
										]) : _List_Nil,
									(hasWorkersAccess && (_Utils_eq(currRoute, $author$project$Route$Route$Workers) && ($elm$core$List$length(sessions) === 1))) ? _List_fromArray(
										[
											$author$project$TopMsg$requestMsg(
											$author$project$Remote$RequestMsg$WatcherWorkersInfo(
												{hO: $elm$core$Maybe$Nothing, v: $author$project$Remote$RequestMsg$defaultWorkersPageLimit, iX: 0, g_: watcherSession.g_, g4: watcherSession.g4}))
										]) : _List_Nil));
						} else {
							return _List_Nil;
						}
					}
				}();
				return _Utils_Tuple3(
					appState,
					$elm$core$Platform$Cmd$none,
					_Utils_ap(
						batchedRequests,
						_Utils_ap(payoutRequests, pplnsProjectionRequests)));
			case 6:
				var authMsg = msg.a;
				return $author$project$Update$outMsgHandlerTopmost(
					{
						nl: $author$project$Msg$AuthMsg,
						o$: function (childState) {
							return _Utils_update(
								appState,
								{hh: childState});
						},
						pN: A2($author$project$UI$Auth$Update$update, authMsg, appState.hh)
					});
			case 7:
				var connectMsg = msg.a;
				return $author$project$Update$outMsgHandlerTopmost(
					{
						nl: $author$project$Msg$ConnectMsg,
						o$: function (childState) {
							return _Utils_update(
								appState,
								{hI: childState});
						},
						pN: A3($author$project$UI$Connect$Update$update, appState.me, connectMsg, appState.hI)
					});
			case 8:
				var accountMsg = msg.a;
				return $author$project$Update$outMsgHandlerTopmost(
					{
						nl: $author$project$Msg$AccountMsg,
						o$: function (childState) {
							return _Utils_update(
								appState,
								{ha: childState});
						},
						pN: A4(
							$author$project$UI$Account$Update$update,
							$author$project$Remote$Model$toUserSession(appState.jr),
							appState.me,
							accountMsg,
							appState.ha)
					});
			case 9:
				var chartMsg = msg.a;
				return $author$project$Update$outMsgHandlerTopmost(
					{
						nl: $author$project$Msg$ChartMsg,
						o$: function (childState) {
							return _Utils_update(
								appState,
								{hw: childState});
						},
						pN: A4(
							$author$project$UI$Library$Chart$Update$update,
							topState.qm,
							$author$project$Remote$Model$toUserSession(appState.jr),
							chartMsg,
							appState.hw)
					});
			case 10:
				var homeMsg = msg.a;
				return $author$project$Update$outMsgHandlerTopmost(
					{
						nl: $author$project$Msg$HomeMsg,
						o$: function (childState) {
							return _Utils_update(
								appState,
								{iu: childState});
						},
						pN: A3(
							$author$project$UI$Home$Update$update,
							$author$project$Remote$Model$toUserSession(appState.jr),
							homeMsg,
							appState.iu)
					});
			case 11:
				var theMsg = msg.a;
				return $author$project$Update$outMsgHandlerTopmost(
					{
						nl: $author$project$Msg$WorkersMsg,
						o$: function (childState) {
							return _Utils_update(
								appState,
								{kv: childState});
						},
						pN: A4(
							$author$project$UI$Workers$Update$update,
							appState.me,
							$author$project$Remote$Model$toUserSession(appState.jr),
							theMsg,
							appState.kv)
					});
			case 12:
				var payoutsMsg = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						appState,
						{
							jc: A2($author$project$UI$Library$TablePagination$update, payoutsMsg, appState.jc)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var generatedBitcoinMsg = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						appState,
						{
							$9: A2($author$project$UI$Library$TablePagination$update, generatedBitcoinMsg, appState.$9)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 14:
				var dateRangeMsg = msg.a;
				var dates = A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
					A2($elm$core$List$map, $author$project$Types$Payout$payoutDate, appState.jr.ek));
				var nextDateRange = A4(
					$author$project$UI$Library$DateRangePicker$update,
					$author$project$UI$Util$currentDateString(topState.ph),
					dates,
					dateRangeMsg,
					appState.jb);
				return _Utils_Tuple3(
					_Utils_update(
						appState,
						{
							jb: nextDateRange,
							jc: $author$project$Update$shouldResetDateRangePagination(dateRangeMsg) ? $author$project$UI$Library$TablePagination$init : appState.jc
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var dateRangeMsg = msg.a;
				var dates = A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
					A2(
						$elm$core$List$map,
						function ($) {
							return $.h0;
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($author$project$UI$Library$AccountData$generatedBTCForScope, appState.me.dD, appState.jr))));
				var nextDateRange = A4(
					$author$project$UI$Library$DateRangePicker$update,
					$author$project$UI$Util$currentDateString(topState.ph),
					dates,
					dateRangeMsg,
					appState.im);
				return _Utils_Tuple3(
					_Utils_update(
						appState,
						{
							im: nextDateRange,
							$9: $author$project$Update$shouldResetDateRangePagination(dateRangeMsg) ? $author$project$UI$Library$TablePagination$init : appState.$9
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Kernel$Aspect$Navigation$RouteHistory$isBackNav = function (_v0) {
	var isBack = _v0.c;
	return isBack;
};
var $author$project$Global$Overlays$DmndModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Global$Overlays$SimpleModal = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Library$Button$Disabled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Global$Model$EditSubAccountModal = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$UI$Library$Button$GreenModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Global$Msg$ShowModal = function (a) {
	return {$: 11, a: a};
};
var $author$project$Remote$RequestMsg$UpdateSubAccount = function (a) {
	return {$: 55, a: a};
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$Kernel$UI$Button$Button = function (a) {
	return {$: 1, a: a};
};
var $author$project$Kernel$UI$Button$NoAction = {$: 2};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Kernel$UI$Button$buttonBase = F3(
	function (buttonKind, attrList, childList) {
		var _v0 = function () {
			switch (buttonKind.$) {
				case 0:
					return _Utils_Tuple2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('submit')
							]));
				case 1:
					var msg = buttonKind.a;
					return _Utils_Tuple2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Events$onClick(msg)
							]));
				case 2:
					return _Utils_Tuple2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button')
							]));
				default:
					var newTab = buttonKind.a.nt;
					var string = buttonKind.b;
					return _Utils_Tuple2(
						$elm$html$Html$a,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$href(string),
							newTab ? _List_fromArray(
								[
									$elm$html$Html$Attributes$target('_blank')
								]) : _List_Nil));
			}
		}();
		var btnEl = _v0.a;
		var handlerAttrs = _v0.b;
		return A2(
			btnEl,
			_Utils_ap(attrList, handlerAttrs),
			childList);
	});
var $author$project$Kernel$UI$Button$button = function (config) {
	return A3(
		$author$project$Kernel$UI$Button$buttonBase,
		config.iJ,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(config.hA)
			]),
		_List_fromArray(
			[config.A]));
};
var $author$project$UI$Library$Button$buttonClasses = 'pt-1 pb-1 pl-2 pr-2 font-weight-semibold';
var $author$project$UI$Library$Button$button = function (buttonConfig) {
	switch (buttonConfig.$) {
		case 0:
			var content = buttonConfig.a.A;
			var tap = buttonConfig.a.cG;
			return $author$project$Kernel$UI$Button$button(
				{
					hA: 'pl-1 pr-1 bg-dmnd-green text-dmnd-black font-weight-semibold',
					A: content,
					iJ: $author$project$Kernel$UI$Button$Button(tap)
				});
		case 1:
			var content = buttonConfig.a.A;
			var tap = buttonConfig.a.cG;
			return $author$project$Kernel$UI$Button$button(
				{
					hA: 'pt-1 pb-1 pl-2 pr-2 bg-dmnd-green text-dmnd-black font-weight-semibold',
					A: content,
					iJ: $author$project$Kernel$UI$Button$Button(tap)
				});
		case 3:
			var content = buttonConfig.a.A;
			var tap = buttonConfig.a.cG;
			return $author$project$Kernel$UI$Button$button(
				{
					hA: $author$project$UI$Library$Button$buttonClasses + ' bg-dmnd-red-1 text-white w-full',
					A: content,
					iJ: $author$project$Kernel$UI$Button$Button(tap)
				});
		case 2:
			var content = buttonConfig.a.A;
			var tap = buttonConfig.a.cG;
			return $author$project$Kernel$UI$Button$button(
				{
					hA: $author$project$UI$Library$Button$buttonClasses + ' bg-dmnd-green text-dmnd-black',
					A: content,
					iJ: $author$project$Kernel$UI$Button$Button(tap)
				});
		default:
			var content = buttonConfig.a.A;
			return $author$project$Kernel$UI$Button$button(
				{hA: 'pt-1 pb-1 pl-2 pr-2 bg-dmnd-gray text-dmnd-white font-weight-semibold', A: content, iJ: $author$project$Kernel$UI$Button$NoAction});
	}
};
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Global$Overlays$editSubAccountContent = F3(
	function (subAccountId, name, twoFaToken) {
		var updateModal = F2(
			function (updatedname, updatedToken) {
				return $author$project$Global$Msg$ShowModal(
					A3($author$project$Global$Model$EditSubAccountModal, subAccountId, updatedname, updatedToken));
			});
		var isValid = (!$elm$core$String$isEmpty(
			$elm$core$String$trim(name))) && (!$elm$core$String$isEmpty(twoFaToken));
		var submitButton = isValid ? $author$project$UI$Library$Button$button(
			$author$project$UI$Library$Button$GreenModal(
				{
					A: $elm$html$Html$text('Proceed'),
					cG: $author$project$TopMsg$requestMsg(
						$author$project$Remote$RequestMsg$UpdateSubAccount(
							{
								mu: subAccountId,
								aJ: $elm$core$String$trim(name),
								kj: twoFaToken
							}))
				})) : $author$project$UI$Library$Button$button(
			$author$project$UI$Library$Button$Disabled(
				{
					A: $elm$html$Html$text('Proceed')
				}));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('max-w-[50rem] w-full')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-18 font-semibold mb-4')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Rename Subaccount')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-14 text-dmnd-lighter-gray mb-4')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Enter the new subaccount name and your 2FA token.')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-14 mb-2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Name')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('subaccount-name-input'),
										$elm$html$Html$Attributes$class('bg-dmnd-black block border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-2 w-full'),
										$elm$html$Html$Attributes$placeholder('Enter subaccount name'),
										$elm$html$Html$Attributes$value(name),
										$elm$html$Html$Events$onInput(
										function (updatedname) {
											return $author$project$TopMsg$globalMsg(
												A2(updateModal, updatedname, twoFaToken));
										}),
										$elm$html$Html$Attributes$autocomplete(false)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-14 mb-2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('2FA Token')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('edit-subaccount-two-fa-token-input'),
										$elm$html$Html$Attributes$class('bg-dmnd-black block border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-2 w-full'),
										$elm$html$Html$Attributes$placeholder('Enter your 2FA token'),
										$elm$html$Html$Attributes$value(twoFaToken),
										$elm$html$Html$Events$onInput(
										function (updatedToken) {
											return $author$project$TopMsg$globalMsg(
												A2(updateModal, name, updatedToken));
										}),
										$elm$html$Html$Attributes$autocomplete(false)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-4 text-left')
							]),
						_List_fromArray(
							[submitButton]))
					]))
			]);
	});
var $author$project$UI$Library$Button$RedModal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Global$Overlays$modalBase = function (_v0) {
	var name = _v0.aJ;
	var content = _v0.A;
	var xButton = _v0.g8;
	var closeButton = xButton ? _List_fromArray(
		[
			$author$project$Kernel$UI$Button$button(
			{
				hA: 'absolute top-0.25 right-0.25 p-1 cursor-pointer text-32 leading-none -mt-0.5',
				A: $elm$html$Html$text('×'),
				iJ: $author$project$Kernel$UI$Button$Button(
					$author$project$TopMsg$globalMsg($author$project$Global$Msg$HideModal))
			})
		]) : _List_Nil;
	var contentWrapper = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('m-3 h-full flex items-center justify-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('relative flex p-3 bg-dmnd-almost-black min-h-[50rem] min-w-[50rem] pt-5')
					]),
				_Utils_ap(closeButton, content))
			]));
	var background = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-dmnd-black backdrop-blur bg-opacity-50 absolute inset-0')
			]),
		_List_Nil);
	return {
		kP: _List_fromArray(
			[
				$elm$html$Html$Attributes$class('absolute inset-0 z-[100] flex flex-col')
			]),
		A: _List_fromArray(
			[background, contentWrapper]),
		nv: name + '-modal',
		pZ: name + '-modal'
	};
};
var $author$project$Global$Overlays$modal = function (modalConfig) {
	if (!modalConfig.$) {
		var content = modalConfig.a.A;
		var name = modalConfig.a.aJ;
		return $author$project$Global$Overlays$modalBase(
			{A: content, aJ: name, g8: true});
	} else {
		var content = modalConfig.a.A;
		var name = modalConfig.a.aJ;
		var confirmButton = modalConfig.a.hH;
		return $author$project$Global$Overlays$modalBase(
			{
				A: _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col relative justify-between grow')
							]),
						_Utils_ap(
							content,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pt-3')
										]),
									_List_fromArray(
										[
											$author$project$UI$Library$Button$button(
											$author$project$UI$Library$Button$RedModal(
												{
													A: $elm$html$Html$text(name),
													cG: confirmButton
												}))
										]))
								])))
					]),
				aJ: name,
				g8: true
			});
	}
};
var $author$project$Global$Msg$CopyFppsPasswordToClipboard = function (a) {
	return {$: 14, a: a};
};
var $author$project$Global$Msg$CopyToClipboard = function (a) {
	return {$: 13, a: a};
};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$UI$Svg$copyIcon = function (classes) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$width('2.25rem'),
				$elm$svg$Svg$Attributes$height('2.25rem'),
				$elm$svg$Svg$Attributes$class(classes)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M19.5 16.5L19.5 4.5L18.75 3.75H9L8.25 4.5L8.25 7.5L5.25 7.5L4.5 8.25V20.25L5.25 21H15L15.75 20.25V17.25H18.75L19.5 16.5ZM15.75 15.75L15.75 8.25L15 7.5L9.75 7.5V5.25L18 5.25V15.75H15.75ZM6 9L14.25 9L14.25 19.5L6 19.5L6 9Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil)
			]));
};
var $author$project$Global$Overlays$subAccountPasswordsContent = F3(
	function (subAccountName, pplnsPassword, fppsPassword) {
		var passwordRow = F3(
			function (label, password, copyMessage) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-0.5 text-12 text-dmnd-lighter-gray')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex min-h-[4.5rem] items-center justify-between gap-1 border border-dmnd-gray bg-dmnd-black p-1.5 ')
								]),
							_List_fromArray(
								[
									$elm$core$String$isEmpty(password) ? A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-11 text-dmnd-lighter-gray')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Not available')
										])) : A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('min-w-0 break-all font-mono text-12 text-white')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(password)
										])),
									$elm$core$String$isEmpty(password) ? $elm$html$Html$text('') : $author$project$Kernel$UI$Button$button(
									{
										hA: 'flex shrink-0 items-center gap-0.5 px-0.5 py-0.25 text-10 text-dmnd-lighter-gray hover:text-white',
										A: A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex items-center gap-0.5')
												]),
											_List_fromArray(
												[
													$author$project$UI$Svg$copyIcon('h-1.25 w-1.25'),
													$elm$html$Html$text('Copy')
												])),
										iJ: $author$project$Kernel$UI$Button$Button(copyMessage)
									})
								]))
						]));
			});
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full max-w-[44rem]')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-1 text-16 font-semibold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Mining passwords')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-3.5 text-12 text-dmnd-lighter-gray')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Use these credentials when configuring miners for '),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('font-semibold text-white')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(subAccountName)
									])),
								$elm$html$Html$text('.')
							])),
						A3(
						passwordRow,
						'PPLNS password',
						pplnsPassword,
						$author$project$TopMsg$globalMsg(
							$author$project$Global$Msg$CopyToClipboard(pplnsPassword))),
						A3(
						passwordRow,
						'FPPS password',
						fppsPassword,
						$author$project$TopMsg$globalMsg(
							$author$project$Global$Msg$CopyFppsPasswordToClipboard(fppsPassword)))
					]))
			]);
	});
var $author$project$Remote$RequestMsg$Activate2FA = function (a) {
	return {$: 6, a: a};
};
var $author$project$UI$Library$Button$Green = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Library$Button$GreenInline = function (a) {
	return {$: 0, a: a};
};
var $author$project$Global$Model$TwoFactorActivation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$UI$Library$Button$copyToClipboard = function (_v0) {
	var value = _v0.pV;
	var iconClasses = _v0.mt;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$TopMsg$globalMsg(
					$author$project$Global$Msg$CopyToClipboard(value)))
			]),
		_List_fromArray(
			[
				$author$project$UI$Svg$copyIcon('cursor-pointer ' + iconClasses)
			]));
};
var $pablohirafuji$elm_qrcode$QRCode$Quartile = 2;
var $pablohirafuji$elm_qrcode$QRCode$QRCode = $elm$core$Basics$identity;
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex = F3(
	function (size, row, col) {
		return (size * row) + col;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy = F4(
	function (row, col, size, matrix) {
		var _v0 = A2(
			$elm$core$Array$get,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			matrix);
		if ((!_v0.$) && (!_v0.a.$)) {
			return true;
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule = function (placement) {
	var row = placement.oG;
	var col = placement.hB;
	var isRight = placement.bk;
	var isUp = placement.c8;
	return isRight ? _Utils_update(
		placement,
		{hB: col - 1, bk: false}) : (isUp ? _Utils_update(
		placement,
		{hB: col + 1, bk: true, oG: row - 1}) : _Utils_update(
		placement,
		{hB: col + 1, bk: true, oG: row + 1}));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor = F2(
	function (_byte, offset) {
		return (1 & (_byte >> (7 - offset))) === 1;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule = F3(
	function (_v0, _byte, offset) {
		var size = _v0.jV;
		var row = _v0.oG;
		var col = _v0.hB;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(
					false,
					A2($pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor, _byte, offset))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule = F4(
	function (placement, bytes, offset, matrix) {
		addDataModule:
		while (true) {
			var size = placement.jV;
			var row = placement.oG;
			var col = placement.hB;
			if (!bytes.b) {
				return matrix;
			} else {
				var head = bytes.a;
				var tail = bytes.b;
				if (offset >= 8) {
					var $temp$placement = placement,
						$temp$bytes = tail,
						$temp$offset = 0,
						$temp$matrix = matrix;
					placement = $temp$placement;
					bytes = $temp$bytes;
					offset = $temp$offset;
					matrix = $temp$matrix;
					continue addDataModule;
				} else {
					if (col === 6) {
						var $temp$placement = _Utils_update(
							placement,
							{hB: col - 1, bk: true}),
							$temp$bytes = bytes,
							$temp$offset = offset,
							$temp$matrix = matrix;
						placement = $temp$placement;
						bytes = $temp$bytes;
						offset = $temp$offset;
						matrix = $temp$matrix;
						continue addDataModule;
					} else {
						if (row < 0) {
							var $temp$placement = _Utils_update(
								placement,
								{hB: col - 2, bk: true, c8: false, oG: 0}),
								$temp$bytes = bytes,
								$temp$offset = offset,
								$temp$matrix = matrix;
							placement = $temp$placement;
							bytes = $temp$bytes;
							offset = $temp$offset;
							matrix = $temp$matrix;
							continue addDataModule;
						} else {
							if (_Utils_cmp(row, size) > -1) {
								var $temp$placement = _Utils_update(
									placement,
									{hB: col - 2, bk: true, c8: true, oG: size - 1}),
									$temp$bytes = bytes,
									$temp$offset = offset,
									$temp$matrix = matrix;
								placement = $temp$placement;
								bytes = $temp$bytes;
								offset = $temp$offset;
								matrix = $temp$matrix;
								continue addDataModule;
							} else {
								if (A4($pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy, row, col, size, matrix)) {
									var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
										$temp$bytes = bytes,
										$temp$offset = offset,
										$temp$matrix = matrix;
									placement = $temp$placement;
									bytes = $temp$bytes;
									offset = $temp$offset;
									matrix = $temp$matrix;
									continue addDataModule;
								} else {
									var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
										$temp$bytes = bytes,
										$temp$offset = offset + 1,
										$temp$matrix = A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule, placement, head, offset, matrix);
									placement = $temp$placement;
									bytes = $temp$bytes;
									offset = $temp$offset;
									matrix = $temp$matrix;
									continue addDataModule;
								}
							}
						}
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement = function (size) {
	return {hB: size + 1, bk: true, c8: true, oG: size + 1, jV: size};
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addData = F3(
	function (size, bytes, matrix) {
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement(size),
			bytes,
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound = {$: 0};
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{_: nodeList, P: nodeListSize, X: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData = $elm$core$Array$fromList(
	_List_fromArray(
		[
			_List_Nil,
			_List_fromArray(
			[6, 18]),
			_List_fromArray(
			[6, 22]),
			_List_fromArray(
			[6, 26]),
			_List_fromArray(
			[6, 30]),
			_List_fromArray(
			[6, 34]),
			_List_fromArray(
			[6, 22, 38]),
			_List_fromArray(
			[6, 24, 42]),
			_List_fromArray(
			[6, 26, 46]),
			_List_fromArray(
			[6, 28, 50]),
			_List_fromArray(
			[6, 30, 54]),
			_List_fromArray(
			[6, 32, 58]),
			_List_fromArray(
			[6, 34, 62]),
			_List_fromArray(
			[6, 26, 46, 66]),
			_List_fromArray(
			[6, 26, 48, 70]),
			_List_fromArray(
			[6, 26, 50, 74]),
			_List_fromArray(
			[6, 30, 54, 78]),
			_List_fromArray(
			[6, 30, 56, 82]),
			_List_fromArray(
			[6, 30, 58, 86]),
			_List_fromArray(
			[6, 34, 62, 90]),
			_List_fromArray(
			[6, 28, 50, 72, 94]),
			_List_fromArray(
			[6, 26, 50, 74, 98]),
			_List_fromArray(
			[6, 30, 54, 78, 102]),
			_List_fromArray(
			[6, 28, 54, 80, 106]),
			_List_fromArray(
			[6, 32, 58, 84, 110]),
			_List_fromArray(
			[6, 30, 58, 86, 114]),
			_List_fromArray(
			[6, 34, 62, 90, 118]),
			_List_fromArray(
			[6, 26, 50, 74, 98, 122]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126]),
			_List_fromArray(
			[6, 26, 52, 78, 104, 130]),
			_List_fromArray(
			[6, 30, 56, 82, 108, 134]),
			_List_fromArray(
			[6, 34, 60, 86, 112, 138]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142]),
			_List_fromArray(
			[6, 34, 62, 90, 118, 146]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126, 150]),
			_List_fromArray(
			[6, 24, 50, 76, 102, 128, 154]),
			_List_fromArray(
			[6, 28, 54, 80, 106, 132, 158]),
			_List_fromArray(
			[6, 32, 58, 84, 110, 136, 162]),
			_List_fromArray(
			[6, 26, 54, 82, 110, 138, 166]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142, 170])
		]));
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord = F2(
	function (rows, cols) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (row, list) {
					return A3(
						$elm$core$List$foldl,
						F2(
							function (col, list_) {
								return A2(
									$elm$core$List$cons,
									_Utils_Tuple2(row, col),
									list_);
							}),
						list,
						cols);
				}),
			_List_Nil,
			rows);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign = F2(
	function (size, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return ((row > 10) || ((10 < col) && (_Utils_cmp(col, size - 10) < 0))) && ((_Utils_cmp(row, size - 10) < 0) || (col > 10));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange = A2($elm$core$List$range, -2, 2);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor = F2(
	function (row, col) {
		return (_Utils_eq(row, -2) || ((row === 2) || (_Utils_eq(col, -2) || ((col === 2) || ((!row) && (!col)))))) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(true, false));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule = F4(
	function (size, rowPos, colPos, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row + rowPos, col + colPos),
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor, row, col));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment = F3(
	function (size, _v0, matrix) {
		var row = _v0.a;
		var col = _v0.b;
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule, size, row, col),
			matrix,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments = F3(
	function (size, locations, matrix) {
		return A3(
			$elm$core$List$foldl,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment(size),
			matrix,
			A2(
				$elm$core$List$filter,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign(size),
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, locations, locations)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern = F3(
	function (version, size, matrix) {
		return A2(
			$elm$core$Result$map,
			function (a) {
				return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments, size, a, matrix);
			},
			A2(
				$elm$core$Result$fromMaybe,
				$pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound,
				A2($elm$core$Array$get, version - 1, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule = F2(
	function (version, size) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, (4 * version) + 9, 8),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, true)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange = A2($elm$core$List$range, 0, 8);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor = F2(
	function (row, col) {
		return ((1 <= row) && ((row <= 7) && ((col === 1) || (col === 7)))) || (((1 <= col) && ((col <= 7) && ((row === 1) || (row === 7)))) || ((3 <= row) && ((row <= 5) && ((3 <= col) && (col <= 5)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder = F5(
	function (size, rowOffset, colOffset, _v0, matrix) {
		var row = _v0.a;
		var col = _v0.b;
		var finalRow = row + rowOffset;
		var finalCol = col + colOffset;
		return ((finalRow < 0) || ((finalCol < 0) || ((_Utils_cmp(finalRow, size) > -1) || (_Utils_cmp(finalCol, size) > -1)))) ? matrix : A3(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, finalRow, finalCol),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(
					true,
					A2($pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor, row, col))),
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern = F4(
	function (size, rowOffset, colOffset, matrix) {
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder, size, rowOffset, colOffset),
			matrix,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor = F2(
	function (maybeModule, isChange) {
		if (isChange) {
			if ((!maybeModule.$) && (!maybeModule.a.a)) {
				var _v1 = maybeModule.a;
				var isDark = _v1.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(false, !isDark));
			} else {
				return maybeModule;
			}
		} else {
			return maybeModule;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord = F2(
	function (size, index) {
		return _Utils_Tuple2(
			(index / size) | 0,
			A2($elm$core$Basics$modBy, size, index));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction = F4(
	function (_function, size, index, maybeModule) {
		return A2(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor,
			maybeModule,
			_function(
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord, size, index)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction = function (mask) {
	switch (mask) {
		case 0:
			return function (_v1) {
				var row = _v1.a;
				var col = _v1.b;
				return !A2($elm$core$Basics$modBy, 2, row + col);
			};
		case 1:
			return function (_v2) {
				var row = _v2.a;
				return !A2($elm$core$Basics$modBy, 2, row);
			};
		case 2:
			return function (_v3) {
				var col = _v3.b;
				return !A2($elm$core$Basics$modBy, 3, col);
			};
		case 3:
			return function (_v4) {
				var row = _v4.a;
				var col = _v4.b;
				return !A2($elm$core$Basics$modBy, 3, row + col);
			};
		case 4:
			return function (_v5) {
				var row = _v5.a;
				var col = _v5.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					$elm$core$Basics$floor(row / 2) + $elm$core$Basics$floor(col / 3));
			};
		case 5:
			return function (_v6) {
				var row = _v6.a;
				var col = _v6.b;
				return !(A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		case 6:
			return function (_v7) {
				var row = _v7.a;
				var col = _v7.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		default:
			return function (_v8) {
				var row = _v8.a;
				var col = _v8.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 3, row * col) + A2($elm$core$Basics$modBy, 2, row + col));
			};
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask = F3(
	function (size, mask, matrix) {
		return A2(
			$elm$core$Array$indexedMap,
			A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction(mask),
				size),
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$breakList = F3(
	function (width, list, acc) {
		breakList:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(acc);
			} else {
				var $temp$width = width,
					$temp$list = A2($elm$core$List$drop, width, list),
					$temp$acc = A2(
					$elm$core$List$cons,
					A2($elm$core$List$take, width, list),
					acc);
				width = $temp$width;
				list = $temp$list;
				acc = $temp$acc;
				continue breakList;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$core$Tuple$second),
	$elm$core$Maybe$withDefault(false));
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_ = F2(
	function (simplifiedList, _v0) {
		rule1Score_:
		while (true) {
			var last = _v0.a;
			var partialScore = _v0.b;
			var score = _v0.c;
			if (!simplifiedList.b) {
				return (partialScore >= 5) ? ((score + partialScore) - 2) : score;
			} else {
				var head = simplifiedList.a;
				var tail = simplifiedList.b;
				if (_Utils_eq(last, head)) {
					var $temp$simplifiedList = tail,
						$temp$_v0 = _Utils_Tuple3(last, partialScore + 1, score);
					simplifiedList = $temp$simplifiedList;
					_v0 = $temp$_v0;
					continue rule1Score_;
				} else {
					if (partialScore >= 5) {
						var $temp$simplifiedList = tail,
							$temp$_v0 = _Utils_Tuple3(head, 0, (score + partialScore) - 2);
						simplifiedList = $temp$simplifiedList;
						_v0 = $temp$_v0;
						continue rule1Score_;
					} else {
						var $temp$simplifiedList = tail,
							$temp$_v0 = _Utils_Tuple3(head, 0, score);
						simplifiedList = $temp$simplifiedList;
						_v0 = $temp$_v0;
						continue rule1Score_;
					}
				}
			}
		}
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function (a) {
			return A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_,
				a,
				_Utils_Tuple3(false, 0, 0));
		}),
	$elm$core$List$sum);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_ = F4(
	function (row1, row2, maybeLast, score) {
		rule2Score_:
		while (true) {
			if (!row1.b) {
				return score;
			} else {
				var head = row1.a;
				var tail = row1.b;
				if (!row2.b) {
					return score;
				} else {
					var head2 = row2.a;
					var tail2 = row2.b;
					if (_Utils_eq(head, head2)) {
						if (_Utils_eq(
							$elm$core$Maybe$Just(head),
							maybeLast)) {
							var $temp$row1 = tail,
								$temp$row2 = tail2,
								$temp$maybeLast = $elm$core$Maybe$Just(head),
								$temp$score = score + 3;
							row1 = $temp$row1;
							row2 = $temp$row2;
							maybeLast = $temp$maybeLast;
							score = $temp$score;
							continue rule2Score_;
						} else {
							var $temp$row1 = tail,
								$temp$row2 = tail2,
								$temp$maybeLast = $elm$core$Maybe$Just(head),
								$temp$score = score;
							row1 = $temp$row1;
							row2 = $temp$row2;
							maybeLast = $temp$maybeLast;
							score = $temp$score;
							continue rule2Score_;
						}
					} else {
						var $temp$row1 = tail,
							$temp$row2 = tail2,
							$temp$maybeLast = $elm$core$Maybe$Nothing,
							$temp$score = score;
						row1 = $temp$row1;
						row2 = $temp$row2;
						maybeLast = $temp$maybeLast;
						score = $temp$score;
						continue rule2Score_;
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score = F2(
	function (list, score) {
		rule2Score:
		while (true) {
			if (list.b && list.b.b) {
				var head1 = list.a;
				var _v1 = list.b;
				var head2 = _v1.a;
				var tail = _v1.b;
				var $temp$list = tail,
					$temp$score = score + A4($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_, head1, head2, $elm$core$Maybe$Nothing, 0);
				list = $temp$list;
				score = $temp$score;
				continue rule2Score;
			} else {
				return score;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_ = F2(
	function (simplifiedList, score) {
		rule3Score_:
		while (true) {
			_v0$3:
			while (true) {
				if (!simplifiedList.b) {
					return score;
				} else {
					if (!simplifiedList.a) {
						if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && (!simplifiedList.b.b.a)) && simplifiedList.b.b.b.b) && (!simplifiedList.b.b.b.a)) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.b.b.a) {
							var _v1 = simplifiedList.b;
							var _v2 = _v1.b;
							var _v3 = _v2.b;
							var _v4 = _v3.b;
							var _v5 = _v4.b;
							var _v6 = _v5.b;
							var _v7 = _v6.b;
							var _v8 = _v7.b;
							var _v9 = _v8.b;
							var _v10 = _v9.b;
							var tail = _v10.b;
							var $temp$simplifiedList = tail,
								$temp$score = score + 40;
							simplifiedList = $temp$simplifiedList;
							score = $temp$score;
							continue rule3Score_;
						} else {
							break _v0$3;
						}
					} else {
						if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && simplifiedList.b.b.a) && simplifiedList.b.b.b.b) && simplifiedList.b.b.b.a) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.b.a)) {
							var _v11 = simplifiedList.b;
							var _v12 = _v11.b;
							var _v13 = _v12.b;
							var _v14 = _v13.b;
							var _v15 = _v14.b;
							var _v16 = _v15.b;
							var _v17 = _v16.b;
							var _v18 = _v17.b;
							var _v19 = _v18.b;
							var _v20 = _v19.b;
							var tail = _v20.b;
							var $temp$simplifiedList = tail,
								$temp$score = score + 40;
							simplifiedList = $temp$simplifiedList;
							score = $temp$score;
							continue rule3Score_;
						} else {
							break _v0$3;
						}
					}
				}
			}
			var head = simplifiedList.a;
			var tail = simplifiedList.b;
			var $temp$simplifiedList = tail,
				$temp$score = score;
			simplifiedList = $temp$simplifiedList;
			score = $temp$score;
			continue rule3Score_;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score = A2($elm$core$List$foldl, $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_, 0);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score = F2(
	function (size, simplifiedList) {
		var moduleCount = size * size;
		var darkCount = $elm$core$List$length(
			A2($elm$core$List$filter, $elm$core$Basics$identity, simplifiedList));
		var darkPerc = $elm$core$Basics$round((100 * darkCount) / moduleCount);
		var remOf5 = darkPerc % 5;
		var nextMult5 = $elm$core$Basics$round(
			$elm$core$Basics$abs((darkPerc + (5 - remOf5)) - 50) / 5);
		var prevMult5 = $elm$core$Basics$round(
			$elm$core$Basics$abs((darkPerc - remOf5) - 50) / 5);
		return A2($elm$core$Basics$min, prevMult5, nextMult5) * 10;
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose = function (ll) {
	transpose:
	while (true) {
		if (!ll.b) {
			return _List_Nil;
		} else {
			if (!ll.a.b) {
				var xss = ll.b;
				var $temp$ll = xss;
				ll = $temp$ll;
				continue transpose;
			} else {
				var _v1 = ll.a;
				var x = _v1.a;
				var xs = _v1.b;
				var xss = ll.b;
				var tails = A2($elm$core$List$filterMap, $elm$core$List$tail, xss);
				var heads = A2($elm$core$List$filterMap, $elm$core$List$head, xss);
				return A2(
					$elm$core$List$cons,
					A2($elm$core$List$cons, x, heads),
					$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(
						A2($elm$core$List$cons, xs, tails)));
			}
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore = F2(
	function (size, matrix) {
		var list = A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule,
			$elm$core$Array$toList(matrix));
		var rowList = A3($pablohirafuji$elm_qrcode$QRCode$Matrix$breakList, size, list, _List_Nil);
		var transposedRowList = $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(rowList);
		return function (b) {
			return _Utils_Tuple2(rowList, b);
		}(
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score, size, list) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(transposedRowList) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(rowList) + (A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score, rowList, 0) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(transposedRowList) + $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(rowList))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt = function (ecLevel) {
	switch (ecLevel) {
		case 0:
			return 1;
		case 1:
			return 0;
		case 2:
			return 3;
		default:
			return 2;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit = function (_int) {
	var helper = F2(
		function (digit, int_) {
			helper:
			while (true) {
				if (!(!int_)) {
					var $temp$digit = digit + 1,
						$temp$int_ = int_ >>> 1;
					digit = $temp$digit;
					int_ = $temp$int_;
					continue helper;
				} else {
					return digit;
				}
			}
		});
	return A2(helper, 0, _int);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt = function (mask) {
	switch (mask) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		default:
			return 7;
	}
};
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo = F2(
	function (ecLevel, mask) {
		var g15Mask = 21522;
		var g15Int = 1335;
		var g15Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g15Int);
		var formatInfoInt = $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt(mask) | ($pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt(ecLevel) << 3);
		var helper = function (d_) {
			helper:
			while (true) {
				if (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit) >= 0) {
					var $temp$d_ = d_ ^ (g15Int << ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit));
					d_ = $temp$d_;
					continue helper;
				} else {
					return g15Mask ^ (d_ | (formatInfoInt << 10));
				}
			}
		};
		var d = formatInfoInt << 10;
		return helper(d);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal = F2(
	function (size, count) {
		return (count < 8) ? _Utils_Tuple2(8, (size - count) - 1) : ((count < 9) ? _Utils_Tuple2(8, 15 - count) : _Utils_Tuple2(8, (15 - count) - 1));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical = F2(
	function (size, count) {
		return (count < 6) ? _Utils_Tuple2(count, 8) : ((count < 8) ? _Utils_Tuple2(count + 1, 8) : _Utils_Tuple2((size - 15) + count, 8));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule = F4(
	function (size, isBlack, row, col) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, isBlack)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_ = F4(
	function (size, isBlackFn, count, matrix) {
		setFormatInfo_:
		while (true) {
			if (count < 15) {
				var isBlack = isBlackFn(count);
				var _v0 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical, size, count);
				var x2 = _v0.a;
				var y2 = _v0.b;
				var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal, size, count);
				var x1 = _v1.a;
				var y1 = _v1.b;
				var $temp$size = size,
					$temp$isBlackFn = isBlackFn,
					$temp$count = count + 1,
					$temp$matrix = A5(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule,
					size,
					isBlack,
					x2,
					y2,
					A5($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule, size, isBlack, x1, y1, matrix));
				size = $temp$size;
				isBlackFn = $temp$isBlackFn;
				count = $temp$count;
				matrix = $temp$matrix;
				continue setFormatInfo_;
			} else {
				return matrix;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo = F4(
	function (ecLevel, size, mask, matrix) {
		var isBlack = F2(
			function (bits_, count) {
				return (1 & (bits_ >> count)) === 1;
			});
		var bits = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo, ecLevel, mask);
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
			size,
			isBlack(bits),
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_ = F5(
	function (ecLevel, size, matrix, mask, _v0) {
		var minSMatrix = _v0.a;
		var minScore = _v0.b;
		var maskedMatrix = A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo,
			ecLevel,
			size,
			mask,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask, size, mask, matrix));
		var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore, size, maskedMatrix);
		var maskSMatrix = _v1.a;
		var maskScore = _v1.b;
		return ((_Utils_cmp(minScore, maskScore) < 0) && (!_Utils_eq(minScore, -1))) ? _Utils_Tuple2(minSMatrix, minScore) : _Utils_Tuple2(maskSMatrix, maskScore);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern0 = 0;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern1 = 1;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern2 = 2;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern3 = 3;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern4 = 4;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern5 = 5;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern6 = 6;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern7 = 7;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$patternList = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7]);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask = F3(
	function (ecLevel, size, matrix) {
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_, ecLevel, size, matrix),
			_Utils_Tuple2(_List_Nil, -1),
			$pablohirafuji$elm_qrcode$QRCode$Matrix$patternList).a;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo = F2(
	function (size, matrix) {
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
			size,
			$elm$core$Basics$always(true),
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo = function (version) {
	var g18Int = 7973;
	var g18Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g18Int);
	var helper = function (d_) {
		helper:
		while (true) {
			if (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit) >= 0) {
				var $temp$d_ = d_ ^ (g18Int << ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit));
				d_ = $temp$d_;
				continue helper;
			} else {
				return d_ | (version << 12);
			}
		}
	};
	var d = version << 12;
	return helper(d);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule = F3(
	function (size, isBlack, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, isBlack)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_ = F4(
	function (size, isBlackFn, count, matrix) {
		setVersionInfo_:
		while (true) {
			if (count < 18) {
				var topRight = _Utils_Tuple2(
					$elm$core$Basics$floor(count / 3),
					((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3);
				var isBlack = isBlackFn(count);
				var bottomLeft = _Utils_Tuple2(
					((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3,
					$elm$core$Basics$floor(count / 3));
				var $temp$size = size,
					$temp$isBlackFn = isBlackFn,
					$temp$count = count + 1,
					$temp$matrix = A4(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule,
					size,
					isBlack,
					bottomLeft,
					A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule, size, isBlack, topRight, matrix));
				size = $temp$size;
				isBlackFn = $temp$isBlackFn;
				count = $temp$count;
				matrix = $temp$matrix;
				continue setVersionInfo_;
			} else {
				return matrix;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo = F3(
	function (version, size, matrix) {
		if (version >= 7) {
			var isBlack = F2(
				function (bits_, count) {
					return (1 & (bits_ >> count)) === 1;
				});
			var bits = $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo(version);
			return A4(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_,
				size,
				isBlack(bits),
				0,
				matrix);
		} else {
			return matrix;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor = F2(
	function (row, col) {
		return (!A2($elm$core$Basics$modBy, 2, row + col)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(true, false));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming = F3(
	function (size, row, col) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor, row, col));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern = F2(
	function (size, matrix) {
		var range = A2($elm$core$List$range, 8, size - 9);
		return A3(
			$elm$core$List$foldl,
			function (b) {
				return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, b, 6);
			},
			A3(
				$elm$core$List$foldl,
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, 6),
				matrix,
				range),
			range);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$apply = function (_v0) {
	var ecLevel = _v0.a.hY;
	var groupInfo = _v0.a.mg;
	var bytes = _v0.b;
	var version = groupInfo.pW;
	var size = ((version - 1) * 4) + 21;
	return A2(
		$elm$core$Result$map,
		A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask, ecLevel, size),
		A2(
			$elm$core$Result$map,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$addData, size, bytes),
			A3(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern,
				version,
				size,
				A2(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern,
					size,
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule,
						version,
						size,
						A3(
							$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo,
							version,
							size,
							A2(
								$pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo,
								size,
								A4(
									$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
									size,
									-1,
									size - 8,
									A4(
										$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
										size,
										size - 8,
										-1,
										A4(
											$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
											size,
											-1,
											-1,
											A2(
												$elm$core$Array$initialize,
												size * size,
												$elm$core$Basics$always($elm$core$Maybe$Nothing))))))))))));
};
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$H = 3;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$L = 0;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$M = 1;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$Q = 2;
var $pablohirafuji$elm_qrcode$QRCode$convertEC = function (ec) {
	switch (ec) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound = {$: 0};
var $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow = {$: 7};
var $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar = {$: 2};
var $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar = {$: 1};
var $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char = {$: 3};
var $pablohirafuji$elm_qrcode$QRCode$LogTableException = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialModException = {$: 6};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException = {$: 5};
var $pablohirafuji$elm_qrcode$QRCode$convertError = function (e) {
	switch (e.$) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar;
		case 3:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char;
		case 4:
			var n = e.a;
			return $pablohirafuji$elm_qrcode$QRCode$LogTableException(n);
		case 5:
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException;
		case 6:
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialModException;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte = 236;
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte = 17;
var $pablohirafuji$elm_qrcode$QRCode$Encode$addFiller = F2(
	function (capacity, bytes) {
		var fillerLength = ((capacity / 8) | 0) - $elm$core$List$length(bytes);
		var ns = $elm$core$List$concat(
			A2(
				$elm$core$List$repeat,
				(fillerLength / 2) | 0,
				_List_fromArray(
					[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte, $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte])));
		return (!A2($elm$core$Basics$modBy, 2, fillerLength)) ? _Utils_ap(bytes, ns) : _Utils_ap(
			bytes,
			_Utils_ap(
				ns,
				_List_fromArray(
					[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte])));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator = F3(
	function (capacity, bitsCount, bits) {
		return _Utils_ap(
			bits,
			_List_fromArray(
				[
					_Utils_Tuple2(
					0,
					A2($elm$core$Basics$min, 4, capacity - bitsCount))
				]));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3 = function (_v0) {
	bitsToBytes3:
	while (true) {
		var _v1 = _v0.a;
		var bits = _v1.a;
		var length = _v1.b;
		var bytes = _v0.b;
		if (length >= 8) {
			var remLength = length - 8;
			var remBits = bits & ((1 << remLength) - 1);
			var _byte = bits >> remLength;
			var $temp$_v0 = _Utils_Tuple2(
				_Utils_Tuple2(remBits, remLength),
				A2($elm$core$List$cons, _byte, bytes));
			_v0 = $temp$_v0;
			continue bitsToBytes3;
		} else {
			return _Utils_Tuple2(
				_Utils_Tuple2(bits, length),
				bytes);
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2 = F2(
	function (_v0, _v1) {
		var curBits = _v0.a;
		var curLength = _v0.b;
		var _v2 = _v1.a;
		var remBits = _v2.a;
		var remLength = _v2.b;
		var bytes = _v1.b;
		var lengthSum = curLength + remLength;
		var bitsSum = curBits | (remBits << curLength);
		return $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3(
			_Utils_Tuple2(
				_Utils_Tuple2(bitsSum, lengthSum),
				bytes));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1 = F2(
	function (bits, _v0) {
		bitsToBytes1:
		while (true) {
			var _v1 = _v0.a;
			var remBits = _v1.a;
			var remLength = _v1.b;
			var bytes = _v0.b;
			if (bits.b) {
				var head = bits.a;
				var tail = bits.b;
				var $temp$bits = tail,
					$temp$_v0 = A2(
					$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2,
					head,
					_Utils_Tuple2(
						_Utils_Tuple2(remBits, remLength),
						bytes));
				bits = $temp$bits;
				_v0 = $temp$_v0;
				continue bitsToBytes1;
			} else {
				return (!remLength) ? $elm$core$List$reverse(bytes) : $elm$core$List$reverse(
					A2($elm$core$List$cons, remBits << (8 - remLength), bytes));
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes = function (bits) {
	return A2(
		$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1,
		bits,
		_Utils_Tuple2(
			_Utils_Tuple2(0, 0),
			_List_Nil));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8 = 3;
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength = F2(
	function (mode, version) {
		if (version <= 9) {
			switch (mode) {
				case 0:
					return 10;
				case 1:
					return 9;
				case 2:
					return 8;
				default:
					return 8;
			}
		} else {
			if (version <= 26) {
				switch (mode) {
					case 0:
						return 12;
					case 1:
						return 11;
					case 2:
						return 16;
					default:
						return 16;
				}
			} else {
				switch (mode) {
					case 0:
						return 14;
					case 1:
						return 13;
					case 2:
						return 16;
					default:
						return 16;
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator = F2(
	function (_v0, bits) {
		var groupInfo = _v0.mg;
		var inputStr = _v0.fK;
		var mode = _v0.iX;
		var length = A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.pW);
		var charCount = (mode === 3) ? $elm$core$List$length(bits) : $elm$core$String$length(inputStr);
		return _Utils_Tuple2(charCount, length);
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator = function (mode) {
	switch (mode) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		default:
			return 4;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits = function (_v0) {
	var bits = _v0.a;
	var model = _v0.b;
	return _Utils_Tuple2(
		model,
		A2(
			$pablohirafuji$elm_qrcode$QRCode$Encode$addFiller,
			model.mg.dK,
			$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes(
				A3(
					$pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator,
					model.mg.dK,
					model.eY,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							$pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator(model.iX),
							4),
						A2(
							$elm$core$List$cons,
							A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator, model, bits),
							bits))))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	var ecBlocks = _v0.c;
	return _Utils_Tuple2(
		model,
		$elm$core$List$concat(
			_Utils_ap(
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(dataBlocks),
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(ecBlocks))));
};
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, list) {
		if ((size <= 0) || (step <= 0)) {
			return _List_Nil;
		} else {
			var go = F2(
				function (xs, acc) {
					go:
					while (true) {
						if ($elm$core$List$isEmpty(xs)) {
							return $elm$core$List$reverse(acc);
						} else {
							var $temp$xs = A2($elm$core$List$drop, step, xs),
								$temp$acc = A2(
								$elm$core$List$cons,
								A2($elm$core$List$take, size, xs),
								acc);
							xs = $temp$xs;
							acc = $temp$acc;
							continue go;
						}
					}
				});
			return A2(go, list, _List_Nil);
		}
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar = {$: 2};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('0', 0),
			_Utils_Tuple2('1', 1),
			_Utils_Tuple2('2', 2),
			_Utils_Tuple2('3', 3),
			_Utils_Tuple2('4', 4),
			_Utils_Tuple2('5', 5),
			_Utils_Tuple2('6', 6),
			_Utils_Tuple2('7', 7),
			_Utils_Tuple2('8', 8),
			_Utils_Tuple2('9', 9),
			_Utils_Tuple2('A', 10),
			_Utils_Tuple2('B', 11),
			_Utils_Tuple2('C', 12),
			_Utils_Tuple2('D', 13),
			_Utils_Tuple2('E', 14),
			_Utils_Tuple2('F', 15),
			_Utils_Tuple2('G', 16),
			_Utils_Tuple2('H', 17),
			_Utils_Tuple2('I', 18),
			_Utils_Tuple2('J', 19),
			_Utils_Tuple2('K', 20),
			_Utils_Tuple2('L', 21),
			_Utils_Tuple2('M', 22),
			_Utils_Tuple2('N', 23),
			_Utils_Tuple2('O', 24),
			_Utils_Tuple2('P', 25),
			_Utils_Tuple2('Q', 26),
			_Utils_Tuple2('R', 27),
			_Utils_Tuple2('S', 28),
			_Utils_Tuple2('T', 29),
			_Utils_Tuple2('U', 30),
			_Utils_Tuple2('V', 31),
			_Utils_Tuple2('W', 32),
			_Utils_Tuple2('X', 33),
			_Utils_Tuple2('Y', 34),
			_Utils_Tuple2('Z', 35),
			_Utils_Tuple2(' ', 36),
			_Utils_Tuple2('$', 37),
			_Utils_Tuple2('%', 38),
			_Utils_Tuple2('*', 39),
			_Utils_Tuple2('+', 40),
			_Utils_Tuple2('-', 41),
			_Utils_Tuple2('.', 42),
			_Utils_Tuple2('/', 43),
			_Utils_Tuple2(':', 44)
		]));
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode = function (_char) {
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar,
		A2($elm$core$Dict$get, _char, $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary = function (chars) {
	_v0$2:
	while (true) {
		if (chars.b) {
			if (chars.b.b) {
				if (!chars.b.b.b) {
					var firstChar = chars.a;
					var _v1 = chars.b;
					var secondChar = _v1.a;
					return A3(
						$elm$core$Result$map2,
						F2(
							function (firstCode, secondCode) {
								return _Utils_Tuple2((firstCode * 45) + secondCode, 11);
							}),
						$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(firstChar),
						$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(secondChar));
				} else {
					break _v0$2;
				}
			} else {
				var _char = chars.a;
				return A2(
					$elm$core$Result$map,
					function (a) {
						return _Utils_Tuple2(a, 6);
					},
					$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(_char));
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode = function (str) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Result$map2($elm$core$List$cons),
		$elm$core$Result$Ok(_List_Nil),
		A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary,
			A2(
				$elm_community$list_extra$List$Extra$greedyGroupsOf,
				2,
				$elm$core$String$toList(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode = function (str) {
	return $elm$core$Result$Ok(
		A2(
			$elm$core$List$map,
			function (a) {
				return _Utils_Tuple2(
					$elm$core$Char$toCode(a),
					8);
			},
			$elm$core$String$toList(str)));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar = {$: 1};
var $elm$core$String$fromList = _String_fromList;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength = function (str) {
	var _v0 = $elm$core$String$length(str);
	switch (_v0) {
		case 1:
			return 4;
		case 2:
			return 7;
		default:
			return 10;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp = function (chars) {
	var str = $elm$core$String$fromList(chars);
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar,
		A2(
			$elm$core$Maybe$map,
			function (a) {
				return _Utils_Tuple2(
					a,
					$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength(str));
			},
			$elm$core$String$toInt(str)));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode = function (str) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Result$map2($elm$core$List$cons),
		$elm$core$Result$Ok(_List_Nil),
		A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp,
			A2(
				$elm_community$list_extra$List$Extra$greedyGroupsOf,
				3,
				$elm$core$String$toList(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char = {$: 3};
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $elm$bytes$Bytes$Encode$getStringWidth = _Bytes_getStringWidth;
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$loopHelp = F4(
	function (state, callback, bites, offset) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var decoder = _v0;
			var _v1 = A2(decoder, bites, offset);
			var newOffset = _v1.a;
			var step = _v1.b;
			if (!step.$) {
				var newState = step.a;
				var $temp$state = newState,
					$temp$callback = callback,
					$temp$bites = bites,
					$temp$offset = newOffset;
				state = $temp$state;
				callback = $temp$callback;
				bites = $temp$bites;
				offset = $temp$offset;
				continue loopHelp;
			} else {
				var result = step.a;
				return _Utils_Tuple2(newOffset, result);
			}
		}
	});
var $elm$bytes$Bytes$Decode$loop = F2(
	function (state, callback) {
		return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
	});
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$bytes$Bytes$Decode$map = F2(
	function (func, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var aOffset = _v1.a;
				var a = _v1.b;
				return _Utils_Tuple2(
					aOffset,
					func(a));
			});
	});
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return F2(
		function (_v0, offset) {
			return _Utils_Tuple2(offset, a);
		});
};
var $elm$bytes$Bytes$Decode$unsignedInt8 = _Bytes_read_u8;
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step = function (_v0) {
	var n = _v0.a;
	var xs = _v0.b;
	return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(
			$elm$core$List$reverse(xs))) : A2(
		$elm$bytes$Bytes$Decode$map,
		function (x) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					n - 1,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(x, 8),
						xs)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode = function (str) {
	var utf8BytesWidth = $elm$bytes$Bytes$Encode$getStringWidth(str);
	var decoder = A2(
		$elm$bytes$Bytes$Decode$loop,
		_Utils_Tuple2(utf8BytesWidth, _List_Nil),
		$pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step);
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char,
		A2(
			$elm$bytes$Bytes$Decode$decode,
			decoder,
			$elm$bytes$Bytes$Encode$encode(
				$elm$bytes$Bytes$Encode$string(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encoder = function (mode) {
	switch (mode) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable = $elm$core$Array$fromList(
	_List_fromArray(
		[1, 2, 4, 8, 16, 32, 64, 128, 29, 58, 116, 232, 205, 135, 19, 38, 76, 152, 45, 90, 180, 117, 234, 201, 143, 3, 6, 12, 24, 48, 96, 192, 157, 39, 78, 156, 37, 74, 148, 53, 106, 212, 181, 119, 238, 193, 159, 35, 70, 140, 5, 10, 20, 40, 80, 160, 93, 186, 105, 210, 185, 111, 222, 161, 95, 190, 97, 194, 153, 47, 94, 188, 101, 202, 137, 15, 30, 60, 120, 240, 253, 231, 211, 187, 107, 214, 177, 127, 254, 225, 223, 163, 91, 182, 113, 226, 217, 175, 67, 134, 17, 34, 68, 136, 13, 26, 52, 104, 208, 189, 103, 206, 129, 31, 62, 124, 248, 237, 199, 147, 59, 118, 236, 197, 151, 51, 102, 204, 133, 23, 46, 92, 184, 109, 218, 169, 79, 158, 33, 66, 132, 21, 42, 84, 168, 77, 154, 41, 82, 164, 85, 170, 73, 146, 57, 114, 228, 213, 183, 115, 230, 209, 191, 99, 198, 145, 63, 126, 252, 229, 215, 179, 123, 246, 241, 255, 227, 219, 171, 75, 150, 49, 98, 196, 149, 55, 110, 220, 165, 87, 174, 65, 130, 25, 50, 100, 200, 141, 7, 14, 28, 56, 112, 224, 221, 167, 83, 166, 81, 162, 89, 178, 121, 242, 249, 239, 195, 155, 43, 86, 172, 69, 138, 9, 18, 36, 72, 144, 61, 122, 244, 245, 247, 243, 251, 235, 203, 139, 11, 22, 44, 88, 176, 125, 250, 233, 207, 131, 27, 54, 108, 216, 173, 71, 142, 1]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp = function (index) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Array$get,
			A2($elm$core$Basics$modBy, 255, index),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException = {$: 5};
var $pablohirafuji$elm_qrcode$QRCode$Error$LogTableException = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable = $elm$core$Array$fromList(
	_List_fromArray(
		[0, 1, 25, 2, 50, 26, 198, 3, 223, 51, 238, 27, 104, 199, 75, 4, 100, 224, 14, 52, 141, 239, 129, 28, 193, 105, 248, 200, 8, 76, 113, 5, 138, 101, 47, 225, 36, 15, 33, 53, 147, 142, 218, 240, 18, 130, 69, 29, 181, 194, 125, 106, 39, 249, 185, 201, 154, 9, 120, 77, 228, 114, 166, 6, 191, 139, 98, 102, 221, 48, 253, 226, 152, 37, 179, 16, 145, 34, 136, 54, 208, 148, 206, 143, 150, 219, 189, 241, 210, 19, 92, 131, 56, 70, 64, 30, 66, 182, 163, 195, 72, 126, 110, 107, 58, 40, 84, 250, 133, 186, 61, 202, 94, 155, 159, 10, 21, 121, 43, 78, 212, 229, 172, 115, 243, 167, 87, 7, 112, 192, 247, 140, 128, 99, 13, 103, 74, 222, 237, 49, 197, 254, 24, 227, 165, 153, 119, 38, 184, 180, 124, 17, 68, 146, 217, 35, 32, 137, 46, 55, 63, 209, 91, 149, 188, 207, 205, 144, 135, 151, 178, 220, 252, 190, 97, 242, 86, 211, 171, 20, 42, 93, 158, 132, 60, 57, 83, 71, 109, 65, 162, 31, 45, 67, 216, 183, 123, 164, 118, 196, 23, 73, 236, 127, 12, 111, 246, 108, 161, 59, 82, 41, 157, 85, 170, 251, 96, 134, 177, 187, 204, 62, 90, 203, 89, 95, 176, 156, 169, 160, 81, 11, 245, 22, 235, 122, 117, 44, 215, 79, 174, 213, 233, 230, 231, 173, 232, 116, 214, 244, 234, 168, 80, 88, 175]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog = function (index) {
	return (index < 1) ? $elm$core$Result$Err(
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index)) : A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index),
		A2($elm$core$Array$get, index - 1, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset = function (_v0) {
	getOffset:
	while (true) {
		var num = _v0.a;
		var offset = _v0.b;
		if (num.b) {
			var head = num.a;
			var tail = num.b;
			if (!head) {
				var $temp$_v0 = _Utils_Tuple2(tail, offset + 1);
				_v0 = $temp$_v0;
				continue getOffset;
			} else {
				return offset;
			}
		} else {
			return offset;
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial = F2(
	function (num, shift) {
		var offset = $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset(
			_Utils_Tuple2(num, 0));
		var numArray = $elm$core$Array$fromList(num);
		return A2(
			$elm$core$Array$initialize,
			($elm$core$List$length(num) - offset) + shift,
			function (index) {
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Array$get, index + offset, numArray));
			});
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply = F2(
	function (poly1, poly2) {
		var valuesArray = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index1, value1) {
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (index2, value2) {
								return _Utils_Tuple3(index1 + index2, value1, value2);
							}),
						$elm$core$Array$toList(poly2));
				}),
			$elm$core$Array$toList(poly1));
		var process__ = F3(
			function (indexSum, num_, exp) {
				return A2(
					$elm$core$Result$fromMaybe,
					$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Bitwise$xor(exp),
						A2($elm$core$Array$get, indexSum, num_)));
			});
		var process_ = F2(
			function (_v0, num_) {
				var indexSum = _v0.a;
				var value1 = _v0.b;
				var value2 = _v0.c;
				return A2(
					$elm$core$Result$map,
					function (r) {
						return A3($elm$core$Array$set, indexSum, r, num_);
					},
					A2(
						$elm$core$Result$andThen,
						A2(process__, indexSum, num_),
						A2(
							$elm$core$Result$map,
							$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
							A3(
								$elm$core$Result$map2,
								$elm$core$Basics$add,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value1),
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
			});
		var process = F2(
			function (args, numResult) {
				return A2(
					$elm$core$Result$andThen,
					process_(args),
					numResult);
			});
		var num = A2(
			$elm$core$Array$initialize,
			($elm$core$Array$length(poly1) + $elm$core$Array$length(poly2)) - 1,
			$elm$core$Basics$always(0));
		return A2(
			$elm$core$Result$map,
			function (a) {
				return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
			},
			A2(
				$elm$core$Result$map,
				$elm$core$Array$toList,
				A3(
					$elm$core$List$foldl,
					process,
					$elm$core$Result$Ok(num),
					$elm$core$List$concat(valuesArray))));
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial = function (ecLength) {
	var generate = F2(
		function (count, polyResult) {
			generate:
			while (true) {
				if (_Utils_cmp(count, ecLength) < 0) {
					var $temp$count = count + 1,
						$temp$polyResult = A2(
						$elm$core$Result$andThen,
						function (a) {
							return A2(
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply,
								a,
								A2(
									$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
									_List_fromArray(
										[
											1,
											$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp(count)
										]),
									0));
						},
						polyResult);
					count = $temp$count;
					polyResult = $temp$polyResult;
					continue generate;
				} else {
					return polyResult;
				}
			}
		});
	return A2(
		generate,
		0,
		$elm$core$Result$Ok(
			A2(
				$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
				_List_fromArray(
					[1]),
				0)));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___ = F2(
	function (ecLength, modPoly) {
		return $elm$core$Array$toList(
			A2(
				$elm$core$Array$initialize,
				ecLength,
				function (index) {
					var modIndex = (index + $elm$core$Array$length(modPoly)) - ecLength;
					return (modIndex >= 0) ? A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($elm$core$Array$get, modIndex, modPoly)) : 0;
				}));
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException = {$: 6};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod = F2(
	function (poly1, poly2) {
		if (($elm$core$Array$length(poly1) - $elm$core$Array$length(poly2)) < 0) {
			return $elm$core$Result$Ok(poly1);
		} else {
			var helper_ = F3(
				function (index2, poly1_, exp) {
					return A2(
						$elm$core$Result$fromMaybe,
						$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Bitwise$xor(exp),
							A2($elm$core$Array$get, index2, poly1_)));
				});
			var getHead = function (poly) {
				return A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog,
					A2(
						$elm$core$Result$fromMaybe,
						$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
						A2($elm$core$Array$get, 0, poly)));
			};
			var ratio = A3(
				$elm$core$Result$map2,
				$elm$core$Basics$sub,
				getHead(poly1),
				getHead(poly2));
			var helper = F2(
				function (_v0, poly1_) {
					var index2 = _v0.a;
					var value2 = _v0.b;
					return A2(
						$elm$core$Result$map,
						function (r) {
							return A3($elm$core$Array$set, index2, r, poly1_);
						},
						A2(
							$elm$core$Result$andThen,
							A2(helper_, index2, poly1_),
							A2(
								$elm$core$Result$map,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
								A3(
									$elm$core$Result$map2,
									$elm$core$Basics$add,
									ratio,
									$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
				});
			var numFold = F2(
				function (args, poly1Result) {
					return A2(
						$elm$core$Result$andThen,
						helper(args),
						poly1Result);
				});
			var numResult = A3(
				$elm$core$Array$foldl,
				numFold,
				$elm$core$Result$Ok(poly1),
				A2(
					$elm$core$Array$indexedMap,
					F2(
						function (a, b) {
							return _Utils_Tuple2(a, b);
						}),
					poly2));
			return A2(
				$elm$core$Result$andThen,
				function (a) {
					return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod, a, poly2);
				},
				A2(
					$elm$core$Result$map,
					function (a) {
						return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
					},
					A2($elm$core$Result$map, $elm$core$Array$toList, numResult)));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__ = F2(
	function (rsPoly, dataCodewords) {
		return A2(
			$elm$core$Result$map,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___(
				$elm$core$Array$length(rsPoly) - 1),
			A2(
				$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod,
				A2(
					$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
					dataCodewords,
					$elm$core$Array$length(rsPoly) - 1),
				rsPoly));
	});
var $pablohirafuji$elm_qrcode$QRCode$Helpers$listResult = F3(
	function (fun, listb, lista) {
		if (lista.b) {
			var head = lista.a;
			var tail = lista.b;
			return A2(
				$elm$core$Result$andThen,
				function (a) {
					return A3($pablohirafuji$elm_qrcode$QRCode$Helpers$listResult, fun, a, tail);
				},
				A2(
					$elm$core$Result$map,
					function (r) {
						return A2($elm$core$List$cons, r, listb);
					},
					fun(head)));
		} else {
			return $elm$core$Result$Ok(
				$elm$core$List$reverse(listb));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_ = F2(
	function (byteBlocks, rsPoly) {
		return A3(
			$pablohirafuji$elm_qrcode$QRCode$Helpers$listResult,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__(rsPoly),
			_List_Nil,
			byteBlocks);
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get = F2(
	function (ecPerBlock, byteBlocks) {
		return A2(
			$elm$core$Result$andThen,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_(byteBlocks),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial(ecPerBlock));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	return A2(
		$elm$core$Result$map,
		function (c) {
			return _Utils_Tuple3(model, dataBlocks, c);
		},
		A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get, model.mg.lR, dataBlocks));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric = 1;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte = 2;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric = 0;
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {d: index, dd: match, nx: number, gP: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric = A2(
	$elm$regex$Regex$fromStringWith,
	{k3: false, nm: false},
	'^[0-9A-Z $%*+\\-.\\/:]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit = A2(
	$elm$regex$Regex$fromStringWith,
	{k3: false, nm: false},
	'^[\\u0000-\\u00ff]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber = A2(
	$elm$regex$Regex$fromStringWith,
	{k3: false, nm: false},
	'^[0-9]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode = function (input) {
	return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid(input) ? 0 : ($pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid(input) ? 1 : ($pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid(input) ? 2 : 3));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow = {$: 7};
var $pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity = F3(
	function (mode, dataLength, _v0) {
		var version = _v0.pW;
		var capacity = _v0.dK;
		return _Utils_cmp(
			A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, version) + dataLength,
			capacity) < 1;
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity = function (_v0) {
	var blockCount = _v0.a;
	var bytePerBlock = _v0.b;
	return blockCount * bytePerBlock;
};
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity = F2(
	function (group1, maybeGroup2) {
		if (!maybeGroup2.$) {
			var block2 = maybeGroup2.a;
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1) + $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(block2);
		} else {
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1);
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo = F4(
	function (version, ecPerBlock, group1, maybeGroup2) {
		return {
			dK: A2($pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity, group1, maybeGroup2) * 8,
			lR: ecPerBlock,
			ir: group1,
			nb: maybeGroup2,
			pW: version
		};
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		17,
		_Utils_Tuple2(1, 9),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		28,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		22,
		_Utils_Tuple2(2, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		16,
		_Utils_Tuple2(4, 9),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		22,
		_Utils_Tuple2(2, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 12))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		28,
		_Utils_Tuple2(4, 15),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		26,
		_Utils_Tuple2(4, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 14))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		26,
		_Utils_Tuple2(4, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		24,
		_Utils_Tuple2(4, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		28,
		_Utils_Tuple2(6, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		24,
		_Utils_Tuple2(3, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(8, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		28,
		_Utils_Tuple2(7, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		22,
		_Utils_Tuple2(12, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 12))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		30,
		_Utils_Tuple2(3, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(17, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(9, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 14))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		28,
		_Utils_Tuple2(15, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		30,
		_Utils_Tuple2(19, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		24,
		_Utils_Tuple2(34, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(16, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(30, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		30,
		_Utils_Tuple2(33, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(12, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(59, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(41, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(64, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(24, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(42, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(10, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(67, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(20, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(61, 16)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		7,
		_Utils_Tuple2(1, 19),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		10,
		_Utils_Tuple2(1, 34),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		15,
		_Utils_Tuple2(1, 55),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		20,
		_Utils_Tuple2(1, 80),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		26,
		_Utils_Tuple2(1, 108),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		20,
		_Utils_Tuple2(2, 78),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		24,
		_Utils_Tuple2(2, 97),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		30,
		_Utils_Tuple2(2, 116),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 69))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		20,
		_Utils_Tuple2(4, 81),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		24,
		_Utils_Tuple2(2, 92),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 93))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		26,
		_Utils_Tuple2(4, 107),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		30,
		_Utils_Tuple2(3, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		22,
		_Utils_Tuple2(5, 87),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 88))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		24,
		_Utils_Tuple2(5, 98),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 99))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(1, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		30,
		_Utils_Tuple2(5, 120),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 121))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		28,
		_Utils_Tuple2(3, 113),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 114))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		28,
		_Utils_Tuple2(3, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		28,
		_Utils_Tuple2(4, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 117))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		28,
		_Utils_Tuple2(2, 111),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 112))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(4, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(6, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		26,
		_Utils_Tuple2(8, 106),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 107))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(10, 114),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 115))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(8, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(3, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(7, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 117))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(5, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(12, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(6, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(17, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(4, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(18, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(20, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(19, 118),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 119)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		10,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		16,
		_Utils_Tuple2(1, 28),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		26,
		_Utils_Tuple2(1, 44),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		18,
		_Utils_Tuple2(2, 32),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		24,
		_Utils_Tuple2(2, 43),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		16,
		_Utils_Tuple2(4, 27),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		18,
		_Utils_Tuple2(4, 31),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		22,
		_Utils_Tuple2(2, 38),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 39))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		22,
		_Utils_Tuple2(3, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		26,
		_Utils_Tuple2(4, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 44))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		30,
		_Utils_Tuple2(1, 50),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 51))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		22,
		_Utils_Tuple2(6, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		22,
		_Utils_Tuple2(8, 37),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 38))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		24,
		_Utils_Tuple2(4, 40),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 41))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		24,
		_Utils_Tuple2(5, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 42))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		28,
		_Utils_Tuple2(7, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		26,
		_Utils_Tuple2(9, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 44))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(3, 44),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(11, 45))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		26,
		_Utils_Tuple2(3, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 42))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		26,
		_Utils_Tuple2(17, 42),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		28,
		_Utils_Tuple2(17, 46),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		28,
		_Utils_Tuple2(4, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		28,
		_Utils_Tuple2(6, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		28,
		_Utils_Tuple2(8, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(19, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		28,
		_Utils_Tuple2(22, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		28,
		_Utils_Tuple2(3, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		28,
		_Utils_Tuple2(21, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		28,
		_Utils_Tuple2(19, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		28,
		_Utils_Tuple2(2, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(29, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(21, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		28,
		_Utils_Tuple2(12, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		28,
		_Utils_Tuple2(6, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		28,
		_Utils_Tuple2(29, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		28,
		_Utils_Tuple2(13, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		28,
		_Utils_Tuple2(40, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		28,
		_Utils_Tuple2(18, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 48)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		13,
		_Utils_Tuple2(1, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		22,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		18,
		_Utils_Tuple2(2, 17),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		26,
		_Utils_Tuple2(2, 24),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		18,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		24,
		_Utils_Tuple2(4, 19),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		18,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		22,
		_Utils_Tuple2(4, 18),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 19))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		20,
		_Utils_Tuple2(4, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		24,
		_Utils_Tuple2(6, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		28,
		_Utils_Tuple2(4, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		26,
		_Utils_Tuple2(4, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 21))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		24,
		_Utils_Tuple2(8, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 21))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		20,
		_Utils_Tuple2(11, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		30,
		_Utils_Tuple2(5, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		24,
		_Utils_Tuple2(15, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(15, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(17, 21),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 22))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(28, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(8, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 24))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(4, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(1, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(37, 24))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(42, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(10, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(29, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(44, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(39, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(46, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(49, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(48, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(43, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(34, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 25)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData = function (ecLevel) {
	switch (ecLevel) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$getVersion = F3(
	function (ecLevel, mode, dataLength) {
		return A2(
			$elm$core$Result$fromMaybe,
			$pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow,
			$elm$core$List$head(
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.dK;
					},
					A2(
						$elm$core$List$filter,
						A2($pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity, mode, dataLength),
						$pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData(ecLevel)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel = F5(
	function (inputStr, ecLevel, mode, partialBitsCount, groupInfo) {
		return {
			eY: partialBitsCount + A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.pW),
			hY: ecLevel,
			mg: groupInfo,
			fK: inputStr,
			iX: mode
		};
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion = F4(
	function (inputStr, ecLevel, mode, encodedStr) {
		var partialBitsCount = 4 + A3(
			$elm$core$List$foldl,
			F2(
				function (a, b) {
					return a.b + b;
				}),
			0,
			encodedStr);
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(encodedStr, b);
			},
			A2(
				$elm$core$Result$map,
				A4($pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel, inputStr, ecLevel, mode, partialBitsCount),
				A3($pablohirafuji$elm_qrcode$QRCode$Encode$getVersion, ecLevel, mode, partialBitsCount)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$breakList = F3(
	function (checkFinish, _v0, _v1) {
		breakList:
		while (true) {
			var times = _v0.a;
			var itemCount = _v0.b;
			var byteList = _v1.a;
			var progress = _v1.b;
			if (times > 0) {
				var remainList = A2($elm$core$List$drop, itemCount, byteList);
				var block = A2($elm$core$List$take, itemCount, byteList);
				var $temp$checkFinish = checkFinish,
					$temp$_v0 = _Utils_Tuple2(times - 1, itemCount),
					$temp$_v1 = _Utils_Tuple2(
					remainList,
					A2($elm$core$List$cons, block, progress));
				checkFinish = $temp$checkFinish;
				_v0 = $temp$_v0;
				_v1 = $temp$_v1;
				continue breakList;
			} else {
				if (checkFinish && ($elm$core$List$length(byteList) > 0)) {
					return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow);
				} else {
					return $elm$core$Result$Ok(
						_Utils_Tuple2(byteList, progress));
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks = function (_v0) {
	var model = _v0.a;
	var groupInfo = model.mg;
	var byteList = _v0.b;
	var _v1 = groupInfo.nb;
	if (!_v1.$) {
		var group2 = _v1.a;
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				A2(
					$elm$core$Result$andThen,
					A2($pablohirafuji$elm_qrcode$QRCode$Encode$breakList, true, group2),
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
						false,
						groupInfo.ir,
						_Utils_Tuple2(byteList, _List_Nil)))));
	} else {
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				A3(
					$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
					true,
					groupInfo.ir,
					_Utils_Tuple2(byteList, _List_Nil))));
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encode = F2(
	function (inputStr, ecLevel) {
		var mode = $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode(inputStr);
		return A2(
			$elm$core$Result$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose,
			A2(
				$elm$core$Result$andThen,
				$pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection,
				A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks,
					A2(
						$elm$core$Result$map,
						$pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits,
						A2(
							$elm$core$Result$andThen,
							A3($pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion, inputStr, ecLevel, mode),
							A2($pablohirafuji$elm_qrcode$QRCode$Encode$encoder, mode, inputStr))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$fromStringWith = F2(
	function (ecLevel, input) {
		return A2(
			$elm$core$Result$mapError,
			$pablohirafuji$elm_qrcode$QRCode$convertError,
			A2(
				$elm$core$Result$andThen,
				function (_v0) {
					var encodeModel = _v0.a;
					var encodedData = _v0.b;
					return A2(
						$elm$core$Result$map,
						function (matrix) {
							return {de: matrix, pW: encodeModel.mg.pW};
						},
						$pablohirafuji$elm_qrcode$QRCode$Matrix$apply(
							_Utils_Tuple2(encodeModel, encodedData)));
				},
				A2(
					$pablohirafuji$elm_qrcode$QRCode$Encode$encode,
					input,
					$pablohirafuji$elm_qrcode$QRCode$convertEC(ecLevel))));
	});
var $pablohirafuji$elm_qrcode$QRCode$fromString = $pablohirafuji$elm_qrcode$QRCode$fromStringWith(2);
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize = 5;
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$appendLastRect = function (_v0) {
	var lastRect = _v0.a;
	var rowLines = _v0.b;
	return A2(
		$elm$core$List$cons,
		'h' + $elm$core$String$fromInt(lastRect.g6 * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
		rowLines);
};
var $elm$svg$Svg$Attributes$shapeRendering = _VirtualDom_attribute('shape-rendering');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$toRowLines = F2(
	function (isDark, _v0) {
		var lastRect = _v0.a;
		var rowLines = _v0.b;
		return isDark ? ((!lastRect.b3) ? _Utils_Tuple2(
			_Utils_update(
				lastRect,
				{g6: lastRect.g6 + 1}),
			rowLines) : _Utils_Tuple2(
			{b3: 0, g6: 1},
			A2(
				$elm$core$List$cons,
				$elm$core$String$concat(
					_List_fromArray(
						[
							(lastRect.g6 > 0) ? ('h' + $elm$core$String$fromInt(lastRect.g6 * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize)) : '',
							'm',
							$elm$core$String$fromInt(lastRect.b3 * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
							' 0'
						])),
				rowLines))) : _Utils_Tuple2(
			_Utils_update(
				lastRect,
				{b3: lastRect.b3 + 1}),
			rowLines);
	});
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewRow = F3(
	function (quietZoneSize, rowIndex, rowLines) {
		return A2(
			$elm$core$List$cons,
			'M0 ',
			A2(
				$elm$core$List$cons,
				$elm$core$String$fromInt(rowIndex * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
				rowLines));
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase = F3(
	function (quietZoneSize, extraAttrs, matrix) {
		var quietZonePx = quietZoneSize * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize;
		var sizePx = $elm$core$String$fromInt(
			($elm$core$List$length(matrix) * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize) + (2 * quietZonePx));
		return A2(
			$elm$svg$Svg$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$viewBox('0 0 ' + (sizePx + (' ' + sizePx))),
						$elm$svg$Svg$Attributes$shapeRendering('crispEdges'),
						$elm$svg$Svg$Attributes$stroke('#000'),
						$elm$svg$Svg$Attributes$strokeWidth(
						$elm$core$String$fromInt($pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize) + 'px')
					]),
				extraAttrs),
			function (d) {
				return _List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								d,
								$elm$svg$Svg$Attributes$transform(
								'translate(' + ($elm$core$String$fromInt(quietZonePx) + (', ' + ($elm$core$String$fromFloat(quietZonePx + ($pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize / 2)) + ')')))),
								$elm$svg$Svg$Attributes$strokeWidth('5px')
							]),
						_List_Nil)
					]);
			}(
				$elm$svg$Svg$Attributes$d(
					$elm$core$String$concat(
						$elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								$pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewRow(quietZoneSize),
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										A2(
											$elm$core$List$foldl,
											$pablohirafuji$elm_qrcode$QRCode$Render$Svg$toRowLines,
											_Utils_Tuple2(
												{b3: 0, g6: 0},
												_List_Nil)),
										A2($elm$core$Basics$composeR, $pablohirafuji$elm_qrcode$QRCode$Render$Svg$appendLastRect, $elm$core$List$reverse)),
									matrix)))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$view = $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase(4);
var $pablohirafuji$elm_qrcode$QRCode$toSvg = F2(
	function (extraAttrs, _v0) {
		var matrix = _v0.de;
		return A2($pablohirafuji$elm_qrcode$QRCode$Render$Svg$view, extraAttrs, matrix);
	});
var $author$project$Global$Overlays$twoFactorActivationContent = function (_v0) {
	var email = _v0.ff;
	var twoFactorSecret = _v0.g0;
	var activationCode = _v0.hb;
	var showKey = _v0.jT;
	var uri = F2(
		function (secret, user) {
			return 'otpauth://totp/' + (user + ('?secret=' + (secret + '&issuer=DMND')));
		});
	if (!twoFactorSecret.$) {
		var twoFactorString = twoFactorSecret.a;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('max-w-[50rem]')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-white')
							]),
						_List_fromArray(
							[
								A2(
								$elm$core$Result$withDefault,
								$elm$html$Html$text('Error while encoding to QRCode.'),
								A2(
									$elm$core$Result$map,
									$pablohirafuji$elm_qrcode$QRCode$toSvg(_List_Nil),
									$pablohirafuji$elm_qrcode$QRCode$fromString(
										A2(uri, twoFactorString, email))))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-16 pt-3 pb-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Scan the QR code with your authenticator app and enter the code bellow to activate 2FA.')
							])),
						showKey ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-12 pb-1 text-dmnd-lighter-yellow')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Unable to scan? Insert this code in your authenticator app: '),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-12 text-dmnd-red-1')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($elm$core$Maybe$withDefault, '', twoFactorSecret))
									])),
								$elm$html$Html$text(' '),
								$author$project$UI$Library$Button$copyToClipboard(
								{
									mt: 'w-2.5 h-2.5 inline mb-0.5',
									pV: A2($elm$core$Maybe$withDefault, '', twoFactorSecret)
								}),
								$elm$html$Html$text(' enter the code bellow to activate 2FA.')
							])) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-12 pb-1 text-dmnd-lighter-yellow')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Unable to scan? You can use the '),
								$author$project$UI$Library$Button$button(
								$author$project$UI$Library$Button$GreenInline(
									{
										A: $elm$html$Html$text('setup key'),
										cG: $author$project$TopMsg$globalMsg(
											$author$project$Global$Msg$ShowModal(
												A2($author$project$Global$Model$TwoFactorActivation, true, activationCode)))
									})),
								$elm$html$Html$text(' to manually configure your authenticator app.')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('two-fa-input-id'),
										$elm$html$Html$Attributes$class('bg-dmnd-black block border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-1 w-full'),
										$elm$html$Html$Attributes$placeholder('Activation token'),
										$elm$html$Html$Attributes$value(activationCode),
										$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$TopMsg$globalMsg, $author$project$Global$Msg$ShowModal),
											$author$project$Global$Model$TwoFactorActivation(showKey))),
										$elm$html$Html$Attributes$autocomplete(false)
									]),
								_List_Nil)
							])),
						$author$project$UI$Library$Button$button(
						$author$project$UI$Library$Button$GreenModal(
							{
								A: $elm$html$Html$text('Activate 2FA'),
								cG: $author$project$TopMsg$requestMsg(
									$author$project$Remote$RequestMsg$Activate2FA(activationCode))
							}))
					]))
			]);
	} else {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('max-w-[50rem]')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-16 pt-3 pb-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('We stumbled upon unexpected error. Please contact support at info@dmnd.work')
							])),
						$author$project$UI$Library$Button$button(
						$author$project$UI$Library$Button$Green(
							{
								A: $elm$html$Html$text('Ok'),
								cG: $author$project$TopMsg$globalMsg($author$project$Global$Msg$HideModal)
							}))
					]))
			]);
	}
};
var $author$project$Remote$RequestMsg$UpdateBitcoinAddress = function (a) {
	return {$: 26, a: a};
};
var $author$project$Global$Model$UpdateBitcoinAddressModal = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Global$Overlays$updateBitcoinAddressContent = F3(
	function (bitcoinAddress, twoFaToken, subAccountId) {
		var updateModal = F2(
			function (addr, token) {
				return $author$project$Global$Msg$ShowModal(
					A3($author$project$Global$Model$UpdateBitcoinAddressModal, addr, token, subAccountId));
			});
		var isValid = (!$elm$core$String$isEmpty(bitcoinAddress)) && (!$elm$core$String$isEmpty(twoFaToken));
		var submitButton = isValid ? $author$project$UI$Library$Button$button(
			$author$project$UI$Library$Button$GreenModal(
				{
					A: $elm$html$Html$text('Proceed'),
					cG: $author$project$TopMsg$requestMsg(
						$author$project$Remote$RequestMsg$UpdateBitcoinAddress(
							{hl: bitcoinAddress, o3: subAccountId, kj: twoFaToken}))
				})) : $author$project$UI$Library$Button$button(
			$author$project$UI$Library$Button$Disabled(
				{
					A: $elm$html$Html$text('Proceed')
				}));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('max-w-[50rem] w-full')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-18 font-semibold mb-4')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Update Bitcoin Address')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-14 text-dmnd-lighter-gray mb-4')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Enter your new Bitcoin address and 2FA token.')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-14 mb-2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Bitcoin Address')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('bitcoin-address-input'),
										$elm$html$Html$Attributes$class('bg-dmnd-black block border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-2 w-full'),
										$elm$html$Html$Attributes$placeholder('Enter your Bitcoin address'),
										$elm$html$Html$Attributes$value(bitcoinAddress),
										$elm$html$Html$Events$onInput(
										function (addr) {
											return $author$project$TopMsg$globalMsg(
												A2(updateModal, addr, twoFaToken));
										}),
										$elm$html$Html$Attributes$autocomplete(false)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-14 mb-2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('2FA Token')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('two-fa-token-input'),
										$elm$html$Html$Attributes$class('bg-dmnd-black block border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-2 w-full'),
										$elm$html$Html$Attributes$placeholder('Enter your 2FA token'),
										$elm$html$Html$Attributes$value(twoFaToken),
										$elm$html$Html$Events$onInput(
										function (token) {
											return $author$project$TopMsg$globalMsg(
												A2(updateModal, bitcoinAddress, token));
										}),
										$elm$html$Html$Attributes$autocomplete(false)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-4 text-left')
							]),
						_List_fromArray(
							[submitButton]))
					]))
			]);
	});
var $author$project$Global$Overlays$overlays = F2(
	function (route, topState) {
		var remoteModel = topState.eV.jr;
		var closeDialog = $author$project$TopMsg$globalMsg($author$project$Global$Msg$HideModal);
		var overlayWrapper = function (modal_) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute inset-0 flexCenter z3')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('absolute inset-0 blackBack o6'),
								$elm$html$Html$Events$onClick(closeDialog)
							]),
						_List_Nil),
					modal_));
		};
		var _v0 = topState;
		var browser = _v0.k0;
		var _v1 = topState.eV.me.cP;
		if (!_v1.$) {
			var dialogWindow = _v1.a;
			switch (dialogWindow.$) {
				case 0:
					var showKey = dialogWindow.a;
					var activationCode = dialogWindow.b;
					var _v3 = topState.eV.jr.pQ;
					if (_v3.$ === 2) {
						var email = _v3.a.ff;
						var twoFactorSecret = _v3.a.g0;
						return _List_fromArray(
							[
								$author$project$Global$Overlays$modal(
								$author$project$Global$Overlays$SimpleModal(
									{
										A: $author$project$Global$Overlays$twoFactorActivationContent(
											{hb: activationCode, ff: email, jT: showKey, g0: twoFactorSecret}),
										aJ: 'two-factor-activation'
									}))
							]);
					} else {
						return _List_fromArray(
							[
								$author$project$Global$Overlays$modal(
								$author$project$Global$Overlays$DmndModal(
									{
										hH: $author$project$TopMsg$globalMsg($author$project$Global$Msg$HideModal),
										A: _List_fromArray(
											[
												$elm$html$Html$text('Error')
											]),
										aJ: 'two-factor-activation-error'
									}))
							]);
					}
				case 1:
					return _List_fromArray(
						[
							$author$project$Global$Overlays$modal(
							$author$project$Global$Overlays$SimpleModal(
								{
									A: _List_fromArray(
										[
											$elm$html$Html$text('×')
										]),
									aJ: 'kyc-verification'
								}))
						]);
				case 2:
					var bitcoinAddress = dialogWindow.a;
					var twoFaToken = dialogWindow.b;
					var subAccountId = dialogWindow.c;
					return _List_fromArray(
						[
							$author$project$Global$Overlays$modal(
							$author$project$Global$Overlays$SimpleModal(
								{
									A: A3($author$project$Global$Overlays$updateBitcoinAddressContent, bitcoinAddress, twoFaToken, subAccountId),
									aJ: 'update-bitcoin-address'
								}))
						]);
				case 3:
					var subAccountName = dialogWindow.a;
					var pplnsPassword = dialogWindow.b;
					var fppsPassword = dialogWindow.c;
					return _List_fromArray(
						[
							$author$project$Global$Overlays$modal(
							$author$project$Global$Overlays$SimpleModal(
								{
									A: A3($author$project$Global$Overlays$subAccountPasswordsContent, subAccountName, pplnsPassword, fppsPassword),
									aJ: 'subaccount-passwords'
								}))
						]);
				default:
					var subAccountId = dialogWindow.a;
					var name = dialogWindow.b;
					var twoFaToken = dialogWindow.c;
					return _List_fromArray(
						[
							$author$project$Global$Overlays$modal(
							$author$project$Global$Overlays$SimpleModal(
								{
									A: A3($author$project$Global$Overlays$editSubAccountContent, subAccountId, name, twoFaToken),
									aJ: 'edit-subaccount'
								}))
						]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Remote$RequestMsg$BrokerLogout = {$: 61};
var $author$project$Remote$RequestMsg$Logout = {$: 2};
var $author$project$Remote$RequestMsg$Report = function (a) {
	return {$: 27, a: a};
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$UI$Library$PageHeader$render = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-row justify-between items-start gap-4 pt-2 pb-4 mb-4 border-b border-gray-800')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col min-w-0')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-white text-20 font-semibold uppercase tracking-wide')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(config.bs)
							])),
						function () {
						var _v0 = config.o8;
						if (!_v0.$) {
							var s = _v0.a;
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-dmnd-lighter-gray text-12 mt-1')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(s)
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}()
					])),
				function () {
				var _v1 = config.cO;
				if (!_v1.$) {
					var btn = _v1.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-shrink-0')
							]),
						_List_fromArray(
							[btn]));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$UI$Library$PageHeader$action = function (_v0) {
	var title = _v0.bs;
	var subtitle = _v0.o8;
	var button = _v0.k1;
	return $author$project$UI$Library$PageHeader$render(
		{
			cO: $elm$core$Maybe$Just(button),
			o8: subtitle,
			bs: title
		});
};
var $author$project$Remote$Model$canEditBtcAddress = function (remote) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.lS;
			},
			remote.nR));
};
var $author$project$UI$Account$View$checkRateLimit = F2(
	function (remote, currentTime) {
		var _v0 = remote.iK;
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var lastTime = _v0.a;
			var timeDiff = $elm$time$Time$posixToMillis(currentTime) - $elm$time$Time$posixToMillis(lastTime);
			var tenMinutesInMs = (10 * 60) * 1000;
			var remaining = A2($elm$core$Basics$max, 0, tenMinutesInMs - timeDiff);
			if (_Utils_cmp(timeDiff, tenMinutesInMs) > -1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var seconds = A2($elm$core$Basics$modBy, 60, (remaining / 1000) | 0);
				var minutes = (remaining / 60000) | 0;
				return $elm$core$Maybe$Just(
					$elm$core$String$fromInt(minutes) + ('m ' + ($elm$core$String$fromInt(seconds) + 's')));
			}
		}
	});
var $author$project$Remote$RequestMsg$NoOp = {$: 59};
var $author$project$Kernel$UI$EndlessList$EndlessList$InitialState = {$: 0};
var $turboMaCk$any_dict$Dict$Any$empty = function (toKey) {
	return {V: $elm$core$Dict$empty, aP: toKey};
};
var $author$project$Kernel$Types$OrderedCollection$empty = F2(
	function (toId, serializeId) {
		return {
			V: $turboMaCk$any_dict$Dict$Any$empty(serializeId),
			m: _List_Nil,
			gy: serializeId,
			gZ: toId
		};
	});
var $author$project$Kernel$UI$EndlessList$EndlessList$empty = F2(
	function (toId, serializeId) {
		return {
			hC: A2($author$project$Kernel$Types$OrderedCollection$empty, toId, serializeId),
			D: $author$project$Kernel$UI$EndlessList$EndlessList$InitialState
		};
	});
var $author$project$UI$Library$DateRangePicker$filterByDateRange = F4(
	function (today, toDate, model, items) {
		var _v0 = model.au;
		if (!_v0) {
			return items;
		} else {
			var _v1 = A3(
				$author$project$UI$Library$DateRangePicker$selectedRangeFor,
				today,
				A2($elm$core$List$map, toDate, items),
				model);
			var fromDate = _v1.a;
			var toDate_ = _v1.b;
			return ($elm$core$String$isEmpty(fromDate) || $elm$core$String$isEmpty(toDate_)) ? items : A2(
				$elm$core$List$filter,
				function (item) {
					var date = toDate(item);
					return (!$elm$core$String$isEmpty(date)) && ((_Utils_cmp(date, fromDate) > -1) && (_Utils_cmp(date, toDate_) < 1));
				},
				items);
		}
	});
var $author$project$UI$Library$AccountData$selectedGeneratedBTC = function (topState) {
	return A2($author$project$UI$Library$AccountData$generatedBTCForScope, topState.eV.me.dD, topState.eV.jr);
};
var $author$project$UI$Library$MainPageWrapper$filteredGeneratedBitcoin = function (topState) {
	return A2(
		$elm$core$Maybe$map,
		A3(
			$author$project$UI$Library$DateRangePicker$filterByDateRange,
			$author$project$UI$Util$currentDateString(topState.ph),
			function ($) {
				return $.h0;
			},
			topState.eV.im),
		$author$project$UI$Library$AccountData$selectedGeneratedBTC(topState));
};
var $author$project$UI$Library$MainPageWrapper$filteredPayouts = function (topState) {
	return A4(
		$author$project$UI$Library$DateRangePicker$filterByDateRange,
		$author$project$UI$Util$currentDateString(topState.ph),
		$author$project$Types$Payout$payoutDate,
		topState.eV.jb,
		topState.eV.jr.ek);
};
var $author$project$Msg$GeneratedBitcoinMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$TopMsg$generatedBitcoinMsg = A2($elm$core$Basics$composeL, $author$project$Kernel$Msg$AppMsg, $author$project$Msg$GeneratedBitcoinMsg);
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $author$project$UI$Library$TablePagination$paginate = F2(
	function (state, items) {
		var pageSize = $author$project$UI$Library$TablePagination$normalizePageSize(state.i9);
		var totalPages = A2(
			$elm$core$Basics$max,
			1,
			$elm$core$Basics$ceiling(
				$elm$core$List$length(items) / pageSize));
		var currentPage = A3($elm$core$Basics$clamp, 1, totalPages, state.nN);
		var startIndex = (currentPage - 1) * pageSize;
		return {
			bQ: currentPage,
			mN: A2(
				$elm$core$List$take,
				pageSize,
				A2($elm$core$List$drop, startIndex, items)),
			i9: pageSize,
			eD: totalPages
		};
	});
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$UI$Library$MainPageWrapper$generatedBitcoinTableData = function (topState) {
	var rewardDataRow = F3(
		function (entryDay, generatedAmount, hashrate) {
			return A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('border-b border-gray-800 hover:bg-gray-900')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 text-white')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(entryDay)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(hashrate)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(generatedAmount)
							]))
					]));
		});
	var rows = function () {
		var _v0 = _Utils_Tuple2(
			$author$project$UI$Library$AccountData$selectedGeneratedBTC(topState),
			$author$project$UI$Library$MainPageWrapper$filteredGeneratedBitcoin(topState));
		_v0$1:
		while (true) {
			if (_v0.a.$ === 1) {
				var _v1 = _v0.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('py-3 pr-3 text-dmnd-lighter-gray'),
										$elm$html$Html$Attributes$colspan(3)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Loading generated BTC...')
									]))
							]))
					]);
			} else {
				if (!_v0.b.$) {
					if (!_v0.a.a.b) {
						break _v0$1;
					} else {
						if (!_v0.b.a.b) {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('py-3 pr-3 text-dmnd-lighter-gray'),
													$elm$html$Html$Attributes$colspan(3)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('No generated BTC found for selected date range')
												]))
										]))
								]);
						} else {
							var generatedEntries = _v0.b.a;
							return A2(
								$elm$core$List$map,
								function (_v2) {
									var entry_day = _v2.h0;
									var btc_generated = _v2.hs;
									var hashrate = _v2.d1;
									return A3(
										rewardDataRow,
										entry_day,
										$author$project$Types$BTC$toString(btc_generated) + ' BTC',
										$author$project$Types$Hashrate$toString(
											$author$project$Types$Hashrate$rawHashrateToHashrate(hashrate)));
								},
								A2($author$project$UI$Library$TablePagination$paginate, topState.eV.$9, generatedEntries).mN);
						}
					}
				} else {
					if (!_v0.a.a.b) {
						break _v0$1;
					} else {
						var _v3 = _v0.b;
						return _List_Nil;
					}
				}
			}
		}
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-3 pr-3 text-dmnd-lighter-gray'),
								$elm$html$Html$Attributes$colspan(3)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('No generated BTC found')
							]))
					]))
			]);
	}();
	return _Utils_Tuple2(
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('border-b border-gray-700')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Entry day')
							])),
						A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Hashrate')
							])),
						A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('BTC generated')
							]))
					]))
			]),
		rows);
};
var $elm_community$html_extra$Html$Extra$nothing = $elm$html$Html$text('');
var $author$project$UI$Library$MainPageWrapper$newPlatformNotice = function (topState) {
	var _v0 = topState.eV.jr.pQ;
	if (_v0.$ === 2) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-1 ml-auto w-fit bg-dmnd-black p-1.5 text-12 text-right text-white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-white font-weight-semibold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Our new dashboard is live. ')
						])),
					$elm$html$Html$text('Check it out at '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('https://new-platform.dmnd.work/'),
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$class('text-dmnd-red-1 underline hover:text-dmnd-red-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('new-platform.dmnd.work')
						])),
					$elm$html$Html$text(' and tell us what you think.')
				]));
	} else {
		return $elm_community$html_extra$Html$Extra$nothing;
	}
};
var $author$project$Msg$PayoutsMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$TopMsg$payoutsMsg = A2($elm$core$Basics$composeL, $author$project$Kernel$Msg$AppMsg, $author$project$Msg$PayoutsMsg);
var $author$project$Kernel$UI$CustomTooltip$CustomTooltip$Center = 1;
var $author$project$Kernel$UI$CustomTooltip$CustomTooltip$Top = 0;
var $author$project$Kernel$UI$CustomTooltip$CustomTooltip$tooltipPositionToAttribute = function (_v0) {
	var side = _v0.a;
	var alignment = _v0.b;
	return A2(
		$elm$html$Html$Attributes$attribute,
		'tooltip-prefers',
		function () {
			switch (side) {
				case 0:
					return 'top';
				case 1:
					return 'right';
				case 2:
					return 'bottom';
				default:
					return function (sideString) {
						return _Utils_ap(
							sideString,
							function () {
								switch (alignment) {
									case 0:
										return '-start';
									case 1:
										return '';
									default:
										return '-end';
								}
							}());
					}('left');
			}
		}());
};
var $author$project$Kernel$UI$CustomTooltip$CustomTooltip$tooltipable = F3(
	function (cfg, attributes, content) {
		return A3(
			$elm$html$Html$node,
			'custom-tooltip',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative'),
					$elm$html$Html$Attributes$class(cfg.hA),
					A2(
					$elm$html$Html$Attributes$attribute,
					'timeout',
					$elm$core$String$fromInt(cfg.pi)),
					$author$project$Kernel$UI$CustomTooltip$CustomTooltip$tooltipPositionToAttribute(cfg.pD)
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$div, attributes, content),
					A3(
					$elm$html$Html$node,
					'tooltip-content',
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute'),
							$elm$html$Html$Attributes$class(cfg.pC)
						]),
					_List_fromArray(
						[
							A3(
							$elm$html$Html$node,
							'tooltip-arrow',
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute'),
									$elm$html$Html$Attributes$class(cfg.kM)
								]),
							_List_Nil),
							cfg.pB
						]))
				]));
	});
var $author$project$Types$BTC$sum = function (values) {
	return $author$project$Types$BTC$fromSatoshis(
		$elm$core$List$sum(
			A2($elm$core$List$map, $author$project$Types$BTC$toSatoshis, values)));
};
var $author$project$Types$Payout$totalAmount = function (payouts) {
	return $author$project$Types$BTC$sum(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.dG;
			},
			payouts));
};
var $author$project$UI$Library$MainPageWrapper$truncateMiddle = F3(
	function (leftCount, rightCount, value) {
		return (_Utils_cmp(
			$elm$core$String$length(value),
			(leftCount + rightCount) + 3) < 1) ? value : (A2($elm$core$String$left, leftCount, value) + ('...' + A2($elm$core$String$right, rightCount, value)));
	});
var $author$project$UI$Library$MainPageWrapper$payoutsTableData = function (topState) {
	var txIdCell = function (txid) {
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('py-2 pr-3')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Kernel$UI$CustomTooltip$CustomTooltip$tooltipable,
					{
						kM: 'hidden',
						hA: 'inline-block',
						pi: 0,
						pB: $elm$html$Html$text('Open link'),
						pC: 'bg-gray-900 text-gray-300 text-10 p-1 rounded shadow-lg whitespace-nowrap z-50',
						pD: _Utils_Tuple2(0, 1)
					},
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cursor-pointer hover:text-green-500'),
							$elm$html$Html$Events$onClick(
							$author$project$TopMsg$globalMsg(
								$author$project$Global$Msg$OpenNewTab('https://mempool.space/tx/' + txid)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($author$project$UI$Library$MainPageWrapper$truncateMiddle, 8, 8, txid))
						]))
				]));
	};
	var payoutStatusRow = function (message) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-3 pr-3 text-dmnd-lighter-gray'),
							$elm$html$Html$Attributes$colspan(5)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]))
				]));
	};
	var copyableCell = F2(
		function (fullValue, truncatedValue) {
			return A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('py-2 pr-3')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Kernel$UI$CustomTooltip$CustomTooltip$tooltipable,
						{
							kM: 'hidden',
							hA: 'inline-block',
							pi: 0,
							pB: $elm$html$Html$text('Click to copy'),
							pC: 'bg-gray-900 text-gray-300 text-10 p-1 rounded shadow-lg whitespace-nowrap z-50',
							pD: _Utils_Tuple2(0, 1)
						},
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cursor-pointer hover:text-green-500'),
								$elm$html$Html$Events$onClick(
								$author$project$TopMsg$globalMsg(
									$author$project$Global$Msg$CopyToClipboard(fullValue)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(truncatedValue)
							]))
					]));
		});
	var payoutDataRow = function (payout) {
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-b border-gray-800 hover:bg-gray-900')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 text-white whitespace-nowrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Types$Payout$payoutDate(payout))
						])),
					txIdCell(payout.kk),
					A2(
					copyableCell,
					payout.dr,
					A3($author$project$UI$Library$MainPageWrapper$truncateMiddle, 4, 4, payout.dr)),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 text-white')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Types$BTC$toString(payout.dG) + ' BTC')
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$toUpper(
								$author$project$Types$Payout$kindToString(payout.iJ)))
						]))
				]));
	};
	var balanceRow = function (filtered) {
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-t border-gray-700')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-3 pr-3'),
							$elm$html$Html$Attributes$colspan(2)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-3 pr-3 font-semibold text-gray-200 whitespace-nowrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Grand total')
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-3 pr-3 font-mono font-semibold text-green-400 whitespace-nowrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Types$BTC$toString(
								$author$project$Types$Payout$totalAmount(filtered)) + ' BTC')
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-3 pr-3')
						]),
					_List_Nil)
				]));
	};
	var rows = function () {
		var payouts = topState.eV.jr.ek;
		var filtered = $author$project$UI$Library$MainPageWrapper$filteredPayouts(topState);
		var _v0 = _Utils_Tuple3(
			$author$project$Remote$Model$payoutsAreLoading(topState.eV.jr),
			payouts,
			filtered);
		if (!_v0.b.b) {
			if (_v0.a) {
				return _List_fromArray(
					[
						payoutStatusRow('Loading payouts...')
					]);
			} else {
				return _List_fromArray(
					[
						payoutStatusRow('No payouts found')
					]);
			}
		} else {
			if (!_v0.c.b) {
				return _List_fromArray(
					[
						payoutStatusRow('No payouts found for selected date range')
					]);
			} else {
				var filteredPayoutRows = _v0.c;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						payoutDataRow,
						A2($author$project$UI$Library$TablePagination$paginate, topState.eV.jc, filteredPayoutRows).mN),
					_List_fromArray(
						[
							balanceRow(filteredPayoutRows)
						]));
			}
		}
	}();
	return _Utils_Tuple2(
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('border-b border-gray-700')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Date')
							])),
						A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('TxID')
							])),
						A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('To')
							])),
						A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Amount')
							])),
						A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Kind')
							]))
					]))
			]),
		rows);
};
var $author$project$Global$Msg$ToggleSidebar = {$: 5};
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $author$project$UI$Svg$connectIcon = function (classes) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 135.419 135.419'),
				$elm$svg$Svg$Attributes$width('2.25rem'),
				$elm$svg$Svg$Attributes$height('2.25rem'),
				$elm$svg$Svg$Attributes$class('group-hover:fill-dmnd-black ' + classes)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M 68.589358,96.528086 86.974134,78.143309 c 1.561999,-1.561998 1.561999,-4.094855 0,-5.656854 -1.561999,-1.561999 -4.094855,-1.561999 -5.656854,0 L 62.932504,90.871232 44.547727,72.486455 62.932504,54.101679 c 1.561999,-1.561999 1.561999,-4.094856 0,-5.656854 -1.561999,-1.561999 -4.094856,-1.561999 -5.656854,0 L 38.890873,66.829601 32.526912,60.46564 21.213204,71.779348 C 10.950256,82.042296 9.6788776,97.889973 17.396241,109.53744 L 0,126.93368 8.4852813,135.41896 25.881523,118.02272 c 11.647463,7.71736 27.49514,6.44598 37.758088,-3.81697 l 11.313708,-11.3137 -6.363961,-6.363964 z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m 102.89204,74.953321 11.31372,-11.313712 c 10.26295,-10.262948 11.53433,-26.110625 3.81696,-37.758088 L 135.41896,8.48528 126.93368,0 109.53744,17.396239 C 97.889972,9.67888 82.042292,10.95025 71.779342,21.213202 l -11.3137,11.313708 c 41.502088,41.502087 0.33001,0.330023 42.426398,42.426411 z')
							]),
						_List_Nil)
					]))
			]));
};
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$UI$Svg$fistLogo = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('30'),
			$elm$svg$Svg$Attributes$height('31'),
			$elm$svg$Svg$Attributes$viewBox('0 0 30 31'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('5.39059'),
					$elm$svg$Svg$Attributes$height('23.203'),
					$elm$svg$Svg$Attributes$fill('white')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('8.20288'),
					$elm$svg$Svg$Attributes$width('5.39059'),
					$elm$svg$Svg$Attributes$height('23.203'),
					$elm$svg$Svg$Attributes$fill('white')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('16.4059'),
					$elm$svg$Svg$Attributes$width('5.39059'),
					$elm$svg$Svg$Attributes$height('23.203'),
					$elm$svg$Svg$Attributes$fill('white')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('24.6094'),
					$elm$svg$Svg$Attributes$width('5.39059'),
					$elm$svg$Svg$Attributes$height('23.203'),
					$elm$svg$Svg$Attributes$fill('white')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('29.9996'),
					$elm$svg$Svg$Attributes$y('25.3121'),
					$elm$svg$Svg$Attributes$width('5.39059'),
					$elm$svg$Svg$Attributes$height('13.5937'),
					$elm$svg$Svg$Attributes$transform('rotate(90 29.9996 25.3121)'),
					$elm$svg$Svg$Attributes$fill('white')
				]),
			_List_Nil)
		]));
var $author$project$Types$PplnsProjection$currentHorizon = function (projection) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (horizon) {
				return !horizon.fy;
			},
			projection.fz));
};
var $author$project$Types$PplnsProjection$hasPayableWork = function (projection) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (horizon) {
				return horizon.jB > 0;
			},
			$author$project$Types$PplnsProjection$currentHorizon(projection)));
};
var $author$project$Remote$Model$hasPayablePplnsWork = function (remote) {
	var _v0 = remote.dk;
	if (_v0.$ === 4) {
		var projection = _v0.a;
		return $author$project$Types$PplnsProjection$hasPayableWork(projection);
	} else {
		return false;
	}
};
var $author$project$UI$Svg$homeIcon = function (classes) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 18 19'),
				$elm$svg$Svg$Attributes$width('2.25rem'),
				$elm$svg$Svg$Attributes$height('2.25rem'),
				$elm$svg$Svg$Attributes$class('group-hover:fill-dmnd-black ' + classes)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M18 18C18 18.2652 17.8946 18.5196 17.7071 18.7071C17.5196 18.8946 17.2652 19 17 19H1C0.734784 19 0.48043 18.8946 0.292893 18.7071C0.105357 18.5196 2.4071e-07 18.2652 2.4071e-07 18V7.48999C-0.000105484 7.3376 0.0346172 7.18721 0.101516 7.05029C0.168415 6.91337 0.26572 6.79356 0.386 6.69999L8.386 0.47699C8.56154 0.340436 8.7776 0.266296 9 0.266296C9.2224 0.266296 9.43846 0.340436 9.614 0.47699L17.614 6.69999C17.7343 6.79356 17.8316 6.91337 17.8985 7.05029C17.9654 7.18721 18.0001 7.3376 18 7.48999V18Z')
					]),
				_List_Nil)
			]));
};
var $author$project$UI$Svg$largeWhiteLogo = function (classes) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 177 77'),
				$elm$svg$Svg$Attributes$class(classes)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M42.6653 9.25639C40.1982 5.65355 36.926 3.14022 32.9386 1.79102C30.6308 1.00598 27.7235 0.582116 24.2776 0.531372H0V58.2216H24.2776C28.5111 58.2216 32.2581 57.3022 35.4174 55.4903C38.5882 53.6725 41.2261 50.9174 43.2676 47.3026C46.2212 42.0401 47.7183 35.5538 47.7183 28.0288C47.7183 25.0587 47.3679 21.8947 46.673 18.6232C45.9635 15.283 44.617 12.1339 42.6653 9.25938V9.25639ZM33.9405 26.596C33.9405 27.2646 33.9405 27.9959 33.9405 28.8138C33.9405 32.7092 33.3933 36.0971 32.319 38.882C30.4194 43.7774 27.1704 46.1594 22.3838 46.1594H13.2623V12.5936H22.3838C26.9938 12.5936 30.0835 13.901 31.5603 16.477C31.7514 16.8143 31.9251 17.1247 32.0873 17.4173C33.1471 19.7515 33.7668 22.826 33.9376 26.596H33.9405Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M71.7665 0.0298495H71.7549L68.1411 17.6202L64.4751 0.28954V0H51.0361V58.1708H64.4751V25.0885L67.9673 49.1144L71.7665 25.0288V58.1708H85.2054V0H71.7665V0.0298495Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M110.926 34.3091L103.632 1.05667V0H90.1958V58.1708H103.632V24.6318L110.909 57.8066H110.926V58.1708H124.362V0H110.926V34.3091Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M175.955 18.623C175.245 15.2828 173.899 12.1337 171.947 9.2592C169.48 5.65636 166.208 3.14303 162.22 1.79383C159.913 1.00879 157.005 0.584924 153.559 0.53418H129.282V58.2214H153.559C157.793 58.2214 161.54 57.302 164.699 55.4902C167.87 53.6723 170.511 50.9172 172.549 47.3024C175.503 42.04 177 35.5536 177 28.0286C177 25.0586 176.65 21.8945 175.955 18.623ZM163.222 26.5958C163.222 27.2644 163.222 27.9957 163.222 28.8136C163.222 32.709 162.675 36.0969 161.601 38.8819C159.701 43.7772 156.452 46.1592 151.666 46.1592H142.544V12.5934H151.666C156.275 12.5934 159.365 13.9008 160.842 16.4768C161.033 16.8141 161.207 17.1245 161.369 17.4171C162.429 19.7513 163.049 22.8258 163.219 26.5958H163.222Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M124.362 63.1499H90.343V77.0001H124.362V63.1499Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil)
			]));
};
var $author$project$UI$Svg$logoutIcon = function (classes) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 18 18'),
				$elm$svg$Svg$Attributes$width('2.25rem'),
				$elm$svg$Svg$Attributes$height('2.25rem'),
				$elm$svg$Svg$Attributes$class('group-hover:fill-dmnd-black ' + classes)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7.7091 0V10.4095H10.2909V0H7.7091ZM2.63562 2.63562C1.00693 4.2643 0 6.51471 0 9C0 13.9706 4.02943 18 9 18C13.9706 18 18 13.9706 18 9C18 6.51471 16.993 4.2643 15.3644 2.63562L13.5516 4.44837C14.7165 5.61324 15.4369 7.22265 15.4369 9C15.4369 12.5547 12.5547 15.4369 9 15.4369C5.44528 15.4369 2.56311 12.5547 2.56311 9C2.56311 7.22265 3.28349 5.61324 4.44837 4.44837L2.63562 2.63562Z')
					]),
				_List_Nil)
			]));
};
var $author$project$UI$Svg$monitoringIcon = function (classes) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 18 18'),
				$elm$svg$Svg$Attributes$width('2.25rem'),
				$elm$svg$Svg$Attributes$height('2.25rem'),
				$elm$svg$Svg$Attributes$class('group-hover:fill-dmnd-black ' + classes)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M3.725 13L2 14.725V16H2.85L5.85 13H3.725ZM7.675 13L4.675 16H6.8L9.8 13H7.675ZM11.4 13L8.4 16H10.525L13.525 13H11.4ZM15.15 13L12.15 16H14.275L16 14.275V13H15.15ZM13.35 3.5L9.675 7.175L7.675 5.175L3.25 9.6L4.65 11L7.675 8L9.675 10L14.75 4.9L13.35 3.5ZM0 18V0H18V18H0Z')
					]),
				_List_Nil)
			]));
};
var $author$project$UI$Svg$rewardsIcon = function (classes) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 18 19'),
				$elm$svg$Svg$Attributes$width('2.25rem'),
				$elm$svg$Svg$Attributes$height('2.25rem'),
				$elm$svg$Svg$Attributes$class('group-hover:fill-dmnd-black ' + classes)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M9 8.06545C13.9711 8.06545 18 6.38499 18 4.31428C18 2.24358 13.9711 0.56311 9 0.56311C4.02891 0.56311 0 2.24358 0 4.31428C0 6.38499 4.02891 8.06545 9 8.06545ZM9 14.0631C5.56523 14.0631 2.52773 13.2369 0.611719 11.9608C0.221484 12.3826 0 12.8362 0 13.3143C0 15.385 4.02891 17.0655 9 17.0655C13.9711 17.0655 18 15.385 18 13.3143C18 12.8362 17.7785 12.3826 17.3883 11.9643C15.4723 13.2369 12.4348 14.0631 9 14.0631ZM9 9.56311C5.56523 9.56311 2.52773 8.73694 0.611719 7.46077C0.221484 7.88264 0 8.33616 0 8.81428C0 10.885 4.02891 12.5655 9 12.5655C13.9711 12.5655 18 10.885 18 8.81428C18 8.33616 17.7785 7.88264 17.3883 7.46428C15.4723 8.73694 12.4348 9.56311 9 9.56311Z')
					]),
				_List_Nil)
			]));
};
var $author$project$UI$Svg$userIcon = function (classes) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 18 18'),
				$elm$svg$Svg$Attributes$width('2.25rem'),
				$elm$svg$Svg$Attributes$height('2.25rem'),
				$elm$svg$Svg$Attributes$class('group-hover:fill-dmnd-black ' + classes)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M9 10C9.96667 10 10.7917 9.65833 11.475 8.975C12.1583 8.29167 12.5 7.46667 12.5 6.5C12.5 5.53333 12.1583 4.70833 11.475 4.025C10.7917 3.34167 9.96667 3 9 3C8.03333 3 7.20833 3.34167 6.525 4.025C5.84167 4.70833 5.5 5.53333 5.5 6.5C5.5 7.46667 5.84167 8.29167 6.525 8.975C7.20833 9.65833 8.03333 10 9 10ZM0 18V0H18V18H0ZM2 16H16V14.85C15.1 13.9667 14.0543 13.271 12.863 12.763C11.6717 12.255 10.384 12.0007 9 12C7.616 11.9993 6.32833 12.2537 5.137 12.763C3.94567 13.2723 2.9 13.968 2 14.85V16Z')
					]),
				_List_Nil)
			]));
};
var $author$project$UI$Svg$workersIcon = function (classes) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 20 21'),
				$elm$svg$Svg$Attributes$width('2.25rem'),
				$elm$svg$Svg$Attributes$height('2.25rem'),
				$elm$svg$Svg$Attributes$class('group-hover:fill-dmnd-black ' + classes)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M10 0.436646C4.48 0.436646 0 4.91665 0 10.4366C0 15.9566 4.48 20.4366 10 20.4366C15.52 20.4366 20 15.9566 20 10.4366C20 4.91665 15.52 0.436646 10 0.436646ZM6 15.9366C5.33696 15.9366 4.70107 15.6733 4.23223 15.2044C3.76339 14.7356 3.5 14.0997 3.5 13.4366C3.5 12.7736 3.76339 12.1377 4.23223 11.6689C4.70107 11.2 5.33696 10.9366 6 10.9366C6.66304 10.9366 7.29893 11.2 7.76777 11.6689C8.23661 12.1377 8.5 12.7736 8.5 13.4366C8.5 14.0997 8.23661 14.7356 7.76777 15.2044C7.29893 15.6733 6.66304 15.9366 6 15.9366ZM7.5 6.43665C7.5 5.7736 7.76339 5.13772 8.23223 4.66888C8.70107 4.20004 9.33696 3.93665 10 3.93665C10.663 3.93665 11.2989 4.20004 11.7678 4.66888C12.2366 5.13772 12.5 5.7736 12.5 6.43665C12.5 7.09969 12.2366 7.73557 11.7678 8.20441C11.2989 8.67325 10.663 8.93665 10 8.93665C9.33696 8.93665 8.70107 8.67325 8.23223 8.20441C7.76339 7.73557 7.5 7.09969 7.5 6.43665ZM14 15.9366C13.337 15.9366 12.7011 15.6733 12.2322 15.2044C11.7634 14.7356 11.5 14.0997 11.5 13.4366C11.5 12.7736 11.7634 12.1377 12.2322 11.6689C12.7011 11.2 13.337 10.9366 14 10.9366C14.663 10.9366 15.2989 11.2 15.7678 11.6689C16.2366 12.1377 16.5 12.7736 16.5 13.4366C16.5 14.0997 16.2366 14.7356 15.7678 15.2044C15.2989 15.6733 14.663 15.9366 14 15.9366Z')
					]),
				_List_Nil)
			]));
};
var $author$project$UI$Library$Sidebar$sidebar = function (topState) {
	var remote = topState.eV.jr;
	var isCollapsed = topState.eV.me.fM;
	var menuClasses = isCollapsed ? 'mt-8 flex flex-col gap-1' : 'mt-4 flex flex-col gap-3';
	var svgClasses = isCollapsed ? 'mx-auto' : '';
	var menuItemAction = F3(
		function (icon, itemText, onClickMsg) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('group hover:bg-dmnd-red-1 hover:text-dmnd-black items-center cursor-pointer '),
						$elm$html$Html$Events$onClick(onClickMsg)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-1')
							]),
						isCollapsed ? _List_fromArray(
							[
								icon(svgClasses + ' fill-white')
							]) : _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-row items-center')
									]),
								_List_fromArray(
									[
										icon(svgClasses + ' fill-white'),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('ml-2 text-16')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(itemText)
											]))
									]))
							]))
					]));
		});
	var width = isCollapsed ? '' : 'w-28';
	var elWidthClass = isCollapsed ? 'mx-auto' : 'w-22';
	var dataScopeSelector = function () {
		var canSelectAggregate = $author$project$Remote$Model$isUserAuthenticated(remote) && ($author$project$Remote$Model$canViewSubAccounts(remote) && $author$project$Remote$Model$hasSubAccounts(remote));
		var activeScope = topState.eV.me.dD;
		var scopeButton = F3(
			function (scope, expandedLabel, collapsedLabel) {
				var label = isCollapsed ? collapsedLabel : expandedLabel;
				var isActive = _Utils_eq(activeScope, scope);
				var stateClasses = isActive ? ' bg-dmnd-red-1 border-dmnd-red-1 text-dmnd-black' : ' bg-transparent border-gray-700 text-gray-300 hover:border-gray-400';
				var baseClasses = isCollapsed ? 'h-7 w-7 text-10 border cursor-pointer' : 'w-full px-2 py-1 text-10 border cursor-pointer text-left';
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							_Utils_ap(baseClasses, stateClasses)),
							$elm$html$Html$Events$onClick(
							$author$project$TopMsg$globalMsg(
								$author$project$Global$Msg$SelectAccountDataScope(scope)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]));
			});
		return canSelectAggregate ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					isCollapsed ? 'mt-3 flex flex-col gap-1 items-center' : 'mt-3 flex flex-col gap-1')
				]),
			_List_fromArray(
				[
					A3(scopeButton, 0, 'Main', 'M'),
					A3(scopeButton, 1, 'Aggregate', 'A')
				])) : $elm_community$html_extra$Html$Extra$nothing;
	}();
	var currentRoute = $author$project$Kernel$Aspect$Navigation$RouteHistory$current(topState.jE);
	var menuItem = F3(
		function (icon, itemText, route) {
			var isRouteActive = function () {
				var _v1 = _Utils_Tuple2(currentRoute, route);
				if ((_v1.a.$ === 7) && (_v1.b.$ === 7)) {
					var _v2 = _v1.a;
					var _v3 = _v1.b;
					return true;
				} else {
					return _Utils_eq(currentRoute, route);
				}
			}();
			var _v0 = isRouteActive ? _Utils_Tuple2('bg-dmnd-red-1 text-dmnd-black fill-dmnd-black', ' fill-dmnd-black') : _Utils_Tuple2('', ' fill-white');
			var selectedBackground = _v0.a;
			var svgFill = _v0.b;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('group hover:bg-dmnd-red-1 hover:text-dmnd-black items-center cursor-pointer ' + selectedBackground),
						$elm$html$Html$Events$onClick(
						$author$project$Kernel$RouteMsgs$routeMsg.gu(route))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-1')
							]),
						isCollapsed ? _List_fromArray(
							[
								icon(
								_Utils_ap(svgClasses, svgFill))
							]) : _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-row items-center')
									]),
								_List_fromArray(
									[
										icon(
										_Utils_ap(svgClasses, svgFill)),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('ml-2 text-16')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(itemText)
											]))
									]))
							]))
					]));
		});
	var sidebarMenu = function () {
		var watcherWorkersVisible = !A2($author$project$Remote$Model$watcherAccessIsDenied, 1, remote);
		var watcherGeneratedBtcVisible = !A2($author$project$Remote$Model$watcherAccessIsDenied, 2, remote);
		var isWatcher = $author$project$Remote$Model$isWatcherAuthenticated(remote);
		var isMultiWatcherMode = $elm$core$List$length(remote.bX) > 1;
		var isFppsUser = $author$project$Remote$Model$isFppsUser(remote);
		var isBroker = $author$project$Remote$Model$isBrokerAuthenticated(remote);
		var isAggregateData = (topState.eV.me.dD === 1) && ($author$project$Remote$Model$canViewSubAccounts(remote) && $author$project$Remote$Model$hasSubAccounts(remote));
		var pplnsProjectionVisible = $author$project$Remote$Model$hasPayablePplnsWork(remote) && (!isAggregateData);
		var generatedBtcRoute = ($elm$core$List$length(remote.bX) > 1) ? A2($author$project$Route$Route$MultiWatcher, remote.eb, remote.bX) : $author$project$Route$Route$GeneratedBitcoin;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(menuClasses)
				]),
			isWatcher ? (isMultiWatcherMode ? _Utils_ap(
				$author$project$Remote$Model$multiWatcherAllowsHashrate(remote) ? _List_fromArray(
					[
						A3(menuItem, $author$project$UI$Svg$connectIcon, '_hashrate', $author$project$Route$Route$Workers)
					]) : _List_Nil,
				$author$project$Remote$Model$multiWatcherAllowsGeneratedBTC(remote) ? _List_fromArray(
					[
						A3(menuItem, $author$project$UI$Svg$monitoringIcon, '_generated_btc', generatedBtcRoute)
					]) : _List_Nil) : _Utils_ap(
				_List_fromArray(
					[
						A3(menuItem, $author$project$UI$Svg$homeIcon, '_home', $author$project$Route$Route$Home)
					]),
				_Utils_ap(
					watcherWorkersVisible ? _List_fromArray(
						[
							A3(menuItem, $author$project$UI$Svg$connectIcon, '_workers', $author$project$Route$Route$Workers)
						]) : _List_Nil,
					_Utils_ap(
						watcherGeneratedBtcVisible ? _List_fromArray(
							[
								A3(menuItem, $author$project$UI$Svg$monitoringIcon, '_generated_btc', generatedBtcRoute)
							]) : _List_Nil,
						_Utils_ap(
							$author$project$Remote$Model$watcherMayViewPayouts(remote) ? _List_fromArray(
								[
									A3(menuItem, $author$project$UI$Svg$rewardsIcon, '_payout', $author$project$Route$Route$Payouts)
								]) : _List_Nil,
							pplnsProjectionVisible ? _List_fromArray(
								[
									A3(menuItem, $author$project$UI$Svg$rewardsIcon, '_pplns', $author$project$Route$Route$PplnsProjection)
								]) : _List_Nil))))) : (isBroker ? _List_fromArray(
				[
					A3(menuItem, $author$project$UI$Svg$homeIcon, '_home', $author$project$Route$Route$Broker)
				]) : _Utils_ap(
				_List_fromArray(
					[
						A3(menuItem, $author$project$UI$Svg$homeIcon, '_home', $author$project$Route$Route$Home),
						A3(menuItem, $author$project$UI$Svg$connectIcon, '_workers', $author$project$Route$Route$Workers)
					]),
				_Utils_ap(
					($author$project$Remote$Model$canViewSubAccounts(remote) && (!isAggregateData)) ? _List_fromArray(
						[
							A3(menuItem, $author$project$UI$Svg$workersIcon, '_subaccounts', $author$project$Route$Route$Subaccounts)
						]) : _List_Nil,
					_Utils_ap(
						_List_fromArray(
							[
								A3(menuItem, $author$project$UI$Svg$rewardsIcon, '_payout', $author$project$Route$Route$Payouts)
							]),
						_Utils_ap(
							pplnsProjectionVisible ? _List_fromArray(
								[
									A3(menuItem, $author$project$UI$Svg$rewardsIcon, '_pplns', $author$project$Route$Route$PplnsProjection)
								]) : _List_Nil,
							_Utils_ap(
								(isFppsUser || isAggregateData) ? _List_fromArray(
									[
										A3(menuItem, $author$project$UI$Svg$monitoringIcon, '_generated_btc', generatedBtcRoute)
									]) : _List_Nil,
								isAggregateData ? _List_Nil : _List_fromArray(
									[
										A3(menuItem, $author$project$UI$Svg$userIcon, '_api_keys', $author$project$Route$Route$ApiKeys)
									]))))))));
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('h-screen pl-3 pt-3')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-full pl-2.5 pr-2.5 pt-3 pb-3 flex flex-col justify-between flex-wrap ' + width)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(elWidthClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('cursor-pointer p-1 mb-3'),
										$elm$html$Html$Events$onClick(
										$author$project$TopMsg$globalMsg($author$project$Global$Msg$ToggleSidebar))
									]),
								_List_fromArray(
									[
										isCollapsed ? $author$project$UI$Svg$fistLogo : $author$project$UI$Svg$largeWhiteLogo('w-16')
									])),
								dataScopeSelector,
								sidebarMenu
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(elWidthClass)
							]),
						_List_fromArray(
							[
								$author$project$Remote$Model$isBrokerAuthenticated(remote) ? A3(
								menuItemAction,
								$author$project$UI$Svg$logoutIcon,
								'_logout',
								$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$BrokerLogout)) : A3(
								menuItemAction,
								$author$project$UI$Svg$userIcon,
								'_account',
								$author$project$Kernel$RouteMsgs$routeMsg.gu($author$project$Route$Route$Account))
							]))
					]))
			]));
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $author$project$Kernel$UI$Eventfull$Eventfull$eventFullKeyed = F2(
	function (eventHandlers, attrs) {
		var toAttrs = function (_v0) {
			var eventEmitterAttributes = _v0;
			return eventEmitterAttributes;
		};
		var normalizedHandlers = $elm$core$List$concat(
			A2($elm$core$List$map, toAttrs, eventHandlers));
		return A2(
			$elm$html$Html$Keyed$node,
			'event-full',
			_Utils_ap(normalizedHandlers, attrs));
	});
var $author$project$Kernel$Types$OrderedCollection$head = function (_v0) {
	var list = _v0.m;
	return $elm$core$List$head(list);
};
var $author$project$Kernel$Types$OrderedCollection$isEmpty = function (col) {
	return $elm_community$maybe_extra$Maybe$Extra$isNothing(
		$author$project$Kernel$Types$OrderedCollection$head(col));
};
var $author$project$Kernel$UI$EndlessList$View$isRequestOngoing = F2(
	function (_v0, requestMsg) {
		var ongoingRequests = _v0.C;
		return A2(
			$elm$core$List$member,
			requestMsg,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.aM;
				},
				ongoingRequests));
	});
var $author$project$Kernel$UI$Eventfull$Eventfull$onNearBottom = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'nearBottom',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Kernel$UI$Eventfull$Eventfull$onScrollNearBottom = function (nearBottomMsg) {
	return _List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'emit-scroll', 'true'),
			$author$project$Kernel$UI$Eventfull$Eventfull$onNearBottom(nearBottomMsg)
		]);
};
var $author$project$Kernel$Types$OrderedCollection$toListSerialized = function (_v0) {
	var list = _v0.m;
	var toId = _v0.gZ;
	var serializeId = _v0.gy;
	return A2(
		$elm$core$List$map,
		function (i) {
			return _Utils_Tuple2(
				serializeId(
					toId(i)),
				i);
		},
		list);
};
var $author$project$Kernel$UI$EndlessList$EndlessList$toListSerialized = function (endlessList) {
	return $author$project$Kernel$Types$OrderedCollection$toListSerialized(endlessList.hC);
};
var $author$project$Kernel$UI$EndlessList$View$viewCustom = function (cfg) {
	var itemsList = $author$project$Kernel$UI$EndlessList$EndlessList$toListSerialized(cfg.aX);
	var isReceivingItems = A2($author$project$Kernel$UI$EndlessList$View$isRequestOngoing, cfg.jr, cfg.R);
	var isEmpty = _Utils_eq(cfg.aX.D, $author$project$Kernel$UI$EndlessList$EndlessList$ReceivedAllItems) && ($author$project$Kernel$Types$OrderedCollection$isEmpty(cfg.aX.hC) && (!isReceivingItems));
	return A3(
		$author$project$Kernel$UI$Eventfull$Eventfull$eventFullKeyed,
		_List_fromArray(
			[
				$author$project$Kernel$UI$Eventfull$Eventfull$onScrollNearBottom(
				cfg.b6(cfg.R))
			]),
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('scrollTarget'),
			cfg.ch),
		cfg.dt(
			{iF: isEmpty, mN: itemsList}));
};
var $author$project$Kernel$UI$EndlessList$View$view = function (cfg) {
	var toContent = function (_v0) {
		var items = _v0.mN;
		var isEmpty = _v0.iF;
		return isEmpty ? cfg.fh : cfg.dt(items);
	};
	return $author$project$Kernel$UI$EndlessList$View$viewCustom(
		{ch: cfg.ch, jr: cfg.jr, R: cfg.R, aX: cfg.aX, dt: toContent, b6: cfg.b6});
};
var $author$project$UI$Library$TablePagination$SetPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Library$TablePagination$SetPageSize = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$UI$Library$TablePagination$view = F2(
	function (toMsg, page) {
		var pageSizeSelect = A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('h-5 rounded-md border border-dmnd-gray bg-dmnd-black px-2 pr-2 text-12 leading-none text-dmnd-lighter-gray'),
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(page.i9)),
					$elm$html$Html$Events$onInput(
					function (rawValue) {
						return toMsg(
							$author$project$UI$Library$TablePagination$SetPageSize(
								A2(
									$elm$core$Maybe$withDefault,
									page.i9,
									$elm$core$String$toInt(rawValue))));
					})
				]),
			A2(
				$elm$core$List$map,
				function (size) {
					return A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(size)),
								$elm$html$Html$Attributes$selected(
								_Utils_eq(size, page.i9))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(size) + ' rows')
							]));
				},
				_List_fromArray(
					[10, 15, 20])));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-3 flex w-full flex-wrap items-center justify-end gap-2 text-dmnd-lighter-gray')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline-flex h-7 items-center text-12')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Page ' + ($elm$core$String$fromInt(page.bQ) + (' of ' + $elm$core$String$fromInt(page.eD))))
						])),
					pageSizeSelect,
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline-flex h-7 min-w-7 items-center justify-center rounded-md bg-dmnd-black px-2 text-12 disabled:opacity-50'),
							$elm$html$Html$Attributes$disabled(page.bQ === 1),
							$elm$html$Html$Events$onClick(
							toMsg(
								$author$project$UI$Library$TablePagination$SetPage(page.bQ - 1)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('<')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline-flex h-7 min-w-7 items-center justify-center rounded-md bg-dmnd-black px-2 text-12 disabled:opacity-50'),
							$elm$html$Html$Attributes$disabled(
							_Utils_eq(page.bQ, page.eD)),
							$elm$html$Html$Events$onClick(
							toMsg(
								$author$project$UI$Library$TablePagination$SetPage(page.bQ + 1)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('>')
						]))
				]));
	});
var $author$project$Kernel$UI$CustomTooltip$CustomTooltip$Bottom = 2;
var $author$project$UI$Workers$Msg$NoOp = {$: 0};
var $author$project$UI$Workers$Msg$SetPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$Workers$Msg$SetPageSize = function (a) {
	return {$: 4, a: a};
};
var $author$project$UI$Workers$Msg$SetSort = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Workers$Model$SortHashrate = 1;
var $author$project$UI$Workers$Model$SortTotalShares = 2;
var $author$project$UI$Library$AccountData$selectedWorkers = function (topState) {
	return A2($author$project$UI$Library$AccountData$workersForScope, topState.eV.me.dD, topState.eV.jr);
};
var $author$project$TopMsg$workersMsg = A2($elm$core$Basics$composeL, $author$project$Kernel$Msg$AppMsg, $author$project$Msg$WorkersMsg);
var $author$project$UI$Library$MainPageWrapper$workersTableData = function (topState) {
	var workersState = topState.eV.kv;
	var workerStatusRow = function (message) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-3 pr-3 text-dmnd-lighter-gray'),
							$elm$html$Html$Attributes$colspan(6)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]))
				]));
	};
	var sortIndicatorEl = function (col) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-gray-500 ml-1 text-10')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					function () {
						if (_Utils_eq(workersState.jX, col)) {
							var _v12 = workersState.jY;
							if (!_v12) {
								return '▲';
							} else {
								return '▼';
							}
						} else {
							return '↕';
						}
					}())
				]));
	};
	var searchTerms = A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$toLower),
			A2($elm$core$String$split, ',', workersState.gx)));
	var rejectionRateFloat = function (worker) {
		var total = A2(
			$elm$core$Maybe$withDefault,
			0,
			$author$project$Types$Worker$totalShares(worker));
		var rejected = A2(
			$elm$core$Maybe$withDefault,
			0,
			$author$project$Types$Worker$rejectedShares(worker));
		return (!total) ? 0.0 : (rejected / total);
	};
	var pageSizeSelect = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center gap-2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-gray-400 text-12')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Rows per page:')
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-dmnd-black text-gray-300 text-12 border border-gray-600 rounded px-2 py-0.5 cursor-pointer'),
						$elm$html$Html$Events$onInput(
						function (val) {
							var _v11 = $elm$core$String$toInt(val);
							if (!_v11.$) {
								var size = _v11.a;
								return $author$project$TopMsg$workersMsg(
									$author$project$UI$Workers$Msg$SetPageSize(size));
							} else {
								return $author$project$TopMsg$workersMsg($author$project$UI$Workers$Msg$NoOp);
							}
						})
					]),
				A2(
					$elm$core$List$map,
					function (n) {
						return A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(
									$elm$core$String$fromInt(n)),
									$elm$html$Html$Attributes$selected(
									_Utils_eq(workersState.i9, n))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(n))
								]));
					},
					_List_fromArray(
						[10, 15, 20])))
			]));
	var pageSize = workersState.i9;
	var noResultsMessage = function () {
		if (!$elm$core$String$isEmpty(workersState.gx)) {
			return 'No workers match \"' + (workersState.gx + '\"');
		} else {
			var _v10 = workersState.$8;
			switch (_v10) {
				case 1:
					return 'No online workers';
				case 2:
					return 'No offline workers';
				default:
					return 'No workers found';
			}
		}
	}();
	var loadingStatusText = function () {
		var _v9 = topState.eV.jr.eM;
		switch (_v9) {
			case 1:
				return $elm$core$Maybe$Just('Refreshing...');
			case 2:
				return $elm$core$Maybe$Just('Loading more...');
			default:
				return $elm$core$Maybe$Nothing;
		}
	}();
	var formatShares = function (worker) {
		var total = A2(
			$elm$core$Maybe$withDefault,
			0,
			$author$project$Types$Worker$totalShares(worker));
		var rejected = A2(
			$elm$core$Maybe$withDefault,
			0,
			$author$project$Types$Worker$rejectedShares(worker));
		var accepted = total - rejected;
		if (!total) {
			return '—';
		} else {
			var rate = (rejected / total) * 100;
			var rateStr = $elm$core$String$fromFloat(
				$elm$core$Basics$round(rate * 100) / 100) + '%';
			return $elm$core$String$fromInt(rejected) + ('/' + ($elm$core$String$fromInt(total) + ('(' + (rateStr + ')'))));
		}
	};
	var formatHashrate = function (hashrate) {
		return $author$project$Types$Hashrate$toString(
			$author$project$Types$Hashrate$rawHashrateToHashrate(hashrate));
	};
	var workerDataRow = F2(
		function (rowNum, worker) {
			var kind = $author$project$Types$Worker$workerKind(worker);
			var hashrateValue = $author$project$Types$Worker$displayHashrateOrZero(worker);
			var displayHashrate = (hashrateValue > 0) ? formatHashrate(hashrateValue) : '0';
			var _v8 = worker.iG ? _Utils_Tuple2(
				'text-green-500',
				$elm$html$Html$text('● Online')) : _Utils_Tuple2(
				'text-red-400',
				$elm$html$Html$text('● Offline'));
			var statusClass = _v8.a;
			var statusText = _v8.b;
			return A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('border-b border-gray-800 hover:bg-gray-900')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 text-gray-600')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(rowNum))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 text-white')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(worker.aJ)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 text-gray-300')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(kind)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 text-white')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(displayHashrate)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								formatShares(worker))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 ' + statusClass)
							]),
						_List_fromArray(
							[statusText]))
					]));
		});
	var workerMatchesSearchTerm = F2(
		function (term, w) {
			var statusText = w.iG ? 'online' : 'offline';
			var sharesCell = $elm$core$String$toLower(
				formatShares(w));
			var kindText = $elm$core$String$toLower(
				$author$project$Types$Worker$workerKind(w));
			var hashrateText = $elm$core$String$toLower(
				formatHashrate(
					$author$project$Types$Worker$displayHashrateOrZero(w)));
			return A2(
				$elm$core$String$contains,
				term,
				$elm$core$String$toLower(w.aJ)) || (A2($elm$core$String$contains, term, statusText) || (A2($elm$core$String$contains, term, hashrateText) || (A2($elm$core$String$contains, term, kindText) || A2($elm$core$String$contains, term, sharesCell))));
		});
	var columnHeaderWithTooltip = F3(
		function (headerText, col, tooltipText) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inline-flex items-center gap-1')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(headerText),
						sortIndicatorEl(col),
						A3(
						$author$project$Kernel$UI$CustomTooltip$CustomTooltip$tooltipable,
						{
							kM: 'hidden',
							hA: '',
							pi: 0,
							pB: $elm$html$Html$text(tooltipText),
							pC: 'bg-dmnd-black text-gray-300 text-12 p-2 rounded shadow-lg whitespace-nowrap z-50',
							pD: _Utils_Tuple2(2, 1)
						},
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-dmnd-lighter-gray cursor-help')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('ⓘ')
							]))
					]));
		});
	var tableHeaders = _List_fromArray(
		[
			A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-b border-gray-700')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 font-normal text-gray-500')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('#')
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 font-normal cursor-pointer hover:text-white'),
							$elm$html$Html$Events$onClick(
							$author$project$TopMsg$workersMsg(
								$author$project$UI$Workers$Msg$SetSort(0)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline-flex items-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Worker name'),
									sortIndicatorEl(0)
								]))
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Kind')
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 font-normal cursor-pointer hover:text-white'),
							$elm$html$Html$Events$onClick(
							$author$project$TopMsg$workersMsg(
								$author$project$UI$Workers$Msg$SetSort(1)))
						]),
					_List_fromArray(
						[
							A3(columnHeaderWithTooltip, 'Hashrate', 1, 'Average hashrate over the last 10 minutes from accepted shares only')
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 font-normal cursor-pointer hover:text-white'),
							$elm$html$Html$Events$onClick(
							$author$project$TopMsg$workersMsg(
								$author$project$UI$Workers$Msg$SetSort(2)))
						]),
					_List_fromArray(
						[
							A3(columnHeaderWithTooltip, 'Rejection Rate', 2, 'Rejected/Total shares over the last 10 minutes')
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Status')
						]))
				]))
		]);
	var allWorkers = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		$author$project$UI$Library$AccountData$selectedWorkers(topState));
	var searchedWorkers = $elm$core$List$isEmpty(searchTerms) ? allWorkers : A2(
		$elm$core$List$filter,
		function (w) {
			return A2(
				$elm$core$List$any,
				function (term) {
					return A2(workerMatchesSearchTerm, term, w);
				},
				searchTerms);
		},
		allWorkers);
	var filteredWorkers = function () {
		var _v7 = workersState.$8;
		switch (_v7) {
			case 0:
				return searchedWorkers;
			case 1:
				return A2(
					$elm$core$List$filter,
					function ($) {
						return $.iG;
					},
					searchedWorkers);
			default:
				return A2(
					$elm$core$List$filter,
					function (w) {
						return !w.iG;
					},
					searchedWorkers);
		}
	}();
	var sortedWorkers = function () {
		var sorted = function () {
			var _v6 = workersState.jX;
			switch (_v6) {
				case 0:
					return A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.aJ;
						},
						filteredWorkers);
				case 1:
					return A2($elm$core$List$sortBy, $author$project$Types$Worker$displayHashrateOrZero, filteredWorkers);
				case 2:
					return A2(
						$elm$core$List$sortBy,
						function (w) {
							return A2(
								$elm$core$Maybe$withDefault,
								0,
								$author$project$Types$Worker$totalShares(w));
						},
						filteredWorkers);
				default:
					return A2($elm$core$List$sortBy, rejectionRateFloat, filteredWorkers);
			}
		}();
		var _v5 = workersState.jY;
		if (!_v5) {
			return sorted;
		} else {
			return $elm$core$List$reverse(sorted);
		}
	}();
	var totalFiltered = $elm$core$List$length(filteredWorkers);
	var totalPages = A2($elm$core$Basics$max, 1, (((totalFiltered + pageSize) - 1) / pageSize) | 0);
	var currentPage = A2($elm$core$Basics$min, workersState.nN, totalPages - 1);
	var pagedWorkers = A2(
		$elm$core$List$take,
		pageSize,
		A2($elm$core$List$drop, currentPage * pageSize, sortedWorkers));
	var prevButton = (!currentPage) ? A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-3 py-1 text-12 text-gray-600 cursor-not-allowed')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('< Prev')
			])) : A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-3 py-1 text-12 text-gray-300 hover:text-gray-400 cursor-pointer'),
				$elm$html$Html$Events$onClick(
				$author$project$TopMsg$workersMsg(
					$author$project$UI$Workers$Msg$SetPage(currentPage - 1)))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('< Prev')
			]));
	var workerDataRows = A2(
		$elm$core$List$indexedMap,
		F2(
			function (i, w) {
				return A2(workerDataRow, ((currentPage * pageSize) + i) + 1, w);
			}),
		pagedWorkers);
	var nextButton = (_Utils_cmp(currentPage, totalPages - 1) > -1) ? A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-3 py-1 text-12 text-gray-600 cursor-not-allowed')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Next >')
			])) : A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-3 py-1 text-12 text-gray-300 hover:text-gray-400 cursor-pointer'),
				$elm$html$Html$Events$onClick(
				$author$project$TopMsg$workersMsg(
					$author$project$UI$Workers$Msg$SetPage(currentPage + 1)))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Next >')
			]));
	var pageInfoText = function () {
		if (!loadingStatusText.$) {
			var status = loadingStatusText.a;
			return status;
		} else {
			return 'Page ' + ($elm$core$String$fromInt(currentPage + 1) + (' of ' + $elm$core$String$fromInt(totalPages)));
		}
	}();
	var uiPaginationRow = A2(
		$elm$html$Html$tr,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sticky bottom-0 bg-dmnd-black border-t border-gray-700')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$colspan(6),
						$elm$html$Html$Attributes$class('pt-2 pb-2 px-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex items-center justify-between')
							]),
						_List_fromArray(
							[
								pageSizeSelect,
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center')
									]),
								_List_fromArray(
									[
										prevButton,
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('px-2 text-12 text-gray-400')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(pageInfoText)
											])),
										nextButton
									]))
							]))
					]))
			]));
	var workersRows = function () {
		if (!$elm$core$List$isEmpty(workerDataRows)) {
			return _Utils_ap(
				workerDataRows,
				_List_fromArray(
					[uiPaginationRow]));
		} else {
			var _v0 = _Utils_Tuple2(
				$author$project$UI$Library$AccountData$selectedWorkers(topState),
				topState.eV.jr.eM);
			if (_v0.a.$ === 1) {
				if (_v0.b === 1) {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return _List_fromArray(
						[
							workerStatusRow('Loading workers...')
						]);
				} else {
					var _v3 = _v0.a;
					return _List_fromArray(
						[
							workerStatusRow('Loading worker data, please do not refresh')
						]);
				}
			} else {
				return _List_fromArray(
					[
						workerStatusRow(noResultsMessage)
					]);
			}
		}
	}();
	return _Utils_Tuple2(tableHeaders, workersRows);
};
var $author$project$UI$Library$MainPageWrapper$mainPageWrapper = F2(
	function (topState, content) {
		var currentRoute = $author$project$Kernel$Aspect$Navigation$RouteHistory$current(topState.jE);
		var maybeEndlessList = function () {
			switch (currentRoute.$) {
				case 5:
					return $elm$core$Maybe$Just(
						$author$project$UI$Library$MainPageWrapper$payoutsTableData(topState));
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					var authRoute = currentRoute.a;
					return $elm$core$Maybe$Nothing;
				case 3:
					return $elm$core$Maybe$Nothing;
				case 2:
					return $elm$core$Maybe$Nothing;
				case 4:
					return $elm$core$Maybe$Just(
						$author$project$UI$Library$MainPageWrapper$workersTableData(topState));
				case 7:
					return $elm$core$Maybe$Just(
						$author$project$UI$Library$MainPageWrapper$workersTableData(topState));
				case 6:
					return $elm$core$Maybe$Nothing;
				case 10:
					return $elm$core$Maybe$Nothing;
				case 8:
					return $elm$core$Maybe$Nothing;
				case 9:
					return $elm$core$Maybe$Nothing;
				case 11:
					return $elm$core$Maybe$Just(
						$author$project$UI$Library$MainPageWrapper$generatedBitcoinTableData(topState));
				case 12:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		var maybePaginationControls = function () {
			switch (currentRoute.$) {
				case 5:
					return $elm$core$List$isEmpty(
						$author$project$UI$Library$MainPageWrapper$filteredPayouts(topState)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						A2(
							$author$project$UI$Library$TablePagination$view,
							$author$project$TopMsg$payoutsMsg,
							A2(
								$author$project$UI$Library$TablePagination$paginate,
								topState.eV.jc,
								$author$project$UI$Library$MainPageWrapper$filteredPayouts(topState))));
				case 11:
					var _v6 = $author$project$UI$Library$MainPageWrapper$filteredGeneratedBitcoin(topState);
					if (!_v6.$) {
						var generatedEntries = _v6.a;
						return $elm$core$List$isEmpty(generatedEntries) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2(
								$author$project$UI$Library$TablePagination$view,
								$author$project$TopMsg$generatedBitcoinMsg,
								A2($author$project$UI$Library$TablePagination$paginate, topState.eV.$9, generatedEntries)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		var endlessListTable = function () {
			if (!maybeEndlessList.$) {
				var _v2 = maybeEndlessList.a;
				var columns = _v2.a;
				var dataRows = _v2.b;
				var tableTopMarginClass = function () {
					switch (currentRoute.$) {
						case 5:
							return 'mt-1';
						case 11:
							return 'mt-1';
						default:
							return 'mt-2';
					}
				}();
				return _Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('max-h-[600px] overflow-x-auto overflow-y-auto ' + tableTopMarginClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$table,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full text-12 text-left text-dmnd-lighter-gray')
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$thead,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('sticky top-0 z-10 bg-dmnd-almost-black text-11 uppercase text-dmnd-lighter-gray')
												]),
											columns),
										dataRows))
								]))
						]),
					function () {
						if (!maybePaginationControls.$) {
							var controls = maybePaginationControls.a;
							return _List_fromArray(
								[controls]);
						} else {
							return _List_Nil;
						}
					}());
			} else {
				return _List_Nil;
			}
		}();
		var endlessListWrapper = function (finiteContent) {
			return $author$project$Kernel$UI$EndlessList$View$view(
				{
					ch: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-dmnd-almost-black flex flex-row flex-grow')
						]),
					fh: _List_Nil,
					jr: topState.eV.jr,
					R: $author$project$Remote$RequestMsg$NoOp,
					aX: A2(
						$author$project$Kernel$UI$EndlessList$EndlessList$empty,
						function ($) {
							return $.mu;
						},
						$elm$core$Basics$identity),
					dt: function (_v0) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'sidebar',
								$author$project$UI$Library$Sidebar$sidebar(topState)),
								_Utils_Tuple2(
								'top-and-finite-section',
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('p-3 w-full')
										]),
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$UI$Library$MainPageWrapper$newPlatformNotice(topState),
												finiteContent
											]),
										endlessListTable)))
							]);
					},
					b6: $author$project$TopMsg$requestMsg
				});
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col min-h-screen')
				]),
			_List_fromArray(
				[
					endlessListWrapper(content)
				]));
	});
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$UI$Account$View$view = function (topState) {
	var twoFactorActivateButton = $author$project$UI$Library$Button$button(
		$author$project$UI$Library$Button$GreenInline(
			{
				A: $elm$html$Html$text('activate'),
				cG: $author$project$TopMsg$globalMsg(
					$author$project$Global$Msg$ShowModal(
						A2($author$project$Global$Model$TwoFactorActivation, false, '')))
			}));
	var remote = topState.eV.jr;
	var rateLimitRemaining = A2($author$project$UI$Account$View$checkRateLimit, remote, topState.ph);
	var legend = F2(
		function (legendTitle, colorClass) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-18 flex flex-row items-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-2.5 h-2.5 inline-block mr-2.5 ' + colorClass)
							]),
						_List_Nil),
						$elm$html$Html$text(legendTitle)
					]));
		});
	var isTwoFactorActivated = function () {
		var _v2 = topState.eV.jr.pQ;
		if (_v2.$ === 2) {
			var userSession = _v2.a;
			return _Utils_eq(userSession.g0, $elm$core$Maybe$Nothing);
		} else {
			return false;
		}
	}();
	var isRateLimited = !_Utils_eq(rateLimitRemaining, $elm$core$Maybe$Nothing);
	var emailAddress = function () {
		var _v1 = topState.eV.jr.pQ;
		switch (_v1.$) {
			case 0:
				return '';
			case 1:
				return '';
			default:
				var userSession = _v1.a;
				return userSession.ff;
		}
	}();
	var downloadButton = isRateLimited ? $author$project$UI$Library$Button$Disabled(
		{
			A: $elm$html$Html$text('Download Report')
		}) : $author$project$UI$Library$Button$Green(
		{
			A: $elm$html$Html$text('Download Report'),
			cG: $author$project$TopMsg$requestMsg(
				$author$project$Remote$RequestMsg$Report(
					{
						lB: $elm$core$Maybe$Just(
							$elm$core$String$fromInt(remote.jv))
					}))
		});
	var bitcoinAddressButton = $author$project$UI$Library$Button$button(
		$author$project$UI$Library$Button$Green(
			{
				A: $elm$html$Html$text('Update'),
				cG: $author$project$TopMsg$globalMsg(
					$author$project$Global$Msg$ShowModal(
						A3($author$project$Global$Model$UpdateBitcoinAddressModal, '', '', $elm$core$Maybe$Nothing)))
			}));
	var bitcoinAddress = function () {
		var _v0 = topState.eV.jr.pQ;
		if (_v0.$ === 2) {
			var userSession = _v0.a;
			return A2($elm$core$Maybe$withDefault, '', userSession.hl);
		} else {
			return '';
		}
	}();
	var hasBitcoinAddress = !$elm$core$String$isEmpty(bitcoinAddress);
	var truncatedBitcoinAddress = A2($elm$core$String$left, 4, bitcoinAddress) + ('...' + A2($elm$core$String$right, 4, bitcoinAddress));
	var bitcoinAddressDisplay = hasBitcoinAddress ? A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mr-3'),
				$elm$html$Html$Attributes$title(bitcoinAddress)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(truncatedBitcoinAddress)
			])) : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mr-3')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('')
			]));
	var bitcoinAddressRow = isTwoFactorActivated ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-25 text-dmnd-lighter-gray')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Bitcoin address:')
					])),
				bitcoinAddressDisplay,
				bitcoinAddressButton
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-25 text-dmnd-lighter-gray')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Bitcoin address:')
					])),
				twoFactorActivateButton,
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ml-1')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('2FA to set')
					]))
			]));
	return A2(
		$author$project$UI$Library$MainPageWrapper$mainPageWrapper,
		topState,
		A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$Library$PageHeader$action(
					{
						k1: A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('px-3 py-1.5 bg-red-900 text-white text-12 rounded-md hover:bg-red-700 cursor-pointer'),
									$elm$html$Html$Events$onClick(
									$author$project$Remote$Model$isBrokerAuthenticated(remote) ? $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$BrokerLogout) : $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$Logout))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Logout')
								])),
						o8: $elm$core$Maybe$Just('Email, payout address, and account-level settings.'),
						bs: 'Account'
					}),
					$author$project$Remote$Model$canEditBtcAddress(remote) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('space-y-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex items-center')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('w-25 text-dmnd-lighter-gray')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Email address:')
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(emailAddress)
												]))
										])),
									bitcoinAddressRow
								]))
						])) : $elm$html$Html$text('')
				])));
};
var $author$project$Remote$RequestMsg$CloseAggregateApiKeysModal = {$: 69};
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$UI$ApiKeys$View$section_ = F3(
	function (title, helper, body) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-white text-14 font-semibold uppercase tracking-wide')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-400 text-12')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(helper)
								]))
						])),
					A2($elm$html$Html$div, _List_Nil, body)
				]));
	});
var $elm$html$Html$code = _VirtualDom_node('code');
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$UI$ApiKeys$View$watcherLinkCell = F2(
	function (fullValue, truncated) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline-flex items-center gap-1.5 hover:text-green-400 group'),
					$elm$html$Html$Attributes$href(fullValue),
					$elm$html$Html$Attributes$target('_blank'),
					$elm$html$Html$Attributes$rel('noopener noreferrer'),
					$elm$html$Html$Attributes$title('Open watcher dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$code,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-mono text-11 text-green-300 break-all')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(truncated)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-10 text-gray-500 group-hover:text-gray-300')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('↗')
						]))
				]));
	});
var $author$project$UI$ApiKeys$View$aggregateGeneratedLinkSection = function (maybeLink) {
	if (maybeLink.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var link = maybeLink.a;
		return A3(
			$author$project$UI$ApiKeys$View$section_,
			'Multiwatcher link',
			'Open or copy this link. You can compose it again from the same existing keys.',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-2')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$ApiKeys$View$watcherLinkCell, link, 'Open multiwatcher dashboard'),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-row justify-end')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('px-3 py-1.5 bg-green-500 text-dmnd-black text-12 font-semibold rounded-md hover:bg-green-600 cursor-pointer'),
											$elm$html$Html$Events$onClick(
											$author$project$TopMsg$globalMsg(
												$author$project$Global$Msg$CopyToClipboard(link)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Copy link')
										]))
								]))
						]))
				]));
	}
};
var $author$project$UI$ApiKeys$View$aggregateInfoSection = function (requirement) {
	var dataDescription = function () {
		switch (requirement) {
			case 0:
				return 'The multiwatcher link will show hashrate for the selected accounts.';
			case 1:
				return 'The multiwatcher link will show generated_btc for the selected accounts.';
			default:
				return 'The multiwatcher link will show hashrate and generated_btc for the selected accounts.';
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('p-3 bg-gray-900 border border-gray-700 rounded-md text-12 text-gray-300 flex flex-col gap-2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(dataDescription)
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Only active keys with available secrets and exactly these permissions are included. Multiple keys for one account produce a single account entry.')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('The link reuses the selected keys and remains valid until they expire or are revoked. You can recreate it from the same keys. Payout addresses are not included.')
					]))
			]));
};
var $author$project$Remote$RequestMsg$CreateMultiWatcherLink = {$: 72};
var $author$project$UI$ApiKeys$View$aggregateModalFooter = function (canCreate) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-6 py-4 border-t border-gray-700 flex justify-end gap-2 bg-gray-800 rounded-b-lg')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('px-4 py-2 bg-gray-700 text-white text-12 rounded-md hover:bg-gray-600 cursor-pointer'),
						$elm$html$Html$Events$onClick(
						$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$CloseAggregateApiKeysModal))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('px-4 py-2 bg-green-500 text-dmnd-black text-12 font-semibold rounded-md hover:bg-green-600 cursor-pointer disabled:bg-gray-600 disabled:text-gray-400 disabled:cursor-not-allowed'),
						$elm$html$Html$Attributes$disabled(!canCreate),
						$elm$html$Html$Events$onClick(
						$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$CreateMultiWatcherLink))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Create multiwatcher link')
					]))
			]));
};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$UI$ApiKeys$View$aggregateModalHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('px-6 py-4 border-b border-gray-700 flex justify-between items-center')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-white text-14 font-semibold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Aggregate API keys')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray-400 text-12 mt-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Combine existing API keys into a multiwatcher link. No new keys are created.')
						]))
				])),
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-gray-400 hover:text-white text-14 leading-none'),
					$elm$html$Html$Events$onClick(
					$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$CloseAggregateApiKeysModal))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('✕')
				]))
		]));
var $author$project$Types$ApiToken$aggregateApiKeyRequirements = _List_fromArray(
	[0, 1, 2]);
var $author$project$Remote$RequestMsg$SetAggregateApiKeyRequirement = function (a) {
	return {$: 70, a: a};
};
var $author$project$Types$ApiToken$aggregateApiKeyRequirementLabel = function (requirement) {
	switch (requirement) {
		case 0:
			return 'Enforce: hashrate only';
		case 1:
			return 'Enforce: generated_btc only';
		default:
			return 'Enforce: generated_btc and hashrate';
	}
};
var $author$project$UI$ApiKeys$View$aggregateRequirementButton = F2(
	function (selectedRequirement, requirement) {
		var selected = _Utils_eq(selectedRequirement, requirement);
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('px-3 py-1.5 text-12 font-semibold rounded-md border transition-colors cursor-pointer', true),
							_Utils_Tuple2('bg-green-400 border-green-400 text-dmnd-black', selected),
							_Utils_Tuple2('bg-gray-900 border-gray-700 text-gray-300 hover:border-gray-500 hover:text-white', !selected)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$TopMsg$requestMsg(
						$author$project$Remote$RequestMsg$SetAggregateApiKeyRequirement(requirement)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Types$ApiToken$aggregateApiKeyRequirementLabel(requirement))
				]));
	});
var $author$project$UI$ApiKeys$View$aggregateRequirementSelector = function (selectedRequirement) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-row flex-wrap gap-2')
			]),
		A2(
			$elm$core$List$map,
			$author$project$UI$ApiKeys$View$aggregateRequirementButton(selectedRequirement),
			$author$project$Types$ApiToken$aggregateApiKeyRequirements));
};
var $author$project$UI$ApiKeys$View$aggregateSelectionSummary = F2(
	function (selectedTokens, includedTokens) {
		return $elm$core$List$isEmpty(selectedTokens) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-gray-500 text-12')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('No API keys selected.')
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-gray-400 text-12')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Selected ' + ($elm$core$String$fromInt(
						$elm$core$List$length(selectedTokens)) + (' key(s); the link will include ' + ($elm$core$String$fromInt(
						$elm$core$List$length(includedTokens)) + ' account(s).'))))
				]));
	});
var $author$project$Remote$RequestMsg$ToggleAggregateApiKeySelection = function (a) {
	return {$: 71, a: a};
};
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$UI$ApiKeys$View$ownerLabelFromToken = function (token) {
	var _v0 = token.nM;
	if (!_v0.$) {
		var name = _v0.a;
		return $elm$core$String$isEmpty(name) ? token.nL : name;
	} else {
		return token.nL;
	}
};
var $author$project$Types$ApiToken$scopeLabel = function (scope) {
	switch (scope) {
		case 0:
			return 'Hashrate';
		case 1:
			return 'Workers';
		case 2:
			return 'Earnings';
		case 3:
			return 'Rejects';
		default:
			return 'Fees';
	}
};
var $author$project$UI$ApiKeys$View$renderScopeChip = function (scope) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-2 py-0.5 bg-blue-900 text-blue-200 text-12 rounded-full')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Types$ApiToken$scopeLabel(scope))
			]));
};
var $author$project$UI$ApiKeys$View$aggregateTokenOption = F2(
	function (selectedIds, token) {
		var truncatedToken = token.pz;
		var selected = A2($elm$core$Set$member, token.mu, selectedIds);
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('p-3 rounded-md border cursor-pointer transition-colors flex flex-col gap-2', true),
							_Utils_Tuple2('border-green-400 bg-green-400 bg-opacity-10', selected),
							_Utils_Tuple2('border-gray-700 bg-gray-900 hover:border-gray-500', !selected)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row items-start justify-between gap-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('min-w-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-white text-12 font-semibold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$UI$ApiKeys$View$ownerLabelFromToken(token))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-500 text-12')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Account ID #' + token.g4)
										])),
									A2(
									$elm$html$Html$code,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('block mt-1 font-mono text-11 text-green-300 break-all')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(truncatedToken)
										]))
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$checked(selected),
									$elm$html$Html$Attributes$class('mt-1 h-4 w-4 accent-green-400 cursor-pointer'),
									$elm$html$Html$Events$onCheck(
									function (_v0) {
										return $author$project$TopMsg$requestMsg(
											$author$project$Remote$RequestMsg$ToggleAggregateApiKeySelection(token.mu));
									})
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row gap-1 flex-wrap')
						]),
					A2($elm$core$List$map, $author$project$UI$ApiKeys$View$renderScopeChip, token.oK))
				]));
	});
var $author$project$UI$ApiKeys$View$aggregateTokenSection = F4(
	function (remote, eligibleTokens, selectedTokens, includedTokens) {
		return A3(
			$author$project$UI$ApiKeys$View$section_,
			'API keys',
			'Select the keys to include in the multiwatcher link.',
			_List_fromArray(
				[
					function () {
					var _v0 = remote.eU;
					if (_v0.$ === 1) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-400 text-12')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Loading API keys...')
								]));
					} else {
						return $elm$core$List$isEmpty(eligibleTokens) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-400 text-12')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('No eligible API keys found for the selected enforcement mode.')
								])) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col gap-2')
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									$author$project$UI$ApiKeys$View$aggregateTokenOption(
										$elm$core$Set$fromList(remote.eO)),
									eligibleTokens),
								_List_fromArray(
									[
										A2($author$project$UI$ApiKeys$View$aggregateSelectionSummary, selectedTokens, includedTokens)
									])));
					}
				}()
				]));
	});
var $author$project$UI$ApiKeys$View$aggregateModal = F2(
	function (time, remote) {
		if (!remote.gB) {
			return $elm$html$Html$text('');
		} else {
			var selectedIds = $elm$core$Set$fromList(remote.eO);
			var eligibleTokens = A3(
				$author$project$Types$ApiToken$aggregateEligibleTokens,
				time,
				remote.hd,
				A2($elm$core$Maybe$withDefault, _List_Nil, remote.eU));
			var selectedTokens = A2(
				$elm$core$List$filter,
				function (key) {
					return A2($elm$core$Set$member, key.mu, selectedIds);
				},
				eligibleTokens);
			var includedTokens = $author$project$Types$ApiToken$bestPerUser(selectedTokens);
			var canCreate = !$elm$core$List$isEmpty(selectedTokens);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fixed inset-0 bg-black bg-opacity-60 z-50 overflow-y-auto'),
						$elm$html$Html$Events$onClick(
						$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$CloseAggregateApiKeysModal))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('min-h-full flex items-start justify-center py-10 px-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bg-gray-800 rounded-lg shadow-2xl max-w-[90vw] w-full flex flex-col max-h-[85vh]'),
										A2(
										$elm$html$Html$Events$stopPropagationOn,
										'click',
										$elm$json$Json$Decode$succeed(
											_Utils_Tuple2(
												$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$NoOp),
												true)))
									]),
								_List_fromArray(
									[
										$author$project$UI$ApiKeys$View$aggregateModalHeader,
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('px-6 py-4 overflow-y-auto flex flex-col gap-4 flex-1')
											]),
										_List_fromArray(
											[
												$author$project$UI$ApiKeys$View$aggregateRequirementSelector(remote.hd),
												$author$project$UI$ApiKeys$View$aggregateInfoSection(remote.hd),
												A4($author$project$UI$ApiKeys$View$aggregateTokenSection, remote, eligibleTokens, selectedTokens, includedTokens),
												$author$project$UI$ApiKeys$View$aggregateGeneratedLinkSection(remote.eP)
											])),
										$author$project$UI$ApiKeys$View$aggregateModalFooter(canCreate)
									]))
							]))
					]));
		}
	});
var $author$project$Remote$RequestMsg$CloseCreateApiTokenModal = {$: 67};
var $author$project$Remote$RequestMsg$SubmitCreateApiToken = {$: 76};
var $author$project$UI$ApiKeys$View$modalFooter = function (canSubmit) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-6 py-4 border-t border-gray-700 flex justify-end gap-2 bg-gray-800 rounded-b-lg')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('px-4 py-2 bg-gray-700 text-white text-12 rounded-md hover:bg-gray-600 cursor-pointer'),
						$elm$html$Html$Events$onClick(
						$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$CloseCreateApiTokenModal))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('px-4 py-2 bg-green-500 text-dmnd-black text-12 font-semibold rounded-md hover:bg-green-600 cursor-pointer disabled:bg-gray-600 disabled:text-gray-400 disabled:cursor-not-allowed'),
						$elm$html$Html$Attributes$disabled(!canSubmit),
						$elm$html$Html$Events$onClick(
						$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$SubmitCreateApiToken))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Create key')
					]))
			]));
};
var $author$project$UI$ApiKeys$View$modalHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('px-6 py-4 border-b border-gray-700 flex justify-between items-center')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-white text-14 font-semibold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Create API key')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray-400 text-12 mt-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Issue a read-only token with no expiry. Its token and watcher link remain available in the key list until revoked.')
						]))
				])),
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-gray-400 hover:text-white text-14 leading-none'),
					$elm$html$Html$Events$onClick(
					$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$CloseCreateApiTokenModal))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('✕')
				]))
		]));
var $author$project$UI$ApiKeys$View$masterLabel = function (email) {
	return 'Master (' + (email + ')');
};
var $author$project$UI$ApiKeys$View$subAccountEntry = function (sub) {
	return _Utils_Tuple2(sub.mu, sub.o4);
};
var $author$project$UI$ApiKeys$View$ownerOptions = function (remote) {
	var subEntries = function () {
		var _v1 = remote.ex;
		if (!_v1.$) {
			var subs = _v1.a;
			return A2($elm$core$List$map, $author$project$UI$ApiKeys$View$subAccountEntry, subs);
		} else {
			return _List_Nil;
		}
	}();
	var masterEntry = function () {
		var _v0 = $author$project$Remote$Model$toUserSession(remote);
		if (!_v0.$) {
			var session = _v0.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Types$User$unwrapUserId(session.mu),
					$author$project$UI$ApiKeys$View$masterLabel(session.ff))
				]);
		} else {
			return _List_Nil;
		}
	}();
	return _Utils_ap(masterEntry, subEntries);
};
var $author$project$Types$ApiToken$allScopes = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $author$project$Remote$RequestMsg$SetCreateApiTokenScopes = function (a) {
	return {$: 75, a: a};
};
var $author$project$UI$ApiKeys$View$presetCard = function (_v0) {
	var title = _v0.bs;
	var subtitle = _v0.o8;
	var scopesText = _v0.gv;
	var active = _v0.kD;
	var scopes = _v0.oK;
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('p-2 text-left rounded-md border cursor-pointer transition-colors', true),
						_Utils_Tuple2('border-green-400 bg-green-400 bg-opacity-10', active),
						_Utils_Tuple2('border-gray-600 bg-gray-900 hover:border-gray-400', !active)
					])),
				$elm$html$Html$Events$onClick(
				$author$project$TopMsg$requestMsg(
					$author$project$Remote$RequestMsg$SetCreateApiTokenScopes(scopes)))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center justify-between mb-1')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-white text-14 font-semibold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(title)
							])),
						active ? A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-green-400 text-12')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('✓ selected')
							])) : $elm$html$Html$text('')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-gray-300 text-12')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(subtitle)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-gray-500 text-12 font-mono mt-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(scopesText)
					]))
			]));
};
var $author$project$UI$ApiKeys$View$presetSection = function (selectedScopes) {
	var sameSet = F2(
		function (a, b) {
			return _Utils_eq(
				$elm$core$List$length(a),
				$elm$core$List$length(b)) && A2(
				$elm$core$List$all,
				function (s) {
					return A2($elm$core$List$member, s, b);
				},
				a);
		});
	var limitedScopes = _List_fromArray(
		[0, 1]);
	var limitedActive = A2(sameSet, selectedScopes, limitedScopes);
	var fullScopes = $author$project$Types$ApiToken$allScopes;
	var fullActive = A2(sameSet, selectedScopes, fullScopes);
	return A3(
		$author$project$UI$ApiKeys$View$section_,
		'Watcher-link presets',
		'Two common shapes — pick one to skip the manual scope picker, or build your own below.',
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('grid grid-cols-1 md:grid-cols-2 gap-3')
					]),
				_List_fromArray(
					[
						$author$project$UI$ApiKeys$View$presetCard(
						{kD: limitedActive, oK: limitedScopes, gv: 'hashrate_read, workers_read', o8: 'Hashrate, worker names and share counts', bs: 'Limited watcher'}),
						$author$project$UI$ApiKeys$View$presetCard(
						{kD: fullActive, oK: fullScopes, gv: 'all 5 scopes', o8: 'Everything read-only: hashrate, miners, earnings, rejection ratio, fees', bs: 'Full watcher'})
					]))
			]));
};
var $author$project$Remote$RequestMsg$ToggleCreateApiTokenScope = function (a) {
	return {$: 74, a: a};
};
var $author$project$UI$ApiKeys$View$scopeDescription = function (scope) {
	switch (scope) {
		case 0:
			return 'Current + historical hashrate snapshots.';
		case 1:
			return 'Live worker roster, miner count, share counts per worker.';
		case 2:
			return 'Daily generated BTC for FPPS earnings.';
		case 3:
			return 'Aggregate accepted/rejected share counts.';
		default:
			return 'Pool fee % and broker fee %.';
	}
};
var $author$project$UI$ApiKeys$View$scopeCard = F2(
	function (selectedScopes, scope) {
		var selected = A2($elm$core$List$member, scope, selectedScopes);
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('p-2 text-left rounded-md border cursor-pointer transition-colors', true),
							_Utils_Tuple2('border-blue-500 bg-blue-600 bg-opacity-20', selected),
							_Utils_Tuple2('border-gray-700 bg-gray-900 hover:border-gray-500', !selected)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$TopMsg$requestMsg(
						$author$project$Remote$RequestMsg$ToggleCreateApiTokenScope(scope)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center justify-between')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-white text-12 font-semibold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Types$ApiToken$scopeLabel(scope))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('text-12 px-2 py-0.5 rounded font-mono', true),
											_Utils_Tuple2('bg-blue-700 text-white', selected),
											_Utils_Tuple2('bg-gray-800 text-gray-400', !selected)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Types$ApiToken$scopeToWire(scope))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray-400 text-12 mt-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$UI$ApiKeys$View$scopeDescription(scope))
						]))
				]));
	});
var $author$project$UI$ApiKeys$View$scopesSection = function (selectedScopes) {
	return A3(
		$author$project$UI$ApiKeys$View$section_,
		'Custom scopes',
		'Toggle individual permissions. Each scope unlocks one set of fields on the read endpoints.',
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('grid grid-cols-1 md:grid-cols-3 gap-2')
					]),
				A2(
					$elm$core$List$map,
					$author$project$UI$ApiKeys$View$scopeCard(selectedScopes),
					$author$project$Types$ApiToken$allScopes))
			]));
};
var $author$project$Remote$RequestMsg$SetCreateApiTokenTargetUserId = function (a) {
	return {$: 73, a: a};
};
var $author$project$UI$ApiKeys$View$targetOption = F2(
	function (remote, _v0) {
		var userId = _v0.a;
		var label = _v0.b;
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(userId),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(
						remote.hN,
						$elm$core$Maybe$Just(userId)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$UI$ApiKeys$View$targetSection = F2(
	function (remote, options) {
		return A3(
			$author$project$UI$ApiKeys$View$section_,
			'Account',
			'Pick which account this key reads. Master accounts can mint for any of their subaccounts.',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full px-3 py-2 bg-gray-900 text-gray-200 text-12 rounded-md border border-gray-600 focus:outline-none focus:border-green-400 cursor-pointer'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							A2(
								$elm$json$Json$Decode$map,
								A2($elm$core$Basics$composeL, $author$project$TopMsg$requestMsg, $author$project$Remote$RequestMsg$SetCreateApiTokenTargetUserId),
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['target', 'value']),
									$elm$json$Json$Decode$string)))
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(''),
									$elm$html$Html$Attributes$selected(
									_Utils_eq(remote.hN, $elm$core$Maybe$Nothing)),
									$elm$html$Html$Attributes$disabled(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Select an account…')
								])),
						A2(
							$elm$core$List$map,
							$author$project$UI$ApiKeys$View$targetOption(remote),
							options)))
				]));
	});
var $author$project$Remote$RequestMsg$SetApiTokenTotp = function (a) {
	return {$: 64, a: a};
};
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $author$project$UI$ApiKeys$View$tokenTotpInput = function (remote) {
	return A3(
		$author$project$UI$ApiKeys$View$section_,
		'Authenticator code',
		'Required if two-factor authentication is enabled on your account.',
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric'),
						A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'one-time-code'),
						$elm$html$Html$Attributes$maxlength(6),
						$elm$html$Html$Attributes$value(remote.eT),
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeL, $author$project$TopMsg$requestMsg, $author$project$Remote$RequestMsg$SetApiTokenTotp)),
						$elm$html$Html$Attributes$class('w-full px-3 py-2 rounded bg-gray-900 text-white')
					]),
				_List_Nil)
			]));
};
var $author$project$UI$ApiKeys$View$createModal = function (remote) {
	if (!remote.gC) {
		return $elm$html$Html$text('');
	} else {
		var canSubmit = (!_Utils_eq(remote.hN, $elm$core$Maybe$Nothing)) && (!$elm$core$List$isEmpty(remote.hM));
		var availableTargets = $author$project$UI$ApiKeys$View$ownerOptions(remote);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fixed inset-0 bg-black bg-opacity-60 z-50 overflow-y-auto'),
					$elm$html$Html$Events$onClick(
					$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$CloseCreateApiTokenModal))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('min-h-full flex items-start justify-center py-10 px-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-gray-800 rounded-lg shadow-2xl max-w-[90vw] w-full flex flex-col max-h-[85vh]'),
									A2(
									$elm$html$Html$Events$stopPropagationOn,
									'click',
									$elm$json$Json$Decode$succeed(
										_Utils_Tuple2(
											$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$NoOp),
											true)))
								]),
							_List_fromArray(
								[
									$author$project$UI$ApiKeys$View$modalHeader,
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('px-6 py-4 overflow-y-auto flex flex-col gap-3 flex-1')
										]),
									_List_fromArray(
										[
											A2($author$project$UI$ApiKeys$View$targetSection, remote, availableTargets),
											$author$project$UI$ApiKeys$View$presetSection(remote.hM),
											$author$project$UI$ApiKeys$View$scopesSection(remote.hM),
											$author$project$UI$ApiKeys$View$tokenTotpInput(remote)
										])),
									$author$project$UI$ApiKeys$View$modalFooter(canSubmit)
								]))
						]))
				]));
	}
};
var $author$project$Remote$RequestMsg$OpenAggregateApiKeysModal = {$: 68};
var $author$project$Remote$RequestMsg$OpenCreateApiTokenModal = function (a) {
	return {$: 66, a: a};
};
var $author$project$UI$ApiKeys$View$header = function (remote) {
	var createButton = A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-3 py-1.5 bg-green-400 text-dmnd-black text-12 font-semibold rounded-md hover:bg-green-500 active:bg-green-400 cursor-pointer'),
				$elm$html$Html$Events$onClick(
				$author$project$TopMsg$requestMsg(
					$author$project$Remote$RequestMsg$OpenCreateApiTokenModal(
						{j7: $elm$core$Maybe$Nothing})))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('+ Create API key')
			]));
	var aggregateButton = A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-3 py-1.5 bg-gray-700 text-white text-12 font-semibold rounded-md hover:bg-gray-600 active:bg-gray-700 cursor-pointer'),
				$elm$html$Html$Events$onClick(
				$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$OpenAggregateApiKeysModal))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Aggregate API keys')
			]));
	var actions = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-row gap-2 items-center')
			]),
		$author$project$Remote$Model$canViewSubAccounts(remote) ? _List_fromArray(
			[aggregateButton, createButton]) : _List_fromArray(
			[createButton]));
	return $author$project$UI$Library$PageHeader$action(
		{
			k1: actions,
			o8: $elm$core$Maybe$Just('Mint, copy, and revoke read-only watcher links for the master account or any subaccount.'),
			bs: 'API keys'
		});
};
var $author$project$UI$ApiKeys$View$payoutAddressesByUserId = function (remote) {
	var nonEmptyEntry = F2(
		function (userId, address) {
			return $elm$core$String$isEmpty(address) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				_Utils_Tuple2(userId, address));
		});
	var subAccountAddresses = $elm$core$Dict$fromList(
		A2(
			$elm$core$List$filterMap,
			function (subAccount) {
				return A2(nonEmptyEntry, subAccount.mu, subAccount.kU);
			},
			A2($elm$core$Maybe$withDefault, _List_Nil, remote.ex)));
	var maybeMainAccountEntry = A2(
		$elm$core$Maybe$andThen,
		function (session) {
			return A2(
				$elm$core$Maybe$andThen,
				nonEmptyEntry(
					$author$project$Types$User$unwrapUserId(session.mu)),
				session.hl);
		},
		$author$project$Remote$Model$toUserSession(remote));
	if (!maybeMainAccountEntry.$) {
		var _v1 = maybeMainAccountEntry.a;
		var userId = _v1.a;
		var address = _v1.b;
		return A3($elm$core$Dict$insert, userId, address, subAccountAddresses);
	} else {
		return subAccountAddresses;
	}
};
var $author$project$Remote$RequestMsg$OpenRevokeApiTokenConfirmation = function (a) {
	return {$: 78, a: a};
};
var $author$project$UI$ApiKeys$View$copyCell = F2(
	function (fullValue, truncated) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline-flex items-center gap-1.5 cursor-pointer hover:text-green-400 group'),
					$elm$html$Html$Events$onClick(
					$author$project$TopMsg$globalMsg(
						$author$project$Global$Msg$CopyToClipboard(fullValue))),
					$elm$html$Html$Attributes$title('Click to copy')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$code,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-mono text-12 text-green-300 break-all')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(truncated)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-12 text-gray-500 group-hover:text-gray-300')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('⧉')
						]))
				]));
	});
var $author$project$UI$ApiKeys$View$monthInt = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $author$project$UI$ApiKeys$View$formatDate = function (posix) {
	var zone = $elm$time$Time$utc;
	var year = $elm$core$String$fromInt(
		A2($elm$time$Time$toYear, zone, posix));
	var month = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			$author$project$UI$ApiKeys$View$monthInt(
				A2($elm$time$Time$toMonth, zone, posix))));
	var day = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$time$Time$toDay, zone, posix)));
	return year + ('-' + (month + ('-' + day)));
};
var $author$project$UI$ApiKeys$View$payoutLinkStatus = F2(
	function (titleText, label) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-gray-600 text-11'),
					$elm$html$Html$Attributes$title(titleText)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Types$Payout$watcherPayoutLink = F3(
	function (frontendOrigin, request, payoutAddresses) {
		return frontendOrigin + ('/login/watcher#userId=' + ($elm$url$Url$percentEncode(request.g4) + ('&token=' + ($elm$url$Url$percentEncode(request.g_) + ('&payoutVersion=1&payoutUserId=' + ($elm$url$Url$percentEncode(request.g4) + ('&userAddress=' + ($elm$url$Url$percentEncode(request.pP) + ('&fppsAddress=' + ($elm$url$Url$percentEncode(payoutAddresses.l5) + ('&pplnsAddress=' + $elm$url$Url$percentEncode(payoutAddresses.n_))))))))))));
	});
var $author$project$UI$ApiKeys$View$payoutWatcherLinkAction = F4(
	function (topState, remote, maybeUserAddress, tok) {
		if (!A2($elm$core$List$member, 2, tok.oK)) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-gray-600'),
						$elm$html$Html$Attributes$title('Requires earnings_read')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('—')
					]));
		} else {
			var _v0 = _Utils_Tuple2(maybeUserAddress, remote.ej);
			if (_v0.a.$ === 1) {
				var _v1 = _v0.a;
				return ((!remote.gO) && A2($author$project$Remote$Model$isRequestAlreadyOngoing, remote, $author$project$Remote$RequestMsg$RetrieveSubAccount)) ? A2($author$project$UI$ApiKeys$View$payoutLinkStatus, 'Loading account payout addresses', 'Loading…') : A2($author$project$UI$ApiKeys$View$payoutLinkStatus, 'This account does not have an active payout address', 'Unavailable');
			} else {
				if (!_v0.b.$) {
					var userAddress = _v0.a.a;
					var payoutAddresses = _v0.b.a;
					var watcherLink = A3(
						$author$project$Types$Payout$watcherPayoutLink,
						topState.eV.me.ma,
						{g_: tok.g_, pP: userAddress, g4: tok.g4},
						payoutAddresses);
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('px-2 py-1 bg-green-900 text-green-200 text-11 rounded-md hover:bg-green-700 cursor-pointer whitespace-nowrap'),
								$elm$html$Html$Attributes$title('Copies a watcher link that discloses this account\'s payout address and public on-chain payout history'),
								$elm$html$Html$Events$onClick(
								$author$project$TopMsg$globalMsg(
									$author$project$Global$Msg$CopyToClipboard(watcherLink)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Copy + payouts')
							]));
				} else {
					var _v2 = _v0.b;
					return A2($author$project$Remote$Model$isRequestAlreadyOngoing, remote, $author$project$Remote$RequestMsg$FetchPayoutLinkAddresses) ? A2($author$project$UI$ApiKeys$View$payoutLinkStatus, 'Loading pool payout addresses', 'Loading…') : A2($author$project$UI$ApiKeys$View$payoutLinkStatus, 'Pool payout addresses are unavailable', 'Unavailable');
				}
			}
		}
	});
var $author$project$UI$ApiKeys$View$truncateMiddle = F3(
	function (leftCount, rightCount, value) {
		return (_Utils_cmp(
			$elm$core$String$length(value),
			(leftCount + rightCount) + 3) < 1) ? value : (A2($elm$core$String$left, leftCount, value) + ('…' + A2($elm$core$String$right, rightCount, value)));
	});
var $author$project$UI$ApiKeys$View$watcherLoginUrlForToken = F2(
	function (frontendOrigin, tok) {
		return frontendOrigin + ('/login/watcher#userId=' + ($elm$url$Url$percentEncode(tok.g4) + ('&token=' + $elm$url$Url$percentEncode(tok.g_))));
	});
var $author$project$UI$ApiKeys$View$renderTokenTableRow = F4(
	function (topState, remote, payoutAddresses, tok) {
		var unavailable = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-amber-300 text-11')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Secret unavailable — recovery needed')
				]));
		var recovered = $author$project$Types$ApiToken$recoverableToken(tok);
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-b border-gray-800 hover:bg-gray-900')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 text-white')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$UI$ApiKeys$View$ownerLabelFromToken(tok))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-12 text-dmnd-lighter-gray')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('ID #' + tok.mu)
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-row gap-1 flex-wrap')
								]),
							A2($elm$core$List$map, $author$project$UI$ApiKeys$View$renderScopeChip, tok.oK))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3')
						]),
					_List_fromArray(
						[
							function () {
							if (!recovered.$) {
								var key = recovered.a;
								return A2(
									$author$project$UI$ApiKeys$View$copyCell,
									key.g_,
									A3($author$project$UI$ApiKeys$View$truncateMiddle, 8, 6, key.g_));
							} else {
								return A2(
									$elm$html$Html$code,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-mono text-11')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(tok.pz)
										]));
							}
						}()
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3')
						]),
					_List_fromArray(
						[
							function () {
							if (!recovered.$) {
								var key = recovered.a;
								var link = A2($author$project$UI$ApiKeys$View$watcherLoginUrlForToken, topState.eV.me.ma, key);
								return A2(
									$author$project$UI$ApiKeys$View$watcherLinkCell,
									link,
									A3($author$project$UI$ApiKeys$View$truncateMiddle, 28, 12, link));
							} else {
								return unavailable;
							}
						}()
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3')
						]),
					_List_fromArray(
						[
							function () {
							if (!recovered.$) {
								var key = recovered.a;
								return A4(
									$author$project$UI$ApiKeys$View$payoutWatcherLinkAction,
									topState,
									remote,
									A2($elm$core$Dict$get, key.g4, payoutAddresses),
									key);
							} else {
								return unavailable;
							}
						}()
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'Never',
								A2($elm$core$Maybe$map, $author$project$UI$ApiKeys$View$formatDate, tok.mX)))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 text-11 text-dmnd-lighter-gray')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$UI$ApiKeys$View$formatDate(tok.lq)),
							function () {
							var _v3 = tok.c1;
							if (!_v3.$) {
								var t = _v3.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-12')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'expires ' + $author$project$UI$ApiKeys$View$formatDate(t))
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('px-2 py-1 bg-red-900 text-white text-12 rounded-md hover:bg-red-700 cursor-pointer'),
									$elm$html$Html$Events$onClick(
									$author$project$TopMsg$requestMsg(
										$author$project$Remote$RequestMsg$OpenRevokeApiTokenConfirmation(tok.mu))),
									$elm$html$Html$Attributes$disabled(
									!_Utils_eq(remote.jd, $elm$core$Maybe$Nothing))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Revoke')
								]))
						]))
				]));
	});
var $author$project$UI$ApiKeys$View$skeletonBlock = function (sizeClasses) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-gray-700 rounded animate-pulse ' + sizeClasses)
			]),
		_List_Nil);
};
var $author$project$UI$ApiKeys$View$skeletonRow = A2(
	$elm$html$Html$tr,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('border-b border-gray-800')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('py-2 pr-3')
				]),
			_List_fromArray(
				[
					$author$project$UI$ApiKeys$View$skeletonBlock('h-4 w-32')
				])),
			A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('py-2 pr-3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row gap-0.5')
						]),
					_List_fromArray(
						[
							$author$project$UI$ApiKeys$View$skeletonBlock('h-4 w-16 rounded-full'),
							$author$project$UI$ApiKeys$View$skeletonBlock('h-4 w-16 rounded-full')
						]))
				])),
			A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('py-2 pr-3')
				]),
			_List_fromArray(
				[
					$author$project$UI$ApiKeys$View$skeletonBlock('h-4 w-40')
				])),
			A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('py-2 pr-3')
				]),
			_List_fromArray(
				[
					$author$project$UI$ApiKeys$View$skeletonBlock('h-4 w-52')
				])),
			A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('py-2 pr-3')
				]),
			_List_fromArray(
				[
					$author$project$UI$ApiKeys$View$skeletonBlock('h-6 w-16')
				])),
			A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('py-2 pr-3')
				]),
			_List_fromArray(
				[
					$author$project$UI$ApiKeys$View$skeletonBlock('h-4 w-20')
				])),
			A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('py-2 pr-3')
				]),
			_List_fromArray(
				[
					$author$project$UI$ApiKeys$View$skeletonBlock('h-6 w-16 ml-auto')
				]))
		]));
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $author$project$UI$ApiKeys$View$skeletonTable = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('overflow-x-auto')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full text-12 text-left text-dmnd-lighter-gray')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-12 uppercase text-dmnd-lighter-gray')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('border-b border-gray-700')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Account')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Scopes')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Token')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('URL')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Payout link')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Last used')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Created')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('py-2 pr-3 font-normal text-right')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2($elm$core$List$repeat, 4, $author$project$UI$ApiKeys$View$skeletonRow))
				]))
		]));
var $author$project$UI$ApiKeys$View$listSection = F2(
	function (topState, remote) {
		var payoutAddresses = $author$project$UI$ApiKeys$View$payoutAddressesByUserId(remote);
		var _v0 = remote.eU;
		if (_v0.$ === 1) {
			return $author$project$UI$ApiKeys$View$skeletonTable;
		} else {
			if (!_v0.a.b) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-6 text-dmnd-lighter-gray text-12')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('You don\'t have any API keys yet. Create one to grant programmatic read access to a specific scope set.')
						]));
			} else {
				var tokens = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('overflow-x-auto max-h-[70vh] overflow-y-auto')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full text-12 text-left text-dmnd-lighter-gray')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$thead,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sticky top-0 z-10 bg-dmnd-almost-black text-12 uppercase text-dmnd-lighter-gray')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$tr,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('border-b border-gray-700')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Account')
														])),
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Scopes')
														])),
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Token')
														])),
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('URL')
														])),
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Payout link')
														])),
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Last used')
														])),
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Created')
														])),
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('py-2 pr-3 font-normal text-right')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tbody,
									_List_Nil,
									A2(
										$elm$core$List$map,
										A3($author$project$UI$ApiKeys$View$renderTokenTableRow, topState, remote, payoutAddresses),
										tokens))
								]))
						]));
			}
		}
	});
var $author$project$Remote$RequestMsg$DismissRevealedApiToken = {$: 77};
var $author$project$UI$ApiKeys$View$primarySampleEndpoint = function (resp) {
	var userId = resp.g4;
	var has = function (scope) {
		return A2($elm$core$List$member, scope, resp.oK);
	};
	return has(0) ? ('/api/user/sub_account/' + (userId + '/hashrate')) : (has(2) ? ('/api/user/sub_account/' + (userId + '/generated_btc')) : (has(3) ? ('/api/user/sub_account/' + (userId + '/share_stats')) : (has(4) ? ('/api/user/sub_account/' + (userId + '/fees')) : ('/api/user/sub_account/' + (userId + '/workers')))));
};
var $author$project$UI$ApiKeys$View$revealRow = F2(
	function (label, children) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-dmnd-lighter-gray text-12 uppercase tracking-wide mb-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2($elm$html$Html$div, _List_Nil, children)
				]));
	});
var $author$project$UI$ApiKeys$View$secretBox = function (secret) {
	return A2(
		$elm$html$Html$code,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('block w-full px-3 py-2 bg-gray-900 text-white text-12 font-mono break-all rounded select-all')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(secret)
			]));
};
var $author$project$UI$ApiKeys$View$revealPanel = F2(
	function (topState, remote) {
		var _v0 = remote.gq;
		if (_v0.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var resp = _v0.a;
			var sampleEndpoint = $author$project$UI$ApiKeys$View$primarySampleEndpoint(resp);
			var _v1 = topState.eV.me.hG.kI;
			var apiBase = _v1;
			var exampleUrl = _Utils_ap(apiBase, sampleEndpoint);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4 p-3 bg-green-900 bg-opacity-15 border border-green-700 rounded-md flex flex-col gap-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex justify-between items-start')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-green-300 text-12 font-semibold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('API key created.')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-dmnd-lighter-gray text-12 mt-0.5')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('The token and watcher links are also available in the key list. Keep them private; anyone with a link can read its permitted account data.')
											]))
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-dmnd-lighter-gray hover:text-white text-12'),
										$elm$html$Html$Events$onClick(
										$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$DismissRevealedApiToken))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('✕')
									]))
							])),
						A2(
						$author$project$UI$ApiKeys$View$revealRow,
						'Token',
						_List_fromArray(
							[
								$author$project$UI$ApiKeys$View$secretBox(resp.g_),
								A2($author$project$UI$ApiKeys$View$copyCell, resp.g_, 'Copy token')
							])),
						A2(
						$author$project$UI$ApiKeys$View$revealRow,
						'Watcher link',
						_List_fromArray(
							[
								A2(
								$author$project$UI$ApiKeys$View$watcherLinkCell,
								A2($author$project$UI$ApiKeys$View$watcherLoginUrlForToken, topState.eV.me.ma, resp),
								'Open watcher dashboard'),
								A2(
								$author$project$UI$ApiKeys$View$copyCell,
								A2($author$project$UI$ApiKeys$View$watcherLoginUrlForToken, topState.eV.me.ma, resp),
								'Copy watcher link'),
								A4(
								$author$project$UI$ApiKeys$View$payoutWatcherLinkAction,
								topState,
								remote,
								A2(
									$elm$core$Dict$get,
									resp.g4,
									$author$project$UI$ApiKeys$View$payoutAddressesByUserId(remote)),
								resp)
							])),
						A2(
						$author$project$UI$ApiKeys$View$revealRow,
						'Scopes',
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-row flex-wrap gap-1.5')
									]),
								A2($elm$core$List$map, $author$project$UI$ApiKeys$View$renderScopeChip, resp.oK))
							])),
						A2(
						$author$project$UI$ApiKeys$View$revealRow,
						'URL',
						_List_fromArray(
							[
								A2(
								$elm$html$Html$code,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('block w-full px-2 py-1 bg-gray-900 text-green-300 text-12 font-mono break-all rounded select-all')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(exampleUrl)
									]))
							])),
						A2(
						$author$project$UI$ApiKeys$View$revealRow,
						'curl',
						_List_fromArray(
							[
								A2(
								$elm$html$Html$code,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('block w-full px-2 py-1 bg-gray-900 text-green-300 text-12 font-mono break-all rounded select-all')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('curl --fail --header \'Authorization: Bearer <YOUR_TOKEN>\' \'' + (exampleUrl + '\''))
									]))
							]))
					]));
		}
	});
var $author$project$Remote$RequestMsg$CancelRevokeApiToken = {$: 79};
var $author$project$Remote$RequestMsg$ConfirmRevokeApiToken = function (a) {
	return {$: 80, a: a};
};
var $author$project$UI$ApiKeys$View$revokeModal = function (remote) {
	var _v0 = remote.jd;
	if (_v0.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var tokenId = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fixed inset-0 bg-black bg-opacity-60 z-50 overflow-y-auto'),
					$elm$html$Html$Events$onClick(
					$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$CancelRevokeApiToken))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('min-h-full flex items-center justify-center py-10 px-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-gray-800 rounded-lg shadow-2xl max-w-4xl w-full flex flex-col'),
									A2(
									$elm$html$Html$Events$stopPropagationOn,
									'click',
									$elm$json$Json$Decode$succeed(
										_Utils_Tuple2(
											$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$NoOp),
											true)))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('px-6 py-4 border-b border-gray-700')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-white text-14 font-semibold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Revoke API Key')
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-gray-400 text-12 mt-1')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('This is permanent. Anything using the key will start getting 401s immediately.')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('px-6 py-5 text-gray-300 text-12')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Revoke key #' + (tokenId + '?')),
											$author$project$UI$ApiKeys$View$tokenTotpInput(remote)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('px-6 py-4 border-t border-gray-700 flex justify-end gap-2 rounded-b-lg')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('px-4 py-2 bg-gray-700 text-white text-12 rounded-md hover:bg-gray-600 cursor-pointer'),
													$elm$html$Html$Events$onClick(
													$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$CancelRevokeApiToken))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('px-4 py-2 bg-red-700 text-white text-12 font-semibold rounded-md hover:bg-red-600 cursor-pointer'),
													$elm$html$Html$Events$onClick(
													$author$project$TopMsg$requestMsg(
														$author$project$Remote$RequestMsg$ConfirmRevokeApiToken(tokenId)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Revoke')
												]))
										]))
								]))
						]))
				]));
	}
};
var $author$project$UI$ApiKeys$View$view = function (topState) {
	var remote = topState.eV.jr;
	return A2(
		$author$project$UI$Library$MainPageWrapper$mainPageWrapper,
		topState,
		A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$ApiKeys$View$header(remote),
					A2($author$project$UI$ApiKeys$View$revealPanel, topState, remote),
					A2($author$project$UI$ApiKeys$View$listSection, topState, remote),
					$author$project$UI$ApiKeys$View$createModal(remote),
					A2($author$project$UI$ApiKeys$View$aggregateModal, topState.ph, remote),
					$author$project$UI$ApiKeys$View$revokeModal(remote)
				])));
};
var $author$project$Remote$RequestMsg$BrokerLogin = function (a) {
	return {$: 60, a: a};
};
var $author$project$UI$Auth$Msg$InputBrokerEmail = function (a) {
	return {$: 5, a: a};
};
var $author$project$UI$Auth$Msg$InputBrokerPassword = function (a) {
	return {$: 6, a: a};
};
var $author$project$Kernel$UI$Button$Submit = {$: 0};
var $elm$html$Html$form = _VirtualDom_node('form');
var $author$project$UI$Svg$largeLogo = function (classes) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 177 77'),
				$elm$svg$Svg$Attributes$class(classes)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M42.6653 9.25639C40.1982 5.65355 36.926 3.14022 32.9386 1.79102C30.6308 1.00598 27.7235 0.582116 24.2776 0.531372H0V58.2216H24.2776C28.5111 58.2216 32.2581 57.3022 35.4174 55.4903C38.5882 53.6725 41.2261 50.9174 43.2676 47.3026C46.2212 42.0401 47.7183 35.5538 47.7183 28.0288C47.7183 25.0587 47.3679 21.8947 46.673 18.6232C45.9635 15.283 44.617 12.1339 42.6653 9.25938V9.25639ZM33.9405 26.596C33.9405 27.2646 33.9405 27.9959 33.9405 28.8138C33.9405 32.7092 33.3933 36.0971 32.319 38.882C30.4194 43.7774 27.1704 46.1594 22.3838 46.1594H13.2623V12.5936H22.3838C26.9938 12.5936 30.0835 13.901 31.5603 16.477C31.7514 16.8143 31.9251 17.1247 32.0873 17.4173C33.1471 19.7515 33.7668 22.826 33.9376 26.596H33.9405Z'),
						$elm$svg$Svg$Attributes$fill('#EF3A2E')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M71.7665 0.0298495H71.7549L68.1411 17.6202L64.4751 0.28954V0H51.0361V58.1708H64.4751V25.0885L67.9673 49.1144L71.7665 25.0288V58.1708H85.2054V0H71.7665V0.0298495Z'),
						$elm$svg$Svg$Attributes$fill('#EF3A2E')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M110.926 34.3091L103.632 1.05667V0H90.1958V58.1708H103.632V24.6318L110.909 57.8066H110.926V58.1708H124.362V0H110.926V34.3091Z'),
						$elm$svg$Svg$Attributes$fill('#EF3A2E')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M175.955 18.623C175.245 15.2828 173.899 12.1337 171.947 9.2592C169.48 5.65636 166.208 3.14303 162.22 1.79383C159.913 1.00879 157.005 0.584924 153.559 0.53418H129.282V58.2214H153.559C157.793 58.2214 161.54 57.302 164.699 55.4902C167.87 53.6723 170.511 50.9172 172.549 47.3024C175.503 42.04 177 35.5536 177 28.0286C177 25.0586 176.65 21.8945 175.955 18.623ZM163.222 26.5958C163.222 27.2644 163.222 27.9957 163.222 28.8136C163.222 32.709 162.675 36.0969 161.601 38.8819C159.701 43.7772 156.452 46.1592 151.666 46.1592H142.544V12.5934H151.666C156.275 12.5934 159.365 13.9008 160.842 16.4768C161.033 16.8141 161.207 17.1245 161.369 17.4171C162.429 19.7513 163.049 22.8258 163.219 26.5958H163.222Z'),
						$elm$svg$Svg$Attributes$fill('#EF3A2E')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M124.362 63.1499H90.343V77.0001H124.362V63.1499Z'),
						$elm$svg$Svg$Attributes$fill('#EF3A2E')
					]),
				_List_Nil)
			]));
};
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $author$project$UI$Auth$BrokerLogin$view = function (topState) {
	var submitText = 'login';
	var state = topState.eV.hh;
	var submitAction = $author$project$TopMsg$requestMsg(
		$author$project$Remote$RequestMsg$BrokerLogin(
			{ff: state.hq, cy: state.hr}));
	var passwordPlaceholder = 'password';
	var headingText = 'BROKER LOGIN';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'background', 'black')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-screen flex justify-center bg-login-register bg-bottom bg-contain bg-no-repeat')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex justify-center items-center text-white ')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('class flex-col text-center w-50')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mb-2 text-55')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(headingText)
											])),
										$author$project$UI$Svg$largeLogo('w-full mb-3'),
										A2(
										$elm$html$Html$form,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex flex-col '),
												$elm$html$Html$Events$onSubmit(submitAction)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$id('broker-email'),
														$elm$html$Html$Attributes$name('broker-email'),
														$elm$html$Html$Attributes$class('block border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-1 mb-2 bg-dmnd-black'),
														$elm$html$Html$Attributes$required(true),
														$elm$html$Html$Attributes$placeholder('email'),
														$elm$html$Html$Attributes$type_('email'),
														$elm$html$Html$Attributes$value(state.hq),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$UI$Auth$Msg$InputBrokerEmail)),
														A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'broker-email')
													]),
												_List_Nil),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$id('broker-password'),
														$elm$html$Html$Attributes$name('broker-password'),
														$elm$html$Html$Attributes$class('block border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-1  bg-dmnd-black'),
														$elm$html$Html$Attributes$type_('password'),
														$elm$html$Html$Attributes$required(true),
														$elm$html$Html$Attributes$placeholder(passwordPlaceholder),
														$elm$html$Html$Attributes$value(state.hr),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$UI$Auth$Msg$InputBrokerPassword)),
														A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'password')
													]),
												_List_Nil),
												$author$project$Kernel$UI$Button$button(
												{
													hA: 'ml-7 mr-7 mt-3 pt-1 pb-1 pl-2 pr-2 bg-dmnd-green text-dmnd-black font-weight-semibold',
													A: A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(submitText)
															])),
													iJ: $author$project$Kernel$UI$Button$Submit
												})
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex items-center justify-between w-full mt-2')
											]),
										_List_fromArray(
											[
												$author$project$Kernel$UI$Button$button(
												{
													hA: '',
													A: A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('text-white text-7')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Login as User')
															])),
													iJ: $author$project$Kernel$UI$Button$Button(
														$author$project$Kernel$RouteMsgs$routeMsg.gu(
															$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$Login)))
												}),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('text-white text-7')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('I forgot my password')
															]))
													]))
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fixed bottom-2 fixed right-1/2 -mr-67 text-16')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('v' + topState.eV.me.pW)
					]))
			]));
};
var $author$project$Remote$RequestMsg$ForgotPassword = function (a) {
	return {$: 7, a: a};
};
var $author$project$UI$Auth$Msg$InputEmail = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Auth$Msg$InputWatcherToken = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$Auth$Msg$InputWatcherUserId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Remote$RequestMsg$ResetPassword = function (a) {
	return {$: 8, a: a};
};
var $author$project$UI$Auth$Msg$SelectLoginMode = function (a) {
	return {$: 4, a: a};
};
var $author$project$Remote$RequestMsg$SignIn = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Auth$Model$WatcherLogin = 1;
var $author$project$UI$Auth$LoginRegister$view = function (topState) {
	var state = topState.eV.hh;
	var loginModeButton = F2(
		function (mode, label) {
			var isActive = _Utils_eq(state.iR, mode);
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Attributes$class(
						'flex-1 border border-dmnd-lighter-gray px-2 py-1 text-12 cursor-pointer ' + (isActive ? 'bg-dmnd-green text-dmnd-black' : 'bg-dmnd-black text-white hover:border-dmnd-red-1')),
						$elm$html$Html$Events$onClick(
						$author$project$TopMsg$authMsg(
							$author$project$UI$Auth$Msg$SelectLoginMode(mode)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]));
		});
	var currentRoute = $author$project$Kernel$Aspect$Navigation$RouteHistory$current(topState.jE);
	var isLoginRoute = _Utils_eq(
		currentRoute,
		$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$Login));
	var resetPasswordEmail = function () {
		if ((currentRoute.$ === 1) && (currentRoute.a.$ === 3)) {
			var email = currentRoute.a.a.ff;
			return A2($elm$core$Maybe$withDefault, state.ff, email);
		} else {
			return state.ff;
		}
	}();
	var watcherCredentialsFromRoute = function () {
		if ((currentRoute.$ === 1) && (currentRoute.a.$ === 1)) {
			var watcherSession = currentRoute.a.a;
			return $elm$core$Maybe$Just(watcherSession);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var isWatcherLinkRoute = function () {
		if (!watcherCredentialsFromRoute.$) {
			return true;
		} else {
			return false;
		}
	}();
	var isWatcherLogin = isWatcherLinkRoute || (isLoginRoute && (state.iR === 1));
	var watcherToken = A2(
		$elm$core$Maybe$withDefault,
		state.p2,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.g_;
			},
			watcherCredentialsFromRoute));
	var watcherUserId = A2(
		$elm$core$Maybe$withDefault,
		state.p3,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.g4;
			},
			watcherCredentialsFromRoute));
	var _v0 = function () {
		_v1$2:
		while (true) {
			if (currentRoute.$ === 1) {
				switch (currentRoute.a.$) {
					case 2:
						var _v2 = currentRoute.a;
						return _Utils_Tuple3(
							'remembered your password?',
							$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$Login),
							'login');
					case 3:
						return _Utils_Tuple3(
							'remembered your password?',
							$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$Login),
							'login');
					default:
						break _v1$2;
				}
			} else {
				break _v1$2;
			}
		}
		return _Utils_Tuple3(
			'',
			$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$Login),
			'');
	}();
	var switchText = _v0.a;
	var switchRoute = _v0.b;
	var switchActionText = _v0.c;
	var _v3 = function () {
		_v4$4:
		while (true) {
			if (currentRoute.$ === 1) {
				switch (currentRoute.a.$) {
					case 0:
						var _v5 = currentRoute.a;
						return isWatcherLogin ? _Utils_Tuple2(
							'login',
							$author$project$TopMsg$requestMsg(
								$author$project$Remote$RequestMsg$WatcherLogin(
									{g_: watcherToken, g4: watcherUserId}))) : _Utils_Tuple2(
							'login',
							$author$project$TopMsg$requestMsg(
								$author$project$Remote$RequestMsg$SignIn(
									{ff: state.ff, cy: state.cy, g$: state.pK})));
					case 1:
						var watcherSession = currentRoute.a.a;
						return _Utils_Tuple2(
							'login',
							$author$project$TopMsg$requestMsg(
								$author$project$Remote$RequestMsg$WatcherLogin(watcherSession)));
					case 2:
						var _v6 = currentRoute.a;
						return _Utils_Tuple2(
							'submit',
							$author$project$TopMsg$requestMsg(
								$author$project$Remote$RequestMsg$ForgotPassword(
									{ff: state.ff})));
					case 3:
						var _v7 = state.oh;
						if (!_v7) {
							return _Utils_Tuple2(
								'proceed',
								$author$project$TopMsg$requestMsg(
									$author$project$Remote$RequestMsg$ResetPassword(
										{lb: state.lb, ff: resetPasswordEmail, ns: state.cy, pK: ''})));
						} else {
							return _Utils_Tuple2(
								'submit',
								$author$project$TopMsg$requestMsg(
									$author$project$Remote$RequestMsg$ResetPassword(
										{lb: state.lb, ff: resetPasswordEmail, ns: state.cy, pK: state.pK})));
						}
					default:
						break _v4$4;
				}
			} else {
				break _v4$4;
			}
		}
		return _Utils_Tuple2(
			'',
			$author$project$TopMsg$requestMsg(
				$author$project$Remote$RequestMsg$SignIn(
					{ff: '', cy: '', g$: ''})));
	}();
	var submitText = _v3.a;
	var submitAction = _v3.b;
	var _v8 = function () {
		_v9$4:
		while (true) {
			if (currentRoute.$ === 1) {
				switch (currentRoute.a.$) {
					case 0:
						var _v10 = currentRoute.a;
						return _Utils_Tuple3(
							isWatcherLogin ? 'WATCHER SIGN IN' : 'SIGN IN',
							'visible',
							'password');
					case 1:
						return _Utils_Tuple3('WATCHER SIGN IN', 'invisible', 'watcher token');
					case 2:
						var _v11 = currentRoute.a;
						return _Utils_Tuple3('FORGOT PASSWORD', 'invisible', '');
					case 3:
						return _Utils_Tuple3('RESET PASSWORD', 'invisible', 'new password');
					default:
						break _v9$4;
				}
			} else {
				break _v9$4;
			}
		}
		return _Utils_Tuple3('', 'invisible', '');
	}();
	var headingText = _v8.a;
	var forgotPasswordVisible = _v8.b;
	var passwordPlaceholder = _v8.c;
	var forgotPasswordClass = isWatcherLogin ? 'invisible' : forgotPasswordVisible;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'background', 'black')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-screen flex justify-center bg-login-register bg-bottom bg-contain bg-no-repeat')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex justify-center items-center text-white ')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('class flex-col text-center w-50')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mb-2 text-62')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(headingText)
											])),
										$author$project$UI$Svg$largeLogo('w-full mb-3'),
										isLoginRoute ? A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex mb-2')
											]),
										_List_fromArray(
											[
												A2(loginModeButton, 0, 'User'),
												A2(loginModeButton, 1, 'Watcher')
											])) : $elm_community$html_extra$Html$Extra$nothing,
										A2(
										$elm$html$Html$form,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex flex-col '),
												$elm$html$Html$Events$onSubmit(submitAction)
											]),
										_List_fromArray(
											[
												function () {
												if ((currentRoute.$ === 1) && (currentRoute.a.$ === 3)) {
													return A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$id('reset-password-username'),
																$elm$html$Html$Attributes$name('username'),
																$elm$html$Html$Attributes$type_('text'),
																$elm$html$Html$Attributes$value(resetPasswordEmail),
																A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'username'),
																A2($elm$html$Html$Attributes$attribute, 'hidden', 'hidden'),
																A2($elm$html$Html$Attributes$attribute, 'tabindex', '-1')
															]),
														_List_Nil);
												} else {
													return $elm_community$html_extra$Html$Extra$nothing;
												}
											}(),
												function () {
												if ((currentRoute.$ === 1) && (currentRoute.a.$ === 3)) {
													var _v14 = state.oh;
													if (!_v14) {
														return A2(
															$elm$html$Html$div,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$id('reset-code'),
																			$elm$html$Html$Attributes$name('reset-code'),
																			$elm$html$Html$Attributes$class('w-full block border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-1 mb-2 bg-dmnd-black'),
																			$elm$html$Html$Attributes$required(true),
																			$elm$html$Html$Attributes$placeholder('reset code'),
																			$elm$html$Html$Attributes$type_('text'),
																			$elm$html$Html$Attributes$value(state.lb),
																			$elm$html$Html$Events$onInput(
																			A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$UI$Auth$Msg$InputCode)),
																			A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'one-time-code')
																		]),
																	_List_Nil)
																]));
													} else {
														return A2(
															$elm$html$Html$input,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$id('two-fa-token'),
																	$elm$html$Html$Attributes$name('two-fa-token'),
																	$elm$html$Html$Attributes$class('w-full block border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-1 mb-2 bg-dmnd-black'),
																	$elm$html$Html$Attributes$required(true),
																	$elm$html$Html$Attributes$placeholder('2FA token'),
																	$elm$html$Html$Attributes$type_('text'),
																	$elm$html$Html$Attributes$value(state.pK),
																	$elm$html$Html$Events$onInput(
																	A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$UI$Auth$Msg$InputTwoFaToken)),
																	A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'one-time-code')
																]),
															_List_Nil);
													}
												} else {
													return isWatcherLogin ? A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$id('watcher-user'),
																$elm$html$Html$Attributes$name('watcher-user'),
																$elm$html$Html$Attributes$class('block border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-1 mb-2 bg-dmnd-black'),
																$elm$html$Html$Attributes$required(true),
																$elm$html$Html$Attributes$placeholder('account ID'),
																$elm$html$Html$Attributes$value(watcherUserId),
																$elm$html$Html$Events$onInput(
																A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$UI$Auth$Msg$InputWatcherUserId)),
																$elm$html$Html$Attributes$autocomplete(false)
															]),
														_List_Nil) : A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$id('user-login-email'),
																$elm$html$Html$Attributes$name('user-email'),
																$elm$html$Html$Attributes$class('block border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-1 mb-2 bg-dmnd-black'),
																$elm$html$Html$Attributes$required(true),
																$elm$html$Html$Attributes$placeholder('email'),
																$elm$html$Html$Attributes$type_('email'),
																$elm$html$Html$Attributes$value(state.ff),
																$elm$html$Html$Events$onInput(
																A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$UI$Auth$Msg$InputEmail)),
																$elm$html$Html$Attributes$autocomplete(true)
															]),
														_List_Nil);
												}
											}(),
												function () {
												_v15$2:
												while (true) {
													if (currentRoute.$ === 1) {
														switch (currentRoute.a.$) {
															case 2:
																var _v16 = currentRoute.a;
																return $elm_community$html_extra$Html$Extra$nothing;
															case 3:
																var _v17 = state.oh;
																if (!_v17) {
																	return A2(
																		$elm$html$Html$input,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$id('new-password'),
																				$elm$html$Html$Attributes$name('new-password'),
																				$elm$html$Html$Attributes$class('block border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-1  bg-dmnd-black'),
																				$elm$html$Html$Attributes$type_('password'),
																				$elm$html$Html$Attributes$required(true),
																				$elm$html$Html$Attributes$placeholder(passwordPlaceholder),
																				$elm$html$Html$Attributes$value(state.cy),
																				$elm$html$Html$Events$onInput(
																				A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$UI$Auth$Msg$InputPassword)),
																				A2($elm$html$Html$Attributes$attribute, 'aria-label', 'new password'),
																				A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'new-password')
																			]),
																		_List_Nil);
																} else {
																	return $elm_community$html_extra$Html$Extra$nothing;
																}
															default:
																break _v15$2;
														}
													} else {
														break _v15$2;
													}
												}
												return isWatcherLogin ? A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$id('watcher-token'),
															$elm$html$Html$Attributes$name('watcher-token'),
															$elm$html$Html$Attributes$class('block border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-1  bg-dmnd-black'),
															$elm$html$Html$Attributes$type_('password'),
															$elm$html$Html$Attributes$required(true),
															$elm$html$Html$Attributes$placeholder('watcher token'),
															$elm$html$Html$Attributes$value(watcherToken),
															$elm$html$Html$Events$onInput(
															A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$UI$Auth$Msg$InputWatcherToken)),
															$elm$html$Html$Attributes$autocomplete(false)
														]),
													_List_Nil) : A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$id('user-login-password'),
															$elm$html$Html$Attributes$name('user-password'),
															$elm$html$Html$Attributes$class('block border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-1  bg-dmnd-black'),
															$elm$html$Html$Attributes$type_('password'),
															$elm$html$Html$Attributes$required(true),
															$elm$html$Html$Attributes$placeholder(passwordPlaceholder),
															$elm$html$Html$Attributes$value(state.cy),
															$elm$html$Html$Events$onInput(
															A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$UI$Auth$Msg$InputPassword)),
															$elm$html$Html$Attributes$autocomplete(true)
														]),
													_List_Nil);
											}(),
												((!isWatcherLogin) && isLoginRoute) ? A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$id('login-totp'),
														$elm$html$Html$Attributes$type_('text'),
														A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric'),
														A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'one-time-code'),
														A2($elm$html$Html$Attributes$attribute, 'maxlength', '6'),
														$elm$html$Html$Attributes$placeholder('Authenticator code (if enabled)'),
														A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Authenticator code (required when two-factor authentication is enabled)'),
														$elm$html$Html$Attributes$value(state.pK),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$UI$Auth$Msg$InputTwoFaToken)),
														$elm$html$Html$Attributes$class('block border border-dmnd-lighter-gray p-1 bg-dmnd-black')
													]),
												_List_Nil) : $elm$html$Html$text(''),
												$author$project$Kernel$UI$Button$button(
												{
													hA: 'ml-7 mr-7 mt-3 pt-1 pb-1 pl-2 pr-2 bg-dmnd-green text-dmnd-black font-weight-semibold',
													A: A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(submitText)
															])),
													iJ: $author$project$Kernel$UI$Button$Submit
												})
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex items-center justify-between w-full mt-2')
											]),
										_List_fromArray(
											[
												$author$project$Kernel$UI$Button$button(
												{
													hA: '',
													A: A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('text-white text-7')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Broker Login')
															])),
													iJ: $author$project$Kernel$UI$Button$Button(
														$author$project$Kernel$RouteMsgs$routeMsg.gu(
															$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$BrokerLogin)))
												}),
												$author$project$Kernel$UI$Button$button(
												{
													hA: forgotPasswordClass,
													A: A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('text-white text-7')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('I forgot my password')
															])),
													iJ: $author$project$Kernel$UI$Button$Button(
														$author$project$Kernel$RouteMsgs$routeMsg.gu(
															$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$ForgotPassword)))
												})
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-6')
											]),
										_List_fromArray(
											[
												$author$project$Kernel$UI$Button$button(
												{
													hA: '',
													A: A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('  ')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(switchText)
															])),
													iJ: $author$project$Kernel$UI$Button$Button(
														$author$project$Kernel$RouteMsgs$routeMsg.gu(switchRoute))
												})
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fixed bottom-2 fixed right-1/2 -mr-67 text-16')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('v' + topState.eV.me.pW)
					]))
			]));
};
var $author$project$UI$Library$PageHeader$withSubtitle = function (_v0) {
	var title = _v0.bs;
	var subtitle = _v0.o8;
	return $author$project$UI$Library$PageHeader$render(
		{
			cO: $elm$core$Maybe$Nothing,
			o8: $elm$core$Maybe$Just(subtitle),
			bs: title
		});
};
var $author$project$UI$Broker$View$view = function (topState) {
	var remote = topState.eV.jr;
	var miners = function () {
		var _v0 = remote.e$;
		if (!_v0.$) {
			var m = _v0.a;
			return m;
		} else {
			return _List_Nil;
		}
	}();
	var minerRows = A2(
		$elm$core$List$map,
		function (miner) {
			return A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('border-b border-gray-800 hover:bg-gray-900')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 text-white')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(miner.aJ)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromFloat(miner.d1))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromFloat(miner.pI * 0))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromFloat(miner.k$))
							]))
					]));
		},
		miners);
	var dashboardContent = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Library$PageHeader$withSubtitle(
				{o8: 'Miners assigned to your broker referral code.', bs: 'Broker dashboard'}),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('overflow-x-auto')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full text-12 text-left text-dmnd-lighter-gray')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$thead,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-11 uppercase text-dmnd-lighter-gray')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('border-b border-gray-700')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$th,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Miner')
													])),
												A2(
												$elm$html$Html$th,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Hashrate')
													])),
												A2(
												$elm$html$Html$th,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Est. earnings')
													])),
												A2(
												$elm$html$Html$th,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Fee')
													]))
											]))
									])),
								A2($elm$html$Html$tbody, _List_Nil, minerRows)
							]))
					]))
			]));
	return A2($author$project$UI$Library$MainPageWrapper$mainPageWrapper, topState, dashboardContent);
};
var $author$project$UI$Library$HashrateDonut$sliceColor = function (i) {
	var hue = A2(
		$elm$core$Basics$modBy,
		360,
		$elm$core$Basics$round(i * 137.508));
	return 'hsl(' + ($elm$core$String$fromInt(hue) + ',68%,60%)');
};
var $author$project$UI$Library$HashrateDonut$buildSlices = function (remote) {
	var subEntries = A2(
		$elm$core$List$filterMap,
		function (sub) {
			var hr = A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$core$Maybe$withDefault,
					0.0,
					$elm$core$String$toFloat(sub.d1)),
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.d1;
						},
						function ($) {
							return $.ay;
						}),
					A2($elm$core$Dict$get, sub.mu, remote.gM)));
			return (hr > 0) ? $elm$core$Maybe$Just(
				_Utils_Tuple2(sub.o4, hr)) : $elm$core$Maybe$Nothing;
		},
		A2($elm$core$Maybe$withDefault, _List_Nil, remote.ex));
	var mainHr = A2(
		$elm$core$Maybe$withDefault,
		0.0,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ay;
			},
			remote.dA));
	var allEntries = (mainHr > 0) ? A2(
		$elm$core$List$cons,
		_Utils_Tuple2('This Account', mainHr),
		subEntries) : subEntries;
	var total = $elm$core$List$sum(
		A2($elm$core$List$map, $elm$core$Tuple$second, allEntries));
	return A2(
		$elm$core$List$indexedMap,
		F2(
			function (i, _v0) {
				var label = _v0.a;
				var hr = _v0.b;
				return {
					cU: $author$project$UI$Library$HashrateDonut$sliceColor(i),
					mR: label,
					gk: (total > 0) ? ((hr / total) * 100) : 0.0,
					dl: hr
				};
			}),
		allEntries);
};
var $author$project$UI$Library$Button$copyFppsPasswordToClipboard = function (_v0) {
	var value = _v0.pV;
	var iconClasses = _v0.mt;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$TopMsg$globalMsg(
					$author$project$Global$Msg$CopyFppsPasswordToClipboard(value)))
			]),
		_List_fromArray(
			[
				$author$project$UI$Svg$copyIcon('cursor-pointer ' + iconClasses)
			]));
};
var $author$project$UI$Library$AccountData$dataScopeIsAggregate = function (topState) {
	return A2($author$project$UI$Library$AccountData$scopeIsAggregate, topState.eV.me.dD, topState.eV.jr);
};
var $author$project$Types$SubAccountSummary$effectivePoolFee = function (fees) {
	return fees.nV + fees.k_;
};
var $author$project$Kernel$Aspect$Utility$emptyContainer = $elm$html$Html$span(_List_Nil);
var $elm$html$Html$i = _VirtualDom_node('i');
var $author$project$UI$Library$Icon$iconConstructor = F3(
	function (maybeMsg, iconName, classes) {
		return A2(
			$elm$html$Html$i,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('icon-' + iconName),
					$elm$html$Html$Attributes$class('icon'),
					$elm$html$Html$Attributes$class(classes),
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Kernel$Aspect$Utility$noOpAttr, $elm$html$Html$Events$onClick, maybeMsg)
				]),
			_List_Nil);
	});
var $author$project$UI$Library$Icon$toStrFromIcon = function (theIcon) {
	switch (theIcon) {
		case 0:
			return 'info';
		case 1:
			return 'arrow_left';
		case 2:
			return 'check';
		case 3:
			return 'close';
		case 4:
			return 'messages';
		default:
			return 'report';
	}
};
var $author$project$UI$Library$Icon$iconConstructorFromIcon = F3(
	function (maybeMsg, theIcon, classes) {
		return A3(
			$author$project$UI$Library$Icon$iconConstructor,
			maybeMsg,
			$author$project$UI$Library$Icon$toStrFromIcon(theIcon),
			classes);
	});
var $author$project$UI$Library$Icon$iconNoOp = $author$project$UI$Library$Icon$iconConstructorFromIcon($elm$core$Maybe$Nothing);
var $author$project$UI$Library$AccountData$combineHashrate = F2(
	function (left, right) {
		return {
			ii: left.ii + right.ii,
			ny: function () {
				var _v0 = right.ny;
				if (!_v0.$) {
					return right.ny;
				} else {
					return left.ny;
				}
			}(),
			n1: left.n1 + right.n1,
			ay: left.ay + right.ay
		};
	});
var $author$project$UI$Library$AccountData$zeroHashrate = function (observedAt) {
	return {ii: 0, ny: observedAt, n1: 0, ay: 0};
};
var $author$project$UI$Library$AccountData$mainHashrate = function (remote) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$UI$Library$AccountData$zeroHashrate($elm$core$Maybe$Nothing),
		remote.dA);
};
var $author$project$UI$Library$AccountData$subAccountHashrate = F2(
	function (remote, subAccount) {
		var _v0 = A2($elm$core$Dict$get, subAccount.mu, remote.gM);
		if (!_v0.$) {
			var summary = _v0.a;
			return summary.d1;
		} else {
			var totalHashrate = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toFloat(subAccount.d1));
			return {ii: 0, ny: $elm$core$Maybe$Nothing, n1: totalHashrate, ay: totalHashrate};
		}
	});
var $author$project$UI$Library$AccountData$subAccountsHashrate = function (remote) {
	return A3(
		$elm$core$List$foldl,
		$author$project$UI$Library$AccountData$combineHashrate,
		$author$project$UI$Library$AccountData$zeroHashrate($elm$core$Maybe$Nothing),
		A2(
			$elm$core$List$map,
			$author$project$UI$Library$AccountData$subAccountHashrate(remote),
			A2($elm$core$Maybe$withDefault, _List_Nil, remote.ex)));
};
var $author$project$UI$Library$AccountData$aggregateHashrate = function (remote) {
	return A2(
		$author$project$UI$Library$AccountData$combineHashrate,
		$author$project$UI$Library$AccountData$mainHashrate(remote),
		$author$project$UI$Library$AccountData$subAccountsHashrate(remote));
};
var $author$project$UI$Library$AccountData$selectedHashrate = function (topState) {
	return $author$project$UI$Library$AccountData$dataScopeIsAggregate(topState) ? $author$project$UI$Library$AccountData$aggregateHashrate(topState.eV.jr) : $author$project$UI$Library$AccountData$mainHashrate(topState.eV.jr);
};
var $author$project$UI$Library$DashboardInfoSquares$square = F4(
	function (classes, title, upperContent, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('h-30 flex-1 p-3 flex flex-col justify-between ' + classes)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(title),
							upperContent
						])),
					content
				]));
	});
var $author$project$UI$Home$Msg$HoverDonutSegment = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$cos = _Basics_cos;
var $author$project$UI$Library$HashrateDonut$fp = function (n) {
	return $elm$core$String$fromFloat(
		$elm$core$Basics$round(n * 1000) / 1000);
};
var $elm$core$Basics$pi = _Basics_pi;
var $elm$core$Basics$sin = _Basics_sin;
var $author$project$UI$Library$HashrateDonut$arcPath = F6(
	function (cx, cy, outerR, innerR, startAngle, endAngle) {
		var totalSweep = endAngle - startAngle;
		var gap = (_Utils_cmp(totalSweep, (2 * $elm$core$Basics$pi) - 0.05) < 0) ? 0.025 : 0.0;
		var sa = startAngle + gap;
		var ix2 = cx + (innerR * $elm$core$Basics$cos(sa));
		var iy2 = cy + (innerR * $elm$core$Basics$sin(sa));
		var ox1 = cx + (outerR * $elm$core$Basics$cos(sa));
		var oy1 = cy + (outerR * $elm$core$Basics$sin(sa));
		var ea = endAngle - gap;
		var ix1 = cx + (innerR * $elm$core$Basics$cos(ea));
		var iy1 = cy + (innerR * $elm$core$Basics$sin(ea));
		var ox2 = cx + (outerR * $elm$core$Basics$cos(ea));
		var oy2 = cy + (outerR * $elm$core$Basics$sin(ea));
		var sweep = ea - sa;
		var largeArc = (_Utils_cmp(sweep, $elm$core$Basics$pi) > 0) ? '1' : '0';
		return $elm$core$String$concat(
			_List_fromArray(
				[
					'M ',
					$author$project$UI$Library$HashrateDonut$fp(ox1),
					' ',
					$author$project$UI$Library$HashrateDonut$fp(oy1),
					' A ',
					$author$project$UI$Library$HashrateDonut$fp(outerR),
					' ',
					$author$project$UI$Library$HashrateDonut$fp(outerR),
					' 0 ',
					largeArc,
					' 1 ',
					$author$project$UI$Library$HashrateDonut$fp(ox2),
					' ',
					$author$project$UI$Library$HashrateDonut$fp(oy2),
					' L ',
					$author$project$UI$Library$HashrateDonut$fp(ix1),
					' ',
					$author$project$UI$Library$HashrateDonut$fp(iy1),
					' A ',
					$author$project$UI$Library$HashrateDonut$fp(innerR),
					' ',
					$author$project$UI$Library$HashrateDonut$fp(innerR),
					' 0 ',
					largeArc,
					' 0 ',
					$author$project$UI$Library$HashrateDonut$fp(ix2),
					' ',
					$author$project$UI$Library$HashrateDonut$fp(iy2),
					' Z'
				]));
	});
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$fontSize = _VirtualDom_attribute('font-size');
var $elm$svg$Svg$Attributes$fontWeight = _VirtualDom_attribute('font-weight');
var $author$project$TopMsg$homeMsg = A2($elm$core$Basics$composeL, $author$project$Kernel$Msg$AppMsg, $author$project$Msg$HomeMsg);
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$svg$Svg$Attributes$opacity = _VirtualDom_attribute('opacity');
var $elm$svg$Svg$Attributes$preserveAspectRatio = _VirtualDom_attribute('preserveAspectRatio');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$Attributes$textAnchor = _VirtualDom_attribute('text-anchor');
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $author$project$UI$Library$HashrateDonut$view = F2(
	function (hoveredLabel, slices) {
		var total = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.dl;
				},
				slices));
		var totalHashrate = $author$project$Types$Hashrate$rawHashrateToHashrate(total);
		var title = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline-flex items-center gap-2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('OVERALL HASHRATE'),
					A3(
					$author$project$Kernel$UI$CustomTooltip$CustomTooltip$tooltipable,
					{
						kM: 'hidden',
						hA: '',
						pi: 0,
						pB: $elm$html$Html$text('Total hashrate across the master account and all sub-accounts'),
						pC: 'bg-dmnd-black text-gray-300 text-12 p-2 rounded shadow-lg whitespace-nowrap z-50',
						pD: _Utils_Tuple2(2, 1)
					},
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-dmnd-lighter-gray cursor-help text-12 leading-none')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('ⓘ')
						]))
				]));
		var slicesWithAngles = A3(
			$elm$core$List$foldl,
			F2(
				function (slice, _v2) {
					var acc = _v2.a;
					var currentAngle = _v2.b;
					var fraction = slice.dl / total;
					var spanAngle = (fraction * 2) * $elm$core$Basics$pi;
					var endAngle = currentAngle + spanAngle;
					return _Utils_Tuple2(
						_Utils_ap(
							acc,
							_List_fromArray(
								[
									_Utils_Tuple3(slice, currentAngle, endAngle)
								])),
						endAngle);
				}),
			_Utils_Tuple2(_List_Nil, -($elm$core$Basics$pi / 2)),
			slices).a;
		var outerR = 50.0;
		var innerR = 36.0;
		var ringR = (outerR + innerR) / 2;
		var ringWidth = outerR - innerR;
		var hoveredSlice = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (s) {
					return _Utils_eq(
						hoveredLabel,
						$elm$core$Maybe$Just(s.mR));
				},
				slices));
		var cy = 60.0;
		var cx = 60.0;
		var segments = A2(
			$elm$core$List$map,
			function (_v1) {
				var slice = _v1.a;
				var startAngle = _v1.b;
				var endAngle = _v1.c;
				var sweepAngle = endAngle - startAngle;
				var isHovered = _Utils_eq(
					hoveredLabel,
					$elm$core$Maybe$Just(slice.mR));
				var opacity = isHovered ? '1' : '0.75';
				var r = isHovered ? (outerR + 4) : outerR;
				return (_Utils_cmp(sweepAngle, (2 * $elm$core$Basics$pi) - 0.01) > -1) ? A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx(
							$author$project$UI$Library$HashrateDonut$fp(cx)),
							$elm$svg$Svg$Attributes$cy(
							$author$project$UI$Library$HashrateDonut$fp(cy)),
							$elm$svg$Svg$Attributes$r(
							$author$project$UI$Library$HashrateDonut$fp((r + innerR) / 2)),
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$stroke(slice.cU),
							$elm$svg$Svg$Attributes$strokeWidth(
							$author$project$UI$Library$HashrateDonut$fp(r - innerR)),
							$elm$svg$Svg$Attributes$opacity(opacity),
							$elm$html$Html$Events$onMouseEnter(
							$author$project$TopMsg$homeMsg(
								$author$project$UI$Home$Msg$HoverDonutSegment(
									$elm$core$Maybe$Just(slice.mR)))),
							$elm$html$Html$Events$onMouseLeave(
							$author$project$TopMsg$homeMsg(
								$author$project$UI$Home$Msg$HoverDonutSegment($elm$core$Maybe$Nothing))),
							$elm$svg$Svg$Attributes$style('cursor: default; transition: opacity 0.15s')
						]),
					_List_Nil) : A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d(
							A6($author$project$UI$Library$HashrateDonut$arcPath, cx, cy, r, innerR, startAngle, endAngle)),
							$elm$svg$Svg$Attributes$fill(slice.cU),
							$elm$svg$Svg$Attributes$opacity(opacity),
							$elm$html$Html$Events$onMouseEnter(
							$author$project$TopMsg$homeMsg(
								$author$project$UI$Home$Msg$HoverDonutSegment(
									$elm$core$Maybe$Just(slice.mR)))),
							$elm$html$Html$Events$onMouseLeave(
							$author$project$TopMsg$homeMsg(
								$author$project$UI$Home$Msg$HoverDonutSegment($elm$core$Maybe$Nothing))),
							$elm$svg$Svg$Attributes$style('cursor: default; transition: opacity 0.15s')
						]),
					_List_Nil);
			},
			slicesWithAngles);
		var centerLabels = _List_fromArray(
			[
				A2(
				$elm$svg$Svg$text_,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('60'),
						$elm$svg$Svg$Attributes$y('61'),
						$elm$svg$Svg$Attributes$textAnchor('middle'),
						$elm$svg$Svg$Attributes$fill('white'),
						$elm$svg$Svg$Attributes$fontSize('17'),
						$elm$svg$Svg$Attributes$fontWeight('600')
					]),
				_List_fromArray(
					[
						$elm$svg$Svg$text(
						$author$project$Types$Hashrate$toTwoDigitString(totalHashrate.cz))
					])),
				A2(
				$elm$svg$Svg$text_,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('60'),
						$elm$svg$Svg$Attributes$y('72'),
						$elm$svg$Svg$Attributes$textAnchor('middle'),
						$elm$svg$Svg$Attributes$fill('rgba(255,255,255,0.5)'),
						$elm$svg$Svg$Attributes$fontSize('8')
					]),
				_List_fromArray(
					[
						$elm$svg$Svg$text(
						$author$project$Types$Hashrate$unitToString(totalHashrate.cL))
					]))
			]);
		var backgroundRing = A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx(
					$author$project$UI$Library$HashrateDonut$fp(cx)),
					$elm$svg$Svg$Attributes$cy(
					$author$project$UI$Library$HashrateDonut$fp(cy)),
					$elm$svg$Svg$Attributes$r(
					$author$project$UI$Library$HashrateDonut$fp(ringR)),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$stroke('rgba(255,255,255,0.08)'),
					$elm$svg$Svg$Attributes$strokeWidth(
					$author$project$UI$Library$HashrateDonut$fp(ringWidth))
				]),
			_List_Nil);
		var donutContent = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative z-10 mt-3 flex flex-1 items-center justify-end min-h-0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-38 w-24 shrink-0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$svg,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$viewBox('0 0 120 120'),
									$elm$svg$Svg$Attributes$class('h-full w-full'),
									$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet')
								]),
							A2(
								$elm$core$List$cons,
								backgroundRing,
								_Utils_ap(segments, centerLabels)))
						])),
					function () {
					if (hoveredSlice.$ === 1) {
						return $elm_community$html_extra$Html$Extra$nothing;
					} else {
						var slice = hoveredSlice.a;
						var pct = $elm$core$String$fromInt(
							$elm$core$Basics$round(slice.gk)) + '%';
						var hr = $author$project$Types$Hashrate$rawHashrateToHashrate(slice.dl);
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute z-50 pointer-events-none flex items-center gap-2 bg-dmnd-black text-gray-300 text-12 p-2 rounded shadow-lg whitespace-nowrap'),
									A2($elm$html$Html$Attributes$style, 'right', '0'),
									A2($elm$html$Html$Attributes$style, 'top', '50%'),
									A2($elm$html$Html$Attributes$style, 'transform', 'translateY(-50%)')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'background-color', slice.cU),
											A2($elm$html$Html$Attributes$style, 'width', '10px'),
											A2($elm$html$Html$Attributes$style, 'height', '10px'),
											$elm$html$Html$Attributes$class('rounded-full shrink-0')
										]),
									_List_Nil),
									$elm$html$Html$text(
									slice.mR + (' · ' + ($author$project$Types$Hashrate$toTwoDigitString(hr.cz) + (' ' + ($author$project$Types$Hashrate$unitToString(hr.cL) + (' (' + (pct + ')')))))))
								]));
					}
				}()
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('h-30 flex-1 p-3 flex flex-col justify-between bg-dmnd-black relative')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative z-20')
						]),
					_List_fromArray(
						[title])),
					donutContent
				]));
	});
var $author$project$UI$Library$DashboardInfoSquares$dashboardInfoSquares = function (topState) {
	var twentyFourHourAverageHashrate = function (_v6) {
		var cutoffMillis = $elm$time$Time$posixToMillis(topState.ph) - (((24 * 60) * 60) * 1000);
		var recentHashrates = A2(
			$elm$core$List$map,
			function ($) {
				return $.pG;
			},
			A2(
				$elm$core$List$filter,
				function (point) {
					return _Utils_cmp(
						$elm$time$Time$posixToMillis(point.ph),
						cutoffMillis) > -1;
				},
				topState.eV.hw.hv));
		var pointCount = $elm$core$List$length(recentHashrates);
		return (!pointCount) ? $author$project$Types$Hashrate$rawHashrateToHashrate(0.0) : $author$project$Types$Hashrate$rawHashrateToHashrate(
			function (totalHashrate) {
				return totalHashrate / pointCount;
			}(
				$elm$core$List$sum(recentHashrates)));
	};
	var truncateToken = function (token) {
		return A2($elm$core$String$left, 6, token) + ('...' + A2($elm$core$String$right, 6, token));
	};
	var sixHourTitle = '6 HOURS';
	var sixHourHashrate = function (_v5) {
		return $author$project$Types$Hashrate$rawHashrateToHashrate(topState.eV.jr.fu);
	};
	var selectedUserHashrate = $author$project$UI$Library$AccountData$selectedHashrate(topState);
	var roundedPercent = function (value) {
		return $elm$core$String$fromFloat(
			$elm$core$Basics$round(value * 100) / 100) + '%';
	};
	var remote = topState.eV.jr;
	var selectedSubAccountsHashrate = $author$project$UI$Library$AccountData$subAccountsHashrate(remote);
	var slices = $author$project$UI$Library$HashrateDonut$buildSlices(remote);
	var userSession = $author$project$Remote$Model$toUserSession(remote);
	var userToken = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.g_;
			},
			userSession));
	var proxyUrl = topState.h1.mJ ? 'stratum+tcp://fpps-backup-s.dmnd.work:32772' : (topState.h1.mM ? 'stratum+tcp://18.185.217.132:32768' : 'stratum+tcp://0.0.0.0:32768');
	var oneHourTitle = '1 HOUR HASHRATE';
	var oneHourHashrate = function (_v4) {
		return $author$project$Types$Hashrate$rawHashrateToHashrate(topState.eV.jr.ft);
	};
	var liveHashrate = function (_v3) {
		return $author$project$Types$Hashrate$rawHashrateToHashrate(selectedUserHashrate.ay);
	};
	var isWatcher = $author$project$Remote$Model$isWatcherAuthenticated(remote);
	var watcherStatsSquare = function () {
		if (!isWatcher) {
			return $elm_community$html_extra$Html$Extra$nothing;
		} else {
			var shareStatsRows = function () {
				var _v2 = remote.eI;
				if (!_v2.$) {
					var stats = _v2.a;
					var total = stats.kB + stats.od;
					var rejectionRate = (!total) ? '0%' : roundedPercent((stats.od / total) * 100);
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center justify-between gap-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-400 text-12 shrink-0')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('REJECTION')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-mono text-12 text-white')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(rejectionRate)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center justify-between gap-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-400 text-12 shrink-0')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('SHARES')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-mono text-12 text-white')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(stats.od) + ('/' + $elm$core$String$fromInt(total)))
										]))
								]))
						]);
				} else {
					return (remote.az.eu === 2) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-12 text-gray-500')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Not permitted to see share stats')
								]))
						]) : _List_Nil;
				}
			}();
			var feeRows = function () {
				var _v1 = remote.eH;
				if (!_v1.$) {
					var fees = _v1.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center justify-between gap-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-400 text-12 shrink-0')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('POOL FEE')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-mono text-12 text-white')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											roundedPercent(
												$author$project$Types$SubAccountSummary$effectivePoolFee(fees)))
										]))
								]))
						]);
				} else {
					return (remote.az.d_ === 2) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-12 text-gray-500')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Not permitted to see fees')
								]))
						]) : _List_Nil;
				}
			}();
			var rows = _Utils_ap(shareStatsRows, feeRows);
			return A4(
				$author$project$UI$Library$DashboardInfoSquares$square,
				'bg-dmnd-gray h-auto',
				'WATCHER DATA',
				$elm$html$Html$text(''),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-1')
						]),
					$elm$core$List$isEmpty(rows) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-12 text-gray-500')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Loading...')
								]))
						]) : rows));
		}
	}();
	var isAggregateData = $author$project$UI$Library$AccountData$dataScopeIsAggregate(topState);
	var liveHashrateTooltip = isAggregateData ? 'Main account + all subaccount hashrate' : 'Combined PPLNS + FPPS hashrate';
	var secondaryHashrate = isAggregateData ? $author$project$Types$Hashrate$rawHashrateToHashrate(selectedSubAccountsHashrate.ay) : twentyFourHourAverageHashrate(0);
	var secondaryHashrateLabel = isAggregateData ? 'SUBACCOUNTS' : '24H AVERAGE';
	var hashRateElOnly = function (hr) {
		var hashRateUnitText = $author$project$Types$Hashrate$unitToString(hr.cL);
		var hashNumberText = $author$project$Types$Hashrate$toTwoDigitString(hr.cz);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-50 mr-1')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(hashNumberText)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-16 font-normal')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(hashRateUnitText)
					]))
			]);
	};
	var hashrateRow = F2(
		function (title, hrValueAndUnit) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-row flex justify-between items-last-baseline')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex min-w-12 max-w-full')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(title)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('min-w-9')
							]),
						hashRateElOnly(hrValueAndUnit))
					]));
		});
	var hashRate = function (hr) {
		var hashRateUnitText = $author$project$Types$Hashrate$unitToString(hr.cL);
		var hashNumberText = $author$project$Types$Hashrate$toTwoDigitString(hr.cz);
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-baseline justify-end')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-50 mr-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(hashNumberText)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-16 font-normal')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(hashRateUnitText)
						]))
				]));
	};
	var hasLiveHashrate = selectedUserHashrate.ay > 0;
	var fppsUserToken = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.l8;
			},
			userSession));
	var connectionInfoSquare = isWatcher ? $elm_community$html_extra$Html$Extra$nothing : A4(
		$author$project$UI$Library$DashboardInfoSquares$square,
		'bg-dmnd-gray h-auto',
		'CONNECTION INFO',
		$elm$html$Html$text(''),
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center justify-between gap-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-400 text-12 shrink-0')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('STRATUM URL')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('min-w-0 flex flex-1 items-center justify-end gap-1 text-right')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('min-w-0 truncate text-white font-mono text-12')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(proxyUrl)
										])),
									$author$project$UI$Library$Button$copyToClipboard(
									{mt: 'w-2.5 h-2.5 shrink-0', pV: proxyUrl})
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center justify-between gap-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-400 text-12 shrink-0')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('USERNAME')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('min-w-0 flex flex-1 items-center justify-end gap-1 text-right')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('min-w-0 truncate text-white font-mono text-12')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Any value or leave empty')
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center justify-between gap-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-400 text-12 shrink-0')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('PPLNS PASSWORD')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('min-w-0 flex flex-1 items-center justify-end gap-1 text-right')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('min-w-0 truncate text-white font-mono text-12')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											truncateToken(userToken))
										])),
									$author$project$UI$Library$Button$copyToClipboard(
									{mt: 'w-2.5 h-2.5 shrink-0', pV: userToken})
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center justify-between gap-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-400 text-12 shrink-0')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('FPPS PASSWORD')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('min-w-0 flex flex-1 items-center justify-end gap-1 text-right')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('min-w-0 truncate text-white font-mono text-12')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											truncateToken(fppsUserToken))
										])),
									$author$project$UI$Library$Button$copyFppsPasswordToClipboard(
									{mt: 'w-2.5 h-2.5 shrink-0', pV: fppsUserToken})
								]))
						]))
				])));
	var compactHashRateElOnly = function (hr) {
		var hashRateUnitText = $author$project$Types$Hashrate$unitToString(hr.cL);
		var hashNumberText = $author$project$Types$Hashrate$toTwoDigitString(hr.cz);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-20 mr-0.5')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(hashNumberText)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-12 font-normal text-gray-300')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(hashRateUnitText)
					]))
			]);
	};
	var liveHashrateSquare = hasLiveHashrate ? A4(
		$author$project$UI$Library$DashboardInfoSquares$square,
		'bg-dmnd-gray',
		'LIVE HASHRATE',
		A3(
			$author$project$Kernel$UI$CustomTooltip$CustomTooltip$tooltipable,
			{
				kM: 'hidden',
				hA: 'inline-flex ml-1',
				pi: 0,
				pB: $elm$html$Html$text(liveHashrateTooltip),
				pC: 'bg-dmnd-black text-gray-300 text-12 p-2 rounded shadow-lg whitespace-nowrap z-50',
				pD: _Utils_Tuple2(2, 1)
			},
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cursor-default')
				]),
			_List_fromArray(
				[
					A2($author$project$UI$Library$Icon$iconNoOp, 0, '')
				])),
		$author$project$Kernel$Aspect$Utility$emptyContainer(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex justify-end')
								]),
							hashRateElOnly(
								liveHashrate(0))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('border-t border-gray-600 pt-1.5 flex justify-between items-last-baseline')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-12 text-gray-400')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(secondaryHashrateLabel)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex items-baseline justify-end')
										]),
									compactHashRateElOnly(secondaryHashrate))
								]))
						]))
				]))) : A4(
		$author$project$UI$Library$DashboardInfoSquares$square,
		'bg-dmnd-red-1',
		'WELCOME BACK',
		$elm$html$Html$text(''),
		$author$project$Kernel$Aspect$Utility$emptyContainer(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-center items-center h-full text-white')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							(isWatcher && (remote.az.d1 === 2)) ? 'No access' : ((isWatcher && (!remote.az.d1)) ? 'Loading...' : ''))
						]))
				])));
	var breakdown = function () {
		if (!$author$project$Remote$Model$canViewSubAccounts(remote)) {
			return $elm_community$html_extra$Html$Extra$nothing;
		} else {
			var _v0 = remote.ex;
			if (_v0.$ === 1) {
				return $elm_community$html_extra$Html$Extra$nothing;
			} else {
				return A2($author$project$UI$Library$HashrateDonut$view, topState.eV.iu.iw, slices);
			}
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-row gap-3 font-light')
			]),
		_List_fromArray(
			[liveHashrateSquare, breakdown, connectionInfoSquare, watcherStatsSquare]));
};
var $author$project$UI$ComponentsPreview$View$simpleWideWrap = function (cfg) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('rounded-lg m-2 border-dmnd-green border-0.5 bg-gray p-2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pb-2 text-16 text-dmnd-red-0')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(cfg.bs)
					])),
				cfg.cj
			]));
};
var $author$project$Global$Msg$InputVerifyEmailCode = function (a) {
	return {$: 9, a: a};
};
var $author$project$Global$Model$KYCVerification = {$: 1};
var $author$project$Remote$RequestMsg$ResendEmailVerification = {$: 5};
var $author$project$Remote$RequestMsg$VerifyEmail = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$User$Active = {$: 2};
var $author$project$Types$User$BitcoinAddress = 1;
var $author$project$Types$User$TwoFactorAuthentication = 0;
var $author$project$Types$User$Unverified = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$User$Verified = {$: 1};
var $author$project$Remote$Model$userStatus = function (_v0) {
	var userSessionStatus = _v0.pQ;
	var userHashrate = _v0.dA;
	switch (userSessionStatus.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			var active = userSessionStatus.a.kD;
			var twoFactorSecret = userSessionStatus.a.g0;
			var kycStatus = userSessionStatus.a.mQ;
			var bitcoinAddress = userSessionStatus.a.hl;
			var twoFactorActivated = _Utils_eq(twoFactorSecret, $elm$core$Maybe$Nothing);
			var hasHashrate = function () {
				if (userHashrate.$ === 1) {
					return false;
				} else {
					var hr = userHashrate.a;
					return (hr.n1 > 0) || (hr.ii > 0);
				}
			}();
			var emailVerified = active;
			return $elm$core$Maybe$Just(
				function () {
					var _v2 = _Utils_Tuple3(
						_Utils_Tuple2(twoFactorActivated, kycStatus),
						bitcoinAddress,
						hasHashrate);
					if (!_v2.a.a) {
						var _v3 = _v2.a;
						return $author$project$Types$User$Unverified(0);
					} else {
						if (_v2.b.$ === 1) {
							var _v4 = _v2.a;
							var _v5 = _v2.b;
							return $author$project$Types$User$Unverified(1);
						} else {
							if (_v2.c) {
								var _v6 = _v2.a;
								return $author$project$Types$User$Active;
							} else {
								var _v7 = _v2.a;
								return $author$project$Types$User$Verified;
							}
						}
					}
				}());
	}
};
var $author$project$UI$Library$TopSection$topSection = function (topState) {
	var verifyInput = A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('01'),
				$elm$html$Html$Attributes$class('bg-dmnd-black border border-dmnd-lighter-gray focus:border-dmnd-red-1 focus:outline-none border-0.25 p-1'),
				$elm$html$Html$Attributes$placeholder('Verification code'),
				$elm$html$Html$Attributes$value(topState.eV.me.kp),
				$elm$html$Html$Events$onInput(
				A2($elm$core$Basics$composeL, $author$project$TopMsg$globalMsg, $author$project$Global$Msg$InputVerifyEmailCode))
			]),
		_List_Nil);
	var verifyButton = $author$project$UI$Library$Button$button(
		$author$project$UI$Library$Button$Green(
			{
				A: $elm$html$Html$text('Verify'),
				cG: $author$project$TopMsg$requestMsg(
					$author$project$Remote$RequestMsg$VerifyEmail(topState.eV.me.kp))
			}));
	var userStatus = $author$project$Remote$Model$userStatus(topState.eV.jr);
	var twoFactorActivateButton = $author$project$UI$Library$Button$button(
		$author$project$UI$Library$Button$GreenInline(
			{
				A: $elm$html$Html$text('activate'),
				cG: $author$project$TopMsg$globalMsg(
					$author$project$Global$Msg$ShowModal(
						A2($author$project$Global$Model$TwoFactorActivation, false, '')))
			}));
	var token = function () {
		var _v5 = topState.eV.jr.pQ;
		if (_v5.$ === 2) {
			var session = _v5.a;
			return session.g_;
		} else {
			return '';
		}
	}();
	var resendButton = (topState.eV.me.dn > 0) ? $author$project$UI$Library$Button$button(
		$author$project$UI$Library$Button$Disabled(
			{
				A: $elm$html$Html$text(
					'ResendEmail ' + (' (' + ($elm$core$String$fromInt(topState.eV.me.dn) + ')')))
			})) : $author$project$UI$Library$Button$button(
		$author$project$UI$Library$Button$Green(
			{
				A: $elm$html$Html$text('Resend Email'),
				cG: $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$ResendEmailVerification)
			}));
	var miningInstructionsButton = $author$project$UI$Library$Button$button(
		$author$project$UI$Library$Button$GreenInline(
			{
				A: $elm$html$Html$text('CONNECT'),
				cG: $author$project$Kernel$RouteMsgs$routeMsg.gu($author$project$Route$Route$Connect)
			}));
	var kycButton = $author$project$UI$Library$Button$button(
		$author$project$UI$Library$Button$GreenInline(
			{
				A: $elm$html$Html$text('here'),
				cG: $author$project$TopMsg$globalMsg(
					$author$project$Global$Msg$ShowModal($author$project$Global$Model$KYCVerification))
			}));
	var addBitcoinAddressButton = $author$project$UI$Library$Button$button(
		$author$project$UI$Library$Button$Green(
			{
				A: $elm$html$Html$text('Add'),
				cG: $author$project$TopMsg$globalMsg(
					$author$project$Global$Msg$ShowModal(
						A3($author$project$Global$Model$UpdateBitcoinAddressModal, '', '', $elm$core$Maybe$Nothing)))
			}));
	var status = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-1')
			]),
		function () {
			if (!userStatus.$) {
				switch (userStatus.a.$) {
					case 0:
						if (!userStatus.a.a) {
							var _v1 = userStatus.a.a;
							return _List_fromArray(
								[
									$elm$html$Html$text('We will need you to '),
									twoFactorActivateButton,
									$elm$html$Html$text(' two factor authentication.')
								]);
						} else {
							var _v2 = userStatus.a.a;
							return _List_fromArray(
								[
									$elm$html$Html$text('One last step before mining: please add your bitcoin address '),
									addBitcoinAddressButton
								]);
						}
					case 1:
						var _v3 = userStatus.a;
						return _List_Nil;
					default:
						var _v4 = userStatus.a;
						return _List_fromArray(
							[
								$elm$html$Html$text('Hashing smoothly.')
							]);
				}
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$text('How earth did we get here? Please logout and login again, and if that doesn\'t work, contact support at info@dmnd.work')
					]);
			}
		}());
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-full pb-3')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-top-section bg-contain bg-repeat min-h-10 p-2 text-light flex-col text-16 flex flex-col justify-between')
					]),
				_List_fromArray(
					[status]))
			]));
};
var $author$project$UI$ComponentsPreview$View$view = function (topState) {
	var routeBtn = F3(
		function (needsAuth, label, route) {
			return $author$project$Kernel$UI$Button$button(
				{
					hA: 'whitespace-nowrap text-20 text-left',
					A: $elm$html$Html$text(label),
					iJ: $author$project$Kernel$UI$Button$Button(
						$author$project$Kernel$RouteMsgs$routeMsg.gu(route))
				});
		});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-dmnd-almost-black text-white')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h1')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Demand Components')
					])),
				$author$project$UI$ComponentsPreview$View$simpleWideWrap(
				{
					cj: A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col gap-1')
							]),
						_List_fromArray(
							[
								A3(routeBtn, false, 'Home', $author$project$Route$Route$Home),
								A3(routeBtn, false, 'Payouts', $author$project$Route$Route$Payouts),
								A3(
								routeBtn,
								false,
								'Login',
								$author$project$Route$Route$Authentication($author$project$UI$Auth$Route$Login)),
								$author$project$Kernel$UI$Button$button(
								{
									hA: 'whitespace-nowrap text-20 text-left',
									A: $elm$html$Html$text('Test authenticated request'),
									iJ: $author$project$Kernel$UI$Button$Button(
										$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$UserHashrate))
								})
							])),
					bs: 'Views'
				}),
				$author$project$UI$ComponentsPreview$View$simpleWideWrap(
				{
					cj: $author$project$UI$Library$Sidebar$sidebar(topState),
					bs: 'Menu'
				}),
				$author$project$UI$ComponentsPreview$View$simpleWideWrap(
				{
					cj: $author$project$UI$Library$TopSection$topSection(topState),
					bs: 'Top Section'
				}),
				$author$project$UI$ComponentsPreview$View$simpleWideWrap(
				{
					cj: A2($author$project$UI$Library$MainPageWrapper$mainPageWrapper, topState, $elm_community$html_extra$Html$Extra$nothing),
					bs: 'Main Page Wrapper'
				}),
				$author$project$UI$ComponentsPreview$View$simpleWideWrap(
				{
					cj: $author$project$UI$Library$DashboardInfoSquares$dashboardInfoSquares(topState),
					bs: 'DashboardInfo Squares'
				})
			]));
};
var $elm$html$Html$article = _VirtualDom_node('article');
var $elm$html$Html$blockquote = _VirtualDom_node('blockquote');
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $author$project$UI$Connect$StartMiningContent$codeBlock = F2(
	function (lang, content) {
		return A2(
			$elm$html$Html$pre,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-gray-100 bg-gray-800 rounded-md py-3 px-4 my-2 text-sm font-mono overflow-x-auto whitespace-pre-wrap break-all')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$code,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('language-' + (lang + ' text-gray-200'))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(content)
						]))
				]));
	});
var $elm$html$Html$details = _VirtualDom_node('details');
var $elm$html$Html$header = _VirtualDom_node('header');
var $elm$html$Html$mark = _VirtualDom_node('mark');
var $author$project$UI$Connect$StartMiningContent$highlightGray = function (str) {
	return A2(
		$elm$html$Html$mark,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-transparent text-gray-400 font-semibold')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $author$project$UI$Connect$StartMiningContent$highlightRed = function (str) {
	return A2(
		$elm$html$Html$mark,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-transparent text-[#d44c47] font-semibold')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $author$project$UI$Connect$StartMiningContent$inlineCode = function (content) {
	return A2(
		$elm$html$Html$code,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-gray-100 bg-gray-800 rounded-sm text-[#eb5757] text-[85%] font-mono')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(content)
			]));
};
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $author$project$UI$Connect$StartMiningContent$styledLink = F2(
	function (url, textContent) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(url),
					$elm$html$Html$Attributes$class('text-dmnd-green underline hover:text-dmnd-red-1'),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(textContent)
				]));
	});
var $elm$html$Html$summary = _VirtualDom_node('summary');
var $author$project$UI$Connect$StartMiningContent$startMiningContentView = function (topState) {
	return A2(
		$elm$html$Html$article,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('19844f4a-23ef-80e8-a775-cc03c85cb575'),
				$elm$html$Html$Attributes$class('font-sans text-gray-700 dark:text-gray-300 mx-auto my-8 leading-relaxed p-4 md:p-2 text-16')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$header,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-3xl md:text-4xl font-bold mt-0 mb-4 tracking-tight text-white')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('How to Start Mining with Demand')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('whitespace-pre-wrap')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('1b244f4a-23ef-80b2-9fbe-faf8906eea69')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Welcome to the DMND Pool guide. DMND pool requires the use of a Translator Proxy Server (TPS). The TPS translates your miners messages from StratumV1 (SV1) to StratumV2 (SV2). More information on TPS and StratumV2 can be found in the FAQ below. This guide will walk you through creating an account and setting up the TPS to start mining with DMND. The process is simple, and we’ll guide you step by step.')
							])),
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('19844f4a-23ef-80ec-8d1d-de61036abe24'),
								$elm$html$Html$Attributes$class('text-2xl md:text-3xl font-semibold mt-3 mb-3 tracking-tight text-gray-900 text-white')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Setup the proxy')
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('1ce44f4a-23ef-8055-be32-dec9cb87955a')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Now that you have your account and token, let’s set up the proxy and start mining. The proxy client acts as a bridge between your miner and the pool. Think of it like this:')
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('19844f4a-23ef-80e5-a339-e04d4b43630d'),
								$elm$html$Html$Attributes$class('font-mono py-2 text-gray-400')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Your miner ———> ProxyClient ———> Pool.')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$blockquote,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('1ce44f4a-23ef-8096-ab45-c6b5aa54ed27'),
										$elm$html$Html$Attributes$class('px-2 py-2 bg-gray-50 bg-gray-800/50 text-gray-400 rounded-r-md')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Setup overview:')
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$id('1ce44f4a-23ef-8097-aa0a-e25ad2b43406'),
												$elm$html$Html$Attributes$class('my-1')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('✅ To mine without Job declaration → Set '),
												$author$project$UI$Connect$StartMiningContent$inlineCode('TOKEN'),
												$elm$html$Html$text(' and pool address, then start '),
												$author$project$UI$Connect$StartMiningContent$inlineCode('proxyclient'),
												$elm$html$Html$text('.')
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$id('1ce44f4a-23ef-8003-9a0d-d1ed1dfeaa34'),
												$elm$html$Html$Attributes$class('my-1')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('✅ To mine with Job declaration → Run a patched Bitcoin node, set '),
												$author$project$UI$Connect$StartMiningContent$inlineCode('TOKEN'),
												$elm$html$Html$text(', pool address and '),
												$author$project$UI$Connect$StartMiningContent$inlineCode('TP_ADDRESS'),
												$elm$html$Html$text(', then start '),
												$author$project$UI$Connect$StartMiningContent$inlineCode('proxyclient'),
												$elm$html$Html$text('.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('1ce44f4a-23ef-8071-8d48-c4174209aacd'),
								$elm$html$Html$Attributes$class('mt-1-important')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Now, let\'s go through the setup step by step.')
							])),
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('1ce44f4a-23ef-8075-b426-ef9afcabf805'),
								$elm$html$Html$Attributes$class('text-xl md:text-2xl font-semibold mt-2 mb-0 tracking-tight text-white')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Step 1: Get ')
									])),
								$author$project$UI$Connect$StartMiningContent$inlineCode('proxyclient'),
								$elm$html$Html$text(' (demand-cli)')
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('19844f4a-23ef-8086-9b4a-f736eee264e0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('To get the proxy, you have two options:')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$details,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$summary,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-semibold cursor-pointer list-item text-gray-100 hover:text-dmnd-green')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Option 1: Download the binaries')
													]))
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('list-disc pl-6 mt-2 space-y-1 text-gray-300')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Download binaries for your OS '),
														A2($author$project$UI$Connect$StartMiningContent$styledLink, 'https://github.com/demand-open-source/demand-cli/releases', 'here'),
														$elm$html$Html$text('.')
													]))
											]))
									])),
								A2(
								$elm$html$Html$details,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$summary,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-semibold cursor-pointer list-item text-gray-100 hover:text-dmnd-green')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Option 2: Build it yourself')
													]))
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('list-disc pl-6 mt-2 space-y-2 text-gray-300')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Install Rust: '),
														A2($author$project$UI$Connect$StartMiningContent$styledLink, 'https://www.rust-lang.org/tools/install', 'Rust'),
														$elm$html$Html$text('.')
													])),
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Clone the repo:'),
														A2($author$project$UI$Connect$StartMiningContent$codeBlock, 'Bash', 'git clone https://github.com/demand-open-source/demand-cli.git')
													])),
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Build the binary'),
														A2($author$project$UI$Connect$StartMiningContent$codeBlock, 'Bash', 'cd demand-cli\ncargo build --release')
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('19844f4a-23ef-8090-b384-fef3dd69cf2a'),
								$elm$html$Html$Attributes$class('text-xl md:text-2xl font-semibold mt-3 tracking-tight text-white')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Step 2 (Optional): Set up Bitcoin Node as Template Provider')
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('19844f4a-23ef-80f8-a5b4-e9da16257879')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('If you want to declare your own mining jobs, you’ll need to run a patched Bitcoin node (Sjors patched bitcoind), otherwise the pool will send you mining jobs.')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$details,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$summary,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-semibold cursor-pointer list-item text-gray-100 hover:text-dmnd-green')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Download the Patched Bitcoin Node')
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('list-disc pl-6 mt-2 space-y-1 text-gray-300')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Get it here: '),
														A2($author$project$UI$Connect$StartMiningContent$styledLink, 'https://github.com/Sjors/bitcoin/releases/tag/sv2-tp-0.1.14', 'Bitcoin SV2 TP Release')
													])),
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Scroll down, click '),
														$author$project$UI$Connect$StartMiningContent$highlightGray('Assets'),
														$elm$html$Html$text(', and download the correct version for your system.')
													])),
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Follow the '),
														A2($author$project$UI$Connect$StartMiningContent$styledLink, 'https://github.com/Sjors/bitcoin/tree/sv2/doc', 'this guide'),
														$elm$html$Html$text(' to install')
													]))
											]))
									])),
								A2(
								$elm$html$Html$details,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$summary,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-semibold cursor-pointer list-item text-gray-100 hover:text-dmnd-green')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Start the node in SV2 Mode')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pl-6 mt-2 space-y-2 text-gray-300')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Run this command to start the Bitcoin node in '),
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('SV2 mode')
															])),
														$elm$html$Html$text(':')
													])),
												A2($author$project$UI$Connect$StartMiningContent$codeBlock, 'Bash', 'bitcoind -sv2 -sv2port=8442 -sv2bind=0.0.0.0 -sv2interval=10 -sv2feedelta=200000'),
												A2(
												$elm$html$Html$h3,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-lg font-semibold mt-4 mb-1 text-gray-100')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('What do these options mean?')
															]))
													])),
												A2(
												$elm$html$Html$ul,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('list-disc pl-5 space-y-1')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																$author$project$UI$Connect$StartMiningContent$inlineCode('sv2port=8442'),
																$elm$html$Html$text(' → The port where the node will accept mining requests.')
															])),
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																$author$project$UI$Connect$StartMiningContent$inlineCode('sv2bind=0.0.0.0'),
																$elm$html$Html$text(' → Allows connections from any computer.')
															])),
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																$author$project$UI$Connect$StartMiningContent$inlineCode('sv2interval=10'),
																$elm$html$Html$text(' → Sends a new mining template every 10 seconds if no better one appears.')
															])),
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																$author$project$UI$Connect$StartMiningContent$inlineCode('sv2feedelta=200000'),
																$elm$html$Html$text(' → Sends a new template if the fees increase by at least 2'),
																A2(
																$elm$html$Html$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('00,000 satoshis')
																	])),
																$elm$html$Html$text('.')
															]))
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mt-3')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('If you want to see detailed logs, add this:')
													])),
												A2($author$project$UI$Connect$StartMiningContent$codeBlock, 'Shell', '-debug=sv2 -loglevel=sv2:trace')
											]))
									]))
							])),
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('19844f4a-23ef-80d2-86b3-c7ada558b161'),
								$elm$html$Html$Attributes$class('text-xl md:text-2xl font-semibold mt-3 tracking-tight text-white')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Start Mining ! ')
									])),
								$elm$html$Html$text('🚀')
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('19844f4a-23ef-80fc-bcd0-ea22ece1daa0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Now, run the binaries:')
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('19844f4a-23ef-80f6-b5dc-fb8c0e3b3079')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('If you downloaded the binary from the release page the command is')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('my-2')
							]),
						_List_fromArray(
							[
								A2($author$project$UI$Connect$StartMiningContent$codeBlock, 'Bash', './demand-cli-<OS> --test --token <your-token> --test-pool general-pool.dmnd.work:20000 -d 50T --delay 540'),
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list-disc pl-5 mt-1 space-y-1 text-gray-300')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Replace '),
												$author$project$UI$Connect$StartMiningContent$highlightRed('<OS>'),
												$elm$html$Html$text(' with linux, mac or windows.exe depending on your OS')
											]))
									])),
								A2(
								$elm$html$Html$details,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$summary,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-semibold cursor-pointer list-item text-gray-100 hover:text-dmnd-green')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Optional (only if you run your own node):')
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pl-6 mt-2 space-y-2 text-gray-300')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$ul,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('list-disc pl-5 space-y-1')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																$author$project$UI$Connect$StartMiningContent$inlineCode('TP_ADDRESS'),
																$elm$html$Html$text(' → The address of your Bitcoin node (set up in Step 3).')
															])),
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('If the node is on '),
																A2(
																$elm$html$Html$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('the same machine')
																	])),
																$elm$html$Html$text(', add to the command:')
															]))
													])),
												A2($author$project$UI$Connect$StartMiningContent$codeBlock, 'Bash', '--tp_address 127.0.0.1:8442'),
												A2(
												$elm$html$Html$ul,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('list-disc pl-5 space-y-1 mt-2')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('If it\'s on '),
																A2(
																$elm$html$Html$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('another machine')
																	])),
																$elm$html$Html$text(', use its IP instead of '),
																$author$project$UI$Connect$StartMiningContent$inlineCode('127.0.0.1'),
																$elm$html$Html$text('.')
															]))
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mt-3')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('This tells the proxyclient to use your node for job declaration.')
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('1d044f4a-23ef-8011-bf9a-c1b3e99fdc32'),
								$elm$html$Html$Attributes$class('mt-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('If you built the binaries from source the command is:')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('my-2')
							]),
						_List_fromArray(
							[
								A2($author$project$UI$Connect$StartMiningContent$codeBlock, 'Bash', './target/release/demand-cli --test --token <your-token> --test-pool general-pool.dmnd.work:20000 -d 50T --delay 540')
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('list-disc pl-6 space-y-2 my-4 text-gray-300')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('The proxy listens for connections on '),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('port 32767')
											])),
										$elm$html$Html$text('.')
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Connect your sv1 mining downstream (miner) or your own proxy (if any) to '),
										$author$project$UI$Connect$StartMiningContent$highlightRed('0.0.0.0:32767'),
										$elm$html$Html$text(' and start mining!')
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray-100')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Options:')
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('list-[circle] pl-5 mt-1 space-y-1')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$UI$Connect$StartMiningContent$highlightRed('—test'),
														$elm$html$Html$text(': Connects to test endpoint.')
													])),
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$UI$Connect$StartMiningContent$highlightRed('--test-pool'),
														$elm$html$Html$text(': Sets the test pool address')
													])),
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$UI$Connect$StartMiningContent$highlightRed('-d'),
														$elm$html$Html$text(': Specifies the expected downstream hashrate. Use formats like 10T (10 Terahash), 2.5P (2.5 Petahash), or 5E (5 Exahash). Defaults to 100 TH/s if not provided.'),
														A2(
														$elm$html$Html$ul,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('list-[square] pl-5 mt-1 space-y-1')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$author$project$UI$Connect$StartMiningContent$highlightRed('-d '),
																		$elm$html$Html$text(' stands for the hashrate of individual miner if connecting devices directly to the proxy (e.g., '),
																		$author$project$UI$Connect$StartMiningContent$highlightRed('-d'),
																		$elm$html$Html$text(' 50T for a miner with 50 TH/s).')
																	])),
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$author$project$UI$Connect$StartMiningContent$highlightRed('-d '),
																		$elm$html$Html$text(' stands for aggregate hashrate when using a hashrate aggregator before the proxy.')
																	]))
															]))
													])),
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$UI$Connect$StartMiningContent$highlightRed('--loglevel'),
														$elm$html$Html$text(', '),
														$author$project$UI$Connect$StartMiningContent$highlightRed('-l'),
														$elm$html$Html$text(': Sets the logging level for the application. Accepts values like trace, debug, warn, info and error. Defaults to info if not provided.')
													])),
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$UI$Connect$StartMiningContent$highlightRed('--nc'),
														$elm$html$Html$text(', '),
														$author$project$UI$Connect$StartMiningContent$highlightRed('-n'),
														$elm$html$Html$text(': Enables or disables noise connection logging for debugging purposes. Use on to enable or off to disable. Defaults to off if not provided.')
													])),
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$UI$Connect$StartMiningContent$highlightRed('--delay'),
														$elm$html$Html$text(': Sets how long the proxy should wait before starting to update the difficulty. This is especially helpful for miners that take some time to submit their first shares after connecting.')
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('1b244f4a-23ef-80da-9f76-deba5e498fb6')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('For further information on how Stratum V2 works, the Stratum Reference Implementation (SRI) '),
								A2($author$project$UI$Connect$StartMiningContent$styledLink, 'https://stratumprotocol.org/', 'website'),
								$elm$html$Html$text(' has a wealth of information on everything SV2 related.')
							])),
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('1b244f4a-23ef-80c8-a454-ee8c706431dc'),
								$elm$html$Html$Attributes$class('text-2xl md:text-3xl font-semibold mt-3 mb-4 tracking-tight text-white')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('FAQ')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('')
							]),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var q = _v0.a;
								var aHtml = _v0.b;
								return A2(
									$elm$html$Html$details,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-gray-50 bg-gray-800/50 p-4 rounded-lg shadow')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$summary,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('font-semibold cursor-pointer list-item text-gray-100 hover:text-dmnd-green')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$strong,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(q)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pl-6 mt-2 text-gray-300')
												]),
											_List_fromArray(
												[aHtml]))
										]));
							},
							_List_fromArray(
								[
									_Utils_Tuple2(
									'What is StratumV2: ',
									A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Stratum V2 was built from the ground up by a diverse group of FOSS Bitcoin Developers with a focus on security, efficiency, and backwards compatibility. It increases security, makes data transfers more efficient, and reduces mining infrastructure requirements. It also introduces three new sub-protocols that let miners select transaction sets and improve decentralization.')
											]))),
									_Utils_Tuple2(
									'What is Translator Proxy Service?',
									A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('One of the key efforts in the development of Stratum v2 was to make the transition from Stratum V1 to Stratum V2 as easy as possible. This was achieved by standardizing and clarifying the role of the '),
												A2($author$project$UI$Connect$StartMiningContent$styledLink, 'https://stratumprotocol.org/docs/#translation-proxy', 'Translator Proxy Server (TPS)'),
												$elm$html$Html$text('.')
											]))),
									_Utils_Tuple2(
									'Can I run both the proxy and the patched bitcoin node in the same computer?',
									A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Yes.')
											]))),
									_Utils_Tuple2(
									'What are the pc requirements to run both the proxy and the patched bitcoin node?',
									A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('The same as of a regular Bitcoin core node. You can check them out '),
												A2($author$project$UI$Connect$StartMiningContent$styledLink, 'https://bitcoin.org/en/full-node#minimum-requirements', 'here.'),
												$elm$html$Html$text(' Since the patched node doesn’t store the blockchain, there is no need for a hard drive with significant storage space.')
											]))),
									_Utils_Tuple2(
									'Can I use my regular node as a template provider for my workers?',
									A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('No, you will have to use the patched node previously mentioned in this guide.')
											]))),
									_Utils_Tuple2(
									'Does DMND pool have a Stratum V1 endpoint?',
									A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('No, DMND is Stratum V2 only.')
											])))
								])))
					]))
			]));
};
var $author$project$UI$Connect$View$view = function (topState) {
	var token = function () {
		var _v0 = topState.eV.jr.pQ;
		if (_v0.$ === 2) {
			var session = _v0.a;
			return session.g_;
		} else {
			return 'Error fetching token';
		}
	}();
	return A2(
		$author$project$UI$Library$MainPageWrapper$mainPageWrapper,
		topState,
		A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$Library$PageHeader$withSubtitle(
					{o8: 'Point your miner at the pool using the token below.', bs: 'Connect a miner'}),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					(_Utils_eq(
						$author$project$Remote$Model$userStatus(topState.eV.jr),
						$elm$core$Maybe$Just($author$project$Types$User$Verified)) || _Utils_eq(
						$author$project$Remote$Model$userStatus(topState.eV.jr),
						$elm$core$Maybe$Just($author$project$Types$User$Active))) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-20')
								]),
							(token === '') ? _List_fromArray(
								[
									$elm$html$Html$text('Please contact us at info@dmnd.work to get your token.')
								]) : _List_fromArray(
								[
									$elm$html$Html$text('Your token is: '),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-dmnd-green')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(token)
										])),
									$author$project$UI$Library$Button$copyToClipboard(
									{mt: 'p-1 w-5 h-5 inline mb-0.5', pV: token})
								])),
							$author$project$UI$Connect$StartMiningContent$startMiningContentView(topState)
						]) : _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-20')
								]),
							_List_fromArray(
								[
									$author$project$UI$Library$TopSection$topSection(topState),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-4')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Please follow the instructions on top of the screen to verify your account first.')
										]))
								]))
						]))
				])));
};
var $author$project$UI$Connections$View$view = function (topState) {
	return A2(
		$author$project$UI$Library$MainPageWrapper$mainPageWrapper,
		topState,
		A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$Library$PageHeader$withSubtitle(
					{o8: 'Active worker connections to the pool.', bs: 'Connections'})
				])));
};
var $author$project$Remote$RequestMsg$ToggleExportGeneratedBTCModal = {$: 35};
var $author$project$Remote$RequestMsg$DownloadAllGeneratedBTC = {$: 42};
var $author$project$Remote$RequestMsg$ExportGeneratedBTC = {$: 40};
var $author$project$Remote$RequestMsg$ExportGeneratedBTCLastDays = function (a) {
	return {$: 41, a: a};
};
var $author$project$Remote$RequestMsg$SetExportBTCFromDate = function (a) {
	return {$: 38, a: a};
};
var $author$project$Remote$RequestMsg$SetExportBTCToDate = function (a) {
	return {$: 39, a: a};
};
var $author$project$Remote$RequestMsg$ToggleExportBTCCustomRange = {$: 37};
var $author$project$Remote$RequestMsg$ToggleExportBTCQuick = {$: 36};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $author$project$UI$GeneratedBitcoin$View$exportModal = F2(
	function (topState, remote) {
		var sectionToggle = F3(
			function (label, isOpen, msg) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center justify-between w-full text-gray-300 hover:text-white text-12 font-medium cursor-pointer py-2'),
							$elm$html$Html$Events$onClick(
							$author$project$TopMsg$requestMsg(msg))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-500 text-10')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									isOpen ? '▲' : '▼')
								]))
						]));
			});
		var dates = $elm$core$List$sort(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.h0;
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$UI$Library$AccountData$selectedGeneratedBTC(topState))));
		var maxDate = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				$elm$core$List$reverse(dates)));
		var minDate = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(dates));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-gray-800 rounded-lg p-6 shadow-xl w-full max-w-4xl mx-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex justify-between items-center mb-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-white text-16 font-semibold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Export Generated BTC')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-500 hover:text-white cursor-pointer text-14 leading-none'),
											$elm$html$Html$Events$onClick(
											$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$ToggleExportGeneratedBTCModal))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('✕')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('border-t border-gray-700')
								]),
							_List_fromArray(
								[
									A3(sectionToggle, 'Quick export', remote.h7, $author$project$Remote$RequestMsg$ToggleExportBTCQuick),
									remote.h7 ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex gap-2 pb-2 ml-5')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('px-1 py-0.5 bg-gray-700 text-gray-300 text-12 font-medium rounded-full hover:bg-green-400 hover:text-dmnd-black cursor-pointer transition-colors'),
													$elm$html$Html$Events$onClick(
													$author$project$TopMsg$requestMsg(
														$author$project$Remote$RequestMsg$ExportGeneratedBTCLastDays(7)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Last 7d')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('px-1 py-0.5 bg-gray-700 text-gray-300 text-12 font-medium rounded-full hover:bg-green-400 hover:text-dmnd-black cursor-pointer transition-colors'),
													$elm$html$Html$Events$onClick(
													$author$project$TopMsg$requestMsg(
														$author$project$Remote$RequestMsg$ExportGeneratedBTCLastDays(30)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Last 30d')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('px-2 py-0.5 bg-gray-700 text-gray-300 text-12 font-medium rounded-full hover:bg-green-400 hover:text-dmnd-black cursor-pointer transition-colors'),
													$elm$html$Html$Events$onClick(
													$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$DownloadAllGeneratedBTC))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('All data')
												]))
										])) : $elm$html$Html$text('')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('border-t border-gray-700')
								]),
							_List_fromArray(
								[
									A3(sectionToggle, 'Custom date range', remote.h5, $author$project$Remote$RequestMsg$ToggleExportBTCCustomRange),
									remote.h5 ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pb-4')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex gap-4 mb-5')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-col gap-1 flex-1')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-gray-400 text-12')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('From')
																])),
															A2(
															$elm$html$Html$input,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$type_('date'),
																	$elm$html$Html$Attributes$value(remote.h6),
																	$elm$html$Html$Attributes$min(minDate),
																	$elm$html$Html$Attributes$max(remote.h8),
																	$elm$html$Html$Attributes$class('px-2 py-1 bg-gray-900 text-12 text-white border border-gray-600 rounded focus:outline-none focus:ring-1 focus:ring-green-500 w-full'),
																	A2($elm$html$Html$Attributes$style, 'color-scheme', 'dark'),
																	$elm$html$Html$Events$onInput(
																	function (d) {
																		return $author$project$TopMsg$requestMsg(
																			$author$project$Remote$RequestMsg$SetExportBTCFromDate(d));
																	})
																]),
															_List_Nil)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-col gap-1 flex-1')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-gray-400 text-12')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('To')
																])),
															A2(
															$elm$html$Html$input,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$type_('date'),
																	$elm$html$Html$Attributes$value(remote.h8),
																	$elm$html$Html$Attributes$min(remote.h6),
																	$elm$html$Html$Attributes$max(maxDate),
																	$elm$html$Html$Attributes$class('px-2 py-1 bg-gray-900 text-12 text-white border border-gray-600 rounded focus:outline-none focus:ring-1 focus:ring-green-500 w-full'),
																	A2($elm$html$Html$Attributes$style, 'color-scheme', 'dark'),
																	$elm$html$Html$Events$onInput(
																	function (d) {
																		return $author$project$TopMsg$requestMsg(
																			$author$project$Remote$RequestMsg$SetExportBTCToDate(d));
																	})
																]),
															_List_Nil)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex justify-end')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('px-2 py-1 bg-green-400 text-dmnd-black text-12 font-semibold rounded hover:bg-green-500 active:bg-green-400 cursor-pointer'),
															$elm$html$Html$Events$onClick(
															$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$ExportGeneratedBTC))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Download CSV')
														]))
												]))
										])) : $elm$html$Html$text('')
								]))
						]))
				]));
	});
var $author$project$Msg$GeneratedBitcoinDateRangeMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$TopMsg$generatedBitcoinDateRangeMsg = A2($elm$core$Basics$composeL, $author$project$Kernel$Msg$AppMsg, $author$project$Msg$GeneratedBitcoinDateRangeMsg);
var $author$project$Types$Payout$minimumPayout = $author$project$Types$BTC$fromSatoshis(500000);
var $author$project$UI$Library$AccountData$payoutProgressAccount = function (topState) {
	var remote = topState.eV.jr;
	if ($author$project$UI$Library$AccountData$dataScopeIsAggregate(topState)) {
		return $elm$core$Maybe$Nothing;
	} else {
		var _v0 = $author$project$Remote$Model$toUserSession(remote);
		if (!_v0.$) {
			var session = _v0.a;
			return $elm$core$Maybe$Just(
				{hX: remote.mb, aJ: 'Main account'});
		} else {
			return A2(
				$elm$core$Maybe$map,
				function (_v1) {
					return {hX: remote.mb, aJ: 'Account'};
				},
				remote.p1);
		}
	}
};
var $author$project$Types$Payout$payoutWindowDays = 30;
var $author$project$Types$Payout$earningsInPayoutWindow = F2(
	function (now, entries) {
		var windowStart = $author$project$UI$Util$currentDateString(
			$elm$time$Time$millisToPosix(
				function (millis) {
					return millis - ((((($author$project$Types$Payout$payoutWindowDays - 1) * 24) * 60) * 60) * 1000);
				}(
					$elm$time$Time$posixToMillis(now))));
		var windowEnd = $author$project$UI$Util$currentDateString(now);
		return A2(
			$elm$core$List$filter,
			function (entry) {
				return (_Utils_cmp(entry.h0, windowStart) > -1) && (_Utils_cmp(entry.h0, windowEnd) < 1);
			},
			entries);
	});
var $author$project$Types$GeneratedBTC$fppsEarnings = function (entries) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (entry, accumulated) {
				return A3(
					$elm$core$Maybe$map2,
					F2(
						function (amount, rest) {
							return A2(
								$elm$core$List$cons,
								{h0: entry.h0, fn: amount},
								rest);
						}),
					entry.fn,
					accumulated);
			}),
		$elm$core$Maybe$Just(_List_Nil),
		entries);
};
var $author$project$Types$Payout$unpaidBalance = F3(
	function (now, entries, payouts) {
		var addToDay = F2(
			function (day, satoshis) {
				return A2(
					$elm$core$Dict$update,
					day,
					function (maybeTotal) {
						return $elm$core$Maybe$Just(
							A2($elm$core$Maybe$withDefault, 0, maybeTotal) + satoshis);
					});
			});
		var generatedByDay = A3(
			$elm$core$List$foldl,
			F2(
				function (entry, totals) {
					return A3(
						addToDay,
						entry.h0,
						$author$project$Types$BTC$toSatoshis(entry.fn),
						totals);
				}),
			$elm$core$Dict$empty,
			A2($author$project$Types$Payout$earningsInPayoutWindow, now, entries));
		var ledgerByDay = A3(
			$elm$core$List$foldl,
			F2(
				function (payout, totals) {
					return A3(
						addToDay,
						$author$project$Types$Payout$payoutDate(payout),
						-$author$project$Types$BTC$toSatoshis(payout.dG),
						totals);
				}),
			generatedByDay,
			A2(
				$elm$core$List$filter,
				function (payout) {
					return payout.iJ === 1;
				},
				payouts));
		var currentBalance = A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, balance) {
					var dailyNet = _v0.b;
					return A2($elm$core$Basics$max, 0, balance + dailyNet);
				}),
			0,
			A2(
				$elm$core$List$sortBy,
				$elm$core$Tuple$first,
				$elm$core$Dict$toList(ledgerByDay)));
		return $author$project$Types$BTC$fromSatoshis(currentBalance);
	});
var $author$project$Types$Payout$progressForAccount = F3(
	function (now, account, payouts) {
		return A2(
			$elm$core$Maybe$map,
			function (entries) {
				return A3($author$project$Types$Payout$unpaidBalance, now, entries, payouts);
			},
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Types$GeneratedBTC$fppsEarnings,
				A2(
					$elm$core$Maybe$map,
					$author$project$Types$Payout$earningsInPayoutWindow(now),
					account.hX)));
	});
var $author$project$UI$GeneratedBitcoin$View$payoutProgress = function (topState) {
	var remote = topState.eV.jr;
	var progressBar = function (balance) {
		var thresholdSatoshis = $author$project$Types$BTC$toSatoshis($author$project$Types$Payout$minimumPayout);
		var balanceSatoshis = $author$project$Types$BTC$toSatoshis(balance);
		var progressPercent = A2($elm$core$Basics$min, 100, (100 * balanceSatoshis) / thresholdSatoshis);
		var remaining = $author$project$Types$BTC$fromSatoshis(
			A2($elm$core$Basics$max, 0, thresholdSatoshis - balanceSatoshis));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-10 text-gray-400')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Types$BTC$toString(balance) + (' / ' + ($author$project$Types$BTC$toString($author$project$Types$Payout$minimumPayout) + ' BTC')))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-1 h-1 w-full overflow-hidden rounded-full bg-gray-800')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-full rounded-full bg-dmnd-green transition-all'),
									A2(
									$elm$html$Html$Attributes$style,
									'width',
									$elm$core$String$fromFloat(progressPercent) + '%'),
									A2($elm$html$Html$Attributes$attribute, 'role', 'progressbar'),
									A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Progress toward minimum payout'),
									A2($elm$html$Html$Attributes$attribute, 'aria-valuemin', '0'),
									A2(
									$elm$html$Html$Attributes$attribute,
									'aria-valuemax',
									$elm$core$String$fromInt(thresholdSatoshis)),
									A2(
									$elm$html$Html$Attributes$attribute,
									'aria-valuenow',
									$elm$core$String$fromInt(
										A2($elm$core$Basics$min, balanceSatoshis, thresholdSatoshis)))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-1 text-10 text-gray-400')
						]),
					_List_fromArray(
						[
							(_Utils_cmp(balanceSatoshis, thresholdSatoshis) > -1) ? $elm$html$Html$text('Minimum payout threshold reached. Payouts are made daily at 07:00 AM CET.') : A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-semibold text-dmnd-green')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Types$BTC$toString(remaining) + ' BTC')
										])),
									$elm$html$Html$text(' more needed before next payout')
								]))
						]))
				]));
	};
	var mayViewPayouts = $author$project$Remote$Model$isUserAuthenticated(remote) || $author$project$Remote$Model$watcherMayViewPayouts(remote);
	var isRefreshing = $author$project$Remote$Model$payoutsAreLoading(remote) || A2($author$project$Remote$Model$isRequestAlreadyOngoing, remote, $author$project$Remote$RequestMsg$GeneratedBTC);
	var unavailable = A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-10 text-gray-400')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				isRefreshing ? 'Refreshing...' : '')
			]));
	var expectedPayoutContext = function () {
		var _v2 = $author$project$Remote$Model$toUserSession(remote);
		if (!_v2.$) {
			var session = _v2.a;
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Types$Payout$UserPayoutContext,
					$author$project$Types$User$unwrapUserId(session.mu),
					false));
		} else {
			return A2(
				$elm$core$Maybe$map,
				function (session) {
					return A2($author$project$Types$Payout$WatcherPayoutContext, session.g4, session.g_);
				},
				$author$project$Remote$Model$toWatcherSession(remote));
		}
	}();
	var hasCachedPayouts = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (context) {
				return _Utils_eq(
					remote.nQ,
					$elm$core$Maybe$Just(context)) && (!_Utils_eq(remote.mV, $elm$core$Maybe$Nothing));
			},
			expectedPayoutContext));
	var accountWidget = function (account) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-72 text-right')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-1 break-all text-10 text-gray-400')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(account.aJ)
						])),
					function () {
					var _v1 = A3($author$project$Types$Payout$progressForAccount, topState.ph, account, remote.ek);
					if (!_v1.$) {
						var balance = _v1.a;
						return progressBar(balance);
					} else {
						return unavailable;
					}
				}()
				]));
	};
	if ((!mayViewPayouts) || $author$project$UI$Library$AccountData$dataScopeIsAggregate(topState)) {
		return $elm$html$Html$text('');
	} else {
		var _v0 = _Utils_Tuple2(
			$author$project$UI$Library$AccountData$payoutProgressAccount(topState),
			hasCachedPayouts);
		if ((!_v0.a.$) && _v0.b) {
			var account = _v0.a.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col items-end gap-3')
					]),
				_List_fromArray(
					[
						accountWidget(account),
						isRefreshing ? A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-10 text-gray-500')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Refreshing...')
							])) : $elm$html$Html$text('')
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-72 text-right')
					]),
				_List_fromArray(
					[unavailable]));
		}
	}
};
var $author$project$Kernel$Aspect$Utility$nbsp = '\u00A0';
var $author$project$UI$Library$RewardsInfoSquares$rewardsInfoSquares = function (topState) {
	var rewardsSummary = topState.eV.jr.gr;
	var bitcoinReward = F2(
		function (satsText, unitText) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-baseline')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-50')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								_Utils_ap(satsText, $author$project$Kernel$Aspect$Utility$nbsp))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-16')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(unitText)
							]))
					]));
		});
	var rowForGraySquare = F3(
		function (titleText, largeText, smallText) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-row justify-between items-baseline w-full max-w-85')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-16 ')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(titleText)
							])),
						A2(bitcoinReward, largeText, smallText)
					]));
		});
	if (!rewardsSummary.$) {
		var rewardsGeneralDataValue = rewardsSummary.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-row gap-3')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$Library$DashboardInfoSquares$square,
					'bg-dmnd-green text-dmnd-black',
					'TODAY\'S MINING REWARDS',
					$elm_community$html_extra$Html$Extra$nothing,
					$author$project$Kernel$Aspect$Utility$emptyContainer(
						_List_fromArray(
							[
								A2(
								bitcoinReward,
								$author$project$Types$BTC$toString(rewardsGeneralDataValue.py),
								'BTC')
							]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-41.5 flex-1 p-3 flex flex-col justify-between text-white bg-dmnd-gray ')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col justify-between items-baseline')
								]),
							_List_fromArray(
								[
									A3(
									rowForGraySquare,
									'YESTERDAY’S TOTAL REWARD',
									$author$project$Types$BTC$toString(rewardsGeneralDataValue.qj),
									'BTC'),
									A3(
									rowForGraySquare,
									'ESTABLISHED PROFITABILITY',
									$author$project$Types$BTC$toString(rewardsGeneralDataValue.lX),
									'BTC'),
									A3(
									rowForGraySquare,
									'ALL TIME REWARD',
									$author$project$Types$BTC$toString(rewardsGeneralDataValue.kF),
									'BTC'),
									A3(rowForGraySquare, 'REWARD SCHEME', 'SLICE', '(FEE 0%)')
								]))
						]))
				]));
	} else {
		return $elm_community$html_extra$Html$Extra$nothing;
	}
};
var $author$project$UI$Library$DateRangePicker$Last30Days = 2;
var $author$project$UI$Library$DateRangePicker$Last7Days = 1;
var $author$project$UI$Library$DateRangePicker$presetLabel = function (preset) {
	switch (preset) {
		case 0:
			return 'All data';
		case 1:
			return 'Last 7 days';
		case 2:
			return 'Last 30 days';
		default:
			return 'Custom';
	}
};
var $author$project$UI$Library$DateRangePicker$defaultPresets = _List_fromArray(
	[
		_Utils_Tuple2(
		0,
		$author$project$UI$Library$DateRangePicker$presetLabel(0)),
		_Utils_Tuple2(
		1,
		$author$project$UI$Library$DateRangePicker$presetLabel(1)),
		_Utils_Tuple2(
		2,
		$author$project$UI$Library$DateRangePicker$presetLabel(2))
	]);
var $author$project$UI$Library$DateRangePicker$Close = {$: 1};
var $author$project$UI$Library$DateRangePicker$SelectPreset = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$Library$DateRangePicker$SetFromDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$Library$DateRangePicker$SetToDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$UI$Library$DateRangePicker$ToggleOpen = {$: 0};
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $author$project$UI$Library$DateRangePicker$closeIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$width('12'),
			$elm$svg$Svg$Attributes$height('12'),
			$elm$svg$Svg$Attributes$class('h-3 w-3'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M6 6l12 12M18 6L6 18'),
					$elm$svg$Svg$Attributes$stroke('currentColor'),
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeWidth('2')
				]),
			_List_Nil)
		]));
var $author$project$UI$Library$DateRangePicker$filterIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$width('12'),
			$elm$svg$Svg$Attributes$height('12'),
			$elm$svg$Svg$Attributes$class('h-3 w-3'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M4 6h16l-6.25 7.1v4.15L10.25 19v-5.9L4 6Z'),
					$elm$svg$Svg$Attributes$fill('currentColor')
				]),
			_List_Nil)
		]));
var $author$project$Kernel$UI$Eventfull$Eventfull$onClickAwayEmitter = function (msg) {
	return A2(
		$author$project$Kernel$Aspect$Utility$onLocal,
		'clickAway',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Kernel$UI$Eventfull$Eventfull$onClickAway = F2(
	function (isActive, msg) {
		return A2(
			$elm$core$List$cons,
			A2($elm$html$Html$Attributes$attribute, 'emit-click-away', ''),
			A2(
				$elm$core$List$cons,
				$author$project$Kernel$UI$Eventfull$Eventfull$onClickAwayEmitter(msg),
				A3(
					$author$project$Kernel$Aspect$Utility$ifElse,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'emit-click-away-active', '')
						]),
					_List_Nil,
					isActive)));
	});
var $author$project$UI$Library$DateRangePicker$viewWithPresets = F2(
	function (presets, config) {
		var selectedPresetLabel = A2(
			$elm$core$Maybe$withDefault,
			$author$project$UI$Library$DateRangePicker$presetLabel(config.ni.au),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(config.ni.au)),
						presets))));
		var triggerButton = function () {
			var triggerClass = config.ni.aS ? 'inline-flex h-5 items-center gap-1.5 rounded border border-gray-500 bg-gray-800 px-2 text-10 text-white hover:border-gray-400 disabled:opacity-50' : 'inline-flex h-5 items-center gap-1 rounded border border-gray-700 bg-gray-900 px-1 text-10 text-gray-300 hover:border-gray-500 hover:text-white disabled:opacity-50';
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Attributes$class(triggerClass),
						$elm$html$Html$Events$onClick(
						config.b6($author$project$UI$Library$DateRangePicker$ToggleOpen))
					]),
				_List_fromArray(
					[
						$author$project$UI$Library$DateRangePicker$filterIcon,
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-medium')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Filter ')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-gray-500')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(selectedPresetLabel)
							]))
					]));
		}();
		var quickRangeRow = F2(
			function (preset, labelText) {
				var isActive = _Utils_eq(config.ni.au, preset);
				var buttonClass = isActive ? 'flex h-6 w-full items-center justify-between px-2 text-left text-12 font-medium text-dmnd-green' : 'flex h-6 w-full items-center justify-between px-2 text-left text-12 text-gray-300 hover:bg-gray-900 hover:text-white';
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class(buttonClass),
							$elm$html$Html$Events$onClick(
							config.b6(
								$author$project$UI$Library$DateRangePicker$SelectPreset(preset)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('whitespace-nowrap')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(labelText)
								])),
							isActive ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-dmnd-green')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('✓')
								])) : $elm$html$Html$text('')
						]));
			});
		var dateInput = F4(
			function (labelText, inputValue, constraints, toInputMsg) {
				return A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-1 text-10 text-gray-500')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('uppercase tracking-wide')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(labelText)
								])),
							A2(
							$elm$html$Html$input,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('date'),
										$elm$html$Html$Attributes$value(inputValue),
										$elm$html$Html$Attributes$class('h-5 w-full min-w-0 rounded border border-gray-700 bg-gray-900 px-2 text-11 text-white focus:outline-none focus:ring-1 focus:ring-green-500'),
										A2($elm$html$Html$Attributes$style, 'color-scheme', 'dark'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, config.b6, toInputMsg))
									]),
								constraints),
							_List_Nil)
						]));
			});
		var _v0 = A3($author$project$UI$Library$DateRangePicker$selectedRangeFor, config.pw, config.ly, config.ni);
		var fromDate = _v0.a;
		var toDate = _v0.b;
		return A3(
			$author$project$Kernel$UI$Eventfull$Eventfull$eventFull,
			_List_fromArray(
				[
					A2(
					$author$project$Kernel$UI$Eventfull$Eventfull$onClickAway,
					config.ni.aS,
					config.b6($author$project$UI$Library$DateRangePicker$Close))
				]),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline-block')
				]),
			_List_fromArray(
				[
					triggerButton,
					config.ni.aS ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fixed inset-y-0 right-0 z-50 flex w-40 flex-col border-l border-gray-800 bg-dmnd-almost-black shadow-2xl')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex h-10 shrink-0 items-center justify-between border-b border-gray-800 px-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex items-center gap-1 text-12 font-semibold text-white')
										]),
									_List_fromArray(
										[
											$author$project$UI$Library$DateRangePicker$filterIcon,
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Filter')
												]))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('inline-flex h-3 w-3 items-center justify-center rounded text-gray-500 hover:bg-gray-900 hover:text-white'),
											A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Close filters'),
											$elm$html$Html$Events$onClick(
											config.b6($author$project$UI$Library$DateRangePicker$Close))
										]),
									_List_fromArray(
										[$author$project$UI$Library$DateRangePicker$closeIcon]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-1 flex-col gap-1 overflow-y-auto px-2 py-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-col gap-2')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-10 uppercase tracking-wide text-gray-600')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Presets')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-col divide-y divide-gray-800 overflow-hidden rounded border border-gray-800')
												]),
											A2(
												$elm$core$List$map,
												function (_v1) {
													var preset = _v1.a;
													var labelText = _v1.b;
													return A2(quickRangeRow, preset, labelText);
												},
												presets))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-col gap-1 border-t border-gray-800 pt-3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-10 uppercase tracking-wide text-gray-600')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Custom range')
												])),
											A4(
											dateInput,
											'From',
											fromDate,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$max(toDate)
												]),
											$author$project$UI$Library$DateRangePicker$SetFromDate),
											A4(
											dateInput,
											'To',
											toDate,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$min(fromDate)
												]),
											$author$project$UI$Library$DateRangePicker$SetToDate)
										]))
								]))
						])) : $elm$html$Html$text('')
				]));
	});
var $author$project$UI$Library$DateRangePicker$view = $author$project$UI$Library$DateRangePicker$viewWithPresets($author$project$UI$Library$DateRangePicker$defaultPresets);
var $author$project$UI$GeneratedBitcoin$View$view = function (topState) {
	var remote = topState.eV.jr;
	var generatedBTCDates = A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
		A2(
			$elm$core$List$map,
			function ($) {
				return $.h0;
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$author$project$UI$Library$AccountData$selectedGeneratedBTC(topState))));
	var exportBtn = A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-3 py-1.5 bg-green-400 text-dmnd-black text-12 font-semibold rounded-md hover:bg-green-500 active:bg-green-400 cursor-pointer'),
				$elm$html$Html$Events$onClick(
				$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$ToggleExportGeneratedBTCModal))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Export CSV')
			]));
	return A2(
		$author$project$UI$Library$MainPageWrapper$mainPageWrapper,
		topState,
		A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$Library$PageHeader$action(
					{
						k1: exportBtn,
						o8: $elm$core$Maybe$Just('Daily FPPS earnings, rolled up by entry day.'),
						bs: 'Generated BTC'
					}),
					$author$project$UI$Library$AccountData$dataScopeIsAggregate(topState) ? $elm$html$Html$text('') : $author$project$UI$Library$RewardsInfoSquares$rewardsInfoSquares(topState),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-wrap items-end justify-end gap-4')
						]),
					_List_fromArray(
						[
							$author$project$UI$GeneratedBitcoin$View$payoutProgress(topState),
							$author$project$UI$Library$DateRangePicker$view(
							{
								ly: generatedBTCDates,
								ni: topState.eV.im,
								b6: $author$project$TopMsg$generatedBitcoinDateRangeMsg,
								pw: $author$project$UI$Util$currentDateString(topState.ph)
							})
						])),
					remote.jR ? A2($author$project$UI$GeneratedBitcoin$View$exportModal, topState, remote) : $elm$html$Html$text('')
				])));
};
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UI$Library$AccountData$aggregateObservedAt = function (remote) {
	var subHashrates = A2(
		$elm$core$List$map,
		$author$project$UI$Library$AccountData$subAccountHashrate(remote),
		A2($elm$core$Maybe$withDefault, _List_Nil, remote.ex));
	var observedMillis = A2(
		$elm$core$List$filterMap,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.ny;
			},
			$elm$core$Maybe$map($elm$time$Time$posixToMillis)),
		A2(
			$elm$core$List$cons,
			$author$project$UI$Library$AccountData$mainHashrate(remote),
			subHashrates));
	return A2(
		$elm$core$Maybe$map,
		$elm$time$Time$millisToPosix,
		$elm$core$List$maximum(observedMillis));
};
var $author$project$UI$Home$View$aggregateSnapshot = function (topState) {
	var remote = topState.eV.jr;
	var subAccountsHashrate = $author$project$UI$Library$AccountData$subAccountsHashrate(remote);
	var observedText = A2(
		$elm$core$Maybe$withDefault,
		'Waiting for observed timestamp',
		A2(
			$elm$core$Maybe$map,
			function (observedAt) {
				return 'Last observed ' + ($author$project$UI$Util$formatPosix(observedAt) + ' UTC');
			},
			$author$project$UI$Library$AccountData$aggregateObservedAt(remote)));
	var mainHashrate = A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ay;
			},
			remote.dA));
	var hashrateText = function (rawHashrate) {
		return $author$project$Types$Hashrate$toString(
			$author$project$Types$Hashrate$rawHashrateToHashrate(rawHashrate));
	};
	var metric = F2(
		function (label, rawHashrate) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-dmnd-gray p-3 min-h-24 flex flex-col justify-between')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-12 text-gray-400 uppercase')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-24 text-white')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								hashrateText(rawHashrate))
							]))
					]));
		});
	var aggregateHashrate = $author$project$UI$Library$AccountData$aggregateHashrate(remote);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-6 mb-6')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col md:flex-row md:items-center md:justify-between gap-2 mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-16 text-white text-left')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('AGGREGATE HASHRATE')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-12 text-gray-500')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(observedText)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('grid gap-3 md:grid-cols-3')
					]),
				_List_fromArray(
					[
						A2(metric, 'Total', aggregateHashrate.ay),
						A2(metric, 'Main', mainHashrate),
						A2(metric, 'Subaccounts', subAccountsHashrate.ay)
					]))
			]));
};
var $author$project$UI$Library$PageHeader$livenessChip = F3(
	function (level, label, onTap) {
		var baseClasses = 'inline-flex items-center gap-2 px-3 py-1.5 bg-gray-900 border border-gray-800 rounded-full';
		var _v0 = function () {
			switch (level) {
				case 0:
					return _Utils_Tuple2('bg-green-400', 'text-green-300');
				case 1:
					return _Utils_Tuple2('bg-amber-400', 'text-amber-300');
				default:
					return _Utils_Tuple2('bg-gray-500', 'text-gray-400');
			}
		}();
		var dotColor = _v0.a;
		var labelColor = _v0.b;
		var dot = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline-block w-2 h-2 rounded-full ' + dotColor)
				]),
			_List_Nil);
		var body = _List_fromArray(
			[
				dot,
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-12 ' + labelColor)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]))
			]);
		if (!onTap.$) {
			var msg = onTap.a;
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(baseClasses + ' hover:border-gray-600 cursor-pointer'),
						$elm$html$Html$Events$onClick(msg)
					]),
				body);
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(baseClasses)
					]),
				body);
		}
	});
var $author$project$UI$Library$PageHeader$liveness = function (_v0) {
	var title = _v0.bs;
	var subtitle = _v0.o8;
	var level = _v0.m_;
	var label = _v0.mR;
	var onTap = _v0.nF;
	return $author$project$UI$Library$PageHeader$render(
		{
			cO: $elm$core$Maybe$Just(
				A3($author$project$UI$Library$PageHeader$livenessChip, level, label, onTap)),
			o8: $elm$core$Maybe$Just(subtitle),
			bs: title
		});
};
var $author$project$UI$Library$PageHeader$LivenessAttention = 1;
var $author$project$UI$Library$PageHeader$LivenessOk = 0;
var $author$project$UI$Home$View$livenessFor = function (topState) {
	var _v0 = $author$project$Remote$Model$userStatus(topState.eV.jr);
	if (!_v0.$) {
		switch (_v0.a.$) {
			case 2:
				var _v1 = _v0.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(0, 'Hashing smoothly', $elm$core$Maybe$Nothing));
			case 1:
				var _v2 = _v0.a;
				return $elm$core$Maybe$Nothing;
			default:
				if (!_v0.a.a) {
					var _v3 = _v0.a.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(
							1,
							'Set up 2FA',
							$elm$core$Maybe$Just(
								$author$project$TopMsg$globalMsg(
									$author$project$Global$Msg$ShowModal(
										A2($author$project$Global$Model$TwoFactorActivation, false, ''))))));
				} else {
					var _v4 = _v0.a.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(
							1,
							'Add bitcoin address',
							$elm$core$Maybe$Just(
								$author$project$TopMsg$globalMsg(
									$author$project$Global$Msg$ShowModal(
										A3($author$project$Global$Model$UpdateBitcoinAddressModal, '', '', $elm$core$Maybe$Nothing))))));
				}
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UI$Library$Chart$Msg$OnHover = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Library$Chart$Model$OneDay = 1;
var $author$project$UI$Library$Chart$Model$OneHour = 0;
var $author$project$UI$Library$Chart$Model$SevenDays = 2;
var $author$project$UI$Library$Chart$Msg$UpdateRangeEnd = function (a) {
	return {$: 7, a: a};
};
var $author$project$UI$Library$Chart$Msg$UpdateRangeStart = function (a) {
	return {$: 6, a: a};
};
var $terezka$elm_charts$Internal$Helpers$Attribute = $elm$core$Basics$identity;
var $terezka$elm_charts$Chart$Attributes$amount = function (value) {
	return function (config) {
		return _Utils_update(
			config,
			{dG: value});
	};
};
var $author$project$UI$Library$Chart$View$applyEwma = F2(
	function (alpha, points) {
		if (!points.b) {
			return _List_Nil;
		} else {
			var firstPoint = points.a;
			var rest = points.b;
			var step = F2(
				function (point, _v2) {
					var prevHashrate = _v2.a;
					var smoothedPoints = _v2.b;
					var smoothedHashrate = (alpha * point.n$) + ((1 - alpha) * prevHashrate);
					var smoothedPoint = _Utils_update(
						point,
						{n$: smoothedHashrate});
					return _Utils_Tuple2(
						smoothedHashrate,
						A2($elm$core$List$cons, smoothedPoint, smoothedPoints));
				});
			var _v1 = A3(
				$elm$core$List$foldl,
				step,
				_Utils_Tuple2(firstPoint.n$, _List_Nil),
				rest);
			var smoothTailRev = _v1.b;
			return A2(
				$elm$core$List$cons,
				firstPoint,
				$elm$core$List$reverse(smoothTailRev));
		}
	});
var $author$project$UI$Library$Chart$View$applyEwmaFpps = F2(
	function (alpha, points) {
		if (!points.b) {
			return _List_Nil;
		} else {
			var firstPoint = points.a;
			var rest = points.b;
			var step = F2(
				function (point, _v2) {
					var prevHashrate = _v2.a;
					var smoothedPoints = _v2.b;
					var smoothedHashrate = (alpha * point.l6) + ((1 - alpha) * prevHashrate);
					var smoothedPoint = _Utils_update(
						point,
						{l6: smoothedHashrate});
					return _Utils_Tuple2(
						smoothedHashrate,
						A2($elm$core$List$cons, smoothedPoint, smoothedPoints));
				});
			var _v1 = A3(
				$elm$core$List$foldl,
				step,
				_Utils_Tuple2(firstPoint.l6, _List_Nil),
				rest);
			var smoothTailRev = _v1.b;
			return A2(
				$elm$core$List$cons,
				firstPoint,
				$elm$core$List$reverse(smoothTailRev));
		}
	});
var $author$project$UI$Library$Chart$View$applyRangeSelection = F2(
	function (selection, points) {
		if ((!selection.j$) && _Utils_eq(selection.h_, $author$project$UI$Library$Chart$Model$rangeScaleMax)) {
			return points;
		} else {
			if (!points.b) {
				return _List_Nil;
			} else {
				if (!points.b.b) {
					var singlePoint = points.a;
					return _List_fromArray(
						[singlePoint]);
				} else {
					var scale = $author$project$UI$Library$Chart$Model$rangeScaleMax;
					var lastIndex = $elm$core$List$length(points) - 1;
					var startIndex = $elm$core$Basics$floor((selection.j$ / scale) * lastIndex);
					var endIndex = A3(
						$elm$core$Basics$clamp,
						startIndex,
						lastIndex,
						$elm$core$Basics$ceiling((selection.h_ / scale) * lastIndex));
					return A2(
						$elm$core$List$take,
						(endIndex - startIndex) + 1,
						A2($elm$core$List$drop, startIndex, points));
				}
			}
		}
	});
var $terezka$elm_charts$Internal$Svg$Event = F2(
	function (name, handler) {
		return {is: handler, aJ: name};
	});
var $terezka$elm_charts$Internal$Helpers$apply = F2(
	function (attrs, _default) {
		var apply_ = F2(
			function (_v0, a) {
				var f = _v0;
				return f(a);
			});
		return A3($elm$core$List$foldl, apply_, _default, attrs);
	});
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $K_Adam$elm_dom$DOM$offsetHeight = A2($elm$json$Json$Decode$field, 'offsetHeight', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$offsetLeft = A2($elm$json$Json$Decode$field, 'offsetLeft', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$offsetParent = F2(
	function (x, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					'offsetParent',
					$elm$json$Json$Decode$null(x)),
					A2($elm$json$Json$Decode$field, 'offsetParent', decoder)
				]));
	});
var $K_Adam$elm_dom$DOM$offsetTop = A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$scrollLeft = A2($elm$json$Json$Decode$field, 'scrollLeft', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$scrollTop = A2($elm$json$Json$Decode$field, 'scrollTop', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$position = F2(
	function (x, y) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				var x_ = _v0.a;
				var y_ = _v0.b;
				return A2(
					$K_Adam$elm_dom$DOM$offsetParent,
					_Utils_Tuple2(x_, y_),
					A2($K_Adam$elm_dom$DOM$position, x_, y_));
			},
			A5(
				$elm$json$Json$Decode$map4,
				F4(
					function (scrollLeftP, scrollTopP, offsetLeftP, offsetTopP) {
						return _Utils_Tuple2((x + offsetLeftP) - scrollLeftP, (y + offsetTopP) - scrollTopP);
					}),
				$K_Adam$elm_dom$DOM$scrollLeft,
				$K_Adam$elm_dom$DOM$scrollTop,
				$K_Adam$elm_dom$DOM$offsetLeft,
				$K_Adam$elm_dom$DOM$offsetTop));
	});
var $K_Adam$elm_dom$DOM$boundingClientRect = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (_v0, width, height) {
			var x = _v0.a;
			var y = _v0.b;
			return {fx: height, iL: x, kc: y, g6: width};
		}),
	A2($K_Adam$elm_dom$DOM$position, 0, 0),
	$K_Adam$elm_dom$DOM$offsetWidth,
	$K_Adam$elm_dom$DOM$offsetHeight);
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $K_Adam$elm_dom$DOM$parentElement = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'parentElement', decoder);
};
function $terezka$elm_charts$Internal$Svg$cyclic$decodePosition() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$K_Adam$elm_dom$DOM$boundingClientRect,
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return $K_Adam$elm_dom$DOM$parentElement(
						$terezka$elm_charts$Internal$Svg$cyclic$decodePosition());
				})
			]));
}
var $terezka$elm_charts$Internal$Svg$decodePosition = $terezka$elm_charts$Internal$Svg$cyclic$decodePosition();
$terezka$elm_charts$Internal$Svg$cyclic$decodePosition = function () {
	return $terezka$elm_charts$Internal$Svg$decodePosition;
};
var $terezka$elm_charts$Internal$Coordinates$innerLength = function (axis) {
	return A2($elm$core$Basics$max, 1, (axis.fP - axis.m3) - axis.m2);
};
var $terezka$elm_charts$Internal$Coordinates$innerWidth = function (plane) {
	return $terezka$elm_charts$Internal$Coordinates$innerLength(plane.kw);
};
var $terezka$elm_charts$Internal$Coordinates$range = function (axis) {
	var diff = axis.ar - axis.aT;
	return (diff > 0) ? diff : 1;
};
var $terezka$elm_charts$Internal$Coordinates$scaleCartesianX = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$range(plane.kw)) / $terezka$elm_charts$Internal$Coordinates$innerWidth(plane);
	});
var $terezka$elm_charts$Internal$Coordinates$toCartesianX = F2(
	function (plane, value) {
		return A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, value - plane.kw.m3) + plane.kw.aT;
	});
var $terezka$elm_charts$Internal$Coordinates$innerHeight = function (plane) {
	return $terezka$elm_charts$Internal$Coordinates$innerLength(plane.kx);
};
var $terezka$elm_charts$Internal$Coordinates$scaleCartesianY = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$range(plane.kx)) / $terezka$elm_charts$Internal$Coordinates$innerHeight(plane);
	});
var $terezka$elm_charts$Internal$Coordinates$toCartesianY = F2(
	function (plane, value) {
		return ($terezka$elm_charts$Internal$Coordinates$range(plane.kx) - A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, value - plane.kx.m3)) + plane.kx.aT;
	});
var $terezka$elm_charts$Internal$Svg$fromSvg = F2(
	function (plane, point) {
		return {
			kw: A2($terezka$elm_charts$Internal$Coordinates$toCartesianX, plane, point.kw),
			kx: A2($terezka$elm_charts$Internal$Coordinates$toCartesianY, plane, point.kx)
		};
	});
var $K_Adam$elm_dom$DOM$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $terezka$elm_charts$Internal$Svg$decoder = F2(
	function (plane, toMsg) {
		var handle = F3(
			function (mouseX, mouseY, box) {
				var yPrev = plane.kx;
				var xPrev = plane.kw;
				var widthPercent = box.g6 / plane.kw.fP;
				var heightPercent = box.fx / plane.kx.fP;
				var newPlane = _Utils_update(
					plane,
					{
						kw: _Utils_update(
							xPrev,
							{fP: box.g6, m2: plane.kw.m2 * widthPercent, m3: plane.kw.m3 * widthPercent}),
						kx: _Utils_update(
							yPrev,
							{fP: box.fx, m2: plane.kx.m2 * heightPercent, m3: plane.kx.m3 * heightPercent})
					});
				var searched = A2(
					$terezka$elm_charts$Internal$Svg$fromSvg,
					newPlane,
					{kw: mouseX - box.iL, kx: mouseY - box.kc});
				return A2(toMsg, newPlane, searched);
			});
		return A4(
			$elm$json$Json$Decode$map3,
			handle,
			A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float),
			$K_Adam$elm_dom$DOM$target($terezka$elm_charts$Internal$Svg$decodePosition));
	});
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$Events$on = $elm$html$Html$Events$on;
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $terezka$elm_charts$Internal$Coordinates$toId = function (plane) {
	var numToStr = A2(
		$elm$core$Basics$composeR,
		$elm$core$String$fromFloat,
		A2($elm$core$String$replace, '.', '-'));
	return A2(
		$elm$core$String$join,
		'_',
		_List_fromArray(
			[
				'elm-charts__id',
				numToStr(plane.kw.fP),
				numToStr(plane.kw.aT),
				numToStr(plane.kw.ar),
				numToStr(plane.kw.m3),
				numToStr(plane.kw.m2),
				numToStr(plane.kx.fP),
				numToStr(plane.kx.aT),
				numToStr(plane.kx.ar),
				numToStr(plane.kx.m3),
				numToStr(plane.kx.m2)
			]));
};
var $terezka$elm_charts$Internal$Svg$container = F5(
	function (plane, config, below, chartEls, above) {
		var toEvent = function (event) {
			return A2(
				$elm$svg$Svg$Events$on,
				event.aJ,
				A2($terezka$elm_charts$Internal$Svg$decoder, plane, event.is));
		};
		var svgAttrsSize = config.eq ? _List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox(
				'0 0 ' + ($elm$core$String$fromFloat(plane.kw.fP) + (' ' + $elm$core$String$fromFloat(plane.kx.fP)))),
				A2($elm$html$Html$Attributes$style, 'display', 'block')
			]) : _List_fromArray(
			[
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(plane.kw.fP)),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromFloat(plane.kx.fP)),
				A2($elm$html$Html$Attributes$style, 'display', 'block')
			]);
		var htmlAttrsSize = config.eq ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'height', '100%')
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'width',
				$elm$core$String$fromFloat(plane.kw.fP) + 'px'),
				A2(
				$elm$html$Html$Attributes$style,
				'height',
				$elm$core$String$fromFloat(plane.kx.fP) + 'px')
			]);
		var htmlAttrsDef = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('elm-charts__container-inner')
			]);
		var htmlAttrs = _Utils_ap(
			config.d2,
			_Utils_ap(htmlAttrsDef, htmlAttrsSize));
		var chartPosition = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$x(
				$elm$core$String$fromFloat(plane.kw.m3)),
				$elm$svg$Svg$Attributes$y(
				$elm$core$String$fromFloat(plane.kx.m3)),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(
					$terezka$elm_charts$Internal$Coordinates$innerWidth(plane))),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromFloat(
					$terezka$elm_charts$Internal$Coordinates$innerHeight(plane))),
				$elm$svg$Svg$Attributes$fill('transparent')
			]);
		var clipPathDefs = A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id(
							$terezka$elm_charts$Internal$Coordinates$toId(plane))
						]),
					_List_fromArray(
						[
							A2($elm$svg$Svg$rect, chartPosition, _List_Nil)
						]))
				]));
		var catcher = A2(
			$elm$svg$Svg$rect,
			_Utils_ap(
				chartPosition,
				A2($elm$core$List$map, toEvent, config.dZ)),
			_List_Nil);
		var chart = A2(
			$elm$svg$Svg$svg,
			_Utils_ap(svgAttrsSize, config.ch),
			_Utils_ap(
				_List_fromArray(
					[clipPathDefs]),
				_Utils_ap(
					chartEls,
					_List_fromArray(
						[catcher]))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('elm-charts__container'),
					A2($elm$html$Html$Attributes$style, 'position', 'relative')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					htmlAttrs,
					_Utils_ap(
						below,
						_Utils_ap(
							_List_fromArray(
								[chart]),
							above)))
				]));
	});
var $terezka$elm_charts$Internal$Coordinates$Position = F4(
	function (x1, x2, y1, y2) {
		return {qa: x1, qb: x2, qf: y1, qg: y2};
	});
var $terezka$elm_charts$Internal$Coordinates$foldPosition = F2(
	function (func, data) {
		var fold = F2(
			function (datum, posM) {
				if (!posM.$) {
					var pos = posM.a;
					return $elm$core$Maybe$Just(
						{
							qa: A2(
								$elm$core$Basics$min,
								func(datum).qa,
								pos.qa),
							qb: A2(
								$elm$core$Basics$max,
								func(datum).qb,
								pos.qb),
							qf: A2(
								$elm$core$Basics$min,
								func(datum).qf,
								pos.qf),
							qg: A2(
								$elm$core$Basics$max,
								func(datum).qg,
								pos.qg)
						});
				} else {
					return $elm$core$Maybe$Just(
						func(datum));
				}
			});
		return A2(
			$elm$core$Maybe$withDefault,
			A4($terezka$elm_charts$Internal$Coordinates$Position, 0, 0, 0, 0),
			A3($elm$core$List$foldl, fold, $elm$core$Maybe$Nothing, data));
	});
var $terezka$elm_charts$Internal$Item$getLimits = function (_v0) {
	var item = _v0.b;
	return item.ae;
};
var $terezka$elm_charts$Chart$Attributes$lowest = F2(
	function (v, edit) {
		return function (b) {
			return _Utils_update(
				b,
				{
					aT: A3(edit, v, b.aT, b.lv)
				});
		};
	});
var $terezka$elm_charts$Chart$Attributes$orLower = F3(
	function (least, real, _v0) {
		return (_Utils_cmp(real, least) > 0) ? least : real;
	});
var $terezka$elm_charts$Chart$definePlane = F2(
	function (config, elements) {
		var width = A2($elm$core$Basics$max, 1, (config.g6 - config.a8.iL) - config.a8.jD);
		var toLimit = F5(
			function (length, marginMin, marginMax, min, max) {
				return {lu: max, lv: min, fP: length, m2: marginMax, m3: marginMin, ar: max, aT: min};
			});
		var height = A2($elm$core$Basics$max, 1, (config.fx - config.a8.ho) - config.a8.kc);
		var fixSingles = function (bs) {
			return _Utils_eq(bs.aT, bs.ar) ? _Utils_update(
				bs,
				{ar: bs.aT + 10}) : bs;
		};
		var collectLimits = F2(
			function (el, acc) {
				switch (el.$) {
					case 0:
						return acc;
					case 1:
						var lims = el.a;
						return _Utils_ap(acc, lims);
					case 2:
						var lims = el.a;
						return _Utils_ap(acc, lims);
					case 3:
						var item = el.a;
						return _Utils_ap(
							acc,
							_List_fromArray(
								[
									$terezka$elm_charts$Internal$Item$getLimits(item)
								]));
					case 4:
						return acc;
					case 5:
						return acc;
					case 6:
						return acc;
					case 7:
						return acc;
					case 8:
						return acc;
					case 9:
						return acc;
					case 10:
						return acc;
					case 11:
						var subs = el.a;
						return A3($elm$core$List$foldl, collectLimits, acc, subs);
					case 12:
						return acc;
					default:
						return acc;
				}
			});
		var limits_ = function (pos) {
			return function (_v3) {
				var x = _v3.kw;
				var y = _v3.kx;
				return {
					kw: fixSingles(x),
					kx: fixSingles(y)
				};
			}(
				{
					kw: A5(toLimit, width, config.bW.iL, config.bW.jD, pos.qa, pos.qb),
					kx: A5(toLimit, height, config.bW.kc, config.bW.ho, pos.qf, pos.qg)
				});
		}(
			A2(
				$terezka$elm_charts$Internal$Coordinates$foldPosition,
				$elm$core$Basics$identity,
				A3($elm$core$List$foldl, collectLimits, _List_Nil, elements)));
		var calcRange = function () {
			var _v2 = config.gm;
			if (!_v2.b) {
				return limits_.kw;
			} else {
				var some = _v2;
				return A2($terezka$elm_charts$Internal$Helpers$apply, some, limits_.kw);
			}
		}();
		var calcDomain = function () {
			var _v1 = config.fc;
			if (!_v1.b) {
				return A2(
					$terezka$elm_charts$Internal$Helpers$apply,
					_List_fromArray(
						[
							A2($terezka$elm_charts$Chart$Attributes$lowest, 0, $terezka$elm_charts$Chart$Attributes$orLower)
						]),
					limits_.kx);
			} else {
				var some = _v1;
				return A2($terezka$elm_charts$Internal$Helpers$apply, some, limits_.kx);
			}
		}();
		var unpadded = {kw: calcRange, kx: calcDomain};
		var scalePadX = $terezka$elm_charts$Internal$Coordinates$scaleCartesianX(unpadded);
		var xMax = calcRange.ar + scalePadX(config.a8.jD);
		var xMin = calcRange.aT - scalePadX(config.a8.iL);
		var scalePadY = $terezka$elm_charts$Internal$Coordinates$scaleCartesianY(unpadded);
		var yMax = calcDomain.ar + scalePadY(config.a8.kc);
		var yMin = calcDomain.aT - scalePadY(config.a8.ho);
		return {
			kw: _Utils_update(
				calcRange,
				{
					fP: config.g6,
					ar: A2($elm$core$Basics$max, xMin, xMax),
					aT: A2($elm$core$Basics$min, xMin, xMax)
				}),
			kx: _Utils_update(
				calcDomain,
				{
					fP: config.fx,
					ar: A2($elm$core$Basics$max, yMin, yMax),
					aT: A2($elm$core$Basics$min, yMin, yMax)
				})
		};
	});
var $terezka$elm_charts$Chart$getItems = F2(
	function (plane, elements) {
		var toItems = F2(
			function (el, acc) {
				switch (el.$) {
					case 0:
						return acc;
					case 1:
						var items = el.b;
						return _Utils_ap(acc, items);
					case 2:
						var items = el.b;
						return _Utils_ap(acc, items);
					case 3:
						var item = el.a;
						return _Utils_ap(
							acc,
							_List_fromArray(
								[item]));
					case 4:
						var func = el.a;
						return acc;
					case 5:
						return acc;
					case 6:
						return acc;
					case 7:
						return acc;
					case 8:
						return acc;
					case 9:
						return acc;
					case 10:
						return acc;
					case 11:
						var subs = el.a;
						return A3($elm$core$List$foldl, toItems, acc, subs);
					case 12:
						return acc;
					default:
						return acc;
				}
			});
		return A3($elm$core$List$foldl, toItems, _List_Nil, elements);
	});
var $terezka$elm_charts$Chart$getLegends = function (elements) {
	var toLegends = F2(
		function (el, acc) {
			switch (el.$) {
				case 0:
					return acc;
				case 1:
					var legends_ = el.c;
					return _Utils_ap(acc, legends_);
				case 2:
					var legends_ = el.c;
					return _Utils_ap(acc, legends_);
				case 3:
					return acc;
				case 4:
					return acc;
				case 5:
					return acc;
				case 6:
					return acc;
				case 7:
					return acc;
				case 8:
					return acc;
				case 9:
					return acc;
				case 10:
					return acc;
				case 11:
					var subs = el.a;
					return A3($elm$core$List$foldl, toLegends, acc, subs);
				case 12:
					return acc;
				default:
					return acc;
			}
		});
	return A3($elm$core$List$foldl, toLegends, _List_Nil, elements);
};
var $terezka$elm_charts$Chart$TickValues = F4(
	function (xAxis, yAxis, xs, ys) {
		return {dB: xAxis, aA: xs, dC: yAxis, aY: ys};
	});
var $terezka$elm_charts$Chart$getTickValues = F3(
	function (plane, items, elements) {
		var toValues = F2(
			function (el, acc) {
				switch (el.$) {
					case 0:
						return acc;
					case 1:
						return acc;
					case 2:
						var func = el.d;
						return A2(func, plane, acc);
					case 3:
						return acc;
					case 4:
						var func = el.a;
						return A2(func, plane, acc);
					case 5:
						var func = el.a;
						return A2(func, plane, acc);
					case 6:
						var toC = el.a;
						var func = el.b;
						return A3(
							func,
							plane,
							toC(plane),
							acc);
					case 7:
						var toC = el.a;
						var func = el.b;
						return A3(
							func,
							plane,
							toC(plane),
							acc);
					case 8:
						var toC = el.a;
						var func = el.b;
						return A3(
							func,
							plane,
							toC(plane),
							acc);
					case 10:
						var func = el.a;
						return A3(
							$elm$core$List$foldl,
							toValues,
							acc,
							A2(func, plane, items));
					case 9:
						return acc;
					case 11:
						var subs = el.a;
						return A3($elm$core$List$foldl, toValues, acc, subs);
					case 12:
						return acc;
					default:
						return acc;
				}
			});
		return A3(
			$elm$core$List$foldl,
			toValues,
			A4($terezka$elm_charts$Chart$TickValues, _List_Nil, _List_Nil, _List_Nil, _List_Nil),
			elements);
	});
var $terezka$elm_charts$Chart$GridElement = function (a) {
	return {$: 9, a: a};
};
var $terezka$elm_charts$Internal$Svg$Circle = 0;
var $terezka$elm_charts$Chart$Attributes$circle = function (config) {
	return _Utils_update(
		config,
		{
			cC: $elm$core$Maybe$Just(0)
		});
};
var $terezka$elm_charts$Chart$Attributes$color = function (v) {
	return function (config) {
		return (v === '') ? config : _Utils_update(
			config,
			{cU: v});
	};
};
var $terezka$elm_charts$Internal$Helpers$darkGray = 'rgb(200 200 200)';
var $terezka$elm_charts$Chart$Attributes$dashed = function (value) {
	return function (config) {
		return _Utils_update(
			config,
			{dS: value});
	};
};
var $terezka$elm_charts$Internal$Helpers$pink = '#ea60df';
var $terezka$elm_charts$Internal$Svg$defaultDot = {ap: '', aC: 0, cU: $terezka$elm_charts$Internal$Helpers$pink, O: false, mm: 0, mn: '', mo: 5, a6: 1, cC: $elm$core$Maybe$Nothing, jV: 6};
var $elm$svg$Svg$Attributes$fillOpacity = _VirtualDom_attribute('fill-opacity');
var $terezka$elm_charts$Internal$Svg$isWithinPlane = F3(
	function (plane, x, y) {
		return _Utils_eq(
			A3($elm$core$Basics$clamp, plane.kw.aT, plane.kw.ar, x),
			x) && _Utils_eq(
			A3($elm$core$Basics$clamp, plane.kx.aT, plane.kx.ar, y),
			y);
	});
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $terezka$elm_charts$Internal$Svg$plusPath = F4(
	function (area_, off, x_, y_) {
		var side = $elm$core$Basics$sqrt(area_ / 4) + off;
		var r6 = side / 2;
		var r3 = side;
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					'M' + ($elm$core$String$fromFloat(x_ - r6) + (' ' + $elm$core$String$fromFloat(((y_ - r3) - r6) + off))),
					'v' + $elm$core$String$fromFloat(r3 - off),
					'h' + $elm$core$String$fromFloat((-r3) + off),
					'v' + $elm$core$String$fromFloat(r3),
					'h' + $elm$core$String$fromFloat(r3 - off),
					'v' + $elm$core$String$fromFloat(r3 - off),
					'h' + $elm$core$String$fromFloat(r3),
					'v' + $elm$core$String$fromFloat((-r3) + off),
					'h' + $elm$core$String$fromFloat(r3 - off),
					'v' + $elm$core$String$fromFloat(-r3),
					'h' + $elm$core$String$fromFloat((-r3) + off),
					'v' + $elm$core$String$fromFloat((-r3) + off),
					'h' + $elm$core$String$fromFloat(-r3),
					'v' + $elm$core$String$fromFloat(r3 - off)
				]));
	});
var $elm$svg$Svg$Attributes$strokeOpacity = _VirtualDom_attribute('stroke-opacity');
var $terezka$elm_charts$Internal$Coordinates$scaleSVGX = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$innerWidth(plane)) / $terezka$elm_charts$Internal$Coordinates$range(plane.kw);
	});
var $terezka$elm_charts$Internal$Coordinates$toSVGX = F2(
	function (plane, value) {
		return A2($terezka$elm_charts$Internal$Coordinates$scaleSVGX, plane, value - plane.kw.aT) + plane.kw.m3;
	});
var $terezka$elm_charts$Internal$Coordinates$scaleSVGY = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$innerHeight(plane)) / $terezka$elm_charts$Internal$Coordinates$range(plane.kx);
	});
var $terezka$elm_charts$Internal$Coordinates$toSVGY = F2(
	function (plane, value) {
		return A2($terezka$elm_charts$Internal$Coordinates$scaleSVGY, plane, plane.kx.ar - value) + plane.kx.m3;
	});
var $elm$core$Basics$degrees = function (angleInDegrees) {
	return (angleInDegrees * $elm$core$Basics$pi) / 180;
};
var $elm$core$Basics$tan = _Basics_tan;
var $terezka$elm_charts$Internal$Svg$trianglePath = F4(
	function (area_, off, x_, y_) {
		var side = $elm$core$Basics$sqrt(
			(area_ * 4) / $elm$core$Basics$sqrt(3)) + (off * $elm$core$Basics$sqrt(3));
		var height = ($elm$core$Basics$sqrt(3) * side) / 2;
		var fromMiddle = height - (($elm$core$Basics$tan(
			$elm$core$Basics$degrees(30)) * side) / 2);
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					'M' + ($elm$core$String$fromFloat(x_) + (' ' + $elm$core$String$fromFloat(y_ - fromMiddle))),
					'l' + ($elm$core$String$fromFloat((-side) / 2) + (' ' + $elm$core$String$fromFloat(height))),
					'h' + $elm$core$String$fromFloat(side),
					'z'
				]));
	});
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $terezka$elm_charts$Internal$Svg$withinChartArea = function (plane) {
	return $elm$svg$Svg$Attributes$clipPath(
		'url(#' + ($terezka$elm_charts$Internal$Coordinates$toId(plane) + ')'));
};
var $terezka$elm_charts$Internal$Svg$dot = F5(
	function (plane, toX, toY, config, datum_) {
		var yOrg = toY(datum_);
		var y_ = A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, yOrg);
		var xOrg = toX(datum_);
		var x_ = A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, xOrg);
		var styleAttrs = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$stroke(
				(config.ap === '') ? config.cU : config.ap),
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(config.aC)),
				$elm$svg$Svg$Attributes$fillOpacity(
				$elm$core$String$fromFloat(config.a6)),
				$elm$svg$Svg$Attributes$fill(config.cU),
				$elm$svg$Svg$Attributes$class('elm-charts__dot'),
				config.O ? $terezka$elm_charts$Internal$Svg$withinChartArea(plane) : $elm$svg$Svg$Attributes$class('')
			]);
		var showDot = A3($terezka$elm_charts$Internal$Svg$isWithinPlane, plane, xOrg, yOrg) || config.O;
		var highlightColor = (config.mn === '') ? config.cU : config.mn;
		var highlightAttrs = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$stroke(highlightColor),
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(config.mo)),
				$elm$svg$Svg$Attributes$strokeOpacity(
				$elm$core$String$fromFloat(config.mm)),
				$elm$svg$Svg$Attributes$fill('transparent'),
				$elm$svg$Svg$Attributes$class('elm-charts__dot-highlight')
			]);
		var view = F3(
			function (toEl, highlightOff, toAttrs) {
				return (config.mm > 0) ? A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__dot-container')
						]),
					_List_fromArray(
						[
							A2(
							toEl,
							_Utils_ap(
								toAttrs(highlightOff),
								highlightAttrs),
							_List_Nil),
							A2(
							toEl,
							_Utils_ap(
								toAttrs(0),
								styleAttrs),
							_List_Nil)
						])) : A2(
					toEl,
					_Utils_ap(
						toAttrs(0),
						styleAttrs),
					_List_Nil);
			});
		var area_ = (2 * $elm$core$Basics$pi) * config.jV;
		if (!showDot) {
			return $elm$svg$Svg$text('');
		} else {
			var _v0 = config.cC;
			if (_v0.$ === 1) {
				return $elm$svg$Svg$text('');
			} else {
				switch (_v0.a) {
					case 0:
						var _v1 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$circle,
							config.mo / 2,
							function (off) {
								var radius = $elm$core$Basics$sqrt(area_ / $elm$core$Basics$pi);
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$cx(
										$elm$core$String$fromFloat(x_)),
										$elm$svg$Svg$Attributes$cy(
										$elm$core$String$fromFloat(y_)),
										$elm$svg$Svg$Attributes$r(
										$elm$core$String$fromFloat(radius + off))
									]);
							});
					case 1:
						var _v2 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$path,
							config.mo,
							function (off) {
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$d(
										A4($terezka$elm_charts$Internal$Svg$trianglePath, area_, off, x_, y_))
									]);
							});
					case 2:
						var _v3 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$rect,
							config.mo,
							function (off) {
								var side = $elm$core$Basics$sqrt(area_);
								var sideOff = side + off;
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$x(
										$elm$core$String$fromFloat(x_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$y(
										$elm$core$String$fromFloat(y_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$width(
										$elm$core$String$fromFloat(sideOff)),
										$elm$svg$Svg$Attributes$height(
										$elm$core$String$fromFloat(sideOff))
									]);
							});
					case 3:
						var _v4 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$rect,
							config.mo,
							function (off) {
								var side = $elm$core$Basics$sqrt(area_);
								var sideOff = side + off;
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$x(
										$elm$core$String$fromFloat(x_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$y(
										$elm$core$String$fromFloat(y_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$width(
										$elm$core$String$fromFloat(sideOff)),
										$elm$svg$Svg$Attributes$height(
										$elm$core$String$fromFloat(sideOff)),
										$elm$svg$Svg$Attributes$transform(
										'rotate(45 ' + ($elm$core$String$fromFloat(x_) + (' ' + ($elm$core$String$fromFloat(y_) + ')'))))
									]);
							});
					case 4:
						var _v5 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$path,
							config.mo,
							function (off) {
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$d(
										A4($terezka$elm_charts$Internal$Svg$plusPath, area_, off, x_, y_)),
										$elm$svg$Svg$Attributes$transform(
										'rotate(45 ' + ($elm$core$String$fromFloat(x_) + (' ' + ($elm$core$String$fromFloat(y_) + ')'))))
									]);
							});
					default:
						var _v6 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$path,
							config.mo,
							function (off) {
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$d(
										A4($terezka$elm_charts$Internal$Svg$plusPath, area_, off, x_, y_))
									]);
							});
				}
			}
		}
	});
var $terezka$elm_charts$Chart$Svg$dot = F4(
	function (plane, toX, toY, edits) {
		return A4(
			$terezka$elm_charts$Internal$Svg$dot,
			plane,
			toX,
			toY,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultDot));
	});
var $terezka$elm_charts$Internal$Helpers$gray = '#EFF2FA';
var $terezka$elm_charts$Internal$Svg$defaultLine = {ch: _List_Nil, kY: false, cU: 'rgb(210, 210, 210)', dS: _List_Nil, B: false, O: false, a6: 1, pd: -90, pe: 0, g6: 1, qa: $elm$core$Maybe$Nothing, qb: $elm$core$Maybe$Nothing, qc: $elm$core$Maybe$Nothing, H: 0, qf: $elm$core$Maybe$Nothing, qg: $elm$core$Maybe$Nothing, qh: $elm$core$Maybe$Nothing, I: 0};
var $terezka$elm_charts$Internal$Commands$Line = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $terezka$elm_charts$Internal$Commands$Move = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $terezka$elm_charts$Internal$Commands$joinCommands = function (commands) {
	return A2($elm$core$String$join, ' ', commands);
};
var $terezka$elm_charts$Internal$Commands$stringBoolInt = function (bool) {
	return bool ? '1' : '0';
};
var $terezka$elm_charts$Internal$Commands$stringPoint = function (_v0) {
	var x = _v0.a;
	var y = _v0.b;
	return $elm$core$String$fromFloat(x) + (' ' + $elm$core$String$fromFloat(y));
};
var $terezka$elm_charts$Internal$Commands$stringPoints = function (points) {
	return A2(
		$elm$core$String$join,
		',',
		A2($elm$core$List$map, $terezka$elm_charts$Internal$Commands$stringPoint, points));
};
var $terezka$elm_charts$Internal$Commands$stringCommand = function (command) {
	switch (command.$) {
		case 0:
			var x = command.a;
			var y = command.b;
			return 'M' + $terezka$elm_charts$Internal$Commands$stringPoint(
				_Utils_Tuple2(x, y));
		case 1:
			var x = command.a;
			var y = command.b;
			return 'L' + $terezka$elm_charts$Internal$Commands$stringPoint(
				_Utils_Tuple2(x, y));
		case 2:
			var cx1 = command.a;
			var cy1 = command.b;
			var cx2 = command.c;
			var cy2 = command.d;
			var x = command.e;
			var y = command.f;
			return 'C' + $terezka$elm_charts$Internal$Commands$stringPoints(
				_List_fromArray(
					[
						_Utils_Tuple2(cx1, cy1),
						_Utils_Tuple2(cx2, cy2),
						_Utils_Tuple2(x, y)
					]));
		case 3:
			var cx1 = command.a;
			var cy1 = command.b;
			var x = command.c;
			var y = command.d;
			return 'Q' + $terezka$elm_charts$Internal$Commands$stringPoints(
				_List_fromArray(
					[
						_Utils_Tuple2(cx1, cy1),
						_Utils_Tuple2(x, y)
					]));
		case 4:
			var cx1 = command.a;
			var cy1 = command.b;
			var x = command.c;
			var y = command.d;
			return 'Q' + $terezka$elm_charts$Internal$Commands$stringPoints(
				_List_fromArray(
					[
						_Utils_Tuple2(cx1, cy1),
						_Utils_Tuple2(x, y)
					]));
		case 5:
			var x = command.a;
			var y = command.b;
			return 'T' + $terezka$elm_charts$Internal$Commands$stringPoint(
				_Utils_Tuple2(x, y));
		case 6:
			var rx = command.a;
			var ry = command.b;
			var xAxisRotation = command.c;
			var largeArcFlag = command.d;
			var sweepFlag = command.e;
			var x = command.f;
			var y = command.g;
			return 'A ' + $terezka$elm_charts$Internal$Commands$joinCommands(
				_List_fromArray(
					[
						$terezka$elm_charts$Internal$Commands$stringPoint(
						_Utils_Tuple2(rx, ry)),
						$elm$core$String$fromInt(xAxisRotation),
						$terezka$elm_charts$Internal$Commands$stringBoolInt(largeArcFlag),
						$terezka$elm_charts$Internal$Commands$stringBoolInt(sweepFlag),
						$terezka$elm_charts$Internal$Commands$stringPoint(
						_Utils_Tuple2(x, y))
					]));
		default:
			return 'Z';
	}
};
var $terezka$elm_charts$Internal$Commands$Arc = F7(
	function (a, b, c, d, e, f, g) {
		return {$: 6, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
	});
var $terezka$elm_charts$Internal$Commands$Close = {$: 7};
var $terezka$elm_charts$Internal$Commands$CubicBeziers = F6(
	function (a, b, c, d, e, f) {
		return {$: 2, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $terezka$elm_charts$Internal$Commands$CubicBeziersShort = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $terezka$elm_charts$Internal$Commands$QuadraticBeziers = F4(
	function (a, b, c, d) {
		return {$: 4, a: a, b: b, c: c, d: d};
	});
var $terezka$elm_charts$Internal$Commands$QuadraticBeziersShort = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $terezka$elm_charts$Internal$Commands$translate = F2(
	function (plane, command) {
		switch (command.$) {
			case 0:
				var x = command.a;
				var y = command.b;
				return A2(
					$terezka$elm_charts$Internal$Commands$Move,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 1:
				var x = command.a;
				var y = command.b;
				return A2(
					$terezka$elm_charts$Internal$Commands$Line,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 2:
				var cx1 = command.a;
				var cy1 = command.b;
				var cx2 = command.c;
				var cy2 = command.d;
				var x = command.e;
				var y = command.f;
				return A6(
					$terezka$elm_charts$Internal$Commands$CubicBeziers,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx2),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy2),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 3:
				var cx1 = command.a;
				var cy1 = command.b;
				var x = command.c;
				var y = command.d;
				return A4(
					$terezka$elm_charts$Internal$Commands$CubicBeziersShort,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 4:
				var cx1 = command.a;
				var cy1 = command.b;
				var x = command.c;
				var y = command.d;
				return A4(
					$terezka$elm_charts$Internal$Commands$QuadraticBeziers,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 5:
				var x = command.a;
				var y = command.b;
				return A2(
					$terezka$elm_charts$Internal$Commands$QuadraticBeziersShort,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 6:
				var rx = command.a;
				var ry = command.b;
				var xAxisRotation = command.c;
				var largeArcFlag = command.d;
				var sweepFlag = command.e;
				var x = command.f;
				var y = command.g;
				return A7(
					$terezka$elm_charts$Internal$Commands$Arc,
					rx,
					ry,
					xAxisRotation,
					largeArcFlag,
					sweepFlag,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			default:
				return $terezka$elm_charts$Internal$Commands$Close;
		}
	});
var $terezka$elm_charts$Internal$Commands$description = F2(
	function (plane, commands) {
		return $terezka$elm_charts$Internal$Commands$joinCommands(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$terezka$elm_charts$Internal$Commands$translate(plane),
					$terezka$elm_charts$Internal$Commands$stringCommand),
				commands));
	});
var $terezka$elm_charts$Internal$Svg$lengthInCartesianX = $terezka$elm_charts$Internal$Coordinates$scaleCartesianX;
var $terezka$elm_charts$Internal$Svg$lengthInCartesianY = $terezka$elm_charts$Internal$Coordinates$scaleCartesianY;
var $elm$svg$Svg$Attributes$strokeDasharray = _VirtualDom_attribute('stroke-dasharray');
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $terezka$elm_charts$Internal$Svg$withAttrs = F3(
	function (attrs, toEl, defaultAttrs) {
		return toEl(
			_Utils_ap(
				defaultAttrs,
				A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					attrs)));
	});
var $terezka$elm_charts$Internal$Svg$line = F2(
	function (plane, config) {
		var angle = $elm$core$Basics$degrees(config.pd);
		var _v0 = function () {
			var _v3 = _Utils_Tuple3(
				_Utils_Tuple2(config.qa, config.qb),
				_Utils_Tuple2(config.qf, config.qg),
				_Utils_Tuple2(config.qc, config.qh));
			if (!_v3.a.a.$) {
				if (!_v3.a.b.$) {
					if (_v3.b.a.$ === 1) {
						if (_v3.b.b.$ === 1) {
							var _v4 = _v3.a;
							var a = _v4.a.a;
							var b = _v4.b.a;
							var _v5 = _v3.b;
							var _v6 = _v5.a;
							var _v7 = _v5.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, b),
								_Utils_Tuple2(plane.kx.aT, plane.kx.aT));
						} else {
							var _v38 = _v3.a;
							var a = _v38.a.a;
							var b = _v38.b.a;
							var _v39 = _v3.b;
							var _v40 = _v39.a;
							var c = _v39.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, b),
								_Utils_Tuple2(c, c));
						}
					} else {
						if (_v3.b.b.$ === 1) {
							var _v41 = _v3.a;
							var a = _v41.a.a;
							var b = _v41.b.a;
							var _v42 = _v3.b;
							var c = _v42.a.a;
							var _v43 = _v42.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, b),
								_Utils_Tuple2(c, c));
						} else {
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($elm$core$Maybe$withDefault, plane.kw.aT, config.qa),
									A2($elm$core$Maybe$withDefault, plane.kw.ar, config.qb)),
								_Utils_Tuple2(
									A2($elm$core$Maybe$withDefault, plane.kx.aT, config.qf),
									A2($elm$core$Maybe$withDefault, plane.kx.ar, config.qg)));
						}
					}
				} else {
					if (_v3.b.a.$ === 1) {
						if (_v3.b.b.$ === 1) {
							var _v8 = _v3.a;
							var a = _v8.a.a;
							var _v9 = _v8.b;
							var _v10 = _v3.b;
							var _v11 = _v10.a;
							var _v12 = _v10.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, a),
								_Utils_Tuple2(plane.kx.aT, plane.kx.ar));
						} else {
							if (!_v3.c.a.$) {
								if (!_v3.c.b.$) {
									var _v51 = _v3.a;
									var a = _v51.a.a;
									var _v52 = _v51.b;
									var _v53 = _v3.b;
									var _v54 = _v53.a;
									var b = _v53.b.a;
									var _v55 = _v3.c;
									var xOff = _v55.a.a;
									var yOff = _v55.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v56 = _v3.a;
									var a = _v56.a.a;
									var _v57 = _v56.b;
									var _v58 = _v3.b;
									var _v59 = _v58.a;
									var b = _v58.b.a;
									var _v60 = _v3.c;
									var xOff = _v60.a.a;
									var _v61 = _v60.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v3.c.b.$ === 1) {
									var _v44 = _v3.a;
									var a = _v44.a.a;
									var _v45 = _v44.b;
									var _v46 = _v3.b;
									var _v47 = _v46.a;
									var b = _v46.b.a;
									var _v48 = _v3.c;
									var _v49 = _v48.a;
									var _v50 = _v48.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.kw.ar),
										_Utils_Tuple2(b, b));
								} else {
									var _v62 = _v3.a;
									var a = _v62.a.a;
									var _v63 = _v62.b;
									var _v64 = _v3.b;
									var _v65 = _v64.a;
									var b = _v64.b.a;
									var _v66 = _v3.c;
									var _v67 = _v66.a;
									var yOff = _v66.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					} else {
						if (!_v3.b.b.$) {
							var _v35 = _v3.a;
							var c = _v35.a.a;
							var _v36 = _v35.b;
							var _v37 = _v3.b;
							var a = _v37.a.a;
							var b = _v37.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(c, c),
								_Utils_Tuple2(a, b));
						} else {
							if (!_v3.c.a.$) {
								if (!_v3.c.b.$) {
									var _v75 = _v3.a;
									var a = _v75.a.a;
									var _v76 = _v75.b;
									var _v77 = _v3.b;
									var b = _v77.a.a;
									var _v78 = _v77.b;
									var _v79 = _v3.c;
									var xOff = _v79.a.a;
									var yOff = _v79.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v80 = _v3.a;
									var a = _v80.a.a;
									var _v81 = _v80.b;
									var _v82 = _v3.b;
									var b = _v82.a.a;
									var _v83 = _v82.b;
									var _v84 = _v3.c;
									var xOff = _v84.a.a;
									var _v85 = _v84.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v3.c.b.$ === 1) {
									var _v68 = _v3.a;
									var a = _v68.a.a;
									var _v69 = _v68.b;
									var _v70 = _v3.b;
									var b = _v70.a.a;
									var _v71 = _v70.b;
									var _v72 = _v3.c;
									var _v73 = _v72.a;
									var _v74 = _v72.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.kw.ar),
										_Utils_Tuple2(b, b));
								} else {
									var _v86 = _v3.a;
									var a = _v86.a.a;
									var _v87 = _v86.b;
									var _v88 = _v3.b;
									var b = _v88.a.a;
									var _v89 = _v88.b;
									var _v90 = _v3.c;
									var _v91 = _v90.a;
									var yOff = _v90.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					}
				}
			} else {
				if (!_v3.a.b.$) {
					if (_v3.b.a.$ === 1) {
						if (_v3.b.b.$ === 1) {
							var _v13 = _v3.a;
							var _v14 = _v13.a;
							var b = _v13.b.a;
							var _v15 = _v3.b;
							var _v16 = _v15.a;
							var _v17 = _v15.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(b, b),
								_Utils_Tuple2(plane.kx.aT, plane.kx.ar));
						} else {
							if (!_v3.c.a.$) {
								if (!_v3.c.b.$) {
									var _v99 = _v3.a;
									var _v100 = _v99.a;
									var a = _v99.b.a;
									var _v101 = _v3.b;
									var _v102 = _v101.a;
									var b = _v101.b.a;
									var _v103 = _v3.c;
									var xOff = _v103.a.a;
									var yOff = _v103.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v104 = _v3.a;
									var _v105 = _v104.a;
									var a = _v104.b.a;
									var _v106 = _v3.b;
									var _v107 = _v106.a;
									var b = _v106.b.a;
									var _v108 = _v3.c;
									var xOff = _v108.a.a;
									var _v109 = _v108.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v3.c.b.$ === 1) {
									var _v92 = _v3.a;
									var _v93 = _v92.a;
									var a = _v92.b.a;
									var _v94 = _v3.b;
									var _v95 = _v94.a;
									var b = _v94.b.a;
									var _v96 = _v3.c;
									var _v97 = _v96.a;
									var _v98 = _v96.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.kw.ar),
										_Utils_Tuple2(b, b));
								} else {
									var _v110 = _v3.a;
									var _v111 = _v110.a;
									var a = _v110.b.a;
									var _v112 = _v3.b;
									var _v113 = _v112.a;
									var b = _v112.b.a;
									var _v114 = _v3.c;
									var _v115 = _v114.a;
									var yOff = _v114.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					} else {
						if (!_v3.b.b.$) {
							var _v32 = _v3.a;
							var _v33 = _v32.a;
							var c = _v32.b.a;
							var _v34 = _v3.b;
							var a = _v34.a.a;
							var b = _v34.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(c, c),
								_Utils_Tuple2(a, b));
						} else {
							if (!_v3.c.a.$) {
								if (!_v3.c.b.$) {
									var _v123 = _v3.a;
									var _v124 = _v123.a;
									var a = _v123.b.a;
									var _v125 = _v3.b;
									var b = _v125.a.a;
									var _v126 = _v125.b;
									var _v127 = _v3.c;
									var xOff = _v127.a.a;
									var yOff = _v127.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v128 = _v3.a;
									var _v129 = _v128.a;
									var a = _v128.b.a;
									var _v130 = _v3.b;
									var b = _v130.a.a;
									var _v131 = _v130.b;
									var _v132 = _v3.c;
									var xOff = _v132.a.a;
									var _v133 = _v132.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v3.c.b.$ === 1) {
									var _v116 = _v3.a;
									var _v117 = _v116.a;
									var a = _v116.b.a;
									var _v118 = _v3.b;
									var b = _v118.a.a;
									var _v119 = _v118.b;
									var _v120 = _v3.c;
									var _v121 = _v120.a;
									var _v122 = _v120.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.kw.ar),
										_Utils_Tuple2(b, b));
								} else {
									var _v134 = _v3.a;
									var _v135 = _v134.a;
									var a = _v134.b.a;
									var _v136 = _v3.b;
									var b = _v136.a.a;
									var _v137 = _v136.b;
									var _v138 = _v3.c;
									var _v139 = _v138.a;
									var yOff = _v138.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					}
				} else {
					if (!_v3.b.a.$) {
						if (!_v3.b.b.$) {
							var _v18 = _v3.a;
							var _v19 = _v18.a;
							var _v20 = _v18.b;
							var _v21 = _v3.b;
							var a = _v21.a.a;
							var b = _v21.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.kw.aT, plane.kw.aT),
								_Utils_Tuple2(a, b));
						} else {
							var _v22 = _v3.a;
							var _v23 = _v22.a;
							var _v24 = _v22.b;
							var _v25 = _v3.b;
							var a = _v25.a.a;
							var _v26 = _v25.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.kw.aT, plane.kw.ar),
								_Utils_Tuple2(a, a));
						}
					} else {
						if (!_v3.b.b.$) {
							var _v27 = _v3.a;
							var _v28 = _v27.a;
							var _v29 = _v27.b;
							var _v30 = _v3.b;
							var _v31 = _v30.a;
							var b = _v30.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.kw.aT, plane.kw.ar),
								_Utils_Tuple2(b, b));
						} else {
							var _v140 = _v3.a;
							var _v141 = _v140.a;
							var _v142 = _v140.b;
							var _v143 = _v3.b;
							var _v144 = _v143.a;
							var _v145 = _v143.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.kw.aT, plane.kw.ar),
								_Utils_Tuple2(plane.kx.aT, plane.kx.ar));
						}
					}
				}
			}
		}();
		var _v1 = _v0.a;
		var x1 = _v1.a;
		var x2 = _v1.b;
		var _v2 = _v0.b;
		var y1 = _v2.a;
		var y2 = _v2.b;
		var x1_ = x1 + A2($terezka$elm_charts$Internal$Svg$lengthInCartesianX, plane, config.H);
		var x2_ = x2 + A2($terezka$elm_charts$Internal$Svg$lengthInCartesianX, plane, config.H);
		var y1_ = y1 - A2($terezka$elm_charts$Internal$Svg$lengthInCartesianY, plane, config.I);
		var y2_ = y2 - A2($terezka$elm_charts$Internal$Svg$lengthInCartesianY, plane, config.I);
		var _v146 = (config.pe > 0) ? _Utils_Tuple2(
			A2(
				$terezka$elm_charts$Internal$Svg$lengthInCartesianX,
				plane,
				$elm$core$Basics$cos(angle) * config.pe),
			A2(
				$terezka$elm_charts$Internal$Svg$lengthInCartesianY,
				plane,
				$elm$core$Basics$sin(angle) * config.pe)) : _Utils_Tuple2(0, 0);
		var tickOffsetX = _v146.a;
		var tickOffsetY = _v146.b;
		var cmds = config.B ? _Utils_ap(
			(config.pe > 0) ? _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x2_ + tickOffsetX, y2_ + tickOffsetY),
					A2($terezka$elm_charts$Internal$Commands$Line, x2_, y2_)
				]) : _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x2_, y2_)
				]),
			_Utils_ap(
				config.kY ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x2_, y1_),
						A2($terezka$elm_charts$Internal$Commands$Line, x1_, y1_)
					]) : _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x1_, y1_)
					]),
				(config.pe > 0) ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x1_ + tickOffsetX, y1_ + tickOffsetY)
					]) : _List_Nil)) : _Utils_ap(
			(config.pe > 0) ? _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x1_ + tickOffsetX, y1_ + tickOffsetY),
					A2($terezka$elm_charts$Internal$Commands$Line, x1_, y1_)
				]) : _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x1_, y1_)
				]),
			_Utils_ap(
				config.kY ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x1_, y2_),
						A2($terezka$elm_charts$Internal$Commands$Line, x2_, y2_)
					]) : _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x2_, y2_)
					]),
				(config.pe > 0) ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x2_ + tickOffsetX, y2_ + tickOffsetY)
					]) : _List_Nil));
		return A4(
			$terezka$elm_charts$Internal$Svg$withAttrs,
			config.ch,
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('elm-charts__line'),
					$elm$svg$Svg$Attributes$fill('transparent'),
					$elm$svg$Svg$Attributes$stroke(config.cU),
					$elm$svg$Svg$Attributes$strokeWidth(
					$elm$core$String$fromFloat(config.g6)),
					$elm$svg$Svg$Attributes$strokeOpacity(
					$elm$core$String$fromFloat(config.a6)),
					$elm$svg$Svg$Attributes$strokeDasharray(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, $elm$core$String$fromFloat, config.dS))),
					$elm$svg$Svg$Attributes$d(
					A2($terezka$elm_charts$Internal$Commands$description, plane, cmds)),
					config.O ? $terezka$elm_charts$Internal$Svg$withinChartArea(plane) : $elm$svg$Svg$Attributes$class('')
				]),
			_List_Nil);
	});
var $terezka$elm_charts$Chart$Svg$line = F2(
	function (plane, edits) {
		return A2(
			$terezka$elm_charts$Internal$Svg$line,
			plane,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultLine));
	});
var $terezka$elm_charts$Chart$Attributes$size = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{jV: v});
	};
};
var $terezka$elm_charts$Chart$Attributes$width = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{g6: v});
	};
};
var $terezka$elm_charts$Chart$Attributes$x1 = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{
				qa: $elm$core$Maybe$Just(v)
			});
	};
};
var $terezka$elm_charts$Chart$Attributes$y1 = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{
				qf: $elm$core$Maybe$Just(v)
			});
	};
};
var $terezka$elm_charts$Chart$grid = function (edits) {
	var config = A2(
		$terezka$elm_charts$Internal$Helpers$apply,
		edits,
		{cU: '', dS: _List_Nil, c_: false, g6: 0});
	var width = (!config.g6) ? (config.c_ ? 0.5 : 1) : config.g6;
	var color = $elm$core$String$isEmpty(config.cU) ? (config.c_ ? $terezka$elm_charts$Internal$Helpers$darkGray : $terezka$elm_charts$Internal$Helpers$gray) : config.cU;
	var toDot = F4(
		function (vs, p, x, y) {
			return (A2($elm$core$List$member, x, vs.dB) || A2($elm$core$List$member, y, vs.dC)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A5(
					$terezka$elm_charts$Chart$Svg$dot,
					p,
					function ($) {
						return $.kw;
					},
					function ($) {
						return $.kx;
					},
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(color),
							$terezka$elm_charts$Chart$Attributes$size(width),
							$terezka$elm_charts$Chart$Attributes$circle
						]),
					{kw: x, kx: y}));
		});
	var toXGrid = F3(
		function (vs, p, v) {
			return A2($elm$core$List$member, v, vs.dB) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$terezka$elm_charts$Chart$Svg$line,
					p,
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(color),
							$terezka$elm_charts$Chart$Attributes$width(width),
							$terezka$elm_charts$Chart$Attributes$x1(v),
							$terezka$elm_charts$Chart$Attributes$dashed(config.dS)
						])));
		});
	var toYGrid = F3(
		function (vs, p, v) {
			return A2($elm$core$List$member, v, vs.dC) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$terezka$elm_charts$Chart$Svg$line,
					p,
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(color),
							$terezka$elm_charts$Chart$Attributes$width(width),
							$terezka$elm_charts$Chart$Attributes$y1(v),
							$terezka$elm_charts$Chart$Attributes$dashed(config.dS)
						])));
		});
	return $terezka$elm_charts$Chart$GridElement(
		F2(
			function (p, vs) {
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__grid')
						]),
					config.c_ ? A2(
						$elm$core$List$concatMap,
						function (x) {
							return A2(
								$elm$core$List$filterMap,
								A3(toDot, vs, p, x),
								vs.aY);
						},
						vs.aA) : _List_fromArray(
						[
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('elm-charts__x-grid')
								]),
							A2(
								$elm$core$List$filterMap,
								A2(toXGrid, vs, p),
								vs.aA)),
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('elm-charts__y-grid')
								]),
							A2(
								$elm$core$List$filterMap,
								A2(toYGrid, vs, p),
								vs.aY))
						]));
			}));
};
var $terezka$elm_charts$Chart$viewElements = F6(
	function (config, plane, tickValues, allItems, allLegends, elements) {
		var viewOne = F2(
			function (el, _v0) {
				var before = _v0.a;
				var chart_ = _v0.b;
				var after = _v0.c;
				switch (el.$) {
					case 0:
						return _Utils_Tuple3(before, chart_, after);
					case 1:
						var view = el.d;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 2:
						var view = el.e;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 3:
						var view = el.b;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 4:
						var view = el.b;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 5:
						var view = el.b;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 6:
						var toC = el.a;
						var view = el.c;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(
									view,
									plane,
									toC(plane)),
								chart_),
							after);
					case 7:
						var toC = el.a;
						var view = el.c;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(
									view,
									plane,
									toC(plane)),
								chart_),
							after);
					case 8:
						var toC = el.a;
						var view = el.c;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(
									view,
									plane,
									toC(plane)),
								chart_),
							after);
					case 9:
						var view = el.a;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(view, plane, tickValues),
								chart_),
							after);
					case 10:
						var func = el.a;
						return A3(
							$elm$core$List$foldr,
							viewOne,
							_Utils_Tuple3(before, chart_, after),
							A2(func, plane, allItems));
					case 11:
						var els = el.a;
						return A3(
							$elm$core$List$foldr,
							viewOne,
							_Utils_Tuple3(before, chart_, after),
							els);
					case 12:
						var view = el.a;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					default:
						var view = el.a;
						return _Utils_Tuple3(
							($elm$core$List$length(chart_) > 0) ? A2(
								$elm$core$List$cons,
								A2(view, plane, allLegends),
								before) : before,
							chart_,
							($elm$core$List$length(chart_) > 0) ? after : A2(
								$elm$core$List$cons,
								A2(view, plane, allLegends),
								after));
				}
			});
		return A3(
			$elm$core$List$foldr,
			viewOne,
			_Utils_Tuple3(_List_Nil, _List_Nil, _List_Nil),
			elements);
	});
var $terezka$elm_charts$Chart$chart = F2(
	function (edits, unindexedElements) {
		var indexedElements = function () {
			var toIndexedEl = F2(
				function (el, _v4) {
					var acc = _v4.a;
					var index = _v4.b;
					switch (el.$) {
						case 0:
							var toElAndIndex = el.a;
							var _v6 = toElAndIndex(index);
							var newEl = _v6.a;
							var newIndex = _v6.b;
							return _Utils_Tuple2(
								_Utils_ap(
									acc,
									_List_fromArray(
										[newEl])),
								newIndex);
						case 11:
							var els = el.a;
							return A3(
								$elm$core$List$foldl,
								toIndexedEl,
								_Utils_Tuple2(acc, index),
								els);
						default:
							return _Utils_Tuple2(
								_Utils_ap(
									acc,
									_List_fromArray(
										[el])),
								index);
					}
				});
			return A3(
				$elm$core$List$foldl,
				toIndexedEl,
				_Utils_Tuple2(_List_Nil, 0),
				unindexedElements).a;
		}();
		var elements = function () {
			var isGrid = function (el) {
				if (el.$ === 9) {
					return true;
				} else {
					return false;
				}
			};
			return A2($elm$core$List$any, isGrid, indexedElements) ? indexedElements : A2(
				$elm$core$List$cons,
				$terezka$elm_charts$Chart$grid(_List_Nil),
				indexedElements);
		}();
		var legends_ = $terezka$elm_charts$Chart$getLegends(elements);
		var config = A2(
			$terezka$elm_charts$Internal$Helpers$apply,
			edits,
			{
				ch: _List_fromArray(
					[
						$elm$svg$Svg$Attributes$style('overflow: visible;')
					]),
				fc: _List_Nil,
				dZ: _List_Nil,
				fx: 300,
				d2: _List_Nil,
				bW: {ho: 0, iL: 0, jD: 0, kc: 0},
				a8: {ho: 0, iL: 0, jD: 0, kc: 0},
				gm: _List_Nil,
				eq: true,
				g6: 300
			});
		var plane = A2($terezka$elm_charts$Chart$definePlane, config, elements);
		var items = A2($terezka$elm_charts$Chart$getItems, plane, elements);
		var toEvent = function (_v2) {
			var event_ = _v2;
			var _v1 = event_.e;
			var decoder = _v1;
			return A2(
				$terezka$elm_charts$Internal$Svg$Event,
				event_.aJ,
				decoder(items));
		};
		var tickValues = A3($terezka$elm_charts$Chart$getTickValues, plane, items, elements);
		var _v0 = A6($terezka$elm_charts$Chart$viewElements, config, plane, tickValues, items, legends_, elements);
		var beforeEls = _v0.a;
		var chartEls = _v0.b;
		var afterEls = _v0.c;
		return A5(
			$terezka$elm_charts$Internal$Svg$container,
			plane,
			{
				ch: config.ch,
				dZ: A2($elm$core$List$map, toEvent, config.dZ),
				d2: config.d2,
				eq: config.eq
			},
			beforeEls,
			chartEls,
			afterEls);
	});
var $author$project$UI$Library$Chart$Msg$SetCustomFromDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$UI$Library$Chart$Msg$SetCustomToDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$UI$Library$Chart$View$customDateRangeInputs = function (config) {
	var dateInput = F5(
		function (labelText, inputValue, minDateValue, maxDateValue, toMsg) {
			return A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center gap-1 text-10 text-gray-400')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(labelText)
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('date'),
								$elm$html$Html$Attributes$value(inputValue),
								$elm$html$Html$Attributes$min(minDateValue),
								$elm$html$Html$Attributes$max(maxDateValue),
								$elm$html$Html$Attributes$disabled(!config.c0),
								$elm$html$Html$Attributes$class('h-4 px-1 rounded border border-gray-700 bg-gray-900 text-10 text-white focus:outline-none focus:ring-1 focus:ring-green-500'),
								A2($elm$html$Html$Attributes$style, 'color-scheme', 'dark'),
								$elm$html$Html$Events$onInput(toMsg)
							]),
						_List_Nil)
					]));
		});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-wrap items-center justify-end gap-2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-10 uppercase tracking-wide text-gray-600')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Date')
					])),
				A5(dateInput, 'From', config.fo, '', config.gY, $author$project$UI$Library$Chart$Msg$SetCustomFromDate),
				A5(dateInput, 'To', config.gY, config.fo, '', $author$project$UI$Library$Chart$Msg$SetCustomToDate)
			]));
};
var $author$project$UI$Library$Chart$Model$periodDurationMillis = function (period) {
	switch (period) {
		case 0:
			return (60 * 60) * 1000;
		case 1:
			return ((24 * 60) * 60) * 1000;
		case 2:
			return (((7 * 24) * 60) * 60) * 1000;
		case 3:
			return (((30 * 24) * 60) * 60) * 1000;
		default:
			return (((30 * 24) * 60) * 60) * 1000;
	}
};
var $author$project$UI$Library$Chart$View$dataForVisiblePeriod = F5(
	function (zone, visiblePeriod, customFromDate, customToDate, chartData) {
		switch (visiblePeriod) {
			case 3:
				return chartData;
			case 4:
				return ($elm$core$String$isEmpty(customFromDate) || $elm$core$String$isEmpty(customToDate)) ? chartData : A2(
					$elm$core$List$filter,
					function (point) {
						var date = A2($author$project$UI$Library$Chart$Model$chartPointDate, zone, point);
						return (_Utils_cmp(date, customFromDate) > -1) && (_Utils_cmp(date, customToDate) < 1);
					},
					chartData);
			default:
				var _v1 = $author$project$UI$Library$Chart$Model$latestChartPoint(chartData);
				if (!_v1.$) {
					var latestPoint = _v1.a;
					var cutoffMillis = $elm$time$Time$posixToMillis(latestPoint.ph) - $author$project$UI$Library$Chart$Model$periodDurationMillis(visiblePeriod);
					return A2(
						$elm$core$List$filter,
						function (point) {
							return _Utils_cmp(
								$elm$time$Time$posixToMillis(point.ph),
								cutoffMillis) > -1;
						},
						chartData);
				} else {
					return _List_Nil;
				}
		}
	});
var $terezka$elm_charts$Internal$Many$Remodel = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $terezka$elm_charts$Internal$Coordinates$center = function (pos) {
	return {kw: pos.qa + ((pos.qb - pos.qa) / 2), kx: pos.qf + ((pos.qg - pos.qf) / 2)};
};
var $terezka$elm_charts$Internal$Many$fromPoint = function (point) {
	return {qa: point.kw, qb: point.kw, qf: point.kx, qg: point.kx};
};
var $terezka$elm_charts$Internal$Item$getPosition = F2(
	function (plane, _v0) {
		var item = _v0.b;
		return item.pr(plane);
	});
var $terezka$elm_charts$Internal$Item$Dot = function (a) {
	return {$: 0, a: a};
};
var $terezka$elm_charts$Internal$Item$Rendered = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $terezka$elm_charts$Internal$Item$isDot = function (_v0) {
	var meta = _v0.a;
	var item = _v0.b;
	var _v1 = meta.n2;
	if (!_v1.$) {
		var dot = _v1.a;
		return $elm$core$Maybe$Just(
			A2(
				$terezka$elm_charts$Internal$Item$Rendered,
				{cU: meta.cU, lz: meta.lz, mv: meta.mv, mL: meta.mL, aJ: meta.aJ, n2: dot, pl: $terezka$elm_charts$Internal$Item$Dot, pE: meta.pE, qa: meta.qa, qb: meta.qb, kx: meta.kx},
				item));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $terezka$elm_charts$Internal$Many$dots = function () {
	var centerPosition = F2(
		function (plane, item) {
			return $terezka$elm_charts$Internal$Many$fromPoint(
				$terezka$elm_charts$Internal$Coordinates$center(
					A2($terezka$elm_charts$Internal$Item$getPosition, plane, item)));
		});
	return A2(
		$terezka$elm_charts$Internal$Many$Remodel,
		centerPosition,
		$elm$core$List$filterMap($terezka$elm_charts$Internal$Item$isDot));
}();
var $terezka$elm_charts$Chart$Item$dots = $terezka$elm_charts$Internal$Many$dots;
var $author$project$UI$Library$Chart$View$dedupeConsecutiveInts = function (indices) {
	return $elm$core$List$reverse(
		A3(
			$elm$core$List$foldl,
			F2(
				function (index, dedupedIndices) {
					if (dedupedIndices.b) {
						var latestIndex = dedupedIndices.a;
						return _Utils_eq(latestIndex, index) ? dedupedIndices : A2($elm$core$List$cons, index, dedupedIndices);
					} else {
						return _List_fromArray(
							[index]);
					}
				}),
			_List_Nil,
			indices));
};
var $author$project$UI$Library$Chart$View$downsampleChartData = F2(
	function (maxPoints, points) {
		var totalPoints = $elm$core$List$length(points);
		if ((_Utils_cmp(totalPoints, maxPoints) < 1) || (maxPoints < 3)) {
			return points;
		} else {
			var pointsArray = $elm$core$Array$fromList(points);
			var lastIndex = totalPoints - 1;
			var step = lastIndex / (maxPoints - 1);
			var sampledIndices = $author$project$UI$Library$Chart$View$dedupeConsecutiveInts(
				A2(
					$elm$core$List$map,
					function (sampleIndex) {
						return A2(
							$elm$core$Basics$min,
							lastIndex,
							$elm$core$Basics$round(sampleIndex * step));
					},
					A2($elm$core$List$range, 0, maxPoints - 1)));
			return A2(
				$elm$core$List$filterMap,
				function (index) {
					return A2($elm$core$Array$get, index, pointsArray);
				},
				sampledIndices);
		}
	});
var $terezka$elm_charts$Chart$Attributes$fontSize = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{
				N: $elm$core$Maybe$Just(v)
			});
	};
};
var $terezka$elm_charts$Chart$Attributes$format = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{
				ih: $elm$core$Maybe$Just(v)
			});
	};
};
var $author$project$UI$Library$Chart$View$monthToInt = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $author$project$UI$Library$Chart$View$formatAxisTimestamp = F3(
	function (zone, spanMillis, posix) {
		var month = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				$author$project$UI$Library$Chart$View$monthToInt(
					A2($elm$time$Time$toMonth, zone, posix))));
		var minute = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toMinute, zone, posix)));
		var hour = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toHour, zone, posix)));
		var day = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toDay, zone, posix)));
		return (_Utils_cmp(spanMillis, ((36 * 60) * 60) * 1000) < 1) ? (hour + (':' + minute)) : ((_Utils_cmp(spanMillis, (((10 * 24) * 60) * 60) * 1000) < 1) ? (day + ('/' + (month + (' ' + (hour + (':' + minute)))))) : (day + ('/' + month)));
	});
var $terezka$elm_charts$Internal$Events$Decoder = $elm$core$Basics$identity;
var $terezka$elm_charts$Internal$Many$apply = F2(
	function (_v0, items) {
		var func = _v0.b;
		return func(items);
	});
var $terezka$elm_charts$Internal$Svg$closestPoint = F2(
	function (pos, searched) {
		return {
			kw: A3($elm$core$Basics$clamp, pos.qa, pos.qb, searched.kw),
			kx: A3($elm$core$Basics$clamp, pos.qf, pos.qg, searched.kx)
		};
	});
var $terezka$elm_charts$Internal$Svg$distanceX = F3(
	function (plane, searched, point) {
		return $elm$core$Basics$abs(
			A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, point.kw) - A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, searched.kw));
	});
var $terezka$elm_charts$Internal$Svg$distanceY = F3(
	function (plane, searched, point) {
		return $elm$core$Basics$abs(
			A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, point.kx) - A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, searched.kx));
	});
var $terezka$elm_charts$Internal$Svg$distanceSquared = F3(
	function (plane, searched, point) {
		return A2(
			$elm$core$Basics$pow,
			A3($terezka$elm_charts$Internal$Svg$distanceX, plane, searched, point),
			2) + A2(
			$elm$core$Basics$pow,
			A3($terezka$elm_charts$Internal$Svg$distanceY, plane, searched, point),
			2);
	});
var $terezka$elm_charts$Internal$Svg$keepOne = function (toPosition) {
	var toArea = function (a) {
		return function (pos) {
			return (pos.qa - pos.qb) * (pos.qf - pos.qg);
		}(
			toPosition(a));
	};
	var func = F2(
		function (one, acc) {
			var _v0 = $elm$core$List$head(acc);
			if (_v0.$ === 1) {
				return _List_fromArray(
					[one]);
			} else {
				var other = _v0.a;
				return _Utils_eq(
					toPosition(other),
					toPosition(one)) ? A2($elm$core$List$cons, other, acc) : ((_Utils_cmp(
					toArea(other),
					toArea(one)) > 0) ? _List_fromArray(
					[one]) : acc);
			}
		});
	return A2($elm$core$List$foldr, func, _List_Nil);
};
var $terezka$elm_charts$Internal$Svg$getNearestHelp = F4(
	function (toPosition, items, plane, searched) {
		var toPoint = function (i) {
			return A2(
				$terezka$elm_charts$Internal$Svg$closestPoint,
				toPosition(i),
				searched);
		};
		var distanceSquared_ = A2($terezka$elm_charts$Internal$Svg$distanceSquared, plane, searched);
		var getClosest = F2(
			function (item, allClosest) {
				var _v0 = $elm$core$List$head(allClosest);
				if (!_v0.$) {
					var closest = _v0.a;
					return _Utils_eq(
						toPoint(closest),
						toPoint(item)) ? A2($elm$core$List$cons, item, allClosest) : ((_Utils_cmp(
						distanceSquared_(
							toPoint(closest)),
						distanceSquared_(
							toPoint(item))) > 0) ? _List_fromArray(
						[item]) : allClosest);
				} else {
					return _List_fromArray(
						[item]);
				}
			});
		return A2(
			$terezka$elm_charts$Internal$Svg$keepOne,
			toPosition,
			A3($elm$core$List$foldl, getClosest, _List_Nil, items));
	});
var $terezka$elm_charts$Internal$Svg$getNearest = F4(
	function (toPosition, items, plane, searched) {
		return A4($terezka$elm_charts$Internal$Svg$getNearestHelp, toPosition, items, plane, searched);
	});
var $terezka$elm_charts$Internal$Events$getNearest = function (grouping) {
	var toPos = grouping.a;
	return F2(
		function (items, plane) {
			var groups = A2($terezka$elm_charts$Internal$Many$apply, grouping, items);
			return A3(
				$terezka$elm_charts$Internal$Svg$getNearest,
				toPos(plane),
				groups,
				plane);
		});
};
var $terezka$elm_charts$Chart$Events$getNearest = $terezka$elm_charts$Internal$Events$getNearest;
var $author$project$UI$Library$Chart$View$hasMultiplePoints = function (points) {
	if (points.b && points.b.b) {
		var _v1 = points.b;
		return true;
	} else {
		return false;
	}
};
var $terezka$elm_charts$Chart$Attributes$height = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{fx: v});
	};
};
var $terezka$elm_charts$Chart$Attributes$background = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{hi: v});
	};
};
var $terezka$elm_charts$Chart$SubElements = function (a) {
	return {$: 10, a: a};
};
var $terezka$elm_charts$Chart$each = F2(
	function (items, func) {
		return $terezka$elm_charts$Chart$SubElements(
			F2(
				function (p, _v0) {
					return A2(
						$elm$core$List$concatMap,
						func(p),
						items);
				}));
	});
var $author$project$UI$Library$Chart$View$formatFullTimestamp = F2(
	function (zone, posix) {
		var year = $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, posix));
		var second = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toSecond, zone, posix)));
		var month = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				$author$project$UI$Library$Chart$View$monthToInt(
					A2($elm$time$Time$toMonth, zone, posix))));
		var minute = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toMinute, zone, posix)));
		var hour = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toHour, zone, posix)));
		var day = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toDay, zone, posix)));
		return day + ('/' + (month + ('/' + (year + (' ' + (hour + (':' + (minute + (':' + second)))))))));
	});
var $terezka$elm_charts$Internal$Item$getDatum = function (_v0) {
	var meta = _v0.a;
	return meta.lz;
};
var $terezka$elm_charts$Chart$Item$getData = $terezka$elm_charts$Internal$Item$getDatum;
var $terezka$elm_charts$Chart$HtmlElement = function (a) {
	return {$: 13, a: a};
};
var $terezka$elm_charts$Chart$html = function (func) {
	return $terezka$elm_charts$Chart$HtmlElement(
		F2(
			function (p, _v0) {
				return func(p);
			}));
};
var $terezka$elm_charts$Internal$Svg$defaultTooltip = {cg: true, hi: 'white', ap: '#D8D8D8', fa: $elm$core$Maybe$Nothing, l2: $elm$core$Maybe$Nothing, fx: 0, j: 8, g6: 0};
var $terezka$elm_charts$Internal$Svg$Bottom = 3;
var $terezka$elm_charts$Internal$Svg$Left = 1;
var $terezka$elm_charts$Internal$Svg$Right = 2;
var $terezka$elm_charts$Internal$Svg$Top = 0;
var $terezka$elm_charts$Internal$Coordinates$bottom = function (pos) {
	return {kw: pos.qa + ((pos.qb - pos.qa) / 2), kx: pos.qf};
};
var $terezka$elm_charts$Internal$Coordinates$left = function (pos) {
	return {kw: pos.qa, kx: pos.qf + ((pos.qg - pos.qf) / 2)};
};
var $terezka$elm_charts$Internal$Svg$positionHtml = F7(
	function (plane, x, y, xOff, yOff, attrs, content) {
		var yPercentage = ((A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y) - yOff) * 100) / plane.kx.fP;
		var xPercentage = ((A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x) + xOff) * 100) / plane.kw.fP;
		var posititonStyles = _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'left',
				$elm$core$String$fromFloat(xPercentage) + '%'),
				A2(
				$elm$html$Html$Attributes$style,
				'top',
				$elm$core$String$fromFloat(yPercentage) + '%'),
				A2($elm$html$Html$Attributes$style, 'margin-right', '-400px'),
				A2($elm$html$Html$Attributes$style, 'position', 'absolute')
			]);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(posititonStyles, attrs),
			content);
	});
var $terezka$elm_charts$Internal$Coordinates$right = function (pos) {
	return {kw: pos.qb, kx: pos.qf + ((pos.qg - pos.qf) / 2)};
};
var $terezka$elm_charts$Internal$Svg$tooltipPointerStyle = F4(
	function (direction, className, background, borderColor) {
		var config = function () {
			switch (direction) {
				case 0:
					return {bL: 'right', aZ: 'top', bf: 'left'};
				case 3:
					return {bL: 'right', aZ: 'bottom', bf: 'left'};
				case 1:
					return {bL: 'bottom', aZ: 'left', bf: 'top'};
				case 2:
					return {bL: 'bottom', aZ: 'right', bf: 'top'};
				case 4:
					return {bL: 'bottom', aZ: 'left', bf: 'top'};
				default:
					return {bL: 'right', aZ: 'top', bf: 'left'};
			}
		}();
		return '\n  .' + (className + (':before, .' + (className + (':after {\n    content: "";\n    position: absolute;\n    border-' + (config.bf + (': 5px solid transparent;\n    border-' + (config.bL + (': 5px solid transparent;\n    ' + (config.aZ + (': 100%;\n    ' + (config.bf + (': 50%;\n    margin-' + (config.bf + (': -5px;\n  }\n\n  .' + (className + (':after {\n    border-' + (config.aZ + (': 5px solid ' + (background + (';\n    margin-' + (config.aZ + (': -1px;\n    z-index: 1;\n    height: 0px;\n  }\n\n  .' + (className + (':before {\n    border-' + (config.aZ + (': 5px solid ' + (borderColor + ';\n    height: 0px;\n  }\n  ')))))))))))))))))))))))))));
	});
var $terezka$elm_charts$Internal$Coordinates$top = function (pos) {
	return {kw: pos.qa + ((pos.qb - pos.qa) / 2), kx: pos.qg};
};
var $terezka$elm_charts$Internal$Svg$tooltip = F5(
	function (plane, pos, config, htmlAttrs, content) {
		var distanceTop = A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, pos.qg);
		var distanceRight = plane.kw.fP - A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, pos.qa);
		var distanceLeft = A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, pos.qb);
		var distanceBottom = plane.kx.fP - A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, pos.qf);
		var direction = function () {
			var _v5 = config.fa;
			if (!_v5.$) {
				switch (_v5.a) {
					case 4:
						var _v6 = _v5.a;
						return (config.g6 > 0) ? ((_Utils_cmp(distanceLeft, config.g6 + config.j) > 0) ? 1 : 2) : ((_Utils_cmp(distanceLeft, distanceRight) > 0) ? 1 : 2);
					case 5:
						var _v7 = _v5.a;
						return (config.fx > 0) ? ((_Utils_cmp(distanceTop, config.fx + config.j) > 0) ? 0 : 3) : ((_Utils_cmp(distanceTop, distanceBottom) > 0) ? 0 : 3);
					default:
						var dir = _v5.a;
						return dir;
				}
			} else {
				var isLargest = function (a) {
					return $elm$core$List$all(
						function (b) {
							return _Utils_cmp(a, b) > -1;
						});
				};
				return A2(
					isLargest,
					distanceTop,
					_List_fromArray(
						[distanceBottom, distanceLeft, distanceRight])) ? 0 : (A2(
					isLargest,
					distanceBottom,
					_List_fromArray(
						[distanceTop, distanceLeft, distanceRight])) ? 3 : (A2(
					isLargest,
					distanceLeft,
					_List_fromArray(
						[distanceTop, distanceBottom, distanceRight])) ? 1 : 2));
			}
		}();
		var focalPoint = function () {
			var _v2 = config.l2;
			if (!_v2.$) {
				var focal = _v2.a;
				switch (direction) {
					case 0:
						return $terezka$elm_charts$Internal$Coordinates$top(
							focal(pos));
					case 3:
						return $terezka$elm_charts$Internal$Coordinates$bottom(
							focal(pos));
					case 1:
						return $terezka$elm_charts$Internal$Coordinates$left(
							focal(pos));
					case 2:
						return $terezka$elm_charts$Internal$Coordinates$right(
							focal(pos));
					case 4:
						return $terezka$elm_charts$Internal$Coordinates$left(
							focal(pos));
					default:
						return $terezka$elm_charts$Internal$Coordinates$right(
							focal(pos));
				}
			} else {
				switch (direction) {
					case 0:
						return $terezka$elm_charts$Internal$Coordinates$top(pos);
					case 3:
						return $terezka$elm_charts$Internal$Coordinates$bottom(pos);
					case 1:
						return $terezka$elm_charts$Internal$Coordinates$left(pos);
					case 2:
						return $terezka$elm_charts$Internal$Coordinates$right(pos);
					case 4:
						return $terezka$elm_charts$Internal$Coordinates$left(pos);
					default:
						return $terezka$elm_charts$Internal$Coordinates$right(pos);
				}
			}
		}();
		var arrowWidth = config.cg ? 4 : 0;
		var _v0 = function () {
			switch (direction) {
				case 0:
					return {bO: 'elm-charts__tooltip-top', ca: 'translate(-50%, -100%)', H: 0, I: config.j + arrowWidth};
				case 3:
					return {bO: 'elm-charts__tooltip-bottom', ca: 'translate(-50%, 0%)', H: 0, I: (-config.j) - arrowWidth};
				case 1:
					return {bO: 'elm-charts__tooltip-left', ca: 'translate(-100%, -50%)', H: (-config.j) - arrowWidth, I: 0};
				case 2:
					return {bO: 'elm-charts__tooltip-right', ca: 'translate(0, -50%)', H: config.j + arrowWidth, I: 0};
				case 4:
					return {bO: 'elm-charts__tooltip-leftOrRight', ca: 'translate(0, -50%)', H: (-config.j) - arrowWidth, I: 0};
				default:
					return {bO: 'elm-charts__tooltip-topOrBottom', ca: 'translate(-50%, -100%)', H: 0, I: config.j + arrowWidth};
			}
		}();
		var xOff = _v0.H;
		var yOff = _v0.I;
		var transformation = _v0.ca;
		var className = _v0.bO;
		var children = config.cg ? A2(
			$elm$core$List$cons,
			A3(
				$elm$html$Html$node,
				'style',
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A4($terezka$elm_charts$Internal$Svg$tooltipPointerStyle, direction, className, config.hi, config.ap))
					])),
			content) : content;
		var attributes = _Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className),
					A2($elm$html$Html$Attributes$style, 'transform', transformation),
					A2($elm$html$Html$Attributes$style, 'padding', '5px 8px'),
					A2($elm$html$Html$Attributes$style, 'background', config.hi),
					A2($elm$html$Html$Attributes$style, 'border', '1px solid ' + config.ap),
					A2($elm$html$Html$Attributes$style, 'border-radius', '3px'),
					A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
				]),
			htmlAttrs);
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A7($terezka$elm_charts$Internal$Svg$positionHtml, plane, focalPoint.kw, focalPoint.kx, xOff, yOff, attributes, children));
	});
var $terezka$elm_charts$Chart$Svg$tooltip = F3(
	function (plane, pos, edits) {
		return A3(
			$terezka$elm_charts$Internal$Svg$tooltip,
			plane,
			pos,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultTooltip));
	});
var $terezka$elm_charts$Internal$Item$tooltip = function (_v0) {
	var item = _v0.b;
	return item.pA(0);
};
var $terezka$elm_charts$Chart$tooltip = F4(
	function (i, edits, attrs_, content) {
		return $terezka$elm_charts$Chart$html(
			function (p) {
				var pos = $terezka$elm_charts$Internal$Item$getLimits(i);
				var content_ = _Utils_eq(content, _List_Nil) ? $terezka$elm_charts$Internal$Item$tooltip(i) : content;
				return A3($terezka$elm_charts$Internal$Svg$isWithinPlane, p, pos.qa, pos.qg) ? A5(
					$terezka$elm_charts$Chart$Svg$tooltip,
					p,
					A2($terezka$elm_charts$Internal$Item$getPosition, p, i),
					edits,
					attrs_,
					content_) : $elm$html$Html$text('');
			});
	});
var $author$project$UI$Library$Chart$View$hoverTooltips = F3(
	function (zone, hovering, formatHashrate) {
		return _List_fromArray(
			[
				A2(
				$terezka$elm_charts$Chart$each,
				hovering,
				F2(
					function (_v0, item) {
						var point = $terezka$elm_charts$Chart$Item$getData(item);
						var pplnsText = 'PPLNS: ' + formatHashrate(point.n$);
						var timeText = A2($author$project$UI$Library$Chart$View$formatFullTimestamp, zone, point.ph);
						var fppsText = 'FPPS: ' + formatHashrate(point.l6);
						return _List_fromArray(
							[
								A4(
								$terezka$elm_charts$Chart$tooltip,
								item,
								_List_fromArray(
									[
										$terezka$elm_charts$Chart$Attributes$background('#0E0F12')
									]),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-white px-3 py-2 rounded shadow-lg border border-gray-600')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-14 font-medium')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(pplnsText + (' at ' + timeText))
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(fppsText)
													]))
											]))
									]))
							]);
					}))
			]);
	});
var $terezka$elm_charts$Internal$Svg$Linear = 0;
var $terezka$elm_charts$Chart$Attributes$linear = function (config) {
	return _Utils_update(
		config,
		{
			f: $elm$core$Maybe$Just(0)
		});
};
var $terezka$elm_charts$Internal$Property$NotStacked = function (a) {
	return {$: 0, a: a};
};
var $terezka$elm_charts$Internal$Property$notStacked = F3(
	function (toY, interpolation, presentation) {
		return $terezka$elm_charts$Internal$Property$NotStacked(
			{
				mA: interpolation,
				n2: presentation,
				eA: toY,
				dv: toY,
				kb: $elm$core$Maybe$Nothing,
				pE: function (datum) {
					return A2(
						$elm$core$Maybe$withDefault,
						'N/A',
						A2(
							$elm$core$Maybe$map,
							$elm$core$String$fromFloat,
							toY(datum)));
				},
				ko: F2(
					function (_v0, _v1) {
						return _List_Nil;
					})
			});
	});
var $terezka$elm_charts$Chart$interpolated = F2(
	function (y, inter) {
		return A2(
			$terezka$elm_charts$Internal$Property$notStacked,
			A2($elm$core$Basics$composeR, y, $elm$core$Maybe$Just),
			_Utils_ap(
				_List_fromArray(
					[$terezka$elm_charts$Chart$Attributes$linear]),
				inter));
	});
var $terezka$elm_charts$Chart$Indexed = function (a) {
	return {$: 0, a: a};
};
var $terezka$elm_charts$Chart$SeriesElement = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $terezka$elm_charts$Internal$Item$generalize = function (_v0) {
	var meta = _v0.a;
	var item = _v0.b;
	return A2(
		$terezka$elm_charts$Internal$Item$Rendered,
		{
			cU: meta.cU,
			lz: meta.lz,
			mv: meta.mv,
			mL: meta.mL,
			aJ: meta.aJ,
			n2: meta.pl(meta.n2),
			pl: $elm$core$Basics$identity,
			pE: meta.pE,
			qa: meta.qa,
			qb: meta.qb,
			kx: meta.kx
		},
		item);
};
var $terezka$elm_charts$Internal$Many$getMembers = function (_v0) {
	var _v1 = _v0.a;
	var x = _v1.a;
	var xs = _v1.b;
	return A2($elm$core$List$cons, x, xs);
};
var $terezka$elm_charts$Internal$Many$generalize = function (many) {
	return A2(
		$elm$core$List$map,
		$terezka$elm_charts$Internal$Item$generalize,
		$terezka$elm_charts$Internal$Many$getMembers(many));
};
var $terezka$elm_charts$Internal$Item$map = F2(
	function (func, _v0) {
		var meta = _v0.a;
		var item = _v0.b;
		return A2(
			$terezka$elm_charts$Internal$Item$Rendered,
			{
				cU: meta.cU,
				lz: func(meta.lz),
				mv: meta.mv,
				mL: meta.mL,
				aJ: meta.aJ,
				n2: meta.n2,
				pl: meta.pl,
				pE: meta.pE,
				qa: meta.qa,
				qb: meta.qb,
				kx: meta.kx
			},
			item);
	});
var $elm$svg$Svg$map = $elm$virtual_dom$VirtualDom$map;
var $terezka$elm_charts$Internal$Item$render = F2(
	function (plane, _v0) {
		var item = _v0.b;
		return A2(
			item.jt,
			plane,
			item.pr(plane));
	});
var $terezka$elm_charts$Internal$Legend$LineLegend = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $terezka$elm_charts$Chart$Attributes$border = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{ap: v});
	};
};
var $terezka$elm_charts$Internal$Svg$defaultInterpolation = {ch: _List_Nil, cU: $terezka$elm_charts$Internal$Helpers$pink, dS: _List_Nil, e8: $elm$core$Maybe$Nothing, f: $elm$core$Maybe$Nothing, a6: 0, g6: 1};
var $terezka$elm_charts$Internal$Helpers$noChange = $elm$core$Basics$identity;
var $terezka$elm_charts$Chart$Attributes$opacity = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{a6: v});
	};
};
var $terezka$elm_charts$Internal$Property$toConfigs = function (property) {
	if (!property.$) {
		var config = property.a;
		return _List_fromArray(
			[config]);
	} else {
		var configs = property.a;
		return configs;
	}
};
var $terezka$elm_charts$Internal$Helpers$blue = '#12A5ED';
var $terezka$elm_charts$Internal$Helpers$brown = '#871c1c';
var $terezka$elm_charts$Internal$Helpers$green = '#71c614';
var $terezka$elm_charts$Internal$Helpers$moss = '#92b42c';
var $terezka$elm_charts$Internal$Helpers$orange = '#FF8400';
var $terezka$elm_charts$Internal$Helpers$purple = '#7b4dff';
var $terezka$elm_charts$Internal$Helpers$red = '#F5325B';
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $terezka$elm_charts$Internal$Helpers$toDefault = F3(
	function (_default, items, index) {
		var dict = $elm$core$Dict$fromList(
			A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, items));
		var numOfItems = $elm$core$Dict$size(dict);
		var itemIndex = index % numOfItems;
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A2($elm$core$Dict$get, itemIndex, dict));
	});
var $terezka$elm_charts$Internal$Helpers$turquoise = '#22d2ba';
var $terezka$elm_charts$Internal$Helpers$yellow = '#FFCA00';
var $terezka$elm_charts$Internal$Helpers$toDefaultColor = A2(
	$terezka$elm_charts$Internal$Helpers$toDefault,
	$terezka$elm_charts$Internal$Helpers$pink,
	_List_fromArray(
		[$terezka$elm_charts$Internal$Helpers$purple, $terezka$elm_charts$Internal$Helpers$pink, $terezka$elm_charts$Internal$Helpers$blue, $terezka$elm_charts$Internal$Helpers$green, $terezka$elm_charts$Internal$Helpers$red, $terezka$elm_charts$Internal$Helpers$yellow, $terezka$elm_charts$Internal$Helpers$turquoise, $terezka$elm_charts$Internal$Helpers$orange, $terezka$elm_charts$Internal$Helpers$moss, $terezka$elm_charts$Internal$Helpers$brown]));
var $terezka$elm_charts$Internal$Legend$toDotLegends = F2(
	function (elIndex, properties) {
		var toInterConfig = function (attrs) {
			return A2($terezka$elm_charts$Internal$Helpers$apply, attrs, $terezka$elm_charts$Internal$Svg$defaultInterpolation);
		};
		var toDotLegend = F3(
			function (props, prop, colorIndex) {
				var defaultOpacity = ($elm$core$List$length(props) > 1) ? 0.4 : 0;
				var interAttr = _Utils_ap(
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(
							$terezka$elm_charts$Internal$Helpers$toDefaultColor(colorIndex)),
							$terezka$elm_charts$Chart$Attributes$opacity(defaultOpacity)
						]),
					prop.mA);
				var interConfig = toInterConfig(interAttr);
				var defaultName = 'Property #' + $elm$core$String$fromInt(colorIndex + 1);
				var defaultAttrs = _List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$color(interConfig.cU),
						$terezka$elm_charts$Chart$Attributes$border(interConfig.cU),
						_Utils_eq(interConfig.f, $elm$core$Maybe$Nothing) ? $terezka$elm_charts$Chart$Attributes$circle : $terezka$elm_charts$Internal$Helpers$noChange
					]);
				var dotAttrs = _Utils_ap(defaultAttrs, prop.n2);
				return A3(
					$terezka$elm_charts$Internal$Legend$LineLegend,
					A2($elm$core$Maybe$withDefault, defaultName, prop.kb),
					interAttr,
					dotAttrs);
			});
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (propIndex, f) {
					return f(elIndex + propIndex);
				}),
			A2(
				$elm$core$List$concatMap,
				function (ps) {
					return A2(
						$elm$core$List$map,
						toDotLegend(ps),
						ps);
				},
				A2($elm$core$List$map, $terezka$elm_charts$Internal$Property$toConfigs, properties)));
	});
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $terezka$elm_charts$Internal$Interpolation$linear = $elm$core$List$map(
	$elm$core$List$map(
		function (_v0) {
			var x = _v0.kw;
			var y = _v0.kx;
			return A2($terezka$elm_charts$Internal$Commands$Line, x, y);
		}));
var $terezka$elm_charts$Internal$Interpolation$First = {$: 0};
var $terezka$elm_charts$Internal$Interpolation$Previous = function (a) {
	return {$: 1, a: a};
};
var $terezka$elm_charts$Internal$Interpolation$monotoneCurve = F4(
	function (point0, point1, tangent0, tangent1) {
		var dx = (point1.kw - point0.kw) / 3;
		return A6($terezka$elm_charts$Internal$Commands$CubicBeziers, point0.kw + dx, point0.kx + (dx * tangent0), point1.kw - dx, point1.kx - (dx * tangent1), point1.kw, point1.kx);
	});
var $terezka$elm_charts$Internal$Interpolation$slope2 = F3(
	function (point0, point1, t) {
		var h = point1.kw - point0.kw;
		return (!(!h)) ? ((((3 * (point1.kx - point0.kx)) / h) - t) / 2) : t;
	});
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $terezka$elm_charts$Internal$Interpolation$sign = function (x) {
	return (x < 0) ? (-1) : 1;
};
var $terezka$elm_charts$Internal$Interpolation$toH = F2(
	function (h0, h1) {
		return (!h0) ? ((h1 < 0) ? (0 * (-1)) : h1) : h0;
	});
var $terezka$elm_charts$Internal$Interpolation$slope3 = F3(
	function (point0, point1, point2) {
		var h1 = point2.kw - point1.kw;
		var h0 = point1.kw - point0.kw;
		var s0h = A2($terezka$elm_charts$Internal$Interpolation$toH, h0, h1);
		var s0 = (point1.kx - point0.kx) / s0h;
		var s1h = A2($terezka$elm_charts$Internal$Interpolation$toH, h1, h0);
		var s1 = (point2.kx - point1.kx) / s1h;
		var p = ((s0 * h1) + (s1 * h0)) / (h0 + h1);
		var slope = ($terezka$elm_charts$Internal$Interpolation$sign(s0) + $terezka$elm_charts$Internal$Interpolation$sign(s1)) * A2(
			$elm$core$Basics$min,
			A2(
				$elm$core$Basics$min,
				$elm$core$Basics$abs(s0),
				$elm$core$Basics$abs(s1)),
			0.5 * $elm$core$Basics$abs(p));
		return $elm$core$Basics$isNaN(slope) ? 0 : slope;
	});
var $terezka$elm_charts$Internal$Interpolation$monotonePart = F2(
	function (points, _v0) {
		var tangent = _v0.a;
		var commands = _v0.b;
		var _v1 = _Utils_Tuple2(tangent, points);
		_v1$4:
		while (true) {
			if (!_v1.a.$) {
				if (_v1.b.b && _v1.b.b.b) {
					if (_v1.b.b.b.b) {
						var _v2 = _v1.a;
						var _v3 = _v1.b;
						var p0 = _v3.a;
						var _v4 = _v3.b;
						var p1 = _v4.a;
						var _v5 = _v4.b;
						var p2 = _v5.a;
						var rest = _v5.b;
						var t1 = A3($terezka$elm_charts$Internal$Interpolation$slope3, p0, p1, p2);
						var t0 = A3($terezka$elm_charts$Internal$Interpolation$slope2, p0, p1, t1);
						return A2(
							$terezka$elm_charts$Internal$Interpolation$monotonePart,
							A2(
								$elm$core$List$cons,
								p1,
								A2($elm$core$List$cons, p2, rest)),
							_Utils_Tuple2(
								$terezka$elm_charts$Internal$Interpolation$Previous(t1),
								_Utils_ap(
									commands,
									_List_fromArray(
										[
											A4($terezka$elm_charts$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1)
										]))));
					} else {
						var _v9 = _v1.a;
						var _v10 = _v1.b;
						var p0 = _v10.a;
						var _v11 = _v10.b;
						var p1 = _v11.a;
						var t1 = A3($terezka$elm_charts$Internal$Interpolation$slope3, p0, p1, p1);
						return _Utils_Tuple2(
							$terezka$elm_charts$Internal$Interpolation$Previous(t1),
							_Utils_ap(
								commands,
								_List_fromArray(
									[
										A4($terezka$elm_charts$Internal$Interpolation$monotoneCurve, p0, p1, t1, t1),
										A2($terezka$elm_charts$Internal$Commands$Line, p1.kw, p1.kx)
									])));
					}
				} else {
					break _v1$4;
				}
			} else {
				if (_v1.b.b && _v1.b.b.b) {
					if (_v1.b.b.b.b) {
						var t0 = _v1.a.a;
						var _v6 = _v1.b;
						var p0 = _v6.a;
						var _v7 = _v6.b;
						var p1 = _v7.a;
						var _v8 = _v7.b;
						var p2 = _v8.a;
						var rest = _v8.b;
						var t1 = A3($terezka$elm_charts$Internal$Interpolation$slope3, p0, p1, p2);
						return A2(
							$terezka$elm_charts$Internal$Interpolation$monotonePart,
							A2(
								$elm$core$List$cons,
								p1,
								A2($elm$core$List$cons, p2, rest)),
							_Utils_Tuple2(
								$terezka$elm_charts$Internal$Interpolation$Previous(t1),
								_Utils_ap(
									commands,
									_List_fromArray(
										[
											A4($terezka$elm_charts$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1)
										]))));
					} else {
						var t0 = _v1.a.a;
						var _v12 = _v1.b;
						var p0 = _v12.a;
						var _v13 = _v12.b;
						var p1 = _v13.a;
						var t1 = A3($terezka$elm_charts$Internal$Interpolation$slope3, p0, p1, p1);
						return _Utils_Tuple2(
							$terezka$elm_charts$Internal$Interpolation$Previous(t1),
							_Utils_ap(
								commands,
								_List_fromArray(
									[
										A4($terezka$elm_charts$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1),
										A2($terezka$elm_charts$Internal$Commands$Line, p1.kw, p1.kx)
									])));
					}
				} else {
					break _v1$4;
				}
			}
		}
		return _Utils_Tuple2(tangent, commands);
	});
var $terezka$elm_charts$Internal$Interpolation$monotoneSection = F2(
	function (points, _v0) {
		var tangent = _v0.a;
		var acc = _v0.b;
		var _v1 = function () {
			if (points.b) {
				var p0 = points.a;
				var rest = points.b;
				return A2(
					$terezka$elm_charts$Internal$Interpolation$monotonePart,
					A2($elm$core$List$cons, p0, rest),
					_Utils_Tuple2(
						tangent,
						_List_fromArray(
							[
								A2($terezka$elm_charts$Internal$Commands$Line, p0.kw, p0.kx)
							])));
			} else {
				return _Utils_Tuple2(tangent, _List_Nil);
			}
		}();
		var t0 = _v1.a;
		var commands = _v1.b;
		return _Utils_Tuple2(
			t0,
			A2($elm$core$List$cons, commands, acc));
	});
var $terezka$elm_charts$Internal$Interpolation$monotone = function (sections) {
	return A3(
		$elm$core$List$foldr,
		$terezka$elm_charts$Internal$Interpolation$monotoneSection,
		_Utils_Tuple2($terezka$elm_charts$Internal$Interpolation$First, _List_Nil),
		sections).b;
};
var $terezka$elm_charts$Internal$Interpolation$Point = F2(
	function (x, y) {
		return {kw: x, kx: y};
	});
var $terezka$elm_charts$Internal$Interpolation$after = F2(
	function (a, b) {
		return _List_fromArray(
			[
				a,
				A2($terezka$elm_charts$Internal$Interpolation$Point, b.kw, a.kx),
				b
			]);
	});
var $terezka$elm_charts$Internal$Interpolation$stepped = function (sections) {
	var expand = F2(
		function (result, section) {
			expand:
			while (true) {
				if (section.b) {
					if (section.b.b) {
						var a = section.a;
						var _v1 = section.b;
						var b = _v1.a;
						var rest = _v1.b;
						var $temp$result = _Utils_ap(
							result,
							A2($terezka$elm_charts$Internal$Interpolation$after, a, b)),
							$temp$section = A2($elm$core$List$cons, b, rest);
						result = $temp$result;
						section = $temp$section;
						continue expand;
					} else {
						var last = section.a;
						return result;
					}
				} else {
					return result;
				}
			}
		});
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			expand(_List_Nil),
			$elm$core$List$map(
				function (_v2) {
					var x = _v2.kw;
					var y = _v2.kx;
					return A2($terezka$elm_charts$Internal$Commands$Line, x, y);
				})),
		sections);
};
var $terezka$elm_charts$Internal$Svg$last = function (list) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$drop,
			$elm$core$List$length(list) - 1,
			list));
};
var $terezka$elm_charts$Internal$Svg$withBorder = F2(
	function (stuff, func) {
		if (stuff.b) {
			var first = stuff.a;
			var rest = stuff.b;
			return $elm$core$Maybe$Just(
				A2(
					func,
					first,
					A2(
						$elm$core$Maybe$withDefault,
						first,
						$terezka$elm_charts$Internal$Svg$last(rest))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $terezka$elm_charts$Internal$Svg$toCommands = F4(
	function (method, toX, toY, data) {
		var toSets = F2(
			function (ps, cmds) {
				return A2(
					$terezka$elm_charts$Internal$Svg$withBorder,
					ps,
					F2(
						function (first, last_) {
							return _Utils_Tuple3(first, cmds, last_);
						}));
			});
		var fold = F2(
			function (datum_, acc) {
				var _v1 = toY(datum_);
				if (!_v1.$) {
					var y_ = _v1.a;
					if (acc.b) {
						var latest = acc.a;
						var rest = acc.b;
						return A2(
							$elm$core$List$cons,
							_Utils_ap(
								latest,
								_List_fromArray(
									[
										{
										kw: toX(datum_),
										kx: y_
									}
									])),
							rest);
					} else {
						return A2(
							$elm$core$List$cons,
							_List_fromArray(
								[
									{
									kw: toX(datum_),
									kx: y_
								}
								]),
							acc);
					}
				} else {
					return A2($elm$core$List$cons, _List_Nil, acc);
				}
			});
		var points = $elm$core$List$reverse(
			A3($elm$core$List$foldl, fold, _List_Nil, data));
		var commands = function () {
			switch (method) {
				case 0:
					return $terezka$elm_charts$Internal$Interpolation$linear(points);
				case 1:
					return $terezka$elm_charts$Internal$Interpolation$monotone(points);
				default:
					return $terezka$elm_charts$Internal$Interpolation$stepped(points);
			}
		}();
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A3($elm$core$List$map2, toSets, points, commands));
	});
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$svg$Svg$linearGradient = $elm$svg$Svg$trustedNode('linearGradient');
var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
var $elm$svg$Svg$pattern = $elm$svg$Svg$trustedNode('pattern');
var $elm$svg$Svg$Attributes$patternTransform = _VirtualDom_attribute('patternTransform');
var $elm$svg$Svg$Attributes$patternUnits = _VirtualDom_attribute('patternUnits');
var $elm$svg$Svg$stop = $elm$svg$Svg$trustedNode('stop');
var $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute('stop-color');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $terezka$elm_charts$Internal$Svg$toPattern = F2(
	function (defaultColor, design) {
		var toPatternId = function (props) {
			return A3(
				$elm$core$String$replace,
				'(',
				'-',
				A3(
					$elm$core$String$replace,
					')',
					'-',
					A3(
						$elm$core$String$replace,
						'.',
						'-',
						A3(
							$elm$core$String$replace,
							',',
							'-',
							A3(
								$elm$core$String$replace,
								' ',
								'-',
								A2(
									$elm$core$String$join,
									'-',
									_Utils_ap(
										_List_fromArray(
											[
												'elm-charts__pattern',
												function () {
												switch (design.$) {
													case 0:
														return 'striped';
													case 1:
														return 'dotted';
													default:
														return 'gradient';
												}
											}()
											]),
										props)))))));
		};
		var toPatternDefs = F4(
			function (id, spacing, rotate, inside) {
				return A2(
					$elm$svg$Svg$defs,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$pattern,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id(id),
									$elm$svg$Svg$Attributes$patternUnits('userSpaceOnUse'),
									$elm$svg$Svg$Attributes$width(
									$elm$core$String$fromFloat(spacing)),
									$elm$svg$Svg$Attributes$height(
									$elm$core$String$fromFloat(spacing)),
									$elm$svg$Svg$Attributes$patternTransform(
									'rotate(' + ($elm$core$String$fromFloat(rotate) + ')'))
								]),
							_List_fromArray(
								[inside]))
						]));
			});
		var _v0 = function () {
			switch (design.$) {
				case 0:
					var edits = design.a;
					var config = A2(
						$terezka$elm_charts$Internal$Helpers$apply,
						edits,
						{cU: defaultColor, S: 45, oZ: 4, g6: 3});
					var theId = toPatternId(
						_List_fromArray(
							[
								config.cU,
								$elm$core$String$fromFloat(config.g6),
								$elm$core$String$fromFloat(config.oZ),
								$elm$core$String$fromFloat(config.S)
							]));
					return _Utils_Tuple2(
						A4(
							toPatternDefs,
							theId,
							config.oZ,
							config.S,
							A2(
								$elm$svg$Svg$line,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$x1('0'),
										$elm$svg$Svg$Attributes$y('0'),
										$elm$svg$Svg$Attributes$x2('0'),
										$elm$svg$Svg$Attributes$y2(
										$elm$core$String$fromFloat(config.oZ)),
										$elm$svg$Svg$Attributes$stroke(config.cU),
										$elm$svg$Svg$Attributes$strokeWidth(
										$elm$core$String$fromFloat(config.g6))
									]),
								_List_Nil)),
						theId);
				case 1:
					var edits = design.a;
					var config = A2(
						$terezka$elm_charts$Internal$Helpers$apply,
						edits,
						{cU: defaultColor, S: 45, oZ: 4, g6: 3});
					var theId = toPatternId(
						_List_fromArray(
							[
								config.cU,
								$elm$core$String$fromFloat(config.g6),
								$elm$core$String$fromFloat(config.oZ),
								$elm$core$String$fromFloat(config.S)
							]));
					return _Utils_Tuple2(
						A4(
							toPatternDefs,
							theId,
							config.oZ,
							config.S,
							A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$fill(config.cU),
										$elm$svg$Svg$Attributes$cx(
										$elm$core$String$fromFloat(config.g6 / 3)),
										$elm$svg$Svg$Attributes$cy(
										$elm$core$String$fromFloat(config.g6 / 3)),
										$elm$svg$Svg$Attributes$r(
										$elm$core$String$fromFloat(config.g6 / 3))
									]),
								_List_Nil)),
						theId);
				default:
					var edits = design.a;
					var colors = _Utils_eq(edits, _List_Nil) ? _List_fromArray(
						[defaultColor, 'white']) : edits;
					var theId = toPatternId(colors);
					var totalColors = $elm$core$List$length(colors);
					var toPercentage = function (i) {
						return (i * 100) / (totalColors - 1);
					};
					var toStop = F2(
						function (i, c) {
							return A2(
								$elm$svg$Svg$stop,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$offset(
										$elm$core$String$fromFloat(
											toPercentage(i)) + '%'),
										$elm$svg$Svg$Attributes$stopColor(c)
									]),
								_List_Nil);
						});
					return _Utils_Tuple2(
						A2(
							$elm$svg$Svg$defs,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$linearGradient,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id(theId),
											$elm$svg$Svg$Attributes$x1('0'),
											$elm$svg$Svg$Attributes$x2('0'),
											$elm$svg$Svg$Attributes$y1('0'),
											$elm$svg$Svg$Attributes$y2('1')
										]),
									A2($elm$core$List$indexedMap, toStop, colors))
								])),
						theId);
			}
		}();
		var patternDefs = _v0.a;
		var patternId = _v0.b;
		return _Utils_Tuple2(patternDefs, 'url(#' + (patternId + ')'));
	});
var $terezka$elm_charts$Internal$Svg$area = F6(
	function (plane, toX, toY2M, toY, config, data) {
		var _v0 = function () {
			var _v1 = config.e8;
			if (_v1.$ === 1) {
				return _Utils_Tuple2(
					$elm$svg$Svg$text(''),
					config.cU);
			} else {
				var design = _v1.a;
				return A2($terezka$elm_charts$Internal$Svg$toPattern, config.cU, design);
			}
		}();
		var patternDefs = _v0.a;
		var fill = _v0.b;
		var view = function (cmds) {
			return A4(
				$terezka$elm_charts$Internal$Svg$withAttrs,
				config.ch,
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__area-section'),
						$elm$svg$Svg$Attributes$fill(fill),
						$elm$svg$Svg$Attributes$fillOpacity(
						$elm$core$String$fromFloat(config.a6)),
						$elm$svg$Svg$Attributes$strokeWidth('0'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$d(
						A2($terezka$elm_charts$Internal$Commands$description, plane, cmds)),
						$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
					]),
				_List_Nil);
		};
		var withUnder = F2(
			function (_v5, _v6) {
				var firstBottom = _v5.a;
				var cmdsBottom = _v5.b;
				var endBottom = _v5.c;
				var firstTop = _v6.a;
				var cmdsTop = _v6.b;
				var endTop = _v6.c;
				return view(
					_Utils_ap(
						_List_fromArray(
							[
								A2($terezka$elm_charts$Internal$Commands$Move, firstBottom.kw, firstBottom.kx),
								A2($terezka$elm_charts$Internal$Commands$Line, firstTop.kw, firstTop.kx)
							]),
						_Utils_ap(
							cmdsTop,
							_Utils_ap(
								_List_fromArray(
									[
										A2($terezka$elm_charts$Internal$Commands$Move, firstBottom.kw, firstBottom.kx)
									]),
								_Utils_ap(
									cmdsBottom,
									_List_fromArray(
										[
											A2($terezka$elm_charts$Internal$Commands$Line, endTop.kw, endTop.kx)
										]))))));
			});
		var withoutUnder = function (_v4) {
			var first = _v4.a;
			var cmds = _v4.b;
			var end = _v4.c;
			return view(
				_Utils_ap(
					_List_fromArray(
						[
							A2($terezka$elm_charts$Internal$Commands$Move, first.kw, 0),
							A2($terezka$elm_charts$Internal$Commands$Line, first.kw, first.kx)
						]),
					_Utils_ap(
						cmds,
						_List_fromArray(
							[
								A2($terezka$elm_charts$Internal$Commands$Line, end.kw, 0)
							]))));
		};
		if (config.a6 <= 0) {
			return $elm$svg$Svg$text('');
		} else {
			var _v2 = config.f;
			if (_v2.$ === 1) {
				return $elm$svg$Svg$text('');
			} else {
				var method = _v2.a;
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__area-sections')
						]),
					function () {
						if (toY2M.$ === 1) {
							return A2(
								$elm$core$List$cons,
								patternDefs,
								A2(
									$elm$core$List$map,
									withoutUnder,
									A4($terezka$elm_charts$Internal$Svg$toCommands, method, toX, toY, data)));
						} else {
							var toY2 = toY2M.a;
							return A2(
								$elm$core$List$cons,
								patternDefs,
								A3(
									$elm$core$List$map2,
									withUnder,
									A4($terezka$elm_charts$Internal$Svg$toCommands, method, toX, toY2, data),
									A4($terezka$elm_charts$Internal$Svg$toCommands, method, toX, toY, data)));
						}
					}());
			}
		}
	});
var $terezka$elm_charts$Internal$Svg$interpolation = F5(
	function (plane, toX, toY, config, data) {
		var view = function (_v1) {
			var first = _v1.a;
			var cmds = _v1.b;
			return A4(
				$terezka$elm_charts$Internal$Svg$withAttrs,
				config.ch,
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__interpolation-section'),
						$elm$svg$Svg$Attributes$fill('transparent'),
						$elm$svg$Svg$Attributes$stroke(config.cU),
						$elm$svg$Svg$Attributes$strokeDasharray(
						A2(
							$elm$core$String$join,
							' ',
							A2($elm$core$List$map, $elm$core$String$fromFloat, config.dS))),
						$elm$svg$Svg$Attributes$strokeWidth(
						$elm$core$String$fromFloat(config.g6)),
						$elm$svg$Svg$Attributes$d(
						A2(
							$terezka$elm_charts$Internal$Commands$description,
							plane,
							A2(
								$elm$core$List$cons,
								A2($terezka$elm_charts$Internal$Commands$Move, first.kw, first.kx),
								cmds))),
						$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
					]),
				_List_Nil);
		};
		var _v0 = config.f;
		if (_v0.$ === 1) {
			return $elm$svg$Svg$text('');
		} else {
			var method = _v0.a;
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__interpolation-sections')
					]),
				A2(
					$elm$core$List$map,
					view,
					A4($terezka$elm_charts$Internal$Svg$toCommands, method, toX, toY, data)));
		}
	});
var $terezka$elm_charts$Internal$Produce$toDefaultName = F2(
	function (ids, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			'Property #' + $elm$core$String$fromInt(ids.kA + 1),
			name);
	});
var $terezka$elm_charts$Internal$Svg$toRadius = F2(
	function (size_, shape) {
		var area_ = (2 * $elm$core$Basics$pi) * size_;
		switch (shape) {
			case 0:
				return $elm$core$Basics$sqrt(area_ / $elm$core$Basics$pi);
			case 1:
				var side = $elm$core$Basics$sqrt(
					(area_ * 4) / $elm$core$Basics$sqrt(3));
				return $elm$core$Basics$sqrt(3) * side;
			case 2:
				return $elm$core$Basics$sqrt(area_) / 2;
			case 3:
				return $elm$core$Basics$sqrt(area_) / 2;
			case 4:
				return $elm$core$Basics$sqrt(area_ / 4);
			default:
				return $elm$core$Basics$sqrt(area_ / 4);
		}
	});
var $terezka$elm_charts$Internal$Produce$tooltipRow = F3(
	function (color, title, text) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', color),
							A2($elm$html$Html$Attributes$style, 'padding', '0'),
							A2($elm$html$Html$Attributes$style, 'padding-right', '3px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title + ':')
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'text-align', 'right'),
							A2($elm$html$Html$Attributes$style, 'padding', '0')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(text)
						]))
				]));
	});
var $terezka$elm_charts$Internal$Helpers$withFirst = F2(
	function (xs, func) {
		if (xs.b) {
			var x = xs.a;
			var rest = xs.b;
			return $elm$core$Maybe$Just(
				A2(func, x, rest));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $terezka$elm_charts$Internal$Produce$toDotSeries = F4(
	function (elementIndex, toX, properties, data) {
		var forEachDataPoint = F9(
			function (absoluteIndex, stackSeriesConfigIndex, lineSeriesConfigIndex, lineSeriesConfig, interpolationConfig, defaultColor, defaultOpacity, dataIndex, datum) {
				var y = A2(
					$elm$core$Maybe$withDefault,
					0,
					lineSeriesConfig.dv(datum));
				var x = toX(datum);
				var identification = {kA: absoluteIndex, hS: dataIndex, lU: elementIndex, oU: lineSeriesConfigIndex, o_: stackSeriesConfigIndex};
				var defaultAttrs = _List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$color(interpolationConfig.cU),
						$terezka$elm_charts$Chart$Attributes$border(interpolationConfig.cU),
						_Utils_eq(interpolationConfig.f, $elm$core$Maybe$Nothing) ? $terezka$elm_charts$Chart$Attributes$circle : $terezka$elm_charts$Internal$Helpers$noChange
					]);
				var dotAttrs = _Utils_ap(
					defaultAttrs,
					_Utils_ap(
						lineSeriesConfig.n2,
						A2(lineSeriesConfig.ko, identification, datum)));
				var dotConfig = A2($terezka$elm_charts$Internal$Helpers$apply, dotAttrs, $terezka$elm_charts$Internal$Svg$defaultDot);
				var radius = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						$terezka$elm_charts$Internal$Svg$toRadius(dotConfig.jV),
						dotConfig.cC));
				var tooltipTextColor = (dotConfig.cU === 'white') ? ((dotConfig.ap === 'white') ? interpolationConfig.cU : dotConfig.ap) : dotConfig.cU;
				return A2(
					$terezka$elm_charts$Internal$Item$Rendered,
					{
						cU: tooltipTextColor,
						lz: datum,
						mv: identification,
						mL: !_Utils_eq(
							lineSeriesConfig.eA(datum),
							$elm$core$Maybe$Nothing),
						aJ: lineSeriesConfig.kb,
						n2: dotConfig,
						pl: $terezka$elm_charts$Internal$Item$Dot,
						pE: lineSeriesConfig.pE(datum),
						qa: x,
						qb: x,
						kx: y
					},
					{
						ae: {qa: x, qb: x, qf: y, qg: y},
						jt: F2(
							function (plane, _v5) {
								var _v6 = lineSeriesConfig.eA(datum);
								if (_v6.$ === 1) {
									return $elm$svg$Svg$text('');
								} else {
									return A5(
										$terezka$elm_charts$Internal$Svg$dot,
										plane,
										function ($) {
											return $.kw;
										},
										function ($) {
											return $.kx;
										},
										dotConfig,
										{kw: x, kx: y});
								}
							}),
						pr: function (plane) {
							var radiusY = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, radius);
							var radiusX = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, radius);
							return {qa: x - radiusX, qb: x + radiusX, qf: y - radiusY, qg: y + radiusY};
						},
						pA: function (_v7) {
							return _List_fromArray(
								[
									A3(
									$terezka$elm_charts$Internal$Produce$tooltipRow,
									tooltipTextColor,
									A2($terezka$elm_charts$Internal$Produce$toDefaultName, identification, lineSeriesConfig.kb),
									lineSeriesConfig.pE(datum))
								]);
						}
					});
			});
		var forEachLine = F5(
			function (isStacked, absoluteIndex, stackSeriesConfigIndex, lineSeriesConfigIndex, lineSeriesConfig) {
				var defaultOpacity = isStacked ? 0.4 : 0;
				var absoluteIndexNew = absoluteIndex + lineSeriesConfigIndex;
				var defaultColor = $terezka$elm_charts$Internal$Helpers$toDefaultColor(absoluteIndexNew);
				var interpolationAttrs = _List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$color(defaultColor),
						$terezka$elm_charts$Chart$Attributes$opacity(defaultOpacity)
					]);
				var interpolationConfig = A2(
					$terezka$elm_charts$Internal$Helpers$apply,
					_Utils_ap(interpolationAttrs, lineSeriesConfig.mA),
					$terezka$elm_charts$Internal$Svg$defaultInterpolation);
				var dotItems = A2(
					$elm$core$List$indexedMap,
					A7(forEachDataPoint, absoluteIndexNew, stackSeriesConfigIndex, lineSeriesConfigIndex, lineSeriesConfig, interpolationConfig, defaultColor, defaultOpacity),
					data);
				var viewSeries = function (plane) {
					var toBottom = function (datum) {
						return A3(
							$elm$core$Maybe$map2,
							F2(
								function (y, ySum) {
									return ySum - y;
								}),
							lineSeriesConfig.eA(datum),
							lineSeriesConfig.dv(datum));
					};
					return A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('elm-charts__series')
							]),
						_List_fromArray(
							[
								A6(
								$terezka$elm_charts$Internal$Svg$area,
								plane,
								toX,
								$elm$core$Maybe$Just(toBottom),
								lineSeriesConfig.dv,
								interpolationConfig,
								data),
								A5($terezka$elm_charts$Internal$Svg$interpolation, plane, toX, lineSeriesConfig.dv, interpolationConfig, data),
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('elm-charts__dots')
									]),
								A2(
									$elm$core$List$map,
									$terezka$elm_charts$Internal$Item$render(plane),
									dotItems))
							]));
				};
				return A2(
					$terezka$elm_charts$Internal$Helpers$withFirst,
					dotItems,
					F2(
						function (first, rest) {
							return A2(
								$terezka$elm_charts$Internal$Item$Rendered,
								_Utils_Tuple2(first, rest),
								{
									ae: A2($terezka$elm_charts$Internal$Coordinates$foldPosition, $terezka$elm_charts$Internal$Item$getLimits, dotItems),
									jt: F2(
										function (plane, _v3) {
											return viewSeries(plane);
										}),
									pr: function (plane) {
										return A2(
											$terezka$elm_charts$Internal$Coordinates$foldPosition,
											$terezka$elm_charts$Internal$Item$getPosition(plane),
											dotItems);
									},
									pA: function (_v4) {
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$table,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'margin', '0')
													]),
												A2($elm$core$List$concatMap, $terezka$elm_charts$Internal$Item$tooltip, dotItems))
											]);
									}
								});
						}));
			});
		var forEachStackSeriesConfig = F2(
			function (stackSeriesConfig, _v2) {
				var absoluteIndex = _v2.a;
				var stackSeriesConfigIndex = _v2.b;
				var items = _v2.c;
				var lineItems = function () {
					if (!stackSeriesConfig.$) {
						var lineSeriesConfig = stackSeriesConfig.a;
						return _List_fromArray(
							[
								A5(forEachLine, false, absoluteIndex, stackSeriesConfigIndex, 0, lineSeriesConfig)
							]);
					} else {
						var lineSeriesConfigs = stackSeriesConfig.a;
						return A2(
							$elm$core$List$indexedMap,
							A3(forEachLine, true, absoluteIndex, stackSeriesConfigIndex),
							lineSeriesConfigs);
					}
				}();
				return _Utils_Tuple3(
					absoluteIndex + $elm$core$List$length(lineItems),
					stackSeriesConfigIndex + 1,
					_Utils_ap(
						items,
						A2($elm$core$List$filterMap, $elm$core$Basics$identity, lineItems)));
			});
		return function (_v0) {
			var items = _v0.c;
			return items;
		}(
			A3(
				$elm$core$List$foldl,
				forEachStackSeriesConfig,
				_Utils_Tuple3(elementIndex, 0, _List_Nil),
				properties));
	});
var $terezka$elm_charts$Chart$seriesMap = F4(
	function (mapData, toX, properties, data) {
		return $terezka$elm_charts$Chart$Indexed(
			function (index) {
				var legends_ = A2($terezka$elm_charts$Internal$Legend$toDotLegends, index, properties);
				var items = A4($terezka$elm_charts$Internal$Produce$toDotSeries, index, toX, properties, data);
				var toLimits = A2($elm$core$List$map, $terezka$elm_charts$Internal$Item$getLimits, items);
				var generalized = A2(
					$elm$core$List$map,
					$terezka$elm_charts$Internal$Item$map(mapData),
					A2($elm$core$List$concatMap, $terezka$elm_charts$Internal$Many$generalize, items));
				return _Utils_Tuple2(
					A4(
						$terezka$elm_charts$Chart$SeriesElement,
						toLimits,
						generalized,
						legends_,
						function (p) {
							return A2(
								$elm$svg$Svg$map,
								$elm$core$Basics$never,
								A2(
									$elm$svg$Svg$g,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('elm-charts__dot-series')
										]),
									A2(
										$elm$core$List$map,
										$terezka$elm_charts$Internal$Item$render(p),
										items)));
						}),
					index + $elm$core$List$length(items));
			});
	});
var $terezka$elm_charts$Chart$series = F3(
	function (toX, properties, data) {
		return A4($terezka$elm_charts$Chart$seriesMap, $elm$core$Basics$identity, toX, properties, data);
	});
var $author$project$UI$Library$Chart$View$invisibleScaleSeries = function (points) {
	return $elm$core$List$isEmpty(points) ? _List_Nil : _List_fromArray(
		[
			A3(
			$terezka$elm_charts$Chart$series,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ph;
				},
				A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$Basics$toFloat)),
			_List_fromArray(
				[
					A3(
					$terezka$elm_charts$Chart$interpolated,
					function ($) {
						return $.n$;
					},
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color('transparent'),
							$terezka$elm_charts$Chart$Attributes$width(0)
						]),
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$circle,
							$terezka$elm_charts$Chart$Attributes$size(0)
						]))
				]),
			points)
		]);
};
var $author$project$UI$Library$Chart$View$legendItem = F2(
	function (color, label) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center gap-1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline-block w-1.5 h-1.5 rounded-full'),
							A2($elm$html$Html$Attributes$style, 'background-color', color)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-12 text-gray-400')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $terezka$elm_charts$Chart$Attributes$margin = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{bW: v});
	};
};
var $author$project$UI$Library$Chart$View$maxRenderablePoints = function (plotWidth) {
	return A2($elm$core$Basics$max, 240, plotWidth);
};
var $terezka$elm_charts$Chart$Attributes$moveDown = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{I: config.I + v});
	};
};
var $terezka$elm_charts$Internal$Events$getCoords = F3(
	function (_v0, plane, searched) {
		return searched;
	});
var $terezka$elm_charts$Chart$Events$getCoords = $terezka$elm_charts$Internal$Events$getCoords;
var $terezka$elm_charts$Internal$Events$map = F2(
	function (f, _v0) {
		var a = _v0;
		return F3(
			function (ps, s, p) {
				return f(
					A3(a, ps, s, p));
			});
	});
var $terezka$elm_charts$Chart$Events$map = $terezka$elm_charts$Internal$Events$map;
var $terezka$elm_charts$Internal$Events$Event = $elm$core$Basics$identity;
var $terezka$elm_charts$Internal$Events$on = F2(
	function (name, decoder) {
		return function (config) {
			return _Utils_update(
				config,
				{
					dZ: A2(
						$elm$core$List$cons,
						{e: decoder, aJ: name},
						config.dZ)
				});
		};
	});
var $terezka$elm_charts$Chart$Events$on = $terezka$elm_charts$Internal$Events$on;
var $terezka$elm_charts$Chart$Events$onMouseLeave = function (onMsg) {
	return A2(
		$terezka$elm_charts$Chart$Events$on,
		'mouseleave',
		A2(
			$terezka$elm_charts$Chart$Events$map,
			$elm$core$Basics$always(onMsg),
			$terezka$elm_charts$Chart$Events$getCoords));
};
var $terezka$elm_charts$Chart$Events$onMouseMove = F2(
	function (onMsg, decoder) {
		return A2(
			$terezka$elm_charts$Chart$Events$on,
			'mousemove',
			A2($terezka$elm_charts$Chart$Events$map, onMsg, decoder));
	});
var $terezka$elm_charts$Chart$Attributes$padding = function (value) {
	return function (config) {
		return _Utils_update(
			config,
			{a8: value});
	};
};
var $author$project$UI$Library$Chart$Msg$SetVisiblePeriod = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$Library$Chart$View$periodButton = F3(
	function (activePeriod, buttonPeriod, label) {
		var isActive = _Utils_eq(activePeriod, buttonPeriod);
		var buttonClass = isActive ? 'px-2 py-0.75 text-10 border border-dmnd-red-1 bg-dmnd-red-1 text-white' : 'px-2 py-0.75 text-10 border border-gray-600 bg-transparent text-gray-300 hover:border-gray-400';
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$class(buttonClass),
					$elm$html$Html$Events$onClick(
					$author$project$UI$Library$Chart$Msg$SetVisiblePeriod(buttonPeriod))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$UI$Library$Chart$View$plottedSeries = F2(
	function (pplnsPoints, fppsPoints) {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					$elm$core$List$isEmpty(pplnsPoints) ? _List_Nil : _List_fromArray(
					[
						A3(
						$terezka$elm_charts$Chart$series,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.ph;
							},
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$Basics$toFloat)),
						_List_fromArray(
							[
								A3(
								$terezka$elm_charts$Chart$interpolated,
								function ($) {
									return $.n$;
								},
								_List_fromArray(
									[
										$terezka$elm_charts$Chart$Attributes$color('#EF3A2E'),
										$terezka$elm_charts$Chart$Attributes$width(1)
									]),
								_List_fromArray(
									[
										$terezka$elm_charts$Chart$Attributes$circle,
										$terezka$elm_charts$Chart$Attributes$size(3)
									]))
							]),
						pplnsPoints)
					]),
					$elm$core$List$isEmpty(fppsPoints) ? _List_Nil : _List_fromArray(
					[
						A3(
						$terezka$elm_charts$Chart$series,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.ph;
							},
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$Basics$toFloat)),
						_List_fromArray(
							[
								A3(
								$terezka$elm_charts$Chart$interpolated,
								function ($) {
									return $.l6;
								},
								_List_fromArray(
									[
										$terezka$elm_charts$Chart$Attributes$color('#3B82F6'),
										$terezka$elm_charts$Chart$Attributes$width(1)
									]),
								_List_fromArray(
									[
										$terezka$elm_charts$Chart$Attributes$circle,
										$terezka$elm_charts$Chart$Attributes$size(3)
									]))
							]),
						fppsPoints)
					])
				]));
	});
var $author$project$UI$Library$Chart$View$futureExtensionPoints = 25;
var $author$project$UI$Library$Chart$View$futureExtensionStepMillis = (5 * 60) * 1000;
var $author$project$UI$Library$Chart$View$prepareDisplayChartData = function (selectedData) {
	var _v0 = $author$project$UI$Library$Chart$Model$latestChartPoint(selectedData);
	if (!_v0.$) {
		var latestPoint = _v0.a;
		var latestTimeMillis = $elm$time$Time$posixToMillis(latestPoint.ph);
		var futurePoints = A2(
			$elm$core$List$map,
			function (intervals) {
				return {
					l6: 0,
					n$: 0,
					ph: $elm$time$Time$millisToPosix(latestTimeMillis + (intervals * $author$project$UI$Library$Chart$View$futureExtensionStepMillis)),
					pG: 0
				};
			},
			A2($elm$core$List$range, 1, $author$project$UI$Library$Chart$View$futureExtensionPoints));
		return _Utils_ap(selectedData, futurePoints);
	} else {
		return _List_Nil;
	}
};
var $author$project$UI$Library$Chart$View$rangeSelector = function (config) {
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col gap-1 text-12 text-gray-400')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(config.mR)
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('range'),
						$elm$html$Html$Attributes$min('0'),
						$elm$html$Html$Attributes$max(
						$elm$core$String$fromInt($author$project$UI$Library$Chart$Model$rangeScaleMax)),
						$elm$html$Html$Attributes$value(
						$elm$core$String$fromInt(config.pV)),
						$elm$html$Html$Attributes$disabled(!config.c0),
						$elm$html$Html$Attributes$class('w-full bg-transparent'),
						A2($elm$html$Html$Attributes$style, 'accent-color', '#EF3A2E'),
						A2($elm$html$Html$Attributes$style, 'transform', 'scaleY(0.65)'),
						$elm$html$Html$Events$onInput(config.f5)
					]),
				_List_Nil)
			]));
};
var $author$project$UI$Library$Chart$View$timeSpanMillis = function (points) {
	var _v0 = _Utils_Tuple2(
		$elm$core$List$head(points),
		$author$project$UI$Library$Chart$Model$latestChartPoint(points));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var firstPoint = _v0.a.a;
		var lastPoint = _v0.b.a;
		return A2(
			$elm$core$Basics$max,
			0,
			$elm$time$Time$posixToMillis(lastPoint.ph) - $elm$time$Time$posixToMillis(firstPoint.ph));
	} else {
		return 0;
	}
};
var $terezka$elm_charts$Chart$Attributes$withGrid = function (config) {
	return _Utils_update(
		config,
		{F: true});
};
var $terezka$elm_charts$Internal$Svg$Floats = {$: 0};
var $terezka$elm_charts$Chart$LabelsElement = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $terezka$elm_charts$Internal$Svg$defaultLabel = {K: $elm$core$Maybe$Nothing, ch: _List_Nil, ap: 'white', aC: 0, cU: '#808BAB', M: $elm$core$Maybe$Nothing, N: $elm$core$Maybe$Nothing, O: false, S: 0, T: false, H: 0, I: 0};
var $terezka$elm_charts$Internal$Svg$Generator = $elm$core$Basics$identity;
var $terezka$intervals$Intervals$Around = function (a) {
	return {$: 1, a: a};
};
var $terezka$intervals$Intervals$around = $terezka$intervals$Intervals$Around;
var $terezka$intervals$Intervals$ceilingTo = F2(
	function (prec, number) {
		return prec * $elm$core$Basics$ceiling(number / prec);
	});
var $terezka$intervals$Intervals$getBeginning = F2(
	function (min, interval) {
		var multiple = min / interval;
		return _Utils_eq(
			multiple,
			$elm$core$Basics$round(multiple)) ? min : A2($terezka$intervals$Intervals$ceilingTo, interval, min);
	});
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$Char$fromCode = _Char_fromCode;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $terezka$intervals$Intervals$correctFloat = function (prec) {
	return A2(
		$elm$core$Basics$composeR,
		$myrho$elm_round$Round$round(prec),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$toFloat,
			$elm$core$Maybe$withDefault(0)));
};
var $terezka$intervals$Intervals$getMultiples = F3(
	function (magnitude, allowDecimals, hasTickAmount) {
		var defaults = hasTickAmount ? _List_fromArray(
			[1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10]) : _List_fromArray(
			[1, 2, 2.5, 5, 10]);
		return allowDecimals ? defaults : ((magnitude === 1) ? A2(
			$elm$core$List$filter,
			function (n) {
				return _Utils_eq(
					$elm$core$Basics$round(n),
					n);
			},
			defaults) : ((magnitude <= 0.1) ? _List_fromArray(
			[1 / magnitude]) : defaults));
	});
var $terezka$intervals$Intervals$getPrecision = function (number) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(number));
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var before = _v0.a;
		var _v1 = _v0.b;
		var after = _v1.a;
		return $elm$core$Basics$abs(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(after)));
	} else {
		var _v2 = A2(
			$elm$core$String$split,
			'.',
			$elm$core$String$fromFloat(number));
		if ((_v2.b && _v2.b.b) && (!_v2.b.b.b)) {
			var before = _v2.a;
			var _v3 = _v2.b;
			var after = _v3.a;
			return $elm$core$String$length(after);
		} else {
			return 0;
		}
	}
};
var $elm$core$Basics$e = _Basics_e;
var $terezka$intervals$Intervals$toMagnitude = function (num) {
	return A2(
		$elm$core$Basics$pow,
		10,
		$elm$core$Basics$floor(
			A2($elm$core$Basics$logBase, $elm$core$Basics$e, num) / A2($elm$core$Basics$logBase, $elm$core$Basics$e, 10)));
};
var $terezka$intervals$Intervals$getInterval = F3(
	function (intervalRaw, allowDecimals, hasTickAmount) {
		var magnitude = $terezka$intervals$Intervals$toMagnitude(intervalRaw);
		var multiples = A3($terezka$intervals$Intervals$getMultiples, magnitude, allowDecimals, hasTickAmount);
		var normalized = intervalRaw / magnitude;
		var findMultipleExact = function (multiples_) {
			findMultipleExact:
			while (true) {
				if (multiples_.b) {
					var m1 = multiples_.a;
					var rest = multiples_.b;
					if (_Utils_cmp(m1 * magnitude, intervalRaw) > -1) {
						return m1;
					} else {
						var $temp$multiples_ = rest;
						multiples_ = $temp$multiples_;
						continue findMultipleExact;
					}
				} else {
					return 1;
				}
			}
		};
		var findMultiple = function (multiples_) {
			findMultiple:
			while (true) {
				if (multiples_.b) {
					if (multiples_.b.b) {
						var m1 = multiples_.a;
						var _v2 = multiples_.b;
						var m2 = _v2.a;
						var rest = _v2.b;
						if (_Utils_cmp(normalized, (m1 + m2) / 2) < 1) {
							return m1;
						} else {
							var $temp$multiples_ = A2($elm$core$List$cons, m2, rest);
							multiples_ = $temp$multiples_;
							continue findMultiple;
						}
					} else {
						var m1 = multiples_.a;
						var rest = multiples_.b;
						if (_Utils_cmp(normalized, m1) < 1) {
							return m1;
						} else {
							var $temp$multiples_ = rest;
							multiples_ = $temp$multiples_;
							continue findMultiple;
						}
					}
				} else {
					return 1;
				}
			}
		};
		var multiple = hasTickAmount ? findMultipleExact(multiples) : findMultiple(multiples);
		var precision = $terezka$intervals$Intervals$getPrecision(magnitude) + $terezka$intervals$Intervals$getPrecision(multiple);
		return A2($terezka$intervals$Intervals$correctFloat, precision, multiple * magnitude);
	});
var $terezka$intervals$Intervals$positions = F5(
	function (range, beginning, interval, m, acc) {
		positions:
		while (true) {
			var nextPosition = A2(
				$terezka$intervals$Intervals$correctFloat,
				$terezka$intervals$Intervals$getPrecision(interval),
				beginning + (m * interval));
			if (_Utils_cmp(nextPosition, range.ar) > 0) {
				return acc;
			} else {
				var $temp$range = range,
					$temp$beginning = beginning,
					$temp$interval = interval,
					$temp$m = m + 1,
					$temp$acc = _Utils_ap(
					acc,
					_List_fromArray(
						[nextPosition]));
				range = $temp$range;
				beginning = $temp$beginning;
				interval = $temp$interval;
				m = $temp$m;
				acc = $temp$acc;
				continue positions;
			}
		}
	});
var $terezka$intervals$Intervals$values = F4(
	function (allowDecimals, exact, amountRough, range) {
		var intervalRough = (range.ar - range.aT) / amountRough;
		var interval = A3($terezka$intervals$Intervals$getInterval, intervalRough, allowDecimals, exact);
		var intervalSafe = (!interval) ? 1 : interval;
		var beginning = A2($terezka$intervals$Intervals$getBeginning, range.aT, intervalSafe);
		var amountRoughSafe = (!amountRough) ? 1 : amountRough;
		return A5($terezka$intervals$Intervals$positions, range, beginning, intervalSafe, 0, _List_Nil);
	});
var $terezka$intervals$Intervals$floats = function (amount) {
	if (!amount.$) {
		var number = amount.a;
		return A3($terezka$intervals$Intervals$values, true, true, number);
	} else {
		var number = amount.a;
		return A3($terezka$intervals$Intervals$values, true, false, number);
	}
};
var $terezka$elm_charts$Internal$Svg$floats = F2(
	function (i, b) {
		return A2(
			$terezka$intervals$Intervals$floats,
			$terezka$intervals$Intervals$around(i),
			{ar: b.ar, aT: b.aT});
	});
var $terezka$elm_charts$Chart$Svg$floats = $terezka$elm_charts$Internal$Svg$floats;
var $ryan_haskell$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {pk: toAmPm, pp: toMonthAbbreviation, pq: toMonthName, cI: toOrdinalSuffix, ps: toWeekdayAbbreviation, pt: toWeekdayName};
	});
var $ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$english = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix);
var $ryan_haskell$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.pk(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $ryan_haskell$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $ryan_haskell$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryan_haskell$date_format$DateFormat$days)))));
	});
var $ryan_haskell$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryan_haskell$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryan_haskell$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $ryan_haskell$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $ryan_haskell$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryan_haskell$date_format$DateFormat$months))));
	});
var $ryan_haskell$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryan_haskell$date_format$DateFormat$monthPair, zone, posix));
	});
var $ryan_haskell$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryan_haskell$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryan_haskell$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryan_haskell$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $ryan_haskell$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $ryan_haskell$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $ryan_haskell$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryan_haskell$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryan_haskell$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryan_haskell$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryan_haskell$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.cI(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.pp(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.pq(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.cI(num));
				}(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.cI(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.cI(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.cI(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.ps(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.pt(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.cI(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryan_haskell$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryan_haskell$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryan_haskell$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryan_haskell$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryan_haskell$date_format$DateFormat$format = $ryan_haskell$date_format$DateFormat$formatWithLanguage($ryan_haskell$date_format$DateFormat$Language$english);
var $ryan_haskell$date_format$DateFormat$HourMilitaryFixed = {$: 25};
var $ryan_haskell$date_format$DateFormat$hourMilitaryFixed = $ryan_haskell$date_format$DateFormat$HourMilitaryFixed;
var $ryan_haskell$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryan_haskell$date_format$DateFormat$minuteFixed = $ryan_haskell$date_format$DateFormat$MinuteFixed;
var $ryan_haskell$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryan_haskell$date_format$DateFormat$text = $ryan_haskell$date_format$DateFormat$Text;
var $terezka$elm_charts$Internal$Svg$formatClock = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed
		]));
var $ryan_haskell$date_format$DateFormat$MillisecondFixed = {$: 35};
var $ryan_haskell$date_format$DateFormat$millisecondFixed = $ryan_haskell$date_format$DateFormat$MillisecondFixed;
var $ryan_haskell$date_format$DateFormat$SecondFixed = {$: 33};
var $ryan_haskell$date_format$DateFormat$secondFixed = $ryan_haskell$date_format$DateFormat$SecondFixed;
var $terezka$elm_charts$Internal$Svg$formatClockMillis = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$secondFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$millisecondFixed
		]));
var $terezka$elm_charts$Internal$Svg$formatClockSecond = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$secondFixed
		]));
var $ryan_haskell$date_format$DateFormat$DayOfMonthNumber = {$: 5};
var $ryan_haskell$date_format$DateFormat$dayOfMonthNumber = $ryan_haskell$date_format$DateFormat$DayOfMonthNumber;
var $ryan_haskell$date_format$DateFormat$MonthNumber = {$: 0};
var $ryan_haskell$date_format$DateFormat$monthNumber = $ryan_haskell$date_format$DateFormat$MonthNumber;
var $terezka$elm_charts$Internal$Svg$formatDate = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$monthNumber,
			$ryan_haskell$date_format$DateFormat$text('/'),
			$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
		]));
var $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated = {$: 3};
var $ryan_haskell$date_format$DateFormat$monthNameAbbreviated = $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated;
var $terezka$elm_charts$Internal$Svg$formatMonth = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[$ryan_haskell$date_format$DateFormat$monthNameAbbreviated]));
var $ryan_haskell$date_format$DateFormat$DayOfWeekNameFull = {$: 14};
var $ryan_haskell$date_format$DateFormat$dayOfWeekNameFull = $ryan_haskell$date_format$DateFormat$DayOfWeekNameFull;
var $terezka$elm_charts$Internal$Svg$formatWeekday = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull]));
var $ryan_haskell$date_format$DateFormat$YearNumber = {$: 16};
var $ryan_haskell$date_format$DateFormat$yearNumber = $ryan_haskell$date_format$DateFormat$YearNumber;
var $terezka$elm_charts$Internal$Svg$formatYear = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[$ryan_haskell$date_format$DateFormat$yearNumber]));
var $terezka$elm_charts$Internal$Svg$formatTime = F2(
	function (zone, time) {
		var _v0 = A2($elm$core$Maybe$withDefault, time.cL, time.k5);
		switch (_v0) {
			case 0:
				return A2($terezka$elm_charts$Internal$Svg$formatClockMillis, zone, time.b5);
			case 1:
				return A2($terezka$elm_charts$Internal$Svg$formatClockSecond, zone, time.b5);
			case 2:
				return A2($terezka$elm_charts$Internal$Svg$formatClock, zone, time.b5);
			case 3:
				return A2($terezka$elm_charts$Internal$Svg$formatClock, zone, time.b5);
			case 4:
				return (time.nn === 7) ? A2($terezka$elm_charts$Internal$Svg$formatWeekday, zone, time.b5) : A2($terezka$elm_charts$Internal$Svg$formatDate, zone, time.b5);
			case 5:
				return A2($terezka$elm_charts$Internal$Svg$formatMonth, zone, time.b5);
			default:
				return A2($terezka$elm_charts$Internal$Svg$formatYear, zone, time.b5);
		}
	});
var $terezka$elm_charts$Chart$Svg$formatTime = $terezka$elm_charts$Internal$Svg$formatTime;
var $terezka$elm_charts$Internal$Svg$generate = F3(
	function (amount, _v0, limits) {
		var func = _v0;
		return A2(func, amount, limits);
	});
var $terezka$elm_charts$Chart$Svg$generate = $terezka$elm_charts$Internal$Svg$generate;
var $terezka$intervals$Intervals$ints = F2(
	function (amount, range) {
		return A2(
			$elm$core$List$map,
			$elm$core$Basics$round,
			function () {
				if (!amount.$) {
					var number = amount.a;
					return A4($terezka$intervals$Intervals$values, false, true, number, range);
				} else {
					var number = amount.a;
					return A4($terezka$intervals$Intervals$values, false, false, number, range);
				}
			}());
	});
var $terezka$elm_charts$Internal$Svg$ints = F2(
	function (i, b) {
		return A2(
			$terezka$intervals$Intervals$ints,
			$terezka$intervals$Intervals$around(i),
			{ar: b.ar, aT: b.aT});
	});
var $terezka$elm_charts$Chart$Svg$ints = $terezka$elm_charts$Internal$Svg$ints;
var $terezka$intervals$Intervals$Day = 4;
var $terezka$intervals$Intervals$Hour = 3;
var $terezka$intervals$Intervals$Millisecond = 0;
var $terezka$intervals$Intervals$Minute = 2;
var $terezka$intervals$Intervals$Month = 5;
var $terezka$intervals$Intervals$Second = 1;
var $terezka$intervals$Intervals$Year = 6;
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 14:
					var $temp$interval = 15,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 13:
					var $temp$interval = 15,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 12:
					var $temp$interval = 15,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 11:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							3,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 2:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							1,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 0:
					var $temp$interval = 2,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 1:
					var $temp$interval = 2,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 3:
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $justinmimbs$time_extra$Time$Extra$Week = 3;
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Month = 2;
var $justinmimbs$date$Date$Quarter = 1;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $justinmimbs$date$Date$Week = 3;
var $justinmimbs$date$Date$Year = 0;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$time_extra$Time$Extra$floorDate = F3(
	function (dateInterval, zone, posix) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A2(
				$justinmimbs$date$Date$floor,
				dateInterval,
				A2($justinmimbs$date$Date$fromPosix, zone, posix)),
			0);
	});
var $justinmimbs$time_extra$Time$Extra$floor = F3(
	function (interval, zone, posix) {
		switch (interval) {
			case 15:
				return posix;
			case 14:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix),
						0));
			case 13:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						0,
						0));
			case 12:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						0,
						0,
						0));
			case 11:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 11, zone, posix);
			case 2:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 2, zone, posix);
			case 0:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 0, zone, posix);
			case 1:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 1, zone, posix);
			case 3:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 3, zone, posix);
			case 4:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 4, zone, posix);
			case 5:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 5, zone, posix);
			case 6:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 6, zone, posix);
			case 7:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 7, zone, posix);
			case 8:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 8, zone, posix);
			case 9:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 9, zone, posix);
			default:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 10, zone, posix);
		}
	});
var $justinmimbs$time_extra$Time$Extra$ceiling = F3(
	function (interval, zone, posix) {
		var floored = A3($justinmimbs$time_extra$Time$Extra$floor, interval, zone, posix);
		return _Utils_eq(floored, posix) ? posix : A4($justinmimbs$time_extra$Time$Extra$add, interval, 1, zone, floored);
	});
var $terezka$intervals$Intervals$Time$ceilingDay = F3(
	function (zone, mult, stamp) {
		return (mult === 7) ? A3($justinmimbs$time_extra$Time$Extra$ceiling, 3, zone, stamp) : A3($justinmimbs$time_extra$Time$Extra$ceiling, 11, zone, stamp);
	});
var $justinmimbs$time_extra$Time$Extra$Hour = 12;
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.ky;
		var month = _v0.i_;
		var day = _v0.lA;
		var hour = _v0.mr;
		var minute = _v0.nh;
		var second = _v0.jI;
		var millisecond = _v0.f_;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $justinmimbs$time_extra$Time$Extra$posixToParts = F2(
	function (zone, posix) {
		return {
			lA: A2($elm$time$Time$toDay, zone, posix),
			mr: A2($elm$time$Time$toHour, zone, posix),
			f_: A2($elm$time$Time$toMillis, zone, posix),
			nh: A2($elm$time$Time$toMinute, zone, posix),
			i_: A2($elm$time$Time$toMonth, zone, posix),
			jI: A2($elm$time$Time$toSecond, zone, posix),
			ky: A2($elm$time$Time$toYear, zone, posix)
		};
	});
var $terezka$intervals$Intervals$Time$ceilingHour = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 12, zone, stamp));
		var rem = parts.mr % mult;
		var _new = A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts);
		return (!rem) ? _new : A4($justinmimbs$time_extra$Time$Extra$add, 12, mult - rem, zone, _new);
	});
var $justinmimbs$time_extra$Time$Extra$Minute = 13;
var $terezka$intervals$Intervals$Time$ceilingMinute = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 13, zone, stamp));
		var rem = parts.nh % mult;
		var _new = A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts);
		return (!rem) ? _new : A4($justinmimbs$time_extra$Time$Extra$add, 13, mult - rem, zone, _new);
	});
var $terezka$intervals$Intervals$Time$intAsMonth = function (_int) {
	switch (_int) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		case 12:
			return 11;
		default:
			return 11;
	}
};
var $terezka$intervals$Intervals$Time$monthAsInt = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $terezka$intervals$Intervals$Time$ceilingMonth = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 2, zone, stamp));
		var monthInt = $terezka$intervals$Intervals$Time$monthAsInt(parts.i_);
		var rem = (monthInt - 1) % mult;
		var newMonth = (!rem) ? monthInt : ((monthInt - rem) + mult);
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			zone,
			(newMonth > 12) ? _Utils_update(
				parts,
				{
					i_: $terezka$intervals$Intervals$Time$intAsMonth(newMonth - 12),
					ky: parts.ky + 1
				}) : _Utils_update(
				parts,
				{
					i_: $terezka$intervals$Intervals$Time$intAsMonth(newMonth)
				}));
	});
var $terezka$intervals$Intervals$Time$ceilingMs = F3(
	function (zone, mult, stamp) {
		var parts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, stamp);
		var rem = parts.f_ % mult;
		return (!rem) ? A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts) : A4($justinmimbs$time_extra$Time$Extra$add, 15, mult - rem, zone, stamp);
	});
var $justinmimbs$time_extra$Time$Extra$Second = 14;
var $terezka$intervals$Intervals$Time$ceilingSecond = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 14, zone, stamp));
		var rem = parts.jI % mult;
		var _new = A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts);
		return (!rem) ? _new : A4($justinmimbs$time_extra$Time$Extra$add, 14, mult - rem, zone, _new);
	});
var $justinmimbs$time_extra$Time$Extra$Year = 0;
var $terezka$intervals$Intervals$Time$ceilingYear = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 0, zone, stamp));
		var rem = parts.ky % mult;
		var newYear = (!rem) ? parts.ky : ((parts.ky - rem) + mult);
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			zone,
			_Utils_update(
				parts,
				{ky: newYear}));
	});
var $terezka$intervals$Intervals$Time$ceilingUnit = F3(
	function (zone, unit, mult) {
		switch (unit) {
			case 0:
				return A2($terezka$intervals$Intervals$Time$ceilingMs, zone, mult);
			case 1:
				return A2($terezka$intervals$Intervals$Time$ceilingSecond, zone, mult);
			case 2:
				return A2($terezka$intervals$Intervals$Time$ceilingMinute, zone, mult);
			case 3:
				return A2($terezka$intervals$Intervals$Time$ceilingHour, zone, mult);
			case 4:
				return A2($terezka$intervals$Intervals$Time$ceilingDay, zone, mult);
			case 5:
				return A2($terezka$intervals$Intervals$Time$ceilingMonth, zone, mult);
			default:
				return A2($terezka$intervals$Intervals$Time$ceilingYear, zone, mult);
		}
	});
var $terezka$intervals$Intervals$Time$Day = 4;
var $terezka$intervals$Intervals$Time$Hour = 3;
var $terezka$intervals$Intervals$Time$Millisecond = 0;
var $terezka$intervals$Intervals$Time$Minute = 2;
var $terezka$intervals$Intervals$Time$Month = 5;
var $terezka$intervals$Intervals$Time$Second = 1;
var $terezka$intervals$Intervals$Time$Year = 6;
var $terezka$intervals$Intervals$Time$getChange = F3(
	function (zone, a, b) {
		var bP = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, b);
		var aP = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, a);
		return (!_Utils_eq(aP.ky, bP.ky)) ? 6 : ((!_Utils_eq(aP.i_, bP.i_)) ? 5 : ((!_Utils_eq(aP.lA, bP.lA)) ? 4 : ((!_Utils_eq(aP.mr, bP.mr)) ? 3 : ((!_Utils_eq(aP.nh, bP.nh)) ? 2 : ((!_Utils_eq(aP.jI, bP.jI)) ? 1 : 0)))));
	});
var $danhandrea$elm_time_extra$Util$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 400, year)) || ((!(!A2($elm$core$Basics$modBy, 100, year))) && (!A2($elm$core$Basics$modBy, 4, year)));
};
var $danhandrea$elm_time_extra$Month$days = F2(
	function (year, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $danhandrea$elm_time_extra$Util$isLeapYear(year) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $danhandrea$elm_time_extra$TimeExtra$daysInMonth = $danhandrea$elm_time_extra$Month$days;
var $terezka$intervals$Intervals$Time$toMs = $elm$time$Time$posixToMillis;
var $terezka$intervals$Intervals$Time$getDiff = F3(
	function (zone, a, b) {
		var _v0 = (_Utils_cmp(
			$terezka$intervals$Intervals$Time$toMs(a),
			$terezka$intervals$Intervals$Time$toMs(b)) < 0) ? _Utils_Tuple2(
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, a),
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, b)) : _Utils_Tuple2(
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, b),
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, a));
		var aP = _v0.a;
		var bP = _v0.b;
		var dMsX = bP.f_ - aP.f_;
		var dMs = (dMsX < 0) ? (1000 + dMsX) : dMsX;
		var dSecondX = (bP.jI - aP.jI) + ((dMsX < 0) ? (-1) : 0);
		var dMinuteX = (bP.nh - aP.nh) + ((dSecondX < 0) ? (-1) : 0);
		var dHourX = (bP.mr - aP.mr) + ((dMinuteX < 0) ? (-1) : 0);
		var dDayX = (bP.lA - aP.lA) + ((dHourX < 0) ? (-1) : 0);
		var dDay = (dDayX < 0) ? (A2($danhandrea$elm_time_extra$TimeExtra$daysInMonth, bP.ky, bP.i_) + dDayX) : dDayX;
		var dMonthX = ($terezka$intervals$Intervals$Time$monthAsInt(bP.i_) - $terezka$intervals$Intervals$Time$monthAsInt(aP.i_)) + ((dDayX < 0) ? (-1) : 0);
		var dMonth = (dMonthX < 0) ? (12 + dMonthX) : dMonthX;
		var dHour = (dHourX < 0) ? (24 + dHourX) : dHourX;
		var dMinute = (dMinuteX < 0) ? (60 + dMinuteX) : dMinuteX;
		var dSecond = (dSecondX < 0) ? (60 + dSecondX) : dSecondX;
		var dYearX = (bP.ky - aP.ky) + ((dMonthX < 0) ? (-1) : 0);
		var dYear = (dYearX < 0) ? ($terezka$intervals$Intervals$Time$monthAsInt(bP.i_) + dYearX) : dYearX;
		return {lA: dDay, mr: dHour, f_: dMs, nh: dMinute, i_: dMonth, jI: dSecond, ky: dYear};
	});
var $terezka$intervals$Intervals$Time$oneSecond = 1000;
var $terezka$intervals$Intervals$Time$oneMinute = $terezka$intervals$Intervals$Time$oneSecond * 60;
var $terezka$intervals$Intervals$Time$oneHour = $terezka$intervals$Intervals$Time$oneMinute * 60;
var $terezka$intervals$Intervals$Time$oneDay = $terezka$intervals$Intervals$Time$oneHour * 24;
var $terezka$intervals$Intervals$Time$oneMs = 1;
var $terezka$intervals$Intervals$Time$getNumOfTicks = F5(
	function (zone, unit, mult, a, b) {
		var div = F2(
			function (n1, n2) {
				return $elm$core$Basics$floor(n1 / n2);
			});
		var timeDiff = function (ms) {
			var ceiled = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, a);
			return (_Utils_cmp(
				$terezka$intervals$Intervals$Time$toMs(ceiled),
				$terezka$intervals$Intervals$Time$toMs(b)) > 0) ? (-1) : A2(
				div,
				A2(
					div,
					$terezka$intervals$Intervals$Time$toMs(b) - $terezka$intervals$Intervals$Time$toMs(ceiled),
					ms),
				mult);
		};
		var diff = function (property) {
			var ceiled = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, a);
			return (_Utils_cmp(
				$terezka$intervals$Intervals$Time$toMs(ceiled),
				$terezka$intervals$Intervals$Time$toMs(b)) > 0) ? (-1) : A2(
				div,
				property(
					A3($terezka$intervals$Intervals$Time$getDiff, zone, ceiled, b)),
				mult);
		};
		switch (unit) {
			case 0:
				return timeDiff($terezka$intervals$Intervals$Time$oneMs) + 1;
			case 1:
				return timeDiff($terezka$intervals$Intervals$Time$oneSecond) + 1;
			case 2:
				return timeDiff($terezka$intervals$Intervals$Time$oneMinute) + 1;
			case 3:
				return timeDiff($terezka$intervals$Intervals$Time$oneHour) + 1;
			case 4:
				return timeDiff($terezka$intervals$Intervals$Time$oneDay) + 1;
			case 5:
				return diff(
					function (d) {
						return d.i_ + (d.ky * 12);
					}) + 1;
			default:
				return diff(
					function ($) {
						return $.ky;
					}) + 1;
		}
	});
var $terezka$intervals$Intervals$Time$largerUnit = function (unit) {
	switch (unit) {
		case 0:
			return $elm$core$Maybe$Just(1);
		case 1:
			return $elm$core$Maybe$Just(2);
		case 2:
			return $elm$core$Maybe$Just(3);
		case 3:
			return $elm$core$Maybe$Just(4);
		case 4:
			return $elm$core$Maybe$Just(5);
		case 5:
			return $elm$core$Maybe$Just(6);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $terezka$intervals$Intervals$Time$niceMultiples = function (unit) {
	switch (unit) {
		case 0:
			return _List_fromArray(
				[1, 2, 5, 10, 20, 25, 50, 100, 200, 500]);
		case 1:
			return _List_fromArray(
				[1, 2, 5, 10, 15, 30]);
		case 2:
			return _List_fromArray(
				[1, 2, 5, 10, 15, 30]);
		case 3:
			return _List_fromArray(
				[1, 2, 3, 4, 6, 8, 12]);
		case 4:
			return _List_fromArray(
				[1, 2, 3, 7, 14]);
		case 5:
			return _List_fromArray(
				[1, 2, 3, 4, 6]);
		default:
			return _List_fromArray(
				[1, 2, 5, 10, 20, 25, 50, 100, 200, 500, 1000, 10000, 1000000, 10000000]);
	}
};
var $terezka$intervals$Intervals$Time$toBestUnit = F4(
	function (zone, amount, min, max) {
		var toNice = function (unit) {
			toNice:
			while (true) {
				var niceNums = $terezka$intervals$Intervals$Time$niceMultiples(unit);
				var maybeNiceNum = A2(
					$elm$core$List$filter,
					function (n) {
						return _Utils_cmp(
							A5($terezka$intervals$Intervals$Time$getNumOfTicks, zone, unit, n, min, max),
							amount) < 1;
					},
					niceNums);
				var div = F2(
					function (n1, n2) {
						return $elm$core$Basics$ceiling(n1 / n2);
					});
				var _v0 = $elm$core$List$head(maybeNiceNum);
				if (!_v0.$) {
					var niceNum = _v0.a;
					return _Utils_Tuple2(unit, niceNum);
				} else {
					var _v1 = $terezka$intervals$Intervals$Time$largerUnit(unit);
					if (!_v1.$) {
						var larger = _v1.a;
						var $temp$unit = larger;
						unit = $temp$unit;
						continue toNice;
					} else {
						return _Utils_Tuple2(6, 100000000);
					}
				}
			}
		};
		return toNice(0);
	});
var $terezka$intervals$Intervals$Time$toExtraUnit = function (unit) {
	switch (unit) {
		case 0:
			return 15;
		case 1:
			return 14;
		case 2:
			return 13;
		case 3:
			return 12;
		case 4:
			return 11;
		case 5:
			return 2;
		default:
			return 0;
	}
};
var $terezka$intervals$Intervals$Time$unitToInt = function (unit) {
	switch (unit) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		default:
			return 6;
	}
};
var $terezka$intervals$Intervals$Time$values = F4(
	function (zone, maxMmount, min, max) {
		var _v0 = A4($terezka$intervals$Intervals$Time$toBestUnit, zone, maxMmount, min, max);
		var unit = _v0.a;
		var mult = _v0.b;
		var amount = A5($terezka$intervals$Intervals$Time$getNumOfTicks, zone, unit, mult, min, max);
		var initial = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, min);
		var tUnit = $terezka$intervals$Intervals$Time$toExtraUnit(unit);
		var toTick = F3(
			function (x, timestamp, change) {
				return {
					k5: (_Utils_cmp(
						$terezka$intervals$Intervals$Time$unitToInt(change),
						$terezka$intervals$Intervals$Time$unitToInt(unit)) > 0) ? $elm$core$Maybe$Just(change) : $elm$core$Maybe$Nothing,
					fL: !x,
					nn: mult,
					b5: timestamp,
					cL: unit,
					qm: zone
				};
			});
		var toTicks = F2(
			function (xs, acc) {
				toTicks:
				while (true) {
					if (xs.b) {
						var x = xs.a;
						var rest = xs.b;
						var prev = A4($justinmimbs$time_extra$Time$Extra$add, tUnit, (x - 1) * mult, zone, initial);
						var curr = A4($justinmimbs$time_extra$Time$Extra$add, tUnit, x * mult, zone, initial);
						var change = A3($terezka$intervals$Intervals$Time$getChange, zone, prev, curr);
						var $temp$xs = rest,
							$temp$acc = A2(
							$elm$core$List$cons,
							A3(toTick, x, curr, change),
							acc);
						xs = $temp$xs;
						acc = $temp$acc;
						continue toTicks;
					} else {
						return acc;
					}
				}
			});
		return $elm$core$List$reverse(
			A2(
				toTicks,
				A2($elm$core$List$range, 0, amount - 1),
				_List_Nil));
	});
var $terezka$intervals$Intervals$times = F3(
	function (zone, amount, range) {
		var toUnit = function (unit) {
			switch (unit) {
				case 0:
					return 0;
				case 1:
					return 1;
				case 2:
					return 2;
				case 3:
					return 3;
				case 4:
					return 4;
				case 5:
					return 5;
				default:
					return 6;
			}
		};
		var translateUnit = function (time) {
			return {
				k5: A2($elm$core$Maybe$map, toUnit, time.k5),
				fL: time.fL,
				nn: time.nn,
				b5: time.b5,
				cL: toUnit(time.cL),
				qm: time.qm
			};
		};
		var fromMs = function (ts) {
			return $elm$time$Time$millisToPosix(
				$elm$core$Basics$round(ts));
		};
		return A2(
			$elm$core$List$map,
			translateUnit,
			A4(
				$terezka$intervals$Intervals$Time$values,
				zone,
				amount,
				fromMs(range.aT),
				fromMs(range.ar)));
	});
var $terezka$elm_charts$Internal$Svg$times = function (zone) {
	return F2(
		function (i, b) {
			return A3(
				$terezka$intervals$Intervals$times,
				zone,
				i,
				{ar: b.ar, aT: b.aT});
		});
};
var $terezka$elm_charts$Chart$Svg$times = $terezka$elm_charts$Internal$Svg$times;
var $terezka$elm_charts$Chart$generateValues = F4(
	function (amount, tick, maybeFormat, axis) {
		var toTickValues = F2(
			function (toValue, toString) {
				return $elm$core$List$map(
					function (i) {
						return {
							mR: function () {
								if (!maybeFormat.$) {
									var formatter = maybeFormat.a;
									return formatter(
										toValue(i));
								} else {
									return toString(i);
								}
							}(),
							pV: toValue(i)
						};
					});
			});
		switch (tick.$) {
			case 0:
				return A3(
					toTickValues,
					$elm$core$Basics$identity,
					$elm$core$String$fromFloat,
					A3($terezka$elm_charts$Chart$Svg$generate, amount, $terezka$elm_charts$Chart$Svg$floats, axis));
			case 1:
				return A3(
					toTickValues,
					$elm$core$Basics$toFloat,
					$elm$core$String$fromInt,
					A3($terezka$elm_charts$Chart$Svg$generate, amount, $terezka$elm_charts$Chart$Svg$ints, axis));
			default:
				var zone = tick.a;
				return A3(
					toTickValues,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Basics$toFloat, $elm$time$Time$posixToMillis),
						function ($) {
							return $.b5;
						}),
					$terezka$elm_charts$Chart$Svg$formatTime(zone),
					A3(
						$terezka$elm_charts$Chart$Svg$generate,
						amount,
						$terezka$elm_charts$Chart$Svg$times(zone),
						axis));
		}
	});
var $elm$svg$Svg$foreignObject = $elm$svg$Svg$trustedNode('foreignObject');
var $terezka$elm_charts$Internal$Svg$position = F6(
	function (plane, rotation, x_, y_, xOff_, yOff_) {
		return $elm$svg$Svg$Attributes$transform(
			'translate(' + ($elm$core$String$fromFloat(
				A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x_) + xOff_) + (',' + ($elm$core$String$fromFloat(
				A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y_) + yOff_) + (') rotate(' + ($elm$core$String$fromFloat(rotation) + ')'))))));
	});
var $elm$svg$Svg$tspan = $elm$svg$Svg$trustedNode('tspan');
var $terezka$elm_charts$Internal$Svg$label = F4(
	function (plane, config, inner, point) {
		var _v0 = config.M;
		if (_v0.$ === 1) {
			var withOverflowWrap = function (el) {
				return config.O ? A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
						]),
					_List_fromArray(
						[el])) : el;
			};
			var uppercaseStyle = config.T ? 'text-transform: uppercase;' : '';
			var fontStyle = function () {
				var _v5 = config.N;
				if (!_v5.$) {
					var size_ = _v5.a;
					return 'font-size: ' + ($elm$core$String$fromInt(size_) + 'px;');
				} else {
					return '';
				}
			}();
			var anchorStyle = function () {
				var _v1 = config.K;
				if (_v1.$ === 1) {
					return 'text-anchor: middle;';
				} else {
					switch (_v1.a) {
						case 0:
							var _v2 = _v1.a;
							return 'text-anchor: end;';
						case 1:
							var _v3 = _v1.a;
							return 'text-anchor: start;';
						default:
							var _v4 = _v1.a;
							return 'text-anchor: middle;';
					}
				}
			}();
			return withOverflowWrap(
				A4(
					$terezka$elm_charts$Internal$Svg$withAttrs,
					config.ch,
					$elm$svg$Svg$text_,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__label'),
							$elm$svg$Svg$Attributes$stroke(config.ap),
							$elm$svg$Svg$Attributes$strokeWidth(
							$elm$core$String$fromFloat(config.aC)),
							$elm$svg$Svg$Attributes$fill(config.cU),
							A6($terezka$elm_charts$Internal$Svg$position, plane, -config.S, point.kw, point.kx, config.H, config.I),
							$elm$svg$Svg$Attributes$style(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									['pointer-events: none;', fontStyle, anchorStyle, uppercaseStyle])))
						]),
					_List_fromArray(
						[
							A2($elm$svg$Svg$tspan, _List_Nil, inner)
						])));
		} else {
			var ellipsis = _v0.a;
			var xOffWithAnchor = function () {
				var _v11 = config.K;
				if (_v11.$ === 1) {
					return config.H - (ellipsis.g6 / 2);
				} else {
					switch (_v11.a) {
						case 0:
							var _v12 = _v11.a;
							return config.H - ellipsis.g6;
						case 1:
							var _v13 = _v11.a;
							return config.H;
						default:
							var _v14 = _v11.a;
							return config.H - (ellipsis.g6 / 2);
					}
				}
			}();
			var withOverflowWrap = function (el) {
				return config.O ? A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
						]),
					_List_fromArray(
						[el])) : el;
			};
			var uppercaseStyle = config.T ? A2($elm$html$Html$Attributes$style, 'text-transform', 'uppercase') : A2($elm$html$Html$Attributes$style, '', '');
			var fontStyle = function () {
				var _v10 = config.N;
				if (!_v10.$) {
					var size_ = _v10.a;
					return A2(
						$elm$html$Html$Attributes$style,
						'font-size',
						$elm$core$String$fromInt(size_) + 'px');
				} else {
					return A2($elm$html$Html$Attributes$style, '', '');
				}
			}();
			var anchorStyle = function () {
				var _v6 = config.K;
				if (_v6.$ === 1) {
					return A2($elm$html$Html$Attributes$style, 'text-align', 'center');
				} else {
					switch (_v6.a) {
						case 0:
							var _v7 = _v6.a;
							return A2($elm$html$Html$Attributes$style, 'text-align', 'right');
						case 1:
							var _v8 = _v6.a;
							return A2($elm$html$Html$Attributes$style, 'text-align', 'left');
						default:
							var _v9 = _v6.a;
							return A2($elm$html$Html$Attributes$style, 'text-align', 'center');
					}
				}
			}();
			return withOverflowWrap(
				A4(
					$terezka$elm_charts$Internal$Svg$withAttrs,
					config.ch,
					$elm$svg$Svg$foreignObject,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__label'),
							$elm$svg$Svg$Attributes$class('elm-charts__html-label'),
							$elm$svg$Svg$Attributes$width(
							$elm$core$String$fromFloat(ellipsis.g6)),
							$elm$svg$Svg$Attributes$height(
							$elm$core$String$fromFloat(ellipsis.fx)),
							A6($terezka$elm_charts$Internal$Svg$position, plane, -config.S, point.kw, point.kx, xOffWithAnchor, config.I - 10)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/1999/xhtml'),
									A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
									A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
									A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
									A2($elm$html$Html$Attributes$style, 'height', '100%'),
									A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
									A2($elm$html$Html$Attributes$style, 'color', config.cU),
									fontStyle,
									uppercaseStyle,
									anchorStyle
								]),
							inner)
						])));
		}
	});
var $terezka$elm_charts$Chart$Attributes$zero = function (b) {
	return A3($elm$core$Basics$clamp, b.aT, b.ar, 0);
};
var $terezka$elm_charts$Chart$xLabels = function (edits) {
	var toTicks = F2(
		function (p, config) {
			return A4(
				$terezka$elm_charts$Chart$generateValues,
				config.dG,
				config.a2,
				config.ih,
				A2($terezka$elm_charts$Internal$Helpers$apply, config.ae, p.kw));
		});
	var toTickValues = F3(
		function (p, config, ts) {
			return (!config.F) ? ts : _Utils_update(
				ts,
				{
					aA: _Utils_ap(
						ts.aA,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.pV;
							},
							A2(toTicks, p, config)))
				});
		});
	var toConfig = function (p) {
		return A2(
			$terezka$elm_charts$Internal$Helpers$apply,
			edits,
			{dG: 5, K: $elm$core$Maybe$Nothing, ch: _List_Nil, cU: '#808BAB', M: $elm$core$Maybe$Nothing, B: false, N: $elm$core$Maybe$Nothing, ih: $elm$core$Maybe$Nothing, a2: $terezka$elm_charts$Internal$Svg$Floats, F: false, O: false, ae: _List_Nil, Q: $terezka$elm_charts$Chart$Attributes$zero, S: 0, T: false, H: 0, I: 18});
	};
	return A3(
		$terezka$elm_charts$Chart$LabelsElement,
		toConfig,
		toTickValues,
		F2(
			function (p, config) {
				var _default = $terezka$elm_charts$Internal$Svg$defaultLabel;
				var toLabel = function (item) {
					return A4(
						$terezka$elm_charts$Internal$Svg$label,
						p,
						_Utils_update(
							_default,
							{
								K: config.K,
								ch: config.ch,
								cU: config.cU,
								M: config.M,
								N: config.N,
								O: config.O,
								S: config.S,
								T: config.T,
								H: config.H,
								I: config.B ? ((-config.I) + 10) : config.I
							}),
						_List_fromArray(
							[
								$elm$svg$Svg$text(item.mR)
							]),
						{
							kw: item.pV,
							kx: config.Q(p.kx)
						});
				};
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__x-labels')
						]),
					A2(
						$elm$core$List$map,
						toLabel,
						A2(toTicks, p, config)));
			}));
};
var $terezka$elm_charts$Internal$Svg$End = 0;
var $terezka$elm_charts$Internal$Svg$Start = 1;
var $terezka$elm_charts$Chart$yLabels = function (edits) {
	var toTicks = F2(
		function (p, config) {
			return A4(
				$terezka$elm_charts$Chart$generateValues,
				config.dG,
				config.a2,
				config.ih,
				A2($terezka$elm_charts$Internal$Helpers$apply, config.ae, p.kx));
		});
	var toTickValues = F3(
		function (p, config, ts) {
			return (!config.F) ? ts : _Utils_update(
				ts,
				{
					aY: _Utils_ap(
						ts.aY,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.pV;
							},
							A2(toTicks, p, config)))
				});
		});
	var toConfig = function (p) {
		return A2(
			$terezka$elm_charts$Internal$Helpers$apply,
			edits,
			{dG: 5, K: $elm$core$Maybe$Nothing, ch: _List_Nil, cU: '#808BAB', M: $elm$core$Maybe$Nothing, B: false, N: $elm$core$Maybe$Nothing, ih: $elm$core$Maybe$Nothing, a2: $terezka$elm_charts$Internal$Svg$Floats, F: false, O: false, ae: _List_Nil, Q: $terezka$elm_charts$Chart$Attributes$zero, S: 0, T: false, H: -10, I: 3});
	};
	return A3(
		$terezka$elm_charts$Chart$LabelsElement,
		toConfig,
		toTickValues,
		F2(
			function (p, config) {
				var _default = $terezka$elm_charts$Internal$Svg$defaultLabel;
				var toLabel = function (item) {
					return A4(
						$terezka$elm_charts$Internal$Svg$label,
						p,
						_Utils_update(
							_default,
							{
								K: function () {
									var _v0 = config.K;
									if (_v0.$ === 1) {
										return $elm$core$Maybe$Just(
											config.B ? 1 : 0);
									} else {
										var anchor = _v0.a;
										return $elm$core$Maybe$Just(anchor);
									}
								}(),
								ch: config.ch,
								cU: config.cU,
								M: config.M,
								N: config.N,
								O: config.O,
								S: config.S,
								T: config.T,
								H: config.B ? (-config.H) : config.H,
								I: config.I
							}),
						_List_fromArray(
							[
								$elm$svg$Svg$text(item.mR)
							]),
						{
							kw: config.Q(p.kw),
							kx: item.pV
						});
				};
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__y-labels')
						]),
					A2(
						$elm$core$List$map,
						toLabel,
						A2(toTicks, p, config)));
			}));
};
var $author$project$UI$Library$Chart$View$view = F2(
	function (topState, chartModel) {
		var zone = topState.qm;
		var plotWidth = A2(
			$elm$core$Basics$max,
			520,
			(topState.k0.g6 < 768) ? (topState.k0.g6 - 32) : A2($elm$core$Basics$min, 1360, topState.k0.g6 - 128));
		var plotHeight = (topState.k0.g6 < 768) ? 240 : 280;
		var formatHashrate = function (rawHashrate) {
			return (rawHashrate === 0.0) ? '0 H/s' : $author$project$Types$Hashrate$toString(
				$author$project$Types$Hashrate$rawHashrateToHashrate(rawHashrate));
		};
		var emptyHistoryMessage = function () {
			var remote = topState.eV.jr;
			return ($author$project$Remote$Model$isWatcherAuthenticated(remote) && (remote.az.d1 === 2)) ? 'This key cannot read hashrate history. It may lack permission, be expired or revoked. Ask the account owner for a current watcher link.' : 'No hashrate history available yet.';
		}();
		var chartMarginTop = 14;
		var chartMarginRight = 10;
		var chartMarginLeft = (topState.k0.g6 < 768) ? 80 : 74;
		var chartWidth = (plotWidth + chartMarginLeft) + chartMarginRight;
		var chartMarginBottom = 30;
		var chartHeight = (plotHeight + chartMarginTop) + chartMarginBottom;
		var _v0 = A2($author$project$UI$Library$Chart$Model$chartDateBounds, zone, chartModel.hv);
		var customMinDate = _v0.a;
		var customMaxDate = _v0.b;
		var customToDate = $elm$core$String$isEmpty(chartModel.hQ) ? customMaxDate : chartModel.hQ;
		var customFromDate = $elm$core$String$isEmpty(chartModel.hP) ? customMinDate : chartModel.hP;
		var periodData = A5($author$project$UI$Library$Chart$View$dataForVisiblePeriod, zone, chartModel.kr, customFromDate, customToDate, chartModel.hv);
		var selectedData = A2($author$project$UI$Library$Chart$View$applyRangeSelection, chartModel.jK, periodData);
		var renderData = A2(
			$author$project$UI$Library$Chart$View$downsampleChartData,
			$author$project$UI$Library$Chart$View$maxRenderablePoints(plotWidth),
			selectedData);
		var displayData = $author$project$UI$Library$Chart$View$prepareDisplayChartData(renderData);
		var scaleAnchorData = A2(
			$elm$core$List$map,
			function (point) {
				return _Utils_update(
					point,
					{
						n$: A2($elm$core$Basics$max, point.n$, point.l6)
					});
			},
			A2(
				$elm$core$List$filter,
				function (point) {
					return (point.n$ > 0) || (point.l6 > 0);
				},
				displayData));
		var visibleFppsData = A2(
			$elm$core$List$filter,
			function (point) {
				return point.l6 > 0;
			},
			displayData);
		var smoothedFppsData = A2($author$project$UI$Library$Chart$View$applyEwmaFpps, $author$project$UI$Library$Chart$View$ewmaAlpha, visibleFppsData);
		var visiblePplnsData = A2(
			$elm$core$List$filter,
			function (point) {
				return point.n$ > 0;
			},
			displayData);
		var smoothedPplnsData = A2($author$project$UI$Library$Chart$View$applyEwma, $author$project$UI$Library$Chart$View$ewmaAlpha, visiblePplnsData);
		var selectedSpanMillis = $author$project$UI$Library$Chart$View$timeSpanMillis(renderData);
		var selectorEnabled = $author$project$UI$Library$Chart$View$hasMultiplePoints(periodData);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-6 mb-6')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-3 mb-1')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col md:flex-row md:items-center md:justify-between gap-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-16 text-white text-left')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('CURRENT HASHRATE')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex items-center gap-2')
										]),
									_List_fromArray(
										[
											A3($author$project$UI$Library$Chart$View$periodButton, chartModel.kr, 0, '1H'),
											A3($author$project$UI$Library$Chart$View$periodButton, chartModel.kr, 1, '1D'),
											A3($author$project$UI$Library$Chart$View$periodButton, chartModel.kr, 2, '7D'),
											A3($author$project$UI$Library$Chart$View$periodButton, chartModel.kr, 3, '30D'),
											A3($author$project$UI$Library$Chart$View$periodButton, chartModel.kr, 4, 'Custom')
										]))
								])),
							(chartModel.kr === 4) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex justify-end')
								]),
							_List_fromArray(
								[
									$author$project$UI$Library$Chart$View$customDateRangeInputs(
									{
										c0: (!$elm$core$String$isEmpty(customMinDate)) && (!$elm$core$String$isEmpty(customMaxDate)),
										fo: customFromDate,
										m5: customMaxDate,
										ne: customMinDate,
										gY: customToDate
									})
								])) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-wrap gap-2')
								]),
							_List_fromArray(
								[
									A2($author$project$UI$Library$Chart$View$legendItem, '#EF3A2E', 'PPLNS'),
									A2($author$project$UI$Library$Chart$View$legendItem, '#3B82F6', 'FPPS')
								])),
							(chartModel.kr === 4) ? $elm$html$Html$text('') : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('grid gap-2 md:grid-cols-2')
								]),
							_List_fromArray(
								[
									$author$project$UI$Library$Chart$View$rangeSelector(
									{c0: selectorEnabled, mR: 'From', f5: $author$project$UI$Library$Chart$Msg$UpdateRangeStart, pV: chartModel.jK.j$}),
									$author$project$UI$Library$Chart$View$rangeSelector(
									{c0: selectorEnabled, mR: 'To', f5: $author$project$UI$Library$Chart$Msg$UpdateRangeEnd, pV: chartModel.jK.h_})
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('overflow-x-auto')
						]),
					_List_fromArray(
						[
							A2(
							$terezka$elm_charts$Chart$chart,
							_List_fromArray(
								[
									$terezka$elm_charts$Chart$Attributes$width(chartWidth),
									$terezka$elm_charts$Chart$Attributes$height(chartHeight),
									$terezka$elm_charts$Chart$Attributes$margin(
									{ho: chartMarginBottom, iL: chartMarginLeft, jD: chartMarginRight, kc: chartMarginTop}),
									$terezka$elm_charts$Chart$Attributes$padding(
									{ho: 0, iL: 0, jD: 0, kc: 8}),
									A2(
									$terezka$elm_charts$Chart$Events$onMouseMove,
									$author$project$UI$Library$Chart$Msg$OnHover,
									$terezka$elm_charts$Chart$Events$getNearest($terezka$elm_charts$Chart$Item$dots)),
									$terezka$elm_charts$Chart$Events$onMouseLeave(
									$author$project$UI$Library$Chart$Msg$OnHover(_List_Nil))
								]),
							_Utils_ap(
								_List_fromArray(
									[
										$terezka$elm_charts$Chart$grid(
										_List_fromArray(
											[
												$terezka$elm_charts$Chart$Attributes$color('#393939'),
												$terezka$elm_charts$Chart$Attributes$dashed(
												_List_fromArray(
													[2, 2]))
											])),
										$terezka$elm_charts$Chart$xLabels(
										_List_fromArray(
											[
												$terezka$elm_charts$Chart$Attributes$withGrid,
												$terezka$elm_charts$Chart$Attributes$amount(
												(_Utils_cmp(selectedSpanMillis, (((7 * 24) * 60) * 60) * 1000) > 0) ? 8 : 12),
												$terezka$elm_charts$Chart$Attributes$moveDown(10),
												$terezka$elm_charts$Chart$Attributes$format(
												function (x) {
													return A3(
														$author$project$UI$Library$Chart$View$formatAxisTimestamp,
														zone,
														selectedSpanMillis,
														$elm$time$Time$millisToPosix(
															$elm$core$Basics$round(x)));
												}),
												$terezka$elm_charts$Chart$Attributes$color('#73797F'),
												$terezka$elm_charts$Chart$Attributes$fontSize(10)
											])),
										$terezka$elm_charts$Chart$yLabels(
										_List_fromArray(
											[
												$terezka$elm_charts$Chart$Attributes$withGrid,
												$terezka$elm_charts$Chart$Attributes$color('#73797F'),
												$terezka$elm_charts$Chart$Attributes$fontSize(12),
												$terezka$elm_charts$Chart$Attributes$amount(5),
												$terezka$elm_charts$Chart$Attributes$format(formatHashrate)
											]))
									]),
								_Utils_ap(
									$author$project$UI$Library$Chart$View$invisibleScaleSeries(scaleAnchorData),
									_Utils_ap(
										A2($author$project$UI$Library$Chart$View$plottedSeries, smoothedPplnsData, smoothedFppsData),
										A3($author$project$UI$Library$Chart$View$hoverTooltips, zone, chartModel.ix, formatHashrate)))))
						])),
					$elm$core$List$isEmpty(selectedData) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-3 text-12 text-gray-500')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(emptyHistoryMessage)
						])) : $elm$html$Html$text('')
				]));
	});
var $author$project$UI$Home$View$view = function (topState) {
	var header = function () {
		var _v0 = $author$project$UI$Home$View$livenessFor(topState);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var level = _v1.a;
			var label = _v1.b;
			var tap = _v1.c;
			return $author$project$UI$Library$PageHeader$liveness(
				{mR: label, m_: level, nF: tap, o8: 'Hashrate, miners, and recent activity at a glance.', bs: 'Dashboard'});
		} else {
			return $author$project$UI$Library$PageHeader$withSubtitle(
				{o8: 'Hashrate, miners, and recent activity at a glance.', bs: 'Dashboard'});
		}
	}();
	var hashrateSection = $author$project$UI$Library$AccountData$dataScopeIsAggregate(topState) ? $author$project$UI$Home$View$aggregateSnapshot(topState) : A2(
		$elm$html$Html$map,
		$author$project$TopMsg$chartMsg,
		A2($author$project$UI$Library$Chart$View$view, topState, topState.eV.hw));
	return A2(
		$author$project$UI$Library$MainPageWrapper$mainPageWrapper,
		topState,
		A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					header,
					$author$project$UI$Library$DashboardInfoSquares$dashboardInfoSquares(topState),
					hashrateSection
				])));
};
var $author$project$Remote$Model$allMultiWatcherGeneratedBTCAccessKnown = F2(
	function (sessions, remote) {
		return A2(
			$elm$core$List$all,
			function (session) {
				return A2(
					$elm$core$Dict$member,
					$author$project$Remote$Model$watcherSessionKey(session),
					remote.bm);
			},
			sessions);
	});
var $author$project$Remote$Model$allMultiWatcherHashrateAccessKnown = F2(
	function (sessions, remote) {
		return A2(
			$elm$core$List$all,
			function (session) {
				return A2(
					$elm$core$Dict$member,
					$author$project$Remote$Model$watcherSessionKey(session),
					remote.bn);
			},
			sessions);
	});
var $author$project$Remote$Model$anyMultiWatcherHashrateDenied = F2(
	function (sessions, remote) {
		return A2(
			$elm$core$List$any,
			function (session) {
				return A2($author$project$Remote$Model$multiWatcherHashrateAccessForSession, session, remote) === 2;
			},
			sessions);
	});
var $author$project$UI$MultiWatcher$View$btcValue = function (_v0) {
	var value = _v0;
	return value;
};
var $author$project$UI$MultiWatcher$View$dailyTotalsByDay = A2(
	$elm$core$List$foldl,
	F2(
		function (entry, acc) {
			return A3(
				$elm$core$Dict$update,
				entry.h0,
				function (maybeTotals) {
					var _v0 = A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(0, 0),
						maybeTotals);
					var currentBtc = _v0.a;
					var currentHashrate = _v0.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							currentBtc + $author$project$UI$MultiWatcher$View$btcValue(entry.hs),
							currentHashrate + entry.d1));
				},
				acc);
		}),
	$elm$core$Dict$empty);
var $author$project$Remote$Model$multiWatcherGeneratedBTCForSession = F2(
	function (session, remote) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Dict$get,
				$author$project$Remote$Model$watcherSessionKey(session),
				remote.bz));
	});
var $author$project$Remote$Model$multiWatcherGeneratedBTCLoadErrorForSession = F2(
	function (session, remote) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Dict$get,
				$author$project$Remote$Model$watcherSessionKey(session),
				remote.a3));
	});
var $author$project$Remote$Model$multiWatcherHashrateLoadErrorForSession = F2(
	function (session, remote) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Dict$get,
				$author$project$Remote$Model$watcherSessionKey(session),
				remote.a4));
	});
var $author$project$UI$MultiWatcher$View$formatBtc = function (value) {
	return $author$project$Types$BTC$toString(value) + ' BTC';
};
var $author$project$UI$MultiWatcher$View$formatHashrate = function (value) {
	return $author$project$Types$Hashrate$toString(
		$author$project$Types$Hashrate$rawHashrateToHashrate(value));
};
var $author$project$UI$MultiWatcher$View$formatPercentage = F2(
	function (numerator, denominator) {
		var value = (!denominator) ? 0.0 : ((numerator / denominator) * 100);
		var valueRounded = $elm$core$Basics$round(value * 100) / 100;
		return $elm$core$String$fromFloat(valueRounded) + '%';
	});
var $author$project$UI$MultiWatcher$View$renderSessionCell = F3(
	function (totalBtc, maybeTotals, session) {
		var _v0 = session.cN;
		if (_v0 === 2) {
			return A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('py-2 pr-3 text-amber-300')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Key expired, revoked or missing permission. Request a new link.')
					]));
		} else {
			if (session.d0) {
				return A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 text-red-400')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Load error')
						]));
			} else {
				var sessionBtc = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, maybeTotals));
				return A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 text-white')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$UI$MultiWatcher$View$formatPercentage, sessionBtc, totalBtc))
						]));
			}
		}
	});
var $author$project$UI$MultiWatcher$View$renderRow = F2(
	function (sessions, day) {
		var rowDataBySession = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dR;
				},
				$elm$core$Dict$get(day)),
			sessions);
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (maybeTotals, _v1) {
					var btcAcc = _v1.a;
					var hashrateAcc = _v1.b;
					if (!maybeTotals.$) {
						var _v3 = maybeTotals.a;
						var sessionBtc = _v3.a;
						var sessionHashrate = _v3.b;
						return _Utils_Tuple2(btcAcc + sessionBtc, hashrateAcc + sessionHashrate);
					} else {
						return _Utils_Tuple2(btcAcc, hashrateAcc);
					}
				}),
			_Utils_Tuple2(0, 0),
			rowDataBySession);
		var totalBtc = _v0.a;
		var totalHashrate = _v0.b;
		var sessionCells = A3(
			$elm$core$List$map2,
			$author$project$UI$MultiWatcher$View$renderSessionCell(totalBtc),
			rowDataBySession,
			sessions);
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-b border-gray-800 hover:bg-gray-900')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 text-white')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(day)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 text-white')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$UI$MultiWatcher$View$formatHashrate(totalHashrate))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 pr-3 text-white')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$UI$MultiWatcher$View$formatBtc(totalBtc))
							]))
					]),
				sessionCells));
	});
var $author$project$UI$MultiWatcher$View$sessionDisplayName = F3(
	function (remote, index, session) {
		return 'Account ' + $elm$core$String$fromInt(index + 1);
	});
var $author$project$UI$MultiWatcher$View$tableHeader = function (sessions) {
	return _Utils_ap(
		_List_fromArray(
			[
				A2(
				$elm$html$Html$th,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('py-2 pr-3 font-normal text-gray-500')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Entry day')
					])),
				A2(
				$elm$html$Html$th,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('py-2 pr-3 font-normal text-gray-500')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Hashrate')
					])),
				A2(
				$elm$html$Html$th,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('py-2 pr-3 font-normal text-gray-500')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('BTC generated')
					]))
			]),
		A2(
			$elm$core$List$map,
			function (session) {
				return A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 font-normal text-gray-500')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(session.fb)
						]));
			},
			sessions));
};
var $author$project$UI$MultiWatcher$View$view = function (topState) {
	var remote = topState.eV.jr;
	var sessions = A2(
		$elm$core$List$indexedMap,
		F2(
			function (index, watcherSession) {
				return {
					cN: A2($author$project$Remote$Model$multiWatcherGeneratedBTCAccessForSession, watcherSession, remote),
					dR: $author$project$UI$MultiWatcher$View$dailyTotalsByDay(
						A2($author$project$Remote$Model$multiWatcherGeneratedBTCForSession, watcherSession, remote)),
					fb: A3($author$project$UI$MultiWatcher$View$sessionDisplayName, remote, index, watcherSession),
					d0: A2($author$project$Remote$Model$multiWatcherGeneratedBTCLoadErrorForSession, watcherSession, remote),
					jM: watcherSession
				};
			}),
		remote.bX);
	var noSessionData = $elm$core$List$isEmpty(remote.bX);
	var hasLoadedAuthorizations = A2($author$project$Remote$Model$allMultiWatcherGeneratedBTCAccessKnown, remote.bX, remote);
	var currentRoute = $author$project$Kernel$Aspect$Navigation$RouteHistory$current(topState.jE);
	var isHashrateRoute = _Utils_eq(currentRoute, $author$project$Route$Route$Workers);
	var header = isHashrateRoute ? $author$project$UI$Library$PageHeader$withSubtitle(
		{o8: 'Aggregated hashrate across all linked accounts.', bs: 'Multiwatcher hashrate'}) : $author$project$UI$Library$PageHeader$withSubtitle(
		{o8: 'Daily total hashrate and BTC generated with per-account contribution.', bs: 'Multiwatcher generated BTC'});
	var anyLoadErrors = A2(
		$elm$core$List$any,
		function ($) {
			return $.d0;
		},
		sessions);
	var anyHashrateLoadErrors = A2(
		$elm$core$List$any,
		function (session) {
			return A2($author$project$Remote$Model$multiWatcherHashrateLoadErrorForSession, session, remote);
		},
		remote.bX);
	var anyDenied = A2(
		$elm$core$List$any,
		function (session) {
			return session.cN === 2;
		},
		sessions);
	var allEntryDays = $elm$core$List$reverse(
		$elm$core$List$sort(
			$elm$core$Set$toList(
				$elm$core$Set$fromList(
					A2(
						$elm$core$List$concatMap,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dR;
							},
							$elm$core$Dict$keys),
						sessions)))));
	var allDenied = A2(
		$elm$core$List$all,
		function (session) {
			return session.cN === 2;
		},
		sessions);
	var hasRenderableData = (!noSessionData) && (hasLoadedAuthorizations && (!allDenied));
	var bodyContent = isHashrateRoute ? ($elm$core$List$isEmpty(remote.bX) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-3 text-12 text-dmnd-lighter-gray')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('')
					])),
				A2(
				$elm$html$Html$map,
				$author$project$TopMsg$chartMsg,
				A2($author$project$UI$Library$Chart$View$view, topState, topState.eV.hw))
			]))) : (hasRenderableData ? ($elm$core$List$isEmpty(allEntryDays) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-dmnd-lighter-gray text-12')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('No generated BTC found.')
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('overflow-x-auto')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full text-12 text-left text-dmnd-lighter-gray')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-dmnd-almost-black text-11 uppercase text-dmnd-lighter-gray')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('border-b border-gray-700')
									]),
								$author$project$UI$MultiWatcher$View$tableHeader(sessions))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$UI$MultiWatcher$View$renderRow(sessions),
							allEntryDays))
					]))
			]))) : $elm$html$Html$text(''));
	var statusMessage = noSessionData ? $elm$core$Maybe$Just('No watcher sessions provided. Open a multiwatcher link to load account data.') : (isHashrateRoute ? ($elm$core$List$isEmpty(remote.bX) ? $elm$core$Maybe$Just('No watcher sessions provided. Open a multiwatcher link to load account data.') : ((!A2($author$project$Remote$Model$allMultiWatcherHashrateAccessKnown, remote.bX, remote)) ? $elm$core$Maybe$Just('Loading watcher hashrate authorizations and data...') : ((A2($author$project$Remote$Model$allMultiWatcherHashrateAccessKnown, remote.bX, remote) && A2($author$project$Remote$Model$anyMultiWatcherHashrateDenied, remote.bX, remote)) ? $elm$core$Maybe$Just('One or more watcher API keys are not authorized for hashrate.') : (anyHashrateLoadErrors ? $elm$core$Maybe$Just('Some watcher API keys returned hashrate load errors. Partial totals may be shown.') : $elm$core$Maybe$Nothing)))) : ((!hasLoadedAuthorizations) ? $elm$core$Maybe$Just('Loading watcher authorizations and generated data...') : (allDenied ? $elm$core$Maybe$Just('None of the provided watcher API keys are authorized.') : (anyDenied ? $elm$core$Maybe$Just('One or more watcher API keys are not authorized. Their columns show \"API key not allowed.\"') : (anyLoadErrors ? $elm$core$Maybe$Just('Some watcher API keys returned data load errors. Partial totals may be shown.') : $elm$core$Maybe$Nothing)))));
	return A2(
		$author$project$UI$Library$MainPageWrapper$mainPageWrapper,
		topState,
		A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					header,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-3 text-12 text-dmnd-lighter-gray')
						]),
					_List_fromArray(
						[
							function () {
							if (!statusMessage.$) {
								var message = statusMessage.a;
								return $elm$html$Html$text(message);
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					bodyContent
				])));
};
var $author$project$Remote$RequestMsg$ToggleExportPayoutsModal = {$: 43};
var $author$project$Remote$RequestMsg$DownloadAllPayouts = {$: 50};
var $author$project$Remote$RequestMsg$ExportPayouts = {$: 48};
var $author$project$Remote$RequestMsg$ExportPayoutsLastDays = function (a) {
	return {$: 49, a: a};
};
var $author$project$Remote$RequestMsg$SetExportPayoutsFromDate = function (a) {
	return {$: 46, a: a};
};
var $author$project$Remote$RequestMsg$SetExportPayoutsToDate = function (a) {
	return {$: 47, a: a};
};
var $author$project$Remote$RequestMsg$ToggleExportPayoutsCustomRange = {$: 45};
var $author$project$Remote$RequestMsg$ToggleExportPayoutsQuick = {$: 44};
var $author$project$UI$Payouts$View$exportModal = function (remote) {
	var sectionToggle = F3(
		function (label, isOpen, msg) {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center justify-between w-full text-gray-300 hover:text-white text-12 font-medium cursor-pointer py-2'),
						$elm$html$Html$Events$onClick(
						$author$project$TopMsg$requestMsg(msg))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-gray-500 text-10')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								isOpen ? '▲' : '▼')
							]))
					]));
		});
	var dates = $elm$core$List$sort(
		A2($elm$core$List$map, $author$project$Types$Payout$payoutDate, remote.ek));
	var maxDate = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			$elm$core$List$reverse(dates)));
	var minDate = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(dates));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-gray-800 rounded-lg p-6 shadow-xl w-full max-w-4xl mx-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex justify-between items-center mb-3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-white text-16 font-semibold')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Export Payouts')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-500 hover:text-white cursor-pointer text-14 leading-none'),
										$elm$html$Html$Events$onClick(
										$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$ToggleExportPayoutsModal))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('✕')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('border-t border-gray-700')
							]),
						_List_fromArray(
							[
								A3(sectionToggle, 'Quick export', remote.ib, $author$project$Remote$RequestMsg$ToggleExportPayoutsQuick),
								remote.ib ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex gap-2 pb-2 ml-5')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('px-1 py-0.5 bg-gray-700 text-gray-300 text-12 font-medium rounded-full hover:bg-green-400 hover:text-dmnd-black cursor-pointer transition-colors'),
												$elm$html$Html$Attributes$disabled(
												$author$project$Remote$Model$payoutsAreLoading(remote)),
												$elm$html$Html$Events$onClick(
												$author$project$TopMsg$requestMsg(
													$author$project$Remote$RequestMsg$ExportPayoutsLastDays(7)))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Last 7d')
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('px-2 py-0.5 bg-gray-700 text-gray-300 text-12 font-medium rounded-full hover:bg-green-400 hover:text-dmnd-black cursor-pointer transition-colors'),
												$elm$html$Html$Attributes$disabled(
												$author$project$Remote$Model$payoutsAreLoading(remote)),
												$elm$html$Html$Events$onClick(
												$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$DownloadAllPayouts))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('All data (Last 30d)')
											]))
									])) : $elm$html$Html$text('')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('border-t border-gray-700')
							]),
						_List_fromArray(
							[
								A3(sectionToggle, 'Custom date range', remote.h9, $author$project$Remote$RequestMsg$ToggleExportPayoutsCustomRange),
								remote.h9 ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pb-4')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex gap-4 mb-5')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex flex-col gap-1 flex-1')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('text-gray-400 text-12')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('From')
															])),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('date'),
																$elm$html$Html$Attributes$value(remote.ia),
																$elm$html$Html$Attributes$min(minDate),
																$elm$html$Html$Attributes$max(remote.ic),
																$elm$html$Html$Attributes$class('px-2 py-1 bg-gray-900 text-12 text-white border border-gray-600 rounded focus:outline-none focus:ring-1 focus:ring-green-500 w-full'),
																A2($elm$html$Html$Attributes$style, 'color-scheme', 'dark'),
																$elm$html$Html$Events$onInput(
																function (d) {
																	return $author$project$TopMsg$requestMsg(
																		$author$project$Remote$RequestMsg$SetExportPayoutsFromDate(d));
																})
															]),
														_List_Nil)
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex flex-col gap-1 flex-1')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('text-gray-400 text-12')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('To')
															])),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('date'),
																$elm$html$Html$Attributes$value(remote.ic),
																$elm$html$Html$Attributes$min(remote.ia),
																$elm$html$Html$Attributes$max(maxDate),
																$elm$html$Html$Attributes$class('px-2 py-1 bg-gray-900 text-12 text-white border border-gray-600 rounded focus:outline-none focus:ring-1 focus:ring-green-500 w-full'),
																A2($elm$html$Html$Attributes$style, 'color-scheme', 'dark'),
																$elm$html$Html$Events$onInput(
																function (d) {
																	return $author$project$TopMsg$requestMsg(
																		$author$project$Remote$RequestMsg$SetExportPayoutsToDate(d));
																})
															]),
														_List_Nil)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex justify-end')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('px-2 py-1 bg-green-400 text-dmnd-black text-12 font-semibold rounded hover:bg-green-500 active:bg-green-400 cursor-pointer'),
														$elm$html$Html$Attributes$disabled(
														$author$project$Remote$Model$payoutsAreLoading(remote)),
														$elm$html$Html$Events$onClick(
														$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$ExportPayouts))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Download CSV')
													]))
											]))
									])) : $elm$html$Html$text('')
							]))
					]))
			]));
};
var $author$project$Msg$PayoutsDateRangeMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$TopMsg$payoutsDateRangeMsg = A2($elm$core$Basics$composeL, $author$project$Kernel$Msg$AppMsg, $author$project$Msg$PayoutsDateRangeMsg);
var $author$project$UI$Payouts$View$view = function (topState) {
	var remote = topState.eV.jr;
	var payoutDates = A2($elm$core$List$map, $author$project$Types$Payout$payoutDate, remote.ek);
	var exportBtn = A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-3 py-1.5 bg-green-400 text-dmnd-black text-12 font-semibold rounded-md hover:bg-green-500 active:bg-green-400 cursor-pointer'),
				$elm$html$Html$Attributes$disabled(
				$author$project$Remote$Model$payoutsAreLoading(remote)),
				$elm$html$Html$Events$onClick(
				$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$ToggleExportPayoutsModal))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Export CSV')
			]));
	return A2(
		$author$project$UI$Library$MainPageWrapper$mainPageWrapper,
		topState,
		A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$Library$PageHeader$action(
					{
						k1: exportBtn,
						o8: $elm$core$Maybe$Just('Confirmed payouts for the last 30 days.'),
						bs: 'Payouts'
					}),
					$author$project$UI$Library$RewardsInfoSquares$rewardsInfoSquares(topState),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center justify-end')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$Library$DateRangePicker$viewWithPresets,
							_List_fromArray(
								[
									_Utils_Tuple2(0, 'All data (Last 30d)'),
									_Utils_Tuple2(1, 'Last 7 days')
								]),
							{
								ly: payoutDates,
								ni: topState.eV.jb,
								b6: $author$project$TopMsg$payoutsDateRangeMsg,
								pw: $author$project$UI$Util$currentDateString(topState.ph)
							})
						])),
					remote.jS ? $author$project$UI$Payouts$View$exportModal(remote) : $elm$html$Html$text('')
				])));
};
var $author$project$UI$Library$PageHeader$plain = function (title) {
	return $author$project$UI$Library$PageHeader$render(
		{cO: $elm$core$Maybe$Nothing, o8: $elm$core$Maybe$Nothing, bs: title});
};
var $author$project$UI$PplnsProjection$View$formatAverageHashrate = function (retainedDifficulty) {
	return $author$project$Types$Hashrate$toString(
		$author$project$Types$Hashrate$rawHashrateToHashrate(
			$author$project$Types$PplnsProjection$averageDailyHashrate(retainedDifficulty)));
};
var $author$project$UI$PplnsProjection$View$formatBtc = function (satoshis) {
	return $author$project$Types$BTC$toString(
		$author$project$Types$BTC$fromSatoshis(satoshis)) + ' BTC';
};
var $author$project$UI$PplnsProjection$View$roundTo = F2(
	function (digits, value) {
		var factor = A2($elm$core$Basics$pow, 10.0, digits);
		return $elm$core$String$fromFloat(
			function (rounded) {
				return rounded / factor;
			}(
				$elm$core$Basics$round(value * factor)));
	});
var $author$project$UI$PplnsProjection$View$formatDifficulty = function (difficulty) {
	return (difficulty >= 1.0e18) ? (A2($author$project$UI$PplnsProjection$View$roundTo, 3, difficulty / 1.0e18) + ' E') : ((difficulty >= 1.0e15) ? (A2($author$project$UI$PplnsProjection$View$roundTo, 3, difficulty / 1.0e15) + ' P') : ((difficulty >= 1.0e12) ? (A2($author$project$UI$PplnsProjection$View$roundTo, 3, difficulty / 1.0e12) + ' T') : ((difficulty >= 1.0e9) ? (A2($author$project$UI$PplnsProjection$View$roundTo, 3, difficulty / 1.0e9) + ' G') : ((difficulty >= 1.0e6) ? (A2($author$project$UI$PplnsProjection$View$roundTo, 3, difficulty / 1.0e6) + ' M') : ((difficulty >= 1.0e3) ? (A2($author$project$UI$PplnsProjection$View$roundTo, 3, difficulty / 1.0e3) + ' k') : A2($author$project$UI$PplnsProjection$View$roundTo, 3, difficulty))))));
};
var $author$project$UI$PplnsProjection$View$formatWorkDay = function (iso) {
	return A2(
		$elm$core$Result$withDefault,
		iso,
		A2(
			$elm$core$Result$map,
			$justinmimbs$date$Date$format('EEEE d MMMM y'),
			$justinmimbs$date$Date$fromIsoString(iso)));
};
var $author$project$UI$PplnsProjection$View$numericCell = function (value) {
	return A2(
		$elm$html$Html$td,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('py-2 pr-4 text-right font-mono whitespace-nowrap')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(value)
			]));
};
var $author$project$UI$PplnsProjection$View$dailyWorkRow = function (dailyWork) {
	return A2(
		$elm$html$Html$tr,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('border-b border-gray-800')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('py-2 pr-4 font-medium whitespace-nowrap text-gray-200')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$UI$PplnsProjection$View$formatWorkDay(dailyWork.p8))
					])),
				$author$project$UI$PplnsProjection$View$numericCell(
				$author$project$UI$PplnsProjection$View$formatDifficulty(dailyWork.jB)),
				$author$project$UI$PplnsProjection$View$numericCell(
				$author$project$UI$PplnsProjection$View$formatAverageHashrate(dailyWork.jB)),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('py-2 pr-4 text-right font-mono text-green-400 whitespace-nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$UI$PplnsProjection$View$formatBtc(dailyWork.kd))
					]))
			]));
};
var $author$project$UI$PplnsProjection$View$headerCell = function (label) {
	return A2(
		$elm$html$Html$th,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('min-w-28 py-2 pr-4 font-normal')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$UI$PplnsProjection$View$numericHeaderCell = function (label) {
	return A2(
		$elm$html$Html$th,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('min-w-24 py-2 pr-4 text-right font-normal')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $elm$html$Html$tfoot = _VirtualDom_node('tfoot');
var $author$project$Types$PplnsProjection$totalDailyWorkNetSats = function (dailyWork) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.kd;
			},
			dailyWork));
};
var $author$project$UI$PplnsProjection$View$dailyWorkTable = function (dailyWork) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('overflow-x-auto')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full border-collapse text-left text-12 text-dmnd-lighter-gray')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-10 uppercase text-dmnd-lighter-gray')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('border-b border-gray-700')
									]),
								_List_fromArray(
									[
										$author$project$UI$PplnsProjection$View$headerCell('Work day (UTC)'),
										$author$project$UI$PplnsProjection$View$numericHeaderCell('Retained work'),
										$author$project$UI$PplnsProjection$View$numericHeaderCell('Average hashrate'),
										$author$project$UI$PplnsProjection$View$numericHeaderCell('Total PPLNS value')
									]))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2($elm$core$List$map, $author$project$UI$PplnsProjection$View$dailyWorkRow, dailyWork)),
						A2(
						$elm$html$Html$tfoot,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('border-t border-gray-700')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$colspan(3),
												$elm$html$Html$Attributes$class('pt-3 pr-4 text-right font-semibold text-gray-200')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Grand total')
											])),
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pt-3 pr-4 text-right font-mono font-semibold text-green-400 whitespace-nowrap')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$UI$PplnsProjection$View$formatBtc(
													$author$project$Types$PplnsProjection$totalDailyWorkNetSats(dailyWork)))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$UI$PplnsProjection$View$projectionBody = function (state) {
	if (state.$ === 4) {
		var projection = state.a;
		return $author$project$UI$PplnsProjection$View$dailyWorkTable(projection.lt);
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$UI$PplnsProjection$View$view = function (topState) {
	return A2(
		$author$project$UI$Library$MainPageWrapper$mainPageWrapper,
		topState,
		A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$Library$PageHeader$plain('PPLNS projection'),
					$author$project$UI$PplnsProjection$View$projectionBody(topState.eV.jr.dk)
				])));
};
var $author$project$Remote$RequestMsg$ToggleSubAccountModal = {$: 51};
var $author$project$Remote$RequestMsg$CreateSubAccount = function (a) {
	return {$: 54, a: a};
};
var $author$project$Remote$RequestMsg$SetSubAccountBitcoinAddress = function (a) {
	return {$: 53, a: a};
};
var $author$project$Remote$RequestMsg$SetSubAccountName = function (a) {
	return {$: 52, a: a};
};
var $author$project$UI$SubAccounts$View$addSubAccountModal = function (remote) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-gray-800 rounded-lg p-6 shadow-xl max-w-4xl w-full mx-4 w-full')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex justify-between items-center mb-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-white text-18 font-semibold')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Sub Account')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-400 hover:text-white'),
										$elm$html$Html$Events$onClick(
										$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$ToggleSubAccountModal))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('✕')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col gap-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray-300 text-14 mb-2')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Name')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Attributes$value(remote.j2),
												$elm$html$Html$Attributes$placeholder('Enter name'),
												$elm$html$Html$Attributes$class('px-3 py-2 bg-gray-900 text-14 text-white border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'),
												A2($elm$html$Html$Attributes$style, 'color-scheme', 'dark'),
												$elm$html$Html$Events$onInput(
												function (newValue) {
													return $author$project$TopMsg$requestMsg(
														$author$project$Remote$RequestMsg$SetSubAccountName(newValue));
												})
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray-300 text-14 mb-2')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Bitcoin Address')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Attributes$value(remote.j1),
												$elm$html$Html$Attributes$placeholder('Enter bitcoin address'),
												$elm$html$Html$Attributes$class('px-3 py-2 bg-gray-900 text-14 text-white border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'),
												A2($elm$html$Html$Attributes$style, 'color-scheme', 'dark'),
												$elm$html$Html$Attributes$autocomplete(false),
												$elm$html$Html$Events$onInput(
												function (newValue) {
													return $author$project$TopMsg$requestMsg(
														$author$project$Remote$RequestMsg$SetSubAccountBitcoinAddress(newValue));
												})
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex justify-end mt-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('px-2 py-1 text-14 rounded-md bg-green-500 text-dmnd-black hover:bg-green-600 active:bg-green-500 cursor-pointer'),
												$elm$html$Html$Events$onClick(
												$author$project$TopMsg$requestMsg(
													$author$project$Remote$RequestMsg$CreateSubAccount(
														{kU: remote.j1, o4: remote.j2})))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Proceed')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Remote$Model$canCreateSubAccount = function (remote) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.lp;
			},
			remote.nR));
};
var $author$project$Remote$RequestMsg$SubAccountLogin = function (a) {
	return {$: 9, a: a};
};
var $author$project$Global$Model$SubAccountPasswordsModal = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$UI$SubAccounts$View$copyable = F2(
	function (fullValue, shownValue) {
		return $elm$core$String$isEmpty(fullValue) ? $elm$html$Html$text('—') : A3(
			$author$project$Kernel$UI$CustomTooltip$CustomTooltip$tooltipable,
			{
				kM: 'hidden',
				hA: 'inline-block',
				pi: 0,
				pB: $elm$html$Html$text('Click to copy'),
				pC: 'bg-gray-900 text-gray-300 text-10 p-1 rounded shadow-lg whitespace-nowrap z-50',
				pD: _Utils_Tuple2(0, 1)
			},
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cursor-pointer hover:text-green-500'),
					$elm$html$Html$Events$onClick(
					$author$project$TopMsg$globalMsg(
						$author$project$Global$Msg$CopyToClipboard(fullValue)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(shownValue)
				]));
	});
var $author$project$UI$Svg$editIcon = function (classes) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$width('1.25rem'),
				$elm$svg$Svg$Attributes$height('1.25rem'),
				$elm$svg$Svg$Attributes$class(classes)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25ZM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$UI$SubAccounts$View$roundTo = F2(
	function (digits, value) {
		var factor = A2($elm$core$Basics$pow, 10.0, digits);
		var rounded = $elm$core$Basics$round(value * factor) / factor;
		return $elm$core$String$fromFloat(rounded);
	});
var $author$project$UI$SubAccounts$View$formatBtc = function (maybeBtc) {
	if (maybeBtc.$ === 1) {
		return '—';
	} else {
		var btc = maybeBtc.a;
		return A2($author$project$UI$SubAccounts$View$roundTo, 8, btc) + ' BTC';
	}
};
var $author$project$UI$SubAccounts$View$formatFee = function (f) {
	return A2($author$project$UI$SubAccounts$View$roundTo, 2, f) + '%';
};
var $author$project$UI$SubAccounts$View$formatHashrate = function (hr) {
	return (hr >= 1.0e15) ? (A2($author$project$UI$SubAccounts$View$roundTo, 2, hr / 1.0e15) + ' PH/s') : ((hr >= 1.0e12) ? (A2($author$project$UI$SubAccounts$View$roundTo, 2, hr / 1.0e12) + ' TH/s') : ((hr >= 1.0e9) ? (A2($author$project$UI$SubAccounts$View$roundTo, 2, hr / 1.0e9) + ' GH/s') : ((hr >= 1.0e6) ? (A2($author$project$UI$SubAccounts$View$roundTo, 2, hr / 1.0e6) + ' MH/s') : ((hr >= 1.0e3) ? (A2($author$project$UI$SubAccounts$View$roundTo, 2, hr / 1.0e3) + ' kH/s') : (A2($author$project$UI$SubAccounts$View$roundTo, 2, hr) + ' H/s')))));
};
var $author$project$UI$SubAccounts$View$formatRejection = function (s) {
	var total = s.eu.kB + s.eu.od;
	if (!total) {
		return '0.00%';
	} else {
		var ratio = (s.eu.od / total) * 100.0;
		return A2($author$project$UI$SubAccounts$View$roundTo, 2, ratio) + '%';
	}
};
var $author$project$UI$SubAccounts$View$placeholder_ = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('text-dmnd-lighter-gray text-11')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('…')
		]));
var $author$project$UI$SubAccounts$View$truncateMiddle = F3(
	function (leftCount, rightCount, value) {
		return (_Utils_cmp(
			$elm$core$String$length(value),
			(leftCount + rightCount) + 3) < 1) ? value : (A2($elm$core$String$left, leftCount, value) + ('…' + A2($elm$core$String$right, rightCount, value)));
	});
var $author$project$UI$SubAccounts$View$renderRow = F2(
	function (remote, sub) {
		var truncatedAddress = A3($author$project$UI$SubAccounts$View$truncateMiddle, 6, 6, sub.kU);
		var summary = A2($elm$core$Dict$get, sub.mu, remote.gM);
		var rejectionCell = function () {
			if (!summary.$) {
				var s = summary.a;
				return $elm$html$Html$text(
					$author$project$UI$SubAccounts$View$formatRejection(s));
			} else {
				return $author$project$UI$SubAccounts$View$placeholder_;
			}
		}();
		var poolFeeCell = function () {
			if (!summary.$) {
				var s = summary.a;
				return $elm$html$Html$text(
					$author$project$UI$SubAccounts$View$formatFee(
						$author$project$Types$SubAccountSummary$effectivePoolFee(s.d_)));
			} else {
				return $author$project$UI$SubAccounts$View$placeholder_;
			}
		}();
		var hashrateCell = function () {
			if (!summary.$) {
				var s = summary.a;
				return $elm$html$Html$text(
					$author$project$UI$SubAccounts$View$formatHashrate(s.d1.ay));
			} else {
				return $elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						sub.d1,
						A2(
							$elm$core$Maybe$map,
							$author$project$UI$SubAccounts$View$formatHashrate,
							$elm$core$String$toFloat(sub.d1))));
			}
		}();
		var currentUserToken = function () {
			var _v1 = remote.pQ;
			if (_v1.$ === 2) {
				var session = _v1.a;
				return session.g_;
			} else {
				return '';
			}
		}();
		var btcCell = function () {
			if (!summary.$) {
				var s = summary.a;
				return $elm$html$Html$text(
					$author$project$UI$SubAccounts$View$formatBtc(s.px));
			} else {
				return $author$project$UI$SubAccounts$View$placeholder_;
			}
		}();
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-b border-gray-800 hover:bg-gray-900')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 text-white')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center gap-1')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('cursor-pointer hover:text-green-500 hover:underline'),
											$elm$html$Html$Events$onClick(
											$author$project$TopMsg$requestMsg(
												$author$project$Remote$RequestMsg$SubAccountLogin(
													{e4: currentUserToken, gN: sub.g_})))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(sub.o4)
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('text-dmnd-lighter-gray hover:text-green-500 cursor-pointer'),
											A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Rename ' + sub.o4),
											$elm$html$Html$Attributes$title('Rename subaccount'),
											$elm$html$Html$Events$onClick(
											$author$project$TopMsg$globalMsg(
												$author$project$Global$Msg$ShowModal(
													A3($author$project$Global$Model$EditSubAccountModal, sub.mu, sub.o4, ''))))
										]),
									_List_fromArray(
										[
											$author$project$UI$Svg$editIcon('h-1.25 w-1.25')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-10 text-dmnd-lighter-gray')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('ID ' + sub.mu)
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 text-white')
						]),
					_List_fromArray(
						[hashrateCell])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3')
						]),
					_List_fromArray(
						[rejectionCell])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3')
						]),
					_List_fromArray(
						[poolFeeCell])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3')
						]),
					_List_fromArray(
						[btcCell])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3 font-mono text-10 text-dmnd-lighter-gray')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center gap-2')
								]),
							_List_fromArray(
								[
									A2($author$project$UI$SubAccounts$View$copyable, sub.kU, truncatedAddress),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('text-dmnd-lighter-gray hover:text-green-500 cursor-pointer'),
											A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Change payout address for ' + sub.o4),
											$elm$html$Html$Attributes$title('Change payout address'),
											$elm$html$Html$Events$onClick(
											$author$project$TopMsg$globalMsg(
												$author$project$Global$Msg$ShowModal(
													A3(
														$author$project$Global$Model$UpdateBitcoinAddressModal,
														'',
														'',
														$elm$core$Maybe$Just(sub.mu)))))
										]),
									_List_fromArray(
										[
											$author$project$UI$Svg$editIcon('h-1.25 w-1.25')
										]))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 pr-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('px-2 py-1 border border-gray-600 text-dmnd-lighter-gray text-12 rounded-md hover:bg-gray-800 hover:text-white cursor-pointer'),
									$elm$html$Html$Events$onClick(
									$author$project$TopMsg$globalMsg(
										$author$project$Global$Msg$ShowModal(
											A3($author$project$Global$Model$SubAccountPasswordsModal, sub.o4, sub.g_, sub.l8))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('View')
								]))
						]))
				]));
	});
var $author$project$UI$SubAccounts$View$table_ = F2(
	function (remote, subs) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-2 overflow-x-auto')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full text-12 text-left text-dmnd-lighter-gray')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sticky top-0 z-10 bg-dmnd-almost-black text-11 uppercase text-dmnd-lighter-gray')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('border-b border-gray-700')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Subaccount')
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Hashrate (10m)')
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Rejection (24hrs) %')
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Pool fee %')
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('BTC today')
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Bitcoin address')
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('py-2 pr-3 font-normal')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Passwords')
												]))
										]))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$UI$SubAccounts$View$renderRow(remote),
								subs))
						]))
				]));
	});
var $author$project$UI$SubAccounts$View$view = function (topState) {
	var remote = topState.eV.jr;
	var canCreate = $author$project$Remote$Model$canCreateSubAccount(remote);
	var body = function () {
		var _v0 = remote.ex;
		if (_v0.$ === 1) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mt-2 text-dmnd-lighter-gray text-14')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Failed to load subaccounts.')
					]));
		} else {
			if (!_v0.a.b) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-2 text-dmnd-lighter-gray text-14')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('No subaccounts yet. Each subaccount maps to a mining site so you can track and compare per-site performance and earnings.')
						]));
			} else {
				var subs = _v0.a;
				return A2($author$project$UI$SubAccounts$View$table_, remote, subs);
			}
		}
	}();
	var addSubAccount = remote.jQ ? $author$project$UI$SubAccounts$View$addSubAccountModal(remote) : $elm$html$Html$text('');
	var addButton = A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-3 py-1.5 bg-green-400 text-dmnd-black text-12 font-semibold rounded-md hover:bg-green-500 active:bg-green-400 cursor-pointer'),
				$elm$html$Html$Events$onClick(
				$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$ToggleSubAccountModal))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('+ Add subaccount')
			]));
	var header_ = $author$project$UI$Library$PageHeader$action(
		{
			k1: canCreate ? addButton : $elm$html$Html$text(''),
			o8: $elm$core$Maybe$Just('One subaccount per mining site. Compare hashrate, rejection ratio, fees, and earnings side-by-side.'),
			bs: 'Subaccounts'
		});
	return A2(
		$author$project$UI$Library$MainPageWrapper$mainPageWrapper,
		topState,
		A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[header_, addSubAccount, body])));
};
var $author$project$Remote$RequestMsg$ExportWorkersCsv = {$: 34};
var $author$project$UI$Workers$Model$OfflineOnly = 2;
var $author$project$UI$Workers$Model$OnlineOnly = 1;
var $author$project$UI$Workers$Msg$SetFilter = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$Workers$Msg$SetSearch = function (a) {
	return {$: 5, a: a};
};
var $author$project$UI$Workers$View$view = function (topState) {
	var workersState = topState.eV.kv;
	var workers = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		$author$project$UI$Library$AccountData$selectedWorkers(topState));
	var onlineCount = $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.iG;
			},
			workers));
	var offlineCount = $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function (w) {
				return !w.iG;
			},
			workers));
	var filterBtn = F3(
		function (label, isActive, msg) {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						isActive ? 'px-2 py-1 bg-green-400 text-dmnd-black text-12 rounded-md cursor-pointer' : 'px-2 py-1 bg-dmnd-black text-gray-400 text-12 rounded-md border border-gray-600 hover:border-gray-400 cursor-pointer'),
						$elm$html$Html$Events$onClick(
						$author$project$TopMsg$workersMsg(msg))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]));
		});
	var exportBtn = A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-3 py-1.5 bg-green-400 text-dmnd-black text-12 font-semibold rounded-md hover:bg-green-500 active:bg-green-400 cursor-pointer'),
				$elm$html$Html$Events$onClick(
				$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$ExportWorkersCsv))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Export CSV')
			]));
	return A2(
		$author$project$UI$Library$MainPageWrapper$mainPageWrapper,
		topState,
		A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$Library$PageHeader$action(
					{
						k1: exportBtn,
						o8: $elm$core$Maybe$Just('Live worker roster — connection status, hashrate, and share counts.'),
						bs: 'Workers'
					}),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center gap-3 mb-3')
						]),
					_List_fromArray(
						[
							A3(
							filterBtn,
							'All',
							!workersState.$8,
							$author$project$UI$Workers$Msg$SetFilter(0)),
							A3(
							filterBtn,
							'Online (' + ($elm$core$String$fromInt(onlineCount) + ')'),
							workersState.$8 === 1,
							$author$project$UI$Workers$Msg$SetFilter(1)),
							A3(
							filterBtn,
							'Offline (' + ($elm$core$String$fromInt(offlineCount) + ')'),
							workersState.$8 === 2,
							$author$project$UI$Workers$Msg$SetFilter(2)),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Attributes$placeholder('Search workers, comma separated...'),
									$elm$html$Html$Attributes$value(workersState.gx),
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$TopMsg$workersMsg, $author$project$UI$Workers$Msg$SetSearch)),
									$elm$html$Html$Attributes$class('flex-1 bg-dmnd-black text-gray-300 text-12 border border-gray-600 rounded-md px-3 py-1 placeholder-gray-600 focus:border-gray-400 focus:outline-none')
								]),
							_List_Nil)
						]))
				])));
};
var $author$project$UI$RoutedViews$routedViews = F4(
	function (browser, route, topState, zone) {
		switch (route.$) {
			case 1:
				var authRoute = route.a;
				switch (authRoute.$) {
					case 0:
						return _List_fromArray(
							[
								{
								kP: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('')
									]),
								A: _List_fromArray(
									[
										$author$project$UI$Auth$LoginRegister$view(topState)
									]),
								nv: 'auth-login',
								pZ: 'auth-element'
							}
							]);
					case 1:
						return _List_fromArray(
							[
								{
								kP: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('')
									]),
								A: _List_fromArray(
									[
										$author$project$UI$Auth$LoginRegister$view(topState)
									]),
								nv: 'auth-watcher-login',
								pZ: 'auth-element'
							}
							]);
					case 4:
						return _List_fromArray(
							[
								{
								kP: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('')
									]),
								A: _List_fromArray(
									[
										$author$project$UI$Auth$BrokerLogin$view(topState)
									]),
								nv: 'auth-broker-login',
								pZ: 'auth-element'
							}
							]);
					case 2:
						return _List_fromArray(
							[
								{
								kP: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('')
									]),
								A: _List_fromArray(
									[
										$author$project$UI$Auth$LoginRegister$view(topState)
									]),
								nv: 'auth-forgot-password',
								pZ: 'auth-element'
							}
							]);
					default:
						return _List_fromArray(
							[
								{
								kP: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('')
									]),
								A: _List_fromArray(
									[
										$author$project$UI$Auth$LoginRegister$view(topState)
									]),
								nv: 'auth-reset-password',
								pZ: 'auth-element'
							}
							]);
				}
			case 0:
				return _List_fromArray(
					[
						{
						kP: _List_Nil,
						A: _List_fromArray(
							[
								$author$project$UI$ComponentsPreview$View$view(topState)
							]),
						nv: 'components-preview',
						pZ: 'components-preview'
					}
					]);
			case 2:
				return _List_fromArray(
					[
						{
						kP: _List_Nil,
						A: _List_fromArray(
							[
								$author$project$UI$Home$View$view(topState)
							]),
						nv: 'home',
						pZ: 'home'
					}
					]);
			case 4:
				return _List_fromArray(
					[
						{
						kP: _List_Nil,
						A: _List_fromArray(
							[
								$author$project$UI$Connections$View$view(topState)
							]),
						nv: 'connections',
						pZ: 'connections'
					}
					]);
			case 5:
				return _List_fromArray(
					[
						{
						kP: _List_Nil,
						A: _List_fromArray(
							[
								$author$project$UI$Payouts$View$view(topState)
							]),
						nv: 'payouts',
						pZ: 'payouts'
					}
					]);
			case 3:
				return _List_fromArray(
					[
						{
						kP: _List_Nil,
						A: _List_fromArray(
							[
								$author$project$UI$Connect$View$view(topState)
							]),
						nv: 'connect',
						pZ: 'connect'
					}
					]);
			case 6:
				return _List_fromArray(
					[
						{
						kP: _List_Nil,
						A: _List_fromArray(
							[
								$author$project$UI$Account$View$view(topState)
							]),
						nv: 'account',
						pZ: 'account'
					}
					]);
			case 7:
				return _List_fromArray(
					[
						{
						kP: _List_Nil,
						A: ($elm$core$List$length(topState.eV.jr.bX) > 1) ? _List_fromArray(
							[
								$author$project$UI$MultiWatcher$View$view(topState)
							]) : _List_fromArray(
							[
								$author$project$UI$Workers$View$view(topState)
							]),
						nv: 'workers',
						pZ: 'workers'
					}
					]);
			case 8:
				return _List_fromArray(
					[
						{
						kP: _List_Nil,
						A: _List_fromArray(
							[
								$author$project$UI$SubAccounts$View$view(topState)
							]),
						nv: 'subaccounts',
						pZ: 'subaccounts'
					}
					]);
			case 9:
				return _List_fromArray(
					[
						{
						kP: _List_Nil,
						A: _List_fromArray(
							[
								$author$project$UI$ApiKeys$View$view(topState)
							]),
						nv: 'api-keys',
						pZ: 'api-keys'
					}
					]);
			case 10:
				return _List_fromArray(
					[
						{
						kP: _List_Nil,
						A: _List_fromArray(
							[
								$author$project$UI$Broker$View$view(topState)
							]),
						nv: 'broker-dashboard',
						pZ: 'broker-dashboard'
					}
					]);
			case 11:
				return _List_fromArray(
					[
						{
						kP: _List_Nil,
						A: _List_fromArray(
							[
								$author$project$UI$GeneratedBitcoin$View$view(topState)
							]),
						nv: 'generated-bitcoin-reward',
						pZ: 'generated-bitcoin-reward'
					}
					]);
			case 12:
				return _List_fromArray(
					[
						{
						kP: _List_Nil,
						A: _List_fromArray(
							[
								$author$project$UI$PplnsProjection$View$view(topState)
							]),
						nv: 'pplns-projection',
						pZ: 'pplns-projection'
					}
					]);
			default:
				return _List_fromArray(
					[
						{
						kP: _List_Nil,
						A: _List_fromArray(
							[
								$author$project$UI$MultiWatcher$View$view(topState)
							]),
						nv: 'multiwatcher',
						pZ: 'multiwatcher'
					}
					]);
		}
	});
var $author$project$Kernel$UI$ViewLayers$ViewLayers$viewLayers = function (cfg) {
	var toLayer = function (l) {
		return _Utils_Tuple2(
			l.pZ,
			A3(
				$elm$html$Html$node,
				l.nv,
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'view-identifier', l.pZ),
					l.kP),
				l.A));
	};
	return A3(
		$elm$html$Html$Keyed$node,
		'view-layers',
		cfg.ch,
		A2($elm$core$List$map, toLayer, cfg.mZ));
};
var $author$project$MainModule$view = function (topState) {
	var appState = topState.eV;
	var env = topState.h1;
	var browser = topState.k0;
	var route = topState.jE;
	var zone = topState.qm;
	var time = topState.ph;
	var currRoute = $author$project$Kernel$Aspect$Navigation$RouteHistory$current(route);
	return A3(
		$elm$html$Html$node,
		'top-app-node',
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('block font-sans text-20 selection:bg-dmnd-red-1 selection:text-white min-w-126 2xl:w-192 ml-auto mr-auto')
			]),
		_List_fromArray(
			[
				$author$project$Kernel$UI$ViewLayers$ViewLayers$viewLayers(
				{
					ch: _List_Nil,
					mF: $author$project$Kernel$Aspect$Navigation$RouteHistory$isBackNav(route),
					mZ: $elm$core$List$concat(
						_List_fromArray(
							[
								A4($author$project$UI$RoutedViews$routedViews, browser, currRoute, topState, zone),
								A2($author$project$Global$Overlays$overlays, currRoute, topState)
							]))
				})
			]));
};
var $author$project$MainModule$config = {
	my: $author$project$MainModule$init,
	nB: F2(
		function (state, route) {
			var refreshHashrateAndWorkersMsg = $author$project$Remote$Model$isAuthenticated(state.eV.jr) ? _List_fromArray(
				[
					$author$project$Kernel$Msg$AppMsg($author$project$Msg$PollHashrateAndWorkers)
				]) : _List_Nil;
			var checkUserAuthMsg = $elm_community$maybe_extra$Maybe$Extra$isJust(
				$author$project$Remote$Model$toUserSession(state.eV.jr)) ? _List_fromArray(
				[
					$author$project$TopMsg$requestMsg(
					$author$project$Remote$RequestMsg$CheckAuth(1))
				]) : _List_Nil;
			return _Utils_ap(
				checkUserAuthMsg,
				_Utils_ap(
					refreshHashrateAndWorkersMsg,
					A3($author$project$MainModule$onNewRouteMsgs, state, state.jE, route)));
		}),
	nD: F2(
		function (_v0, _v1) {
			return _List_Nil;
		}),
	nE: F2(
		function (state, route) {
			var refreshHashrateAndWorkersMsg = $author$project$Remote$Model$isAuthenticated(state.eV.jr) ? _List_fromArray(
				[
					$author$project$Kernel$Msg$AppMsg($author$project$Msg$PollHashrateAndWorkers)
				]) : _List_Nil;
			return _Utils_ap(
				refreshHashrateAndWorkersMsg,
				A3($author$project$MainModule$onNewRouteMsgs, state, state.jE, route));
		}),
	ac: $author$project$MainModule$routingConfig,
	o7: $author$project$MainModule$subscriptions,
	pM: $author$project$Update$update,
	pY: $author$project$MainModule$view
};
var $author$project$MainModule$main = $author$project$Kernel$Main$app($author$project$MainModule$config);
_Platform_export({'MainModule':{'init':$author$project$MainModule$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (kernelArgs) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (appArgs) {
					return $elm$json$Json$Decode$succeed(
						{kJ: appArgs, mO: kernelArgs});
				},
				A2(
					$elm$json$Json$Decode$field,
					'appArgs',
					A2(
						$elm$json$Json$Decode$andThen,
						function (watcherPayoutInfo) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (watcherAuthResponses) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (watcherAuthResponse) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (uuids) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (uuid) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (userId) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (multiWatcherRequirement) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (correlationIds) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (correlationId) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (configArgs) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (brokerAuthResponse) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (authResponse) {
																													return $elm$json$Json$Decode$succeed(
																														{hf: authResponse, hp: brokerAuthResponse, lg: configArgs, cW: correlationId, ln: correlationIds, eb: multiWatcherRequirement, g4: userId, pT: uuid, pU: uuids, eG: watcherAuthResponse, p0: watcherAuthResponses, p1: watcherPayoutInfo});
																												},
																												A2(
																													$elm$json$Json$Decode$field,
																													'authResponse',
																													$elm$json$Json$Decode$oneOf(
																														_List_fromArray(
																															[
																																$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																A2(
																																$elm$json$Json$Decode$map,
																																$elm$core$Maybe$Just,
																																A2(
																																	$elm$json$Json$Decode$andThen,
																																	function (twoFactorSecret) {
																																		return A2(
																																			$elm$json$Json$Decode$andThen,
																																			function (token) {
																																				return A2(
																																					$elm$json$Json$Decode$andThen,
																																					function (sellingHashRate) {
																																						return A2(
																																							$elm$json$Json$Decode$andThen,
																																							function (language) {
																																								return A2(
																																									$elm$json$Json$Decode$andThen,
																																									function (kycStatus) {
																																										return A2(
																																											$elm$json$Json$Decode$andThen,
																																											function (id) {
																																												return A2(
																																													$elm$json$Json$Decode$andThen,
																																													function (fpps_token) {
																																														return A2(
																																															$elm$json$Json$Decode$andThen,
																																															function (email) {
																																																return A2(
																																																	$elm$json$Json$Decode$andThen,
																																																	function (bitcoinAddresses) {
																																																		return A2(
																																																			$elm$json$Json$Decode$andThen,
																																																			function (active) {
																																																				return $elm$json$Json$Decode$succeed(
																																																					{kD: active, kT: bitcoinAddresses, ff: email, l8: fpps_token, mu: id, mQ: kycStatus, mS: language, oN: sellingHashRate, g_: token, g0: twoFactorSecret});
																																																			},
																																																			A2($elm$json$Json$Decode$field, 'active', $elm$json$Json$Decode$bool));
																																																	},
																																																	A2($elm$json$Json$Decode$field, 'bitcoinAddresses', $elm$json$Json$Decode$value));
																																															},
																																															A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string));
																																													},
																																													A2($elm$json$Json$Decode$field, 'fpps_token', $elm$json$Json$Decode$string));
																																											},
																																											A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
																																									},
																																									A2($elm$json$Json$Decode$field, 'kycStatus', $elm$json$Json$Decode$string));
																																							},
																																							A2($elm$json$Json$Decode$field, 'language', $elm$json$Json$Decode$string));
																																					},
																																					A2($elm$json$Json$Decode$field, 'sellingHashRate', $elm$json$Json$Decode$bool));
																																			},
																																			A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string));
																																	},
																																	A2(
																																		$elm$json$Json$Decode$field,
																																		'twoFactorSecret',
																																		$elm$json$Json$Decode$oneOf(
																																			_List_fromArray(
																																				[
																																					$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																																				])))))
																															]))));
																										},
																										A2(
																											$elm$json$Json$Decode$field,
																											'brokerAuthResponse',
																											$elm$json$Json$Decode$oneOf(
																												_List_fromArray(
																													[
																														$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																														A2(
																														$elm$json$Json$Decode$map,
																														$elm$core$Maybe$Just,
																														A2(
																															$elm$json$Json$Decode$andThen,
																															function (referenceCode) {
																																return A2(
																																	$elm$json$Json$Decode$andThen,
																																	function (id) {
																																		return A2(
																																			$elm$json$Json$Decode$andThen,
																																			function (email) {
																																				return $elm$json$Json$Decode$succeed(
																																					{ff: email, mu: id, oc: referenceCode});
																																			},
																																			A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string));
																																	},
																																	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
																															},
																															A2($elm$json$Json$Decode$field, 'referenceCode', $elm$json$Json$Decode$string)))
																													]))));
																								},
																								A2(
																									$elm$json$Json$Decode$field,
																									'configArgs',
																									A2(
																										$elm$json$Json$Decode$andThen,
																										function (apiUrl) {
																											return $elm$json$Json$Decode$succeed(
																												{kI: apiUrl});
																										},
																										A2($elm$json$Json$Decode$field, 'apiUrl', $elm$json$Json$Decode$string))));
																						},
																						A2($elm$json$Json$Decode$field, 'correlationId', $elm$json$Json$Decode$string));
																				},
																				A2(
																					$elm$json$Json$Decode$field,
																					'correlationIds',
																					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
																		},
																		A2($elm$json$Json$Decode$field, 'multiWatcherRequirement', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'userId', $elm$json$Json$Decode$string));
														},
														A2($elm$json$Json$Decode$field, 'uuid', $elm$json$Json$Decode$string));
												},
												A2(
													$elm$json$Json$Decode$field,
													'uuids',
													$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
										},
										A2(
											$elm$json$Json$Decode$field,
											'watcherAuthResponse',
											$elm$json$Json$Decode$oneOf(
												_List_fromArray(
													[
														$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
														A2(
														$elm$json$Json$Decode$map,
														$elm$core$Maybe$Just,
														A2(
															$elm$json$Json$Decode$andThen,
															function (userId) {
																return A2(
																	$elm$json$Json$Decode$andThen,
																	function (token) {
																		return $elm$json$Json$Decode$succeed(
																			{g_: token, g4: userId});
																	},
																	A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string));
															},
															A2($elm$json$Json$Decode$field, 'userId', $elm$json$Json$Decode$string)))
													]))));
								},
								A2(
									$elm$json$Json$Decode$field,
									'watcherAuthResponses',
									$elm$json$Json$Decode$list(
										A2(
											$elm$json$Json$Decode$andThen,
											function (userId) {
												return A2(
													$elm$json$Json$Decode$andThen,
													function (token) {
														return $elm$json$Json$Decode$succeed(
															{g_: token, g4: userId});
													},
													A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string));
											},
											A2($elm$json$Json$Decode$field, 'userId', $elm$json$Json$Decode$string)))));
						},
						A2(
							$elm$json$Json$Decode$field,
							'watcherPayoutInfo',
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
										A2(
										$elm$json$Json$Decode$map,
										$elm$core$Maybe$Just,
										A2(
											$elm$json$Json$Decode$andThen,
											function (userAddress) {
												return A2(
													$elm$json$Json$Decode$andThen,
													function (pplnsAddress) {
														return A2(
															$elm$json$Json$Decode$andThen,
															function (fppsAddress) {
																return $elm$json$Json$Decode$succeed(
																	{l5: fppsAddress, n_: pplnsAddress, pP: userAddress});
															},
															A2($elm$json$Json$Decode$field, 'fppsAddress', $elm$json$Json$Decode$string));
													},
													A2($elm$json$Json$Decode$field, 'pplnsAddress', $elm$json$Json$Decode$string));
											},
											A2($elm$json$Json$Decode$field, 'userAddress', $elm$json$Json$Decode$string)))
									]))))));
		},
		A2(
			$elm$json$Json$Decode$field,
			'kernelArgs',
			A2(
				$elm$json$Json$Decode$andThen,
				function (timezoneOffset) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (navigationLocation) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (env) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (currTime) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (browser) {
													return $elm$json$Json$Decode$succeed(
														{k0: browser, ls: currTime, h1: env, np: navigationLocation, pj: timezoneOffset});
												},
												A2(
													$elm$json$Json$Decode$field,
													'browser',
													A2(
														$elm$json$Json$Decode$andThen,
														function (width) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (unitSize) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (pixelRatio) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (height) {
																					return $elm$json$Json$Decode$succeed(
																						{fx: height, jf: pixelRatio, eE: unitSize, g6: width});
																				},
																				A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
																		},
																		A2($elm$json$Json$Decode$field, 'pixelRatio', $elm$json$Json$Decode$float));
																},
																A2($elm$json$Json$Decode$field, 'unitSize', $elm$json$Json$Decode$int));
														},
														A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int))));
										},
										A2($elm$json$Json$Decode$field, 'currTime', $elm$json$Json$Decode$int));
								},
								A2(
									$elm$json$Json$Decode$field,
									'env',
									A2(
										$elm$json$Json$Decode$andThen,
										function (isStaging) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (isProd) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (isDev) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (isActiveDevelopment) {
																	return $elm$json$Json$Decode$succeed(
																		{mC: isActiveDevelopment, mG: isDev, mJ: isProd, mM: isStaging});
																},
																A2($elm$json$Json$Decode$field, 'isActiveDevelopment', $elm$json$Json$Decode$bool));
														},
														A2($elm$json$Json$Decode$field, 'isDev', $elm$json$Json$Decode$bool));
												},
												A2($elm$json$Json$Decode$field, 'isProd', $elm$json$Json$Decode$bool));
										},
										A2($elm$json$Json$Decode$field, 'isStaging', $elm$json$Json$Decode$bool))));
						},
						A2(
							$elm$json$Json$Decode$field,
							'navigationLocation',
							A2(
								$elm$json$Json$Decode$andThen,
								function (search) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (protocol) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (port_) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (pathname) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (origin) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (href) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (hostname) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (host) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (hash) {
																									return $elm$json$Json$Decode$succeed(
																										{fs: hash, mp: host, mq: hostname, fA: href, nK: origin, gj: pathname, nY: port_, n7: protocol, gw: search});
																								},
																								A2($elm$json$Json$Decode$field, 'hash', $elm$json$Json$Decode$string));
																						},
																						A2($elm$json$Json$Decode$field, 'host', $elm$json$Json$Decode$string));
																				},
																				A2($elm$json$Json$Decode$field, 'hostname', $elm$json$Json$Decode$string));
																		},
																		A2($elm$json$Json$Decode$field, 'href', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'origin', $elm$json$Json$Decode$string));
														},
														A2($elm$json$Json$Decode$field, 'pathname', $elm$json$Json$Decode$string));
												},
												A2($elm$json$Json$Decode$field, 'port_', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'protocol', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'search', $elm$json$Json$Decode$string))));
				},
				A2($elm$json$Json$Decode$field, 'timezoneOffset', $elm$json$Json$Decode$int)))))(0)}});}(this));